webpackJsonp([14],{

/***/ "+Sxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);

/***/ }),

/***/ "+ZFP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.formURLSearchObject = formURLSearchObject, exports.fetcher = fetcher;function _typeof(a) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}function formURLSearchObject(a) {
  var b = new URLSearchParams();return "object" === _typeof(a) && Object.keys(a).forEach(function (c) {
    return b.append(c, a[c]);
  }), b;
}function fetcher(a) {
  var b = "/core/quikrcom/pwa_api" + a.url,
      c = { method: a.method || "GET" };return a.body && (c.body = a.body), fetch(b, c);
}

/***/ }),

/***/ "+jex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return detectLocations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchCityDefaultCallback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("Vr6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var detectLocations = function detectLocations() {
	var successCalback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	var failureCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

	if (navigator) {
		navigator.geolocation.getCurrentPosition(function (res) {
			var _res$coords = res.coords,
			    latitude = _res$coords.latitude,
			    longitude = _res$coords.longitude;
			// send api call

			var data = new URLSearchParams();
			data.append('latitude', latitude);
			data.append('longitude', longitude);
			data.append('distance', 5);
			data.append('distanceType', 'km');
			data.append('resultCount', 1);
			data.append('source', 1);
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://feservices.quikr.com/v2/header/fetch_locality', data, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then(function (apiResp) {
				var data = apiResp.data;

				if (data.error) {
					failureCallback({
						code: 143,
						message: 'Api error',
						error: data.error
					});
				} else {
					res.cityName = data.cityName;
					res.localityName = data.localityName;
					res.cityId = data.cityId;
					res.localityId = data.localityId;
					successCalback(res);
				}
			});
		}, function (err) {
			failureCallback(err);
		});
	} else {
		failureCallback({
			code: 142,
			message: 'navigator object not found'
		});
	}
};

var searchCityDefaultCallback = function searchCityDefaultCallback(cityId, cityName, g_id) {
	var axiosInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
		baseURL: 'https://www.quikr.com/',
		timeout: 1000,
		headers: {
			accept: 'application/json, text/javascript, */*; q=0.01',
			'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});

	var params = new URLSearchParams();
	params.append('cityName', cityName);
	params.append('categoryId', g_id);
	params.append('gid', '0, www');
	params.append('URL', '/');
	axiosInstance.post('/?aj=1&citysrch=true&sx=true&carsResponsiveLayout=1', params).then(function (res) {
		if (res.status === 200) {
			var id = res.data.id;
			var path = window.location.pathname;
			var reg = /cId-[0-9]+|cId[0-9]+/;
			var regw = /w[0-9]+/;
			var regy = /y[0-9]+/;
			var regg = /gId-[0-9]+|gId[0-9]+/;
			var matchcId = path.match(reg);
			var matchwId = path.match(regw);
			var matchyId = path.match(regy);
			var matchgId = path.match(regg);
			var filterParams = window.location.search;
			if (matchcId != null) {
				if (cityId == 0 || cityId == 1) {
					var tmp_gid = matchcId[0].replace(/[0-9]+/, g_id).replace(/cId/, 'gId');
					path = path.replace(reg, tmp_gid);
				} else {
					var tmp_cid = matchcId[0].replace(/[0-9]+/, id);
					path = path.replace(reg, tmp_cid);
				}
			} else if (matchcId == null && matchwId != null) {
				if (cityId == 0 || cityId == 1) {
					path = path.replace(regw, 'y' + g_id);
				} else {
					path = path.replace(regw, 'w' + id);
				}
			} else if (matchyId != null) {
				path = path.replace(regy, 'w' + id);
			} else if (matchgId != null && !(cityId == 0 || cityId == 1)) {
				var _tmp_cid = matchgId[0].replace(/[0-9]+/, id).replace(/gId/, 'cId');
				path = path.replace(regg, _tmp_cid);
			} else {
				path = '/';
			}
			var subDomain = cityId != 0 && cityId != 1 ? cityName.toLowerCase() : 'www';

			window.location = window.location.protocol + '//' + subDomain + '.quikr.com' + path + filterParams;
			return;
		} else {
			console.log('Something went wrong');
		}
	}).catch(function (err) {
		console.log('Something went wrong');
	});
};

/***/ }),

/***/ "+oM5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),

/***/ "+t08":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),

/***/ "/5uS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/ErD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../q-jobs/node_modules/cookie/index.js
var cookie = __webpack_require__("4xz6");
var cookie_default = /*#__PURE__*/__webpack_require__.n(cookie);

// CONCATENATED MODULE: ../q-jobs/node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies) {
    if (typeof cookies === 'string') {
        return cookie["parse"](cookies);
    } else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    } else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) {
        options = {};
    }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        } catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}
// CONCATENATED MODULE: ../q-jobs/node_modules/universal-cookie/es6/Cookies.js


// We can't please Rollup and TypeScript at the same time
// Only way to make both of them work
var objectAssign = __webpack_require__("X84d");
var Cookies_Cookies = /** @class */function () {
    function Cookies(cookies) {
        this.changeListeners = [];
        this.TESTING_ONETWO = 2;
        this.cookies = parseCookies(cookies);
        this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    }
    Cookies.prototype._updateBrowserValues = function () {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie["parse"](document.cookie);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options) {
        if (options === void 0) {
            options = {};
        }
        this._updateBrowserValues();
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options) {
        if (options === void 0) {
            options = {};
        }
        this._updateBrowserValues();
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = objectAssign({}, this.cookies, (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie["serialize"](name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = options = objectAssign({}, options, {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = objectAssign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie["serialize"](name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}();
/* harmony default export */ var es6_Cookies = (Cookies_Cookies);
// CONCATENATED MODULE: ../q-jobs/node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = __webpack_exports__["a"] = (es6_Cookies);

/***/ }),

/***/ "/X51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Fab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ripple__ = __webpack_require__("MIZk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_fab_mdc_fab_scss__ = __webpack_require__("PSZ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_fab_mdc_fab_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_fab_mdc_fab_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */




/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */


/**
 * Create the component.
 */

var Fab = function (_Component) {
  _inherits(Fab, _Component);

  function Fab(props) {
    _classCallCheck(this, Fab);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.componentDidMount = function () {
      setTimeout(function () {
        var rippleInstance = Object(__WEBPACK_IMPORTED_MODULE_2__material_ripple__["a" /* default */])(_this.root_);
        _this.setState({ style: rippleInstance.style });
      });
    };

    _this.handleFocus = function (e) {
      _this.setState({ focus: true });
      _this.props.onFocus && _this.props.onFocus(e);
    };

    _this.handleBlur = function (e) {
      _this.setState({ focus: false });
      _this.props.onBlur && _this.props.onBlur(e);
    };

    _this.handleClick = function (e) {
      var rippleInstance = Object(__WEBPACK_IMPORTED_MODULE_2__material_ripple__["a" /* default */])(_this.root_);
      _this.setState({ ripple: true, style: rippleInstance.style });
      setTimeout(function () {
        _this.setState({ ripple: false });
      }, rippleInstance.duration);
      _this.props.onClick && _this.props.onClick(e);
    };

    _this.state = {
      focus: false,
      ripple: false,
      style: ''
    };
    return _this;
  }

  Fab.prototype.render = function render(_ref, _ref2, context) {
    var _this2 = this;

    var focus = _ref2.focus,
        ripple = _ref2.ripple,
        style = _ref2.style;

    var className = _ref['class'],
        children = _ref.children,
        icon = _ref.icon,
        plain = _ref.plain,
        mini = _ref.mini,
        onFocus = _ref.onFocus,
        onBlur = _ref.onBlur,
        onClick = _ref.onClick,
        props = _objectWithoutProperties(_ref, ['class', 'children', 'icon', 'plain', 'mini', 'onFocus', 'onBlur', 'onClick']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-fab mdc-ripple-upgraded mdc-ripple-upgraded--unbounded material-icons', {
      'mdc-fab--plain': plain,
      'mdc-fab--mini': mini,
      'mdc-ripple-upgraded--background-active-fill': ripple,
      'mdc-ripple-upgraded--foreground-activation': ripple,
      'mdc-ripple-upgraded--foreground-deactivation': !ripple,
      'mdc-ripple-upgraded--background-focused': focus
    }, className);

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'button',
      _extends({ 'class': classes,
        'aria-label': icon,
        style: style,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick
      }, props, {
        ref: function ref(e) {
          return _this2.root_ = e;
        } }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { 'class': 'mdc-fab__icon' },
        icon
      )
    );
  };

  return Fab;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "/X9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @template A
 */
var MDCFoundation = function () {
  _createClass(MDCFoundation, null, [{
    key: "cssClasses",

    /** @return enum{cssClasses} */
    get: function get() {
      // Classes extending MDCFoundation should implement this method to return an object which exports every
      // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
      return {};
    }

    /** @return enum{strings} */

  }, {
    key: "strings",
    get: function get() {
      // Classes extending MDCFoundation should implement this method to return an object which exports all
      // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
      return {};
    }

    /** @return enum{numbers} */

  }, {
    key: "numbers",
    get: function get() {
      // Classes extending MDCFoundation should implement this method to return an object which exports all
      // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
      return {};
    }

    /** @return {!Object} */

  }, {
    key: "defaultAdapter",
    get: function get() {
      // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
      // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
      // validation.
      return {};
    }

    /**
     * @param {A=} adapter
     */

  }]);

  function MDCFoundation() {
    var adapter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MDCFoundation);

    /** @protected {!A} */
    this.adapter_ = adapter;
  }

  MDCFoundation.prototype.init = function init() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
  };

  MDCFoundation.prototype.destroy = function destroy() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
  };

  return MDCFoundation;
}();

/* harmony default export */ __webpack_exports__["a"] = (MDCFoundation);

/***/ }),

/***/ "/gj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return POST_AD_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FORM_ELEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return POST_AD_FORMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAP_ERROR_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAP_CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defaultJobsPostAdRequestState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateCityField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateLocalityFieldWithCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateSubRolesFieldWithRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showOnlyFreeJobsPostingVersion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__("upA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Apply_ApplyCookieHelper__ = __webpack_require__("8Ery");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__message__ = __webpack_require__("9mGc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_window_or_global__);
var _defaultJobsPostAdReq;

/* eslint-disable indent */
/* eslint-disable func-style */





//Don't change this object.
var POST_AD_FIELDS = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  TYPE: 'jobType',
  ROLE: 'role',
  SUB_ROLE: 'subRole',
  ROLE_SUB_ROLE: 'roleSubrole',
  MIN_SALARY: 'minSalary',
  MAX_SALARY: 'maxSalary',
  MIN_EXPERIENCE: 'minExp',
  MAX_EXPERIENCE: 'maxExp',
  RECRUITER_EMAIL: 'recruiterEmail',
  RECRUITER_PHONE: 'recruiterMobile',
  CITY: 'city',
  LOCALITY: 'locality',
  HIRING_COMPANY: 'hiringCompany',
  POSTED_BY_COMPANY: 'postedByCompany',
  CITY_LOCALITY: 'cityLocality',
  DISPLAY_CONTACT: 'displayContact',
  INCLUDE_WEBSITE_URL: 'includeWebsiteUrl',
  INCLUDE_MOBILE_NUMBER: 'includeMobileNumber',
  QUIKR_RECRUITMENT_SERVICES: 'quikrRecruitmentServices',
  REMOTE_JOB: 'remoteJob',
  CUSTOM_ERROR_FIELD: 'customErrorField',
  PACK_SELECTION: 'packSelection'
};

var FORM_ELEMENTS = {
  JOB_AD: 'jobAd',
  PAYMENT_CART: 'jobCart'
};

var POST_AD_FORMS = {
  POST_AD_STEP_1: 'POST_AD_STEP_1',
  POST_AD_STEP_2: 'POST_AD_STEP_2',
  EDIT_AD_STEP_1: 'EDIT_AD_STEP_1',
  EDIT_AD_STEP_2: 'EDIT_AD_STEP_2'
};

var PAP_ERROR_MESSAGES = {
  ERROR: 'Something went wrong. Please try again',
  MAX_FREE_POSTED: 'You have posted maximum free ads in last 24 hours. You can post Gold jobs now',
  MAX_FREE_ACTIVE_AD_POSTED: 'Your limit of a maximum of [[MAX_LIMIT]] active free ads for city [[CITY_NAME]] is exceeded',
  MAX_GLOBAL_ACTIVE_AD_POSTED: 'You have reached your Monthly limit of [[MAX_LIMIT]] free active ads',
  MAX_TOTAL_AD_POSTED: 'Your total free ad limit of jobs post is exceeded.'
};

var PAP_CONSTANTS = {
  FULL_CITY: 'Full City',
  MAX_FREE_LOCALITY: 5,
  TITLE_MIN_CHARACTER: 10,
  DEFAULT_MAX_SALARY: 100000,
  TECH_MAX_SALARY: 500000
};

var defaultJobsPostAdRequestState = (_defaultJobsPostAdReq = {}, _defaultJobsPostAdReq[POST_AD_FIELDS.TYPE] = {
  show: true,
  disabled: false,
  options: [],
  selectedId: 272,
  value: 'Full Time Jobs'
}, _defaultJobsPostAdReq[POST_AD_FIELDS.MIN_SALARY] = {
  show: true,
  value: '',
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.MIN_SALARY }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.MAX_SALARY] = {
  show: true,
  value: '',
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.MAX_SALARY }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.TITLE] = {
  value: '',
  show: true,
  disabled: false,
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.TITLE }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.HIRING_COMPANY] = {
  value: '',
  disabled: false,
  show: true,
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: [POST_AD_FIELDS.HIRING_COMPANY] }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.POSTED_BY_COMPANY] = {
  value: '',
  disabled: true,
  show: false,
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: [POST_AD_FIELDS.POSTED_BY_COMPANY] }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.CITY] = {
  value: '',
  id: '',
  apiUrl: '/jobs/jobsAjax/getAllCities',
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.CITY }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.LOCALITY] = {
  apiUrl: '/jobs/jobsAjax/localitySearch?cityName=',
  value: [],
  disabled: true,
  show: true,
  maxLimit: 5,
  fullCity: {
    display: '',
    show: false
  },
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.LOCALITY }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.ROLE] = {
  // value: '',
  // id: -1,
  valueObject: {},
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.ROLE }).get(),
  others: ''
}, _defaultJobsPostAdReq[POST_AD_FIELDS.SUB_ROLE] = {
  valueObject: []
}, _defaultJobsPostAdReq[POST_AD_FIELDS.MIN_EXPERIENCE] = {
  value: '',
  options: [],
  defaultOptions: [],
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.MIN_EXPERIENCE }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.MAX_EXPERIENCE] = {
  value: '',
  options: [],
  defaultOptions: [],
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.MAX_EXPERIENCE }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.DESCRIPTION] = {
  value: '',
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.DESCRIPTION }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.RECRUITER_EMAIL] = {
  value: '',
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.RECRUITER_EMAIL }).get(),
  options: [],
  label: 'Email'
}, _defaultJobsPostAdReq[POST_AD_FIELDS.RECRUITER_PHONE] = {
  value: '',
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.RECRUITER_PHONE }).get(),
  options: [],
  label: 'Phone'
}, _defaultJobsPostAdReq[POST_AD_FIELDS.DISPLAY_CONTACT] = {
  checked: true
}, _defaultJobsPostAdReq[POST_AD_FIELDS.INCLUDE_WEBSITE_URL] = {
  checked: false,
  url: '',
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.INCLUDE_WEBSITE_URL }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.INCLUDE_MOBILE_NUMBER] = {
  checked: false
}, _defaultJobsPostAdReq[POST_AD_FIELDS.QUIKR_RECRUITMENT_SERVICES] = {
  value: '',
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.QUIKR_RECRUITMENT_SERVICES }).get()
}, _defaultJobsPostAdReq[POST_AD_FIELDS.REMOTE_JOB] = {
  value: '',
  message: new __WEBPACK_IMPORTED_MODULE_2__message__["a" /* Message */](1, 0, '', { field: POST_AD_FIELDS.REMOTE_JOB }).get()
}, _defaultJobsPostAdReq.others = {
  formType: POST_AD_FORMS.POST_AD_STEP_1,
  paymentTotal: {
    value: 0,
    type: 'money'
  },
  packContainerMessage: null,
  selectedPack: 'freeAd',
  selectedSubPack: null,
  message: '',
  customErrorField: '' // used for displaying validation message ref: formchangehandler@handleSubmit
}, _defaultJobsPostAdReq.showLoader = false, _defaultJobsPostAdReq.showUnlimitedFreeAdsBanner = false, _defaultJobsPostAdReq.showOTP = false, _defaultJobsPostAdReq.packContainerVersion = 1, _defaultJobsPostAdReq.step = 1, _defaultJobsPostAdReq.validationVersion = 0, _defaultJobsPostAdReq.currentStep = 0, _defaultJobsPostAdReq);

var updateCityField = function updateCityField(existingCityObject, cityName, cityId) {
  var updatedCityObject = Object(__WEBPACK_IMPORTED_MODULE_0____["c" /* copyObject */])(existingCityObject);
  updatedCityObject.value = cityName;
  updatedCityObject.id = cityId;
  return updatedCityObject;
};

var updateLocalityFieldWithCity = function updateLocalityFieldWithCity(existingLocalityObject, cityName) {
  var updatedLocalityObject = Object(__WEBPACK_IMPORTED_MODULE_0____["c" /* copyObject */])(existingLocalityObject);
  if (existingLocalityObject.show) {
    updatedLocalityObject.disabled = false;
  }
  updatedLocalityObject.value = [];
  updatedLocalityObject.apiUrl = '/jobs/jobsAjax/localitySearch?cityName=' + cityName;
  return updatedLocalityObject;
};

var updateSubRolesFieldWithRole = function updateSubRolesFieldWithRole(existingSubRoleObject, roleObject) {
  var updatedSubRoleObject = Object(__WEBPACK_IMPORTED_MODULE_0____["c" /* copyObject */])(existingSubRoleObject);
  if (existingSubRoleObject.show) {
    updatedSubRoleObject.disabled = false;
  }
  updatedSubRoleObject.value = [];
  updatedSubRoleObject.subList = roleObject.subList;
  return updatedSubRoleObject;
};

var showOnlyFreeJobsPostingVersion = function showOnlyFreeJobsPostingVersion() {
  var config = typeof __WEBPACK_IMPORTED_MODULE_3_window_or_global___default.a.JobSnow != 'undefined' && __WEBPACK_IMPORTED_MODULE_3_window_or_global___default.a.JobSnow.upgradeAdAbRand ? parseInt(__WEBPACK_IMPORTED_MODULE_3_window_or_global___default.a.JobSnow.upgradeAdAbRand, 10) : 0;
  var cookieHelper = new __WEBPACK_IMPORTED_MODULE_1__utils_Apply_ApplyCookieHelper__["a" /* default */]();
  var abRandMobile = cookieHelper.getABRandMobile();
  return abRandMobile <= config;
};

/***/ }),

/***/ "1QGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../form-urlencoded/dist/form-urlencoded.js
var form_urlencoded = __webpack_require__("dA1j");
var form_urlencoded_default = /*#__PURE__*/__webpack_require__.n(form_urlencoded);

// EXTERNAL MODULE: ../q-jobs/src/utils/FetchHelper/index.js
var FetchHelper = __webpack_require__("Hm4v");

// EXTERNAL MODULE: ../q-jobs/src/constants/index.js
var constants = __webpack_require__("QSFW");

// EXTERNAL MODULE: ../q-jobs/src/constants/events.js
var events = __webpack_require__("4xt+");

// CONCATENATED MODULE: ../q-jobs/src/actions/ConfigActions/index.js
/**
 * @author shreyas.hande on 6/11/18
 *
 */



var ConfigActions_updateConfig = function updateConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var store = arguments[1];
    return {
        type: events["c" /* CONFIG_EVENTS */].UPDATE_CONFIG,
        payload: { config: config, store: store }
    };
};

var ConfigActions_configUpdated = function configUpdated() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var store = arguments[1];
    return {
        type: events["c" /* CONFIG_EVENTS */].CONFIG_UPDATED,
        payload: { config: config, store: store }
    };
};
// EXTERNAL MODULE: ../q-jobs/src/actions/UserActions/index.js
var UserActions = __webpack_require__("X6l3");

// EXTERNAL MODULE: ../q-jobs/src/store.js + 18 modules
var src_store = __webpack_require__("R8p8");

// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/jobsPostAdRequest.js + 1 modules
var jobsPostAdRequest = __webpack_require__("YShu");

// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/genericValidator.js
var genericValidator = __webpack_require__("LZrM");

// EXTERNAL MODULE: ../window-or-global/lib/index.js
var lib = __webpack_require__("IyPV");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ../q-jobs/src/utils/Config/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Config_Config; });
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author shreyas.hande on 6/12/18
 *
 */













var Config_Config = (_temp = _class = function () {
  function Config() {
    _classCallCheck(this, Config);
  }

  Config.updateConfig = function updateConfig(updatedConfig, jobStore) {
    src_store["b" /* default */].dispatch(ConfigActions_updateConfig(updatedConfig, jobStore));
    src_store["b" /* default */].dispatch(ConfigActions_configUpdated({}, jobStore));
  };

  Config.updateConfigForCategory = function updateConfigForCategory(params) {
    var _params$cityId = params.cityId,
        cityId = _params$cityId === undefined ? null : _params$cityId,
        _params$subCatId = params.subCatId,
        subCatId = _params$subCatId === undefined ? null : _params$subCatId,
        _params$cityname = params.cityname,
        cityname = _params$cityname === undefined ? null : _params$cityname,
        _params$roleName = params.roleName,
        roleName = _params$roleName === undefined ? null : _params$roleName,
        _params$adId = params.adId,
        adId = _params$adId === undefined ? null : _params$adId;

    var apiParams = {};

    if (!genericValidator["a" /* Validator */].isEmpty(adId)) apiParams.adId = adId;else apiParams.adId = '';

    if (!genericValidator["a" /* Validator */].isEmpty(cityId)) apiParams.cityId = cityId;else apiParams.cityId = '';

    if (!genericValidator["a" /* Validator */].isEmpty(cityname)) apiParams.cityname = cityname;else apiParams.cityname = '';

    if (!genericValidator["a" /* Validator */].isEmpty(subCatId)) apiParams.subCatId = subCatId;

    if (!genericValidator["a" /* Validator */].isEmpty(roleName)) apiParams.roleName = roleName;

    var url = lib_default.a.location.protocol + '//' + constants["b" /* API_URL */] + '/getPremiumPriceJobs';

    var options = {
      url: url,
      data: form_urlencoded_default()(apiParams)
    };

    var fetchHelper = new FetchHelper["a" /* default */]();
    var responsePromise = fetchHelper.request('post', options);
    responsePromise.then(function (apiResponse) {
      var response = apiResponse.data;
      if ('undefined' !== typeof response) {
        var updatedConfig = {
          papPrices: response
        };

        var jobStore = src_store["a" /* JobStore */].getState();
        Config.updateConfig(updatedConfig, jobStore);

        var updatedUserDetails = {
          hasCredits: response.userCredit,
          credits: response.userCreditNo,
          whatsappConnectCredits: response.whatsappConnectCredits
        };

        src_store["b" /* default */].dispatch(Object(UserActions["a" /* updateUser */])(updatedUserDetails));
        jobsPostAdRequest["a" /* default */].updateRedux();
      }
    });
  };

  Config.activeWhatsappPackForAd = function activeWhatsappPackForAd(adId) {
    var apiParams = {};

    if (!genericValidator["a" /* Validator */].isEmpty(adId)) apiParams.adId = adId;

    var url = lib_default.a.location.protocol + '//' + constants["b" /* API_URL */] + '/activateWhatsappConnect';
    var options = {
      url: url,
      data: form_urlencoded_default()(apiParams)
    };
    var fetchHelper = new FetchHelper["a" /* default */]();
    var responsePromise = fetchHelper.request('post', options);

    return responsePromise;
  };

  return Config;
}(), _class.get = function (key, store) {
  return store ? store.config[key] : null;
}, _class.hasKey = function (key, store) {
  return store ? store.config.hasOwnProperty(key) : null;
}, _class.isUnlimitedFreeAdsEnabled = function (cityname) {
  var isEnabled = false;

  var _JobStore$getState = src_store["a" /* JobStore */].getState(),
      config = _JobStore$getState.config;

  if ('undefined' !== typeof config) {
    isEnabled = -1 !== config.jobsUnlimitedFreeAdsEnabledCities.indexOf(cityname) || -1 !== config.jobsUnlimitedFreeAdsEnabledCities.indexOf('all');
  }

  return isEnabled;
}, _temp);


/***/ }),

/***/ "1j7S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("UXCT");
var utils = __webpack_require__("bEy/");
var InterceptorManager = __webpack_require__("Nyl0");
var dispatchRequest = __webpack_require__("miKh");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, { method: 'get' }, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),

/***/ "2BRZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../preact/dist/preact.js
var preact = __webpack_require__("xIV9");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// EXTERNAL MODULE: ../classnames/dedupe.js
var dedupe = __webpack_require__("I0+G");
var dedupe_default = /*#__PURE__*/__webpack_require__.n(dedupe);

// EXTERNAL MODULE: ../@material/menu/index.js + 5 modules
var menu = __webpack_require__("IHAU");

// EXTERNAL MODULE: ../q-jobs/node_modules/q-mdc/elements/material-list-item/index.js
var material_list_item = __webpack_require__("OCMy");

// EXTERNAL MODULE: ../@material/menu/mdc-menu.scss
var mdc_menu = __webpack_require__("aQ7X");
var mdc_menu_default = /*#__PURE__*/__webpack_require__.n(mdc_menu);

// EXTERNAL MODULE: ../q-jobs/node_modules/q-mdc/elements/material-menu/index.scss
var material_menu = __webpack_require__("7vuG");
var material_menu_default = /*#__PURE__*/__webpack_require__.n(material_menu);

// CONCATENATED MODULE: ../q-jobs/node_modules/q-mdc/elements/material-menu/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var defaultProps = {
	open: false
};

var material_menu_Menu = function (_Component) {
	_inherits(Menu, _Component);

	function Menu(props) {
		_classCallCheck(this, Menu);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._mdcProps = ["open", "open-from-top-left", "open-from-top-right", "open-from-bottom-left", "open-from-bottom-right"];
		_this._select = _this._select.bind(_this);
		_this._cancel = _this._cancel.bind(_this);
		return _this;
	}

	Menu.prototype.componentDidMount = function componentDidMount() {
		this.MDComponent = new menu["a" /* MDCSimpleMenu */](this.control);
		this.MDComponent.listen("MDCSimpleMenu:selected", this._select);
		this.MDComponent.listen("MDCSimpleMenu:cancel", this._cancel);
		toggleMenu(defaultProps, this.props, this.MDComponent);
	};

	Menu.prototype.componentWillUnmount = function componentWillUnmount() {
		this.MDComponent.unlisten("MDCSimpleMenu:selected", this._select);
		this.MDComponent.unlisten("MDCSimpleMenu:cancel", this._cancel);
		this.MDComponent.destroy && this.MDComponent.destroy();
	};

	Menu.prototype._select = function _select() {
		if (this.props.onSelect) {
			this.props.onSelect();
		}
		this._menuClosed();
	};

	Menu.prototype._cancel = function _cancel() {
		if (this.props.onCancel) {
			this.props.onCancel();
		}
		this._menuClosed();
	};

	Menu.prototype._menuClosed = function _menuClosed() {
		if (this.props.onMenuClosed) {
			this.props.onMenuClosed();
		}
	};

	Menu.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
		toggleMenu(this.props, nextProps, this.MDComponent);
	};

	Menu.prototype.render = function render(_ref) {
		var _this2 = this;

		var className = _ref['class'],
		    props = _objectWithoutProperties(_ref, ['class']);

		var classes = dedupe_default()('mdc-simple-menu', className);
		return Object(preact["h"])(
			'div',
			_extends({ 'class': classes, tabindex: '-1' }, props, { ref: function ref(control) {
					return _this2.control = control;
				} }),
			Object(preact["h"])(
				'ul',
				{
					'class': 'mdc-simple-menu__items mdc-list',
					role: 'menu',
					'aria-hidden': 'true'
				},
				props.children
			)
		);
	};

	return Menu;
}(preact["Component"]);

var material_menu_MenuAnchor = function (_Component2) {
	_inherits(MenuAnchor, _Component2);

	function MenuAnchor(props) {
		_classCallCheck(this, MenuAnchor);

		return _possibleConstructorReturn(this, _Component2.call(this, props));
	}

	MenuAnchor.prototype.render = function render(_ref2) {
		var className = _ref2['class'],
		    children = _ref2.children,
		    props = _objectWithoutProperties(_ref2, ['class', 'children']);

		var classes = dedupe_default()('mdc-menu-anchor', className);
		return Object(preact["h"])(
			'div',
			{ 'class': classes },
			children
		);
	};

	return MenuAnchor;
}(preact["Component"]);

function toggleMenu(oldprops, newprops, menu) {
	if ("open" in oldprops && "open" in newprops && oldprops.open !== newprops.open) {
		menu.open = newprops.open;
	}
}

material_menu_Menu.Anchor = material_menu_MenuAnchor;
material_menu_Menu.Item = material_list_item["a" /* default */];
/* harmony default export */ var elements_material_menu = (material_menu_Menu);
// EXTERNAL MODULE: ../q-jobs/node_modules/q-components/components/icons/headerIcons/index.js + 2 modules
var headerIcons = __webpack_require__("O3jv");

// EXTERNAL MODULE: ../q-jobs/node_modules/q-components/helpers/ga.js
var ga = __webpack_require__("WDOI");

// EXTERNAL MODULE: ../axios/index.js
var axios = __webpack_require__("Vr6w");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ../q-jobs/node_modules/q-components/components/myAccount/index.scss
var myAccount = __webpack_require__("uka7");
var myAccount_default = /*#__PURE__*/__webpack_require__.n(myAccount);

// CONCATENATED MODULE: ../q-jobs/node_modules/q-components/components/myAccount/index.js


function myAccount__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function myAccount__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function myAccount__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var defaultLoggedOutMenuArr = [
// { title: 'My Cart', href: '/QuikrX/Cart',gaEventName: 'cart' },
// { title: 'My Doorstep Offers', href: '/Escrow/MyOffers/getBuyersOfferForm',gaEventName:'doorstep_offers' },
// { title: 'My Notifications', href: "no_redicetion" , gaEventName:'notifictions', onClick: (e) => { e.preventDefault(); e.stopPropagation(); }, callFunction:'openNotificationPopup'},
{ title: 'Chats', href: '/MyQuikr?action=mychats', gaEventName: 'chats' }, {
	href: "/instant-leads",
	title: "Instant Leads",
	gaEventName: "instant_leads"
}, { title: 'Login/Register', href: '/SignIn', gaEventName: 'login', onClick: function onClick(e) {
		e.preventDefault();e.stopPropagation();window.location = '/SignIn?redirect=' + encodeURIComponent(window.location.href);
	} }];

var defaultLoggedInMenuArr = [{ href: '/MyQuikr', title: 'My Account', gaEventName: 'account' }, { href: '/MyQuikr?action=mychats', title: 'Chats' /*<span class="notification--num" >3</span>*/, gaEventName: 'chats' }, { href: '/MyQuikr?action=alertsdetails', title: 'Alerts', gaEventName: 'alerts' }, { href: '/MyQuikr?action=activeads', title: 'My Ads', gaEventName: 'ads' },
// { title: 'My Cart', href: '/QuikrX/Cart',gaEventName: 'cart' },
// { title: 'My Doorstep Offers', href: '/Escrow/MyOffers/getBuyersOfferForm', gaEventName:'doorstep_offers' },
// { title: 'My Notifications', href: "no_redicetion", gaEventName:'notifictions', onClick: (e) => { e.preventDefault(); e.stopPropagation(); }, callFunction:'openNotificationPopup' },
{ href: '/MyQuikr?action=lead', title: 'My Leads', gaEventName: 'leads' }, {
	href: "/instant-leads",
	title: "Instant Leads",
	gaEventName: "instant_leads"
}, { href: '/QuikrX/myorders', title: 'My Orders', gaEventName: 'orders' },

/* <Menu.Item link href="#">Recommendation for me</Menu.Item> */

{ title: 'Logout', href: '/bye', gaEventName: 'logout' }];

var myAccount_QMenu = function (_Component) {
	myAccount__inherits(QMenu, _Component);

	function QMenu() {
		var _temp, _this, _ret;

		myAccount__classCallCheck(this, QMenu);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = myAccount__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.pushGAEvent = function (eventName) {
			var pageType = _this.context.pageType;

			var gaEventObject = { category: 'quikr_pwa', action: 'quikr_pwa_' + pageType + '_usersection', label: 'quikr_pwa_' + pageType + '_usersection_my_' + eventName };
			Object(ga["a" /* getEventTrackGA */])(gaEventObject);
		}, _temp), myAccount__possibleConstructorReturn(_this, _ret);
	}

	QMenu.prototype.render = function render(_ref) {
		var _this2 = this;

		var list = _ref.list,
		    refFn = _ref.refFn,
		    callHeaderfunction = _ref.callHeaderfunction;

		return Object(preact["h"])(
			elements_material_menu,
			{
				ref: function ref(menu) {
					return refFn(menu);
				},
				links: true
			},
			list.map(function (menuItem) {
				return Object(preact["h"])(
					elements_material_menu.Item,
					{
						link: true,
						href: menuItem.href,
						onClick: function onClick(e) {
							_this2.pushGAEvent(menuItem.gaEventName);
							if (menuItem.onClick) {
								menuItem.onClick(e);
							}
							if (menuItem.callFunction) {
								callHeaderfunction(menuItem.callFunction);
							}
						}
					},
					menuItem.title
				);
			})
		);
	};

	return QMenu;
}(preact["Component"]);

var myAccount__ref2 = Object(preact["h"])(
	'div',
	{ className: 'qc-tooltip' },
	'You\'re signed out of Quikr',
	Object(preact["h"])('br', null),
	'Login/Register'
);

var _ref3 = Object(preact["h"])(headerIcons["a" /* Account */], { 'class': 'mdc-toolbar__icons' });

var _ref4 = Object(preact["h"])(
	'span',
	{ 'class': 'link-text-hidden' },
	'Quikr Account Menu'
);

var myAccount_MyAccountMenu = function (_Component2) {
	myAccount__inherits(MyAccountMenu, _Component2);

	function MyAccountMenu(props) {
		myAccount__classCallCheck(this, MyAccountMenu);

		return myAccount__possibleConstructorReturn(this, _Component2.call(this, props));
	}

	MyAccountMenu.prototype.render = function render(props, state, context) {
		var _this4 = this;

		var showTooltip = context.showTooltip;

		var child = myAccount__ref2;
		var isLoggedIn = props.isLoggedIn,
		    _props$loggedInMenu = props.loggedInMenu,
		    loggedInMenu = _props$loggedInMenu === undefined ? defaultLoggedInMenuArr : _props$loggedInMenu,
		    _props$loggedOutMenu = props.loggedOutMenu,
		    loggedOutMenu = _props$loggedOutMenu === undefined ? defaultLoggedOutMenuArr : _props$loggedOutMenu,
		    callHeaderfunction = props.callHeaderfunction;

		return Object(preact["h"])(
			'span',
			null,
			Object(preact["h"])(
				'a',
				{ href: 'javascript:void(0);',
					'class': 'mdc-toolbar__icon',
					onClick: function onClick(e) {
						_this4.setState({ show: false });
						_this4.menu.MDComponent.open = true;
					}
				},
				_ref3,
				_ref4,
				!isLoggedIn && showTooltip && child
			),
			!isLoggedIn && Object(preact["h"])(myAccount_QMenu, {
				refFn: function refFn(menu) {
					_this4.menu = menu;
				},
				list: loggedOutMenu,
				callHeaderfunction: callHeaderfunction
			}),
			isLoggedIn && Object(preact["h"])(myAccount_QMenu, {
				refFn: function refFn(menu) {
					_this4.menu = menu;
				},
				list: loggedInMenu,
				callHeaderfunction: callHeaderfunction
			})
		);
	};

	return MyAccountMenu;
}(preact["Component"]);

/* harmony default export */ var components_myAccount = __webpack_exports__["a"] = (myAccount_MyAccountMenu);

/***/ }),

/***/ "2L6H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),

/***/ "2Pi1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Y88":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ckI":
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "2mi+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2oDr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "33Wp":
/***/ (function(module, exports, __webpack_require__) {

var tabbable = __webpack_require__("m0N8");

var listeningFocusTrap = null;

function focusTrap(element, userOptions) {
  var tabbableNodes = [];
  var firstTabbableNode = null;
  var lastTabbableNode = null;
  var nodeFocusedBeforeActivation = null;
  var active = false;
  var paused = false;
  var tabEvent = null;

  var container = typeof element === 'string' ? document.querySelector(element) : element;

  var config = userOptions || {};
  config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
  config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;

  var trap = {
    activate: activate,
    deactivate: deactivate,
    pause: pause,
    unpause: unpause
  };

  return trap;

  function activate(activateOptions) {
    if (active) return;

    var defaultedActivateOptions = {
      onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
    };

    active = true;
    paused = false;
    nodeFocusedBeforeActivation = document.activeElement;

    if (defaultedActivateOptions.onActivate) {
      defaultedActivateOptions.onActivate();
    }

    addListeners();
    return trap;
  }

  function deactivate(deactivateOptions) {
    if (!active) return;

    var defaultedDeactivateOptions = {
      returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
      onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
    };

    removeListeners();

    if (defaultedDeactivateOptions.onDeactivate) {
      defaultedDeactivateOptions.onDeactivate();
    }

    if (defaultedDeactivateOptions.returnFocus) {
      setTimeout(function () {
        tryFocus(nodeFocusedBeforeActivation);
      }, 0);
    }

    active = false;
    paused = false;
    return this;
  }

  function pause() {
    if (paused || !active) return;
    paused = true;
    removeListeners();
  }

  function unpause() {
    if (!paused || !active) return;
    paused = false;
    addListeners();
  }

  function addListeners() {
    if (!active) return;

    // There can be only one listening focus trap at a time
    if (listeningFocusTrap) {
      listeningFocusTrap.pause();
    }
    listeningFocusTrap = trap;

    updateTabbableNodes();
    // Ensure that the focused element doesn't capture the event that caused the focus trap activation
    setTimeout(function () {
      tryFocus(firstFocusNode());
    }, 0);
    document.addEventListener('focus', checkFocus, true);
    document.addEventListener('click', checkClick, true);
    document.addEventListener('mousedown', checkPointerDown, true);
    document.addEventListener('touchstart', checkPointerDown, true);
    document.addEventListener('keydown', checkKey, true);

    return trap;
  }

  function removeListeners() {
    if (!active || listeningFocusTrap !== trap) return;

    document.removeEventListener('focus', checkFocus, true);
    document.removeEventListener('click', checkClick, true);
    document.removeEventListener('mousedown', checkPointerDown, true);
    document.removeEventListener('touchstart', checkPointerDown, true);
    document.removeEventListener('keydown', checkKey, true);

    listeningFocusTrap = null;

    return trap;
  }

  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === 'string') {
      node = document.querySelector(optionValue);
      if (!node) {
        throw new Error('`' + optionName + '` refers to no known node');
      }
    }
    if (typeof optionValue === 'function') {
      node = optionValue();
      if (!node) {
        throw new Error('`' + optionName + '` did not return a node');
      }
    }
    return node;
  }

  function firstFocusNode() {
    var node;
    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (container.contains(document.activeElement)) {
      node = document.activeElement;
    } else {
      node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error('You can\'t have a focus-trap without at least one focusable element');
    }

    return node;
  }

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event
  function checkPointerDown(e) {
    if (config.clickOutsideDeactivates && !container.contains(e.target)) {
      deactivate({ returnFocus: false });
    }
  }

  function checkClick(e) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function checkFocus(e) {
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // Checking for a blur method here resolves a Firefox issue (#15)
    if (typeof e.target.blur === 'function') e.target.blur();

    if (tabEvent) {
      readjustFocus(tabEvent);
    }
  }

  function checkKey(e) {
    if (e.key === 'Tab' || e.keyCode === 9) {
      handleTab(e);
    }

    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      deactivate();
    }
  }

  function handleTab(e) {
    updateTabbableNodes();

    if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) {
      return tabEvent = e;
    }

    e.preventDefault();
    var currentFocusIndex = tabbableNodes.indexOf(e.target);

    if (e.shiftKey) {
      if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) {
        return tryFocus(lastTabbableNode);
      }
      return tryFocus(tabbableNodes[currentFocusIndex - 1]);
    }

    if (e.target === lastTabbableNode) return tryFocus(firstTabbableNode);

    tryFocus(tabbableNodes[currentFocusIndex + 1]);
  }

  function updateTabbableNodes() {
    tabbableNodes = tabbable(container);
    firstTabbableNode = tabbableNodes[0];
    lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
  }

  function readjustFocus(e) {
    if (e.shiftKey) return tryFocus(lastTabbableNode);

    tryFocus(firstTabbableNode);
  }
}

function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}

function tryFocus(node) {
  if (!node || !node.focus) return;
  if (node === document.activeElement) return;

  node.focus();
  if (node.tagName.toLowerCase() === 'input') {
    node.select();
  }
}

module.exports = focusTrap;

/***/ }),

/***/ "3T6j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/***/ }),

/***/ "3hZy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3tI1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ "4Pem":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UrlBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_url__ = __webpack_require__("hnk3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("QSFW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_path_to_regexp__ = __webpack_require__("mKYW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_form_urlencoded__ = __webpack_require__("dA1j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_form_urlencoded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_form_urlencoded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_universal_cookie__ = __webpack_require__("/ErD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_url_search_params_polyfill__ = __webpack_require__("Qrop");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_url_search_params_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_url_search_params_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_window_or_global__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Helper for forming Jobs Urls based on route and parameters
 */








var UrlBuilder = function () {
	function UrlBuilder() {
		_classCallCheck(this, UrlBuilder);
	}

	/**
  * Get Jobs Snb Url's from parameter
  * @param {*} params
  */
	UrlBuilder.prototype.getJobsSnbUrl = function getJobsSnbUrl(params) {
		// Loop through Each Key and form seo url key
		var urlFormat = this.getUrlFromIdentifires(params);

		urlFormat = __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BASE_URL */] + '/' + urlFormat;
		return urlFormat;
	};

	/**
  * Get OrderedKey from url params
  * @param {*} params
  */


	UrlBuilder.prototype.getUrlFromIdentifires = function getUrlFromIdentifires(params) {
		//Appending Get parameters
		var getParams = {};

		//If city is not passed get from cookie
		if (!params || !params.city) {
			var cookies = new __WEBPACK_IMPORTED_MODULE_4_universal_cookie__["a" /* default */]();
			var city = cookies.get('new_prefer_city');
			if (city) {
				params.city = city;
			}
		}

		if (params.city && !(params.city instanceof Array)) {
			params.city = this.sanitizeCity(params.city);
		}

		// Remove search if role is selected
		if (params.role) {
			delete params.keyword;
		}
		//Keywords seo url handlibg
		if (params.keyword) {
			for (var key in params) {
				if (Object.prototype.hasOwnProperty.call(params, key)) {
					if (__WEBPACK_IMPORTED_MODULE_0__constants_url__["l" /* KEYWORD_URL_PARAMS */].indexOf(key) < 0) {
						getParams[key] = params[key] instanceof Array && params[key].length > 0 ? params[key][0] : params[key];
						delete params[key];
					}
				}
			}
		}
		// Handling for all india and www case
		if ('All  India' === params.city || params.city === 'www' || params.city === '') {
			delete params.city;
		}

		// Special Case for Govt Jobs
		if (params.role && params.role === __WEBPACK_IMPORTED_MODULE_1__constants__["o" /* GOVERNMENT_JOBS_ROLE */]) {
			params.role = __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* GOVERNMENT_JOBS_ROLE_ALIAS */];
		}
		var urlKey = '';
		var sanitizedParams = [];

		for (var _key in __WEBPACK_IMPORTED_MODULE_0__constants_url__["C" /* URL_PARAMS_ORDER */]) {
			if (Object.prototype.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_0__constants_url__["C" /* URL_PARAMS_ORDER */], _key)) {
				var value = __WEBPACK_IMPORTED_MODULE_0__constants_url__["C" /* URL_PARAMS_ORDER */][_key];
				if (Object.prototype.hasOwnProperty.call(params, value)) {
					sanitizedParams.push(this.santizeUrlParam(params[value]));
					urlKey = urlKey === '' ? value : urlKey + '-' + value;
				}
			}
		}
		var url = '';
		if (__WEBPACK_IMPORTED_MODULE_0__constants_url__["B" /* URL_IDENTIFIERS */].hasOwnProperty(urlKey)) {
			var identifier = __WEBPACK_IMPORTED_MODULE_0__constants_url__["B" /* URL_IDENTIFIERS */][urlKey];

			//let pathRegex = pathToRegexp.compile(urlConstants.SNB_PATH_REGEX);
			//url = pathRegex({ query: sanitizedParams.join(urlConstants.PARAMETER_SEPERATOR),identifier });
			url += sanitizedParams.join(__WEBPACK_IMPORTED_MODULE_0__constants_url__["q" /* PARAMETER_SEPERATOR */]) + __WEBPACK_IMPORTED_MODULE_0__constants_url__["q" /* PARAMETER_SEPERATOR */] + __WEBPACK_IMPORTED_MODULE_0__constants_url__["y" /* SNB_URL_STRING */] + identifier;
		}

		for (var _key2 in __WEBPACK_IMPORTED_MODULE_0__constants_url__["h" /* GET_PARAMS */]) {
			if (Object.prototype.hasOwnProperty.call(params, __WEBPACK_IMPORTED_MODULE_0__constants_url__["h" /* GET_PARAMS */][_key2]) && params[__WEBPACK_IMPORTED_MODULE_0__constants_url__["h" /* GET_PARAMS */][_key2]].length > 0) {
				getParams[__WEBPACK_IMPORTED_MODULE_0__constants_url__["h" /* GET_PARAMS */][_key2]] = params[__WEBPACK_IMPORTED_MODULE_0__constants_url__["h" /* GET_PARAMS */][_key2]][0];
			}
		}

		if (getParams.salary && !(getParams.salary instanceof Array)) {
			getParams.salary = getParams.salary.replace(/[^0-9]/g, '');
			//getParams.salary  = getParams.salary.match(/\d+$/)[0];
		}
		if (Object.keys(getParams).length > 0) {
			url = url + '?' + __WEBPACK_IMPORTED_MODULE_3_form_urlencoded___default()(getParams);
		}

		return url;
	};

	// Remove x: from international cities


	UrlBuilder.prototype.sanitizeCity = function sanitizeCity(city) {
		try {
			return city.replace('x:', '').replace(/([A-Z])/g, ' $1').trim();
		} catch (e) {
			return '';
		}
	};

	/**
  * Sanitize Url Parameters for seo purpose
  * @param {*} param
  */


	UrlBuilder.prototype.santizeUrlParam = function santizeUrlParam(param) {
		//If parameter is array join them
		if (param instanceof Array) {
			param = param.join(__WEBPACK_IMPORTED_MODULE_0__constants_url__["a" /* ARRAY_SEPERATOR */]);
		}

		if (typeof param !== "undefined" && param !== null && param !== '') {
			try {
				return param.replace(__WEBPACK_IMPORTED_MODULE_0__constants_url__["D" /* URL_PATTERN */], __WEBPACK_IMPORTED_MODULE_0__constants_url__["u" /* SANITIZE_URL_SEPERATOR */]).toLowerCase();
			} catch (e) {
				return '';
			}
		}
	};

	/**
  * Get Parameters from parameter string
  */


	UrlBuilder.prototype.getParametersFromString = function getParametersFromString(paramString) {
		return paramString.split(__WEBPACK_IMPORTED_MODULE_0__constants_url__["a" /* ARRAY_SEPERATOR */]);
	};

	/**
  * Parse Url get Parameters.
  * @param {*} url (UrlString with parameters)
  * @param ssr (if this is called from node server)
  * @return params object
  */


	UrlBuilder.prototype.parseSnbUrl = function parseSnbUrl(url) {
		var ssr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		// get identifier from url and parse values
		var keys = [];
		var regex = __WEBPACK_IMPORTED_MODULE_2_path_to_regexp___default()(__WEBPACK_IMPORTED_MODULE_0__constants_url__["x" /* SNB_PATH_REGEX */], keys);
		var tokens = regex.exec(url);
		if (!tokens) {
			return {};
		}

		var paramString = tokens[1];
		var identifier = tokens[3];
		var resultIndex = Object.keys(__WEBPACK_IMPORTED_MODULE_0__constants_url__["B" /* URL_IDENTIFIERS */]).find(function (key) {
			return __WEBPACK_IMPORTED_MODULE_0__constants_url__["B" /* URL_IDENTIFIERS */][key] === identifier;
		});

		var searchString = '';
		if (ssr) {} else {
			searchString = __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location && __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location.hash !== '' ? __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location.hash : __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location && __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location.search !== '' ? __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location.search : '';
		}
		var urlParams = this.getUrlParams(searchString);

		// All get parameters from url
		try {

			return _extends({}, urlParams, this.getParametersFromIdentifier(paramString, resultIndex));
		} catch (error) {
			return urlParams;
		}
	};

	/**
  * Mapping parameter values and keys
  * @param {*} paramString
  * @param {*} IdentifierString
  */


	UrlBuilder.prototype.getParametersFromIdentifier = function getParametersFromIdentifier(paramString, IdentifierString) {
		var _this = this;

		var paramsArray = paramString.split(__WEBPACK_IMPORTED_MODULE_0__constants_url__["q" /* PARAMETER_SEPERATOR */]);
		var identifierArray = IdentifierString.split(__WEBPACK_IMPORTED_MODULE_0__constants_url__["u" /* SANITIZE_URL_SEPERATOR */]);

		var params = {};
		paramsArray.forEach(function (value, index) {
			if (identifierArray[index]) {
				params[identifierArray[index]] = _this.getParametersFromString(value);
			}
		});
		if (params.companyJobs) {
			params.keyword = params.companyJobs;
		}

		if (params.indexedKeyword) {
			params.keyword = params.indexedKeyword;
		}
		return params;
	};

	UrlBuilder.prototype.getJobIdFromVapUrl = function getJobIdFromVapUrl(url) {
		var regex = __WEBPACK_IMPORTED_MODULE_2_path_to_regexp___default()(__WEBPACK_IMPORTED_MODULE_0__constants_url__["E" /* VAP_PATH_REGEX */]);
		var tokens = regex.exec(url);
		if (!tokens) {
			return 0;
		}
		var jobId = tokens[2];
		return jobId;
	};

	UrlBuilder.prototype.getUrlParams = function getUrlParams(url) {
		var _this2 = this;

		var searchParams = new URLSearchParams(url);
		var getParams = {};
		__WEBPACK_IMPORTED_MODULE_0__constants_url__["h" /* GET_PARAMS */].forEach(function (value, index) {
			if (searchParams.has(value)) {
				getParams[value] = _this2.getParametersFromString(searchParams.get(value));
			}
		});
		return getParams;
	};

	UrlBuilder.getPageTypeFromUrl = function getPageTypeFromUrl(url) {
		var pageType = '';

		if (!url) {
			url = __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location.href;
		}

		if (url.indexOf('W0QQAdIdZ') > -1) {
			pageType = 'VAP';
		} else if (url.indexOf('zwqxj') > -1) {
			pageType = 'SNB';
		}

		return pageType;
	};

	return UrlBuilder;
}();



/***/ }),

/***/ "4t40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateJobSearchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emptyJobSearchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateDfpOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toggleJobListDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateJobSearchReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");


var updateJobSearchList = function updateJobSearchList() {
	var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["h" /* JOB_SEARCH_EVENTS */].UPDATE_JOB_SEARCH_LIST,
		payload: context
	};
};

var emptyJobSearchList = function emptyJobSearchList() {
	var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["h" /* JOB_SEARCH_EVENTS */].EMPTY_JOB_SEARCH_LIST,
		payload: context
	};
};

var updateDfpOptions = function updateDfpOptions() {
	var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["h" /* JOB_SEARCH_EVENTS */].UPDATE_DFP_OPTIONS,
		payload: context
	};
};

var toggleJobListDisplay = function toggleJobListDisplay(show) {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["h" /* JOB_SEARCH_EVENTS */].TOGGLE_JOB_LIST_DISPLAY,
		payload: {
			hideJobs: !show
		}
	};
};

var updateJobSearchReducer = function updateJobSearchReducer() {
	var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["h" /* JOB_SEARCH_EVENTS */].UPDATE_JOB_SEARCH_REDUCER,
		payload: context
	};
};

/***/ }),

/***/ "4xt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return JOB_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPLY_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return USER_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONTEXT_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return JOB_SEARCH_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONFIG_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return JOBS_POST_AD_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INTEGRATIONS_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WINDOW_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CANDIDATE_TEST_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PROFILE_EVENTS; });
/**
 * Maintaining all events in the application as constants
 * for tracking mainly
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

var EVENTS = {
  SNB_CONTAINER_EVENTS: {
    SORT_FILTER_CLICKED: "SORT_FILTER_CLICKED",
    SORT_FILTER_ITEM_CLICKED: "SORT_FILTER_ITEM_CLICKED",
    SORT_FILTER_CLOSED: "SORT_FILTER_CLOSED",
    FILTER_OPEN: "FILTER_OPEN",
    FILTER_CLOSE: "FILTER_CLOSE",
    FILTER_PREPARE: "FILTER_PREPARE",
    FILTER_APPLY: "FILTER_APPLY",
    FILTER_RESET: "FILTER_RESET",
    FILTER_ITEM_CLICKED: "FILTER_ITEM_CLICKED",
    FILTER_MOUNTED: "FILTER_MOUNTED",
    UPDATE_JOB_LISTINGS: "UPDATE_JOB_LISTINGS",
    UPDATE_JOB_PAGE: "UPDATE_JOB_PAGE",
    RECEVED_SIMILAR_JOBS_AJAXDATA: "RECEVED_SIMILAR_JOBS_AJAXDATA",
    UPDATE_FILTER_STATE: "UPDATE_FILTER_STATE",
    NORTHEAST_MY_CITY: "NORTHEAST_MY_CITY",
    SHOW_NORTHEAST_CITY_FILTER: "SHOW_NORTHEAST_CITY_FILTER"
  }
};
/* harmony default export */ __webpack_exports__["l"] = (EVENTS);

var JOB_EVENTS = {
  UPDATE_JOB: "UPDATE_JOB",
  UPDATE_NEW_JOB: "UPDATE_NEW_JOB",
  UPDATE_RSA_DATA: "UPDATE_RSA_DATA"
};

var APPLY_EVENTS = {
  UPDATE_APPLY: "UPDATE_APPLY",
  TOGGLE_CALL_UNLOCK_CANDIDATE_BUY_OPTIONS: "TOGGLE_CALL_UNLOCK_CANDIDATE_BUY_OPTIONS",
  FORM_FIELD_CHANGE: "FORM_FIELD_CHANGE",
  WHATSAPP_NOTIFICATION: "WHATSAPP_NOTIFICATION",
  TOGGLE_SKIP_APPLY_FLAG: "TOGGLE_SKIP_APPLY_FLAG",
  TOGGLE_QUICK_APPLY_FLAG: "TOGGLE_QUICK_APPLY_FLAG",
  SET_UTM_PARAMETERS: "SET_UTM_PARAMETERS"
};

var USER_EVENTS = {
  UPDATE_USER: "UPDATE_USER"
};

var CONTEXT_EVENTS = {
  UPDATE_CONTEXT: "UPDATE_CONTEXT",
  SEARCH_POPUP_TOGGLE: "SEARCH_POPUP_TOGGLE",
  TOGGLE_LOADER: "TOGGLE_LOADER"
};

var JOB_SEARCH_EVENTS = {
  UPDATE_JOB_SEARCH_LIST: "UPDATE_JOB_SEARCH_LIST",
  UPDATE_DFP_OPTIONS: "UPDATE_DFP_OPTIONS",
  EMPTY_JOB_SEARCH_LIST: "EMPTY_JOB_SEARCH_LIST",
  TOGGLE_JOB_LIST_DISPLAY: "TOGGLE_JOB_LIST_DISPLAY",
  UPDATE_JOB_SEARCH_REDUCER: "UPDATE_JOB_SEARCH_REDUCER"
};

var CONFIG_EVENTS = {
  UPDATE_CONFIG: "UPDATE_CONFIG",
  CONFIG_UPDATED: "CONFIG_UPDATED"
};

/**
 * PS1 : Post Ad Step 1
 * PS2 : Post Ad Step 2
 * ES2 : Edit Ad Step 1
 * ES2 : Edit Ad Step 2
 *
 * JOBS_POST_AD contains all the events for post/edit ad for both step1 and step2
 */
var JOBS_POST_AD_EVENTS = {
  FEATURE_CHANGE: "FEATURE_CHANGE",
  AD_ATTRIBUTE_CHANGE: "AD_ATTRIBUTE_CHANGE",
  UPDATE_PACK_SELECTED: "UPDATE_PACK_SELECTED"
};

var INTEGRATIONS_EVENTS = {
  FORM_OPEN: "FORM_OPEN",
  FORM_CLOSE: "FORM_CLOSE",
  FORM_FIELD_CHANGE: "FORM_FIELD_CHANGE",
  FORM_SUBMITTED: "FORM_SUBMITTED",
  SET_FORM_TYPE: "SET_FORM_TYPE",
  CLEAR_FORM: "CLEAR_FORM",
  FORM_CHANGE: "FORM_CHANGE",
  INTEGRATION_SOURCE_CLEAR: "INTEGRATION_SOURCE_CLEAR",
  UPDATE_FORM_STATE: "UPDATE_FORM_STATE"
};

var WINDOW_EVENTS = {
  REMOVE_ERROR_MESSAGE: "REMOVE_ERROR_MESSAGE",
  UPDATE_DATA: "UPDATE_WINDOW_DATA"
};

var CANDIDATE_TEST_EVENTS = {
  INITIALIZE_CONTEXT: "CANDIDATE_TEST_INITIALIZE_CONTEXT",
  SHOW_NEXT_SURVEY_QUESTION: "SHOW_NEXT_SURVEY_QUESTION",
  SHOW_PREVIOUS_SURVEY_QUESTION: "SHOW_PREVIOUS_SURVEY_QUESTION",
  UPDATE_CONTEXT: "CANDIDATE_TEST_UPDATE_CONTEXT",
  CHANGE_TAB: "CANDIDATE_TEST_CHANGE_TAB",
  START_TEST: "START_TEST",
  SHOW_RESPONSE: "SHOW_RESPONSE",
  SHOW_NEXT_RESPONSE_SCREEN: "SHOW_NEXT_RESPONSE_SCREEN",
  SET_FINAL_FEEDBACK_ANSWER: "SET_FINAL_FEEDBACK_ANSWER",
  SET_REDIRECT_URL: "CANDIDATE_TEST_SET_REDIRECT_URL",
  SET_ERROR: "CANDIDATE_TEST_SET_ERROR"
};

var PROFILE_EVENTS = {
  TOGGLE_POPUP: "PROFILE_TOGGLE_POPUP",
  SET_QUESTION: "PROFILE_SET_QUESTION",
  INITIALIZE_CONTEXT: "PROFILE_INITIALIZE_CONTEXT",
  UPDATE_CONTEXT: "PROFILE_UPDATE_CONTEXT",
  TOGGLE_ACK: "PROFILE_TOGGLE_ACK",
  FORM_SUBMITTED: "PROFILE_FORM_SUBMITTED"
};

/***/ }),

/***/ "4xz6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim();
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

/***/ }),

/***/ "5/Mg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INTEGRATIONS_FORMS_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INTEGRATIONS_FORMS_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isFormSubmitted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setFormSubmitted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateIntegrationFormFields; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__ = __webpack_require__("9mGc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocalStorageWrapper__ = __webpack_require__("gEYR");
var _form;




var INTEGRATIONS_FORMS_FIELDS = {
  NAME: 'name',
  MOBILE: 'mobile',
  EMAIL: 'email',
  CITY: 'city',
  AGE: 'age',
  SALARY: 'salary',
  PAN: 'pan',
  BIKE_USED_BOOL: 'bike_used_bool',
  BIKE_BUY_TIME: 'bike_buy_time',
  BIKE_BUDGET: 'bike_budget',
  EDUCATION: 'education'
};

var INTEGRATIONS_FORMS_DETAILS = {
  loan: {
    key: 'loan',
    fields: [INTEGRATIONS_FORMS_FIELDS.NAME, INTEGRATIONS_FORMS_FIELDS.MOBILE, INTEGRATIONS_FORMS_FIELDS.EMAIL, INTEGRATIONS_FORMS_FIELDS.CITY]
  },
  insurance: {
    key: 'insurance',
    fields: [INTEGRATIONS_FORMS_FIELDS.NAME, INTEGRATIONS_FORMS_FIELDS.MOBILE, INTEGRATIONS_FORMS_FIELDS.EMAIL, INTEGRATIONS_FORMS_FIELDS.CITY]
  },
  bike: {
    key: 'bike',
    fields: [INTEGRATIONS_FORMS_FIELDS.NAME, INTEGRATIONS_FORMS_FIELDS.MOBILE, INTEGRATIONS_FORMS_FIELDS.EMAIL, INTEGRATIONS_FORMS_FIELDS.CITY]
  },
  deliveryExecutive: {
    key: 'deliveryExecutive',
    fields: []
  }
};

var isFormSubmitted = function isFormSubmitted(type) {
  return __WEBPACK_IMPORTED_MODULE_1__LocalStorageWrapper__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_1__LocalStorageWrapper__["a" /* default */].hasKey('IntegrationForm_' + type);
};

var setFormSubmitted = function setFormSubmitted(type) {
  __WEBPACK_IMPORTED_MODULE_1__LocalStorageWrapper__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_1__LocalStorageWrapper__["a" /* default */].setItem('IntegrationForm_' + type, 1);
};

var defaultIntegrationFormState = {
  form: (_form = {}, _form[INTEGRATIONS_FORMS_FIELDS.NAME] = {
    show: true,
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.NAME }).get()
  }, _form[INTEGRATIONS_FORMS_FIELDS.MOBILE] = {
    show: true,
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.MOBILE }).get()
  }, _form[INTEGRATIONS_FORMS_FIELDS.EMAIL] = {
    show: true,
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.EMAIL }).get()
  }, _form[INTEGRATIONS_FORMS_FIELDS.CITY] = {
    show: true,
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.CITY }).get()
  }, _form[INTEGRATIONS_FORMS_FIELDS.AGE] = {
    show: true,
    value: null,
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.AGE }).get()
  }, _form[INTEGRATIONS_FORMS_FIELDS.PAN] = {
    show: true,
    value: null,
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.PAN }).get()
  }, _form[INTEGRATIONS_FORMS_FIELDS.SALARY] = {
    show: true,
    value: null,
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.SALARY }).get()
  }, _form[INTEGRATIONS_FORMS_FIELDS.BIKE_USED_BOOL] = {
    show: true,
    value: 'No',
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.BIKE_USED_BOOL }).get()
  }, _form[INTEGRATIONS_FORMS_FIELDS.BIKE_BUY_TIME] = {
    show: true,
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.BIKE_BUY_TIME }).get()
  }, _form[INTEGRATIONS_FORMS_FIELDS.BIKE_BUDGET] = {
    show: true,
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.BIKE_BUDGET }).get()
  }, _form[INTEGRATIONS_FORMS_FIELDS.EDUCATION] = {
    show: true,
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__JobsPostAd_message__["a" /* Message */](1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.EDUCATION }).get()
  }, _form),
  type: '',
  sourcesSet: {},
  forms: {
    loan: {
      status: isFormSubmitted('loan') ? 3 : 0 // 0: not open 1: open form 2: open confirmation form 3: submitted
    },
    insurance: {
      status: isFormSubmitted('insurance') ? 3 : 0
    },
    bike: {
      status: isFormSubmitted('bike') ? 3 : 0
    },
    deliveryExecutive: {
      status: isFormSubmitted('deliveryExecutive') ? 3 : 0
    }
  },
  values: {
    bike_used_bool: {
      'Yes': {
        id: 'Yes',
        checked: false,
        value: 'Yes'
      },
      'No': {
        id: 'No',
        checked: true,
        value: 'No'
      }
    },
    bike_buy_time: {
      'Immediately': {
        key: 'Immediately',
        value: 'Immediately'
      },
      'Within 1 month': {
        key: 'Within 1 month',
        value: 'Within 1 month'
      },
      'Within 3 months': {
        key: 'Within 3 months',
        value: 'Within 3 months'
      },
      'Not sure': {
        key: 'Not sure',
        value: 'Not sure'
      }
    },
    bike_budget: {
      'Less than 20k': {
        key: 'Less than 20k',
        value: 'Less than 20k'
      },
      '20k to 40k': {
        key: '20k to 40k',
        value: '20k to 40k'
      },
      '40k to 60k': {
        key: '40k to 60k',
        value: '40k to 60k'
      },
      '60k to 1 lakh': {
        key: '60k to 1 lakh',
        value: '60k to 1 lakh'
      },
      '1 lakh and above': {
        key: '1 lakh and above',
        value: '1 lakh and above'
      }
    },
    education: {
      'Below 12th': {
        key: 'Below 12th',
        value: 'Below 12th'
      },
      'Pursuing Graduation': {
        key: 'Pursuing Graduation',
        value: 'Pursuing Graduation'
      },
      'Graduate': {
        key: 'Graduate',
        value: 'Graduate'
      },
      'Post Graduate': {
        key: 'Post Graduate',
        value: 'Post Graduate'
      }
    }
  }
};

var getDefaultState = function getDefaultState() {
  return defaultIntegrationFormState;
};

var updateIntegrationFormFields = function updateIntegrationFormFields(integrationKey, integrationValue) {
  if (INTEGRATIONS_FORMS_DETAILS[integrationKey]) {
    return;
  }

  INTEGRATIONS_FORMS_DETAILS[integrationKey] = {
    key: integrationKey,
    fields: [INTEGRATIONS_FORMS_FIELDS.NAME, INTEGRATIONS_FORMS_FIELDS.MOBILE, INTEGRATIONS_FORMS_FIELDS.EMAIL, INTEGRATIONS_FORMS_FIELDS.CITY]
  };
};

/***/ }),

/***/ "5P8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FreeLocality; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("R8p8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packHandler__ = __webpack_require__("UNCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("upA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__("/gj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_JobsPostAd_jobsPostAdRequest__ = __webpack_require__("YShu");
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Utility class for free locality feature
 *
 * @author John Lukose <john.lukose@quikr.com>
 */







var FreeLocality = (_temp = _class = function FreeLocality() {
    _classCallCheck(this, FreeLocality);
}, _class.creditForExtraLocality = function (localityCount, store) {
    return parseInt(Math.ceil(localityCount * store.config.papPrices.creditToDeductBasePrice * store.config.papPrices.creditToDeductBaseLocality - 1), 10);
}, _class.getLineItem = function (store) {
    var type = 'money';
    var localitiesSelected = store.postAdRequest[__WEBPACK_IMPORTED_MODULE_3__index__["d" /* POST_AD_FIELDS */].LOCALITY].value;
    var localityCount = localitiesSelected.length;
    var display = localityCount + ' Localities Selected (' + __WEBPACK_IMPORTED_MODULE_3__index__["b" /* PAP_CONSTANTS */].MAX_FREE_LOCALITY + ' Free)';
    var value = 0;

    if (store.config.papPrices && localityCount > 0 && __WEBPACK_IMPORTED_MODULE_1__packHandler__["a" /* PACKS */].GOLD === store.postAdRequest.others.selectedPack && store.user.hasCredits) {
        // Credit calculation for extra locality
        value = FreeLocality.creditForExtraLocality(localityCount, store);
    }

    if (1 === localityCount && store.config.papPrices && localitiesSelected[0].indexOf(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* PAP_CONSTANTS */].FULL_CITY) >= 0) {
        display = __WEBPACK_IMPORTED_MODULE_3__index__["b" /* PAP_CONSTANTS */].FULL_CITY;
        value = store.config.papPrices.creditToDeductFullCity;
        type = 'credit';
    } else if (store.user.credits > 0 && __WEBPACK_IMPORTED_MODULE_1__packHandler__["a" /* PACKS */].GOLD === store.postAdRequest.others.selectedPack) type = 'credit';

    return { display: display, value: value, type: type };
}, _class.getCreditToDeduct = function (_) {
    var jobStore = __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].getState().jobs;
    var value = 0;

    if (__WEBPACK_IMPORTED_MODULE_1__packHandler__["a" /* PACKS */].GOLD === jobStore.postAdRequest.others.selectedPack) {
        // one credit for gold ad
        value++;

        var localitiesSelected = jobStore.postAdRequest[__WEBPACK_IMPORTED_MODULE_3__index__["d" /* POST_AD_FIELDS */].LOCALITY].value;
        var localityCount = localitiesSelected.length;

        if (1 === localityCount && jobStore.config.papPrices && localitiesSelected[0].indexOf(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* PAP_CONSTANTS */].FULL_CITY) >= 0) {
            // adding credit for full city
            value = value + parseInt(jobStore.config.papPrices.creditToDeductFullCity, 10);
        } else if (jobStore.config.papPrices && localityCount > 0 && jobStore.user.hasCredits) {
            // adding credit for extra localities
            value = value + FreeLocality.creditForExtraLocality(localityCount, jobStore);
        }
    }

    return value;
}, _class.getCustomLocalityLineItems = function (_) {
    var jobstore = __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].getState().jobs;
    var fullCity = jobstore.postAdRequest[__WEBPACK_IMPORTED_MODULE_3__index__["d" /* POST_AD_FIELDS */].LOCALITY].fullCity;

    return [{ value: fullCity.display, show: fullCity.show, data1: __WEBPACK_IMPORTED_MODULE_3__index__["b" /* PAP_CONSTANTS */].FULL_CITY }];
}, _class.showFullCity = function (_) {
    var jobstore = __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].getState().jobs;
    var fullCity = jobstore.postAdRequest[__WEBPACK_IMPORTED_MODULE_3__index__["d" /* POST_AD_FIELDS */].LOCALITY].fullCity;

    return fullCity.show;
}, _class.setFullCityDetails = function (_) {
    var jobstore = __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].getState().jobs;
    var papPrices = jobstore.config.papPrices;
    var updatedRequest = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* copyObject */])(jobstore.postAdRequest);

    if (papPrices && papPrices.creditToDeductFullCity && papPrices.full_city_conditions) {
        var _newPayload;

        var condition = JSON.parse(papPrices.full_city_conditions);

        var display = 'Full City ' + papPrices.creditToDeductFullCity + ' Credits ';
        var localityObject = updatedRequest[__WEBPACK_IMPORTED_MODULE_3__index__["d" /* POST_AD_FIELDS */].LOCALITY];
        localityObject.fullCity.display = display;
        localityObject.fullCity.show = condition.display_full_city && jobstore.user.hasCredits;

        var newPayload = (_newPayload = {}, _newPayload[__WEBPACK_IMPORTED_MODULE_3__index__["d" /* POST_AD_FIELDS */].LOCALITY] = localityObject, _newPayload);
        __WEBPACK_IMPORTED_MODULE_4__utils_JobsPostAd_jobsPostAdRequest__["a" /* default */].updatePostAdRequest(newPayload);
    }
}, _class.setLocalityMaxSelectionLimit = function (_) {
    var jobstore = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].getState();
    var updatedRequest = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* copyObject */])(jobstore.postAdRequest);

    if (jobstore.user.hasCredits) {
        var _newPayload2;

        var localityObject = updatedRequest[__WEBPACK_IMPORTED_MODULE_3__index__["d" /* POST_AD_FIELDS */].LOCALITY];
        localityObject.maxLimit = 999;
        var newPayload = (_newPayload2 = {}, _newPayload2[__WEBPACK_IMPORTED_MODULE_3__index__["d" /* POST_AD_FIELDS */].LOCALITY] = localityObject, _newPayload2);
        __WEBPACK_IMPORTED_MODULE_4__utils_JobsPostAd_jobsPostAdRequest__["a" /* default */].updatePostAdRequest(newPayload);
    }
}, _temp);


/***/ }),

/***/ "5aIp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = __webpack_require__("OaXg");

var _Cookies2 = _interopRequireDefault(_Cookies);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _Cookies2.default;
module.exports = exports['default'];

/***/ }),

/***/ "5j+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentCityId; });
/* unused harmony export capitalize */
/* unused harmony export redirectToPostAd */
/* unused harmony export getCookie */
/* harmony export (immutable) */ __webpack_exports__["a"] = formURLSearchObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__("5aIp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_universal_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("Nukh");
// We can still create subfolders add some component or functionality specific helpers in that folder





var getCurrentCity = function getCurrentCity() {
	var cookies = new __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default.a();
	var cityName = void 0,
	    cityCookie = void 0;
	if (cookies.get(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* CITY_NAME_COOKIE_KEY */])) {
		cityCookie = cookies.get(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* CITY_NAME_COOKIE_KEY */]);
		cityName = cityCookie == 'www' ? __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ALL_INDIA */] : capitalize(cityCookie);
	} else {
		cookies.set(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* CITY_NAME_COOKIE_KEY */], 'www', {
			path: '/',
			maxAge: __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CITY_COOKIE_TTL */],
			domain: __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* COOKIE_DOMAIN */]
		});
		cookies.set(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CITY_ID_COOKIE_KEY */], __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ALL_INDIA_CITY_ID */], {
			path: '/',
			maxAge: __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CITY_COOKIE_TTL */],
			domain: __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* COOKIE_DOMAIN */]
		});
		cityName = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ALL_INDIA */];
	}
	return cityName;
};

/**
 * Returns the current city, if its not exist it will set the default city(All india) and returns hte id(0)
 * @return {String} [City id]
 */
var getCurrentCityId = function getCurrentCityId() {
	var cookies = new __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default.a();
	var cityId = cookies.get(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CITY_ID_COOKIE_KEY */]);
	if (cityId && cityId !== '0') {
		return cityId;
	}
	// Setting the cookie if it is not already set
	getCurrentCity();
	return __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ALL_INDIA_CITY_ID */];
};

/**
 * Capitalize first letter of evey word by splitting with different separators
 * @param  {String} string     String to be capitalized
 * @param  {Array}  separators List of separators, with which you want to split the string
 * @return {String}            Capitalized string
 */
var capitalize = function capitalize(string) {
	var separators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [' '];

	var stringToBeCapitalized = string;
	separators.forEach(function (separator, index) {
		stringToBeCapitalized = stringToBeCapitalized.split(separator).map(function (v, i) {
			return v.charAt(0).toUpperCase() + v.slice(1);
		}).join(separator);
	});
	return stringToBeCapitalized;
};

var redirectToPostAd = function redirectToPostAd(e) {
	window.location = 'http://' + window.location.host + '/post-classifieds-ads';
};

var getCookie = function getCookie(cookieKey) {
	var cookies = new __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default.a();
	return cookies.get(cookieKey);
};

function formURLSearchObject(data) {
	var result = new URLSearchParams();
	if (typeof data === 'object') {
		Object.keys(data).forEach(function (key) {
			result.append(key, data[key]);
		});
	}
	return result;
}

/***/ }),

/***/ "5x+S":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

/***/ }),

/***/ "6C3Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(_extends({}, a, b)).every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),

/***/ "6QU2":
/***/ (function(module, exports) {

module.exports = {
    formQueryString: function formQueryString(searchObj) {
        return '?' + Object.keys(searchObj).reduce(function (acc, each) {
            if (searchObj[each]) {
                acc.push(each + '=' + searchObj[each]);
            }
            return acc;
        }, []).join('&');
    },
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    dateConvert: function dateConvert(date) {
        var convertedDate = new Date(date);
        return convertedDate.toLocaleDateString();
    },
    getDate: function getDate() {
        var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var date = time ? new Date(time) : new Date();
        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
    },
    getInitials: function getInitials(string) {
        var parts = string.split(' ');
        var max = parts.length < 2 ? parts.length : 2;
        var result = '';
        for (var i = 0; i < max; i++) {
            result += parts[i].charAt(0).toUpperCase();
        }
        return result;
    },
    stripHtmlTags: function stripHtmlTags(string) {
        var div = document.createElement("div");
        div.innerHTML = string;
        return div.innerText;
    },

    localStore: {
        AddElementInStore: function AddElementInStore(key, value) {
            if (!value || !key) {
                return;
            }
            if (typeof Storage !== "undefined") {
                var s = localStorage.getItem(key) || "";
                if (!s) {
                    localStorage.setItem(key, value);
                } else {
                    s = s + ',' + value;
                    localStorage.setItem(key, s);
                }
                return 1;
            }
        },
        popElementInStore: function popElementInStore(key, value) {
            if (!value || !key) {
                return;
            }
            if (typeof Storage !== "undefined") {
                var s = localStorage.getItem(key) || "";
                var arr = s.split(",");
                for (var i = arr.length - 1; i >= 0; i--) {
                    if (arr[i] === value) {
                        arr.splice(i, 1);
                    }
                }
                s = arr.join(",");
                localStorage.setItem(key, s);
                return 1;
            }
        },
        getStoreData: function getStoreData(key) {
            if (!key) {
                return;
            }
            if (typeof Storage !== "undefined") {
                var s = localStorage.getItem(key) || "";
                var arr = [];
                if (s) {
                    arr = s.split(",");
                }
                return arr;
            }
        },
        deleteStore: function deleteStore(key) {
            if (!key) {
                return;
            }
            if (typeof Storage !== "undefined") {
                localStorage.removeItem(key);
            }
            return 1;
        }
    },
    loadGA: function loadGA() {
        var imported = document.createElement('script');
        imported.src = 'https://teja10.kuikr.com/public/core/dist/horizontal/horizontal-q-ga-9f46ef10d0a122383c5e.js';
        document.body.appendChild(imported);
        window._gaq = window._gaq || [];
        window._gaq.push(['_setAccount', checkIsMobile() ? 'UA-5568615-7' : 'UA-5568615-1']);
        window._gaq.push(['_gat._forceSSL']);
        window._gaq.push(['_trackPageview']);
    },
    pushToDataLayer: function pushToDataLayer(data) {
        if (typeof dataLayer !== "undefined" && window.dataLayer) {
            window.dataLayer.push(data);
        }
    },
    convertPriceToIndFormat: function convertPriceToIndFormat(price) {
        if (typeof price === 'undefined') {
            return 0;
        }
        price = price.toString();
        var lastThree = price.substring(price.length - 3);
        var otherNumbers = price.substring(0, price.length - 3);
        if (otherNumbers !== '') lastThree = ',' + lastThree;
        var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
        return res + lastThree;
    },


    convertPriceToKFormat: function convertPriceToKFormat(num) {
        if (typeof num === 'undefined') {
            return '';
        }
        if (num < 1000) {
            return num;
        }
        if (num < 99999) {
            return parseFloat((num / 1000).toFixed(1)) + "K";
        }
        if (num > 99999) {
            return parseFloat((num / 100000).toFixed(2)) + "L";
        }
    },

    bigBrotherEvents: function bigBrotherEvents(data, event, source) {
        if (typeof _paqv3 !== "undefined") {
            bigBrotherEventsDup(data, event, source);
        } else {
            setTimeout(function () {
                if (typeof _paqv3 !== "undefined") {
                    bigBrotherEventsDup(data, event, source);
                }
            }, 2000);
        }
    },
    isRequired: function isRequired(inputVal) {
        if (!inputVal || inputVal === '' || Array.isArray(inputVal) && inputVal.length <= 0) {
            return true;
        }
        return false;
    },
    isMobileValid: function isMobileValid(inputVal) {
        if (!inputVal || !/^\d{10}$/.test(inputVal) || !/^[9876].*/.test(inputVal)) {
            return true;
        }
        return false;
    },
    isEmailValid: function isEmailValid(inputVal) {
        if (!inputVal || !/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(inputVal)) {
            return true;
        }
        return false;
    },
    isMobileRequest: function isMobileRequest() {
        return checkIsMobile();
    },
    isValidPincode: function isValidPincode(pincode) {
        if (!/^[1-9][0-9]{5}$/.test(pincode)) {
            return true;
        }
        return false;
    },
    triggerPageView: function triggerPageView() {
        window._gaq = window._gaq || [];
        window._gaq.push(['_trackPageview']);
    },
    extractImageUrl: function extractImageUrl(image, type) {
        if (image && image[type] && image[type].url) {
            return image[type].url;
        } else if (image.lg && image.lg.url) {
            return image.lg.url;
        } else if (image.nr && image.nr.url) {
            return image.nr.url;
        } else if (image.gv && image.gv.url) {
            return image.gv.url;
        } else if (image.sm && image.sm.url) {
            return image.sm.url;
        } else if (image.sq && image.sq.url) {
            return image.sq.url;
        }
        if (type !== "nr") {
            var url = image.match(/(.*)\.(.*)/);
            return url[1] + '_' + type + '.' + url[2];
        }
        return image;
    },
    isEmpty: function isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) return false;
        }
        return true;
    },
    loadDynamicAd: function loadDynamicAd(gAdsSlot) {
        var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        window.QDFP = window.QDFP || {};
        window.QDFP.dynamicSlots = window.QDFP.dynamicSlots || [];
        if (typeof window.QDFP.getAdForDivId === "function") {
            window.QDFP.getAdForDivId(gAdsSlot, index);
        } else {
            window.QDFP.dynamicSlots.push(gAdsSlot);
        }
    },
    linkHref: function linkHref(href) {
        return href.replace('https://www.quikr.com', '');
    },
    getAutoFillName: function getAutoFillName(name) {
        return name !== '' && name || localStorage.getItem('autofill_name') || '';
    },
    getAutoFillEmail: function getAutoFillEmail(email) {
        return email && email.length > 0 && email[0] || localStorage.getItem('autofill_email') || null;
    },
    getAutoFillMobile: function getAutoFillMobile(mobile) {
        return mobile && mobile.length > 0 && mobile[0].toString() || localStorage.getItem('autofill_mobile') || null;
    },

    getQueryParams: function getQueryParams(href) {
        var hrefarr = href.split('?');
        var queryString = hrefarr.length > 1 ? hrefarr[1] : null;
        var queryparams = [];
        if (queryString) {
            queryparams = queryString.split('&').map(function (param) {
                return param.split('=');
            }).reduce(function (values, _ref) {
                var key = _ref[0],
                    value = _ref[1];
                values[key] = value;return values;
            }, {});
        }
        return queryparams;
    },
    convertMilliSecondsToHumanReadableForm: function convertMilliSecondsToHumanReadableForm(seconds) {
        seconds = seconds / 1000;
        var numdays = Math.floor(seconds % 31536000 / 86400);
        var numhours = Math.floor(seconds % 31536000 % 86400 / 3600);
        var numminutes = Math.floor(seconds % 31536000 % 86400 % 3600 / 60);
        var numseconds = Math.floor(seconds % 31536000 % 86400 % 3600 % 60);
        var timeString = numdays ? numdays + 'd ' : '';
        timeString += numhours ? numhours + 'h ' : '';
        timeString += numminutes ? numminutes + 'm ' : '';
        timeString += numseconds ? numseconds + 's' : '';
        return timeString;
    },
    getTimeDiffInMilliSeconds: function getTimeDiffInMilliSeconds(endTime) {
        var currentTime = new Date().getTime();
        var seconds = endTime - currentTime;
        return seconds;
    }
};

var bigBrotherEventsDup = function bigBrotherEventsDup(data, event, source) {
    var postData = JSON.stringify(data);
    window._paqv3.push(['_sendEventApiData', event, source, postData]);
};

var checkIsMobile = function checkIsMobile() {
    if (typeof window !== "undefined" && typeof window.__PRELOADED_STATE__ !== 'undefined' && typeof window.__PRELOADED_STATE__.isMobile !== 'undefined') {
        return window.__PRELOADED_STATE__.isMobile;
    }
    return true;
};

/***/ }),

/***/ "6X2+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),

/***/ "7Mlx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__("yy8s"));

var _react = _interopRequireDefault(__webpack_require__("CK2z"));

var _reactDom = _interopRequireDefault(__webpack_require__("CK2z"));

var _reactLifecyclesCompat = __webpack_require__("sTIH");

var _PropTypes = __webpack_require__("uN/K");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }newObj.default = obj;return newObj;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
}

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),

/***/ "7qZ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SnackBarV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_q_mdc_elements_material_snackbar__ = __webpack_require__("mBU9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss__ = __webpack_require__("aQ5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SnackBarV2 = function (_Component) {
	_inherits(SnackBarV2, _Component);

	function SnackBarV2(props) {
		_classCallCheck(this, SnackBarV2);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.handleClose = function (e) {
			var _this$props = _this.props,
			    onClose = _this$props.onClose,
			    active = _this$props.active;

			if (active && typeof onClose === 'function') {
				onClose(e);
			}
		};

		_this.timeoutMethod = null;
		return _this;
	}

	SnackBarV2.prototype.render = function render() {
		var _props = this.props,
		    active = _props.active,
		    timeout = _props.timeout;


		if (this.timeoutMethod) {
			clearTimeout(this.timeoutMethod);
		}
		this.timeoutMethod = setTimeout(this.handleClose, timeout);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_q_mdc_elements_material_snackbar__["a" /* default */], _extends({}, this.props, {
			active: active
		}));
	};

	return SnackBarV2;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "7vuG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7xfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../q-jobs/src/constants/index.js
var constants = __webpack_require__("QSFW");

// EXTERNAL MODULE: ../q-jobs/src/utils/FetchHelper/index.js
var FetchHelper = __webpack_require__("Hm4v");

// EXTERNAL MODULE: ../form-urlencoded/dist/form-urlencoded.js
var form_urlencoded = __webpack_require__("dA1j");
var form_urlencoded_default = /*#__PURE__*/__webpack_require__.n(form_urlencoded);

// EXTERNAL MODULE: ../q-jobs/src/actions/JobActions/index.js
var JobActions = __webpack_require__("F6nf");

// EXTERNAL MODULE: ../q-jobs/src/actions/ApplyActions/index.js
var ApplyActions = __webpack_require__("y6h9");

// EXTERNAL MODULE: ../q-jobs/src/actions/UserActions/index.js
var UserActions = __webpack_require__("X6l3");

// EXTERNAL MODULE: ../q-jobs/src/actions/ContextActions/index.js
var ContextActions = __webpack_require__("d3IN");

// EXTERNAL MODULE: ../q-jobs/src/actions/JobSearchActions/index.js
var JobSearchActions = __webpack_require__("4t40");

// EXTERNAL MODULE: ../q-jobs/src/utils/Config/index.js + 1 modules
var Config = __webpack_require__("1QGg");

// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/jobsPostAdRequest.js + 1 modules
var jobsPostAdRequest = __webpack_require__("YShu");

// EXTERNAL MODULE: ../window-or-global/lib/index.js
var lib = __webpack_require__("IyPV");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ../q-jobs/src/store.js + 18 modules
var store = __webpack_require__("R8p8");

// EXTERNAL MODULE: ../q-jobs/src/utils/Apply/ApplyCookieHelper.js
var ApplyCookieHelper = __webpack_require__("8Ery");

// EXTERNAL MODULE: ../q-jobs/src/utils/index.js + 1 modules
var utils = __webpack_require__("upA3");

// EXTERNAL MODULE: ../q-jobs/node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__("/ErD");

// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/others/includeMobileUrl.js
var includeMobileUrl = __webpack_require__("kZEW");

// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/others/unlimitedFreeAd.js
var unlimitedFreeAd = __webpack_require__("TZCA");

// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/others/otherFeatures.js
var otherFeatures = __webpack_require__("c9Av");

// EXTERNAL MODULE: ../q-jobs/src/utils/User/index.js
var User = __webpack_require__("nzOW");

// EXTERNAL MODULE: ../q-jobs/src/utils/Apply/ApplyService.js
var ApplyService = __webpack_require__("vyFQ");

// EXTERNAL MODULE: ../q-jobs/src/utils/Apply/index.js
var Apply = __webpack_require__("RGwo");

// EXTERNAL MODULE: ../q-jobs/src/actions/IntegrationsActions/index.js
var IntegrationsActions = __webpack_require__("8OFB");

// CONCATENATED MODULE: ../q-jobs/src/actions/CompanyActions/index.js
var updateCompany = function updateCompany() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_COMPANY',
    payload: payload
  };
};
// CONCATENATED MODULE: ../q-jobs/src/utils/Context/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Context_Context; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * global context helper for Values from server side and push to store.
 */

























var Context_Context = (_temp = _class = function () {
  function Context() {
    var _this = this;

    _classCallCheck(this, Context);

    this.initializeContextForHome = function () {
      var ssr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var dispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cookies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!dispatch) {
        dispatch = store["b" /* default */].dispatch;
      }
      var dispatchPromises = [];

      if (!cookies) {
        cookies = new es6["a" /* default */]();
      }

      var url = void 0;
      if (ssr) {
        url = __JOBS_BAAHUBALI_PREFIX__ + constants["c" /* BASE_URL */] + constants["q" /* HOME_CONTEXT_API */];
      } else {
        url = constants["c" /* BASE_URL */] + constants["q" /* HOME_CONTEXT_API */];
      }
      var fetchHelper = new FetchHelper["a" /* default */]();
      var options = {
        url: url,
        includeCredentials: true
      };
      var contextPromise = fetchHelper.request("GET", options);
      return _this.handleContextForHomePromise(contextPromise, dispatch, ssr, cookies);
    };

    this.handleContextForHomePromise = function (contextPromise, dispatch) {
      var ssr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var cookies = arguments[3];

      var city = null;
      if (ssr) {
        city = cookies["new_prefer_city"];
      } else {
        city = cookies.get("new_prefer_city");
      }
      var updatedContext = { city: city };

      return contextPromise.then(function (apiResponse) {
        var response = apiResponse.data ? apiResponse.data : {};
        if (response.success) {
          if (response.json.redirectUrl) {
            if (lib_default.a.location) {
              lib_default.a.location.href = response.json.redirectUrl;
              return;
            }
          }

          var dispatchPromises = [];
          dispatchPromises.push(dispatch(Object(UserActions["a" /* updateUser */])(response.json.userDetails)));
          updatedContext = _extends(updatedContext, {
            roleCount: response.json.roleCount,
            isInternationalCity: response.json.isInternationalCity,
            cityRoleConfigsForGuaranteedJob: response.json.cityRoleConfigsForGuaranteedJob,
            jobsMonopolyConfig: response.json.jobsMonopolyConfig,
            localStorageCacheBurstingDetails: response.json.localStorageCacheBurstingDetails,
            isQCashEnabled: response.json.isQCashEnabled,
            qCashDetails: response.json.qCashDetails,
            vapLandingUrlConfig: response.json.vapLandingUrlConfig,
            isCompanyLinksDisplayActive: response.json.isCompanyLinksDisplayActive,
            fullScreenBannerConfig: response.json.fullScreenBannerConfig,
            androidDownloadPopupConfig: response.json.androidDownloadPopupConfig
          });

          if (response.json.redirectUrl && lib_default.a.location && lib_default.a.location.href) {
            lib_default.a.location.href = response.json.redirectUrl;
          }

          if (response.json.jobsPudoAdData) {
            updatedContext = _extends(updatedContext, {
              jobsPudoAdData: response.json.jobsPudoAdData
            });
          }

          updatedContext.homeContextUpdatedInStore = true;

          dispatchPromises.push(dispatch(Object(ContextActions["e" /* updateContext */])(updatedContext)));
          return dispatchPromises;
        }
      });
    };

    this.initializeContext = function (params) {
      var ssr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var cookies = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var queryParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var url = void 0;
      if (ssr) {
        url = __JOBS_BAAHUBALI_PREFIX__ + constants["c" /* BASE_URL */] + constants["j" /* CONTEXT_API */];
      } else {
        url = constants["c" /* BASE_URL */] + constants["j" /* CONTEXT_API */];
      }
      var fetchHelper = new FetchHelper["a" /* default */]();

      var paramString = form_urlencoded_default()(params);
      var queryString = void 0;

      if (queryParams) {
        queryString = queryParams + "&";
      } else if (lib_default.a.location && lib_default.a.location.search && lib_default.a.location.search !== "") {
        queryString = lib_default.a.location.search + "&";
      } else {
        queryString = "?";
      }

      var options = {
        url: url + queryString + paramString,
        includeCredentials: true
      };
      if (cookies) {
        options.cookies = cookies;
      }
      if (params.role) {
        _this.updateJobSnow({ role: Object(utils["b" /* capitalizeFirstLetter */])(params.role) });
      }
      var contextPromise = fetchHelper.request("POST", options);
      return _this.handleContextPromise(contextPromise, params, dispatch);
    };

    this.getRsaData = function (params) {
      var url = constants["c" /* BASE_URL */] + constants["J" /* RSA_CONTEXT_API */];
      var fetchHelper = new FetchHelper["a" /* default */]();
      var paramString = "ad_id=" + String(params.jobId);
      var queryString = lib_default.a.location && lib_default.a.location.search && lib_default.a.location.search !== "" ? lib_default.a.location.search + "&" : "?";
      var options = {
        url: url + queryString + paramString
      };
      var contextPromise = fetchHelper.request("POST", options);
      contextPromise.then(function (apiResponse) {
        var response = apiResponse.data ? apiResponse.data : {};
        if (response.success) {
          store["b" /* default */].dispatch(Object(JobActions["b" /* updateRsaData */])(response.json));
        }
      });
    };

    this.getCompanies = function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var url = constants["c" /* BASE_URL */] + constants["m" /* GET_COMPANIES_API */];
      var fetchHelper = new FetchHelper["a" /* default */]();
      var options = {
        url: url,
        params: params,
        data: form_urlencoded_default()(data)
      };
      var contextPromise = fetchHelper.request("POST", options);
      return contextPromise.then(function (apiResponse) {
        var response = apiResponse.data ? apiResponse.data : {};
        if (response.success) {
          var companies = store["a" /* JobStore */].getState().company.companies;
          companies = companies.concat(response.json.results);
          var payload = {
            companies: companies,
            totalCount: response.json.totalCount,
            page: data.page
          };

          store["b" /* default */].dispatch(updateCompany(payload));
        }
      });
    };

    this.initializeContextForPAP = function () {
      var url = constants["c" /* BASE_URL */] + constants["y" /* PAP_CONTEXT_API */];
      url += "?isRoleSubRoleOptionsRequired=" + !otherFeatures["b" /* RoleSubRole */].isOptionsStored() + "&isCityOptionsRequired=" + !otherFeatures["a" /* CityOptions */].isOptionsStored();

      var options = { url: url };
      var contextPromise = _this.fetchHelper.request("GET", options);
      contextPromise.then(function (apiResponse) {
        var response = apiResponse.data ? apiResponse.data : {};
        if (response.success) {
          var _store = store["a" /* JobStore */].getState();
          Config["a" /* default */].updateConfig(response.json.configs, _store);
          store["a" /* JobStore */].dispatch(Object(UserActions["a" /* updateUser */])(User["a" /* default */].updateUserCompanyDetails(response.json.userDetails)));

          var updatedContext = {
            localStorageCacheBurstingDetails: response.json.localStorageCacheBurstingDetails
          };
          store["a" /* JobStore */].dispatch(Object(ContextActions["e" /* updateContext */])(updatedContext));

          jobsPostAdRequest["a" /* default */].updatePostAdRequestFromContext(response);
          // get global jobstore before calling static functions
          // so as to avoid getState call from inside the static functions
          _store = store["a" /* JobStore */].getState();
          includeMobileUrl["b" /* IncludeWebsiteUrl */].updatePrice(_store);
          _store = store["a" /* JobStore */].getState();
          includeMobileUrl["a" /* IncludeMobileNumber */].updatePrice(_store);
          _store = store["a" /* JobStore */].getState();
          unlimitedFreeAd["a" /* default */].updateDetails(_store);
          otherFeatures["b" /* RoleSubRole */].updateOptionsFromContext(response);
          otherFeatures["a" /* CityOptions */].updateOptionsFromContext(response);
        }
      });
    };

    this.initializeContextForQJG = function () {
      var url = constants["c" /* BASE_URL */] + constants["C" /* QJG_CONTEXT_API */];
      var options = {
        url: url
      };
      var contextPromise = _this.fetchHelper.request("GET", options);
      contextPromise.then(function (apiResponse) {
        var response = apiResponse.data ? apiResponse.data : {};
        if (response.success) {
          var updatedContext = {
            localStorageCacheBurstingDetails: response.json.localStorageCacheBurstingDetails,
            cityRoleConfigForGuaranteedJob: response.json.cityRoleConfigForGuaranteedJob
          };
          store["a" /* JobStore */].dispatch(Object(ContextActions["e" /* updateContext */])(updatedContext));
          store["a" /* JobStore */].dispatch(Object(UserActions["a" /* updateUser */])(response.json.userDetails));
        }
      });
    };

    this.fetchHelper = new FetchHelper["a" /* default */]();
  }

  /**
   * Remove the applied jobs from store
   */
  Context.filterJobs = function filterJobs() {
    var jobs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var updateStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var applyCookieHelper = new ApplyCookieHelper["a" /* default */]();
    var appliedJobs = applyCookieHelper.getAppliedJobs();
    var jobsList = null;

    // fetch jobs from store
    if (!jobs) {
      jobsList = store["a" /* JobStore */].getState().jobSearch.jobs;
    } else {
      jobsList = jobs;
    }

    // from the list of jobs, remove the already applied jobs
    var i = jobsList.length;
    while (i--) {
      var job = jobsList[i];

      if (appliedJobs.indexOf(job.id.toString()) > -1) {
        // console.log('removing jobs ', job.id);
        jobsList.splice(i, 1);
      }
    }

    // update store if required
    if (updateStore) {
      store["b" /* default */].dispatch(Object(JobSearchActions["d" /* updateJobSearchList */])({
        jobs: jobsList,
        replaceJobs: true
      }));
    }

    return jobsList;
  };

  Context.prototype.updateContextStoreValues = function updateContextStoreValues(response, params) {
    var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (params && params.jobId && response && response.jobJson && response.jobJson.category_pgid != constants["h" /* CATEGORY_PGID */]) {
      location.href = location.protocol + "//quikr.com/";
      return;
    }
    var dispatchPromises = [];
    if (!dispatch) {
      dispatch = store["b" /* default */].dispatch;
    }

    var applyCookieHelper = new ApplyCookieHelper["a" /* default */]();
    var appliedJobs = applyCookieHelper.getAppliedJobs();
    var updatedApply = {
      isExpressApplyEnabled: response.isExpressApplyEnabled,
      isQuickApplyEnabled: response.isQuickApplyEnabled,
      isSkipApplyEnabled: response.isSkipApplyEnabled,
      taskId: response.taskId,
      firstStepProfile: response.firstStepProfile,
      source: params.source ? params.source : "VAP",
      expressApplyErrorCode: response.expressApplyErrorCode,
      appliedJobs: appliedJobs,
      newApplicationCount: response.newApplicationCount,
      isNewDesiredCityImplementationSupported: response.isNewDesiredCityImplementationSupported,
      discount: response.vipApplyDiscount,
      emailNonMandatoryConfig: response.emailNonMandatoryConfig,
      job: response.jobJson
    };

    var role = response.jobJson && response.jobJson.role ? response.jobJson.role : response.roleName;
    var city = response.jobJson && response.jobJson.cityName ? response.jobJson.cityName : response.cityName;
    var cityId = response.jobJson && response.jobJson.city ? response.jobJson.city : response.city;
    var stateId = response.stateId;

    var updatedContext = {
      vipPackInfo: response.vipPackInfo,
      recruitmentAssistInfo: response.recruitmentAssistInfo,
      classifiedConfig: response.classifiedConfig,
      isCallUnlockEnabled: response.isCallUnlockEnabled,
      role: role,
      city: city,
      cityId: cityId,
      stateId: stateId,
      promotionVIPData: response.promotionVIPData,
      cityRoleConfigsForGuaranteedJob: response.cityRoleConfigForGuaranteedJob,
      cityRoleConfigsForThirdPartyPromotion: response.cityRoleConfigsForThirdPartyPromotion,
      interstitialAdConfigs: response.interstitialAdConfigs,
      flyingCarpetAdConfig: response.flyingCarpetAdConfig,
      localStorageCacheBurstingDetails: response.localStorageCacheBurstingDetails,
      integrations: response.integrationsConfigs,
      fullScreenBannerConfig: response.fullScreenBannerConfig,
      jobsPudoAdData: response.jobsPudoAdData,
      candidateCallUnlockConfig: response.candidateCallUnlockConfig,
      isQCashEnabled: response.isQCashEnabled,
      qCashDetails: response.qCashDetails,
      crossCatConfig: response.crossCatConfig,
      vapLandingUrlConfig: response.vapLandingUrlConfig,
      isInterstialAdEnabled: response.isInterstialAdEnabled,
      isFlyingCarpetAdEnabled: response.isFlyingCarpetAdEnabled,
      showBeSafeBanner: response.showBeSafeBanner,
      androidDownloadPopupConfig: response.androidDownloadPopupConfig
    };

    var updatedJobSnow = {
      role: role,
      isInterstialAdEnabled: response.isInterstialAdEnabled,
      isFlyingCarpetAdEnabled: response.isFlyingCarpetAdEnabled
    };

    if (params.source === "SNB") {
      updatedContext.snbContextUpdatedInStore = true;
      updatedJobSnow.route = constants["I" /* ROUTES */].SNB;
    } else {
      updatedContext.vapContextUpdatedInStore = true;
      updatedJobSnow.route = constants["I" /* ROUTES */].VAP;
    }

    // update JobSnow with context values
    this.updateJobSnow(updatedJobSnow);

    dispatchPromises.push(dispatch(Object(ContextActions["e" /* updateContext */])(updatedContext)));
    dispatchPromises.push(dispatch(Object(UserActions["a" /* updateUser */])(response.userDetails)));
    dispatchPromises.push(dispatch(Object(ApplyActions["i" /* updateApply */])(updatedApply)));
    dispatchPromises.push(dispatch(Object(JobActions["a" /* updateJob */])(response.jobJson)));
    dispatchPromises.push(dispatch(Object(IntegrationsActions["c" /* reduxActionIntegrationUpdateFormState */])(updatedContext.integrations)));

    if ("SNB" === params.source && response.jobJson.id) {
      var ampApplyJob = Apply["a" /* default */].getJobFromStore(response.jobJson.id);
      if (null === ampApplyJob) {
        dispatchPromises.push(dispatch(Object(JobSearchActions["d" /* updateJobSearchList */])({
          jobs: [response.jobJson]
        })));
      }
    }

    ApplyService["a" /* default */].directApplyAd(params.source); // for apply coming from amp

    return dispatchPromises;
  };

  Context.prototype.handleContextPromise = function handleContextPromise(contextPromise, params) {
    var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var self = this;

    return contextPromise.then(function (apiResponse) {
      var response = apiResponse.data ? apiResponse.data : {};
      if (response.success && response.json && !response.json.isInActiveJob) {
        return self.updateContextStoreValues(response.json, params, dispatch);
      } else if (response.success && response.json.isInActiveJob && response.json.snbUrl) {
        if (response.json && response.json.snbUrl && lib_default.a.location) {
          lib_default.a.location.href = response.json.snbUrl;
        }
      } else if (response.success === false) {
        ApplyService["a" /* default */].directApplyAd(params.source);
        if (params && "SNB" === params.source) {
          Apply["a" /* default */].toggleJobListDisplay(true);
        } else {
          try {
            if (typeof JobsSentry !== "undefined" && params) JobsSentry.captureMessage("Vap failed to fetch Ad! \nParams : " + JSON.stringify(params) + "\nResponse : " + JSON.stringify(response));

            if (lib_default.a.location) {
              lib_default.a.location.href = "/jobs/404";
            }
          } catch (error) {}
        }
      }
    });
  };

  /**
   * Update JobSnow variable used for dfp ads
   */


  // initializeContextForFlexi = () => {}
  Context.prototype.updateJobSnow = function updateJobSnow(values) {
    if (lib_default.a.JobSnow && typeof lib_default.a.JobSnow !== "undefined") {
      lib_default.a.JobSnow = _extends(lib_default.a.JobSnow, values);
    }
  };

  return Context;
}(), _class.updateCityForLocality = function (event) {
  var city = event.target.innerText;
  store["a" /* JobStore */].dispatch(Object(ContextActions["c" /* updateApplyAfterCityChange */])(city));

  Context_Context.updateLocalityForLocality("");
}, _class.updateLocalityForLocality = function (value) {
  store["a" /* JobStore */].dispatch(Object(ContextActions["d" /* updateApplyAfterLocalityChange */])(value));
}, _class.toggleSearchPopupFilter = function (value) {
  store["a" /* JobStore */].dispatch(Object(ContextActions["b" /* toggleSearchPopupFilter */])(value));
}, _class.getDetailsForContext = function (qCashDetails, context) {
  var details = {};
  for (var key in qCashDetails) {
    if (qCashDetails.hasOwnProperty(key)) {
      var value = qCashDetails[key];
      if (context === value.productContext) {
        details = value;
        break;
      }
    }
  }

  return details;
}, _class.showLoader = function () {
  return Context_Context.toggleLoader(true);
}, _class.hideLoader = function () {
  return Context_Context.toggleLoader(false);
}, _class.toggleLoader = function (value) {
  store["a" /* JobStore */].dispatch(Object(ContextActions["a" /* toggleLoader */])(value));
}, _class.isInterstitialAdEnabled = function (page, city) {
  var isEnabled = false;
  var storeValues = store["a" /* JobStore */].getState();
  var config = storeValues.context.interstitialAdConfigs;
  if (config) {
    var pageConfig = config[page];
    var formattedCity = Object(utils["A" /* sanitizeRole */])(city.toLowerCase());
    isEnabled = pageConfig.isComplete || pageConfig.enabledCities.indexOf(formattedCity) > -1;
  }

  return isEnabled;
}, _class.isFlyingCarpetAdEnabled = function (role, city) {
  var isEnabled = false;
  var storeValues = store["a" /* JobStore */].getState();
  var config = storeValues.context.flyingCarpetAdConfig;
  if (config) {
    var formattedCity = Object(utils["A" /* sanitizeRole */])(city.toLowerCase());
    var formattedRole = Object(utils["A" /* sanitizeRole */])(role.toLowerCase());

    var isRoleEnabled = config.areAllRolesEnabled || config.enabledRoles.indexOf(formattedRole) > -1;
    var isCityEnabled = config.areAllCitiesEnabled || config.enabledCities.indexOf(formattedCity) > -1;

    isEnabled = isRoleEnabled && isCityEnabled;
  }

  return isEnabled;
}, _temp);


/***/ }),

/***/ "85P6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_q_components_components_icons_headerIcons__ = __webpack_require__("AZDm");



function isMobileRequest() {
  if (typeof window != "undefined" && typeof window.__PRELOADED_STATE__ != 'undefined' && typeof window.__PRELOADED_STATE__.isMobile != 'undefined') {
    return window.__PRELOADED_STATE__.isMobile;
  } else {
    return true;
  }
}

function isWebViewRequest() {
  if (typeof window != "undefined" && typeof window.__PRELOADED_STATE__ != "undefined" && typeof window.__PRELOADED_STATE__.isWebView != "undefined") {
    return window.__PRELOADED_STATE__.isWebView;
  }
  return false;
}

var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_q_components_components_icons_headerIcons__["e" /* Quikr */], { 'class': 'mdc-toolbar__icons' });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'span',
  { 'class': 'link-text-hidden' },
  'Quikr'
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'span',
  { 'class': 'link-text-hidden' },
  'Quikr'
);

function logoCallBack(props, context) {
  if (isMobileRequest()) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: 'https://www.quikr.com', 'class': 'logo' },
      _ref,
      _ref2
    );
  } else {
    var type = props.match.params.type;

    var logoUrl = 'https://teja8.kuikr.com/module_assets/images/quikr_logo.png';
    var href = 'https://www.quikr.com';
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: href, 'class': 'logo' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: logoUrl, 'class': 'quikrs-logo' }),
      _ref3
    );
  }
}

var config = [{
  route: {
    path: "/securepaymentpage",
    exact: true
  },
  pageType: "pwaPaymentPage",
  header: {
    show: false
  },
  footer: {
    show: false
  }
}, {
  route: {
    path: "/wallet",
    exact: true
  },
  pageType: "quikrWalletDetails",
  header: {
    show: !isWebViewRequest(),
    searchCityCallback: function searchCityCallback(cityId, cityName, g_id, match, prevcity) {
      var currentLocation = window.location.href;
      window.location = currentLocation;
    },
    logoCallback: logoCallBack,
    cityModal: true
  },
  search: {
    show: !isWebViewRequest()
  },
  footer: {
    show: false
  }
}, {
  route: {
    path: "/giftcards",
    exact: true
  },
  pageType: "activeGiftCards",
  header: {
    show: !isWebViewRequest(),
    searchCityCallback: function searchCityCallback(cityId, cityName, g_id, match, prevcity) {
      var currentLocation = window.location.href;
      window.location = currentLocation;
    },
    logoCallback: logoCallBack,
    cityModal: true
  },
  search: {
    show: !isWebViewRequest()
  },
  footer: {
    show: false
  }
}, {
  route: {
    path: "/giftcard/categories",
    exact: true
  },
  pageType: "giftCardCategory",
  header: {
    show: !isWebViewRequest(),
    searchCityCallback: function searchCityCallback(cityId, cityName, g_id, match, prevcity) {
      var currentLocation = window.location.href;
      window.location = currentLocation;
    },
    logoCallback: logoCallBack,
    cityModal: true
  },
  search: {
    show: !isWebViewRequest()
  },
  footer: {
    show: false
  }
}, {
  route: {
    path: '/giftcard/details',
    exact: true
  },
  pageType: "giftCardDetails",
  header: {
    show: !isWebViewRequest(),
    searchCityCallback: function searchCityCallback(cityId, cityName, g_id, match, prevcity) {
      var currentLocation = window.location.href;
      window.location = currentLocation;
    },
    logoCallback: logoCallBack,
    cityModal: true
  },
  search: {
    show: !isWebViewRequest()
  },
  footer: {
    show: false
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ "8Ery":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplyCookieHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__("/ErD");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * For prefilling apply details and stroring apply related information in cookie/localstorage
 */

var ApplyCookieHelper = function () {
  function ApplyCookieHelper() {
    var _this = this;

    _classCallCheck(this, ApplyCookieHelper);

    this.getABRand = function () {
      return parseInt(_this.cookies.get('abRand'), 10);
    };

    this.getABRandMobile = function () {
      return parseInt(_this.cookies.get('abRandMobile'), 10);
    };

    this.cookies = new __WEBPACK_IMPORTED_MODULE_0_universal_cookie__["a" /* default */]();
  }

  //Get applied jobs from cookie


  ApplyCookieHelper.prototype.getAppliedJobs = function getAppliedJobs() {
    var jobsApplied = this.cookies.get('jobs_applied');
    return jobsApplied ? jobsApplied.split(',') : [];
  };

  /**
   * Is Job Already Applied and Added to applied cookie list
   * @param {*} jobId
  */


  ApplyCookieHelper.prototype.isJobApplied = function isJobApplied(jobId) {
    var appliedJobs = this.getAppliedJobs();
    if (appliedJobs && jobId) {
      if (appliedJobs.indexOf(jobId.toString()) > -1) {
        return true;
      }
    }
    return false;
  };

  //Add job id to applied job list


  ApplyCookieHelper.prototype.setAppliedJob = function setAppliedJob(jobId) {
    var appliedJobs = this.getAppliedJobs();
    if (appliedJobs.indexOf(jobId.toString()) < 0) {
      appliedJobs.push(jobId);
      this.cookies.set('jobs_applied', appliedJobs.join(','), { path: '/' });
    }
  };

  ApplyCookieHelper.prototype.setAppliedJobs = function setAppliedJobs(appliedJobs) {
    // appliedJobs should be an array of jobs ids
    this.cookies.set('jobs_applied', appliedJobs.join(','), { path: '/' });
  };

  ApplyCookieHelper.prototype.getPrefillItem = function getPrefillItem(key) {
    var item = this.cookies.get('jobs_var_' + key);
    return item;
  };

  ApplyCookieHelper.prototype.setPrefillItem = function setPrefillItem(key, value) {
    if (key === 'email') {
      // Compatibility with old code
      key = 'email_Id';
    }

    if (value && typeof value !== 'undefined') {
      this.cookies.set('jobs_var_' + key, value, { path: '/' });
    }
  };

  ApplyCookieHelper.prototype.getPreferredCity = function getPreferredCity() {
    return this.cookies.get('new_prefer_city');
  };

  ApplyCookieHelper.prototype.getPreferredCityId = function getPreferredCityId() {
    return this.cookies.get('new_prefer_city_id');
  };

  ApplyCookieHelper.prototype.getPreferredRole = function getPreferredRole() {
    return this.cookies.get('new_prefer_role');
  };

  ApplyCookieHelper.prototype.setPreferredRole = function setPreferredRole(role) {
    if ('' !== role && 'undefined' !== typeof role) {
      this.cookies.set('new_prefer_role', role, { path: '/' });
    }
  };

  ApplyCookieHelper.prototype.checkProfileCookieDataForLoggedOutUser = function checkProfileCookieDataForLoggedOutUser() {
    if (this.getPrefillItem('city') && this.getPrefillItem('email_Id') && this.getPrefillItem('locality') && this.getPrefillItem('mobile') && this.getPrefillItem('name')) {
      return true;
    } else {
      return false;
    }
  };

  ApplyCookieHelper.prototype.updateCookiesAfterApplyWithoutEmail = function updateCookiesAfterApplyWithoutEmail() {
    this.cookies.set('jobs_var_email_Id', '', { path: '/', expires: new Date(0) });
  };

  return ApplyCookieHelper;
}();



/***/ }),

/***/ "8OFB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reduxActionFormChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reduxActionAdAttributeChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return reduxActionIntegrationsFormOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return reduxActionIntegrationsFormClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return reduxActionIntegrationsFormSubmitted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return reduxActionIntegrationsSetFormType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reduxActionIntegrationsClearForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return reduxActionIntegrationsSourceClear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reduxActionIntegrationUpdateFormState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");


var reduxActionFormChange = function reduxActionFormChange(attributes) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["e" /* INTEGRATIONS_EVENTS */].FORM_CHANGE,
    payload: attributes
  };
};

var reduxActionAdAttributeChange = function reduxActionAdAttributeChange(attributes) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["e" /* INTEGRATIONS_EVENTS */].FORM_FIELD_CHANGE,
    payload: attributes
  };
};

var reduxActionIntegrationsFormOpen = function reduxActionIntegrationsFormOpen() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["e" /* INTEGRATIONS_EVENTS */].FORM_OPEN,
    payload: {}
  };
};

var reduxActionIntegrationsFormClose = function reduxActionIntegrationsFormClose(attributes) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["e" /* INTEGRATIONS_EVENTS */].FORM_CLOSE,
    payload: attributes || {}
  };
};

var reduxActionIntegrationsFormSubmitted = function reduxActionIntegrationsFormSubmitted() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["e" /* INTEGRATIONS_EVENTS */].FORM_SUBMITTED,
    payload: {}
  };
};

var reduxActionIntegrationsSetFormType = function reduxActionIntegrationsSetFormType(type, source, globalState) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["e" /* INTEGRATIONS_EVENTS */].SET_FORM_TYPE,
    payload: { type: type, source: source, globalState: globalState }
  };
};

var reduxActionIntegrationsClearForm = function reduxActionIntegrationsClearForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["e" /* INTEGRATIONS_EVENTS */].CLEAR_FORM,
    payload: {}
  };
};

var reduxActionIntegrationsSourceClear = function reduxActionIntegrationsSourceClear(source) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["e" /* INTEGRATIONS_EVENTS */].INTEGRATION_SOURCE_CLEAR,
    payload: { source: source }
  };
};

var reduxActionIntegrationUpdateFormState = function reduxActionIntegrationUpdateFormState(context) {
  return {
    type: 'UPDATE_FORM_STATE',
    payload: { context: context }
  };
};

/***/ }),

/***/ "8j0a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.default = void 0;var _getPushSubscription = _interopRequireDefault(__webpack_require__("s+cM")),
    _initialize = _interopRequireDefault(__webpack_require__("FhIh")),
    _preRequestModal = __webpack_require__("B4uj"),
    _requestPermission = _interopRequireDefault(__webpack_require__("lhFt")),
    _saveSubscription = _interopRequireDefault(__webpack_require__("D+gp")),
    _updateSubscription = _interopRequireDefault(__webpack_require__("P1CM")),
    _common = __webpack_require__("yMAY");function _interopRequireDefault(a) {
  return a && a.__esModule ? a : { default: a };
}function WebPushNotifications() {
  var a = this,
      b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};if (this.subscribeConfig = { userVisibleOnly: !0 }, !b.vertical || !b.context) throw new Error("Vertical and Context are mandatory!");else this.vertical = b.vertical, this.context = b.context;if (this.threshold = 1, b.threshold && (this.threshold = b.threshold), b.vapidKey && (this.subscribeConfig.applicationServerKey = (0, _common.urlBase64ToUint8Array)(b.vapidKey)), b.useThisServiceWorker) if ("ServiceWorkerRegistration" === Object.getPrototypeOf(b.useThisServiceWorker).constructor.name) this.swRegistration = b.useThisServiceWorker;else throw new Error("Invalid service worker registration");b.pwa && (this.pwa = !0), window.ga = window.ga || function () {
    for (var a = arguments.length, b = Array(a), c = 0; c < a; c++) {
      b[c] = arguments[c];
    }return (ga.q = ga.q || []).push(b);
  }, ga("create", b.gaTrackingId || (this.pwa ? "UA-5568615-7" : "UA-5568615-1"), "auto", "wpn"), ga("wpn.set", "transport", "beacon"), this.pushToGA = function (c, d, e) {
    "allow" == d || "block" == d || "impression" == d || ga("wpn.send", "event", { eventCategory: "wpn_".concat(0 < b.withTimeout ? "".concat(b.withTimeout, "sec") : "onload"), eventAction: "wpn_".concat(a.vertical, "_").concat(a.context, "_").concat(c), eventLabel: "wpn_".concat(d), nonInteraction: !e });
  }, this.isSupported = function () {
    return "undefined" != typeof navigator && "serviceWorker" in navigator && "undefined" != typeof PushManager && "undefined" != typeof Notification && "undefined" != typeof indexedDB;
  };
}WebPushNotifications.prototype.canTriggerCustomDialog = _preRequestModal.canTriggerCustomDialog, WebPushNotifications.prototype.getIgnoredTimestamp = _preRequestModal.getIgnoredTimestamp, WebPushNotifications.prototype.getPushSubscription = _getPushSubscription.default, WebPushNotifications.prototype.initialize = _initialize.default, WebPushNotifications.prototype.requestPermission = _requestPermission.default, WebPushNotifications.prototype.saveSubscription = _saveSubscription.default, WebPushNotifications.prototype.setIgnoredTimestamp = _preRequestModal.setIgnoredTimestamp, WebPushNotifications.prototype.updateSubscription = _updateSubscription.default;var _default = WebPushNotifications;exports.default = _default;

/***/ }),

/***/ "8wV9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return firePageLoadGa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fireEventGa; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_ga__ = __webpack_require__("HP3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_form_urlencoded__ = __webpack_require__("dA1j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_form_urlencoded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_form_urlencoded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_window_or_global__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Submit GA Actions
 * @todo: move this to redux
 */




var getWebview = function getWebview() {
  var __WEBVIEW_STATE__ = __WEBPACK_IMPORTED_MODULE_2_window_or_global___default.a.__WEBVIEW_STATE__;

  if (__WEBVIEW_STATE__ && (__WEBVIEW_STATE__ == 'android' || __WEBVIEW_STATE__ == 'ios')) {
    return __WEBVIEW_STATE__;
  }
  return false;
};

var setTracker = function setTracker() {
  try {
    var isWebview = getWebview();
    if (isWebview) {
      var tracker = ga.getByName(__WEBPACK_IMPORTED_MODULE_0__constants_ga__["c" /* GA_TRACKER_NAME */]);
      tracker && ga(function () {
        tracker.set('dimension17', isWebview);
      });
    }
  } catch (error) {}
};

var firePageLoadGa = function firePageLoadGa(name, options) {
  var pageLoadGa = __WEBPACK_IMPORTED_MODULE_0__constants_ga__["d" /* PAGE_LOAD */][name];
  if (!pageLoadGa) return false;

  var gaOptions = _extends({}, __WEBPACK_IMPORTED_MODULE_0__constants_ga__["a" /* DEFAULT_PAGELOAD_OPTIONS */], pageLoadGa.options, options);
  var gaTag = pageLoadGa.page + '?' + __WEBPACK_IMPORTED_MODULE_1_form_urlencoded___default()(gaOptions);

  if (typeof ga !== 'undefined' && ga) {
    setTracker();
    try {
      // _gaq.push(['_trackPageview', gaTag]);
      ga(__WEBPACK_IMPORTED_MODULE_0__constants_ga__["c" /* GA_TRACKER_NAME */] + '.send', 'pageview', gaTag);
    } catch (error) {
      console.log('Ga error');
    }
  }
};

var fireEventGa = function fireEventGa(options) {
  var category = options.category,
      action = options.action,
      label = options.label,
      _options$value = options.value,
      value = _options$value === undefined ? 0 : _options$value,
      rest = _objectWithoutProperties(options, ['category', 'action', 'label', 'value']);

  if (typeof ga !== 'undefined' && ga) {
    setTracker();
    try {
      // _gaq.push(['_trackEvent', category, action, label, value, true]);
      ga(__WEBPACK_IMPORTED_MODULE_0__constants_ga__["c" /* GA_TRACKER_NAME */] + '.send', 'event', _extends({
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value
      }, rest));
    } catch (error) {
      console.log('Ga error');
    }
  } else {
    console.log('Google Analytics not loaded');
  }
};


/***/ }),

/***/ "9BVR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),

/***/ "9Snp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim();
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

/***/ }),

/***/ "9Szb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("yy8s"));

var _react = _interopRequireDefault(__webpack_require__("CK2z"));

var _reactLifecyclesCompat = __webpack_require__("sTIH");

var _ChildMapping = __webpack_require__("OWbL");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "9kyV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toolbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss__ = __webpack_require__("w/zb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss__ = __webpack_require__("kNFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import styles.
 */


/**
 * Import local dependencies.
 */


/**
 * Create the component.
 */

var Toolbar = function (_Component) {
  _inherits(Toolbar, _Component);

  function Toolbar() {
    _classCallCheck(this, Toolbar);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Toolbar.prototype.render = function render(_ref, state, context) {
    var className = _ref['class'],
        children = _ref.children,
        black = _ref.black,
        fixed = _ref.fixed,
        props = _objectWithoutProperties(_ref, ['class', 'children', 'black', 'fixed']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-toolbar', {
      'mdc-toolbar__black': black
    }, {
      'mdc-toolbar--fixed': fixed
    }, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'header',
      _extends({ 'class': classes }, props),
      children
    );
  };

  return Toolbar;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "9mGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Message; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Generic object used to carry information between different
 * layers in the application
 */
var Message = function () {
  /**
   * @param {int}    type     0 - failure | 1 - success | 2 - info
   * @param {int}    html     0 - text | 1 - html
   * @param {string} value    value to be displayed
   * @param {object} metaData extra data
   */
  function Message(type, html, value) {
    var metaData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Message);

    this.type = type;
    this.html = html;
    this.value = value;
    this.metaData = metaData;
  }

  Message.prototype.get = function get() {
    return {
      type: this.type,
      html: this.html,
      value: this.value,
      metaData: this.metaData
    };
  };

  return Message;
}();

/***/ }),

/***/ "A+/b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initializeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showNextSurveyQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return showPreviousSurveyQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return startTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return showResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showNextResponseScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setFinalFeedBackAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setRedirectURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");


var initializeContext = function initializeContext(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].INITIALIZE_CONTEXT,
    payload: payload
  };
};

var showNextSurveyQuestion = function showNextSurveyQuestion() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].SHOW_NEXT_SURVEY_QUESTION,
    payload: {}
  };
};

var showPreviousSurveyQuestion = function showPreviousSurveyQuestion() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].SHOW_PREVIOUS_SURVEY_QUESTION,
    payload: {}
  };
};

var updateContext = function updateContext(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].UPDATE_CONTEXT,
    payload: payload
  };
};

var changeTab = function changeTab(newTab) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].CHANGE_TAB,
    payload: {
      currentTab: newTab
    }
  };
};

var startTest = function startTest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].START_TEST,
    payload: {}
  };
};

var showResponse = function showResponse(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].SHOW_RESPONSE,
    payload: payload
  };
};

var showNextResponseScreen = function showNextResponseScreen() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].SHOW_NEXT_RESPONSE_SCREEN,
    payload: {}
  };
};

var setFinalFeedBackAnswer = function setFinalFeedBackAnswer(answerObject) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].SET_FINAL_FEEDBACK_ANSWER,
    payload: {
      finalFeedbackAnswer: answerObject
    }
  };
};

var setRedirectURL = function setRedirectURL(redirectURL) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].SET_REDIRECT_URL,
    payload: {
      redirectURL: redirectURL
    }
  };
};

var setError = function setError(message) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["b" /* CANDIDATE_TEST_EVENTS */].SET_ERROR,
    payload: {
      message: message
    }
  };
};

/***/ }),

/***/ "AUOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCitySpecificCategoryId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return searchCityCallbackForSnb; });
/* unused harmony export searchCityCallbackForCategory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchCityCallbackForCertified; });
/* unused harmony export searchCityCallbackForAssured */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pfetch__ = __webpack_require__("rqos");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_window_or_global__);


var getCitySpecificCategoryId = function getCitySpecificCategoryId(cityId, categoryGlobalId, categoryId) {
    return new Promise(function (resolve, reject) {
        var ajaxHost = "https://www.quikr.com";
        var params = {
            cityId: cityId
        };

        if (typeof categoryGlobalId !== 'undefined' && categoryGlobalId) {
            params['categoryGlobalId'] = categoryGlobalId;
        }

        if (typeof categoryId !== 'undefined' && categoryId) {
            params['categoryId'] = categoryId;
        }

        Object(__WEBPACK_IMPORTED_MODULE_0__pfetch__["b" /* QPost */])(ajaxHost + '/escrow/Category/getCitySpecificCategoryId?aj=1', params).then(function (response) {
            if (response.hasOwnProperty('status') && response.status === 'success') {
                resolve(response.id);
            } else {
                reject(response.errorMessage ? response.errorMessage : 'Something went wrong');
            }
        }).catch(function (err) {
            reject('Something went wrong');
        });
    });
};

var searchCityCallbackForSnb = function searchCityCallbackForSnb(cityId, cityName, globalId, match) {
    cityId = cityId * 1;
    var isAllIndia = cityId === 0 || cityId === 1;
    var pageUrl = match.url;
    var matches = pageUrl.match(/[w|x|y|z](\d+)([a-zA-Z]+)/);

    getCitySpecificCategoryId(cityId, globalId).then(function (categoryId) {
        var searchMatches = pageUrl.match(/(x|z)(\d+)/);
        var isSearchUrl = searchMatches && searchMatches.length;
        var slugParams = match.params.slug.split('+');
        var slugParamsLength = slugParams.length;
        if (isAllIndia) {
            slugParams[slugParamsLength - 1] = (isSearchUrl ? 'z' : 'y') + categoryId + matches[2];
            slugParams[slugParamsLength - 2] = 'India';
        } else {
            slugParams[slugParamsLength - 1] = (isSearchUrl ? 'x' : 'w') + categoryId + matches[2];
            slugParams[slugParamsLength - 2] = cityName;
        }
        __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.href = __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.search;
    }).catch(function (err) {
        console.log(err);
    });
};

var searchCityCallbackForCategory = function searchCityCallbackForCategory(cityId, cityName, globalId, match) {
    cityId = cityId * 1;
    cityName = cityName.toLowerCase();
    var isAllIndia = cityId === 0 || cityId === 1;
    var pageUrl = match.url;
    var matches = pageUrl.match(/[gId|cId](\d+)/);

    getCitySpecificCategoryId(cityId, globalId).then(function (categoryId) {
        var slugParams = match.params.slug.split('+');
        var slugParamsLength = slugParams.length;
        if (isAllIndia) {
            slugParams[slugParamsLength - 2] = 'gId' + escrowCategoriesMap[match.params.type];
            slugParams.splice(slugParamsLength - 1, 1);
        } else {
            if (slugParamsLength === 1) {
                slugParams[0] = cityName;
                slugParams[1] = 'cId' + categoryId;
            } else {
                slugParams[slugParamsLength - 2] = cityName;
                slugParams[slugParamsLength - 1] = 'cId' + categoryId;
            }
        }
        __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.href = __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.search;
    }).catch(function (err) {
        console.log(err);
    });
};

var searchCityCallbackForCertified = function searchCityCallbackForCertified(cityId, cityName, globalId, match) {
    cityId = cityId * 1;
    var isAllIndia = cityId === 0 || cityId === 1;

    var slugParams = match.params.slug.split('+');
    var slugParamsLength = slugParams.length;
    if (slugParamsLength) {
        if (isAllIndia) {
            if (slugParamsLength > 1) {
                slugParams.splice(slugParamsLength - 1, 1);
            }
        } else {
            if (slugParamsLength > 1) {
                slugParams[slugParamsLength - 1] = cityName.toLowerCase();
            } else {
                slugParams[slugParamsLength] = cityName.toLowerCase();
            }
        }
    }
    __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.href = __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.search;
};

var searchCityCallbackForAssured = function searchCityCallbackForAssured(cityId, cityName, globalId, match) {
    cityId = cityId * 1;
    var isAllIndia = cityId === 0 || cityId === 1;

    var slugParams = match.params.slug.split('+');
    var slugParamsLength = slugParams.length;
    if (slugParamsLength) {
        if (isAllIndia) {
            if (slugParamsLength > 1) {
                slugParams.splice(slugParamsLength - 1, 1);
            }
        } else {
            if (slugParamsLength > 1) {
                slugParams[slugParamsLength - 1] = cityName.toLowerCase();
            } else {
                slugParams[slugParamsLength] = cityName.toLowerCase();
            }
        }
    }
    __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.href = __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.origin + '/' + slugParams.join('+') + __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.search;
};



/***/ }),

/***/ "AZDm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../preact/dist/preact.js
var preact = __webpack_require__("xIV9");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// CONCATENATED MODULE: ../q-monetization/node_modules/q-components/components/icons/headerIcons/account/index.js



var _ref = Object(preact["h"])("path", { d: "M35.6,2C45.8,2,54,10,54,20.2v0.2c0,10.2-8,18.2-18.1,18.4c-10.1,0-18.4-8-18.4-18.2C17.3,10.3,25.5,2,35.6,2 M67.7,69.3c0,0.5-0.2,0.7-0.7,0.7H5c-0.5,0-0.7-0.2-0.7-0.7c0-13.2,14.6-24.1,31.6-24.1C53.1,45,67.4,56.1,67.7,69.3" });

var account_account = function account(props) {
	return Object(preact["h"])(
		"svg",
		{ viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};
/* harmony default export */ var headerIcons_account = (account_account);
// CONCATENATED MODULE: ../q-monetization/node_modules/q-components/components/icons/headerIcons/back/index.js



var back__ref = Object(preact["h"])("polygon", { points: "70,31.8 18.2,31.8 41.9,7.9 36,2 2,36 36,70 41.9,64.1 18.2,40.2 70,40.2 " });

var back_back = function back(props) {
	return Object(preact["h"])(
		"svg",
		{ id: "back", viewBox: "0 0 72 72", "class": props.class },
		back__ref
	);
};
/* harmony default export */ var headerIcons_back = (back_back);
// CONCATENATED MODULE: ../q-monetization/node_modules/q-components/components/icons/headerIcons/menu/index.js



var menu__ref = Object(preact["h"])("path", { xmlns: "http://www.w3.org/2000/svg", d: "M70,10.8v9.1H2v-9.1H70z M2,33.5v9.1h68v-9.1H2z M2,56.1v9.1h68v-9.1H2z" });

var menu_menu = function menu(props) {
	return Object(preact["h"])(
		"svg",
		{ viewBox: "0 0 72 72", "class": props.class },
		menu__ref
	);
};
/* harmony default export */ var headerIcons_menu = (menu_menu);
// CONCATENATED MODULE: ../q-monetization/node_modules/q-components/components/icons/headerIcons/quikr/index.js



var quikr__ref = Object(preact["h"])("path", { d: "M60.8,18.3c0.7,8.4-2.6,22.5-8.9,28.6c-1.4,1.4-3,2.5-4.7,3.4L44,44.8c-1.2-2.1-2.5-3.4-3.8-4.3c2-1.3,3.5-3.2,4.6-5.8c1.3-3.1,3.1-10.2,2.7-13.6c-0.5-3.7-3-6.7-8.8-7c-2.6-0.2-5.2,0-7.7,0.7c-2.2,0.6-4.1,1.6-5.4,2.9c-3.2,3-5.2,10.5-5.5,14.8c-0.2,3,0.2,5.3,1.3,6.8c1.9,2.8,4.9,3.1,7.9,3l2.3,0c3.6,0,6.6,0.4,9.7,5.6l3.9,6.8c2.2,3.6,2.6,4.7,7.9,4.7H65L62.6,71H49c-3.8,0-8.9-0.6-12-5.8l-4.6-7.9c-1.8-2.9-1.7-3.4-5-3.6c-3.6-0.2-7.6-0.6-9.8-1.5c-5.5-2.1-9.9-6.3-10.6-13.7c-0.2-1.9-0.1-3.9,0.1-6C7.4,30.2,8,27.3,8.6,25c1.5-6.2,3.7-11.3,7.6-15c5-4.8,12-6.7,18.6-6.9c2.6-0.1,7.1,0,10.9,0.5C53.9,4.7,60.1,9.5,60.8,18.3" });

var quikr_quikr = function quikr(props) {
	return Object(preact["h"])(
		"svg",
		{ viewBox: "0 0 72 72", "class": props.class },
		quikr__ref
	);
};
/* harmony default export */ var headerIcons_quikr = (quikr_quikr);
// EXTERNAL MODULE: ../q-monetization/node_modules/q-components/components/icons/headerIcons/gps/index.js
var gps = __webpack_require__("TsWY");

// CONCATENATED MODULE: ../q-monetization/node_modules/q-components/components/icons/headerIcons/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return headerIcons_account; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return headerIcons_back; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return headerIcons_menu; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return headerIcons_quikr; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return gps["a" /* default */]; });








/***/ }),

/***/ "Aslg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),

/***/ "Atye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ripple_mdc_ripple_scss__ = __webpack_require__("sPP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ripple_mdc_ripple_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ripple_mdc_ripple_scss__);
/**
 * Import dependencies.
 */

/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */


/**
 * Export the ripple helper.
 */
/* harmony default export */ __webpack_exports__["a"] = (function (e, rippleParameter) {
  if (!e || !e.getBoundingClientRect) {
    return '';
  }
  var dimensions = e.getBoundingClientRect();
  var maxDim = Math.max(dimensions.height, dimensions.width);
  var surfaceDiameter = Math.sqrt(Math.pow(dimensions.width, 2) + Math.pow(dimensions.height, 2));
  // 60% of the largest dimension of the surface
  var fgSize = maxDim * 0.6;
  // Diameter of the surface + 10px
  var maxRadius = surfaceDiameter + 10;
  var fgScale = maxRadius / fgSize;
  if (rippleParameter) {
    return {
      style: '--mdc-ripple-surface-width:' + dimensions.width / rippleParameter + 'px;\n      --mdc-ripple-surface-height:' + dimensions.height / rippleParameter + 'px;\n      --mdc-ripple-fg-size:' + Math.round(fgSize) + 'px;\n      --mdc-ripple-fg-scale:' + fgScale / rippleParameter + ';\n      --mdc-ripple-left:' + Math.round(dimensions.width / 2 - fgSize / 2) + 'px;\n      --mdc-ripple-top:' + Math.round(dimensions.height / 2 - fgSize / 2) + 'px;',
      duration: 1000 * Math.sqrt(maxRadius / 1024)
    };
  } else {
    return {
      style: '--mdc-ripple-surface-width:' + dimensions.width + 'px;\n      --mdc-ripple-surface-height:' + dimensions.height + 'px;\n      --mdc-ripple-fg-size:' + Math.round(fgSize) + 'px;\n      --mdc-ripple-fg-scale:' + fgScale + ';\n      --mdc-ripple-left:' + Math.round(dimensions.width / 2 - fgSize / 2) + 'px;\n      --mdc-ripple-top:' + Math.round(dimensions.height / 2 - fgSize / 2) + 'px;',
      duration: 1000 * Math.sqrt(maxRadius / 1024)
    };
  }
});

/***/ }),

/***/ "B4uj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _idb = __webpack_require__("RTKd");Object.defineProperty(exports, "__esModule", { value: !0 }), exports.getIgnoredTimestamp = getIgnoredTimestamp, exports.setIgnoredTimestamp = setIgnoredTimestamp, exports.canTriggerCustomDialog = canTriggerCustomDialog;function getIgnoredTimestamp() {
  var a = this;return new Promise(function (b, c) {
    a.initialized ? (0, _idb.readFromIDB)(a.idb, "ignoredTimestamp").then(function (a) {
      return b(a && a.timestamp);
    }).catch(c) : c(new Error("IDB Instance unavailable. Please initialize."));
  });
}function setIgnoredTimestamp() {
  var a = this;return new Promise(function (b, c) {
    a.initialized ? (0, _idb.writeToIDB)(a.idb, "ignoredTimestamp", { timestamp: Date.now() }).then(b).catch(c) : c(new Error("IDB Instance unavailable. Please initialize."));
  });
}function canTriggerCustomDialog() {
  var a = this;return new Promise(function (b, c) {
    a.initialized ? a.pushSubscription ? c(new Error("User is already subscribed!")) : a.getIgnoredTimestamp().then(function (d) {
      !d || (Date.now() - d) / 86400000 > a.threshold ? b() : c(new Error("Last ignored timestamp is below the threshold"));
    }).catch(c) : new Error("IDB Instance unavailable. Please initialize.");
  });
}

/***/ }),

/***/ "Cl+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_tabs__ = __webpack_require__("Xf5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_tabs_mdc_tabs_scss__ = __webpack_require__("GthU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_tabs_mdc_tabs_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_tabs_mdc_tabs_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_scss__ = __webpack_require__("ejLf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * @prop indicator-accent = false
 * @prop icon-tab-bar = false
 * @prop icons-with-text = false
 * @prop scroller = false
 */

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("span", { "class": "mdc-tab-bar__indicator" });

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs() {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.componentName = "tab-bar";
    _this._mdcProps = ["indicator-accent", "icon-tab-bar", "icons-with-text", "scroller"];
    return _this;
  }

  Tabs.prototype.componentDidMount = function componentDidMount() {
    this.MDComponent = new __WEBPACK_IMPORTED_MODULE_2__material_tabs__["a" /* MDCTabBar */](this.control);
    if (this.props.contentClass) {
      var updatePanel = function updatePanel(index) {
        var activePanel = panels.querySelector('.mdc-panel.active');
        if (activePanel) {
          activePanel.classList.remove('active');
        }
        var newActivePanel = panels.querySelector('.mdc-panel:nth-child(' + (index + 1) + ')');
        if (newActivePanel) {
          newActivePanel.classList.add('active');
        }
      };

      var panels = document.querySelector('.' + this.props.contentClass);


      this.MDComponent.listen('MDCTabBar:change', function (_ref) {
        var tabs = _ref.detail;

        var nthChildIndex = tabs.activeTabIndex;

        updatePanel(nthChildIndex);
      });
    }
  };

  Tabs.prototype.componentWillUnmount = function componentWillUnmount() {
    this.MDComponent.destroy && this.MDComponent.destroy();
  };

  Tabs.prototype.render = function render(_ref2) {
    var _this2 = this;

    var className = _ref2['class'],
        children = _ref2.children,
        scroller = _ref2.scroller,
        props = _objectWithoutProperties(_ref2, ['class', "children", "scroller"]);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-tab-bar', {
      'mdc-tab-bar-scroller__scroll-frame__tabs': scroller
    }, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "nav",
      _extends({
        "class": classes,
        role: "tablist"
      }, props, {
        ref: function ref(control) {
          return _this2.control = control;
        }
      }),
      children,
      _ref3
    );
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "div",
  { className: "mdc-tab-bar-scroller__indicator mdc-tab-bar-scroller__indicator--back" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "a",
    {
      className: "mdc-tab-bar-scroller__indicator__inner material-icons",
      href: "#",
      "aria-label": "scroll back button"
    },
    "\u2039"
  )
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "div",
  { className: "mdc-tab-bar-scroller__indicator mdc-tab-bar-scroller__indicator--forward" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "a",
    {
      className: "mdc-tab-bar-scroller__indicator__inner material-icons",
      href: "#",
      "aria-label": "scroll forward button"
    },
    "\u203A"
  )
);

var TabBarScroller = function (_Component2) {
  _inherits(TabBarScroller, _Component2);

  function TabBarScroller() {
    _classCallCheck(this, TabBarScroller);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this));

    _this3.componentName = "tab-bar-scroller";
    return _this3;
  }

  TabBarScroller.prototype.componentDidMount = function componentDidMount() {
    this.MDComponent = new __WEBPACK_IMPORTED_MODULE_2__material_tabs__["b" /* MDCTabBarScroller */](this.control);
  };

  TabBarScroller.prototype.componentWillUnmount = function componentWillUnmount() {
    this.MDComponent.destroy && this.MDComponent.destroy();
  };

  TabBarScroller.prototype.render = function render(_ref4) {
    var _this4 = this;

    var className = _ref4['class'],
        children = _ref4.children,
        props = _objectWithoutProperties(_ref4, ['class', "children"]);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-tab-bar-scroller', {}, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      _extends({ "class": classes }, props, { ref: function ref(control) {
          return _this4.control = control;
        } }),
      _ref5,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        { className: "mdc-tab-bar-scroller__scroll-frame" },
        children
      ),
      _ref6
    );
  };

  return TabBarScroller;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/**
 * @prop active = false
 */


var Tab = function (_Component3) {
  _inherits(Tab, _Component3);

  function Tab() {
    _classCallCheck(this, Tab);

    var _this5 = _possibleConstructorReturn(this, _Component3.call(this));

    _this5.componentName = "tab";
    _this5._mdcProps = ["active"];
    return _this5;
  }

  Tab.prototype.render = function render(_ref7) {
    var _this6 = this;

    var className = _ref7['class'],
        children = _ref7.children,
        active = _ref7.active,
        props = _objectWithoutProperties(_ref7, ['class', "children", "active"]);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-tab', { 'mdc-tab--active': active }, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "a",
      _extends({ "class": classes, role: "tab" }, props, { ref: function ref(control) {
          return _this6.control = control;
        } }),
      children
    );
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var TabIconLabel = function (_Component4) {
  _inherits(TabIconLabel, _Component4);

  function TabIconLabel() {
    _classCallCheck(this, TabIconLabel);

    var _this7 = _possibleConstructorReturn(this, _Component4.call(this));

    _this7.componentName = "tab__icon-text";
    return _this7;
  }

  TabIconLabel.prototype.render = function render(_ref8) {
    var _this8 = this;

    var props = _objectWithoutProperties(_ref8, []);

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "span",
      _extends({}, props, { ref: function ref(control) {
          return _this8.control = control;
        } }),
      props.children
    );
  };

  return TabIconLabel;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

Tabs.TabBarScroller = TabBarScroller;
Tabs.Tab = Tab;
Tabs.TabIconLabel = TabIconLabel;

/***/ }),

/***/ "D+gp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.default = saveSubscription;var _common = __webpack_require__("yMAY"),
    _fetch = __webpack_require__("+ZFP"),
    _idb = __webpack_require__("RTKd");function saveSubscription(a) {
  var b = this;return new Promise(function (c, d) {
    var e = (0, _common.getBrowserDetails)(),
        f = { endpointjson: JSON.stringify(a.toJSON()), create_time: (0, _common.getCurrentDateTime)(), br_name: e.name, br_version: e.version, browser_url: window.location.href, reg_id: a.endpoint.split("/").slice(-1) };(0, _fetch.fetcher)({ url: "/save-browser-reg-info", method: "POST", body: (0, _fetch.formURLSearchObject)(f) }).then(function (a) {
      a.ok ? c() : (b.pushSubscription.unsubscribe(), (0, _idb.clearIDB)(b.idb), d(new Error("Subscription save API failure!")));
    });
  });
}

/***/ }),

/***/ "DyZn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),

/***/ "EDt3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__("CK2z");
var PropTypes = __webpack_require__("yy8s");

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];

function isWebpackReady(getModuleIds) {
  if (( false ? "undefined" : _typeof(__webpack_require__.m)) !== "object") {
    return false;
  }

  return getModuleIds().every(function (moduleId) {
    return typeof moduleId !== "undefined" && typeof __webpack_require__.m[moduleId] !== "undefined";
  });
}

function load(loader) {
  var promise = loader();

  var state = {
    loading: true,
    loaded: null,
    error: null
  };

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });

  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };

  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);

      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });

  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return React.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var _class, _temp;

  if (!options.loading) {
    throw new Error("react-loadable requires a `loading` component");
  }

  var opts = _extends({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);

  var res = null;

  function init() {
    if (!res) {
      res = loadFn(opts.loader);
    }
    return res.promise;
  }

  ALL_INITIALIZERS.push(init);

  if (typeof opts.webpack === "function") {
    READY_INITIALIZERS.push(function () {
      if (isWebpackReady(opts.webpack)) {
        return init();
      }
    });
  }

  return _temp = _class = function (_React$Component) {
    _inherits(LoadableComponent, _React$Component);

    function LoadableComponent(props) {
      _classCallCheck(this, LoadableComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.retry = function () {
        _this.setState({ error: null, loading: true, timedOut: false });
        res = loadFn(opts.loader);
        _this._loadModule();
      };

      init();

      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      return _this;
    }

    LoadableComponent.preload = function preload() {
      return init();
    };

    LoadableComponent.prototype.componentWillMount = function componentWillMount() {
      this._mounted = true;
      this._loadModule();
    };

    LoadableComponent.prototype._loadModule = function _loadModule() {
      var _this2 = this;

      if (this.context.loadable && Array.isArray(opts.modules)) {
        opts.modules.forEach(function (moduleName) {
          _this2.context.loadable.report(moduleName);
        });
      }

      if (!res.loading) {
        return;
      }

      if (typeof opts.delay === "number") {
        if (opts.delay === 0) {
          this.setState({ pastDelay: true });
        } else {
          this._delay = setTimeout(function () {
            _this2.setState({ pastDelay: true });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === "number") {
        this._timeout = setTimeout(function () {
          _this2.setState({ timedOut: true });
        }, opts.timeout);
      }

      var update = function update() {
        if (!_this2._mounted) {
          return;
        }

        _this2.setState({
          error: res.error,
          loaded: res.loaded,
          loading: res.loading
        });

        _this2._clearTimeouts();
      };

      res.promise.then(function () {
        update();
      }).catch(function (err) {
        update();
      });
    };

    LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._mounted = false;
      this._clearTimeouts();
    };

    LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };

    LoadableComponent.prototype.render = function render() {
      if (this.state.loading || this.state.error) {
        return React.createElement(opts.loading, {
          isLoading: this.state.loading,
          pastDelay: this.state.pastDelay,
          timedOut: this.state.timedOut,
          error: this.state.error,
          retry: this.retry
        });
      } else if (this.state.loaded) {
        return opts.render(this.state.loaded, this.props);
      } else {
        return null;
      }
    };

    return LoadableComponent;
  }(React.Component), _class.contextTypes = {
    loadable: PropTypes.shape({
      report: PropTypes.func.isRequired
    })
  }, _temp;
}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== "function") {
    throw new Error("LoadableMap requires a `render(loaded, props)` function");
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

var Capture = function (_React$Component2) {
  _inherits(Capture, _React$Component2);

  function Capture() {
    _classCallCheck(this, Capture);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Capture.prototype.getChildContext = function getChildContext() {
    return {
      loadable: {
        report: this.props.report
      }
    };
  };

  Capture.prototype.render = function render() {
    return React.Children.only(this.props.children);
  };

  return Capture;
}(React.Component);

Capture.propTypes = {
  report: PropTypes.func.isRequired
};
Capture.childContextTypes = {
  loadable: PropTypes.shape({
    report: PropTypes.func.isRequired
  }).isRequired
};

Loadable.Capture = Capture;

function flushInitializers(initializers) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init());
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolve, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolve, reject);
  });
};

Loadable.preloadReady = function () {
  return new Promise(function (resolve, reject) {
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS).then(resolve, resolve);
  });
};

module.exports = Loadable;

/***/ }),

/***/ "EW5h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("yy8s"));

var _react = _interopRequireDefault(__webpack_require__("CK2z"));

var _reactDom = __webpack_require__("CK2z");

var _TransitionGroup = _interopRequireDefault(__webpack_require__("9Szb"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
}

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "EcKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BIG_BROTHER_EVENTS; });
/**
 * Event name constants for big brother analytics.
 * The list is provided by Analytics Team.
*/

var BIG_BROTHER_EVENTS = {
    jobsApplyInit: 'JobApply_init',
    jobsApplySuccess: 'JobApply_success',
    jobsPostAdInit: 'Post_Ad_init',
    jobsPostAdSuccess: 'Post_Ad_success',
    jobsSnBFilterSelect: 'Filter_select',
    jobsVapLoad: 'VAP',
    jobsHomeLoad: 'CATHOME',
    jobsSnbSearch: 'Search',
    jobsSnbBrowse: 'Browse',
    jobsCallInit: 'Call_init',
    jobsCallSuccess: 'Call_success'
};

/***/ }),

/***/ "EpF0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CandidateTestUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("R8p8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_form_urlencoded__ = __webpack_require__("dA1j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_form_urlencoded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_form_urlencoded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__ = __webpack_require__("A+/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("QSFW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FetchHelper__ = __webpack_require__("Hm4v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Context__ = __webpack_require__("7xfs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Search_UrlBuilder__ = __webpack_require__("4Pem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GaHelper__ = __webpack_require__("8wV9");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }












var CandidateTestUtils = (_temp = _class = function () {
  function CandidateTestUtils() {
    _classCallCheck(this, CandidateTestUtils);
  }

  CandidateTestUtils.performTrackingActions = function performTrackingActions(params) {
    Object(__WEBPACK_IMPORTED_MODULE_8__GaHelper__["b" /* firePageLoadGa */])('candidateTest', params);
    CandidateTestUtils.trackAction(params);
  };

  CandidateTestUtils.fireGAOnClose = function fireGAOnClose() {
    var storeValues = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].getState();
    var candidateTestStore = storeValues.candidateTest;
    var currentTab = candidateTestStore.currentTab;

    CandidateTestUtils.performTrackingActions({ action: 'close', tab: currentTab });
  };

  CandidateTestUtils.trackAction = function trackAction(params) {

    var requiredActions = ['initiate', 'startTest', 'close', 'submitSurvey', 'submitSkillTest', 'submitFeedback', 'answerFeedback', 'responseNext', 'showResponse'];

    if (params.action && -1 !== requiredActions.indexOf(params.action)) {
      var storeValues = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].getState();
      var candidateTestStore = storeValues.candidateTest;
      var userId = candidateTestStore.userId;
      var applicationId = candidateTestStore.applicationId;
      var actionTrackingQuestionId = candidateTestStore.actionTrackingQuestionId;

      if (actionTrackingQuestionId) {
        var payload = {
          userId: userId,
          questionId: actionTrackingQuestionId,
          answerId: 0,
          answer: new Date().getTime(),
          extraData: JSON.stringify(_extends({}, params, { applicationId: applicationId })),
          overrideRequired: true
        };

        CandidateTestUtils.submitHarvardAnswer(payload);
      }
    }
  };

  return CandidateTestUtils;
}(), _class.showNextSurveyQuestion = function () {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["g" /* showNextSurveyQuestion */])());
}, _class.showPreviousSurveyQuestion = function () {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["h" /* showPreviousSurveyQuestion */])());
}, _class.isTabChangeAllowed = function (newTab, currentTab) {
  var isAllowed = true;

  var storeValues = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].getState();
  var candidateTestStore = storeValues.candidateTest;

  if ('survey' === currentTab) {
    isAllowed = Object.keys(candidateTestStore.surveyAnswers).length === candidateTestStore.surveyQuestionsOverall.length;
  } else if ('skillTest' === currentTab) {
    isAllowed = Object.keys(candidateTestStore.skillTestAnswers).length === candidateTestStore.skillTestQuestions.length;
  }

  return isAllowed;
}, _class.changeTab = function (newTab, currentTab) {
  if (CandidateTestUtils.isTabChangeAllowed(newTab, currentTab)) {
    scrollTo(0, 0);
    CandidateTestUtils.performTrackingActions({ action: 'tabChange', newTab: newTab });
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["a" /* changeTab */])(newTab));
  } else {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["c" /* setError */])('Please answer all the questions in the current section before moving on to the next one'));

    //hack to make sure the message is thrown again when required
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["c" /* setError */])(''));
    }, 5000);
  }
}, _class.initializeContext = function (applicationId, token) {
  var fetchHelper = new __WEBPACK_IMPORTED_MODULE_4__FetchHelper__["a" /* default */]();

  var url = __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BASE_URL */] + __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* CANDIDATE_TEST_API */].replace('{applicationId}', applicationId).replace('{token}', token);

  var options = {
    url: url
  };
  var contextPromise = fetchHelper.request('GET', options);
  contextPromise.then(function (apiResponse) {
    if (apiResponse.hasOwnProperty('data')) {
      var response = apiResponse.data;
      if (response.success) {
        var newContext = response.json;

        var surveyQuestionsOverall = response.json.surveyQuestionsOverall;
        var surveyConfidenceQuestionMap = {};
        var surveyQuestions = [];
        for (var index in surveyQuestionsOverall) {
          if (surveyQuestionsOverall.hasOwnProperty(index)) {
            var question = surveyQuestionsOverall[index];
            var label = question.label;
            //Ignoring confidence questions
            if (label.indexOf('Confidence - ') === -1) {
              surveyQuestions.push(question);
            } else {
              //creating confidence question map for easier rendering
              var regex = /Confidence - Candidate Test Survey Q(.*)/;
              var matches = regex.exec(label);
              if (matches.hasOwnProperty(1)) {
                var mainQuestionNumber = matches[1];
                if (surveyQuestions.hasOwnProperty(mainQuestionNumber - 1)) {
                  var mainQuestion = surveyQuestions[mainQuestionNumber - 1];
                  var mainQuestionId = mainQuestion.id;
                  surveyConfidenceQuestionMap[mainQuestionId] = question;
                }
              }
            }
          }
        }
        newContext.surveyQuestionsOverall = surveyQuestionsOverall;
        newContext.surveyQuestions = surveyQuestions;
        newContext.surveyConfidenceQuestionMap = surveyConfidenceQuestionMap;

        if (response.json.hasOwnProperty('finalFeedbackQuestion')) {
          newContext.finalFeedbackQuestion = response.json.finalFeedbackQuestion;
        }

        if (newContext.city && newContext.role) {
          var urlBuilder = new __WEBPACK_IMPORTED_MODULE_6__Search_UrlBuilder__["a" /* default */]();
          CandidateTestUtils.setRedirectURL(urlBuilder.getJobsSnbUrl({ city: newContext.city, role: newContext.role }));
        }

        if (newContext.isTestTaken) {
          newContext.message = 'Test already Taken!';
        }

        var updatedContext = _extends({}, newContext, { isContextLoaded: true });
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["b" /* initializeContext */])(updatedContext));
        __WEBPACK_IMPORTED_MODULE_5__Context__["a" /* default */].hideLoader();

        if (!newContext.isTestTaken) {
          //calling ajax here because it depends on the above ajax response.
          CandidateTestUtils.performTrackingActions({ action: 'initiate' });
        }
      }
    }
  });
}, _class.submitCandidateTest = function (payload) {
  __WEBPACK_IMPORTED_MODULE_5__Context__["a" /* default */].showLoader();
  var fetchHelper = new __WEBPACK_IMPORTED_MODULE_4__FetchHelper__["a" /* default */]();
  var url = __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BASE_URL */] + __WEBPACK_IMPORTED_MODULE_3__constants__["f" /* CANDIDATE_TEST_SUBMIT_API */];

  var options = {
    url: url,
    data: __WEBPACK_IMPORTED_MODULE_1_form_urlencoded___default()(payload)
  };

  var submitResponse = fetchHelper.request('POST', options);
  submitResponse.then(function (apiResponse) {
    if (apiResponse.hasOwnProperty('data')) {
      var response = apiResponse.data;
      if (response.success) {
        var testResponse = response.json;
        scrollTo(0, 0);
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["i" /* showResponse */])({
          testResponse: testResponse,
          isTestSubmitted: true
        }));

        CandidateTestUtils.performTrackingActions({ action: 'showResponse' });
      }
    }
    __WEBPACK_IMPORTED_MODULE_5__Context__["a" /* default */].hideLoader();
  });
}, _class.startTest = function () {
  scrollTo(0, 0);
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["j" /* startTest */])());
}, _class.showNextResponseScreen = function () {
  scrollTo(0, 0);
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["f" /* showNextResponseScreen */])());
}, _class.setURL = function (url) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["k" /* updateContext */])({ url: url }));
}, _class.setRedirectURL = function (redirectUrl) {
  if (redirectUrl) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["e" /* setRedirectURL */])(redirectUrl));
  }
}, _class.redirect = function () {
  __WEBPACK_IMPORTED_MODULE_5__Context__["a" /* default */].showLoader();
  var store = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].getState();
  var candidateTestStore = store.candidateTest;
  var redirectURL = candidateTestStore.redirectURL;
  if (redirectURL) {
    __WEBPACK_IMPORTED_MODULE_7_window_or_global___default.a.location.href = redirectURL;
  }
}, _class.setFinalFeedbackAnswer = function (answerObject) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_CandidateTestActions__["d" /* setFinalFeedBackAnswer */])(answerObject));
}, _class.submitFinalFeedbackAnswer = function (payload) {
  __WEBPACK_IMPORTED_MODULE_5__Context__["a" /* default */].showLoader();
  var contextPromise = CandidateTestUtils.submitHarvardAnswer(payload);
  contextPromise.then(function (apiResponse) {
    if (apiResponse.hasOwnProperty('data')) {
      var response = apiResponse.data;
      if (response.success) {
        CandidateTestUtils.redirect();
      }
    }
  });
}, _class.submitHarvardAnswer = function (payload) {
  var fetchHelper = new __WEBPACK_IMPORTED_MODULE_4__FetchHelper__["a" /* default */]();

  var url = __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BASE_URL */] + __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* CANDIDATE_TEST_SUBMIT_HARVARD_ANSWER */];

  var options = {
    url: url,
    data: __WEBPACK_IMPORTED_MODULE_1_form_urlencoded___default()(payload)
  };
  return fetchHelper.request('POST', options);
}, _temp);


/***/ }),

/***/ "F6nf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateJob; });
/* unused harmony export updateNewJob */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateRsaData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");


var updateJob = function updateJob() {
  var job = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["g" /* JOB_EVENTS */].UPDATE_JOB,
    payload: job
  };
};

var updateNewJob = function updateNewJob() {
  var job = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["g" /* JOB_EVENTS */].UPDATE_NEW_JOB,
    payload: job
  };
};

var updateRsaData = function updateRsaData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["g" /* JOB_EVENTS */].UPDATE_RSA_DATA,
    payload: data
  };
};

/***/ }),

/***/ "FQP4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),

/***/ "FhIh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _idb = __webpack_require__("RTKd");Object.defineProperty(exports, "__esModule", { value: !0 }), exports.default = initialize;function initialize() {
  var a = this;return new Promise(function (b, c) {
    if (a.isSupported()) {
      a.initialized = !0, a.getPermissionStatus = function () {
        return Notification.permission;
      };var d = window.indexedDB.open("q_wpn");d.onerror = function () {
        c(new Error("Could not open IndexedDB"));
      }, d.onupgradeneeded = function (b) {
        a.idb = b.target.result, a.idb.createObjectStore("webpush", { keyPath: "id" });
      }, d.onsuccess = function (d) {
        a.idb = d.target.result;var e = function e() {
          return a.getPushSubscription().then(function (d) {
            d ? (0, _idb.readFromIDB)(a.idb, "subscription").then(function (e) {
              e && e.endpoint === d.endpoint ? b(d) : d.unsubscribe().then(function () {
                a.requestPermission().then(b).catch(c);
              }).catch(c);
            }).catch(c) : "granted" === a.getPermissionStatus() ? a.requestPermission().then(b).catch(c) : b(d);
          }).catch(c);
        };a.swRegistration ? e() : navigator.serviceWorker.ready.then(function () {
          navigator.serviceWorker.getRegistration().then(function (b) {
            a.swRegistration = b, e();
          });
        });
      };
    } else c(new Error("Push notifications are not supported on this browser"));
  });
}

/***/ }),

/***/ "FnfM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("xIV9");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "G8y9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),

/***/ "GNhE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reduxActionAdAttributeChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reduxActionUpdateSelectedPack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reduxActionFeatureChange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");
/**
 * Redux action creators defined for JobsPostAdContainer
 *
 * Note : Kindly follow the naming convention of prefix 'reduxAction' to function names
 *
 * @author John Lukose <john.lukose@quikr.com>
 */



// Start : POST AD STEP 1 Action
var reduxActionAdAttributeChange = function reduxActionAdAttributeChange(attributes) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["f" /* JOBS_POST_AD_EVENTS */].AD_ATTRIBUTE_CHANGE,
    payload: attributes
  };
};

var reduxActionUpdateSelectedPack = function reduxActionUpdateSelectedPack(selectedPackDetails) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["f" /* JOBS_POST_AD_EVENTS */].UPDATE_PACK_SELECTED,
    payload: selectedPackDetails
  };
};

var reduxActionFeatureChange = function reduxActionFeatureChange(values) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["f" /* JOBS_POST_AD_EVENTS */].FEATURE_CHANGE,
    payload: values
  };
};
// End : POST AD STEP 1 Action

/***/ }),

/***/ "GnPc":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

!function (e, t) {
   true ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(e.reduxLogger = e.reduxLogger || {});
}(this, function (e) {
  "use strict";
  function t(e, t) {
    e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } });
  }function r(e, t) {
    Object.defineProperty(this, "kind", { value: e, enumerable: !0 }), t && t.length && Object.defineProperty(this, "path", { value: t, enumerable: !0 });
  }function n(e, t, r) {
    n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", { value: t, enumerable: !0 }), Object.defineProperty(this, "rhs", { value: r, enumerable: !0 });
  }function o(e, t) {
    o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", { value: t, enumerable: !0 });
  }function i(e, t) {
    i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", { value: t, enumerable: !0 });
  }function a(e, t, r) {
    a.super_.call(this, "A", e), Object.defineProperty(this, "index", { value: t, enumerable: !0 }), Object.defineProperty(this, "item", { value: r, enumerable: !0 });
  }function f(e, t, r) {
    var n = e.slice((r || t) + 1 || e.length);return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
  }function u(e) {
    var t = "undefined" == typeof e ? "undefined" : N(e);return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
  }function l(e, t, r, c, s, d, p) {
    s = s || [], p = p || [];var g = s.slice(0);if ("undefined" != typeof d) {
      if (c) {
        if ("function" == typeof c && c(g, d)) return;if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
          if (c.prefilter && c.prefilter(g, d)) return;if (c.normalize) {
            var h = c.normalize(g, d, e, t);h && (e = h[0], t = h[1]);
          }
        }
      }g.push(d);
    }"regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());var y = "undefined" == typeof e ? "undefined" : N(e),
        v = "undefined" == typeof t ? "undefined" : N(t),
        b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d),
        m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);if (!b && m) r(new o(g, t));else if (!m && b) r(new i(g, e));else if (u(e) !== u(t)) r(new n(g, e, t));else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));else if ("object" === y && null !== e && null !== t) {
      if (p.filter(function (t) {
        return t.lhs === e;
      }).length) e !== t && r(new n(g, e, t));else {
        if (p.push({ lhs: e, rhs: t }), Array.isArray(e)) {
          var w;e.length;for (w = 0; w < e.length; w++) {
            w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
          }for (; w < t.length;) {
            r(new a(g, w, new o(void 0, t[w++])));
          }
        } else {
          var x = Object.keys(e),
              S = Object.keys(t);x.forEach(function (n, o) {
            var i = S.indexOf(n);i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
          }), S.forEach(function (e) {
            l(void 0, t[e], r, c, g, e, p);
          });
        }p.length = p.length - 1;
      }
    } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
  }function c(e, t, r, n) {
    return n = n || [], l(e, t, function (e) {
      e && n.push(e);
    }, r), n.length ? n : void 0;
  }function s(e, t, r) {
    if (r.path && r.path.length) {
      var n,
          o = e[t],
          i = r.path.length - 1;for (n = 0; n < i; n++) {
        o = o[r.path[n]];
      }switch (r.kind) {case "A":
          s(o[r.path[n]], r.index, r.item);break;case "D":
          delete o[r.path[n]];break;case "E":case "N":
          o[r.path[n]] = r.rhs;}
    } else switch (r.kind) {case "A":
        s(e[t], r.index, r.item);break;case "D":
        e = f(e, t);break;case "E":case "N":
        e[t] = r.rhs;}return e;
  }function d(e, t, r) {
    if (e && t && r && r.kind) {
      for (var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;) {
        "undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
      }switch (r.kind) {case "A":
          s(r.path ? n[r.path[o]] : n, r.index, r.item);break;case "D":
          delete n[r.path[o]];break;case "E":case "N":
          n[r.path[o]] = r.rhs;}
    }
  }function p(e, t, r) {
    if (r.path && r.path.length) {
      var n,
          o = e[t],
          i = r.path.length - 1;for (n = 0; n < i; n++) {
        o = o[r.path[n]];
      }switch (r.kind) {case "A":
          p(o[r.path[n]], r.index, r.item);break;case "D":
          o[r.path[n]] = r.lhs;break;case "E":
          o[r.path[n]] = r.lhs;break;case "N":
          delete o[r.path[n]];}
    } else switch (r.kind) {case "A":
        p(e[t], r.index, r.item);break;case "D":
        e[t] = r.lhs;break;case "E":
        e[t] = r.lhs;break;case "N":
        e = f(e, t);}return e;
  }function g(e, t, r) {
    if (e && t && r && r.kind) {
      var n,
          o,
          i = e;for (o = r.path.length - 1, n = 0; n < o; n++) {
        "undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
      }switch (r.kind) {case "A":
          p(i[r.path[n]], r.index, r.item);break;case "D":
          i[r.path[n]] = r.lhs;break;case "E":
          i[r.path[n]] = r.lhs;break;case "N":
          delete i[r.path[n]];}
    }
  }function h(e, t, r) {
    if (e && t) {
      var n = function n(_n) {
        r && !r(e, t, _n) || d(e, t, _n);
      };l(e, t, n);
    }
  }function y(e) {
    return "color: " + F[e].color + "; font-weight: bold";
  }function v(e) {
    var t = e.kind,
        r = e.path,
        n = e.lhs,
        o = e.rhs,
        i = e.index,
        a = e.item;switch (t) {case "E":
        return [r.join("."), n, "→", o];case "N":
        return [r.join("."), o];case "D":
        return [r.join(".")];case "A":
        return [r.join(".") + "[" + i + "]", a];default:
        return [];}
  }function b(e, t, r, n) {
    var o = c(e, t);try {
      n ? r.groupCollapsed("diff") : r.group("diff");
    } catch (e) {
      r.log("diff");
    }o ? o.forEach(function (e) {
      var t = e.kind,
          n = v(e);r.log.apply(r, ["%c " + F[t].text, y(t)].concat(P(n)));
    }) : r.log("—— no diff ——");try {
      r.groupEnd();
    } catch (e) {
      r.log("—— diff end —— ");
    }
  }function m(e, t, r, n) {
    switch ("undefined" == typeof e ? "undefined" : N(e)) {case "object":
        return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];case "function":
        return e(t);default:
        return e;}
  }function w(e) {
    var t = e.timestamp,
        r = e.duration;return function (e, n, o) {
      var i = ["action"];return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
    };
  }function x(e, t) {
    var r = t.logger,
        n = t.actionTransformer,
        o = t.titleFormatter,
        i = void 0 === o ? w(t) : o,
        a = t.collapsed,
        f = t.colors,
        u = t.level,
        l = t.diff,
        c = "undefined" == typeof t.titleFormatter;e.forEach(function (o, s) {
      var d = o.started,
          p = o.startedTime,
          g = o.action,
          h = o.prevState,
          y = o.error,
          v = o.took,
          w = o.nextState,
          x = e[s + 1];x && (w = x.prevState, v = x.started - d);var S = n(g),
          k = "function" == typeof a ? a(function () {
        return w;
      }, g, o) : a,
          j = D(p),
          E = f.title ? "color: " + f.title(S) + ";" : "",
          A = ["color: gray; font-weight: lighter;"];A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");var O = i(S, j, v);try {
        k ? f.title && c ? r.groupCollapsed.apply(r, ["%c " + O].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, ["%c " + O].concat(A)) : r.group(O);
      } catch (e) {
        r.log(O);
      }var N = m(u, S, [h], "prevState"),
          P = m(u, S, [S], "action"),
          C = m(u, S, [y, h], "error"),
          F = m(u, S, [w], "nextState");if (N) if (f.prevState) {
        var L = "color: " + f.prevState(h) + "; font-weight: bold";r[N]("%c prev state", L, h);
      } else r[N]("prev state", h);if (P) if (f.action) {
        var T = "color: " + f.action(S) + "; font-weight: bold";r[P]("%c action    ", T, S);
      } else r[P]("action    ", S);if (y && C) if (f.error) {
        var M = "color: " + f.error(y, h) + "; font-weight: bold;";r[C]("%c error     ", M, y);
      } else r[C]("error     ", y);if (F) if (f.nextState) {
        var _ = "color: " + f.nextState(w) + "; font-weight: bold";r[F]("%c next state", _, w);
      } else r[F]("next state", w);l && b(h, w, r, k);try {
        r.groupEnd();
      } catch (e) {
        r.log("—— log end ——");
      }
    });
  }function S() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = _extends({}, L, e),
        r = t.logger,
        n = t.stateTransformer,
        o = t.errorTransformer,
        i = t.predicate,
        a = t.logErrors,
        f = t.diffPredicate;if ("undefined" == typeof r) return function () {
      return function (e) {
        return function (t) {
          return e(t);
        };
      };
    };if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function () {
      return function (e) {
        return function (t) {
          return e(t);
        };
      };
    };var u = [];return function (e) {
      var r = e.getState;return function (e) {
        return function (l) {
          if ("function" == typeof i && !i(r, l)) return e(l);var c = {};u.push(c), c.started = O.now(), c.startedTime = new Date(), c.prevState = n(r()), c.action = l;var s = void 0;if (a) try {
            s = e(l);
          } catch (e) {
            c.error = o(e);
          } else s = e(l);c.took = O.now() - c.started, c.nextState = n(r());var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;if (x(u, _extends({}, t, { diff: d })), u.length = 0, c.error) throw c.error;return s;
        };
      };
    };
  }var k,
      j,
      E = function E(e, t) {
    return new Array(t + 1).join(e);
  },
      A = function A(e, t) {
    return E("0", t - e.toString().length) + e;
  },
      D = function D(e) {
    return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
  },
      O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date,
      N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      P = function P(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }return r;
    }return Array.from(e);
  },
      C = [];k = "object" === ("undefined" == typeof global ? "undefined" : N(global)) && global ? global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function () {
    "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
  }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, { diff: { value: c, enumerable: !0 }, observableDiff: { value: l, enumerable: !0 }, applyDiff: { value: h, enumerable: !0 }, applyChange: { value: d, enumerable: !0 }, revertChange: { value: g, enumerable: !0 }, isConflict: { value: function value() {
        return "undefined" != typeof j;
      }, enumerable: !0 }, noConflict: { value: function value() {
        return C && (C.forEach(function (e) {
          e();
        }), C = null), c;
      }, enumerable: !0 } });var F = { E: { color: "#2196F3", text: "CHANGED:" }, N: { color: "#4CAF50", text: "ADDED:" }, D: { color: "#F44336", text: "DELETED:" }, A: { color: "#2196F3", text: "ARRAY:" } },
      L = { level: "log", logger: console, logErrors: !0, collapsed: void 0, predicate: void 0, duration: !1, timestamp: !0, stateTransformer: function stateTransformer(e) {
      return e;
    }, actionTransformer: function actionTransformer(e) {
      return e;
    }, errorTransformer: function errorTransformer(e) {
      return e;
    }, colors: { title: function title() {
        return "inherit";
      }, prevState: function prevState() {
        return "#9E9E9E";
      }, action: function action() {
        return "#03A9F4";
      }, nextState: function nextState() {
        return "#4CAF50";
      }, error: function error() {
        return "#F20404";
      } }, diff: !1, diffPredicate: void 0, transformer: void 0 },
      T = function T() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.dispatch,
        r = e.getState;return "function" == typeof t || "function" == typeof r ? S()({ dispatch: t, getState: r }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
  };e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", { value: !0 });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("HPUF")))

/***/ }),

/***/ "GoGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", { points: "14.6224146 4.92544493 13.5449735 3.84800385 9.23520924 8.15776816 4.92544493 3.84800385 3.84800385 4.92544493 8.15776816 9.23520924 3.84800385 13.5449735 4.92544493 14.6224146 9.23520924 10.3126503 13.5449735 14.6224146 14.6224146 13.5449735 10.3126503 9.23520924" });

var Close = function Close(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ viewBox: "0 0 20 20", "class": props.class },
		_ref
	);
};
/* harmony default export */ __webpack_exports__["a"] = (Close);

/***/ }),

/***/ "GthU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HBda":
/***/ (function(module, exports) {

module.exports = function (originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "HP3o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GA_ACCOUNT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GA_TRACKER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_PAGELOAD_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SNB_SCROLL_DOCUMENT_COUNT; });
/**
 * All GA events and Pageload with default options
 */

var GA_ACCOUNT_ID = 'UA-5568615-7';
var GA_TRACKER_NAME = 'quikrJobsPWAtracker';

var PAGE_LOAD = {
  applyinitiate: {
    page: '/applyinitiate',
    options: { type: 'vapapply' }
  },

  inlineapplyonadfrombrowse: {
    page: '/inlineapplyonadfrombrowse',
    options: {}
  },

  applyError: {
    page: '/Errorinapply',
    options: { step: 1 }
  },

  viewContact: {
    page: '/call',
    options: { step: 1 }
  },

  undoApply: {
    page: '/undo_apply',
    options: { step: 1 }
  },

  expressApplySuccess: {
    page: '/ExpressApply_Success',
    options: {}
  },

  expressApplyFailure: {
    page: '/expressapply_failure',
    options: {}
  },

  applySuccess: {
    page: '/apply',
    options: { step: 1 }
  },

  vapPageLoad: {
    page: 'view-ad',
    options: {}
  },

  snbPageLoad: {
    page: 'SnB',
    options: { type: 'browse' }
  },

  cityChangedInStepOne: {
    page: '/CandidateCurrentCityChangeFromStepOne',
    options: {}
  },

  cityChangedGAInUpdateApplication: {
    page: '/CandidateCurrentCityChange',
    options: {}
  },

  guaranteedJobPageView: {
    page: 'guaranteedJobPageView',
    options: {}
  },

  search: {
    page: 'search',
    options: { keyw: '' }
  },

  browse: {
    page: 'browse',
    options: {}
  },

  guaranteedJobAction: {
    page: 'guaranteedJobAction',
    options: {}
  },

  kotakThirdpartyAction: {
    page: 'KotakClick',
    options: {}
  },

  homePage: {
    page: 'Hp',
    options: { type: 'Tile', catname: 'Jobs', PageType: 'Candidate' }
  },

  papFreeAdLimit: {
    page: 'jobs_pap_step_one_response_ERROR_USER_DAILY_AD_LIMIT_EXCEEDED_ERROR',
    options: {}
  },

  papStep2Initiate: {
    page: 'PAP_step2_initiate',
    options: {}
  },

  papInitiate: {
    page: 'pap_initiate',
    options: {}
  },

  helloEnglish: {
    page: 'vap',
    options: { display_type: 'hello_english_recommended_score', PageType: 'Candidate' }
  },

  ampApplyError: {
    page: '/ampApplyError',
    options: {}
  },

  integration: {
    page: '/integrationFormSubmit',
    options: {}
  },

  applyFilter: {
    page: '/applyFilter',
    options: {}
  },

  campaignManager: {
    page: '/campaignManager',
    options: {}
  },

  applyWithoutEmail: {
    page: '/applyWithoutEmail',
    options: {}
  },

  pwaPAPWhatsappChatLinkClicked: {
    page: '/pwaPAPWhatsappChatLinkClicked',
    options: {}
  },

  profileRichnessForm: {
    page: '/profileRichness',
    options: {}
  },

  fullScreenBanner: {
    page: '/fullScreenBanner',
    options: {}
  },

  candidateTest: {
    page: '/candidateTest',
    options: {}
  },

  feedback: {
    page: '/feedback',
    options: {}
  },
  newPapInitiate: {
    page: 'new_pap_initiate',
    options: {}
  },
  papStep1Success: {
    page: 'new_pap_success',
    options: {}
  }
};

//All default options for page load GA's in Jobs Category
var DEFAULT_PAGELOAD_OPTIONS = {
  catname: 'Jobs',
  t73: 'JobsResponsiveUI',
  v73: 'True',
  Language: 'en',
  Pagetype: 'Candidate',
  pwaRequest: 1
};

var SNB_SCROLL_DOCUMENT_COUNT = 4;

/***/ }),

/***/ "HPUF":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "HQQY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.default = showGenericPreRequestModal;var _dom = __webpack_require__("fXy/"),
    _modalStyles = _interopRequireDefault(__webpack_require__("PUp1")),
    _notificationIcon = _interopRequireDefault(__webpack_require__("pTcH"));function _interopRequireDefault(a) {
  return a && a.__esModule ? a : { default: a };
}var state = {};function showGenericPreRequestModal() {
  var a = this,
      b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};return new Promise(function (c, d) {
    "undefined" != typeof document && a.initialized && "default" === a.getPermissionStatus() ? a.canTriggerCustomDialog().then(function () {
      if (!state.alreadyTriggered) {
        (0, _dom.appendModalStyles)(_modalStyles.default);var k = document.createElement("div");document.body.append(k), state.alreadyTriggered = !0, state.container = k;
      }if (!state.isOpen) {
        var e = b.classes,
            f = void 0 === e ? {} : e,
            g = state.container;g.className = "wpn_modal_container ".concat(f.container || "");var h = function h() {
          g.className = "", g.innerHTML = "", state.isOpen = !1, document.body.style.overflow = "";
        },
            i = function i(c) {
          a.pushToGA("custom", "block"), a.setIgnoredTimestamp(), b.onIgnore && "function" == typeof b.onIgnore && b.onIgnore(c), d(new Error("User denied the permission")), h();
        },
            j = document.createElement("div");j.className = "wpn_modal_backdrop", j.role = "presentation", j.addEventListener("click", function (a) {
          return i(a);
        });var l = document.createElement("div");l.className = "wpn_modal_modal", l.innerHTML = "<div class=\"wpn_modal_content\"><div>".concat(_notificationIcon.default, "</div><div class=\"wpn_modal_description ").concat(f.description || "", "\">").concat(b.description || "Would you like to allow Quikr to send notifications?", " <span>&#8377;").concat(b.qcash, " QCash</span></div></div>");var m = document.createElement("div");m.className = "wpn_modal_actionButtonsContainer";var n = (0, _dom.createActionButton)("NOT NOW");n.addEventListener("click", function (a) {
          return i(a);
        }), m.appendChild(n);var o = (0, _dom.createActionButton)("ALLOW");o.addEventListener("click", function (f) {
          a.pushToGA("custom", "allow"), b.onAllow && "function" == typeof b.onAllow && b.onAllow(f), a.requestPermission().then(c).catch(d), h();
        }), m.appendChild(o), l.appendChild(m), g.appendChild(j), g.appendChild(l), state.isOpen = !0, document.body.style.overflow = "hidden", a.pushToGA("custom", "impression", !1), setTimeout(function () {
          g.className += "wpn_modal_show";
        }, 100);
      }
    }).catch(d) : d(new Error("Failed to show custom popup"));
  });
}

/***/ }),

/***/ "HTqT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M70,14.9c-2.5,1.1-5.2,1.9-8,2.2c2.9-1.7,5.1-4.5,6.1-7.7c-2.7,1.6-5.7,2.8-8.9,3.4c-2.5-2.7-6.2-4.4-10.2-4.4c-7.7,0-14,6.2-14,14c0,1.1,0.1,2.2,0.4,3.2c-11.6-0.6-21.9-6.1-28.8-14.6c-1.2,2.1-1.9,4.5-1.9,7c0,4.8,2.5,9.1,6.2,11.6c-2.3-0.1-4.4-0.7-6.3-1.7V28c0,6.8,4.8,12.4,11.2,13.7c-1.2,0.3-2.4,0.5-3.7,0.5c-0.9,0-1.8-0.1-2.6-0.3c1.8,5.5,6.9,9.6,13,9.7c-4.8,3.7-10.8,6-17.3,6c-1.1,0-2.2-0.1-3.3-0.2c6.2,4,13.5,6.3,21.4,6.3c25.7,0,39.7-21.3,39.7-39.7c0-0.6,0-1.2,0-1.8C65.8,20.2,68.1,17.7,70,14.9z" });

var twitter = function twitter(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ id: "twitter", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};

/* harmony default export */ __webpack_exports__["a"] = (twitter);

/***/ }),

/***/ "Hm4v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("Vr6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Moving to Axios API since used across verticals
 */

var FetchHelper = function () {
  function FetchHelper() {
    _classCallCheck(this, FetchHelper);
  }

  /**
   * Returns a promise using axios
   * @param {*} method
   * @param {*} params
   */
  FetchHelper.prototype.request = function request(method, params) {
    var apiHeaders = {
      'Content-Type': params.isJson ? 'application/json' : 'application/x-www-form-urlencoded;charset=UTF-8'
    };
    params.params = params.params || {};
    if (params.cookies) {
      params.params['cookies'] = params.cookies;
    }

    var options = {
      method: method ? method : 'GET',
      url: params.url,
      headers: apiHeaders,
      params: params.params,
      withCredentials: params.includeCredentials ? params.includeCredentials : false
    };

    if (params.data) {
      options.data = params.data;
    }

    if (params.excludeHeader) {
      delete options.headers;
    }

    return this.apiCall(options);
  };

  /**
   * @param {*} options
   */


  FetchHelper.prototype.apiCall = function apiCall(options) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(options);
  };

  return FetchHelper;
}();



/***/ }),

/***/ "I0+G":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var classNames = function () {
		// don't inherit from Object so we can skip hasOwnProperty check later
		// http://stackoverflow.com/questions/15518328/creating-js-object-with-object-createnull#answer-21079232
		function StorageObject() {}
		StorageObject.prototype = Object.create(null);

		function _parseArray(resultSet, array) {
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				_parse(resultSet, array[i]);
			}
		}

		var hasOwn = {}.hasOwnProperty;

		function _parseNumber(resultSet, num) {
			resultSet[num] = true;
		}

		function _parseObject(resultSet, object) {
			if (object.toString !== Object.prototype.toString && !object.toString.toString().includes('[native code]')) {
				resultSet[object.toString()] = true;
				return;
			}

			for (var k in object) {
				if (hasOwn.call(object, k)) {
					// set value to false instead of deleting it to avoid changing object structure
					// https://www.smashingmagazine.com/2012/11/writing-fast-memory-efficient-javascript/#de-referencing-misconceptions
					resultSet[k] = !!object[k];
				}
			}
		}

		var SPACE = /\s+/;
		function _parseString(resultSet, str) {
			var array = str.split(SPACE);
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				resultSet[array[i]] = true;
			}
		}

		function _parse(resultSet, arg) {
			if (!arg) return;
			var argType = typeof arg;

			// 'foo bar'
			if (argType === 'string') {
				_parseString(resultSet, arg);

				// ['foo', 'bar', ...]
			} else if (Array.isArray(arg)) {
				_parseArray(resultSet, arg);

				// { 'foo': true, ... }
			} else if (argType === 'object') {
				_parseObject(resultSet, arg);

				// '130'
			} else if (argType === 'number') {
				_parseNumber(resultSet, arg);
			}
		}

		function _classNames() {
			// don't leak arguments
			// https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
			var len = arguments.length;
			var args = Array(len);
			for (var i = 0; i < len; i++) {
				args[i] = arguments[i];
			}

			var classSet = new StorageObject();
			_parseArray(classSet, args);

			var list = [];

			for (var k in classSet) {
				if (classSet[k]) {
					list.push(k);
				}
			}

			return list.join(' ');
		}

		return _classNames;
	}();

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "I2hN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),

/***/ "ICuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_pfetch__ = __webpack_require__("rqos");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_cityChangeHelper__ = __webpack_require__("AUOp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src__ = __webpack_require__("eKXM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_universal_cookie__ = __webpack_require__("5aIp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_universal_cookie__);







var escrowCategoriesMap = {
    'home-lifestyle': 40,
    'electronics-appliances': 247,
    'mobiles-tablets': 269
};

var logoHref = '/bazaar';

var searchCityCallbackForCategory = function searchCityCallbackForCategory(cityId, cityName, globalId, match) {
    cityId = cityId * 1;
    cityName = cityName.toLowerCase();
    var isAllIndia = cityId === 0 || cityId === 1;
    var pageUrl = match.url;
    var matches = pageUrl.match(/[gId|cId](\d+)/);
    var gIdMatches = pageUrl.match(/gId(\d+)/);
    var gId = gIdMatches && gIdMatches.length ? 1 * gIdMatches[1] : 0;
    var catId = gId ? 0 : 1 * matches[1];

    Object(__WEBPACK_IMPORTED_MODULE_2__common_cityChangeHelper__["a" /* getCitySpecificCategoryId */])(cityId, gId, catId).then(function (categoryId) {
        var slugParams = match.params.slug.split('+');
        var slugParamsLength = slugParams.length;
        if (isAllIndia) {
            if (slugParamsLength === 1) {
                slugParams[0] = 'gId' + escrowCategoriesMap[match.params.type];
            } else {
                slugParams[slugParamsLength - 2] = 'gId' + escrowCategoriesMap[match.params.type];
                slugParams.splice(slugParamsLength - 1, 1);
            }
        } else {
            if (slugParamsLength === 1) {
                slugParams[0] = cityName;
                slugParams[1] = 'cId' + categoryId;
            } else {
                slugParams[slugParamsLength - 2] = cityName;
                slugParams[slugParamsLength - 1] = 'cId' + categoryId;
            }
        }
        window.location.href = window.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + window.location.search;
    }).catch(function (err) {
        console.log(err);
    });
};

var searchCityCallbackForSnb = function searchCityCallbackForSnb(cityId, cityName, globalId, match) {
    cityId = cityId * 1;
    var isAllIndia = cityId === 0 || cityId === 1;
    var pageUrl = match.url;
    var matches = pageUrl.match(/[w|x|y|z](\d+)([a-zA-Z]+)/);
    var gIdMatches = pageUrl.match(/[y|z](\d+)([a-zA-Z]+)/);
    var gId = gIdMatches && gIdMatches.length ? 1 * gIdMatches[1] : 0;
    var catId = gId ? 0 : 1 * matches[1];

    Object(__WEBPACK_IMPORTED_MODULE_2__common_cityChangeHelper__["a" /* getCitySpecificCategoryId */])(cityId, gId, catId).then(function (categoryId) {
        var searchMatches = pageUrl.match(/(x|z)(\d+)/);
        var isSearchUrl = searchMatches && searchMatches.length;
        var slugParams = match.params.slug.split('+');
        var slugParamsLength = slugParams.length;
        if (isAllIndia) {
            slugParams[slugParamsLength - 1] = (isSearchUrl ? 'z' : 'y') + categoryId + matches[2];
            slugParams[slugParamsLength - 2] = 'India';
        } else {
            slugParams[slugParamsLength - 1] = (isSearchUrl ? 'x' : 'w') + categoryId + matches[2];
            slugParams[slugParamsLength - 2] = cityName;
        }
        window.location.href = window.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + window.location.search;
    }).catch(function (err) {
        console.log(err);
    });
};

var searchCityCallbackForCertified = function searchCityCallbackForCertified(cityId, cityName, globalId, match) {
    cityId = cityId * 1;
    var isAllIndia = cityId === 0 || cityId === 1;

    var slugParams = match.params.slug.split('+');
    var slugParamsLength = slugParams.length;
    if (slugParamsLength) {
        if (isAllIndia) {
            if (slugParamsLength > 1) {
                slugParams.splice(slugParamsLength - 1, 1);
            }
        } else {
            if (slugParamsLength > 1) {
                slugParams[slugParamsLength - 1] = cityName.toLowerCase();
            } else {
                slugParams[slugParamsLength] = cityName.toLowerCase();
            }
        }
    }
    window.location.href = window.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + window.location.search;
};

var searchCityCallbackForAssured = function searchCityCallbackForAssured(cityId, cityName, globalId, match) {
    cityId = cityId * 1;
    var isAllIndia = cityId === 0 || cityId === 1;

    var slugParams = match.params.slug.split('+');
    var slugParamsLength = slugParams.length;
    if (slugParamsLength) {
        if (isAllIndia) {
            if (slugParamsLength > 1) {
                slugParams.splice(slugParamsLength - 1, 1);
            }
        } else {
            if (slugParamsLength > 1) {
                slugParams[slugParamsLength - 1] = cityName.toLowerCase();
            } else {
                slugParams[slugParamsLength] = cityName.toLowerCase();
            }
        }
    }
    window.location.href = window.location.origin + '/' + slugParams.join('+') + window.location.search;
};

var searchCityCallbackForBazaar = function searchCityCallbackForBazaar(cityId, cityName, globalId, match) {
    window.location.reload();
};

var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "svg",
    { viewBox: "0 0 162.5 180.9", fill: "#17AA4A", style: "width: 1.5rem;margin-right: 0.5rem;" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { opacity: "0.15", fill: "#17AA4A", d: "M91.2,171c-3.5,1.5-7.1,2.8-10.9,4C-6.8,145.4,4.9,57.1,7,44.7L81.6,6.3l8.7,4.6L15.8,50.2 C15.8,50.2,0.1,141.5,91.2,171z" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { fill: "17AA4A", d: "M161,43.6C161,43.5,161,43.5,161,43.6l-0.2-1.4L82.3,0.4L81.7,0L81,0.4L2,40.9l-0.2,1.3 C1.5,43.3-18,147.8,79,180.5l1.3,0.4l1.3-0.4c20.3-6.5,37.2-16.8,50.1-30.4c3.2-3.4,6.1-7,8.8-10.7c7.5-10.5,13.1-22.5,16.8-35.8 C165.9,72.8,161.4,45.7,161,43.6z M152,102c-4.8,17.3-13,32.2-24.3,44.2c-6,6.3-12.8,11.9-20.5,16.6c-3.5,2.1-7.1,4.1-11,5.9l0,0 c-1.6,0.8-3.3,1.5-4.9,2.2c-3.5,1.5-7.2,2.8-10.9,4C-6.8,145.4,4.9,57.1,7,44.7L81.6,6.3l8.7,4.6l65.3,34.8 C156.5,51.6,159.3,75.7,152,102z M104.9,122.5l17.2,0.1l-3.6,16.5L99.2,139c-5.4,0-12.7-0.9-17-8.4l-6.5-11.3 c-2.6-4.1-2.4-4.9-7-5.2c-5.1-0.3-10.8-1-14-2.2c-7.8-3.1-14.1-9-14.9-19.6c-0.2-2.7-0.1-5.5,0.2-8.5c0.4-3.4,1.3-7.4,2.1-10.7 c2.3-8.9,5.3-16,10.9-21.3c7.1-6.8,17.1-9.4,26.6-9.6c3.7-0.1,10.2,0.1,15.5,0.9c11.7,1.7,20.4,8.6,21.4,21.1c1,12-3.9,32-13,40.6 c-2,1.9-4.3,3.5-6.8,4.8l-4.5-7.9c-1.8-3-3.5-4.9-5.3-6.1c2.9-1.8,4.9-4.5,6.6-8.2c1.9-4.3,4.5-14.5,3.9-19.3 c-0.5-5.3-4-9.5-12.4-10.1c-3.7-0.2-7.5,0-11,0.9c-3.2,0.8-5.9,2.2-7.8,4c-4.5,4.2-7.5,14.9-8,21c-0.3,4.2,0.3,7.5,1.8,9.7 c2.7,4,6.9,4.4,11.2,4.4h3.2c5.1,0,9.4,0.6,13.7,8.1l5.5,9.7C96.7,120.9,97.3,122.4,104.9,122.5z" })
);

var qgAssuredSearchUI = function qgAssuredSearchUI(text, callbackfun) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        { "class": "qg_assured-search", onclick: callbackfun, style: "background-color: #fff;color: #333;display: flex;align-items: center;border-bottom: 1px solid rgb(220, 220, 220);padding: 0.8125rem 0.9375rem;" },
        _ref,
        text
    );
};

var qgAssuredCallbackFunc = function qgAssuredCallbackFunc() {
    if (typeof window.gdGlobalFunForAssuredSearch === 'function') {
        gdGlobalFunForAssuredSearch();
    }
};

var customSearchForBazaar = function customSearchForBazaar() {
    var _ui = qgAssuredSearchUI('Quikr Assured Products', qgAssuredCallbackFunc);
    return _ui;
};

var customSearchForCategory = function customSearchForCategory() {
    var _path = location.pathname.split('/')[1];
    var text = '';
    if (_path === 'home-lifestyle' && (location.search == '?filter=fd' || location.search == '?filter=hl') || _path === 'electronics-appliances') {

        if (_path === 'home-lifestyle') {
            text = 'Explore Quikr Assured Furniture';
        } else if (_path === 'electronics-appliances') {
            text = 'Explore Quikr Assured Electronics';
        }

        var _ui = qgAssuredSearchUI(text, qgAssuredCallbackFunc);
        return _ui;
    }
};

var vapBack = function vapBack(e, history, match) {
    var _backURL = window.vapCustomBackURL ? window.vapCustomBackURL : '/bazaar';
    if ('referrer' in document) {
        var referrer = document.referrer;
        var isQuikrUrl = referrer ? referrer.search(/\.quikr.com\//) : -1;

        if (isQuikrUrl !== -1) {
            history.goBack();
        } else {
            location.href = _backURL;
        }
    } else {
        location.href = _backURL;
    }
};

function getJKID() {
    var cookies = new __WEBPACK_IMPORTED_MODULE_4_universal_cookie___default.a();
    var jkidCookie = cookies.get('_jk_id') && cookies.get('_jk_id').split('.');
    return jkidCookie && jkidCookie[0];
}

function getCurrentCityId() {
    var cookies = new __WEBPACK_IMPORTED_MODULE_4_universal_cookie___default.a();
    var cityCookie = cookies.get('prefer_city_id') || '1';
    return cityCookie;
}

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "span",
    null,
    "Quikr Experience Zone"
);

var exampleConfig = [{
    route: { path: '/bazaar/bazaar-experience-zones', exact: true },
    header: {
        show: false,
        hasLogo: false,
        back: false,
        toolbarItems: false,
        hasTitle: false,
        hamburger: false,
        CustomTitle: function CustomTitle() {
            return _ref2;
        }
    },
    pageType: 'warehouse',
    footer: { show: false },

    qrum: function qrum(location, match) {
        var city = getCurrentCityId();
        var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src___default()('GOODS_WAREHOUSE_PWA'), CITY: city, JKID: getJKID() };
        return config;
    }
}, {
    route: { path: '/bazaar/exchange-old-for-new-through-quikr', exact: true },
    header: { show: false },
    footer: { show: false }
}, {
    route: { path: '/:type(home-lifestyle|electronics-appliances|mobiles-tablets)/:slug(.*[cId|gId][\\d]+)', exact: true }, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
    header: {
        show: true,
        hasTitle: true,
        logoHref: logoHref,
        searchCityCallback: searchCityCallbackForCategory,
        marketTalkButton: true
    },
    pageType: 'category',
    search: { show: true, placeholder: 'Please enter keyword', searchSuggestions: customSearchForCategory, showDefaultSuggestion: true },
    footer: { show: true },
    ga: { trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.type;
        }
        var city = getCurrentCityId();
        var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src___default()('GOODS_CATEGORY_PWA'), CAT: category, CITY: city, JKID: getJKID() };
        return config;
    }
}, {
    route: { path: '/:type(home-lifestyle|electronics-appliances|mobiles-tablets)/:slug(.*[w|x|y|z][\\d]+f.*)', exact: true }, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
    header: {
        show: true,
        hasTitle: true,
        logoHref: logoHref,
        searchCityCallback: searchCityCallbackForSnb,
        category: 'goods',
        gaPageType: 'SnB',
        viewinAppFAB: true,
        qkrAppWidget: true,
        marketTalkButton: true
    },
    pageType: 'Snb',
    search: { show: true, placeholder: 'Please enter keyword' },
    footer: { show: true },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.type;
        }
        var city = getCurrentCityId();
        var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src___default()('GOODS_SNB_PWA'), CAT: category, CITY: city, JKID: getJKID() };
        return config;
    },
    ga: { trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7' }
}, {
    route: { path: '/:type(home-lifestyle|electronics-appliances|mobiles-tablets)/:slug(.*W0QQAdIdZ[\\d]+)', exact: true },
    header: {
        show: true,
        hasTitle: false,
        logoHref: logoHref,
        hamburger: false,
        back: true,
        toolbarItems: false,
        handleBackClick: vapBack,
        walletIcon: true
    },
    pageType: 'VAP',
    search: { show: false },
    footer: { show: true },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            //console.log(match.params,1);
            category = match && match.params && match.params.type;
        }
        var city = getCurrentCityId();
        var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src___default()('GOODS_VAP_PWA'), CAT: category, CITY: city, JKID: getJKID() };
        return config;
    },
    ga: { trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7' }
}, {
    route: {
        path: '/:type(bazaar|electronics-appliances)/:slug([certified-refurbished-products|refurbished-electronics].*)',
        exact: true
    },
    header: {
        show: true,
        hasTitle: true,
        logoHref: logoHref,
        marketTalkButton: true,
        searchCityCallback: searchCityCallbackForCertified
    },
    pageType: 'certified',
    search: { show: true, placeholder: 'Please enter keyword' },
    footer: { show: true },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            //console.log(match.params,1);
            category = match && match.params && match.params.type;
        }
        var city = getCurrentCityId();
        var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src___default()('GOODS_CERTIFIED_PWA'), CAT: category, CITY: city, JKID: getJKID() };
        return config;
    },
    ga: { trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7' }
}, {
    route: { path: '/:slug(quikr-assured-products.*)', exact: true },
    header: {
        show: true,
        hasTitle: true,
        searchCityCallback: searchCityCallbackForAssured
    },
    pageType: 'certified',
    search: { show: true, placeholder: 'Please enter keyword' },
    footer: { show: true },
    qrum: function qrum(location, match) {
        var city = getCurrentCityId();
        var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src___default()('COMMON_ASSURED_PWA'), CITY: city, JKID: getJKID() };
        return config;
    },
    ga: { trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7' }
}, {
    route: {
        path: '/:type(bazaar)',
        exact: true
    }, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
    header: {
        show: true,
        hasTitle: true,
        logoHref: logoHref,
        marketTalkButton: true,
        searchCityCallback: searchCityCallbackForBazaar
    },
    pageType: 'bazaar',
    search: { show: true, placeholder: 'Please enter keyword', searchSuggestions: customSearchForBazaar, showDefaultSuggestion: true },
    footer: { show: true },
    qrum: function qrum(location, match) {
        var city = getCurrentCityId();
        var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src___default()('GOODS_BAZAAR_PWA'), CITY: city, JKID: getJKID() };
        console.log(config, 123);
        return config;
    },
    ga: { trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7' }
}, {
    route: {
        path: '/:type(bazaar|escrow)',
        exact: false
    }, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
    header: { show: true, logoHref: logoHref, marketTalkButton: true },
    search: { show: true, placeholder: 'Please enter keyword' },
    footer: { show: true },
    qrum: function qrum(location, match) {
        var city = getCurrentCityId();
        var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_3_rum_pagetypes_src___default()('GOODS_BAZAAR_PWA'), CITY: city, JKID: getJKID() };
        return config;
    },
    ga: { trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7' }
}];

/* harmony default export */ __webpack_exports__["a"] = (exampleConfig);

/***/ }),

/***/ "IHAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util_namespaceObject = {};
__webpack_require__.d(util_namespaceObject, "getTransformPropertyName", function() { return getTransformPropertyName; });
__webpack_require__.d(util_namespaceObject, "clamp", function() { return clamp; });
__webpack_require__.d(util_namespaceObject, "bezierProgress", function() { return bezierProgress; });

// CONCATENATED MODULE: ../@material/menu/util.js
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @type {string|undefined} */
var storedTransformPropertyName_ = void 0;

/**
 * Returns the name of the correct transform property to use on the current browser.
 * @param {!Window} globalObj
 * @param {boolean=} forceRefresh
 * @return {string}
 */
function getTransformPropertyName(globalObj) {
  var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (storedTransformPropertyName_ === undefined || forceRefresh) {
    var el = globalObj.document.createElement('div');
    var transformPropertyName = 'transform' in el.style ? 'transform' : 'webkitTransform';
    storedTransformPropertyName_ = transformPropertyName;
  }

  return storedTransformPropertyName_;
}

/**
 * Clamps a value between the minimum and the maximum, returning the clamped value.
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  return Math.min(max, Math.max(min, value));
}

/**
 * Returns the easing value to apply at time t, for a given cubic bezier curve.
 * Control points P0 and P3 are assumed to be (0,0) and (1,1), respectively.
 * Parameters are as follows:
 * - time: The current time in the animation, scaled between 0 and 1.
 * - x1: The x value of control point P1.
 * - y1: The y value of control point P1.
 * - x2: The x value of control point P2.
 * - y2: The y value of control point P2.
 * @param {number} time
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @return {number}
 */
function bezierProgress(time, x1, y1, x2, y2) {
  return getBezierCoordinate_(solvePositionFromXValue_(time, x1, x2), y1, y2);
}

/**
 * Compute a single coordinate at a position point between 0 and 1.
 * c1 and c2 are the matching coordinate on control points P1 and P2, respectively.
 * Control points P0 and P3 are assumed to be (0,0) and (1,1), respectively.
 * Adapted from https://github.com/google/closure-library/blob/master/closure/goog/math/bezier.js.
 * @param {number} t
 * @param {number} c1
 * @param {number} c2
 * @return {number}
 */
function getBezierCoordinate_(t, c1, c2) {
  // Special case start and end.
  if (t === 0 || t === 1) {
    return t;
  }

  // Step one - from 4 points to 3
  var ic0 = t * c1;
  var ic1 = c1 + t * (c2 - c1);
  var ic2 = c2 + t * (1 - c2);

  // Step two - from 3 points to 2
  ic0 += t * (ic1 - ic0);
  ic1 += t * (ic2 - ic1);

  // Final step - last point
  return ic0 + t * (ic1 - ic0);
}

/**
 * Project a point onto the Bezier curve, from a given X. Calculates the position t along the curve.
 * Adapted from https://github.com/google/closure-library/blob/master/closure/goog/math/bezier.js.
 * @param {number} xVal
 * @param {number} x1
 * @param {number} x2
 * @return {number}
 */
function solvePositionFromXValue_(xVal, x1, x2) {
  var EPSILON = 1e-6;
  var MAX_ITERATIONS = 8;

  if (xVal <= 0) {
    return 0;
  } else if (xVal >= 1) {
    return 1;
  }

  // Initial estimate of t using linear interpolation.
  var t = xVal;

  // Try gradient descent to solve for t. If it works, it is very fast.
  var tMin = 0;
  var tMax = 1;
  var value = 0;
  for (var i = 0; i < MAX_ITERATIONS; i++) {
    value = getBezierCoordinate_(t, x1, x2);
    var derivative = (getBezierCoordinate_(t + EPSILON, x1, x2) - value) / EPSILON;
    if (Math.abs(value - xVal) < EPSILON) {
      return t;
    } else if (Math.abs(derivative) < EPSILON) {
      break;
    } else {
      if (value < xVal) {
        tMin = t;
      } else {
        tMax = t;
      }
      t -= (value - xVal) / derivative;
    }
  }

  // If the gradient descent got stuck in a local minimum, e.g. because
  // the derivative was close to 0, use a Dichotomy refinement instead.
  // We limit the number of interations to 8.
  for (var _i = 0; Math.abs(value - xVal) > EPSILON && _i < MAX_ITERATIONS; _i++) {
    if (value < xVal) {
      tMin = t;
      t = (t + tMax) / 2;
    } else {
      tMax = t;
      t = (t + tMin) / 2;
    }
    value = getBezierCoordinate_(t, x1, x2);
  }
  return t;
}


// EXTERNAL MODULE: ../@material/base/component.js
var component = __webpack_require__("xJR0");

// EXTERNAL MODULE: ../@material/base/foundation.js
var foundation = __webpack_require__("/X9I");

// CONCATENATED MODULE: ../@material/menu/simple/adapter.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @license
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* eslint no-unused-vars: [2, {"args": "none"}] */

/**
 * Adapter for MDC Simple Menu. Provides an interface for managing
 * - classes
 * - dom
 * - focus
 * - position
 * - dimensions
 * - event handlers
 *
 * Additionally, provides type information for the adapter to the Closure
 * compiler.
 *
 * Implement this adapter for your framework of choice to delegate updates to
 * the component in your framework of choice. See architecture documentation
 * for more details.
 * https://github.com/material-components/material-components-web/blob/master/docs/architecture.md
 *
 * @record
 */
var MDCSimpleMenuAdapter = function () {
  function MDCSimpleMenuAdapter() {
    _classCallCheck(this, MDCSimpleMenuAdapter);
  }

  /** @param {string} className */
  MDCSimpleMenuAdapter.prototype.addClass = function addClass(className) {};

  /** @param {string} className */


  MDCSimpleMenuAdapter.prototype.removeClass = function removeClass(className) {};

  /**
   * @param {string} className
   * @return {boolean}
   */


  MDCSimpleMenuAdapter.prototype.hasClass = function hasClass(className) {};

  /** @return {boolean} */


  MDCSimpleMenuAdapter.prototype.hasNecessaryDom = function hasNecessaryDom() {};

  /**
   * @param {EventTarget} target
   * @param {string} attributeName
   * @return {string}
   */


  MDCSimpleMenuAdapter.prototype.getAttributeForEventTarget = function getAttributeForEventTarget(target, attributeName) {};

  /** @return {{ width: number, height: number }} */


  MDCSimpleMenuAdapter.prototype.getInnerDimensions = function getInnerDimensions() {};

  /** @return {boolean} */


  MDCSimpleMenuAdapter.prototype.hasAnchor = function hasAnchor() {};

  /** @return {{width: number, height: number, top: number, right: number, bottom: number, left: number}} */


  MDCSimpleMenuAdapter.prototype.getAnchorDimensions = function getAnchorDimensions() {};

  /** @return {{ width: number, height: number }} */


  MDCSimpleMenuAdapter.prototype.getWindowDimensions = function getWindowDimensions() {};

  /**
   * @param {number} x
   * @param {number} y
   */


  MDCSimpleMenuAdapter.prototype.setScale = function setScale(x, y) {};

  /**
   * @param {number} x
   * @param {number} y
   */


  MDCSimpleMenuAdapter.prototype.setInnerScale = function setInnerScale(x, y) {};

  /** @return {number} */


  MDCSimpleMenuAdapter.prototype.getNumberOfItems = function getNumberOfItems() {};

  /**
   * @param {string} type
   * @param {function(!Event)} handler
   */


  MDCSimpleMenuAdapter.prototype.registerInteractionHandler = function registerInteractionHandler(type, handler) {};

  /**
   * @param {string} type
   * @param {function(!Event)} handler
   */


  MDCSimpleMenuAdapter.prototype.deregisterInteractionHandler = function deregisterInteractionHandler(type, handler) {};

  /** @param {function(!Event)} handler */


  MDCSimpleMenuAdapter.prototype.registerBodyClickHandler = function registerBodyClickHandler(handler) {};

  /** @param {function(!Event)} handler */


  MDCSimpleMenuAdapter.prototype.deregisterBodyClickHandler = function deregisterBodyClickHandler(handler) {};

  /**
   * @param {number} index
   * @return {{top: number, height: number}}
   */


  MDCSimpleMenuAdapter.prototype.getYParamsForItemAtIndex = function getYParamsForItemAtIndex(index) {};

  /**
   * @param {number} index
   * @param {string|null} value
   */


  MDCSimpleMenuAdapter.prototype.setTransitionDelayForItemAtIndex = function setTransitionDelayForItemAtIndex(index, value) {};

  /**
   * @param {EventTarget} target
   * @return {number}
   */


  MDCSimpleMenuAdapter.prototype.getIndexForEventTarget = function getIndexForEventTarget(target) {};

  /** @param {{index: number}} evtData */


  MDCSimpleMenuAdapter.prototype.notifySelected = function notifySelected(evtData) {};

  MDCSimpleMenuAdapter.prototype.notifyCancel = function notifyCancel() {};

  MDCSimpleMenuAdapter.prototype.saveFocus = function saveFocus() {};

  MDCSimpleMenuAdapter.prototype.restoreFocus = function restoreFocus() {};

  /** @return {boolean} */


  MDCSimpleMenuAdapter.prototype.isFocused = function isFocused() {};

  MDCSimpleMenuAdapter.prototype.focus = function focus() {};

  /** @return {number} */


  MDCSimpleMenuAdapter.prototype.getFocusedItemIndex = function getFocusedItemIndex() /* number */{};

  /** @param {number} index */


  MDCSimpleMenuAdapter.prototype.focusItemAtIndex = function focusItemAtIndex(index) {};

  /** @return {boolean} */


  MDCSimpleMenuAdapter.prototype.isRtl = function isRtl() {};

  /** @param {string} origin */


  MDCSimpleMenuAdapter.prototype.setTransformOrigin = function setTransformOrigin(origin) {};

  /** @param {{
  *   top: (string|undefined),
  *   right: (string|undefined),
  *   bottom: (string|undefined),
  *   left: (string|undefined)
  * }} position */


  MDCSimpleMenuAdapter.prototype.setPosition = function setPosition(position) {};

  /** @return {number} */


  MDCSimpleMenuAdapter.prototype.getAccurateTime = function getAccurateTime() {};

  return MDCSimpleMenuAdapter;
}();

/* harmony default export */ var adapter = (MDCSimpleMenuAdapter);
// CONCATENATED MODULE: ../@material/menu/simple/constants.js
/**
 * @license
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @enum {string} */
var cssClasses = {
  ROOT: 'mdc-simple-menu',
  OPEN: 'mdc-simple-menu--open',
  ANIMATING: 'mdc-simple-menu--animating',
  TOP_RIGHT: 'mdc-simple-menu--open-from-top-right',
  BOTTOM_LEFT: 'mdc-simple-menu--open-from-bottom-left',
  BOTTOM_RIGHT: 'mdc-simple-menu--open-from-bottom-right'
};

/** @enum {string} */
var strings = {
  ITEMS_SELECTOR: '.mdc-simple-menu__items',
  SELECTED_EVENT: 'MDCSimpleMenu:selected',
  CANCEL_EVENT: 'MDCSimpleMenu:cancel',
  ARIA_DISABLED_ATTR: 'aria-disabled'
};

/** @enum {number} */
var numbers = {
  // Amount of time to wait before triggering a selected event on the menu. Note that this time
  // will most likely be bumped up once interactive lists are supported to allow for the ripple to
  // animate before closing the menu
  SELECTED_TRIGGER_DELAY: 50,
  // Total duration of the menu animation.
  TRANSITION_DURATION_MS: 300,
  // The menu starts its open animation with the X axis at this time value (0 - 1).
  TRANSITION_SCALE_ADJUSTMENT_X: 0.5,
  // The time value the menu waits until the animation starts on the Y axis (0 - 1).
  TRANSITION_SCALE_ADJUSTMENT_Y: 0.2,
  // The cubic bezier control points for the animation (cubic-bezier(0, 0, 0.2, 1)).
  TRANSITION_X1: 0,
  TRANSITION_Y1: 0,
  TRANSITION_X2: 0.2,
  TRANSITION_Y2: 1
};


// CONCATENATED MODULE: ../@material/menu/simple/foundation.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function foundation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @license
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/**
 * @extends {MDCFoundation<!MDCSimpleMenuAdapter>}
 */

var foundation_MDCSimpleMenuFoundation = function (_MDCFoundation) {
  _inherits(MDCSimpleMenuFoundation, _MDCFoundation);

  _createClass(MDCSimpleMenuFoundation, null, [{
    key: 'cssClasses',

    /** @return enum{cssClasses} */
    get: function get() {
      return cssClasses;
    }

    /** @return enum{strings} */

  }, {
    key: 'strings',
    get: function get() {
      return strings;
    }

    /** @return enum{numbers} */

  }, {
    key: 'numbers',
    get: function get() {
      return numbers;
    }

    /**
     * {@see MDCSimpleMenuAdapter} for typing information on parameters and return
     * types.
     * @return {!MDCSimpleMenuAdapter}
     */

  }, {
    key: 'defaultAdapter',
    get: function get() {
      return (/** @type {!MDCSimpleMenuAdapter} */{
          addClass: function addClass() {},
          removeClass: function removeClass() {},
          hasClass: function hasClass() {
            return false;
          },
          hasNecessaryDom: function hasNecessaryDom() {
            return false;
          },
          getAttributeForEventTarget: function getAttributeForEventTarget() {},
          getInnerDimensions: function getInnerDimensions() {
            return {};
          },
          hasAnchor: function hasAnchor() {
            return false;
          },
          getAnchorDimensions: function getAnchorDimensions() {
            return {};
          },
          getWindowDimensions: function getWindowDimensions() {
            return {};
          },
          setScale: function setScale() {},
          setInnerScale: function setInnerScale() {},
          getNumberOfItems: function getNumberOfItems() {
            return 0;
          },
          registerInteractionHandler: function registerInteractionHandler() {},
          deregisterInteractionHandler: function deregisterInteractionHandler() {},
          registerBodyClickHandler: function registerBodyClickHandler() {},
          deregisterBodyClickHandler: function deregisterBodyClickHandler() {},
          getYParamsForItemAtIndex: function getYParamsForItemAtIndex() {
            return {};
          },
          setTransitionDelayForItemAtIndex: function setTransitionDelayForItemAtIndex() {},
          getIndexForEventTarget: function getIndexForEventTarget() {
            return 0;
          },
          notifySelected: function notifySelected() {},
          notifyCancel: function notifyCancel() {},
          saveFocus: function saveFocus() {},
          restoreFocus: function restoreFocus() {},
          isFocused: function isFocused() {
            return false;
          },
          focus: function focus() {},
          getFocusedItemIndex: function getFocusedItemIndex() {
            return -1;
          },
          focusItemAtIndex: function focusItemAtIndex() {},
          isRtl: function isRtl() {
            return false;
          },
          setTransformOrigin: function setTransformOrigin() {},
          setPosition: function setPosition() {},
          getAccurateTime: function getAccurateTime() {
            return 0;
          }
        }
      );
    }

    /** @param {!MDCSimpleMenuAdapter} adapter */

  }]);

  function MDCSimpleMenuFoundation(adapter) {
    foundation__classCallCheck(this, MDCSimpleMenuFoundation);

    /** @private {function(!Event)} */
    var _this = _possibleConstructorReturn(this, _MDCFoundation.call(this, _extends(MDCSimpleMenuFoundation.defaultAdapter, adapter)));

    _this.clickHandler_ = function (evt) {
      return _this.handlePossibleSelected_(evt);
    };
    /** @private {function(!Event)} */
    _this.keydownHandler_ = function (evt) {
      return _this.handleKeyboardDown_(evt);
    };
    /** @private {function(!Event)} */
    _this.keyupHandler_ = function (evt) {
      return _this.handleKeyboardUp_(evt);
    };
    /** @private {function(!Event)} */
    _this.documentClickHandler_ = function (evt) {
      _this.adapter_.notifyCancel();
      _this.close(evt);
    };
    /** @private {boolean} */
    _this.isOpen_ = false;
    /** @private {number} */
    _this.startScaleX_ = 0;
    /** @private {number} */
    _this.startScaleY_ = 0;
    /** @private {number} */
    _this.targetScale_ = 1;
    /** @private {number} */
    _this.scaleX_ = 0;
    /** @private {number} */
    _this.scaleY_ = 0;
    /** @private {boolean} */
    _this.running_ = false;
    /** @private {number} */
    _this.selectedTriggerTimerId_ = 0;
    /** @private {number} */
    _this.animationRequestId_ = 0;
    /** @private {!{ width: number, height: number }} */
    _this.dimensions_;
    /** @private {number} */
    _this.startTime_;
    /** @private {number} */
    _this.itemHeight_;
    return _this;
  }

  MDCSimpleMenuFoundation.prototype.init = function init() {
    var _MDCSimpleMenuFoundat = MDCSimpleMenuFoundation.cssClasses,
        ROOT = _MDCSimpleMenuFoundat.ROOT,
        OPEN = _MDCSimpleMenuFoundat.OPEN;


    if (!this.adapter_.hasClass(ROOT)) {
      throw new Error(ROOT + ' class required in root element.');
    }

    if (!this.adapter_.hasNecessaryDom()) {
      throw new Error('Required DOM nodes missing in ' + ROOT + ' component.');
    }

    if (this.adapter_.hasClass(OPEN)) {
      this.isOpen_ = true;
    }

    this.adapter_.registerInteractionHandler('click', this.clickHandler_);
    this.adapter_.registerInteractionHandler('keyup', this.keyupHandler_);
    this.adapter_.registerInteractionHandler('keydown', this.keydownHandler_);
  };

  MDCSimpleMenuFoundation.prototype.destroy = function destroy() {
    clearTimeout(this.selectedTriggerTimerId_);
    // Cancel any currently running animations.
    cancelAnimationFrame(this.animationRequestId_);
    this.adapter_.deregisterInteractionHandler('click', this.clickHandler_);
    this.adapter_.deregisterInteractionHandler('keyup', this.keyupHandler_);
    this.adapter_.deregisterInteractionHandler('keydown', this.keydownHandler_);
    this.adapter_.deregisterBodyClickHandler(this.documentClickHandler_);
  };

  /**
   * Calculates transition delays for individual menu items, so that they fade in one at a time.
   * @private
   */


  MDCSimpleMenuFoundation.prototype.applyTransitionDelays_ = function applyTransitionDelays_() {
    var _MDCSimpleMenuFoundat2 = MDCSimpleMenuFoundation.cssClasses,
        BOTTOM_LEFT = _MDCSimpleMenuFoundat2.BOTTOM_LEFT,
        BOTTOM_RIGHT = _MDCSimpleMenuFoundat2.BOTTOM_RIGHT;

    var numItems = this.adapter_.getNumberOfItems();
    var height = this.dimensions_.height;

    var transitionDuration = MDCSimpleMenuFoundation.numbers.TRANSITION_DURATION_MS / 1000;
    var start = MDCSimpleMenuFoundation.numbers.TRANSITION_SCALE_ADJUSTMENT_Y;

    for (var index = 0; index < numItems; index++) {
      var _adapter_$getYParamsF = this.adapter_.getYParamsForItemAtIndex(index),
          itemTop = _adapter_$getYParamsF.top,
          itemHeight = _adapter_$getYParamsF.height;

      this.itemHeight_ = itemHeight;
      var itemDelayFraction = itemTop / height;
      if (this.adapter_.hasClass(BOTTOM_LEFT) || this.adapter_.hasClass(BOTTOM_RIGHT)) {
        itemDelayFraction = (height - itemTop - itemHeight) / height;
      }
      var itemDelay = (start + itemDelayFraction * (1 - start)) * transitionDuration;
      // Use toFixed() here to normalize CSS unit precision across browsers
      this.adapter_.setTransitionDelayForItemAtIndex(index, itemDelay.toFixed(3) + 's');
    }
  };

  /**
   * Removes transition delays from menu items.
   * @private
   */


  MDCSimpleMenuFoundation.prototype.removeTransitionDelays_ = function removeTransitionDelays_() {
    var numItems = this.adapter_.getNumberOfItems();
    for (var i = 0; i < numItems; i++) {
      this.adapter_.setTransitionDelayForItemAtIndex(i, null);
    }
  };

  /**
   * Animates menu opening or closing.
   * @private
   */


  MDCSimpleMenuFoundation.prototype.animationLoop_ = function animationLoop_() {
    var _this2 = this;

    var time = this.adapter_.getAccurateTime();
    var _MDCSimpleMenuFoundat3 = MDCSimpleMenuFoundation.numbers,
        TRANSITION_DURATION_MS = _MDCSimpleMenuFoundat3.TRANSITION_DURATION_MS,
        TRANSITION_X1 = _MDCSimpleMenuFoundat3.TRANSITION_X1,
        TRANSITION_Y1 = _MDCSimpleMenuFoundat3.TRANSITION_Y1,
        TRANSITION_X2 = _MDCSimpleMenuFoundat3.TRANSITION_X2,
        TRANSITION_Y2 = _MDCSimpleMenuFoundat3.TRANSITION_Y2,
        TRANSITION_SCALE_ADJUSTMENT_X = _MDCSimpleMenuFoundat3.TRANSITION_SCALE_ADJUSTMENT_X,
        TRANSITION_SCALE_ADJUSTMENT_Y = _MDCSimpleMenuFoundat3.TRANSITION_SCALE_ADJUSTMENT_Y;

    var currentTime = clamp((time - this.startTime_) / TRANSITION_DURATION_MS);

    // Animate X axis very slowly, so that only the Y axis animation is visible during fade-out.
    var currentTimeX = clamp((currentTime - TRANSITION_SCALE_ADJUSTMENT_X) / (1 - TRANSITION_SCALE_ADJUSTMENT_X));
    // No time-shifting on the Y axis when closing.
    var currentTimeY = currentTime;

    var startScaleY = this.startScaleY_;
    if (this.targetScale_ === 1) {
      // Start with the menu at the height of a single item.
      if (this.itemHeight_) {
        startScaleY = Math.max(this.itemHeight_ / this.dimensions_.height, startScaleY);
      }
      // X axis moves faster, so time-shift forward.
      currentTimeX = clamp(currentTime + TRANSITION_SCALE_ADJUSTMENT_X);
      // Y axis moves slower, so time-shift backwards and adjust speed by the difference.
      currentTimeY = clamp((currentTime - TRANSITION_SCALE_ADJUSTMENT_Y) / (1 - TRANSITION_SCALE_ADJUSTMENT_Y));
    }

    // Apply cubic bezier easing independently to each axis.
    var easeX = bezierProgress(currentTimeX, TRANSITION_X1, TRANSITION_Y1, TRANSITION_X2, TRANSITION_Y2);
    var easeY = bezierProgress(currentTimeY, TRANSITION_X1, TRANSITION_Y1, TRANSITION_X2, TRANSITION_Y2);

    // Calculate the scales to apply to the outer container and inner container.
    this.scaleX_ = this.startScaleX_ + (this.targetScale_ - this.startScaleX_) * easeX;
    var invScaleX = 1 / (this.scaleX_ === 0 ? 1 : this.scaleX_);
    this.scaleY_ = startScaleY + (this.targetScale_ - startScaleY) * easeY;
    var invScaleY = 1 / (this.scaleY_ === 0 ? 1 : this.scaleY_);

    // Apply scales.
    this.adapter_.setScale(this.scaleX_, this.scaleY_);
    this.adapter_.setInnerScale(invScaleX, invScaleY);

    // Stop animation when we've covered the entire 0 - 1 range of time.
    if (currentTime < 1) {
      this.animationRequestId_ = requestAnimationFrame(function () {
        return _this2.animationLoop_();
      });
    } else {
      this.animationRequestId_ = 0;
      this.running_ = false;
      this.adapter_.removeClass(MDCSimpleMenuFoundation.cssClasses.ANIMATING);
    }
  };

  /**
   * Starts the open or close animation.
   * @private
   */


  MDCSimpleMenuFoundation.prototype.animateMenu_ = function animateMenu_() {
    var _this3 = this;

    this.startTime_ = this.adapter_.getAccurateTime();
    this.startScaleX_ = this.scaleX_;
    this.startScaleY_ = this.scaleY_;

    this.targetScale_ = this.isOpen_ ? 1 : 0;

    if (!this.running_) {
      this.running_ = true;
      this.animationRequestId_ = requestAnimationFrame(function () {
        return _this3.animationLoop_();
      });
    }
  };

  /**
   * @param {?number} focusIndex
   * @private
   */


  MDCSimpleMenuFoundation.prototype.focusOnOpen_ = function focusOnOpen_(focusIndex) {
    if (focusIndex === null) {
      // First, try focusing the menu.
      this.adapter_.focus();
      // If that doesn't work, focus first item instead.
      if (!this.adapter_.isFocused()) {
        this.adapter_.focusItemAtIndex(0);
      }
    } else {
      this.adapter_.focusItemAtIndex(focusIndex);
    }
  };

  /**
   * Handle keys that we want to repeat on hold (tab and arrows).
   * @param {!Event} evt
   * @return {boolean}
   * @private
   */


  MDCSimpleMenuFoundation.prototype.handleKeyboardDown_ = function handleKeyboardDown_(evt) {
    // Do nothing if Alt, Ctrl or Meta are pressed.
    if (evt.altKey || evt.ctrlKey || evt.metaKey) {
      return true;
    }

    var keyCode = evt.keyCode,
        key = evt.key,
        shiftKey = evt.shiftKey;

    var isTab = key === 'Tab' || keyCode === 9;
    var isArrowUp = key === 'ArrowUp' || keyCode === 38;
    var isArrowDown = key === 'ArrowDown' || keyCode === 40;
    var isSpace = key === 'Space' || keyCode === 32;

    var focusedItemIndex = this.adapter_.getFocusedItemIndex();
    var lastItemIndex = this.adapter_.getNumberOfItems() - 1;

    if (shiftKey && isTab && focusedItemIndex === 0) {
      this.adapter_.focusItemAtIndex(lastItemIndex);
      evt.preventDefault();
      return false;
    }

    if (!shiftKey && isTab && focusedItemIndex === lastItemIndex) {
      this.adapter_.focusItemAtIndex(0);
      evt.preventDefault();
      return false;
    }

    // Ensure Arrow{Up,Down} and space do not cause inadvertent scrolling
    if (isArrowUp || isArrowDown || isSpace) {
      evt.preventDefault();
    }

    if (isArrowUp) {
      if (focusedItemIndex === 0 || this.adapter_.isFocused()) {
        this.adapter_.focusItemAtIndex(lastItemIndex);
      } else {
        this.adapter_.focusItemAtIndex(focusedItemIndex - 1);
      }
    } else if (isArrowDown) {
      if (focusedItemIndex === lastItemIndex || this.adapter_.isFocused()) {
        this.adapter_.focusItemAtIndex(0);
      } else {
        this.adapter_.focusItemAtIndex(focusedItemIndex + 1);
      }
    }

    return true;
  };

  /**
   * Handle keys that we don't want to repeat on hold (Enter, Space, Escape).
   * @param {!Event} evt
   * @return {boolean}
   * @private
   */


  MDCSimpleMenuFoundation.prototype.handleKeyboardUp_ = function handleKeyboardUp_(evt) {
    // Do nothing if Alt, Ctrl or Meta are pressed.
    if (evt.altKey || evt.ctrlKey || evt.metaKey) {
      return true;
    }

    var keyCode = evt.keyCode,
        key = evt.key;

    var isEnter = key === 'Enter' || keyCode === 13;
    var isSpace = key === 'Space' || keyCode === 32;
    var isEscape = key === 'Escape' || keyCode === 27;

    if (isEnter || isSpace) {
      this.handlePossibleSelected_(evt);
    }

    if (isEscape) {
      this.adapter_.notifyCancel();
      this.close();
    }

    return true;
  };

  /**
   * @param {!Event} evt
   * @private
   */


  MDCSimpleMenuFoundation.prototype.handlePossibleSelected_ = function handlePossibleSelected_(evt) {
    var _this4 = this;

    if (this.adapter_.getAttributeForEventTarget(evt.target, strings.ARIA_DISABLED_ATTR) === 'true') {
      return;
    }
    var targetIndex = this.adapter_.getIndexForEventTarget(evt.target);
    if (targetIndex < 0) {
      return;
    }
    // Debounce multiple selections
    if (this.selectedTriggerTimerId_) {
      return;
    }
    this.selectedTriggerTimerId_ = setTimeout(function () {
      _this4.selectedTriggerTimerId_ = 0;
      _this4.close();
      _this4.adapter_.notifySelected({ index: targetIndex });
    }, numbers.SELECTED_TRIGGER_DELAY);
  };

  /** @private */


  MDCSimpleMenuFoundation.prototype.autoPosition_ = function autoPosition_() {
    var _position;

    if (!this.adapter_.hasAnchor()) {
      return;
    }

    // Defaults: open from the top left.
    var vertical = 'top';
    var horizontal = 'left';

    var anchor = this.adapter_.getAnchorDimensions();
    var windowDimensions = this.adapter_.getWindowDimensions();

    var topOverflow = anchor.top + this.dimensions_.height - windowDimensions.height;
    var bottomOverflow = this.dimensions_.height - anchor.bottom;
    var extendsBeyondTopBounds = topOverflow > 0;

    if (extendsBeyondTopBounds) {
      if (bottomOverflow < topOverflow) {
        vertical = 'bottom';
      }
    }

    var leftOverflow = anchor.left + this.dimensions_.width - windowDimensions.width;
    var rightOverflow = this.dimensions_.width - anchor.right;
    var extendsBeyondLeftBounds = leftOverflow > 0;
    var extendsBeyondRightBounds = rightOverflow > 0;

    if (this.adapter_.isRtl()) {
      // In RTL, we prefer to open from the right.
      horizontal = 'right';
      if (extendsBeyondRightBounds && leftOverflow < rightOverflow) {
        horizontal = 'left';
      }
    } else if (extendsBeyondLeftBounds && rightOverflow < leftOverflow) {
      horizontal = 'right';
    }

    var position = (_position = {}, _position[horizontal] = '0', _position[vertical] = '0', _position);

    this.adapter_.setTransformOrigin(vertical + ' ' + horizontal);
    this.adapter_.setPosition(position);
  };

  /**
   * Open the menu.
   * @param {{focusIndex: ?number}=} options
   */


  MDCSimpleMenuFoundation.prototype.open = function open() {
    var _this5 = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$focusIndex = _ref.focusIndex,
        focusIndex = _ref$focusIndex === undefined ? null : _ref$focusIndex;

    this.adapter_.saveFocus();
    this.adapter_.addClass(MDCSimpleMenuFoundation.cssClasses.ANIMATING);
    this.animationRequestId_ = requestAnimationFrame(function () {
      _this5.dimensions_ = _this5.adapter_.getInnerDimensions();
      _this5.applyTransitionDelays_();
      _this5.autoPosition_();
      _this5.animateMenu_();
      _this5.adapter_.addClass(MDCSimpleMenuFoundation.cssClasses.OPEN);
      _this5.focusOnOpen_(focusIndex);
      _this5.adapter_.registerBodyClickHandler(_this5.documentClickHandler_);
    });
    this.isOpen_ = true;
  };

  /**
   * Closes the menu.
   * @param {Event=} evt
   */


  MDCSimpleMenuFoundation.prototype.close = function close() {
    var _this6 = this;

    var evt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var targetIsDisabled = evt ? this.adapter_.getAttributeForEventTarget(evt.target, strings.ARIA_DISABLED_ATTR) === 'true' : false;

    if (targetIsDisabled) {
      return;
    }

    this.adapter_.deregisterBodyClickHandler(this.documentClickHandler_);
    this.adapter_.addClass(MDCSimpleMenuFoundation.cssClasses.ANIMATING);
    requestAnimationFrame(function () {
      _this6.removeTransitionDelays_();
      _this6.animateMenu_();
      _this6.adapter_.removeClass(MDCSimpleMenuFoundation.cssClasses.OPEN);
    });
    this.isOpen_ = false;
    this.adapter_.restoreFocus();
  };

  /** @return {boolean} */


  MDCSimpleMenuFoundation.prototype.isOpen = function isOpen() {
    return this.isOpen_;
  };

  return MDCSimpleMenuFoundation;
}(foundation["a" /* default */]);

/* harmony default export */ var simple_foundation = (foundation_MDCSimpleMenuFoundation);
// CONCATENATED MODULE: ../@material/menu/simple/index.js
var simple__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function simple__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function simple__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function simple__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @license
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/**
 * @extends MDCComponent<!MDCSimpleMenuFoundation>
 */

var simple_MDCSimpleMenu = function (_MDCComponent) {
  simple__inherits(MDCSimpleMenu, _MDCComponent);

  /** @param {...?} args */
  function MDCSimpleMenu() {
    simple__classCallCheck(this, MDCSimpleMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    /** @private {!Element} */
    var _this = simple__possibleConstructorReturn(this, _MDCComponent.call.apply(_MDCComponent, [this].concat(args)));

    _this.previousFocus_;
    return _this;
  }

  /**
   * @param {!Element} root
   * @return {!MDCSimpleMenu}
   */


  MDCSimpleMenu.attachTo = function attachTo(root) {
    return new MDCSimpleMenu(root);
  };

  /** @return {boolean} */


  /** @param {{focusIndex: ?number}=} options */
  MDCSimpleMenu.prototype.show = function show() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$focusIndex = _ref.focusIndex,
        focusIndex = _ref$focusIndex === undefined ? null : _ref$focusIndex;

    this.foundation_.open({ focusIndex: focusIndex });
  };

  MDCSimpleMenu.prototype.hide = function hide() {
    this.foundation_.close();
  };

  /**
   * Return the item container element inside the component.
   * @return {?Element}
   */


  /** @return {!MDCSimpleMenuFoundation} */
  MDCSimpleMenu.prototype.getDefaultFoundation = function getDefaultFoundation() {
    var _this2 = this;

    return new simple_foundation({
      addClass: function addClass(className) {
        return _this2.root_.classList.add(className);
      },
      removeClass: function removeClass(className) {
        return _this2.root_.classList.remove(className);
      },
      hasClass: function hasClass(className) {
        return _this2.root_.classList.contains(className);
      },
      hasNecessaryDom: function hasNecessaryDom() {
        return Boolean(_this2.itemsContainer_);
      },
      getAttributeForEventTarget: function getAttributeForEventTarget(target, attributeName) {
        return target.getAttribute(attributeName);
      },
      getInnerDimensions: function getInnerDimensions() {
        var itemsContainer = _this2.itemsContainer_;

        return { width: itemsContainer.offsetWidth, height: itemsContainer.offsetHeight };
      },
      hasAnchor: function hasAnchor() {
        return _this2.root_.parentElement && _this2.root_.parentElement.classList.contains('mdc-menu-anchor');
      },
      getAnchorDimensions: function getAnchorDimensions() {
        return _this2.root_.parentElement.getBoundingClientRect();
      },
      getWindowDimensions: function getWindowDimensions() {
        return { width: window.innerWidth, height: window.innerHeight };
      },
      setScale: function setScale(x, y) {
        _this2.root_.style[getTransformPropertyName(window)] = 'scale(' + x + ', ' + y + ')';
      },
      setInnerScale: function setInnerScale(x, y) {
        _this2.itemsContainer_.style[getTransformPropertyName(window)] = 'scale(' + x + ', ' + y + ')';
      },
      getNumberOfItems: function getNumberOfItems() {
        return _this2.items.length;
      },
      registerInteractionHandler: function registerInteractionHandler(type, handler) {
        return _this2.root_.addEventListener(type, handler);
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(type, handler) {
        return _this2.root_.removeEventListener(type, handler);
      },
      registerBodyClickHandler: function registerBodyClickHandler(handler) {
        return document.body.addEventListener('click', handler);
      },
      deregisterBodyClickHandler: function deregisterBodyClickHandler(handler) {
        return document.body.removeEventListener('click', handler);
      },
      getYParamsForItemAtIndex: function getYParamsForItemAtIndex(index) {
        var _items$index = _this2.items[index],
            top = _items$index.offsetTop,
            height = _items$index.offsetHeight;

        return { top: top, height: height };
      },
      setTransitionDelayForItemAtIndex: function setTransitionDelayForItemAtIndex(index, value) {
        return _this2.items[index].style.setProperty('transition-delay', value);
      },
      getIndexForEventTarget: function getIndexForEventTarget(target) {
        return _this2.items.indexOf(target);
      },
      notifySelected: function notifySelected(evtData) {
        return _this2.emit(simple_foundation.strings.SELECTED_EVENT, {
          index: evtData.index,
          item: _this2.items[evtData.index]
        });
      },
      notifyCancel: function notifyCancel() {
        return _this2.emit(simple_foundation.strings.CANCEL_EVENT, {});
      },
      saveFocus: function saveFocus() {
        _this2.previousFocus_ = document.activeElement;
      },
      restoreFocus: function restoreFocus() {
        if (_this2.previousFocus_) {
          _this2.previousFocus_.focus();
        }
      },
      isFocused: function isFocused() {
        return document.activeElement === _this2.root_;
      },
      focus: function focus() {
        return _this2.root_.focus();
      },
      getFocusedItemIndex: function getFocusedItemIndex() {
        return _this2.items.indexOf(document.activeElement);
      },
      focusItemAtIndex: function focusItemAtIndex(index) {
        return _this2.items[index].focus();
      },
      isRtl: function isRtl() {
        return getComputedStyle(_this2.root_).getPropertyValue('direction') === 'rtl';
      },
      setTransformOrigin: function setTransformOrigin(origin) {
        _this2.root_.style[getTransformPropertyName(window) + '-origin'] = origin;
      },
      setPosition: function setPosition(position) {
        _this2.root_.style.left = 'left' in position ? position.left : null;
        _this2.root_.style.right = 'right' in position ? position.right : null;
        _this2.root_.style.top = 'top' in position ? position.top : null;
        _this2.root_.style.bottom = 'bottom' in position ? position.bottom : null;
      },
      getAccurateTime: function getAccurateTime() {
        return window.performance.now();
      }
    });
  };

  simple__createClass(MDCSimpleMenu, [{
    key: 'open',
    get: function get() {
      return this.foundation_.isOpen();
    }

    /** @param {boolean} value */
    ,
    set: function set(value) {
      if (value) {
        this.foundation_.open();
      } else {
        this.foundation_.close();
      }
    }
  }, {
    key: 'itemsContainer_',
    get: function get() {
      return this.root_.querySelector(simple_foundation.strings.ITEMS_SELECTOR);
    }

    /**
     * Return the items within the menu. Note that this only contains the set of elements within
     * the items container that are proper list items, and not supplemental / presentational DOM
     * elements.
     * @return {!Array<!Element>}
     */

  }, {
    key: 'items',
    get: function get() {
      var itemsContainer = this.itemsContainer_;

      return [].slice.call(itemsContainer.querySelectorAll('.mdc-list-item[role]'));
    }
  }]);

  return MDCSimpleMenu;
}(component["a" /* default */]);


// CONCATENATED MODULE: ../@material/menu/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return simple_MDCSimpleMenu; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return simple_foundation; });
/* unused concated harmony import util */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return util_namespaceObject; });
/**
 * @license
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/***/ }),

/***/ "IPuT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");
var bind = __webpack_require__("6X2+");
var Axios = __webpack_require__("1j7S");
var defaults = __webpack_require__("UXCT");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("G8y9");
axios.CancelToken = __webpack_require__("ygIO");
axios.isCancel = __webpack_require__("DyZn");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("+t08");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),

/***/ "IyPV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

module.exports = typeof self === 'object' && self.self === self && self || typeof global === 'object' && global.global === global && global || this;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("HPUF")))

/***/ }),

/***/ "J5Lc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ "JI39":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JJ8B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.hasDocumentCookie = hasDocumentCookie;
exports.cleanCookies = cleanCookies;
// Can we get/set cookies on document.cookie?

function hasDocumentCookie() {
  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
}

//backwards compatibility
var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();

function cleanCookies() {
  document.cookie.split(';').forEach(function (c) {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
}

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_plugin_forked_dual_import_importCss_js__ = __webpack_require__("QHaY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_plugin_forked_dual_import_importCss_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_plugin_forked_dual_import_importCss_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("stbB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_loadable__ = __webpack_require__("EDt3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group__ = __webpack_require__("jvbI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_q_core_src_shellConfig__ = __webpack_require__("o4Mi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_q_cars_src_shellConfig__ = __webpack_require__("Wnb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_q_goods_src_shellConfig__ = __webpack_require__("ICuJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_q_monetization_src_shellConfig__ = __webpack_require__("85P6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_q_jobs_src_shellConfig__ = __webpack_require__("p5EL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_q_components_components_shell__ = __webpack_require__("lL3/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_scss__ = __webpack_require__("3hZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_scss__);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















__webpack_require__("QFZf");
// import qLoader from './resources/qLoader.gif';

// render(<App />, document.getElementById('reactContainer'));

var preloadedState = void 0;
if (typeof window !== 'undefined') {
    preloadedState = window.__PRELOADED_STATE__;
}

var carsShellConfig = preloadedState && preloadedState.isMobile ? __WEBPACK_IMPORTED_MODULE_6_q_cars_src_shellConfig__["b" /* shellConfig */] : __WEBPACK_IMPORTED_MODULE_6_q_cars_src_shellConfig__["a" /* desktopShellConfig */];

var mergedConfig = [].concat(__WEBPACK_IMPORTED_MODULE_8_q_monetization_src_shellConfig__["a" /* default */], carsShellConfig, __WEBPACK_IMPORTED_MODULE_7_q_goods_src_shellConfig__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_q_jobs_src_shellConfig__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_q_core_src_shellConfig__["a" /* default */]);

var _ref = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('div', { 'class': 'q-loader' });

var LoadableCoreApp = __WEBPACK_IMPORTED_MODULE_3_react_loadable___default()({
    loader: function loader() {
        return Promise.all([__webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "eTlp")), __WEBPACK_IMPORTED_MODULE_0_babel_plugin_forked_dual_import_importCss_js___default()('q-core/src')]).then(function (proms) {
            return proms[0];
        });
    },
    loading: function loading() {
        return _ref;
    },
    render: function render(loaded, props) {
        var CoreApp = loaded.default;
        return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(CoreApp, props);
    }
});

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('div', { 'class': 'q-loader' });

var LoadableCarsApp = __WEBPACK_IMPORTED_MODULE_3_react_loadable___default()({
    loader: function loader() {
        return Promise.all([__webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "7xld")), __WEBPACK_IMPORTED_MODULE_0_babel_plugin_forked_dual_import_importCss_js___default()('q-cars/src')]).then(function (proms) {
            return proms[0];
        });
    },
    loading: function loading() {
        return _ref2;
    },
    render: function render(loaded, props) {
        var CarsApp = loaded.default;
        return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(CarsApp, props);
    }
});

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('div', { 'class': 'q-loader' });

var LoadableGoodsApp = __WEBPACK_IMPORTED_MODULE_3_react_loadable___default()({
    loader: function loader() {
        return Promise.all([__webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "vq1i")), __WEBPACK_IMPORTED_MODULE_0_babel_plugin_forked_dual_import_importCss_js___default()('q-goods/src/index')]).then(function (proms) {
            return proms[0];
        });
    },
    loading: function loading() {
        return _ref3;
    },
    render: function render(loaded, props) {
        var GoodsApp = loaded.default;
        return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(GoodsApp, props);
    }
});

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('div', { 'class': 'q-loader' });

var LoadableMonetizationApp = __WEBPACK_IMPORTED_MODULE_3_react_loadable___default()({
    loader: function loader() {
        return Promise.all([__webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "mmAT")), __WEBPACK_IMPORTED_MODULE_0_babel_plugin_forked_dual_import_importCss_js___default()('q-monetization/src/index')]).then(function (proms) {
            return proms[0];
        });
    },
    loading: function loading() {
        return _ref4;
    },
    render: function render(loaded, props) {
        var MonetizationApp = loaded.default;
        return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(MonetizationApp, props);
    }
});

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('div', { 'class': 'q-loader' });

var LoadableJobsApp = __WEBPACK_IMPORTED_MODULE_3_react_loadable___default()({
    loader: function loader() {
        return Promise.all([__webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "kR4T")), __WEBPACK_IMPORTED_MODULE_0_babel_plugin_forked_dual_import_importCss_js___default()('q-jobs/src/index')]).then(function (proms) {
            return proms[0];
        });
    },
    loading: function loading() {
        return _ref5;
    },
    render: function render(loaded, props) {
        var JobsApp = loaded.default;
        return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(JobsApp, props);
    }
});

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],
    null,
    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],
        { path: '/(securepaymentpage|wallet|giftcards|giftcard/details|giftcard/categories)' },
        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(LoadableMonetizationApp, null)
        )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],
        { path: '/(cars|cars-bikes|bikes-scooters|commercial-vehicles)' },
        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(LoadableCarsApp, null)
        )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],
        { path: '/(home-lifestyle|electronics-appliances|mobiles-tablets|escrow|bazaar|quikr-assured-products.*)' },
        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(LoadableGoodsApp, null)
        )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],
        { path: '/jobs' },
        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(LoadableJobsApp, null)
        )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],
        { path: '/MyChats' },
        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(LoadableCoreApp, null)
        )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],
        { path: '/(pets|entertainment|events|matrimonial)' },
        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(LoadableCoreApp, null)
        )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],
        { path: '/post-classifieds-ads' },
        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(LoadableCoreApp, null)
        )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],
        { path: '/PostAd/' },
        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(LoadableCoreApp, null)
        )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],
        { path: '/:cityName?' },
        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(LoadableCoreApp, null)
        )
    )
);

var QuikrApp = function (_Component) {
    _inherits(QuikrApp, _Component);

    function QuikrApp(props) {
        _classCallCheck(this, QuikrApp);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleOnline = function () {
            _this.setState({
                isOnline: true
            });
        };

        _this.handleOffline = function () {
            _this.setState({
                isOnline: false
            });
        };

        _this.state = { isOnline: true };
        return _this;
    }

    QuikrApp.prototype.componentDidMount = function componentDidMount() {
        this.setState({
            isOnline: navigator.onLine
        });
        window.addEventListener('offline', this.handleOffline);
        window.addEventListener('online', this.handleOnline);
    };

    QuikrApp.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('online', this.handleOnline);
        window.removeEventListener('offline', this.handleOffline);
    };

    QuikrApp.prototype.render = function render(props, state) {
        var url = props.url;
        var isDesktop = props.isDesktop;
        var isOnline = state.isOnline;

        return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
            'div',
            { 'class': 'app ' + (isOnline ? 'online' : 'offline') },
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
                __WEBPACK_IMPORTED_MODULE_10_q_components_components_shell__["a" /* default */],
                { config: mergedConfig, location: url, isDesktop: isDesktop },
                Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
                    'div',
                    { 'class': 'app-router' },
                    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
                        __WEBPACK_IMPORTED_MODULE_4_react_transition_group__["TransitionGroup"],
                        null,
                        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
                            __WEBPACK_IMPORTED_MODULE_4_react_transition_group__["CSSTransition"],
                            { key: url, classNames: 'fade', timeout: 300 },
                            _ref6
                        )
                    )
                )
            )
        );
    };

    return QuikrApp;
}(__WEBPACK_IMPORTED_MODULE_1_preact__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (QuikrApp);

/***/ }),

/***/ "KAG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HOME_PAGE_LINK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return POSTAD_PAGE_LINK; });
/* unused harmony export UPGRADE_AD_PAGE_LINK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECRUITMENT_ASSIST_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GUARANTEEDJOBS_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HIRE_LANDING_PAGE_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANDIATE_TEST_PAGE_LINK; });
var HOME_PAGE_LINK = '/jobs';

var POSTAD_PAGE_LINK = '/jobs/post-ad-jobs';

var UPGRADE_AD_PAGE_LINK = '/jobs/upgrade-ad-jobs';

var RECRUITMENT_ASSIST_LINK = '/jobs/vip-landing';

var GUARANTEEDJOBS_LINK = '/jobs/guaranteed-job';

var HIRE_LANDING_PAGE_LINK = '/jobs/hire';

var CANDIATE_TEST_PAGE_LINK = '/jobs/candidate-test';

/***/ }),

/***/ "KIDv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/supports-webp 1.0.7 */


var canvas = typeof document === 'object' ? document.createElement('canvas') : {};
canvas.width = canvas.height = 1;
var index = canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;

module.exports = index;

/***/ }),

/***/ "KvVG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MediaQuery = function (_Component) {
	_inherits(MediaQuery, _Component);

	function MediaQuery(props) {
		_classCallCheck(this, MediaQuery);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.shouldRender = function () {
			var render = false;
			var mounted = _this.state.mounted;
			var _this$props = _this.props,
			    minWidth = _this$props.minWidth,
			    maxWidth = _this$props.maxWidth;
			var screenWidth = _this.state.screenWidth;

			if (!mounted) {
				screenWidth = _this.context.screenWidth;
			}

			if (minWidth && maxWidth) {
				render = screenWidth >= minWidth && _this.screenWidth < maxWidth;
			} else if (minWidth) {
				render = screenWidth >= minWidth;
			} else {
				render = screenWidth < maxWidth;
			}
			return render;
		};

		_this.state = {
			screenWidth: 0,
			deviceWidth: 0,
			mounted: false
		};
		return _this;
	}

	MediaQuery.prototype.componentDidMount = function componentDidMount() {
		if (window.innerWidth) {
			this.setState({
				screenWidth: window.innerWidth,
				deviceWidth: window.innerWidth * window.devicePixelRatio,
				mounted: true
			});
		}
	};

	MediaQuery.prototype.render = function render() {
		var _state = this.state,
		    mounted = _state.mounted,
		    screenWidth = _state.screenWidth;
		var _props = this.props,
		    minWidth = _props.minWidth,
		    maxWidth = _props.maxWidth;
		var className = this.props.className;

		var render = this.shouldRender();

		return render ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ className: className },
			this.props.children
		) : null;
	};

	return MediaQuery;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "L8bY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M26.6,15.7v9.7h-7.1v11.9h7.1V70h14.7V37.3h9.8c0,0,0.9-5.7,1.4-12H41.4v-8.1c0-1.2,1.6-2.8,3.2-2.8h8V2H41.7C26.3,2,26.6,13.9,26.6,15.7z" });

var facebookIcon = function facebookIcon(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ id: "facebook", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};

/* harmony default export */ __webpack_exports__["a"] = (facebookIcon);

/***/ }),

/***/ "LU+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEventTrackGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setPageView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pushAnalyticsEvent; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getEventTrackGA = function getEventTrackGA(obj) {

	if (typeof obj !== 'undefined' && typeof ga !== 'undefined') {

		// let category = obj.category;
		// let action = obj.action;
		// let label = obj.label;
		var _obj$category = obj.category,
		    category = _obj$category === undefined ? 'quikr_pwa' : _obj$category,
		    action = obj.action,
		    label = obj.label,
		    rest = _objectWithoutProperties(obj, ['category', 'action', 'label']);

		var windowNewOpen = obj.windowNewOpen;
		var windowOpen = obj.windowOpen;

		if (category !== '' && action !== '' && label !== '') {

			if (typeof ga !== 'undefined' && ga) {
				// _gaq.push(['_trackEvent', category, action, label, 0, true]);
				ga('quikrPWATracker.send', 'event', _extends({ eventCategory: category, eventAction: action, eventLabel: label }, rest));

				// alert('Category:'+category+',action:'+action+',label:'+label);
			} else {
				console.log('Google Analytics not loaded');
			}

			if (typeof gen_comscore_tag === 'function') {
				gen_comscore_tag('www.quikr.com/' + category + action);
			}
		}

		if (windowNewOpen) {
			window.open(windowNewOpen, '_blank');
		}

		if (windowOpen) {
			window.location = windowOpen;
			return false;
		}
	}
};


var setPageView = function setPageView(pageUrl) {
	if (typeof ga !== 'undefined' && ga) {
		ga('quikrPWATracker.send', 'pageview', pageUrl);
	}
};

var pushAnalyticsEvent = function pushAnalyticsEvent(eventName, data) {
	var isMsite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	var MAX_TRY = 10; // try 10 times
	var source = isMsite ? 'Msite' : 'Desktop';

	var pushEvent = function pushEvent(eventName, _data, source) {
		var tryCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MAX_TRY;

		try {
			if (typeof _paqv3 !== 'undefined' && _paqv3) {
				_paqv3.push(["_sendEventApiData", eventName, source, JSON.stringify(_data)]);
			} else if (tryCount) {
				setTimeout(function () {
					return pushEvent(eventName, _data, source, tryCount - 1);
				}, 1000);
			}
		} catch (err) {
			console.log(err);
		}
	};

	pushEvent(eventName, data, source, MAX_TRY);
};

/***/ }),

/***/ "LZrM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Validator; });
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Generic form validator utlity class
 */
var Validator = (_temp = _class = function () {
  function Validator() {
    _classCallCheck(this, Validator);
  }

  Validator.isEmpty = function isEmpty(value) {
    if (false === value || '' === value || undefined === value || 'undefined' === typeof value || null === value || Array.isArray(value) && 0 === value.length) return true;
    return false;
  };

  return Validator;
}(), _class.isNAN = function (number) {
  return isNaN(number);
}, _class.isEmail = function (email) {
  return (/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(email)
  );
}, _class.isValidUrl = function (url) {
  return (/^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url)
  );
}, _class.isValidPhone = function (number) {
  return (/^(9|8|7|6)[\d]{9}$/.test(number)
  );
}, _class.hasMobileNumber = function (string) {
  return (/(.*)[6-9]\d{9}(.*)/.test(string)
  );
}, _class.isValidOtp = function (number) {
  return (/^[\d]{4}$/.test(number)
  );
}, _temp);

/***/ }),

/***/ "Lpc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../window-or-global/lib/index.js
var lib = __webpack_require__("IyPV");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ../q-jobs/src/utils/WebStorageWrapper/sessionStorageWrapper.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Utility for session storage
 *
 * @author John Lukose <john.lukose@quikr.com>
 */


var sessionStorageWrapper = null;

var sessionStorageWrapper_SessionStorageWrapper = function () {
  function SessionStorageWrapper() {
    _classCallCheck(this, SessionStorageWrapper);

    if (sessionStorageWrapper) {
      return sessionStorageWrapper;
    }

    sessionStorageWrapper = this;
  }

  SessionStorageWrapper.prototype.get = function get(key) {
    return lib_default.a.sessionStorage && lib_default.a.sessionStorage.getItem(key);
  };

  SessionStorageWrapper.prototype.set = function set(key, value) {
    try {
      lib_default.a.sessionStorage && lib_default.a.sessionStorage.setItem(key, value);
      return true;
    } catch (e) {
      // console.error('Session Storage : error while set item ' + e + key + value);
      return false;
    }
  };

  SessionStorageWrapper.prototype.remove = function remove(key) {
    lib_default.a.sessionStorage && lib_default.a.sessionStorage.removeItem(key);
  };

  return SessionStorageWrapper;
}();

sessionStorageWrapper = new sessionStorageWrapper_SessionStorageWrapper();
/* harmony default export */ var WebStorageWrapper_sessionStorageWrapper = (sessionStorageWrapper);
// EXTERNAL MODULE: ../q-jobs/src/utils/LocalStorageWrapper/index.js
var LocalStorageWrapper = __webpack_require__("gEYR");

// EXTERNAL MODULE: ../q-jobs/node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__("/ErD");

// CONCATENATED MODULE: ../q-jobs/src/utils/WebStorageWrapper/index.js
function WebStorageWrapper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Utility for managing web storage objects
 *
 * @author John Lukose <john.lukose@quikr.com>
 */




var webStorageWrapper = null;

var WebStorageWrapper_WebStorageWrapper = function WebStorageWrapper() {
    var _this = this;

    WebStorageWrapper__classCallCheck(this, WebStorageWrapper);

    this.getLocalStorage = function () {
        return LocalStorageWrapper["a" /* default */];
    };

    this.getCookie = function () {
        if (!_this.cookieWrapper) _this.cookieWrapper = new es6["a" /* default */]();

        return _this.cookieWrapper;
    };

    this.getSessionStorage = function () {
        return WebStorageWrapper_sessionStorageWrapper;
    };
};

webStorageWrapper = new WebStorageWrapper_WebStorageWrapper();
/* harmony default export */ var utils_WebStorageWrapper = __webpack_exports__["a"] = (webStorageWrapper);

/***/ }),

/***/ "MIZk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ripple_mdc_ripple_scss__ = __webpack_require__("sPP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ripple_mdc_ripple_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ripple_mdc_ripple_scss__);
/**
 * Import dependencies.
 */

/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */


/**
 * Export the ripple helper.
 */
/* harmony default export */ __webpack_exports__["a"] = (function (e, rippleParameter) {
  if (!e || !e.getBoundingClientRect) {
    return '';
  }
  var dimensions = e.getBoundingClientRect();
  var maxDim = Math.max(dimensions.height, dimensions.width);
  var surfaceDiameter = Math.sqrt(Math.pow(dimensions.width, 2) + Math.pow(dimensions.height, 2));
  // 60% of the largest dimension of the surface
  var fgSize = maxDim * 0.6;
  // Diameter of the surface + 10px
  var maxRadius = surfaceDiameter + 10;
  var fgScale = maxRadius / fgSize;
  if (rippleParameter) {
    return {
      style: '--mdc-ripple-surface-width:' + dimensions.width / rippleParameter + 'px;\n      --mdc-ripple-surface-height:' + dimensions.height / rippleParameter + 'px;\n      --mdc-ripple-fg-size:' + Math.round(fgSize) + 'px;\n      --mdc-ripple-fg-scale:' + fgScale / rippleParameter + ';\n      --mdc-ripple-left:' + Math.round(dimensions.width / 2 - fgSize / 2) + 'px;\n      --mdc-ripple-top:' + Math.round(dimensions.height / 2 - fgSize / 2) + 'px;',
      duration: 1000 * Math.sqrt(maxRadius / 1024)
    };
  } else {
    return {
      style: '--mdc-ripple-surface-width:' + dimensions.width + 'px;\n      --mdc-ripple-surface-height:' + dimensions.height + 'px;\n      --mdc-ripple-fg-size:' + Math.round(fgSize) + 'px;\n      --mdc-ripple-fg-scale:' + fgScale + ';\n      --mdc-ripple-left:' + Math.round(dimensions.width / 2 - fgSize / 2) + 'px;\n      --mdc-ripple-top:' + Math.round(dimensions.height / 2 - fgSize / 2) + 'px;',
      duration: 1000 * Math.sqrt(maxRadius / 1024)
    };
  }
});

/***/ }),

/***/ "MYMf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_q_mdc_elements_material_menu__ = __webpack_require__("VisV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_headerIcons__ = __webpack_require__("WJAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ga__ = __webpack_require__("ZDZs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_scss__ = __webpack_require__("jC5+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_scss__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var defaultLoggedOutMenuArr = [
// { title: 'My Cart', href: '/QuikrX/Cart',gaEventName: 'cart' },
// { title: 'My Doorstep Offers', href: '/Escrow/MyOffers/getBuyersOfferForm',gaEventName:'doorstep_offers' },
// { title: 'My Notifications', href: "no_redicetion" , gaEventName:'notifictions', onClick: (e) => { e.preventDefault(); e.stopPropagation(); }, callFunction:'openNotificationPopup'},
{ title: 'Chats', href: '/MyQuikr?action=mychats', gaEventName: 'chats' }, {
	href: "/instant-leads",
	title: "Get Instant Leads",
	gaEventName: "instant_leads"
}, { title: 'Login/Register', href: '/SignIn', gaEventName: 'login', onClick: function onClick(e) {
		e.preventDefault();e.stopPropagation();window.location = '/SignIn?redirect=' + encodeURIComponent(window.location.href);
	} }];

var defaultLoggedInMenuArr = [{ href: '/MyQuikr', title: 'My Account', gaEventName: 'account' }, { href: '/MyQuikr?action=mychats', title: 'Chats' /*<span class="notification--num" >3</span>*/, gaEventName: 'chats' }, { href: '/MyQuikr?action=alertsdetails', title: 'Alerts', gaEventName: 'alerts' }, { href: '/MyQuikr?action=activeads', title: 'My Ads', gaEventName: 'ads' },
// { title: 'My Cart', href: '/QuikrX/Cart',gaEventName: 'cart' },
// { title: 'My Doorstep Offers', href: '/Escrow/MyOffers/getBuyersOfferForm', gaEventName:'doorstep_offers' },
// { title: 'My Notifications', href: "no_redicetion", gaEventName:'notifictions', onClick: (e) => { e.preventDefault(); e.stopPropagation(); }, callFunction:'openNotificationPopup' },
{ href: '/MyQuikr?action=lead', title: 'My Leads', gaEventName: 'leads' }, {
	href: "/instant-leads",
	title: "Instant Leads",
	gaEventName: "instant_leads"
}, { href: '/QuikrX/myorders', title: 'My Orders', gaEventName: 'orders' },

/* <Menu.Item link href="#">Recommendation for me</Menu.Item> */

{ title: 'Logout', href: '/bye', gaEventName: 'logout' }];

var QMenu = function (_Component) {
	_inherits(QMenu, _Component);

	function QMenu() {
		var _temp, _this, _ret;

		_classCallCheck(this, QMenu);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.pushGAEvent = function (eventName) {
			var pageType = _this.context.pageType;

			var gaEventObject = { category: 'quikr_pwa', action: 'quikr_pwa_' + pageType + '_usersection', label: 'quikr_pwa_' + pageType + '_usersection_my_' + eventName };
			Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ga__["a" /* getEventTrackGA */])(gaEventObject);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	QMenu.prototype.render = function render(_ref) {
		var _this2 = this;

		var list = _ref.list,
		    refFn = _ref.refFn,
		    callHeaderfunction = _ref.callHeaderfunction;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_1_q_mdc_elements_material_menu__["a" /* default */],
			{
				ref: function ref(menu) {
					return refFn(menu);
				},
				links: true
			},
			list.map(function (menuItem) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_q_mdc_elements_material_menu__["a" /* default */].Item,
					{
						link: true,
						href: menuItem.href,
						onClick: function onClick(e) {
							_this2.pushGAEvent(menuItem.gaEventName);
							if (menuItem.onClick) {
								menuItem.onClick(e);
							}
							if (menuItem.callFunction) {
								callHeaderfunction(menuItem.callFunction);
							}
						}
					},
					menuItem.title
				);
			})
		);
	};

	return QMenu;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__icons_headerIcons__["a" /* Account */], { 'class': 'mdc-toolbar__icons' });

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'span',
	{ 'class': 'link-text-hidden' },
	'Quikr Account Menu'
);

var MyAccountMenu = function (_Component2) {
	_inherits(MyAccountMenu, _Component2);

	function MyAccountMenu() {
		_classCallCheck(this, MyAccountMenu);

		return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	MyAccountMenu.prototype.render = function render(props, state, context) {
		var _this4 = this;

		var isLoggedIn = props.isLoggedIn,
		    _props$loggedInMenu = props.loggedInMenu,
		    loggedInMenu = _props$loggedInMenu === undefined ? defaultLoggedInMenuArr : _props$loggedInMenu,
		    _props$loggedOutMenu = props.loggedOutMenu,
		    loggedOutMenu = _props$loggedOutMenu === undefined ? defaultLoggedOutMenuArr : _props$loggedOutMenu,
		    callHeaderfunction = props.callHeaderfunction;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'span',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{ href: 'javascript:void(0);',
					'class': 'mdc-toolbar__icon',
					onClick: function onClick(e) {
						_this4.menu.MDComponent.open = true;
					}
				},
				_ref2,
				_ref3
			),
			!isLoggedIn && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(QMenu, {
				refFn: function refFn(menu) {
					_this4.menu = menu;
				},
				list: loggedOutMenu,
				callHeaderfunction: callHeaderfunction
			}),
			isLoggedIn && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(QMenu, {
				refFn: function refFn(menu) {
					_this4.menu = menu;
				},
				list: loggedInMenu,
				callHeaderfunction: callHeaderfunction
			})
		);
	};

	return MyAccountMenu;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MyAccountMenu);

/***/ }),

/***/ "Nukh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CITY_COOKIE_TTL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COOKIE_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_INDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALL_INDIA_CITY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CITY_ID_COOKIE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CITY_NAME_COOKIE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RECENT_SEARCHES_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TRENDING_SEARCHES_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABRAND_COOKIE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return STATE_NAME_COOKIE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return STATE_ID_COOKIE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return WALLET_REDIRECTION_CONSTANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_HOSTNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HEADER_API_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TRENDING_SEARCH_API_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_USER_API_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RECOMMENDATION_LOCAL_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PLAY_STORE_REDIRECT_URL; });
var CITY_COOKIE_TTL = 60 * 60 * 24 * 30;
var COOKIE_DOMAIN = '.quikr.com';
var ALL_INDIA = 'All India';
var ALL_INDIA_CITY_ID = '1';
var CITY_ID_COOKIE_KEY = 'prefer_city_id';
var CITY_NAME_COOKIE_KEY = 'new_prefer_city';
var RECENT_SEARCHES_KEY = 'recentSearches';
var TRENDING_SEARCHES_KEY = 'trendingSearches';
var ABRAND_COOKIE_KEY = 'abRand';
var STATE_NAME_COOKIE_KEY = 'new_prefer_state';
var STATE_ID_COOKIE_KEY = 'new_prefer_state_id';
var WALLET_REDIRECTION_CONSTANT = 100;

/**** API ENDPOINTS START****/

var DEFAULT_HOSTNAME = 'www.quikr.com';
var HEADER_API_HOST = 'https://feservices.quikr.com/v2/header';
var TRENDING_SEARCH_API_PATH = 'fetch_trending_searches';
var GET_USER_API_PATH = 'core/base/sign-in/get-user';

/**** API ENDPOINTS END ****/

var RECOMMENDATION_LOCAL_STORAGE_KEY = 'commonParamsForCrossCategory';
var PLAY_STORE_REDIRECT_URL = {
    jobs: 'https://play.google.com/store/apps/details?id=com.quikr.job',
    others: 'https://play.google.com/store/apps/details?id=com.quikr'
};

/***/ }),

/***/ "Nyl0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),

/***/ "O3jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../preact/dist/preact.js
var preact = __webpack_require__("xIV9");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// CONCATENATED MODULE: ../q-jobs/node_modules/q-components/components/icons/headerIcons/account/index.js



var _ref = Object(preact["h"])("path", { d: "M35.6,2C45.8,2,54,10,54,20.2v0.2c0,10.2-8,18.2-18.1,18.4c-10.1,0-18.4-8-18.4-18.2C17.3,10.3,25.5,2,35.6,2 M67.7,69.3c0,0.5-0.2,0.7-0.7,0.7H5c-0.5,0-0.7-0.2-0.7-0.7c0-13.2,14.6-24.1,31.6-24.1C53.1,45,67.4,56.1,67.7,69.3" });

var account_account = function account(props) {
	return Object(preact["h"])(
		"svg",
		{ id: "account", version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};
/* harmony default export */ var headerIcons_account = (account_account);
// EXTERNAL MODULE: ../q-jobs/node_modules/q-components/components/icons/headerIcons/back/index.js
var back = __webpack_require__("njsv");

// CONCATENATED MODULE: ../q-jobs/node_modules/q-components/components/icons/headerIcons/menu/index.js



var menu__ref = Object(preact["h"])("path", { xmlns: "http://www.w3.org/2000/svg", d: "M70,10.8v9.1H2v-9.1H70z M2,33.5v9.1h68v-9.1H2z M2,56.1v9.1h68v-9.1H2z" });

var menu_menu = function menu(props) {
	return Object(preact["h"])(
		"svg",
		{ id: "menu", version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 72 72", "class": props.class },
		menu__ref
	);
};
/* harmony default export */ var headerIcons_menu = (menu_menu);
// EXTERNAL MODULE: ../q-jobs/node_modules/q-components/components/icons/headerIcons/quikr/index.js
var quikr = __webpack_require__("lCHb");

// EXTERNAL MODULE: ../q-jobs/node_modules/q-components/components/icons/headerIcons/gps/index.js
var gps = __webpack_require__("Ob73");

// CONCATENATED MODULE: ../q-jobs/node_modules/q-components/components/icons/headerIcons/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return headerIcons_account; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return back["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return headerIcons_menu; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return quikr["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return gps["a" /* default */]; });








/***/ }),

/***/ "O4pu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),

/***/ "OCA3":
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/***/ }),

/***/ "OCMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_list_mdc_list_scss__ = __webpack_require__("hP+K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_list_mdc_list_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_list_mdc_list_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */


/**
 * Create the component.
 */

var ListItem = function (_Component) {
  _inherits(ListItem, _Component);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ListItem.prototype.render = function render(_ref, state, context) {
    var className = _ref['class'],
        children = _ref.children,
        role = _ref.role,
        link = _ref.link,
        props = _objectWithoutProperties(_ref, ['class', 'children', 'role', 'link']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-list-item', className);
    return link ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      _extends({ 'class': classes }, props),
      children
    ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'li',
      _extends({ 'class': classes }, props, { role: role }),
      children
    );
  };

  return ListItem;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "OIb5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomEventService = function CustomEventService() {
  var _this = this;

  _classCallCheck(this, CustomEventService);

  this.getEvents = function () {
    return _this.callbacks;
  };

  this.triggerEvent = function (eventName) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (_this.callbacks[eventName]) {
      if (data !== null) {
        _this.callbacks[eventName].callbackFn(data);
      } else {
        _this.callbacks[eventName].callbackFn.apply(null, _this.callbacks[eventName].arguments);
      }
      // Object.keys(this.callbacks[eventName]).forEach((id) => {
      //   this.callbacks[eventName][id](data);
      // });
    }
  };

  this.listenEvent = function (eventName, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _this.callbacks[eventName] = {};
    _this.callbacks[eventName].callbackFn = callback;
    _this.callbacks[eventName].arguments = params;
  };

  this.unlistenEvent = function (eventName) {
    delete _this.callbacks[eventName];
  };

  this.callbacks = {};
}

/**
 * @param {string} eventName
 * @param {*} data
 */


/**
 * @param {string} eventName name of event
 * @param {Function} callback
 * @param {Array} params callback parameters
 */


/**
 * @param {string} eventName name of event
 */
;

var instance = new CustomEventService();
/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),

/***/ "OPyx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OWbL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__("CK2z");

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),

/***/ "OZRe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("dp6N");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),

/***/ "OaXg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _cookie = __webpack_require__("9Snp");

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__("X84d");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _utils = __webpack_require__("JJ8B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Cookies = function () {
  function Cookies(cookies, hooks) {
    _classCallCheck(this, Cookies);

    this.changeListeners = [];

    this.cookies = parseCookies(cookies);
    this.hooks = hooks;
    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
  }

  _createClass(Cookies, [{
    key: '_updateBrowserValues',
    value: function _updateBrowserValues() {
      if (!this.HAS_DOCUMENT_COOKIE) {
        return;
      }

      this.cookies = _cookie2.default.parse(document.cookie);
    }
  }, {
    key: 'get',
    value: function get(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._updateBrowserValues();
      return readCookie(this.cookies[name], options);
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._updateBrowserValues();
      var result = {};

      for (var name in this.cookies) {
        result[name] = readCookie(this.cookies[name], options);
      }

      return result;
    }
  }, {
    key: 'set',
    value: function set(name, value, options) {
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        value = JSON.stringify(value);
      }

      if (this.hooks && this.hooks.onSet) {
        this.hooks.onSet(name, value, options);
      }

      this.cookies[name] = value;

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, value, options);
      }

      this._emitChange({ name: name, value: value, options: options });
    }
  }, {
    key: 'remove',
    value: function remove(name, options) {
      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
        expires: new Date(1970, 1, 1, 0, 0, 1),
        maxAge: 0
      });

      if (this.hooks && this.hooks.onRemove) {
        this.hooks.onRemove(name, finalOptions);
      }

      delete this.cookies[name];

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
      }

      this._emitChange({ name: name, value: undefined, options: options });
    }
  }, {
    key: '_emitChange',
    value: function _emitChange(params) {
      for (var i = 0; i < this.changeListeners.length; ++i) {
        this.changeListeners[i](params);
      }
    }
  }, {
    key: 'addChangeListener',
    value: function addChangeListener(callback) {
      this.changeListeners.push(callback);
    }
  }, {
    key: 'removeChangeListener',
    value: function removeChangeListener(callback) {
      var idx = this.changeListeners.indexOf(callback);
      if (idx >= 0) {
        this.changeListeners.splice(idx, 1);
      }
    }
  }]);

  return Cookies;
}();

exports.default = Cookies;

function parseCookies(cookies) {
  if (typeof cookies === 'string') {
    return _cookie2.default.parse(cookies);
  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isParsingCookie(value, options.doNotParse)) {
    try {
      return JSON.parse(value);
    } catch (e) {
      // At least we tried
    }
  }

  return value;
}
module.exports = exports['default'];

/***/ }),

/***/ "Ob73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" });

var GPS = function GPS(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ viewBox: "0 0 24 24", "class": props.class },
		_ref
	);
};
/* harmony default export */ __webpack_exports__["a"] = (GPS);

/***/ }),

/***/ "P1CM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.default = updateSubscription;var _common = __webpack_require__("yMAY"),
    _fetch = __webpack_require__("+ZFP"),
    _idb = __webpack_require__("RTKd");function updateSubscription(a) {
  var b = this;return new Promise(function (c, d) {
    var e = { endpointjson: JSON.stringify(a.toJSON()), updatetime: (0, _common.getCurrentDateTime)(), reg_id: a.endpoint.split("/").slice(-1) };(0, _fetch.fetcher)({ url: "/browser-unique-id-update", method: "POST", body: (0, _fetch.formURLSearchObject)(e) }).then(function (a) {
      a.ok ? c() : (b.pushSubscription.unsubscribe(), (0, _idb.clearIDB)(b.idb), d(new Error("Subscription update API failure!")));
    });
  });
}

/***/ }),

/***/ "PG4g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transformStyleProperties */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCorrectEventName;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCorrectPropertyName;
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @typedef {{
 *   noPrefix: string,
 *   webkitPrefix: string
 * }}
 */
var VendorPropertyMapType = void 0;

/** @const {Object<string, !VendorPropertyMapType>} */
var eventTypeMap = {
  'animationstart': {
    noPrefix: 'animationstart',
    webkitPrefix: 'webkitAnimationStart',
    styleProperty: 'animation'
  },
  'animationend': {
    noPrefix: 'animationend',
    webkitPrefix: 'webkitAnimationEnd',
    styleProperty: 'animation'
  },
  'animationiteration': {
    noPrefix: 'animationiteration',
    webkitPrefix: 'webkitAnimationIteration',
    styleProperty: 'animation'
  },
  'transitionend': {
    noPrefix: 'transitionend',
    webkitPrefix: 'webkitTransitionEnd',
    styleProperty: 'transition'
  }
};

/** @const {Object<string, !VendorPropertyMapType>} */
var cssPropertyMap = {
  'animation': {
    noPrefix: 'animation',
    webkitPrefix: '-webkit-animation'
  },
  'transform': {
    noPrefix: 'transform',
    webkitPrefix: '-webkit-transform'
  },
  'transition': {
    noPrefix: 'transition',
    webkitPrefix: '-webkit-transition'
  }
};

/**
 * @param {!Object} windowObj
 * @return {boolean}
 */
function hasProperShape(windowObj) {
  return windowObj['document'] !== undefined && typeof windowObj['document']['createElement'] === 'function';
}

/**
 * @param {string} eventType
 * @return {boolean}
 */
function eventFoundInMaps(eventType) {
  return eventType in eventTypeMap || eventType in cssPropertyMap;
}

/**
 * @param {string} eventType
 * @param {!Object<string, !VendorPropertyMapType>} map
 * @param {!Element} el
 * @return {string}
 */
function getJavaScriptEventName(eventType, map, el) {
  return map[eventType].styleProperty in el.style ? map[eventType].noPrefix : map[eventType].webkitPrefix;
}

/**
 * Helper function to determine browser prefix for CSS3 animation events
 * and property names.
 * @param {!Object} windowObj
 * @param {string} eventType
 * @return {string}
 */
function getAnimationName(windowObj, eventType) {
  if (!hasProperShape(windowObj) || !eventFoundInMaps(eventType)) {
    return eventType;
  }

  var map = /** @type {!Object<string, !VendorPropertyMapType>} */eventType in eventTypeMap ? eventTypeMap : cssPropertyMap;
  var el = windowObj['document']['createElement']('div');
  var eventName = '';

  if (map === eventTypeMap) {
    eventName = getJavaScriptEventName(eventType, map, el);
  } else {
    eventName = map[eventType].noPrefix in el.style ? map[eventType].noPrefix : map[eventType].webkitPrefix;
  }

  return eventName;
}

// Public functions to access getAnimationName() for JavaScript events or CSS
// property names.

var transformStyleProperties = ['transform', 'WebkitTransform', 'MozTransform', 'OTransform', 'MSTransform'];

/**
 * @param {!Object} windowObj
 * @param {string} eventType
 * @return {string}
 */
function getCorrectEventName(windowObj, eventType) {
  return getAnimationName(windowObj, eventType);
}

/**
 * @param {!Object} windowObj
 * @param {string} eventType
 * @return {string}
 */
function getCorrectPropertyName(windowObj, eventType) {
  return getAnimationName(windowObj, eventType);
}

/***/ }),

/***/ "PSZ3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PUp1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.default = void 0;var _default = ".wpn_modal_backdrop,.wpn_modal_container{bottom:0;height:100%;left:0;position:fixed;right:0;top:0;width:100%}.wpn_modal_container{align-items:center;display:flex;justify-content:center;z-index:9999}.wpn_modal_backdrop{background:rgba(0,0,0,.6);opacity:0;transition:opacity .3s ease;z-index:-1}.wpn_modal_container.wpn_modal_show .wpn_modal_backdrop{opacity:1}.wpn_modal_modal{background:#fff;border-radius:2px;box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);margin:20px;opacity:0;transition:opacity .2s ease;max-width:500px}.wpn_modal_container.wpn_modal_show .wpn_modal_modal{opacity:1}.wpn_modal_title{font-size:1.25em;font-weight:500;margin:0;padding:24px 20px 0}.wpn_modal_content{align-items:center;display:flex;padding:20px 24px}.wpn_modal_description{line-height:1.25em;margin-left:16px}.wpn_modal_actionButtonsContainer{align-items:center;display:flex;justify-content:flex-end;padding:0 8px 8px}.wpn_modal_actionButton{background:0 0;border:none;border-radius:2px;color:#0083ca;cursor:pointer;font-size:1em;font-weight:500;margin:0;min-height:40px;min-width:80px;overflow:hidden;padding:8px 16px;position:relative;text-overflow:ellipsis;transition:background .3s ease-in;user-select:none;vertical-align:middle;white-space:nowrap;-webkit-user-select:none}.wpn_modal_actionButton:hover{background:rgba(0,131,202,.2)}@media (hover:none){.wpn_modal_actionButton:hover{background:0 0}}.wpn_modal_actionButton:focus{outline:0}.wpn_modal_actionButton:-moz-focus-inner{border:0}.wpn_modal_actionButton span{pointer-events:none}@keyframes wpnRippleEffect{0%{transform:translate(-50%,-50%) scale(0);opacity:.3}100%{transform:translate(-50%,-50%) scale(2.5);opacity:0}}@-webkit-keyframes wpnRippleEffect{0%{-webkit-transform:translate(-50%,-50%) scale(0);opacity:.3}100%{-webkit-transform:translate(-50%,-50%) scale(2.5);opacity:0}}.wpn_ripple_effect{animation-duration:1s;animation-name:wpnRippleEffect;background:currentColor;border-radius:50%;height:200px;position:absolute;width:200px;z-index:0;-webkit-animation-duration:1s;-webkit-animation-name:wpnRippleEffect}.wpn_modal_icon{font-size:56px;height:1em;vertical-align:middle;width:1em}";exports.default = ".wpn_modal_backdrop,.wpn_modal_container{bottom:0;height:100%;left:0;position:fixed;right:0;top:0;width:100%}.wpn_modal_container{align-items:center;display:flex;justify-content:center;z-index:9999}.wpn_modal_backdrop{background:rgba(0,0,0,.6);opacity:0;transition:opacity .3s ease;z-index:-1}.wpn_modal_container.wpn_modal_show .wpn_modal_backdrop{opacity:1}.wpn_modal_modal{background:#fff;border-radius:2px;box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);margin:20px;opacity:0;transition:opacity .2s ease;max-width:500px}.wpn_modal_container.wpn_modal_show .wpn_modal_modal{opacity:1}.wpn_modal_title{font-size:1.25em;font-weight:500;margin:0;padding:24px 20px 0}.wpn_modal_content{align-items:center;display:flex;padding:20px 24px}.wpn_modal_description{line-height:1.25em;margin-left:16px}.wpn_modal_actionButtonsContainer{align-items:center;display:flex;justify-content:flex-end;padding:0 8px 8px}.wpn_modal_actionButton{background:0 0;border:none;border-radius:2px;color:#0083ca;cursor:pointer;font-size:1em;font-weight:500;margin:0;min-height:40px;min-width:80px;overflow:hidden;padding:8px 16px;position:relative;text-overflow:ellipsis;transition:background .3s ease-in;user-select:none;vertical-align:middle;white-space:nowrap;-webkit-user-select:none}.wpn_modal_actionButton:hover{background:rgba(0,131,202,.2)}@media (hover:none){.wpn_modal_actionButton:hover{background:0 0}}.wpn_modal_actionButton:focus{outline:0}.wpn_modal_actionButton:-moz-focus-inner{border:0}.wpn_modal_actionButton span{pointer-events:none}@keyframes wpnRippleEffect{0%{transform:translate(-50%,-50%) scale(0);opacity:.3}100%{transform:translate(-50%,-50%) scale(2.5);opacity:0}}@-webkit-keyframes wpnRippleEffect{0%{-webkit-transform:translate(-50%,-50%) scale(0);opacity:.3}100%{-webkit-transform:translate(-50%,-50%) scale(2.5);opacity:0}}.wpn_ripple_effect{animation-duration:1s;animation-name:wpnRippleEffect;background:currentColor;border-radius:50%;height:200px;position:absolute;width:200px;z-index:0;-webkit-animation-duration:1s;-webkit-animation-name:wpnRippleEffect}.wpn_modal_icon{font-size:56px;height:1em;vertical-align:middle;width:1em}";

/***/ }),

/***/ "PWyx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ "Pp8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__("mZt8");


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */

  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */

  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */

  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */

  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */

  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */

  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */

function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);
  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */

function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),

/***/ "QFZf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-console */

if (false) {
	var preact = require('preact');
	var options = preact.options;
	var oldVnodeOption = options.vnode;

	options.vnode = function (vnode) {
		var nodeName = vnode.nodeName,
		    attributes = vnode.attributes,
		    children = vnode.children;

		if (nodeName === void 0) {
			console.error('Undefined component passed to preact.h()\n' + serializeVNode(vnode));
		}

		if (attributes && attributes.ref !== void 0 && typeof attributes.ref !== 'function' && !('$$typeof' in vnode) // allow string refs when preact-compat is installed
		) {
				throw new Error('Component\'s "ref" property should be a function,' + (' but [' + typeof attributes.ref + '] passed\n') + serializeVNode(vnode));
			}

		{
			var keys = {};

			inspectChildren(children, function (deepChild) {
				if (!deepChild || deepChild.key == null) return;

				// In Preact, all keys are stored as object values, i.e. being strings
				var key = deepChild.key + '';

				if (keys.hasOwnProperty(key)) {
					console.error('Following component has two or more children with the ' + 'same "key" attribute. This may cause glitches and misbehavior ' + 'in rendering process. Component: \n\n' + serializeVNode(vnode));

					// Return early to not spam the console
					return true;
				}

				keys[key] = true;
			});
		}

		if (oldVnodeOption) oldVnodeOption.call(this, vnode);
	};

	try {
		var oldRender = preact.render;
		preact.render = function (vnode, parent, merge) {
			if (parent == null && merge == null) {
				// render(vnode, parent, merge) can't have both parent and merge be undefined
				console.error('The "containerNode" or "replaceNode" is not defined in the render method. ' + 'Component: \n\n' + serializeVNode(vnode));
			} else if (parent == merge) {
				// if parent == merge, it doesn't reason well and would cause trouble when preact
				// tries to update or replace that 'replaceNode' element
				console.error('The "containerNode" and "replaceNode" are the same in render method, ' + 'when the "replaceNode" DOM node is expected to be a child of "containerNode". ' + 'docs-ref: https://preactjs.com/guide/api-reference#-preact-render-. Component: \n\n' + serializeVNode(vnode));
			}
			return oldRender(vnode, parent, merge);
		};
	} catch (e) {}

	var inspectChildren = function inspectChildren(children, inspect) {
		if (!Array.isArray(children)) {
			children = [children];
		}
		return children.some(function (child, i) {
			if (Array.isArray(child)) {
				return inspectChildren(child, inspect);
			}

			return inspect(child, i);
		});
	};

	var serializeVNode = function serializeVNode(_ref) {
		var nodeName = _ref.nodeName,
		    attributes = _ref.attributes,
		    children = _ref.children;

		if (typeof nodeName === 'function') {
			nodeName = nodeName.name || nodeName.displayName;
		}

		var props = '';
		if (attributes) {
			for (var attr in attributes) {
				if (attributes.hasOwnProperty(attr) && attr !== 'children') {
					var value = attributes[attr];

					// If it is an object but doesn't have toString(), use Object.toString
					if (typeof value === 'function') {
						value = 'function ' + (value.displayName || value.name) + '() {}';
					}
					if (Object(value) === value && !value.toString) {
						value = Object.prototype.toString.call(value);
					} else {
						value = value + '';
					}

					props += ' ' + attr + '=' + JSON.stringify(value);
				}
			}
		}

		return '<' + nodeName + props + (children && children.length ? '>..</' + nodeName + '>' : ' />');
	};

	require('preact/devtools');
}

//# sourceMappingURL=debug.js.map

/***/ }),

/***/ "QHaY":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

// From https://www.npmjs.com/package/babel-plugin-dual-import

var ADDED = {};

module.exports = function (chunkName) {
  var href = getHref(chunkName);
  if (!href) {
    if (false) {
      if (typeof window === 'undefined' || !window.__CSS_CHUNKS__) {
        console.warn('[DUAL-IMPORT] no css chunks hash found at "window.__CSS_CHUNKS__"');
        return;
      }

      console.warn('[DUAL-IMPORT] no chunk, ', chunkName, ', found in "window.__CSS_CHUNKS__"');
    }

    return;
  }

  if (ADDED[href] === true) {
    return Promise.resolve();
  }
  ADDED[href] = true;

  var head = document.getElementsByTagName('head')[0];
  var link = document.createElement('link');

  link.href = href;
  link.charset = 'utf-8';
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.timeout = 30000;

  return new Promise(function (resolve, reject) {
    var timeout;

    link.onerror = function () {
      link.onerror = link.onload = null; // avoid mem leaks in IE.
      clearTimeout(timeout);
      var message = 'could not load css chunk:${chunkName}';
      console.error(message);
      reject(new Error(message));
    };

    link.onload = function () {
      clearTimeout(timeout);
      resolve();
    };

    // link.onload doesn't work well enough, but this will handle it
    // since images can't load css (this is a popular fix)
    // var img = document.createElement('img');
    // img.onerror = function() {
    //   link.onerror = img.onerror = null; // avoid mem leaks in IE.
    //   clearTimeout(timeout);
    //   resolve();
    // };

    timeout = setTimeout(link.onerror, link.timeout);
    head.appendChild(link);
    // img.src = href;
  });
};

function getHref(chunkName) {
  if (typeof window === 'undefined' || !window.__CSS_CHUNKS__) return null;
  return window.__CSS_CHUNKS__[chunkName];
}

/***/ }),

/***/ "QSFW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ROOT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CONTEXT_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return HOME_CONTEXT_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PAP_CONTEXT_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return QJG_CONTEXT_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CANDIDATE_TEST_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CANDIDATE_TEST_SUBMIT_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CANDIDATE_TEST_SUBMIT_HARVARD_ANSWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return RSA_CONTEXT_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CALL_RECRUITER_NUMBER_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SEARCH_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PROFILE_RICHNESS_CONTEXT_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return UPDATE_PROFILE_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return LOG_DATA_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SAVE_JOB_VIEW_URL; });
/* unused harmony export SAVE_FEEDBACK_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SSR_GQL_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SAVE_LEAD_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_COMPANIES_API; });
/* unused harmony export GET_CITIES_API */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_INTERNATIONAL_CITIES_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GOVERNMENT_JOBS_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GOVERNMENT_JOBS_ROLE_ALIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABROAD_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CATEGORY_PGID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PRE_PROFILE_BENEFITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SILVER_PROFILE_BENEFITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMPARISON; });
/* unused harmony export hotjarConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return TOP_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return PROFILE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return JOB_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LOGGEDIN_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LOGGEDOUT_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return TRUST_BADGES; });
/* unused harmony export SENTRY_CONFIG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return INSUFFICIENT_CREDITS_ERROR_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return Q_CASH_STATUS_CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return Q_CASH_CONTEXTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DUMMY_EMAIL_PATTERNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return QUESTION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return LOCALSTORAGE_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FLEXI_CANDIDATE_SMS_TO_UPDATE_PROFILE_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return RECRUITMENT_SERVICES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_window_or_global__);


var ROOT_URL = "www.quikr.com";
var BASE_URL = "/jobs";
var API_URL = ROOT_URL + BASE_URL;
var CONTEXT_API = "/jobsAjax/context";
var HOME_CONTEXT_API = "/jobsAjax/homeContext";
var PAP_CONTEXT_API = "/jobsAjax/papContext";
var QJG_CONTEXT_API = "/jobsAjax/qjgContext";
var CANDIDATE_TEST_API = "/jobsAjax/candidateTestContext?applicationId={applicationId}&token={token}";
var CANDIDATE_TEST_SUBMIT_API = "/jobsAjax/candidateTestSubmission";
var CANDIDATE_TEST_SUBMIT_HARVARD_ANSWER = "/jobsAjax/harvard/answer";
var RSA_CONTEXT_API = "/jobsAjax/rsaData";
var CALL_RECRUITER_NUMBER_API = "/getRecruiterDetails";
var SEARCH_API = "/jobsAjax/search";
var PROFILE_RICHNESS_CONTEXT_API = "/jobsAjax/profileRichnessContext";
var UPDATE_PROFILE_API = "/jobsAjax/updateProfile";
var LOG_DATA_API_URL = "/log-data";
var SAVE_JOB_VIEW_URL = "/save-job-view";
var SAVE_FEEDBACK_URL = "/saveFeedback";
var SSR_GQL_ENDPOINT = "https://www.quikr.com/api";
var SAVE_LEAD_DATA = "/o/jobleads/lead";

var GET_COMPANIES_API = "/jobsAjax/getCompanies";
var GET_CITIES_API = "/jobsAjax/getAllCities";
var GET_INTERNATIONAL_CITIES_API = "/jobsAjax/getAllCities?type=international";

var GOVERNMENT_JOBS_ROLE = "Government Jobs";
var GOVERNMENT_JOBS_ROLE_ALIAS = "govt-jobs";

var ABROAD_CATEGORY = "Work Abroad";

var CATEGORY_PGID = "93";

var ICONS = {
  DELIVERY: "M18.45,63.75c-5.49,0-10-4.26-10.4-9.64H6.28c-0.74,0-1.43-0.29-1.97-0.83c-0.54-0.54-0.83-1.26-0.81-2.02\n\t\tc0.11-9.03,4.53-13.11,6.9-14.66L8.43,34.7c-0.99-0.96-1.55-2.29-1.55-3.65c0-1.59,1.21-2.8,2.71-2.8h22.57c0.04,0,0.07,0,0.11,0\n\t\th1.28c2.2,0,3.99,1.79,3.99,3.99v1.7c0,1.75-1.1,3.23-2.65,3.81c5.02,3.41,5.92,9.01,6.07,11.59c0.02,0.36,0,0.72-0.07,1.08\n\t\tc5.65-3.03,9.26-8.97,9.26-15.44V19.73c0-0.69-0.56-1.28-1.28-1.28h-7.17c-0.63,0-1.12-0.49-1.12-1.12s0.49-1.12,1.12-1.12h7.17\n\t\tc1.93,0,3.52,1.57,3.52,3.52v2.26c1.32-1.19,3.16-1.93,5.16-1.93c0.63,0,1.12,0.49,1.12,1.12V32.1c0,0.63-0.49,1.12-1.12,1.12\n\t\tc-2.02,0-3.83-0.74-5.16-1.93v3.65c0,0.49-0.02,0.99-0.07,1.48c12.62,0.85,15.49,9.44,16.12,13.18c0.13,0.83-0.09,1.68-0.65,2.33\n\t\tc-0.45,0.54-1.05,0.87-1.73,0.99C66,58.6,61.36,63.19,55.66,63.19c-5.67,0-10.31-4.57-10.42-10.22h-4.8c0,0-0.02,0-0.04,0h-1.08\n\t\tc-0.49,0.4-1.08,0.69-1.75,0.85c-1.32,0.31-2.6,0.27-2.67,0.27h-6.07C28.45,59.49,23.92,63.75,18.45,63.75z M10.29,54.09\n\t\tc0.4,4.15,3.9,7.4,8.16,7.4s7.76-3.25,8.16-7.4h-3.83c-0.04,2.13-1.77,3.83-3.9,3.83S15,56.2,14.96,54.09H10.29z M47.48,52.97\n\t\tc0.11,4.42,3.74,7.98,8.18,7.98s8.07-3.56,8.18-7.98h-4.08c0,0.09,0,0.18,0,0.29c0,2.15-1.75,3.92-3.92,3.92\n\t\tc-2.17,0-3.92-1.75-3.92-3.92c0-0.09,0-0.2,0-0.29H47.48z M17.17,54.09c0.04,0.9,0.76,1.59,1.68,1.59c0.9,0,1.64-0.72,1.66-1.59\n\t\tH17.17z M54.23,52.97c-0.02,0.09-0.02,0.18-0.02,0.29c0,0.92,0.74,1.68,1.68,1.68c0.94,0,1.68-0.74,1.68-1.68\n\t\tc0-0.09,0-0.2-0.02-0.29H54.23z M12.51,37.97c-1.1,0.52-6.66,3.59-6.77,13.31c0,0.16,0.07,0.31,0.16,0.43\n\t\tc0.07,0.07,0.18,0.16,0.36,0.16h28.67c0.04,0,1.08,0.02,2.13-0.22c1.01-0.25,1.7-1.17,1.66-2.22c-0.18-3.32-1.5-9.21-8.34-11.41\n\t\tc-0.04-0.02-0.07-0.02-0.11-0.04H12.51z M44.5,50.73h21.12c0.2,0,0.38-0.09,0.52-0.25c0.07-0.09,0.18-0.27,0.13-0.52\n\t\tc-0.69-3.99-3.45-10.67-14.21-11.34C51.11,43.46,48.4,47.79,44.5,50.73z M12.74,35.73h20.76c1.01,0,1.82-0.81,1.82-1.82v-1.7\n\t\tc0-0.96-0.78-1.75-1.75-1.75h-1.28c-0.04,0-0.07,0-0.11,0H9.6c-0.27,0-0.47,0.2-0.47,0.47c0,0.87,0.31,1.61,0.87,2.15L12.74,35.73z\n\t\t M56.45,22.39c-2.26,0.45-3.95,2.17-3.95,4.24s1.68,3.79,3.95,4.24V22.39z",
  BPO: "M67.8,39.3c0-4.1-1-17.5-8.5-26.9c-5.2-6.5-13.3-9.9-24.2-9.9c-11-0.1-19.1,3.1-24,9.5C3,22.5,4.3,38.3,4.5,39 l0.2,0c-2,1.8-3.3,5.1-2.3,10.7C3,52.8,3.9,55,5.1,56.5C4.4,58.4,4,60.9,5,63.1c1,2.1,3.2,3.3,6.4,3.7c4.9,0.6,9.8,1.1,13.7,1.4 c0.4,0.6,1.2,1.1,2,1.1l6.6,0.2c1.4,0,2.6-1.1,2.7-2.5c0-1.4-1.1-2.6-2.5-2.7l-6.6-0.2c-1.2,0-2.3,0.8-2.6,2 c-3.7-0.3-8.4-0.8-13-1.4c-2.5-0.3-4.2-1.2-4.8-2.6c-0.6-1.2-0.5-2.8-0.1-4.1c1.6,1.1,3.4,1.3,5,1.1l0.2,1.3l5-0.9L12.4,35l-3.6,0.7 c-0.6-4.4-1.3-14.6,4.3-22C17.6,8,25,5.2,35.1,5.2c10,0.1,17.5,3.1,22.1,8.9c5.5,6.9,5.9,16.2,5.6,21.4L59.6,35l-4.5,24.5l5,0.9 l0.2-1.3c3.3,0.4,7.7-0.9,9.3-9.6C70.6,44.4,69.5,41.2,67.8,39.3",
  DATAENTRY: "M67.38,67.51H4.62c-0.63,0-1.12-0.49-1.12-1.12V52.34c0-0.25,0.07-0.47,0.2-0.65l10.31-15.08V19.35	c0-0.63,0.49-1.12,1.12-1.12h10.18v-2.4H15.24c-0.63,0-1.12-0.49-1.12-1.12v-9.1c0-0.63,0.49-1.12,1.12-1.12h22.39	c0.63,0,1.12,0.49,1.12,1.12v9.1c0,0.63-0.49,1.12-1.12,1.12H27.57v2.42h29.29c0.63,0,1.12,0.49,1.12,1.12v17.26L68.3,51.71 c0.13,0.18,0.2,0.4,0.2,0.65v14.05C68.5,67.02,68.01,67.51,67.38,67.51z M5.74,65.27h60.52V53.46H5.74V65.27z M6.75,51.22h58.5	l-8.99-13.13H15.74L6.75,51.22z M16.25,35.84h39.47V20.49H16.25V35.84z M16.37,13.59h20.15V6.73H16.37V13.59z M38.89,60.57h-6.77	c-0.63,0-1.12-0.49-1.12-1.12c0-0.63,0.49-1.12,1.12-1.12h6.77c0.63,0,1.12,0.49,1.12,1.12C40.01,60.07,39.52,60.57,38.89,60.57z",
  INTERNSHIP: "M55.9,47.9c-0.2-0.7-0.5-1.3-1.1-1.8c-0.6-0.5-1.3-0.8-2-0.9L41,42.8l3.4,2.3L39,62.3l-3-10.5l-3,10.5l-5.4-17.2l3.4-2.3 l-11.8,2.3c-0.7,0.1-1.4,0.4-2,0.9c-0.6,0.5-0.9,1.1-1.1,1.8l-3.5,15.6l6.6,2.3c2.2,2.3,8.3,4,15.7,4.2H36h1.1 c7.4-0.2,13.5-1.9,15.7-4.2l6.6-2.3L55.9,47.9z M36,42.8l-3.3,1.4l3.3,5.4l3.3-5.4L36,42.8z M18.7,30.7h-4.9l1.6-5.9V14.6l1.6,0.7 v9.5L18.7,30.7z M48.3,15.3l8.7-3.7L34.8,2l-19.4,8.3l-2.8,1.2l2.9,1.2l1.6,0.7l4.2,1.8c-0.7,1.4-1.1,3.1-1.1,4.9l4.4,1.7 c-0.2,1-0.3,2-0.3,3.2c-0.7,0.7-1.4,2.1-0.4,4.6c0.4,1,1,2,1.8,2.6C28,37.8,32.4,42,36,42s8-4.1,10.4-9.7c0.7-0.7,1.4-1.6,1.8-2.6 c0.9-2.5,0.3-3.8-0.4-4.6c0-1.5-0.2-2.8-0.5-4l2.2-0.9C49.4,18.3,49,16.7,48.3,15.3z M44.8,25.8v0.9l0.8,0.4 c0.2,0.1,0.1,0.6-0.2,1.5c-0.3,0.7-0.8,1.4-1.1,1.6L44,30.5l-0.1,0.4c-2,4.8-5.7,8.2-7.8,8.2s-5.8-3.4-7.8-8.2L28,30.5l-0.3-0.2 c-0.4-0.3-0.9-0.9-1.1-1.6c-0.3-0.9-0.3-1.4-0.2-1.5l0.8-0.4v-0.9c0-0.9,0.1-1.9,0.2-2.8l7.4,2.9l9.7-3.7 C44.7,23.4,44.8,24.6,44.8,25.8z",
  WORKHOME: "M22.8,58.8c0.3,0,0.4,0.1,0.4,0.4v0.1c0,0.2,0,0.4,0,0.6c0,0.2-0.1,0.3-0.3,0.3c-1.2,0-2.4,0-3.6,0 c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0-0.5,0-0.7c0-0.3,0.1-0.4,0.4-0.4H22.8z M22.8,58.8c0.3,0,0.4,0.1,0.4,0.4v0.1c0,0.2,0,0.4,0,0.6 c0,0.2-0.1,0.3-0.3,0.3c-1.2,0-2.4,0-3.6,0c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0-0.5,0-0.7c0-0.3,0.1-0.4,0.4-0.4H22.8z M2,33.5h68v6.6 h-3.9v27.6h-4.5V39.8H35.3v27.9H5.4V40.1H2V33.5z M31.3,60.6V56c0-0.3-0.1-0.5-0.2-0.7c-0.2-0.3-0.4-0.5-0.7-0.6 c-0.9,0-1.9,0-2.8,0c-0.3,0-0.8,0.1-1,0.3c-0.8,0.5-1.4,1.2-2.2,1.7c-0.3,0.2-0.6,0.4-1,0.4c-0.8,0-1.6,0-2.3,0 c-0.8,0-1.6,0-2.3,0c-0.3,0-0.7-0.2-1-0.4c-0.7-0.6-1.4-1.2-2.2-1.7c-0.3-0.2-0.7-0.3-1-0.3c-0.9,0-1.9,0-2.8,0 c-0.3,0.1-0.6,0.3-0.7,0.6c-0.1,0.2-0.2,0.5-0.2,0.7v4.7c0,0.8,0.7,1.5,1.5,1.5h17.6C30.7,62.1,31.3,61.4,31.3,60.6z M31.3,49.3 v-4.7c0-0.3-0.1-0.5-0.2-0.7c-0.2-0.3-0.4-0.5-0.7-0.6c-0.9,0-1.9,0-2.8,0c-0.3,0-0.8,0.1-1,0.3c-0.8,0.5-1.4,1.2-2.2,1.7 c-0.3,0.2-0.6,0.4-1,0.4c-0.8,0-1.6,0-2.3,0c-0.8,0-1.6,0-2.3,0c-0.3,0-0.7-0.2-1-0.4c-0.7-0.6-1.4-1.2-2.2-1.7 c-0.3-0.2-0.7-0.3-1-0.3c-0.9,0-1.9,0-2.8,0c-0.3,0.1-0.6,0.3-0.7,0.6c-0.1,0.2-0.2,0.5-0.2,0.7v4.7c0,0.8,0.7,1.5,1.5,1.5h17.6 C30.7,50.8,31.3,50.1,31.3,49.3z M22.8,58.8c0.3,0,0.4,0.1,0.4,0.4v0.1c0,0.2,0,0.4,0,0.6c0,0.2-0.1,0.3-0.3,0.3 c-1.2,0-2.4,0-3.6,0c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0-0.5,0-0.7c0-0.3,0.1-0.4,0.4-0.4H22.8z M60.5,6.9c1.3,0,2,0.7,2,2v16 c0,1.4-0.6,2-2,2h-8.4c0,0.6,0.1,1.1,0.1,1.7c0,0.2,0.1,0.4,0.1,0.6c0.2,0.4,0.4,0.7,0.9,1c0.1,0.1,0.2,0.1,0.3,0.2 c0.3,0.2,0.5,0.3,0.8,0.5c0.2,0.1,0.3,0.2,0.3,0.5c0,0.3-0.3,0.2-0.5,0.2c-3.3,0-6.6,0-9.8,0c-0.1,0-0.1,0-0.2,0 c-0.2,0-0.3-0.2-0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.5-0.3,0.8-0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.2,0.7-0.6,0.8-1 c0-0.1,0.1-0.3,0.1-0.4c0.1-0.5,0.1-0.9,0.1-1.4c0-0.2,0-0.3,0-0.5c-2.8,0-5.6,0-8.4,0c-1.5,0-2.1-0.6-2.1-2.1 c0-5.3,0-10.5,0-15.8c0-1.5,0.6-2.1,2.1-2.1H60.5z M60,22.7c0.6,0,0.7-0.2,0.7-0.7c0-4.2,0-8.3,0-12.5c0-0.7,0-0.8-0.8-0.8h-0.9 c-3.6,0-17.9,0-20.5,0c-0.9,0-0.9,0-0.9,0.9v12.3c0,0.8,0,0.8,0.8,0.8C45.6,22.7,52.8,22.7,60,22.7z M22.8,47.5l-0.7,0h-2 c-0.2,0-0.5,0-0.7,0c-0.3,0-0.4,0.1-0.4,0.5c0,0.3,0,0.6,0,0.9c0,0.3,0.1,0.4,0.3,0.4c1.2,0,2.4,0,3.6,0c0.2,0,0.3-0.1,0.3-0.4 c0-0.2,0-0.5,0-0.7V48C23.2,47.6,23.1,47.5,22.8,47.5z M22.8,58.8h-3.4c-0.3,0-0.4,0.1-0.4,0.5c0,0.3,0,0.6,0,0.9 c0,0.3,0.1,0.4,0.3,0.4c1.2,0,2.4,0,3.6,0c0.2,0,0.3-0.1,0.3-0.4c0-0.2,0-0.5,0-0.7v-0.2C23.2,58.9,23.1,58.8,22.8,58.8z M22,4.3 L22,4.3c-0.2,0-0.4,0.1-0.6,0.2c-0.8,0.4-1.7,0.8-2.5,1.3C18.2,6,18,6.6,18.3,7.2c0.4,0.8,0.8,1.6,1.2,2.4c0.1,0.2,0.1,0.3,0,0.5 c-0.9,1.2-1.3,2.5-1.3,4c0,0.9,0.2,1.8,0.5,2.7c0.2,0.5,0.5,0.8,0.9,0.8h0c0.2,0,0.4-0.1,0.7-0.2c3.2-1.6,6.4-3.2,9.6-4.8 c0.7-0.3,0.9-1,0.4-1.6c-1.4-2.1-3.4-3.4-6-3.4c-0.2,0-0.3-0.1-0.3-0.2c-0.4-0.8-0.8-1.6-1.2-2.4C22.6,4.5,22.3,4.3,22,4.3z M5.2,18.1c0,1.1,0.9,2.1,2.1,2.1c1.1,0,2.1-0.9,2.1-2.1S8.4,16,7.3,16C6.1,16,5.2,16.9,5.2,18.1z M9.8,17.2 c1.9-1.9,3.8-3.8,5.9-5.8c0,0,0.1,0,0.2-0.1c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0 c1.1-0.2,1.8-1.4,1.6-2.5c-0.2-1-1.1-1.7-2.1-1.7c-0.1,0-0.2,0-0.4,0c-1.2,0.2-2,1.3-1.8,2.4c0,0.1,0,0.2-0.1,0.2 c-1.2,1.2-2.4,2.4-3.6,3.6c-0.7,0.7-1.4,1.4-2.2,2.1C9,15.8,9.6,16.4,9.8,17.2z M9.8,18.9c-0.3,0.8-0.9,1.4-1.6,1.7 c1.3,1.3,2.6,2.6,4.2,4.2c0.4,0.4,0.8,0.7,1.1,1.1c0.5-0.2,1-0.3,1.5-0.4c0.4-0.1,0.8-0.1,1.2-0.2C14.1,23.1,11.9,21,9.8,18.9z M17.4,31.4c1,0,2.1,0,3.1,0c0.9,0,1.7,0,2.6,0c0.6,0,0.9-0.3,0.8-0.9c0-0.5-0.2-0.9-0.4-1.3c-0.7-1.1-1.7-1.7-2.9-2.1 c-1.6-0.6-3.3-0.7-5.1-0.4c-1.2,0.2-2.3,0.6-3.3,1.3c-0.7,0.5-1.3,1.2-1.5,2.1c0,0.2-0.1,0.5,0,0.7c0.1,0.4,0.4,0.5,0.9,0.5 C13.6,31.4,15.5,31.4,17.4,31.4C17.4,31.4,17.4,31.4,17.4,31.4z",
  PARTTIME: "M49.5,60L49.5,60c0.7,0,1.3,0.6,1.3,1.3c0,2.8-2.3,5.1-5.1,5.1h-38c-3.1,0-5.6-2.5-5.6-5.6V11.2c0-3.1,2.5-5.6,5.6-5.6h37.9 c2.9,0,5.3,2.4,5.3,5.3c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-1.5-1.2-2.7-2.7-2.7H7.6c-1.7,0-3,1.4-3,3v49.6 c0,1.7,1.4,3,3,3h38c1.4,0,2.5-1.1,2.5-2.5C48.2,60.5,48.8,60,49.5,60z M70,36c0,11.3-9.2,20.5-20.5,20.5C38.2,56.5,29,47.3,29,36 s9.2-20.5,20.5-20.5C60.8,15.5,70,24.7,70,36z M57.5,36c0-0.7-0.6-1.3-1.3-1.3h-5.4V23.6c0-0.7-0.6-1.3-1.3-1.3 c-0.7,0-1.3,0.6-1.3,1.3V36c0,0.7,0.6,1.3,1.3,1.3h6.7C56.9,37.3,57.5,36.7,57.5,36z M33.4,14.6H12.1c-0.7,0-1.3,0.6-1.3,1.3 c0,0.7,0.6,1.3,1.3,1.3h0h21.3c0.7,0,1.3-0.6,1.3-1.3C34.7,15.2,34.1,14.6,33.4,14.6z M28.9,20.5H12.1c-0.7,0-1.3,0.6-1.3,1.3 c0,0.7,0.6,1.3,1.3,1.3h16.8c0.7,0,1.3-0.6,1.3-1.3C30.2,21.1,29.6,20.5,28.9,20.5z M24.1,29c0.7,0,1.3-0.6,1.3-1.3 c0-0.7-0.6-1.3-1.3-1.3H12.1c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3H24.1z M24.1,35c0.7,0,1.3-0.6,1.3-1.3 c0-0.7-0.6-1.3-1.3-1.3H12.1c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3H24.1z M24.1,40.9c0.7,0,1.3-0.6,1.3-1.3 s-0.6-1.3-1.3-1.3H12.1c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3H24.1z M24.1,46.8c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3H12.1 c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3H24.1z M12.1,50.1c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h16.8 c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3H12.1z M12.1,58.6h21.3c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3H12.1 c-0.7,0-1.3,0.6-1.3,1.3C10.8,58,11.4,58.6,12.1,58.6z",
  FULLTIME: "M59.4,44c-0.2-0.8-0.6-1.5-1.3-2.1c-0.7-0.6-1.5-1-2.4-1.1l-13.8-2.7l4,2.7l-6.3,20.2L36,48.6l-3.6,12.3l-6.3-20.2l4-2.7 l-13.8,2.7c-0.9,0.1-1.7,0.5-2.4,1.1c-0.7,0.6-1.1,1.3-1.3,2.1L8.5,62.4l7.7,2.7c2.6,2.7,9.8,4.7,18.4,4.9H36h1.3 c8.6-0.2,15.8-2.2,18.4-4.9l7.7-2.7L59.4,44z M36,38.1l-3.9,1.6l3.9,6.4l3.9-6.4L36,38.1z M36,36.9c-4.1,0-9.3-4.9-12-11.3 c-0.9-0.8-1.6-1.9-2.1-3.1c-1.1-2.9-0.3-4.4,0.5-5.2C22.7,7.6,27.6,2,36,2c8.4,0,13.3,5.6,13.5,15.4c0.8,0.8,1.6,2.3,0.5,5.2 c-0.4,1.2-1.2,2.3-2.1,3.1C45.3,32,40.1,36.9,36,36.9z M36,5c-8.7,0-10.5,7.1-10.5,13.1v0.9l-0.8,0.4c-0.5,0.3,0,1.7,0.1,2 c0.3,0.9,1,1.7,1.4,2l0.3,0.2l0.2,0.4c2.3,5.7,6.8,9.8,9.4,9.8s7-4,9.3-9.8l0.2-0.4l0.3-0.2c0.5-0.4,1.1-1.1,1.4-2 c0.1-0.3,0.6-1.7,0.1-2l-0.8-0.4v-0.9C46.5,12.2,44.7,5,36,5z",
  GOVERNMENT: "M2,65.2h68v4H2V65.2z M6.6,63.2h58.9v-6.4H6.6V63.2z M6.6,30.4h58.9v-3.2H6.6V30.4z M10.3,55.1h7.7V32h-7.7V55.1z M24.9,55.1h7.7V32h-7.7V55.1z M39.5,55.1h7.7V32h-7.7V55.1z M54,55.1h7.7V32H54V55.1z M61.6,25.7C60.1,12.8,49.2,2.8,36,2.8 s-24.1,9.9-25.5,22.8H61.6z",
  WORKABROAD: "M14.7,63.8L14.7,63.8c-0.1-0.1-0.1-0.1-0.2-0.1C14.6,63.7,14.6,63.7,14.7,63.8z M53.1,49c0.3-1.5,0.5-3,0.6-4.5 c-1,0.9-2.2,1.6-3.5,2.3c-2.4,1.4-4.9,2.8-4.9,4.8c0,0.5-0.2,0.9-0.5,1.3c-0.7,0.8-2.1,0.7-3.6,0.7c-1.2,0-2.8,0-3.3,0.5 c-0.7,0.6-1.4,0.8-2.2,0.8c-1.6,0-3.4-1-4.4-1.7c-0.1,0-0.5-0.1-0.8-0.1c-0.9-0.1-2.1-0.3-2.6-1.1c-0.2-0.3-0.4-0.9-0.1-1.7 c0.7-2.1,2.5-2.3,4-2.5c0.4-0.1,0.8-0.1,1.3-0.2c1.4-0.3,3-1.3,3.6-1.8c-5.4-3.1-6.7-8.7-6.9-9.9c-0.2-0.4-0.1-0.9-0.1-1.5 c0.1-2.2-0.1-2.7-0.3-2.8c-0.6-0.2-1-0.2-1.6-0.3c-0.9-0.1-2-0.2-3.5-0.9c-2.4-1.1-2.2-2.8-1.8-5c0.1-0.5,0.2-1.2,0.3-1.8 c0.2-2.1,0.8-3.4,1.4-4.3C14.9,20.9,7.4,27.9,5,37.4c3.3,0.7,6.8,1.9,6.6,3.8c0,0.3-0.1,0.7-0.1,1c-0.2,1.3-0.3,2.2,0.2,2.6 c0.1,0,0.5-0.3,0.7-0.5c0.5-0.4,1.7-1.4,2.7-0.3c0.3,0.3,0.7,0.6,1.2,1c1.4,1,3,2.2,2.6,3.7c-0.1,0.5-0.3,1.1-0.5,1.7 C18.3,50.9,18,51.7,18,52c0.5,0.8,2.4,4,2.2,4.8c0,0,0,0.4,0,0.6c0.1,1.3,0.1,2.3-0.3,2.9c-0.2,0.3-2.1,3.1-3.9,4.3 c2.2,1.4,4.7,2.4,7.3,3c1.8,0.4,3.7,0.6,5.5,0.6C40.6,68.3,50.5,60.4,53.1,49z M42,26.6l-6.9-1.1L33.6,27l6.8,3.4l0.8,0.8l3.4,6.8 l1.4-1.5l-1.7-6.7l0.6-0.3c0.5-0.3,1-0.6,1.5-1.1l7.4-6.8l9,16.4l0.6,0.5l-0.6-0.6l2.8-2.8L60,15.9l6.7-6.3c1.4-1.4,1.5-3.6,0.2-4.9 c-0.6-0.6-1.4-0.9-2.3-0.9c-1,0-1.9,0.4-2.6,1.1l-6.3,6.8l-19-5.7l-2.9,2.9l16.2,8.9L43.1,25C42.7,25.5,42.3,26,42,26.6z M69.5,7 c0,1.4-0.5,2.8-1.6,3.8l-6,5.6l5.7,19.1l-3.6,3.6c-0.7,0.7-1.8,0.7-2.5,0L61.5,39l-0.1-0.1l-8-14.6L50,27.5c0.5,0.6,0.9,1.2,1.3,1.9 c2.3,3.7,3.7,7.8,4,12h0c0,0,0,0.1,0,0.1c0.2,2.6,0,5.3-0.6,7.9C52,61.5,41.4,70,29,70c-2,0-4-0.2-5.9-0.7 c-6.9-1.6-12.8-5.7-16.5-11.7c-2.7-4.3-4.1-9.1-4.1-14.1v0c0-2,0.2-4,0.7-5.9C5.9,25.5,16.5,17,28.9,17c2,0,4,0.2,5.9,0.7 c3.3,0.8,6.4,2.1,9.1,4l3.2-3.5l-14.5-8L32.6,10C32.2,9.7,32,9.3,32,8.8c0-0.5,0.2-0.9,0.5-1.2L36.1,4l19,5.7l5.6-6 C61.8,2.6,63.1,2,64.6,2c1.3,0,2.6,0.5,3.5,1.4C69,4.4,69.5,5.7,69.5,7L69.5,7z",
  RIGHTARROW: "15,62 41,36 15,10 23,2 57,36 23,70",
  TICK: "M20.8857143,58 C19.72,58 18.5542857,57.42 17.68,56.4533333 L1.65142857,39.3433333 C4.3298698e-15,37.6033333 0.0971428571,34.8 1.84571429,33.1566667 C3.59428571,31.5133333 6.41142857,31.61 8.06285714,33.35 L20.7885714,46.8833333 L59.84,1.74 C61.3942857,-0.0966666667 64.2114286,-0.29 65.96,1.25666667 C67.8057143,2.80333333 68,5.60666667 66.4457143,7.34666667 L24.1885714,56.3566667 C23.4114286,57.3233333 22.2457143,58 20.8857143,58 L20.8857143,58 L20.8857143,58 Z",
  SEARCH: "M50.6,44.8h-3.1l-1.1-1c3.8-4.4,6.1-10.2,6.1-16.4C52.5,13.3,41.2,2,27.3,2S2,13.3,2,27.3s11.3,25.3,25.3,25.3 c6.3,0,12-2.3,16.4-6.1l1,1.1v3.1L64.2,70l5.8-5.8L50.6,44.8L50.6,44.8z M27.3,44.8c-9.7,0-17.5-7.8-17.5-17.5S17.6,9.8,27.3,9.8 s17.5,7.8,17.5,17.5S37,44.8,27.3,44.8z",
  cook: "M43.4,47.5c0.7,0,1.2,0.5,1.2,1.2v8.3h6V44.4c0-1.2,1-2.3,2.3-2.3c8.1,0,14.7-6.6,14.7-14.6 c0-8.1-6.6-14.6-14.7-14.6h-1l0.1,0.1c0.8,1.9,1.1,3.9,1.1,6v4.2c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2v-4.2 c0-8.1-6.6-14.6-14.7-14.6c-8.1,0-14.7,6.6-14.7,14.6v4.2c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2v-4.2c0-2,0.4-4,1.1-6l0-0.1 h-0.9c-8.1,0-14.7,6.6-14.7,14.6c0,8.1,6.6,14.6,14.7,14.6c1.3,0,2.3,1,2.3,2.3v12.5h6v-8.3c0-0.7,0.5-1.2,1.2-1.2 c0.7,0,1.2,0.5,1.2,1.2v8.3h5V46.5c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2v10.4h5v-8.3C42.2,47.9,42.7,47.5,43.4,47.5 L43.4,47.5z M21.2,69.9c-1.3,0-2.3-1-2.3-2.3V44.6l-0.1,0C9.5,44.5,2,36.8,2,27.6c0-9.4,7.7-17,17.1-17h2.1C24.3,5.3,30,2.1,36,2.1 c6.1,0,11.7,3.2,14.7,8.4l0,0.1h2.2c9.4,0,17.1,7.6,17.1,17c0,9.3-7.5,16.9-16.8,17l-0.1,0v23.1c0,1.2-1,2.3-2.3,2.3H21.2z",
  Marketing: "M61.7,20.2v-11c0-1.2-0.6-2.3-1.7-2.9c-1-0.6-2.3-0.6-3.4,0c-10.1,5.7-21.1,9-32.6,9.8c-0.1,0-10.5,0.1-10.5,0.1 c-2.6,0-4.8,2-5.1,4.5H6.3C3.9,20.7,2,22.7,2,25v9.4c0,2.4,1.9,4.3,4.3,4.3h2.1c0.2,1.8,1.4,3.4,3,4.1l7.6,21.1 c0.5,1.3,1.7,2.2,3.1,2.2h7.7c1.1,0,2.1-0.5,2.7-1.4c0.6-0.9,0.8-2,0.4-3.1l-6.6-18.1c10.7,1.1,20.9,4.3,30.3,9.6 c0.5,0.3,1.1,0.4,1.6,0.4c0.6,0,1.2-0.2,1.7-0.5c1-0.6,1.7-1.7,1.7-2.9v-11c4.7-0.6,8.3-4.6,8.3-9.5C70,24.9,66.4,20.8,61.7,20.2z M8.4,35.4H6.3c-0.5,0-1-0.4-1-1V25c0-0.5,0.4-1,1-1h2.1V35.4z M29.9,62.8C29.9,62.8,29.9,62.8,29.9,62.8 C29.9,62.8,29.9,62.8,29.9,62.8l-7.7,0.1c0,0,0,0,0,0l-7.1-19.6h7.8L29.9,62.8z M58.4,50.2C58.4,50.2,58.4,50.2,58.4,50.2 c-0.1,0.1-0.1,0.1-0.1,0.1c-10.1-5.7-21-9.1-32.6-10.1V19.3c11.5-1.1,22.5-4.5,32.6-10.1c0,0,0,0,0.1,0c0,0,0,0,0,0.1V50.2z",
  Sales: "M66.7,67.3c0.7,0,1.3,0.6,1.3,1.3S67.5,70,66.7,70H5.3C4.5,70,4,69.4,4,68.7s0.6-1.3,1.3-1.3h3.1v-12c0-2,1.6-3.6,3.6-3.6 h6.5c2,0,3.6,1.6,3.6,3.6v12h7.4V44.2c0-2,1.6-3.6,3.6-3.6h6.5c2,0,3.6,1.6,3.6,3.6v23.1h7.4V25.1c0-2,1.6-3.6,3.6-3.6h6.5 c2,0,3.6,1.6,3.6,3.6v42.3H66.7 M54.7,2c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h4.9L46.6,17.8l-4.9-4.9 c-0.2-0.2-0.6-0.4-0.9-0.4c-0.4,0-0.7,0.1-0.9,0.4L16,36.7c-0.5,0.5-0.5,1.4,0,1.9c0.3,0.3,0.6,0.4,0.9,0.4s0.7-0.1,0.9-0.4 l22.8-22.9l4.9,4.9c0.5,0.5,1.4,0.5,1.9,0l14-14V11c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3V3.5c0,0,0,0,0-0.1 c0-0.4-0.1-0.7-0.4-1",
  Nurse: "M37.8,18.5c1.5,0,3.9-0.1,6.3,0.1c1.2,0.1,2.4,0.3,3.6,0.8c1.4,0.5,2.7,1.1,4.1,1.8c1.7,0.8,2.9,2.1,3.5,4 c1.3,4,2.1,8,2.1,12.1c0,1-0.1,2.1-0.4,3.1c-0.7,2.1-2.1,3.2-4.3,3.5c-1,0.1-2,0.3-3-0.1c-0.3-0.1-0.4,0.1-0.5,0.3 c-3.9,4.5-8.9,6.5-14.8,5.9c-4.3-0.4-7.9-2.2-10.7-5.4c-0.4-0.4-0.7-0.5-1.2-0.4c-1.2,0.3-2.5,0.4-3.8,0.2c-1.3-0.3-2.2-1-2.7-2.2 c-0.6-1.3-0.8-2.6-0.9-4c-0.2-3.1-0.1-6.3,1-9.2c2.2-5.9,6.6-9,12.6-10C31.2,18.5,34.1,18.5,37.8,18.5z M41.7,23.4 c-1,2.7-3,3.9-5.3,4.6c-2.3,0.7-4.7,1-7,1.2c-1.7,0.1-3.4,0.1-5,0.6c-1.2,0.4-1.6,0.9-1.5,2.1c0.1,1.2,0.2,2.4,0.3,3.7 c0.3,2.5,1.2,4.8,2.1,7.2c0.2,0.5,0.5,0.9,0.9,1.3c2.5,2.3,5.4,3.6,8.8,3.8c5.2,0.4,9.5-1.4,12.8-5.5c0.1-0.2,0.3-0.3,0.2-0.6 c-0.4-1.7-0.1-3.4,0.3-5c0.4-1.6,0.8-3.3,0.8-4.9c0-1.9-0.8-3.3-2.6-4c-0.4-0.2-0.9-0.4-1.3-0.6C43.4,26.3,41.9,25.5,41.7,23.4z M44.6,69.9c0.2,0,0.5,0,0.7,0c4,0,8.1,0,12.1,0c4,0,7.9,0,11.9,0c0.6,0,0.7-0.2,0.7-0.7c-0.1-0.8-0.1-1.7-0.2-2.5 c-1.5-9.7-8.9-16.8-18.6-17.8c-0.7-0.1-0.6,0.1-0.5,0.6c0.8,2.3,1.6,4.7,2.4,7c0.2,0.4,0.1,0.6-0.4,0.8c-1.3,0.4-2.7,0.9-4.1,1.4 c0.9,0.9,1.8,1.7,2.7,2.5c0.4,0.4,1.1,0.8,1.1,1.1c0,0.5-0.7,0.8-1.1,1.2c-2.2,2.1-4.5,4.1-6.7,6.2C44.6,69.8,44.6,69.8,44.6,69.9z M19.4,57.3c-0.6-0.2-0.6-0.4-0.4-0.9c0.8-2.3,1.6-4.6,2.4-6.9c0.2-0.5,0.1-0.7-0.4-0.6c-0.5,0.1-1,0.1-1.5,0.2 C9.7,50.6,2.1,59.3,2,69.1c0,0.6,0.2,0.8,0.8,0.8c7.9,0,15.9,0,23.8,0c0.3,0,0.6,0.1,0.8-0.1c-0.1-0.3-0.3-0.4-0.5-0.6 c-2.3-2.1-4.6-4.3-7-6.4c-0.4-0.4-0.4-0.5,0-0.9c1.1-1,2.2-2.1,3.4-3.3C21.9,58.2,20.7,57.7,19.4,57.3z M23.2,61.9 c-0.4,0.4-0.4,0.6,0,1c2.1,1.9,4.3,3.8,6.3,5.9c0.9,0.9,1.9,1.4,3.2,1.2c0.6-0.1,0.7-0.2,0.4-0.7c-2.6-6.6-5.2-13.3-7.8-20 c-0.2-0.6-0.6-0.5-1-0.5c-0.5,0-0.6,0.2-0.7,0.6c-0.6,1.9-1.3,3.8-1.9,5.7c-0.2,0.6-0.1,0.7,0.5,0.9c1.7,0.6,3.5,1.2,5.3,1.8 C26,59.2,24.6,60.5,23.2,61.9z M45.3,57.4c1.5-0.5,3.1-1.1,4.6-1.6c0.5-0.2,0.5-0.3,0.4-0.8c-0.7-1.9-1.3-3.7-1.9-5.6 c-0.1-0.4-0.2-0.8-0.8-0.7c-0.5,0-0.8,0.1-1,0.7C44,56,41.4,62.6,38.9,69.1c-0.2,0.6-0.2,0.7,0.5,0.8c1.2,0.1,2.2-0.3,3.1-1.2 c2-2,4.2-3.9,6.3-5.9c0.5-0.5,0.4-0.7,0-1.1c-1.4-1.3-2.8-2.6-4.3-4C44.8,57.6,45,57.5,45.3,57.4z M50.8,19.6l-1.9-1.2l5.8-9.6 c-5.9-3-12-4.5-18-4.6c-6.1,0-12.4,1.5-18.7,4.6l4.7,9.6l-2,1L14.9,7.9l1-0.5c6.9-3.6,13.8-5.4,20.6-5.4c0.1,0,0.1,0,0.2,0 c6.7,0,13.5,1.8,20.1,5.4l1,0.6L50.8,19.6z M37.6,15.5h-2.3v-3.2h-3.2v-2.3h3.2V6.9h2.3v3.2h3.2v2.3h-3.2V15.5z",
  Beautician: "M60,43h-9.8V23.5c0-0.7-0.6-1.3-1.3-1.3H41c-0.7,0-1.3,0.6-1.3,1.3V43H36v-3.4c0-0.7-0.6-1.3-1.3-1.3h-2.5v-8.1 c0-1.5-1.2-2.7-2.7-2.7h-0.4V11.3c0-1.3,0-2.6-0.5-3.9v0c-0.8-2.2-2.3-3.9-4.2-4.8c-1.4-0.7-3-0.8-4.4-0.3c-2.1,0.7-3.8,2.7-3.8,5 c0,2.7,0,20.2,0,20.2h-0.4c-1.5,0-2.7,1.2-2.7,2.7v8.1h-2.5c-0.7,0-1.3,0.6-1.3,1.3v29c0,0.7,0.6,1.3,1.3,1.3H60 c1.5,0,2.7-1.2,2.7-2.7V45.7C62.7,44.2,61.5,43,60,43z M21,4.9c0.3-0.1,0.6-0.2,0.9-0.2c0.6,0,1,0.2,1.4,0.3 c1.2,0.6,2.2,1.8,2.8,3.3c0.9,2.5,0.1,5.3-1.8,5.9c-0.9,0.3-1.8,0.1-2.3-0.2c-1.2-0.6-2.2-1.8-2.8-3.3C18.3,8.2,19.2,5.5,21,4.9z M29.5,38.3H15.9v-8.1h13.6V38.3z M60,67.3H29.9l0-21.6l30.2,0V67.3z",
  Hospitality: "M12.2,53.7c0.8-6.8,4.5-26.4,20.9-29.3c0,0-15.3,8.2-15.3,29.3h46.8c0.1-1,0.1-1.9,0.1-2.9c0-14.5-10.8-26.5-24.8-28.4 c1-1,1.6-2.3,1.6-3.8c0-3-2.5-5.5-5.5-5.5s-5.5,2.5-5.5,5.5c0,1.5,0.6,2.8,1.5,3.8c-14,1.9-24.8,13.9-24.8,28.4c0,1,0.1,2,0.1,2.9 H12.2z M36,15c1.9,0,3.5,1.6,3.5,3.5S37.9,22,36,22s-3.5-1.6-3.5-3.5S34.1,15,36,15z",
  HR: "M57.2,41.2c-6.1-0.3-11.2,4.5-11.5,10.6c-0.3,6.1,4.5,11.2,10.6,11.5c1.9,0.1,3.7-0.3,5.3-1.2l0.3-0.1l0,0l4.1,4.5 c0.5,0.5,0.9,0.7,1.6,0.7l0,0c0.6,0,1.3-0.1,1.6-0.6c0.5-0.5,0.7-0.9,0.7-1.6c0-0.6-0.1-1.1-0.6-1.6l-4.1-4.5l0.2-0.3 c1.2-1.7,1.9-3.8,2-6C68,46.4,63.3,41.4,57.2,41.2z M56.5,59.1c-3.8-0.2-6.7-3.3-6.6-7.2s3.3-6.7,7.2-6.6c3.8,0.2,6.7,3.3,6.6,7.2 C63.5,56.3,60.3,59.3,56.5,59.1z M45.9,65.6c-4.7,0.7-9.9,0.9-14.6,0.9c0,0,0,0,0,0c0,0,0,0,0,0c-11.6,0-25.8-1.6-28.5-6.7 c-0.2-0.4-0.4-0.9-0.5-1.4c-0.2-1-0.2-2.2,0.1-3.2c1.1-3.9,2.6-6.5,4.1-8.2c2.9-3.4,5.8-3.7,6.7-3.9c2.6-0.6,5.7-0.4,7.4-0.9 c0.2,1.6,5,7.1,8.1,10.5l1.3-5.2c-1-0.6-1.2-1.9-1.2-3h5.2c0,1.1-0.2,2.4-1.2,3l1.4,5.2c3.1-3.4,7.9-8.8,8.1-10.5 c0.2,0,0.3,0.1,0.5,0.1c-1.8,2.6-2.9,5.7-3.1,9.2C39.3,57.2,41.8,62.3,45.9,65.6z M45.9,21c0-0.6,0-1.2,0-1.8 c0-8.7-5.1-13.7-13.1-14.3c-7-0.5-12.3,2.3-14.7,6.9c-0.8,1.6-1.3,3.5-1.5,5.6c-0.3,1.1-0.4,2.2-0.4,3.4h0c0,0,0,0,0,0c0,0,0,0,0,0 c-1,0.2-1.5,2.4-1,4.9c0.4,2.3,1.5,4.1,2.4,4.2c1.2,3.3,3.2,6.5,5.6,8.8c1.4,1.3,2.8,2.4,4.4,3c0.5,0.2,1,0.3,1.4,0.4h4 c0.5-0.1,1-0.3,1.4-0.4c1.7-0.7,3.2-1.7,4.6-3.2c2.3-2.3,4.2-5.5,5.4-8.7c0.9-0.3,1.9-2,2.3-4.2C47.2,23.5,46.8,21.4,45.9,21z M44.3,26.2c-0.1,0.5-0.2,0.9-0.3,1.3c-0.1,0.3-0.2,0.5-0.3,0.7c-0.2,0.3-0.4,0.5-0.5,0.7C43,28.9,42.9,29,42.8,29h0l-0.1,0 c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.2c-1.1,3.4-3.2,6.9-5.9,9c-0.8,0.6-1.6,1.1-2.5,1.4c0,0,0,0,0,0l-1,0.3 c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0h-0.1l-0.4,0h-0.1c-0.3,0-0.6,0.1-0.8,0.1c-0.7,0-1.4-0.1-2-0.3 c-0.4-0.1-0.9-0.3-1.3-0.5c-0.6-0.3-1.2-0.7-1.8-1.1c-0.8-0.7-1.6-1.4-2.4-2.3c-0.3-0.4-0.6-0.7-0.8-1.1c-0.4-0.6-0.8-1.2-1.1-1.8 c-0.7-1.2-1.2-2.5-1.7-3.9c-0.1,0.1-0.2,0.1-0.3,0.2h-0.1c-0.2,0-0.4-0.1-0.6-0.3c-0.3-0.3-0.6-0.8-0.8-1.4 c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.1,0-0.2c0-0.8,0-1.6,0.1-2.3c0-0.1,0.1-0.3,0.2-0.4 c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0l0.2-0.1h0.1c0.2,0,0.3,0.1,0.5,0.2c0,0,0,0,0,0c0,0,0,0,0,0v0 c0-0.5,0.6-4.4,3.8-5.5c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l0.5-0.2c0,0,0,0,0,0c0.6-0.1,1.2-0.1,1.9-0.1c0,0,4.8,1.8,9.2,0.2H36 c1.8,0.1,3.1,1,4.4,1.6c0-0.6-0.5-1.2-0.5-1.6v0c0.2,0.1,0.4,0.2,0.6,0.3c0.9,1,1.8,2.7,2.6,5.4c0,0,0,0,0,0s0,0,0,0l0,0 c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.2-0.1,0.3,0c0,0,0.1,0,0.1,0C44.3,23.2,44.6,24.6,44.3,26.2z M32.6,39.7c0.1,0,0.1,0,0.2,0 c0,0,0,0,0.1,0c0,0,0,0-0.1,0C32.7,39.7,32.6,39.7,32.6,39.7z M31.9,39.8l0.4,0c0,0,0.1,0,0.1,0h-0.1L31.9,39.8z M29,39.6 c0.7,0.2,1.3,0.3,2,0.3c0.3,0,0.6-0.1,0.8-0.1c-0.3,0-0.6,0.1-0.8,0.1C30.3,39.9,29.6,39.8,29,39.6z",
  OfficeHelper: "M28.2,22.6l-6.2,3.3c-0.4-2-0.8-5.1,0.4-6.3C24.3,17.6,26.8,20.6,28.2,22.6z M15.5,9.4c-2.2,0-4,1.8-4,4s1.8,4,4,4 s4-1.8,4-4S17.7,9.4,15.5,9.4z M58.6,45.6v21.5c0,1.3-1,2.3-2.3,2.3H30.2c-1.3,0-2.3-1-2.3-2.3V45.6c0-1.3,1-2.3,2.3-2.3h26.1 C57.6,43.4,58.6,44.4,58.6,45.6z M34.8,45.6h-3.4v21.5h3.4V45.6z M34.8,30.9V20.7c0-0.3,0.1-0.5,0.3-0.7l5.9-6.8 c0.2-0.2,0.5-0.4,0.8-0.4c0.3,0,0.6,0.1,0.8,0.3l6.6,6.8c0.2,0.2,0.3,0.5,0.3,0.8v6.8c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1v-3.4 h-1.7v10.8c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1V24.1H41V41c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1V24.1H37v6.8 c0,0.6-0.5,1.1-1.1,1.1C35.3,32,34.8,31.5,34.8,30.9z M37,21.8h2.8h7.4v-0.7L44,17.9h-4.2L37,21.1V21.8z M25.1,47.9 c-0.6,0-1.1,0.5-1.1,1.1v17.6c0,0.6-0.5,1.1-1.1,1.1H8.1c-0.6,0-1.1-0.5-1.1-1.1V5.4c0-0.6,0.5-1.1,1.1-1.1h14.7 c0.6,0,1.1,0.5,1.1,1.1v9c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-9c0-1.9-1.5-3.4-3.4-3.4H8.1C6.3,2,4.7,3.5,4.7,5.4v61.2 c0,1.9,1.5,3.4,3.4,3.4h14.7c1.9,0,3.4-1.5,3.4-3.4V49C26.3,48.4,25.8,47.9,25.1,47.9z M66.7,26.6l-10.9-6 c-0.6-0.3-1.2-0.1-1.5,0.5L43.3,41c-0.3,0.6-0.1,1.2,0.5,1.5c0.2,0.1,0.4,0.1,0.5,0.1c0.4,0,0.8-0.2,1-0.6l0.4-0.6l1.9,1.1 c0.5,0.3,1.2,0.1,1.5-0.4c0.3-0.5,0.1-1.2-0.4-1.5l-1.9-1.1l1.5-2.8l4.1,2.1c0.6,0.3,1.2,0.1,1.5-0.5c0.3-0.6,0.1-1.2-0.5-1.5l-4-2 l1.3-2.5l2.6,1.3c0.6,0.3,1.2,0.1,1.5-0.5c0.3-0.6,0.1-1.2-0.5-1.5l-2.5-1.2l1.3-2.5l3.8,1.9c0.6,0.3,1.2,0.1,1.5-0.5 c0.3-0.6,0.1-1.2-0.5-1.5l-3.7-1.9l1.4-2.6l9,4.9l-7,12.9c-0.3,0.6-0.1,1.2,0.5,1.5c0.6,0.3,1.2,0.1,1.5-0.5l7.6-13.9 C67.4,27.6,67.2,26.9,66.7,26.6z M22.5,34c-0.2-0.5,0-1.1,0.5-1.4l0.9-0.5c1.3,3.6,2.7,6.9,4.2,10.1h10.2 c-2.3-6.8-9.1-18.1-9.1-18.1s-0.1-0.2-0.3-0.6L22.2,27c0.1,0.3,0.1,0.5,0.1,0.5c0.2,0.8,0.5,1.6,0.8,2.4c0,0,0,0,0,0l-1.3,0.7 c-1.5,0.9-2.1,2.7-1.4,4.3l3.7,8.3c0.2,0.4,0.6,0.7,1,0.7c0.2,0,0.3,0,0.5-0.1c0.6-0.3,0.8-0.9,0.6-1.5L22.5,34z M21.7,60.4H9.3 c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1h12.5c0.6,0,1.1-0.5,1.1-1.1S22.4,60.4,21.7,60.4z M21.7,53.6H9.3c-0.6,0-1.1,0.5-1.1,1.1 c0,0.6,0.5,1.1,1.1,1.1h12.5c0.6,0,1.1-0.5,1.1-1.1C22.9,54.1,22.4,53.6,21.7,53.6z",
  Receptionist: "M68,60l-33,0c-0.6,0-1-0.4-1-1l0-47c0-0.6,0.4-1,1-1l33,0c0.6,0,1,0.4,1,1l0,47C69,59.6,68.5,60,68,60z M36,58l31,0l0-45 l-31,0L36,58z M4,60c-0.6,0-1-0.4-1-1l0-47c0-0.6,0.4-1,1-1s1,0.4,1,1l0,47C5,59.5,4.5,60,4,60z M64,27l0-8c0-1.1-0.9-2-2-2l-21,0 c-1.1,0-2,0.9-2,2l0,8c0,1.1,0.9,2,2,2l21,0C63.1,29,64,28.1,64,27z M17.5,4.2c-5.3,0-9.6,4.3-9.6,9.6l0,44.4 c0,5.3,4.3,9.6,9.6,9.6l4.1,0c5.3,0,9.6-4.3,9.6-9.6l0-44.4c0-5.3-4.3-9.6-9.5-9.6L17.5,4.2L17.5,4.2z M41.3,33.3 c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C38.6,34.5,39.8,33.3,41.3,33.3z M51.3,33.3 c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C48.6,34.5,49.8,33.3,51.3,33.3L51.3,33.3z M61.3,33.3 c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C58.5,34.5,59.8,33.3,61.3,33.3z M41.3,41.9 c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C38.6,43.1,39.8,41.9,41.3,41.9z M51.3,41.9 c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C48.6,43.1,49.8,41.9,51.3,41.9L51.3,41.9z M61.2,41.9 c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C58.5,43.1,59.8,41.9,61.2,41.9z M41.3,50.6 c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C38.6,51.8,39.8,50.6,41.3,50.6z M51.3,50.6 c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C48.6,51.8,49.8,50.6,51.3,50.6L51.3,50.6z M61.2,50.6 c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C58.5,51.8,59.7,50.6,61.2,50.6z",
  ITSoftware: "M66.3 10.4h-60.6c-2 0-3.7 1.7-3.7 3.7v43.8c0 2 1.7 3.7 3.7 3.7h60.6c2 0 3.7-1.7 3.7-3.7v-43.8c0-2-1.7-3.7-3.7-3.7zM23.7 14.2h24.5c0.6 0 1 0.4 1 1s-0.4 1-1 1h-24.5c-0.6 0-1-0.4-1-1 0.1-0.6 0.5-1 1-1zM13.1 14.2c0.6 0 1 0.4 1 1s-0.4 1-1 1c-0.6 0-1-0.4-1-1s0.5-1 1-1zM9.8 14.2c0.6 0 1 0.4 1 1s-0.4 1-1 1c-0.6 0-1-0.4-1-1s0.6-1 1-1zM6.7 14.2c0.6 0 1 0.4 1 1s-0.4 1-1 1c-0.6 0-1-0.4-1-1s0.4-1 1-1zM68.1 58c0 1-0.8 1.7-1.7 1.7h-60.7c-1 0-1.7-0.8-1.7-1.7v-38h64.2l-0.1 38zM27.7 43.9l-5.1-3.6 5.1-3.5-1.7-2.4-8.6 5.9 8.6 6 1.7-2.4zM41.8 29.1h-3.4l-8.3 21.5h3.4l8.3-21.5zM46 46.3l8.5-6-8.5-5.9-1.8 2.4 5.1 3.5-5.1 3.6 1.8 2.4z",
  Driver: "M35.98,68.5h-0.02c-8.67,0-16.83-3.41-22.95-9.55c-6.14-6.16-9.5-14.32-9.5-23.02\n\t\tc0-8.67,3.38-16.83,9.53-22.93c6.16-6.14,14.34-9.5,23.06-9.5c0.04,0,0.09,0,0.13,0c17.82,0.07,32.3,14.68,32.28,32.57\n\t\tC68.48,53.95,53.89,68.5,35.98,68.5z M35.96,66.26h0.02c16.68,0,30.26-13.54,30.28-30.19S52.79,5.81,36.22,5.74\n\t\tc-0.04,0-0.09,0-0.13,0c-8.14,0-15.76,3.14-21.47,8.83S5.74,27.84,5.74,35.93s3.14,15.71,8.83,21.43\n\t\tC20.29,63.1,27.89,66.26,35.96,66.26z M31.94,60.21c-0.04,0-0.07,0-0.11,0c-11.7-1.88-20.69-12.53-20.44-24.23\n\t\tc0.02-0.61,0.49-1.1,1.1-1.1c1.23-0.02,2.49,0.11,3.74,0.4c4.68,1.08,8.67,3.77,11.81,8c2.4,3.25,3.99,7.04,4.68,11.27\n\t\tc0.16,0.94,0.25,1.88,0.31,2.82l0.11,1.19c0.02,0.16,0,0.31,0,0.47c-0.02,0.31-0.2,0.67-0.45,0.85\n\t\tC32.48,60.07,32.21,60.21,31.94,60.21z M13.63,37.17c0.36,9.68,7.62,18.36,17.19,20.55v-0.16c-0.07-0.87-0.13-1.77-0.29-2.64\n\t\tc-0.65-3.88-2.08-7.33-4.28-10.31c-2.87-3.86-6.3-6.21-10.51-7.15C15.04,37.32,14.33,37.21,13.63,37.17z M39.92,60.21\n\t\tc-0.29,0-0.56-0.11-0.76-0.31c-0.25-0.22-0.38-0.56-0.36-0.92l0.09-1.17c0.04-0.74,0.09-1.46,0.18-2.17\n\t\tc0.52-3.83,1.7-7.33,3.59-10.4c2.64-4.44,6.21-7.53,10.6-9.21c1.84-0.72,3.86-1.1,5.98-1.14c0.09,0,0.27,0,0.47,0.04\n\t\tc0.52,0.11,0.9,0.56,0.9,1.1c0.04,13.25-10.42,22.68-20.55,24.18C40.03,60.21,39.97,60.21,39.92,60.21z M58.37,37.17\n\t\tc-1.52,0.11-2.96,0.43-4.3,0.96c-3.97,1.52-7.06,4.21-9.48,8.27c-1.7,2.82-2.82,6.03-3.27,9.53c-0.07,0.58-0.11,1.19-0.16,1.77\n\t\tC49.58,55.84,57.85,47.99,58.37,37.17z M58.06,29.25H13.97c-0.36,0-0.69-0.18-0.9-0.47c-0.2-0.29-0.27-0.67-0.16-1.01\n\t\tc2.31-7.22,9.84-15.4,20.91-16.34l0,0c13.2-1.12,22.35,7.67,25.31,16.32c0.11,0.34,0.07,0.72-0.16,1.01\n\t\tC58.77,29.07,58.41,29.25,58.06,29.25z M15.58,27.01h40.84c-3.27-7.53-11.66-14.23-22.41-13.34l0,0\n\t\tC24.7,14.48,18.16,20.89,15.58,27.01z M33.92,12.56L33.92,12.56L33.92,12.56z",
  Teacher: "M49,68.5c-0.3,0-0.5-0.1-0.7-0.3L37,56.9v7.6c0,0.6-0.4,1-1,1s-1-0.4-1-1v-7.6L23.7,68.2c-0.4,0.4-1,0.4-1.4,0 s-0.4-1,0-1.4L35,54.1v-4.6c0-0.6,0.4-1,1-1s1,0.4,1,1v4.6l12.7,12.7c0.4,0.4,0.4,1,0,1.4C49.5,68.4,49.3,68.5,49,68.5z M70.5,4.5 c0-0.6-0.4-1-1-1h-67c-0.6,0-1,0.4-1,1s0.4,1,1,1h67C70.1,5.5,70.5,5.1,70.5,4.5z M21,23.8l-1.8,5.1h3.6L21,23.8z M38.1,31.9 c0.4-0.1,0.7-0.3,1-0.5c0.2-0.3,0.4-0.7,0.4-1.2c0-0.4-0.1-0.8-0.3-1c-0.2-0.3-0.5-0.5-0.8-0.6c-0.4-0.1-1.1-0.2-2.3-0.2h-2.1V32 h2.4C37.3,32,37.9,31.9,38.1,31.9z M37.5,26c0.5-0.1,0.8-0.2,1.1-0.5c0.3-0.3,0.4-0.6,0.4-1.1c0-0.4-0.1-0.8-0.3-1 c-0.2-0.3-0.6-0.4-1-0.5c-0.3,0-1,0-2.3,0h-1.5V26h1.7C36.6,26,37.3,26,37.5,26z M6,8.6H66v38.1c0,0.4-0.4,0.8-0.8,0.8H6.9 c-0.4,0-0.8-0.4-0.8-0.8V8.6z M46.1,27.5c0,2.2,0.6,3.8,1.7,5.1c1.1,1.2,2.5,1.9,4.3,1.9c1.4,0,2.6-0.4,3.5-1.1 c0.9-0.7,1.6-1.8,2-3.3l-2.6-0.8c-0.2,1-0.6,1.7-1.1,2.2c-0.5,0.5-1.1,0.7-1.8,0.7c-1,0-1.7-0.4-2.3-1.1c-0.6-0.7-0.9-2-0.9-3.7 c0-1.6,0.3-2.8,0.9-3.5c0.6-0.7,1.4-1.1,2.4-1.1c0.7,0,1.3,0.2,1.8,0.6c0.5,0.4,0.8,1,1,1.7l2.6-0.7c-0.3-1.1-0.7-1.9-1.3-2.5 c-1-1-2.3-1.5-3.9-1.5c-1.8,0-3.3,0.6-4.4,1.9C46.7,23.5,46.1,25.3,46.1,27.5z M31.2,34.3h4.4c1.7,0,2.7,0,3.2-0.1 c0.7-0.1,1.3-0.3,1.8-0.6c0.5-0.4,0.9-0.8,1.1-1.4c0.3-0.6,0.4-1.2,0.4-1.8c0-0.8-0.2-1.5-0.6-2.1c-0.4-0.6-1-1-1.8-1.2 c0.6-0.3,1-0.7,1.3-1.2c0.3-0.5,0.5-1.1,0.5-1.8c0-0.6-0.1-1.1-0.4-1.6c-0.3-0.5-0.6-0.9-1-1.1c-0.4-0.3-0.9-0.5-1.4-0.6 c-0.5-0.1-1.3-0.1-2.3-0.1h-5.2V34.3z M14.5,34.3h2.8l1.1-3.1h5.2l1.1,3.1h2.9l-5.2-13.7h-2.8L14.5,34.3z",
  OfficeAssistant: "M28.2,22.6l-6.2,3.3c-0.4-2-0.8-5.1,0.4-6.3C24.3,17.6,26.8,20.6,28.2,22.6z M15.5,9.4c-2.2,0-4,1.8-4,4s1.8,4,4,4 s4-1.8,4-4S17.7,9.4,15.5,9.4z M58.6,45.6v21.5c0,1.3-1,2.3-2.3,2.3H30.2c-1.3,0-2.3-1-2.3-2.3V45.6c0-1.3,1-2.3,2.3-2.3h26.1 C57.6,43.4,58.6,44.4,58.6,45.6z M34.8,45.6h-3.4v21.5h3.4V45.6z M34.8,30.9V20.7c0-0.3,0.1-0.5,0.3-0.7l5.9-6.8 c0.2-0.2,0.5-0.4,0.8-0.4c0.3,0,0.6,0.1,0.8,0.3l6.6,6.8c0.2,0.2,0.3,0.5,0.3,0.8v6.8c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1v-3.4 h-1.7v10.8c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1V24.1H41V41c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1V24.1H37v6.8 c0,0.6-0.5,1.1-1.1,1.1C35.3,32,34.8,31.5,34.8,30.9z M37,21.8h2.8h7.4v-0.7L44,17.9h-4.2L37,21.1V21.8z M25.1,47.9 c-0.6,0-1.1,0.5-1.1,1.1v17.6c0,0.6-0.5,1.1-1.1,1.1H8.1c-0.6,0-1.1-0.5-1.1-1.1V5.4c0-0.6,0.5-1.1,1.1-1.1h14.7 c0.6,0,1.1,0.5,1.1,1.1v9c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-9c0-1.9-1.5-3.4-3.4-3.4H8.1C6.3,2,4.7,3.5,4.7,5.4v61.2 c0,1.9,1.5,3.4,3.4,3.4h14.7c1.9,0,3.4-1.5,3.4-3.4V49C26.3,48.4,25.8,47.9,25.1,47.9z M66.7,26.6l-10.9-6 c-0.6-0.3-1.2-0.1-1.5,0.5L43.3,41c-0.3,0.6-0.1,1.2,0.5,1.5c0.2,0.1,0.4,0.1,0.5,0.1c0.4,0,0.8-0.2,1-0.6l0.4-0.6l1.9,1.1 c0.5,0.3,1.2,0.1,1.5-0.4c0.3-0.5,0.1-1.2-0.4-1.5l-1.9-1.1l1.5-2.8l4.1,2.1c0.6,0.3,1.2,0.1,1.5-0.5c0.3-0.6,0.1-1.2-0.5-1.5l-4-2 l1.3-2.5l2.6,1.3c0.6,0.3,1.2,0.1,1.5-0.5c0.3-0.6,0.1-1.2-0.5-1.5l-2.5-1.2l1.3-2.5l3.8,1.9c0.6,0.3,1.2,0.1,1.5-0.5 c0.3-0.6,0.1-1.2-0.5-1.5l-3.7-1.9l1.4-2.6l9,4.9l-7,12.9c-0.3,0.6-0.1,1.2,0.5,1.5c0.6,0.3,1.2,0.1,1.5-0.5l7.6-13.9 C67.4,27.6,67.2,26.9,66.7,26.6z M22.5,34c-0.2-0.5,0-1.1,0.5-1.4l0.9-0.5c1.3,3.6,2.7,6.9,4.2,10.1h10.2 c-2.3-6.8-9.1-18.1-9.1-18.1s-0.1-0.2-0.3-0.6L22.2,27c0.1,0.3,0.1,0.5,0.1,0.5c0.2,0.8,0.5,1.6,0.8,2.4c0,0,0,0,0,0l-1.3,0.7 c-1.5,0.9-2.1,2.7-1.4,4.3l3.7,8.3c0.2,0.4,0.6,0.7,1,0.7c0.2,0,0.3,0,0.5-0.1c0.6-0.3,0.8-0.9,0.6-1.5L22.5,34z M21.7,60.4H9.3 c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1h12.5c0.6,0,1.1-0.5,1.1-1.1S22.4,60.4,21.7,60.4z M21.7,53.6H9.3c-0.6,0-1.1,0.5-1.1,1.1 c0,0.6,0.5,1.1,1.1,1.1h12.5c0.6,0,1.1-0.5,1.1-1.1C22.9,54.1,22.4,53.6,21.7,53.6z",
  Cashier: "M5.3 34.5c0 1.6 1.3 2.9 2.9 2.9h35.3c1.6 0 2.9-1.3 2.9-2.9s-1.3-2.9-2.9-2.9h-1.2v-27.3c0-2.2-1.8-4-4-4h-24.9c-2.2 0-4 1.8-4 4v27.3h-1.2c-1.6 0-2.9 1.3-2.9 2.9zM11.2 4.3c0-1.2 1-2.1 2.1-2.1h24.9c1.2 0 2.1 1 2.1 2.1v27.3h-29.1v-27.3zM15.7 50.5c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5zM36 50.7c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5zM15.7 60.8c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5zM36 61c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5zM34.4 23.5h-17.3c-0.5 0-1 0.4-1 1s0.4 1 1 1h17.3c0.5 0 1-0.4 1-1s-0.4-1-1-1zM34.4 16.9h-17.3c-0.5 0-1 0.4-1 1s0.4 1 1 1h17.3c0.5 0 1-0.4 1-1s-0.4-1-1-1zM47 13.8h-2.2c-0.5 0-1 0.4-1 1s0.4 1 1 1h2.2c1.6 0 2.9 1.3 2.9 2.9v48.3c0 1.6-1.3 2.9-2.9 2.9h-42.2c-1.6 0-2.9-1.3-2.9-2.9v-48.3c0-1.6 1.3-2.9 2.9-2.9h2.3c0.5 0 1-0.4 1-1s-0.4-1-1-1h-2.3c-2.6 0-4.8 2.1-4.8 4.8v48.3c0 2.6 2.1 4.8 4.8 4.8h42.2c2.6 0 4.8-2.1 4.8-4.8v-48.3c0.1-2.6-2.1-4.8-4.8-4.8zM67.2 13.8h-9c-2.6 0-4.8 2.1-4.8 4.8v48.3c0 2.6 2.1 4.8 4.8 4.8h9c2.6 0 4.8-2.1 4.8-4.8v-48.3c0-2.6-2.1-4.8-4.8-4.8z",
  ITHardware: "M37.5,66.5c-2.4,0-4.8-0.3-7.1-0.8c-0.6-0.1-1-0.8-0.9-1.4c0.1-0.6,0.8-1,1.4-0.9c0.3,0.1,0.7,0.1,1,0.2 c-0.8-0.8-1.5-1.9-2.2-3.1c-0.3-0.6-0.1-1.3,0.4-1.6s1.3-0.1,1.6,0.4c1.2,2.2,3.3,4.7,5.8,4.7c3.5,0,7.1-5.1,9.2-13.7 c-5.1-0.8-10.6-0.9-15.8-0.2c-0.6,0.1-1.2-0.4-1.3-1c-0.1-0.6,0.4-1.2,1-1.3c5.5-0.7,11.2-0.7,16.7,0.2c0.7-3.8,1.2-8.1,1.3-12.8 H30.7c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h17.8c-0.1-4.3-0.4-8.2-1.1-11.7c-3,0.5-6.1,0.8-9.3,0.8c-8.9,0-17.3-2-24.6-5.9 c-0.7,0.9-1.3,1.8-1.9,2.8c-0.3,0.5-1,0.7-1.6,0.4c-0.5-0.3-0.7-1-0.4-1.6c0.8-1.3,1.7-2.6,2.6-3.8c0,0,0.1-0.1,0.1-0.1 C18.5,6.5,27.7,2,37.5,2C47.8,2,57.1,6.9,63,14.5c0.1,0.1,0.1,0.1,0.1,0.2c4.2,5.4,6.7,12.2,6.7,19.6 C69.8,52.1,55.3,66.5,37.5,66.5z M48.9,50.9C47.5,56.6,45.5,61,43,63.7c6.5-1.2,12.3-4.6,16.6-9.3C56.3,52.9,52.7,51.7,48.9,50.9z M49.4,48.7c4.1,0.9,8.1,2.2,11.7,4c3.7-4.8,6-10.7,6.3-17.2H50.8C50.7,40.2,50.2,44.7,49.4,48.7z M50.8,33.1h16.7 c-0.2-6.1-2.3-11.7-5.7-16.4c-3.8,1.9-7.9,3.3-12.2,4.2C50.3,24.7,50.7,28.8,50.8,33.1z M28.2,19c6.1,1.1,12.7,1.2,18.8,0.2 c-2-9.2-5.8-14.8-9.4-14.8C33.8,4.3,30.2,10,28.2,19z M43,4.8c2.6,2.9,4.8,7.8,6.2,13.9c3.9-0.8,7.7-2.1,11.2-3.8 C56,9.7,49.9,6.1,43,4.8z M15,14.5c3.4,1.8,7,3.1,10.9,4c1.4-6.2,3.5-10.9,6-13.6C25.4,6.1,19.4,9.5,15,14.5z M24.6,21.6H5.9 c-2.1,0-3.7,1.7-3.7,3.7v41c0,2.1,1.7,3.7,3.7,3.7h18.6c2.1,0,3.7-1.7,3.7-3.7v-41C28.3,23.3,26.6,21.6,24.6,21.6z M15.3,63.2 c-2.1,0-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7C19,61.5,17.3,63.2,15.3,63.2z M22.1,34H8.4v-2.5h13.7V34z M22.1,29 H8.4v-2.5h13.7V29z",
  Warehouse: "M40.9,70c-3.6,0-6.5-2.9-6.5-6.5c0-0.1,0-0.2,0-0.4L5.8,53.6c-0.7-0.2-1.1-1-0.8-1.7c0.2-0.7,1-1.1,1.7-0.8L35,60.6 c1.1-2.2,3.3-3.6,5.9-3.6c0.5,0,0.9,0,1.4,0.1L56.5,8.9c0.6-2.2,3-3.5,5.2-2.9l4.4,1.2c0.7,0.2,1.1,0.9,0.9,1.6 c-0.2,0.7-0.9,1.1-1.6,0.9L61,8.6c-0.9-0.2-1.7,0.3-2,1.1L44.7,58.1c1.7,1.2,2.8,3.1,2.8,5.3C47.4,67.1,44.5,70,40.9,70z M37,63 c0,0.1,0,0.3,0,0.4c0,2.2,1.8,3.9,3.9,3.9s3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9c-1.7,0-3.1,1-3.7,2.5c0,0.2,0,0.4-0.1,0.6 C37.1,62.8,37.1,62.9,37,63z M49.3,6.9L33.7,2.1c-1.2-0.4-2.4,0.3-2.7,1.5l-4.8,15.6c-0.4,1.2,0.3,2.4,1.5,2.7l15.6,4.8 c1.2,0.4,2.4-0.3,2.7-1.5l4.8-15.6C51.1,8.4,50.5,7.2,49.3,6.9z M38.9,11.1l-4.2-1.3c-0.9-0.3-1.4-1.2-1.1-2v0 c0.3-0.9,1.2-1.4,2-1.1L39.9,8c0.9,0.3,1.4,1.2,1.1,2l0,0C40.7,10.9,39.8,11.4,38.9,11.1z M42.7,28.8l-20.9-6.4 c-1.2-0.4-2.4,0.3-2.7,1.5l-6.4,20.9c-0.4,1.2,0.3,2.4,1.5,2.7L35,53.8c1.2,0.4,2.4-0.3,2.7-1.5l6.4-20.9 C44.5,30.3,43.8,29.1,42.7,28.8z M33,34.4l-9.4-2.9c-0.9-0.3-1.4-1.2-1.1-2v0c0.3-0.9,1.2-1.4,2-1.1l9.4,2.9c0.9,0.3,1.4,1.2,1.1,2 l0,0C34.7,34.1,33.8,34.6,33,34.4z",
  premium_jobseeker: "M36,70C17.3,70,2,54.7,2,36S17.3,2,36,2c18.7,0,34,15.3,34,34S54.7,70,36,70z M36,4.6C18.7,4.6,4.6,18.7,4.6,36 S18.7,67.4,36,67.4c17.3,0,31.4-14.1,31.4-31.4S53.3,4.6,36,4.6z M36,45.8l-13.1,6.5l3.3-13.1l-9.8-9.8h13.1L36,16.4l6.5,13.1h13.1 l-9.8,9.8l3.3,13.1L36,45.8z",
  Next: "15,62 41,36 15,10 23,2 57,36 23,70",
  Close: "70,8.8 63.2,2 36,29.2 8.8,2 2,8.8 29.2,36 2,63.2 8.8,70 36,42.8 63.2,70 70,63.2 42.8,36",
  Security: "M43.64,68.48c-0.07,0-0.13,0-0.2,0c-2.36-0.04-4.54-0.9-6.65-2.58c-0.31-0.25-0.58-0.52-0.88-0.76\n\t\tl-0.11,0.11c-0.47,0.4-0.94,0.83-1.46,1.19c-1.68,1.24-3.5,1.91-5.39,2.04c-3.75,0.22-6.6-1.24-8.58-4.33\n\t\tc-0.79-1.21-1.26-2.47-1.44-3.75c-0.02-0.22-0.04-0.47-0.02-0.74c0.02-0.38,0.36-0.9,0.7-1.08c0.4-0.2,0.88-0.16,1.26,0.09\n\t\tc0.2,0.13,0.38,0.27,0.56,0.45l0.43,0.43c0.2,0.22,0.43,0.43,0.65,0.63c0.67,0.54,1.28,0.54,2,0.02c0.36-0.27,0.7-0.58,1.01-0.9\n\t\tl0.4-0.38c0.61-0.61,1.24-1.24,2.02-1.73c2.13-1.37,4.4-1.46,6.58-0.29c0.56,0.31,1.01,0.72,1.37,1.1c0.63-0.67,1.3-1.17,2.09-1.46\n\t\tc2.16-0.81,4.29-0.52,6.15,0.85c0.43,0.31,0.83,0.7,1.24,1.06l0.97,0.9c0.31,0.29,0.63,0.61,0.97,0.85\n\t\tc0.65,0.49,1.28,0.49,1.93-0.02c0.25-0.18,0.45-0.43,0.67-0.65l0.38-0.38c0.18-0.18,0.31-0.31,0.47-0.4\n\t\tc0.65-0.45,1.21-0.25,1.44-0.13c0.2,0.11,0.7,0.45,0.67,1.26c0,0.4-0.04,0.74-0.11,1.06c-0.67,2.83-2.2,4.96-4.49,6.35\n\t\tC46.94,68.08,45.37,68.48,43.64,68.48z M35.92,62.58c0.31,0,0.65,0.13,0.97,0.43l0.49,0.43c0.27,0.25,0.54,0.49,0.83,0.72\n\t\tc1.71,1.37,3.41,2.04,5.28,2.09c1.44,0.02,2.63-0.27,3.66-0.9c1.19-0.72,2.09-1.66,2.72-2.87c-1.28,0.61-2.69,0.45-3.88-0.47\n\t\tc-0.4-0.31-0.76-0.65-1.15-1.01l-0.94-0.88c-0.34-0.31-0.67-0.63-1.03-0.9c-1.26-0.94-2.58-1.12-4.02-0.56\n\t\tc-0.63,0.25-1.17,0.7-1.68,1.46c-0.07,0.09-0.13,0.18-0.22,0.29c-0.22,0.27-0.61,0.45-0.97,0.49c-0.36,0-0.74-0.11-0.94-0.38\n\t\tl-0.31-0.43c-0.43-0.58-0.79-0.97-1.21-1.19c-1.46-0.79-2.83-0.74-4.31,0.2c-0.58,0.38-1.1,0.88-1.64,1.44l-0.43,0.4\n\t\tc-0.4,0.38-0.79,0.76-1.24,1.08c-1.26,0.92-2.63,1.08-3.91,0.47c0.09,0.16,0.18,0.31,0.27,0.47c1.5,2.38,3.64,3.46,6.53,3.28\n\t\tc1.46-0.09,2.87-0.63,4.2-1.59c0.45-0.34,0.88-0.72,1.32-1.08l0.65-0.56C35.27,62.71,35.6,62.58,35.92,62.58z M36.01,51.53\n\t\tc-4.54,0-8.78-1.19-12.62-3.53c-3.88-2.4-7.07-5.66-9.72-9.97c-0.36-0.58-0.7-1.21-1.06-1.86l-0.52-0.97\n\t\tc-0.22-0.38-0.18-0.85,0.09-1.21c0.27-0.36,0.7-0.52,1.15-0.43c9.07,1.98,16.06,2.78,22.75,2.83c8.38-0.04,16.46-1.5,22.59-2.78\n\t\tc0.34-0.07,0.67,0.02,0.94,0.22l0.07,0.07c0.43,0.36,0.58,1.01,0.31,1.48l-0.65,1.15c-0.49,0.85-0.99,1.73-1.53,2.56\n\t\tc-2.78,4.22-6.22,7.46-10.24,9.63c-2.99,1.59-6.24,2.54-9.68,2.78C37.24,51.51,36.61,51.53,36.01,51.53z M15.24,36.26\n\t\tc0.11,0.2,0.22,0.4,0.36,0.61c2.45,4.02,5.39,7.03,8.96,9.21c3.97,2.43,8.4,3.48,13.16,3.14c3.12-0.22,6.09-1.06,8.78-2.52\n\t\tc3.75-2.02,6.83-4.92,9.43-8.89c0.34-0.52,0.65-1.06,0.97-1.57c-5.91,1.17-13.25,2.36-20.82,2.38\n\t\tC29.85,38.64,23.34,37.92,15.24,36.26z M36.16,33.75c-0.25,0-0.49,0-0.76,0c-6.94-0.07-14.28-1.01-22.46-2.85\n\t\tc-0.45-0.11-0.79-0.47-0.85-0.94l-0.07-0.49c-0.04-0.31-0.07-0.61-0.13-0.88c-0.18-0.92-0.79-1.62-1.75-2.52\n\t\tc-1.15-1.08-2.18-2.02-3.1-3.08c-0.9-1.03-1.21-2.45-0.85-3.77c0.36-1.28,1.32-2.29,2.6-2.69c6.04-1.91,11.3-5.01,17.56-8.82\n\t\tc2.22-1.37,4.27-2.58,6.51-3.53c2.11-0.88,4.27-0.9,6.38,0c1.93,0.81,3.73,1.86,5.48,2.9l2.78,1.64c2.72,1.59,5.46,3.19,8.22,4.72\n\t\tc2,1.1,4.27,2.04,7.1,2.94l0,0c0.97,0.31,1.75,0.88,2.27,1.66c0.54,0.79,0.76,1.73,0.65,2.69c-0.07,0.49-0.25,1.01-0.49,1.46\n\t\tc-0.74,1.24-1.71,2.4-3.03,3.64c-0.94,0.88-1.73,1.68-1.95,2.78c-0.07,0.29-0.09,0.56-0.13,0.88l-0.07,0.54\n\t\tc-0.07,0.47-0.4,0.83-0.88,0.94C50.51,32.85,43.15,33.75,36.16,33.75z M14.2,28.87c7.7,1.71,14.66,2.58,21.22,2.63\n\t\tc6.85,0.09,14.03-0.76,22.52-2.63c0.04-0.27,0.07-0.52,0.11-0.76c0.36-1.75,1.48-2.94,2.63-4c1.17-1.1,2.02-2.09,2.63-3.14\n\t\tc0.11-0.18,0.18-0.4,0.2-0.58c0.04-0.43-0.04-0.83-0.27-1.17c-0.25-0.36-0.63-0.63-1.1-0.79c-2.99-0.97-5.37-1.95-7.5-3.12\n\t\tc-2.78-1.53-5.52-3.12-8.29-4.74l-2.81-1.64c-1.75-1.03-3.39-2-5.19-2.74c-1.57-0.65-3.05-0.65-4.65,0\n\t\tc-2.11,0.88-4.06,2.04-6.22,3.37c-6.35,3.93-11.74,7.1-18.03,9.09c-0.54,0.16-0.94,0.58-1.1,1.15c-0.18,0.61-0.02,1.24,0.38,1.71\n\t\tc0.83,0.97,1.82,1.86,2.76,2.74c1.15,1.08,2.25,2.2,2.58,3.86C14.14,28.36,14.18,28.6,14.2,28.87z M35.78,27.62\n\t\tc-0.9,0-2.65-0.67-4.06-1.77c-2.11-1.64-4.54-4.87-4.11-11.09c-0.07-0.88,0.92-1.1,1.64-1.26c1.24-0.29,3.79-0.88,5.75-2.69\n\t\tc0.43-0.4,1.1-0.4,1.53,0c2,1.84,4.81,2.45,6.15,2.72c0.72,0.16,1.62,0.34,1.62,1.32c-0.99,10.4-6.04,12.06-7.95,12.69l-0.2,0.07\n\t\tC36.03,27.62,35.92,27.62,35.78,27.62z M35.76,26.52L35.76,26.52L35.76,26.52z M29.81,15.67c-0.18,7.81,4.85,9.45,5.86,9.7\n\t\tc1.64-0.54,5.25-1.8,6.27-9.72c-1.37-0.29-3.97-0.92-6.15-2.56C33.58,14.77,31.11,15.35,29.81,15.67z",
  Electrician: "M18.8,68.5h-6.72c-3.06,0-5.53-2.47-5.53-5.53V48.81c0-0.25,0.09-0.49,0.25-0.7l3.06-3.8v-3.46L9.6,40.43\n\t\tc-1.06-0.56-1.75-1.71-1.75-2.92V35.6c0-1.51,1.24-2.74,2.74-2.74h0.99V16.38l-2.02-4.02c-0.11-0.22-0.13-0.52-0.07-0.76l1.69-6.97\n\t\tc0.11-0.52,0.56-0.88,1.08-0.88h6.38c0.52,0,0.97,0.36,1.1,0.85l1.69,6.97c0.07,0.25,0.02,0.52-0.09,0.76l-2.02,4.02v16.47h0.97\n\t\tc1.51,0,2.74,1.24,2.74,2.74v1.91c0,1.24-0.7,2.36-1.75,2.92l-0.22,0.43v3.44l3.03,3.8c0.16,0.2,0.25,0.45,0.25,0.7v14.16\n\t\tC24.32,66.03,21.85,68.5,18.8,68.5z M8.79,49.19v13.78c0,1.82,1.48,3.28,3.28,3.28h6.72c1.82,0,3.28-1.48,3.28-3.28V49.19\n\t\tl-3.03-3.8c-0.16-0.2-0.25-0.45-0.25-0.7v-4.11c0-0.2,0.04-0.38,0.13-0.54l0.56-0.99c0.13-0.22,0.34-0.4,0.58-0.49\n\t\tc0.43-0.16,0.7-0.56,0.7-1.01v-1.91c0-0.27-0.22-0.49-0.49-0.49h-9.69c-0.27,0-0.49,0.22-0.49,0.49v1.91c0,0.45,0.27,0.85,0.7,1.01\n\t\tc0.25,0.09,0.45,0.27,0.58,0.49l0.56,0.99c0.09,0.16,0.13,0.36,0.13,0.54v4.11c0,0.25-0.09,0.49-0.25,0.7L8.79,49.19z M13.83,32.86\n\t\th3.21V16.11c0-0.18,0.04-0.34,0.11-0.49l1.96-3.89L17.74,6h-4.61l-1.37,5.73l1.96,3.89c0.07,0.16,0.11,0.34,0.11,0.49V32.86z\n\t\t M51.02,67.65c-0.63,0-1.12-0.49-1.12-1.12v-2.7h-6.07v2.7c0,0.63-0.49,1.12-1.12,1.12s-1.12-0.49-1.12-1.12v-2.7h-3.19\n\t\tc-0.63,0-1.12-0.49-1.12-1.12v-6.5c-1.93-0.49-3.35-2.25-3.35-4.34v-4.63c0-0.63,0.49-1.12,1.12-1.12h2.14v-6.59\n\t\tc0-0.65-0.31-1.24-0.83-1.57c-5.91-3.89-9.1-10.7-8.34-17.75c0.94-8.65,7.89-15.62,16.54-16.59c5.42-0.58,10.63,1.06,14.65,4.67\n\t\tc3.98,3.55,6.25,8.65,6.25,14c0,6.32-3.15,12.18-8.43,15.66c-0.54,0.36-0.85,0.94-0.85,1.6v6.59h2.14c0.63,0,1.12,0.49,1.12,1.12\n\t\tv4.63c0,1.98-1.28,3.66-3.08,4.25v6.56c0,0.63-0.49,1.12-1.12,1.12h-3.1v2.7C52.15,67.15,51.63,67.65,51.02,67.65z M39.54,61.58\n\t\th14.61v-5.21H39.54V61.58z M38.42,54.12h16.56c1.24,0,2.22-0.99,2.22-2.22v-3.51h-2.05c-0.02,0-0.07,0-0.09,0H38.33\n\t\tc-0.04,0-0.09,0-0.13,0c-0.02,0-0.07,0-0.09,0h-1.91v3.51C36.17,53.1,37.18,54.12,38.42,54.12z M39.45,46.14h14.5v-6.59\n\t\tc0-1.39,0.7-2.7,1.87-3.46c4.65-3.08,7.42-8.23,7.42-13.8c0-4.7-2-9.19-5.51-12.32c-3.55-3.17-8.14-4.63-12.92-4.11\n\t\tc-7.6,0.83-13.73,6.97-14.54,14.59c-0.67,6.23,2.14,12.23,7.35,15.64c1.15,0.76,1.84,2.05,1.84,3.46\n\t\tC39.45,39.55,39.45,46.14,39.45,46.14z",
  prejob: "90053,8.68466191 9.24563676,7.71157208 8.0000246,7.71157208 C6.75441244,7.71157208 5.74104389,8.68466191 5.74104389,9.88073525 L5.74104389,10.6155318 C5.74104389,10.8119832 5.57515911,10.9713179 5.37052195,10.9713179 C5.16588478,10.9713179 5,10.8120068 5,10.6155318 L5,9.88073525 C5,8.2923026 6.34580244,7 7.99999999,7 C9.65419755,7 11,8.29227898 11,9.88073525M13,6.1491 L60,6.1491 C64.418278,6.1491 68,9.730822 68,14.1491 L68,29.1491 C68,33.567378 64.418278,37.1491 60,37.1491 L13,37.1491 C8.581722,37.1491 5,33.567378 5,29.1491 L5,14.1491 C5,9.730822 8.581722,6.1491 13,6.1491 Z M13,8.9491 C10.1281193,8.9491 7.8,11.2772193 7.8,14.1491 L7.8,29.1491 C7.8,32.0209807 10.1281193,34.3491 13,34.3491 L60,34.3491 C62.8718807,34.3491 65.2,32.0209807 65.2,29.1491 L65.2,14.1491 C65.2,11.2772193 62.8718807,8.9491 60,8.9491 L13,8.9491 Z M15.34065,35.8242165 L12.54065,35.8242165 L12.54065,33.3144238 C12.54065,29.2552613 16.3864214,26.0737835 21.0001,26.0737835 C25.6137786,26.0737835 29.45955,29.2552613 29.45955,33.3144238 L29.45955,35.8242165 L26.65955,35.8242165 L26.65955,33.3144238 C26.65955,30.931433 24.1722626,28.8737835 21.0001,28.8737835 C17.8279374,28.8737835 15.34065,30.931433 15.34065,33.3144238 L15.34065,35.8242165 Z M21.0002338,27.32945 C17.0388404,27.32945 13.81965,24.1102596 13.81965,20.1488662 C13.81965,16.1876191 17.0386938,12.96955 21.0002338,12.96955 C24.9616273,12.96955 28.17955,16.1874727 28.17955,20.1488662 C28.17955,24.1104062 24.9614809,27.32945 21.0002338,27.32945 Z M21.0002338,24.52945 C23.4148937,24.52945 25.37955,22.5641986 25.37955,20.1488662 C25.37955,17.73387 23.41523,15.76955 21.0002338,15.76955 C18.5849014,15.76955 16.61965,17.7342063 16.61965,20.1488662 C16.61965,22.5638623 18.5852377,24.52945 21.0002338,24.52945 Z M13,41.1491 L60,41.1491 C64.418278,41.1491 68,44.730822 68,49.1491 L68,58.1491 C68,62.567378 64.418278,66.1491 60,66.1491 L13,66.1491 C8.581722,66.1491 5,62.567378 5,58.1491 L5,49.1491 C5,44.730822 8.581722,41.1491 13,41.1491 Z M13,43.9491 C10.1281193,43.9491 7.8,46.2772193 7.8,49.1491 L7.8,58.1491 C7.8,61.0209807 10.1281193,63.3491 13,63.3491 L60,63.3491 C62.8718807,63.3491 65.2,61.0209807 65.2,58.1491 L65.2,49.1491 C65.2,46.2772193 62.8718807,43.9491 60,43.9491 L13,43.9491 Z M14.75,48 L38.25,48 C39.2164983,48 40,48.7835017 40,49.75 L40,49.75 C40,50.7164983 39.2164983,51.5 38.25,51.5 L14.75,51.5 C13.7835017,51.5 13,50.7164983 13,49.75 L13,49.75 C13,48.7835017 13.7835017,48 14.75,48 Z M14.75,56 L28.25,56 C29.2164983,56 30,56.7835017 30,57.75 L30,57.75 C30,58.7164983 29.2164983,59.5 28.25,59.5 L14.75,59.5 C13.7835017,59.5 13,58.7164983 13,57.75 L13,57.75 C13,56.7835017 13.7835017,56 14.75,56 Z",
  boost: "M47.696124,35.8175153 C48.675969,24.3991853 44.8806202,12.7592668 36.9178295,4.3910387 C36.4341085,3.88268839 35.5782946,3.88268839 35.0945736,4.3910387 C27.1317829,12.7592668 23.3364341,24.3861507 24.3162791,35.8175153 C21.5627907,38.9327902 20.0496124,42.9474542 20.0496124,47.2228106 C20.0496124,51.5372709 21.6124031,55.6431772 24.4527132,58.7714868 C25.1472868,59.5405295 26.9209302,59.1885947 26.6356589,57.4940937 C26.4868217,56.6077393 26.3007752,55.7474542 26.3007752,54.9002037 C26.3007752,52.7885947 26.9085271,50.7812627 28.0372093,49.0867617 C28.2232558,49.1910387 28.4341085,49.2562118 28.6573643,49.2562118 L43.3550388,49.2562118 C43.5782946,49.2562118 43.7891473,49.1910387 43.9751938,49.0867617 C45.103876,50.7812627 45.7116279,52.7885947 45.7116279,54.9002037 C45.7116279,55.7474542 45.5007752,56.5947047 45.3767442,57.4940937 C45.1162791,59.3710794 46.9767442,59.4362525 47.5596899,58.7714868 C50.3875969,55.6301426 51.9627907,51.5372709 51.9627907,47.2228106 C51.9503876,42.9474542 50.4496124,38.9197556 47.696124,35.8175153 Z M36,7.3107943 C38.3069767,9.91771894 40.1922481,12.8505092 41.655814,15.9657841 L30.3565891,15.9657841 C31.8077519,12.8374745 33.6930233,9.91771894 36,7.3107943 Z M42.4992248,46.5319756 L29.5007752,46.5319756 C25.8542636,37.5380855 25.8914729,27.488391 29.2031008,18.6639511 L42.7968992,18.6639511 C46.1085271,27.488391 46.1457364,37.5380855 42.4992248,46.5319756 Z M30.7782946,51.5242363 C30.0589147,51.5242363 29.4883721,52.1368635 29.4883721,52.8798371 L29.4883721,59.696945 C29.4883721,60.4529532 30.0713178,61.0525458 30.7782946,61.0525458 C31.4852713,61.0525458 32.0682171,60.4399185 32.0682171,59.696945 L32.0682171,52.8798371 C32.0682171,52.1238289 31.4852713,51.5242363 30.7782946,51.5242363 Z M36,51.5242363 C35.6403101,51.5242363 35.3178295,51.6806517 35.0821705,51.9283096 C35.0821705,51.9283096 35.0821705,51.9283096 35.0697674,51.9413442 C34.9209302,52.0977597 34.8093023,52.3063136 34.7472868,52.5409369 C34.7224806,52.6582485 34.6976744,52.7755601 34.6976744,52.9059063 L34.6976744,66.5270876 C34.6976744,66.6313646 34.7100775,66.7356415 34.7348837,66.8399185 C34.8713178,67.4395112 35.379845,67.8826884 35.9875969,67.8826884 C36.5953488,67.8826884 37.103876,67.4395112 37.2403101,66.8399185 C37.2651163,66.7356415 37.2775194,66.6313646 37.2775194,66.5270876 L37.2775194,52.8798371 C37.2775194,52.7494908 37.2651163,52.6321792 37.227907,52.5148676 C37.0914729,51.9413442 36.5953488,51.5242363 36,51.5242363 Z M41.2217054,51.5242363 C40.5023256,51.5242363 39.9317829,52.1368635 39.9317829,52.8798371 L39.9317829,59.696945 C39.9317829,60.4529532 40.5147287,61.0525458 41.2217054,61.0525458 C41.9286822,61.0525458 42.5116279,60.4399185 42.5116279,59.696945 L42.5116279,52.8798371 C42.524031,52.1238289 41.9410853,51.5242363 41.2217054,51.5242363 Z M23.8449612,53.0623218 C23.0511628,51.2505092 22.6418605,49.2692464 22.6418605,47.2228106 C22.6418605,44.4594705 23.3984496,41.813442 24.8124031,39.5454175 C24.8248062,39.6496945 26.1767442,45.0851324 26.6976744,46.4798371 C25.1472868,48.3568228 24.1674419,50.6248473 23.8449612,53.0623218 Z M45.3147287,46.4798371 C46.0341085,44.5376782 47.1875969,39.6236253 47.2,39.5454175 C48.6139535,41.8004073 49.3705426,44.4464358 49.3705426,47.2228106 C49.3705426,49.2692464 48.9488372,51.2505092 48.1674419,53.0623218 C47.8325581,50.6248473 46.8527132,48.3568228 45.3147287,46.4798371 Z",
  reusume: "M64.1191,54.9199 C64.1191,58.2899 61.7891,61.1179 58.6571,61.8989 L58.6571,59.6429 C58.6571,55.9089 56.3981,52.6879 53.1441,51.1759 C55.1311,49.8379 56.4401,47.5689 56.4401,44.9999 C56.4401,40.8979 53.1021,37.5599 49.0001,37.5599 C44.8971,37.5599 41.5591,40.8979 41.5591,44.9999 C41.5591,47.5689 42.8691,49.8379 44.8551,51.1759 C41.6011,52.6879 39.3431,55.9089 39.3431,59.6429 L39.3431,62.1189 L17.0801,62.1189 C13.1101,62.1189 9.8801,58.8899 9.8801,54.9199 L9.8801,15.0799 C9.8801,11.1099 13.1101,7.8799 17.0801,7.8799 L56.9201,7.8799 C60.8901,7.8799 64.1191,11.1099 64.1191,15.0799 L64.1191,54.9199 Z M55.1191,59.6429 L55.1191,62.1189 L42.8811,62.1189 L42.8811,59.6429 C42.8811,56.4649 45.6261,53.8809 49.0001,53.8809 C52.3741,53.8809 55.1191,56.4649 55.1191,59.6429 Z M49.0001,49.5599 C46.4851,49.5599 44.4401,47.5149 44.4401,44.9999 C44.4401,42.4849 46.4851,40.4409 49.0001,40.4409 C51.5151,40.4409 53.5591,42.4849 53.5591,44.9999 C53.5591,47.5149 51.5151,49.5599 49.0001,49.5599 Z M56.9201,4.9999 L17.0801,4.9999 C11.5221,4.9999 7.0001,9.5219 7.0001,15.0799 L7.0001,54.9199 C7.0001,60.4779 11.5221,64.9999 17.0801,64.9999 L56.9201,64.9999 C62.4771,64.9999 67.0001,60.4779 67.0001,54.9199 L67.0001,15.0799 C67.0001,9.5219 62.4771,4.9999 56.9201,4.9999 Z M19.5,17 L37.5,17 C38.328,17 39,16.329 39,15.5 C39,14.671 38.328,14 37.5,14 L19.5,14 C18.671,14 18,14.671 18,15.5 C18,16.329 18.671,17 19.5,17 M19.5,23 L31.5,23 C32.329,23 33,22.329 33,21.5 C33,20.671 32.329,20 31.5,20 L19.5,20 C18.671,20 18,20.671 18,21.5 C18,22.329 18.671,23 19.5,23 M19.5,41 L28.5,41 C29.329,41 30,40.328 30,39.5 C30,38.672 29.329,38 28.5,38 L19.5,38 C18.671,38 18,38.672 18,39.5 C18,40.328 18.671,41 19.5,41 M19.5,47 L28.5,47 C29.329,47 30,46.328 30,45.5 C30,44.672 29.329,44 28.5,44 L19.5,44 C18.671,44 18,44.672 18,45.5 C18,46.328 18.671,47 19.5,47 M31.5,50 L19.5,50 C18.671,50 18,50.672 18,51.5 C18,52.328 18.671,53 19.5,53 L31.5,53 C32.329,53 33,52.328 33,51.5 C33,50.672 32.329,50 31.5,50 M46.5,26 L19.5,26 C18.671,26 18,26.671 18,27.5 C18,28.329 18.671,29 19.5,29 L46.5,29 C47.328,29 48,28.329 48,27.5 C48,26.671 47.328,26 46.5,26",
  chat: "M45.0225,10.9999 C56.9155,10.9999 66.5885,20.2989 66.5885,31.7289 C66.5885,36.5199 64.8485,41.1939 61.6915,44.8869 C58.9095,48.1399 55.0875,50.5389 50.8895,51.6819 L50.8895,59.6309 C50.8895,60.3409 50.4545,60.9719 49.7775,61.2389 C49.5715,61.3229 49.3435,61.3669 49.1045,61.3669 C48.6335,61.3669 48.1915,61.1899 47.8555,60.8719 L39.0965,52.4599 L26.5645,52.4599 C14.6725,52.4599 5.0005,43.1619 5.0005,31.7309 C5.0005,28.2059 5.9375,24.7229 7.7115,21.6599 C8.1855,20.8389 9.2645,20.5349 10.1225,20.9899 C10.5475,21.2179 10.8545,21.5949 10.9835,22.0509 C11.1095,22.4959 11.0505,22.9639 10.8165,23.3659 C9.3435,25.9079 8.5645,28.7999 8.5645,31.7309 C8.5645,41.2469 16.6375,48.9879 26.5615,48.9879 L39.8265,48.9879 C40.2945,48.9879 40.7405,49.1659 41.0765,49.4839 L47.3205,55.4789 L47.3205,50.3149 C47.3205,49.4989 47.9175,48.7849 48.7425,48.6169 C57.0145,46.9499 63.0195,39.8479 63.0195,31.7289 C63.0195,22.2129 54.9475,14.4719 45.0225,14.4719 L43.5375,14.4719 C42.5555,14.4719 41.7545,13.6929 41.7545,12.7359 C41.7545,11.7779 42.5555,10.9999 43.5375,10.9999 L45.0225,10.9999 Z M21.2817,25.1488 C20.6297,25.1488 20.1017,24.6418 20.1017,24.0168 C20.1017,23.3918 20.6297,22.8848 21.2817,22.8848 L50.3077,22.8848 C50.9597,22.8848 51.4877,23.3918 51.4877,24.0168 C51.4877,24.6418 50.9597,25.1488 50.3077,25.1488 L21.2817,25.1488 Z M21.2817,31.1874 C20.6297,31.1874 20.1017,30.6804 20.1017,30.0554 C20.1017,29.4304 20.6297,28.9234 21.2817,28.9234 L50.3077,28.9234 C50.9597,28.9234 51.4877,29.4304 51.4877,30.0554 C51.4877,30.6804 50.9597,31.1874 50.3077,31.1874 L21.2817,31.1874 Z M21.2817,37.2265 C20.6297,37.2265 20.1017,36.7195 20.1017,36.0945 C20.1017,35.4695 20.6297,34.9625 21.2817,34.9625 L50.3077,34.9625 C50.9597,34.9625 51.4877,35.4695 51.4877,36.0945 C51.4877,36.7195 50.9597,37.2265 50.3077,37.2265 L21.2817,37.2265 Z M50.3076,41.0028 C50.9596,41.0028 51.4876,41.5108 51.4876,42.1358 C51.4876,42.7608 50.9596,43.2678 50.3076,43.2678 L34.8356,43.2678 C34.1836,43.2678 33.6556,42.7608 33.6556,42.1358 C33.6556,41.5108 34.1836,41.0028 34.8356,41.0028 L50.3076,41.0028 Z M28.1807,41.0009 L28.1987,41.0009 C28.8507,41.0009 29.3787,41.5079 29.3787,42.1329 C29.3787,42.7579 28.8507,43.2659 28.1987,43.2659 L28.1807,43.2659 C27.5287,43.2659 27.0007,42.7579 27.0007,42.1329 C27.0007,41.5079 27.5287,41.0009 28.1807,41.0009 Z",
  trackApplication: "M53.817,61.2757 C52.699,61.2757 51.79,60.3697 51.79,59.2537 C51.79,58.1377 52.699,57.2307 53.817,57.2307 C54.934,57.2307 55.844,58.1377 55.844,59.2537 C55.844,60.3697 54.934,61.2757 53.817,61.2757 Z M11.604,30.8317 C10.486,30.8317 9.576,29.9247 9.576,28.8097 C9.576,27.6937 10.486,26.7867 11.604,26.7867 C12.722,26.7867 13.631,27.6937 13.631,28.8097 C13.631,29.9247 12.722,30.8317 11.604,30.8317 Z M53.817,19.4157 C50.726,19.4157 48.213,21.9237 48.213,25.0057 C48.213,28.0867 50.728,30.5947 53.817,30.5947 C56.908,30.5947 59.421,28.0867 59.421,25.0057 C59.421,21.9237 56.905,19.4157 53.817,19.4157 M53.817,27.0257 C52.699,27.0257 51.79,26.1187 51.79,25.0037 C51.79,23.8877 52.699,22.9807 53.817,22.9807 C54.934,22.9807 55.844,23.8877 55.844,25.0037 C55.844,26.1187 54.934,27.0257 53.817,27.0257 M53.817,53.6667 L53.817,53.6647 C51.351,53.6647 49.255,55.2597 48.506,57.4697 L15.42,57.4697 C12.198,57.4697 9.576,54.8547 9.576,51.6437 C9.576,48.4317 12.198,45.8167 15.42,45.8167 L26.866,45.8167 C32.06,45.8167 36.285,41.6037 36.285,36.4217 C36.285,31.2397 32.06,27.0257 26.866,27.0257 L16.914,27.0257 C16.355,25.3777 15.045,24.0697 13.392,23.5137 L13.392,19.1767 L23.05,19.1767 C24.038,19.1767 24.838,18.3787 24.838,17.3937 L24.838,9.7837 C24.838,8.7977 24.038,8.0007 23.05,8.0007 L11.604,8.0007 C10.616,8.0007 9.816,8.7977 9.816,9.7837 L9.816,23.5157 C7.601,24.2617 6,26.3537 6,28.8117 C6,31.8927 8.515,34.4007 11.604,34.4007 C14.069,34.4007 16.166,32.8047 16.914,30.5947 L26.866,30.5947 C30.087,30.5947 32.709,33.2097 32.709,36.4217 C32.709,39.6327 30.087,42.2487 26.866,42.2487 L15.42,42.2487 C10.225,42.2487 6,46.4617 6,51.6437 C6,56.8257 10.225,61.0397 15.42,61.0397 L48.506,61.0397 C49.255,63.2497 51.351,64.8447 53.817,64.8447 C56.908,64.8447 59.421,62.3377 59.421,59.2557 C59.421,56.1737 56.905,53.6667 53.817,53.6667 Z M59.7974,32.5706 C59.5954,32.7286 59.4304,32.9306 59.3114,33.1596 L53.8174,43.9106 L48.3214,33.1596 C48.2054,32.9306 48.0394,32.7286 47.8364,32.5706 C45.4984,30.7306 44.1574,27.9726 44.1574,25.0056 C44.1574,19.6936 48.4894,15.3726 53.8174,15.3726 C59.1434,15.3726 63.4754,19.6936 63.4754,25.0056 C63.4754,27.9726 62.1344,30.7306 59.7974,32.5706 M53.8174,11.8056 C46.5174,11.8056 40.5794,17.7276 40.5794,25.0056 C40.5794,28.9346 42.2964,32.5986 45.3044,35.1166 L52.2224,48.6496 C52.5274,49.2466 53.1444,49.6236 53.8174,49.6236 C54.4884,49.6236 55.1054,49.2466 55.4104,48.6496 L62.3284,35.1166 C65.3364,32.5986 67.0544,28.9376 67.0544,25.0056 C67.0544,17.7276 61.1154,11.8056 53.8174,11.8056 M13.394,15.6097 L21.265,15.6097 L21.265,11.5667 L13.394,11.5667 L13.394,15.6097 Z",
  jobApplication: "M13,6.1491 L60,6.1491 C64.418278,6.1491 68,9.730822 68,14.1491 L68,29.1491 C68,33.567378 64.418278,37.1491 60,37.1491 L13,37.1491 C8.581722,37.1491 5,33.567378 5,29.1491 L5,14.1491 C5,9.730822 8.581722,6.1491 13,6.1491 Z M13,8.9491 C10.1281193,8.9491 7.8,11.2772193 7.8,14.1491 L7.8,29.1491 C7.8,32.0209807 10.1281193,34.3491 13,34.3491 L60,34.3491 C62.8718807,34.3491 65.2,32.0209807 65.2,29.1491 L65.2,14.1491 C65.2,11.2772193 62.8718807,8.9491 60,8.9491 L13,8.9491 Z M15.34065,35.8242165 L12.54065,35.8242165 L12.54065,33.3144238 C12.54065,29.2552613 16.3864214,26.0737835 21.0001,26.0737835 C25.6137786,26.0737835 29.45955,29.2552613 29.45955,33.3144238 L29.45955,35.8242165 L26.65955,35.8242165 L26.65955,33.3144238 C26.65955,30.931433 24.1722626,28.8737835 21.0001,28.8737835 C17.8279374,28.8737835 15.34065,30.931433 15.34065,33.3144238 L15.34065,35.8242165 Z M21.0002338,27.32945 C17.0388404,27.32945 13.81965,24.1102596 13.81965,20.1488662 C13.81965,16.1876191 17.0386938,12.96955 21.0002338,12.96955 C24.9616273,12.96955 28.17955,16.1874727 28.17955,20.1488662 C28.17955,24.1104062 24.9614809,27.32945 21.0002338,27.32945 Z M21.0002338,24.52945 C23.4148937,24.52945 25.37955,22.5641986 25.37955,20.1488662 C25.37955,17.73387 23.41523,15.76955 21.0002338,15.76955 C18.5849014,15.76955 16.61965,17.7342063 16.61965,20.1488662 C16.61965,22.5638623 18.5852377,24.52945 21.0002338,24.52945 Z M13,41.1491 L60,41.1491 C64.418278,41.1491 68,44.730822 68,49.1491 L68,58.1491 C68,62.567378 64.418278,66.1491 60,66.1491 L13,66.1491 C8.581722,66.1491 5,62.567378 5,58.1491 L5,49.1491 C5,44.730822 8.581722,41.1491 13,41.1491 Z M13,43.9491 C10.1281193,43.9491 7.8,46.2772193 7.8,49.1491 L7.8,58.1491 C7.8,61.0209807 10.1281193,63.3491 13,63.3491 L60,63.3491 C62.8718807,63.3491 65.2,61.0209807 65.2,58.1491 L65.2,49.1491 C65.2,46.2772193 62.8718807,43.9491 60,43.9491 L13,43.9491 Z M14.75,48 L38.25,48 C39.2164983,48 40,48.7835017 40,49.75 L40,49.75 C40,50.7164983 39.2164983,51.5 38.25,51.5 L14.75,51.5 C13.7835017,51.5 13,50.7164983 13,49.75 L13,49.75 C13,48.7835017 13.7835017,48 14.75,48 Z M14.75,56 L28.25,56 C29.2164983,56 30,56.7835017 30,57.75 L30,57.75 C30,58.7164983 29.2164983,59.5 28.25,59.5 L14.75,59.5 C13.7835017,59.5 13,58.7164983 13,57.75 L13,57.75 C13,56.7835017 13.7835017,56 14.75,56 Z",
  profileInSms: "M58.6189,15.0145 L33.8529,15.0145 C30.8949,15.0145 28.4939,17.5155 28.4939,20.5955 L28.4939,36.3275 C28.4939,39.4075 30.8949,41.9085 33.8529,41.9085 L35.7619,41.9085 L35.7619,48.0855 C35.7619,48.6255 36.0609,49.1125 36.5409,49.3145 L36.5409,49.3165 C36.7099,49.3845 36.8799,49.4245 37.0459,49.4245 C37.3699,49.4245 37.6959,49.3025 37.9419,49.0455 L45.1059,41.9085 L58.6189,41.9085 C61.5769,41.9085 63.9779,39.4075 63.9779,36.3275 L63.9779,20.5955 C63.9779,17.5155 61.5769,15.0145 58.6189,15.0145 Z M61.3949,36.3275 C61.3949,37.9345 60.1489,39.2335 58.6059,39.2335 L44.5769,39.2335 C44.2379,39.2335 43.9269,39.3685 43.6929,39.6115 L38.3329,44.9645 L38.3329,40.5855 C38.3329,39.8415 37.7609,39.2465 37.0489,39.2465 L33.8559,39.2465 L33.8559,39.2335 L33.8529,39.2335 C32.3089,39.2335 31.0639,37.9365 31.0639,36.3275 L31.0639,20.5955 C31.0639,18.9885 32.3109,17.6885 33.8529,17.6885 L58.6059,17.6885 C60.1509,17.6885 61.3949,18.9855 61.3949,20.5955 L61.3949,36.3275 Z M36.6581,26.2742 L55.1271,26.2742 C55.8411,26.2742 56.4111,25.6792 56.4111,24.9352 C56.4111,24.1912 55.8391,23.5962 55.1271,23.5962 L36.6581,23.5962 C35.9441,23.5962 35.3741,24.1912 35.3741,24.9352 C35.3741,25.6792 35.9591,26.2742 36.6581,26.2742 M55.1293,30.8826 L36.6603,30.8826 C35.9463,30.8826 35.3763,31.4776 35.3763,32.2216 C35.3763,32.9656 35.9463,33.5606 36.6603,33.5606 L55.1293,33.5606 C55.8443,33.5606 56.4133,32.9656 56.4133,32.2216 C56.4133,31.4776 55.8413,30.8826 55.1293,30.8826 M49.2494,45.1116 C49.9614,45.1116 50.5334,45.7066 50.5334,46.4506 L50.5334,64.3416 C50.5334,67.0446 48.4314,69.2496 45.8224,69.2606 L15.7104,69.2606 C13.1154,69.2606 10.9994,67.0586 10.9994,64.3566 L10.9994,7.9046 C10.9994,5.2026 13.1154,2.9996 15.7104,2.9996 L45.8224,2.9996 C48.4184,2.9996 50.5334,5.2026 50.5334,7.9046 L50.5334,10.7016 C50.5334,11.4456 49.9614,12.0406 49.2494,12.0406 C48.5374,12.0406 47.9654,11.4456 47.9654,10.7016 L47.9654,7.9046 C47.9654,6.6876 47.0054,5.6876 45.8224,5.6876 L15.7104,5.6876 C14.5284,5.6876 13.5684,6.6756 13.5684,7.9046 L13.5684,64.3566 C13.5684,65.5866 14.5284,66.5866 15.7104,66.5866 L45.8224,66.5866 C47.0054,66.5866 47.9654,65.5866 47.9654,64.3566 L47.9654,46.4506 C47.9654,45.7066 48.5374,45.1116 49.2494,45.1116 Z M26.9086,61.2239 C26.1946,61.2239 25.6246,60.6289 25.6246,59.8849 C25.6246,59.1409 26.1946,58.5459 26.9086,58.5459 L34.6326,58.5459 C35.3466,58.5459 35.9166,59.1409 35.9166,59.8849 C35.9166,60.6289 35.3466,61.2239 34.6326,61.2239 L26.9086,61.2239 Z",
  govtId: "M17.0181,57.952 L35.1331,57.952 C35.5216888,57.952 35.9081,57.5405829 35.9081,56.966 L35.9081,38.366 C35.9081,37.789365 35.5226007,37.379 35.1331,37.379 L17.0181,37.379 C16.6299257,37.379 16.2431,37.7910216 16.2431,38.366 L16.2431,56.966 C16.2431,57.5416871 16.6286267,57.952 17.0181,57.952 Z M17.0181,60.452 C15.2121,60.452 13.7431,58.889 13.7431,56.966 L13.7431,38.366 C13.7431,36.445 15.2121,34.879 17.0181,34.879 L35.1331,34.879 C36.9391,34.879 38.4081,36.442 38.4081,38.366 L38.4081,56.966 C38.4081,58.887 36.9391,60.452 35.1331,60.452 L17.0181,60.452 Z M23.8133447,45.6123784 C23.8133447,47.1048272 24.8760889,48.25187 26.0769223,48.25187 C27.2775808,48.25187 28.3390454,47.1064203 28.3390454,45.6123784 C28.3390454,44.1200654 27.2763994,42.9728868 26.0769223,42.9728868 C24.8749074,42.9728868 23.8133447,44.1182008 23.8133447,45.6123784 Z M27.543245,50.5026288 C29.0609423,50.8135006 30.4574416,51.6069369 31.5754337,52.8111738 C33.0438763,54.3944301 33.8514485,56.5044762 33.8514485,58.7444158 L33.8514485,60.4214839 L31.3514485,60.4214839 L31.3514485,58.7444158 C31.3514485,57.126393 30.7761324,55.6257274 29.7432771,54.5121154 C28.7402815,53.4317461 27.449653,52.8547452 26.0791,52.8547452 C23.2187741,52.8547452 20.8067515,55.4584362 20.8067515,58.7444158 L20.8067515,60.4214839 L18.3067515,60.4214839 L18.3067515,58.7444158 C18.3067515,54.658875 21.0267182,51.2454944 24.614822,50.5040781 C22.7011205,49.8362011 21.3133447,47.8942088 21.3133447,45.6123784 C21.3133447,42.7780674 23.4500456,40.4728868 26.0769223,40.4728868 C28.7023445,40.4728868 30.8390454,42.7810152 30.8390454,45.6123784 C30.8390454,47.8946275 29.4536466,49.8337979 27.543245,50.5026288 Z M58.8279,57.3163 C59.5059,57.3163 60.0549,57.9033 60.0549,58.6263 C60.0549,59.3483 59.5059,59.9343 58.8279,59.9343 C58.1499,59.9343 57.6009,59.3483 57.6009,58.6263 C57.6009,57.9033 58.1499,57.3163 58.8279,57.3163 Z M51.1043,57.3163 C51.7823,57.3163 52.3313,57.9033 52.3313,58.6263 C52.3313,59.3483 51.7823,59.9343 51.1043,59.9343 C50.4253,59.9343 49.8773,59.3483 49.8773,58.6263 C49.8773,57.9033 50.4253,57.3163 51.1043,57.3163 Z M43.7469,36.3905 C43.0689,36.3905 42.5199,35.8045 42.5199,35.0815 C42.5199,34.3585 43.0689,33.7725 43.7469,33.7725 C44.4259,33.7725 44.9739,34.3585 44.9739,35.0815 C44.9739,35.8045 44.4259,36.3905 43.7469,36.3905 Z M43.7469,59.9344 C43.0689,59.9344 42.5199,59.3484 42.5199,58.6254 C42.5199,57.9034 43.0689,57.3164 43.7469,57.3164 C44.4259,57.3164 44.9739,57.9034 44.9739,58.6254 C44.9739,59.3484 44.4259,59.9344 43.7469,59.9344 Z M48.6512,36.3929 C47.9722,36.3929 47.4242,35.8069 47.4242,35.0839 C47.4242,34.3609 47.9722,33.7749 48.6512,33.7749 L58.8282,33.7749 C59.5052,33.7749 60.0542,34.3609 60.0542,35.0839 C60.0542,35.8069 59.5052,36.3929 58.8282,36.3929 L48.6512,36.3929 Z M43.7469,44.2391 C43.0689,44.2391 42.5199,43.6531 42.5199,42.9301 C42.5199,42.2081 43.0689,41.6211 43.7469,41.6211 L58.8279,41.6211 C59.5059,41.6211 60.0549,42.2081 60.0549,42.9301 C60.0549,43.6531 59.5059,44.2391 58.8279,44.2391 L43.7469,44.2391 Z M43.7469,52.0877 C43.0689,52.0877 42.5199,51.5017 42.5199,50.7787 C42.5199,50.0567 43.0689,49.4707 43.7469,49.4707 L58.8279,49.4707 C59.5059,49.4707 60.0549,50.0567 60.0549,50.7787 C60.0549,51.5017 59.5059,52.0877 58.8279,52.0877 L43.7469,52.0877 Z M65.3299,25.9286 L7.4579,25.9286 L7.4579,19.3886 C7.4579,18.6686 8.0089,18.0796 8.6839,18.0796 L30.2599,18.0796 L30.2599,19.3886 C30.2599,20.1116 30.8089,20.6976 31.4869,20.6976 L41.2969,20.6976 C41.9749,20.6976 42.5229,20.1116 42.5229,19.3886 L42.5229,18.0796 L64.1029,18.0796 C64.7789,18.0796 65.3299,18.6656 65.3299,19.3886 L65.3299,25.9286 Z M65.3259,63.8546 C65.3259,64.5746 64.7739,65.1626 64.0999,65.1626 L8.6799,65.1626 C8.0039,65.1626 7.4529,64.5766 7.4529,63.8546 L7.4529,28.5416 L65.3259,28.5416 L65.3259,63.8546 Z M36.3929,7.6156 C37.3739,7.6156 38.2979,8.0226 38.9939,8.7646 C39.6909,9.5056 40.0719,10.4906 40.0719,11.5376 L40.0719,18.0776 L32.7159,18.0776 L32.7159,11.5376 L32.7129,11.5396 C32.7129,9.3766 34.3639,7.6156 36.3929,7.6156 Z M64.1009,15.4646 L42.5199,15.4646 L42.5199,11.5396 C42.5199,9.7936 41.8829,8.1526 40.7249,6.9166 C39.5659,5.6806 38.0259,4.9996 36.3909,4.9996 C33.0099,4.9996 30.2599,7.9336 30.2599,11.5396 L30.2599,15.4646 L8.6799,15.4646 C6.6499,15.4646 4.9999,17.2256 4.9999,19.3886 L4.9999,63.8566 C4.9999,66.0206 6.6499,67.7816 8.6799,67.7816 L64.1009,67.7816 C66.1309,67.7816 67.7809,66.0206 67.7809,63.8566 L67.7809,19.3886 C67.7809,17.2256 66.1309,15.4646 64.1009,15.4646 Z",
  customerCare: "M51.8102679,22.8151261 L51.8102679,20.5084034 C51.8102679,14.987395 49.734375,9.85714286 45.9709821,6.05042017 C42.1138393,2.14285714 36.8102679,0 31.0245536,0 L29.0022321,0 C23.2165179,0 17.9129464,2.14285714 14.0558036,6.05042017 C10.2924107,9.85714286 8.21651786,14.987395 8.21651786,20.5084034 L8.21651786,22.8151261 C3.64955357,23.105042 0.0200892857,26.6848739 0.0200892857,31.0588235 L0.0200892857,34.6638655 C0.0200892857,39.2142857 3.95758929,42.9201681 8.79241071,42.9201681 L13.734375,42.9201681 C14.6183036,42.9201681 15.3415179,42.2394958 15.3415179,41.407563 L15.3415179,24.302521 C15.3415179,23.4705882 14.6183036,22.789916 13.734375,22.789916 L11.4308036,22.789916 L11.4308036,20.5084034 C11.4308036,10.5378151 18.984375,3.02521008 28.9888393,3.02521008 L31.0111607,3.02521008 C41.0290179,3.02521008 48.5691964,10.5378151 48.5691964,20.5084034 L48.5691964,22.789916 L46.265625,22.789916 C45.3816964,22.789916 44.6584821,23.4705882 44.6584821,24.302521 L44.6584821,41.394958 C44.6584821,42.2268908 45.3816964,42.907563 46.265625,42.907563 L48.515625,42.907563 C47.859375,50.7983193 42.0870536,52.6260504 39.4084821,53.0420168 C38.671875,50.9117647 36.5424107,49.3739496 34.0379464,49.3739496 L30.0200893,49.3739496 C26.9129464,49.3739496 24.3816964,51.7563025 24.3816964,54.6806723 C24.3816964,57.605042 26.9129464,60 30.0200893,60 L34.0513393,60 C36.6495536,60 38.8325893,58.3361345 39.4888393,56.092437 C40.8013393,55.9159664 42.8772321,55.4747899 44.9397321,54.3403361 C47.8459821,52.7394958 51.2879464,49.4747899 51.7433036,42.894958 C56.3370536,42.6302521 59.9799107,39.0378151 59.9799107,34.6512605 L59.9799107,31.0462185 C59.9933036,26.6848739 56.3772321,23.092437 51.8102679,22.8151261 Z M12.1540179,39.8823529 L8.81919643,39.8823529 C5.75223214,39.8823529 3.26116071,37.5378151 3.26116071,34.6512605 L3.26116071,31.0462185 C3.26116071,28.1596639 5.75223214,25.8151261 8.81919643,25.8151261 L12.1540179,25.8151261 L12.1540179,39.8823529 Z M34.0513393,56.9747899 L30.0200893,56.9747899 C28.6808036,56.9747899 27.5959821,55.9537815 27.5959821,54.6932773 C27.5959821,53.4327731 28.6808036,52.4117647 30.0200893,52.4117647 L34.0513393,52.4117647 C35.390625,52.4117647 36.4754464,53.4327731 36.4754464,54.6932773 C36.4754464,55.9537815 35.390625,56.9747899 34.0513393,56.9747899 Z M56.7790179,34.6512605 C56.7790179,37.5378151 54.2879464,39.8823529 51.2209821,39.8823529 L47.8861607,39.8823529 L47.8861607,25.8151261 L51.2209821,25.8151261 C54.2879464,25.8151261 56.7790179,28.1596639 56.7790179,31.0462185 L56.7790179,34.6512605 Z",
  profileHighlighted: "M44.1244,38.1092 C50.5754,35.4322 55.1264,29.0722 55.1264,21.6652 C55.1264,11.8512 47.1424,3.8662 37.3254,3.8662 C27.5114,3.8662 19.5264,11.8512 19.5264,21.6652 C19.5264,28.7892 23.7424,34.9312 29.8024,37.7732 C18.9934,40.5422 11.0004,49.9732 11.0004,61.1802 L11.0004,67.6222 C11.0004,68.7942 12.0154,69.7502 13.2624,69.7502 C14.5104,69.7502 15.5234,68.7942 15.5234,67.6222 L15.5234,61.1802 C15.5234,50.1542 24.8614,41.1842 36.3374,41.1842 C47.8144,41.1842 57.1484,50.1542 57.1484,61.1802 L57.1484,67.8712 C57.1484,69.0432 58.1654,69.9992 59.4144,69.9992 C60.6604,69.9992 61.6774,69.0432 61.6774,67.8712 L61.6774,61.1802 C61.6774,50.4082 54.2954,41.2632 44.1244,38.1092 M23.4814,21.6652 C23.4814,14.0312 29.6914,7.8212 37.3254,7.8212 C44.9604,7.8212 51.1684,14.0312 51.1684,21.6652 C51.1684,29.2992 44.9604,35.5102 37.3254,35.5102 C29.6914,35.5102 23.4814,29.2992 23.4814,21.6652 M44.4458,55.317 L38.5838,54.765 L36.2548,49.289 C36.0918,48.906 35.5548,48.906 35.3918,49.289 L33.0628,54.765 L27.1998,55.317 C26.7908,55.356 26.6248,55.873 26.9328,56.148 L31.3568,60.085 L30.0628,65.903 C29.9708,66.309 30.4068,66.63 30.7598,66.417 L35.8218,63.373 L40.8828,66.417 C41.2358,66.63 41.6728,66.309 41.5808,65.903 L40.2868,60.085 L44.7108,56.148 C45.0188,55.873 44.8528,55.356 44.4428,55.317 L44.4458,55.317 Z"
};
var PRE_PROFILE_BENEFITS = [{
  icon: ICONS.reusume,
  benefits: "Get a Professional CV"
  // des: 'Get a professionally written resume'
}, {
  icon: ICONS.profileHighlighted,
  benefits: "Profile shown at the top"
  // des: 'Company calls people with verified ID first'
}, {
  icon: ICONS.jobApplication,
  benefits: "50 Premium Job Applications"
  // des: 'UX Designer from Thanisandra, Bangalore'
}, {
  icon: ICONS.profileInSms,
  benefits: "Companies get your profile in SMS"
  // des: 'Get a professionally written resume'
}, {
  icon: ICONS.Receptionist,
  benefits: "View recruiter contact numbers"
  // des: 'Company calls people with verified ID first'
}, {
  icon: ICONS.trackApplication,
  benefits: "Track Application"
  // des: 'UX Designer from Thanisandra, Bangalore'
}];

var SILVER_PROFILE_BENEFITS = [{
  icon: ICONS.profileHighlighted,
  benefits: "Profile shown at the top"
}, {
  icon: ICONS.jobApplication,
  benefits: "50 Premium Job Applications"
}, {
  icon: ICONS.profileInSms,
  benefits: "Companies get your profile in SMS"
}, {
  icon: ICONS.Receptionist,
  benefits: "View recruiter contact numbers"
}];
var COMPARISON = [{
  name: "Get a Professional CV",
  free: "✕",
  premium: "✕",
  assist: ICONS.TICK
}, {
  name: "Track application status",
  free: "✕",
  premium: "✕",
  assist: ICONS.TICK
}, {
  name: "Profile shown at the top",
  free: "✕",
  premium: 1,
  assist: ICONS.TICK
}, {
  name: "50 Premium Job Applications sunny",
  free: "✕",
  premium: 1,
  assist: ICONS.TICK
}, {
  name: "Companies get your profile in SMS",
  free: "✕",
  premium: 1,
  assist: ICONS.TICK
}, {
  name: "View recruiter contact numbers",
  free: "✕",
  premium: 1,
  assist: ICONS.TICK
}];

var hotjarConfig = {
  id: 1185867,
  version: 6
};

var TOP_ROLES = [{
  icon: ICONS.DATAENTRY,
  name: "Data Entry / Back Office",
  iconType: "DataEntry"
}, {
  icon: ICONS.Teacher,
  name: "Teacher",
  iconType: "Teacher"
}, {
  icon: ICONS.BPO,
  name: "BPO/  Telecaller",
  iconType: "Bpo"
}, {
  icon: ICONS.Security,
  name: "Security/ Guard",
  iconType: "Security"
}, {
  icon: ICONS.DELIVERY,
  name: "Delivery/ Collections",
  iconType: "Delivery"
}, {
  icon: ICONS.Receptionist,
  name: "Receptionist/ Front Office",
  iconType: "Receptionist"
}, {
  icon: ICONS.OfficeHelper,
  name: "Office Assistant/ Helper",
  iconType: "OfficeAssistance"
}, {
  icon: ICONS.Electrician,
  name: "Electrician",
  iconType: "Electrician"
}, {
  icon: ICONS.Driver,
  name: 'Driver',
  iconType: "Driver"
}, {
  icon: ICONS.Nurse,
  name: "Nurse",
  iconType: "Nurse"
}, {
  icon: ICONS.Sales,
  name: "Sales",
  iconType: "Sales"
}, {
  icon: ICONS.Beautician,
  name: "Beautician",
  iconType: "Beautician"
}];

var PROFILE_SERVICES = [{
  icon: ICONS.TICK,
  name: "Profile gets highlighted"
}, {
  icon: ICONS.TICK,
  name: "100 Premium job applications"
}, {
  icon: ICONS.TICK,
  name: "Recruiter gets Profile in SMS"
}, {
  icon: ICONS.TICK,
  name: "Get any Govt. ID verified"
}, {
  icon: ICONS.TICK,
  name: "Get Customer care help"
}, {
  icon: ICONS.TICK,
  name: "2 boosts per day"
}];

var JOB_TYPE = [{
  icon: ICONS.WORKHOME,
  name: "Work from Home",
  value: "Work from Home",
  iconType: "WorkFromHome",
  arrowIcon: "❯"
}, {
  icon: ICONS.INTERNSHIP,
  name: "Internship",
  value: "Internship",
  arrowIcon: "❯",
  iconType: "Internship"
}, {
  icon: ICONS.PARTTIME,
  name: "Part time Jobs",
  value: "part time",
  arrowIcon: "❯",
  iconType: "PartTime"
}, {
  icon: ICONS.FULLTIME,
  name: "Full time Jobs",
  value: "full time",
  arrowIcon: "❯",
  iconType: "FullTimeJob"
}, {
  icon: ICONS.GOVERNMENT,
  name: "Government Jobs",
  value: "govt jobs",
  arrowIcon: "❯",
  urlParm: "role",
  iconType: "Government"
}, {
  icon: ICONS.WORKABROAD,
  name: "Work Abroad",
  value: "abroad",
  arrowIcon: "❯",
  iconType: "WorkAbroad"
}];

var LOGGEDIN_MENU = [{ title: "My Profile", href: "/jobs/my-profile" }, { title: "Upgrade Profile", href: "/jobs/vip-landing" }, { title: "Sign Out", href: "/bye" }];

var LOGGEDOUT_MENU = [];
if (__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.location) {
  LOGGEDOUT_MENU.push({
    title: "Login/Register",
    href: "/SignIn?redirect=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.location.pathname + "?from=jobs_pwa")
  });
}

var TRUST_BADGES = {
  NSE_Flag: "nse",
  BSE_Flag: "bse",
  Fortune_100_Flag: "fortune100",
  Fortune_500_Flag: "fortune500",
  ISO_Certified_Flag: "iso",
  Nasscom_Flag: "nasscom",
  ICRA_Sme_Rating: "icrasmerating",
  Startup_Nasscom_Emerge50: "nasscom50",
  // Award_Recognition_Flag:
  Govt_Registered: "govt"
};

// Previous DSN : sentryDSN: 'https://1aff5201f005490bbd979f5255846ab9@quikrsentry.quikr.com/18'
var SENTRY_CONFIG = {
  globalName: "JobsSentry",
  sentryDSN: "https://ec872efc9e76445f814b68466803e56e@quikrsentry.quikr.com/12"
};

var INSUFFICIENT_CREDITS_ERROR_CODE = 8118;

var Q_CASH_STATUS_CONSTANTS = {
  PROMOTIONAL: "PROMOTION",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  PENDING: "PENDING"
};

var Q_CASH_CONTEXTS = {
  APPLY_STEP_1: "JobsApply1",
  APPLY_STEP_2: "JobsApply2",
  APPLY_STEP_CUMULATIVE: "JobsApply"
};

var DUMMY_EMAIL_PATTERNS = [/[6-9]\d{9}-jobs@quikr.com/i];

var ROUTES = {
  HOME: "home",
  SNB: "pwasnb",
  VAP: "pwavap"
};

var PAGES = {
  HOME: "HOME",
  SNB: "SNB",
  VAP: "VAP"
};

var QUESTION_TYPE = {
  CHECKBOX: "CHECKBOX",
  RADIOBOX: "RADIOBOX",
  TEXTBOX: "TEXTBOX",
  DROPDOWN: "DROPDOWN",
  FILE: "FILE",
  RANGE: "RANGE"
};

var LOCALSTORAGE_KEYS = {
  ALL_CITIES: "getAllCities"
};

var FLEXI_CANDIDATE_SMS_TO_UPDATE_PROFILE_MESSAGE = "Hi, please use the link below to update your profile: ";

var RECRUITMENT_SERVICES = {
  remoteJob: ['Yes', 'No', 'Partially'],
  quikrRecruitmentServices: ['Yes', 'No']
};

/***/ }),

/***/ "QZ4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateSnbUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return generateSnbSortUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateFeaturedSnbUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateAssuredSnbUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildNewCitySnbUrl; });
var generateSnbUrl = function generateSnbUrl(currentUrl, selectedFilters, mGlobal, relatedFilter) {
    var queryParts = currentUrl.split("?");
    var urlParts = queryParts[0].split("/");
    var lastPart = urlParts[urlParts.length - 1];
    var filterPart = lastPart.split('+');
    var filterLength = filterPart.length;
    var isSearchRequest = filterPart[filterLength - 1].indexOf('x') >= 0 || filterPart[filterLength - 1].indexOf('y') >= 0;
    var identifierParts = filterPart[filterLength - 1].split('v');
    var newFilterPart = !isSearchRequest ? [filterPart[0]] : [filterPart[0], filterPart[1]];

    var identifiers = [];
    var selectedFilterValues = [];
    var localityFilter = '';
    var premiumApply = false;

    Object.keys(selectedFilters).map(function (filter) {
        if (filter === 'Premium Ads') {
            if (selectedFilters[filter][0] === 1) {
                premiumApply = true;
            }
            return;
        }
        var pos = relatedFilter[filter].charCodeAt(0) - 96;
        identifiers[pos] = relatedFilter[filter];
        if (relatedFilter[filter] === 'u') {
            localityFilter = selectedFilters[filter].length > 1 ? selectedFilters[filter].join('_') : selectedFilters[filter][0];
        } else {
            selectedFilterValues[pos] = selectedFilters[filter].join('_');
        }
    });

    newFilterPart = newFilterPart.concat(selectedFilterValues.filter(Boolean));

    if (mGlobal === 71 || mGlobal === 72) {
        if (filterPart[filterLength - 1].indexOf('u') > 0) {
            newFilterPart.push(filterPart[filterLength - 4]);
        } else {
            newFilterPart.push(filterPart[filterLength - 3]);
        }
    }

    if (localityFilter !== '') {
        newFilterPart.push(localityFilter);
    }

    newFilterPart.push(filterPart[filterLength - 2]);

    if (identifiers.length > 0) {
        identifierParts[1] = identifiers.join('');
        newFilterPart.push(identifierParts.join('v'));
    } else {
        newFilterPart.push(identifierParts[0]);
    }

    urlParts[urlParts.length - 1] = newFilterPart.join('+');
    var newUrl = urlParts.join("/");

    if (queryParts.length > 1) {
        queryParts[0] = newUrl;
        var getParams = queryParts[1].split('&');
        getParams = getParams.filter(function (p) {
            if (p === 'showpremium=1' && !premiumApply) {
                return false;
            }
            return true;
        });
        queryParts[1] = getParams.length > 1 ? getParams.join('&') : getParams;
        newUrl = queryParts[1] !== '' ? queryParts.join("?") : newUrl;
        if (!newUrl.match(/showpremium=1/) && premiumApply) {
            newUrl += '&showpremium=1';
        }
    } else if (premiumApply) {
        newUrl += '?showpremium=1';
    }

    return newUrl;
};

var generateSnbSortUrl = function generateSnbSortUrl(currentUrl, sortby) {
    var url = currentUrl;
    if (currentUrl.indexOf('order=') >= 0) {
        url = sortby == "" ? currentUrl.replace(/order\=[a-zA-Z\_]+/, '') : currentUrl.replace(/order\=[a-zA-Z\_]+/, 'order=' + sortby);
    } else {
        if (sortby != "") {
            url = currentUrl.indexOf("?") >= 0 ? currentUrl + "&order=" + sortby : currentUrl + "?order=" + sortby;
        }
    }
    return url;
};

var generateFeaturedSnbUrl = function generateFeaturedSnbUrl(currentUrl) {
    var newUrl = '';

    var key = "showpremium";

    if (currentUrl.indexOf(key) >= 0) {
        var urlParts = currentUrl.split('?');
        var queryParams = urlParts[1].split('&');
        if (queryParams.length > 1) {
            delete queryParams[queryParams.indexOf(key + "=1")];
            var queryString = queryParams.length > 1 ? queryParams.join('&') : queryParams[0];
            urlParts[1] = queryString;
            newUrl = urlParts.join('?');
        } else {
            newUrl = urlParts[0];
        }
    } else {
        newUrl = currentUrl.indexOf("?") >= 0 ? currentUrl + "&" + key + "=1" : currentUrl + "?" + key + "=1";
    }
    return newUrl;
};

var generateAssuredSnbUrl = function generateAssuredSnbUrl(currentUrl) {
    return currentUrl.indexOf('refurbished') >= 0 ? currentUrl.replace(/refurbished/, 'used') : currentUrl.replace(/used/, 'refurbished');
};

var buildNewCitySnbUrl = function buildNewCitySnbUrl(id, name, match, location) {
    location = typeof location !== 'undefined' ? location : typeof window !== 'undefined' ? window.location : location;
    id = id * 1;
    name = name.replace(/ /g, "-");
    var isAllIndia = id === 0 || id === 1;
    var pageUrl = location.pathname;
    var matches = pageUrl.match(/[w|x|y|z](\d+)([a-zA-Z]+)?/);
    var searchMatches = pageUrl.match(/(x|y)(\d+)/);
    var isSearchUrl = searchMatches && searchMatches.length;
    var slugParams = pageUrl.split('/')[2].split('+');

    var i = slugParams.indexOf("quikrcertified");

    if (i > -1 && matches[2]) {
        var identifiers = matches[2].split('v')[1];
        identifiers = identifiers.replace(new RegExp(identifiers[i - 1]), '');
        if (identifiers == '') {
            matches[2] = '';
        } else {
            matches[2] = matches[2].replace(/n/, '');
        }
        slugParams = slugParams.filter(function (slug) {
            return slug != "quikrcertified";
        });
    }
    var slugParamsLength = slugParams.length;

    if (isAllIndia) {
        slugParams[slugParamsLength - 1] = (isSearchUrl ? 'y' : 'z') + id + (matches[2] ? matches[2] : '');
        slugParams[slugParamsLength - 2] = 'all-india';
    } else {
        slugParams[slugParamsLength - 1] = (isSearchUrl ? 'x' : 'w') + id + (matches[2] ? matches[2] : '');
        slugParams[slugParamsLength - 2] = name.toLowerCase();
    }

    var queryString = location.search;
    queryString = queryString.replace(/showcertified=1/, '');
    queryString = queryString.replace(/\?&/, '?');
    queryString = queryString == '?' ? '' : queryString;
    return '/' + match.params.type + '/' + slugParams.join('+') + queryString;
};

/***/ }),

/***/ "Qq+M":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("IPuT");

/***/ }),

/***/ "Qrop":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */

(function (self) {
    'use strict';

    var nativeURLSearchParams = self.URLSearchParams && self.URLSearchParams.prototype.get ? self.URLSearchParams : null,
        isSupportObjectConstructor = nativeURLSearchParams && new nativeURLSearchParams({ a: 1 }).toString() === 'a=1',

    // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
    decodesPlusesCorrectly = nativeURLSearchParams && new nativeURLSearchParams('s=%2B').get('s') === '+',
        __URLSearchParams__ = "__URLSearchParams__",

    // Fix bug in Edge which cannot encode ' &' correctly
    encodesAmpersandsCorrectly = nativeURLSearchParams ? function () {
        var ampersandTest = new nativeURLSearchParams();
        ampersandTest.append('s', ' &');
        return ampersandTest.toString() === 's=+%26';
    }() : true,
        prototype = URLSearchParamsPolyfill.prototype,
        iterable = !!(self.Symbol && self.Symbol.iterator);

    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
        return;
    }

    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
    function URLSearchParamsPolyfill(search) {
        search = search || "";

        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
            search = search.toString();
        }
        this[__URLSearchParams__] = parseToDict(search);
    }

    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.append = function (name, value) {
        appendTo(this[__URLSearchParams__], name, value);
    };

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
    prototype['delete'] = function (name) {
        delete this[__URLSearchParams__][name];
    };

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
    prototype.get = function (name) {
        var dict = this[__URLSearchParams__];
        return name in dict ? dict[name][0] : null;
    };

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
    prototype.getAll = function (name) {
        var dict = this[__URLSearchParams__];
        return name in dict ? dict[name].slice(0) : [];
    };

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    prototype.has = function (name) {
        return name in this[__URLSearchParams__];
    };

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.set = function set(name, value) {
        this[__URLSearchParams__][name] = ['' + value];
    };

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
    prototype.toString = function () {
        var dict = this[__URLSearchParams__],
            query = [],
            i,
            key,
            name,
            value;
        for (key in dict) {
            name = encode(key);
            for (i = 0, value = dict[key]; i < value.length; i++) {
                query.push(name + '=' + encode(value[i]));
            }
        }
        return query.join('&');
    };

    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = !forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy;
    /*
     * Apply polifill to global object and append other prototype into it
     */
    Object.defineProperty(self, 'URLSearchParams', {
        value: useProxy ?
        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        new Proxy(nativeURLSearchParams, {
            construct: function construct(target, args) {
                return new target(new URLSearchParamsPolyfill(args[0]).toString());
            }
        }) : URLSearchParamsPolyfill
    });

    var USPProto = self.URLSearchParams.prototype;

    USPProto.polyfill = true;

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
    USPProto.forEach = USPProto.forEach || function (callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function (name) {
            dict[name].forEach(function (value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };

    /**
     * Sort all name-value pairs
     */
    USPProto.sort = USPProto.sort || function () {
        var dict = parseToDict(this.toString()),
            keys = [],
            k,
            i,
            j;
        for (k in dict) {
            keys.push(k);
        }
        keys.sort();

        for (i = 0; i < keys.length; i++) {
            this['delete'](keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            var key = keys[i],
                values = dict[key];
            for (j = 0; j < values.length; j++) {
                this.append(key, values[j]);
            }
        }
    };

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.keys = USPProto.keys || function () {
        var items = [];
        this.forEach(function (item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.values = USPProto.values || function () {
        var items = [];
        this.forEach(function (item) {
            items.push(item);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.entries = USPProto.entries || function () {
        var items = [];
        this.forEach(function (item, name) {
            items.push([name, item]);
        });
        return makeIterator(items);
    };

    if (iterable) {
        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    }

    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function (match) {
            return replace[match];
        });
    }

    function decode(str) {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    }

    function makeIterator(arr) {
        var iterator = {
            next: function next() {
                var value = arr.shift();
                return { done: value === undefined, value: value };
            }
        };

        if (iterable) {
            iterator[self.Symbol.iterator] = function () {
                return iterator;
            };
        }

        return iterator;
    }

    function parseToDict(search) {
        var dict = {};

        if (typeof search === "object") {
            for (var key in search) {
                if (search.hasOwnProperty(key)) {
                    appendTo(dict, key, search[key]);
                }
            }
        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) {
                search = search.slice(1);
            }

            var pairs = search.split("&");
            for (var j = 0; j < pairs.length; j++) {
                var value = pairs[j],
                    index = value.indexOf('=');

                if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
                } else {
                    if (value) {
                        appendTo(dict, decode(value), '');
                    }
                }
            }
        }

        return dict;
    }

    function appendTo(dict, name, value) {
        var val = typeof value === 'string' ? value : value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value);

        if (name in dict) {
            dict[name].push(val);
        } else {
            dict[name] = [val];
        }
    }
})(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("HPUF")))

/***/ }),

/***/ "R8p8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../window-or-global/lib/index.js
var lib = __webpack_require__("IyPV");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ../q-jobs/node_modules/redux/es/redux.js
var redux = __webpack_require__("Pp8G");

// EXTERNAL MODULE: ../redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__("GnPc");
var redux_logger_default = /*#__PURE__*/__webpack_require__.n(redux_logger);

// CONCATENATED MODULE: ../q-jobs/src/reducers/UserReducer/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var userDefault = {
	loggedIn: false,
	hasCredits: false,
	credits: 0,
	hasUnlimitedFreeAdsPack: false,
	vblDetails: [],
	companyDetails: {},
	loaded: false,
	whatsappConnectCredits: 0
};

var userReducer = function userReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userDefault;
	var actions = arguments[1];


	switch (actions.type) {
		case 'UPDATE_USER':
			state = _extends({}, state, actions.payload, { loaded: true });
			break;
		default:
			return state;
	}
	return state;
};

/* harmony default export */ var UserReducer = (userReducer);
// EXTERNAL MODULE: ../q-jobs/src/utils/index.js + 1 modules
var utils = __webpack_require__("upA3");

// CONCATENATED MODULE: ../q-jobs/src/utils/Apply/defaultState.js


var applyDefaultState = {
  step: 0,
  type: 'DEFAULT',
  job: { //Current Job for which the apply is called.Only required Fields added
    id: '',
    title: '',
    snbUrl: '/jobs',
    cityId: ''
  },
  disableInputs: false,
  directApplyAdId: null, // used to initiate apply from amp
  refDirectApplyAdId: null, // used to pass source in apply request
  applySource: null,
  discount: 0,
  showCallUnlockBuyOptions: false,
  applyForm: {},
  hasNewStepTwoAnswers: false,
  isSkipApplyInitiated: false,
  isQuickApplyInitiated: false,
  utmSource: '',
  utmMedium: '',
  utmCampaign: ''
};
// EXTERNAL MODULE: ../q-jobs/src/constants/events.js
var events = __webpack_require__("4xt+");

// CONCATENATED MODULE: ../q-jobs/src/reducers/ApplyReducer/index.js
var ApplyReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var ApplyReducer_applyReducer = function applyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : applyDefaultState;
  var actions = arguments[1];

  switch (actions.type) {
    case 'UPDATE_APPLY':
      state = ApplyReducer__extends({}, state, actions.payload);
      break;
    case events["a" /* APPLY_EVENTS */].TOGGLE_CALL_UNLOCK_CANDIDATE_BUY_OPTIONS:
      state = ApplyReducer__extends({}, state, actions.payload);
      break;
    case 'FORM_FIELD_CHANGE':
      state.applyForm = ApplyReducer__extends({}, state.applyForm, actions.payload);
      break;
    case events["a" /* APPLY_EVENTS */].WHATSAPP_NOTIFICATION:
      var payload = { whatsAppOptInFlag: actions.payload };
      state.applyForm = ApplyReducer__extends({}, state.applyForm, payload);
      break;
    case events["a" /* APPLY_EVENTS */].TOGGLE_SKIP_APPLY_FLAG:
    case events["a" /* APPLY_EVENTS */].TOGGLE_QUICK_APPLY_FLAG:
    case events["a" /* APPLY_EVENTS */].SET_UTM_PARAMETERS:
      state = ApplyReducer__extends({}, state, actions.payload);
      break;
  }
  return state;
};

/* harmony default export */ var ApplyReducer = (ApplyReducer_applyReducer);
// CONCATENATED MODULE: ../q-jobs/src/reducers/JobReducer/index.js
var JobReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var job = {
	isJobViewSaved: false
};

var JobReducer_jobReducer = function jobReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : job;
	var actions = arguments[1];

	switch (actions.type) {
		case events["g" /* JOB_EVENTS */].UPDATE_JOB:
			state = JobReducer__extends({}, state, actions.payload);
			break;
		case events["g" /* JOB_EVENTS */].UPDATE_NEW_JOB:
			state = actions.payload;
			state.callUnlockShowHide = 0; // hide call button by default
			break;
		case events["g" /* JOB_EVENTS */].UPDATE_RSA_DATA:
			state.rsaData = actions.payload;
			break;
		default:
			return state;
	}
	return state;
};

/* harmony default export */ var JobReducer = (JobReducer_jobReducer);
// CONCATENATED MODULE: ../q-jobs/src/reducers/WindowReducer/index.js
var WindowReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var loadDefault = { windowLoadComplete: false, updateDfp: false };

/**
 * Adding a state for window properties
 * @param {*} state
 * @param {*} actions
 */
var WindowReducer_windowReducer = function windowReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : loadDefault;
  var actions = arguments[1];

  switch (actions.type) {
    case 'UPDATE_LOAD_STATUS':
      state = WindowReducer__extends({}, state, actions.payload);
      break;
    case 'UPDATE_PAYMENT_DATA':
      state = WindowReducer__extends({}, state, actions.payload);
      break;
    case events["k" /* WINDOW_EVENTS */].REMOVE_ERROR_MESSAGE:
      state = WindowReducer__extends({}, state, actions.payload);
      break;
    case 'UPDATE_WINDOW_DATA':
      state = WindowReducer__extends({}, state, actions.payload);
    default:
      return state;
  }

  return state;
};

/* harmony default export */ var WindowReducer = (WindowReducer_windowReducer);
// CONCATENATED MODULE: ../q-jobs/src/reducers/ContextReducer/index.js
var ContextReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var defaultContext = {
  togglePopup: false,
  isQCashEnabled: false,
  qCashDetails: {},
  // isFlyingCarpetAdEnabled: false,
  showLoader: false
};

/**
 * Defualt context values for jobs.Can include city,role,packs
 */
var ContextReducer_contextReducer = function contextReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultContext;
  var actions = arguments[1];

  switch (actions.type) {
    case events["d" /* CONTEXT_EVENTS */].UPDATE_CONTEXT:
      {
        state = ContextReducer__extends({}, state, actions.payload);
        break;
      }
    case events["d" /* CONTEXT_EVENTS */].SEARCH_POPUP_TOGGLE:
      {
        // use state as first parameter
        state = ContextReducer__extends(state, { 'togglePopup': actions.payload.value });
        break;
      }
    case events["d" /* CONTEXT_EVENTS */].TOGGLE_LOADER:
      {
        state = ContextReducer__extends({}, state, actions.payload);
        break;
      }
  }

  return state;
};

/* harmony default export */ var ContextReducer = (ContextReducer_contextReducer);
// EXTERNAL MODULE: ../q-jobs/src/reducers/SnbReducer/filter.js
var filter = __webpack_require__("VsV7");

// CONCATENATED MODULE: ../q-jobs/src/reducers/SnbReducer/index.js
var SnbReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Declaring the redux reducers and default state
 * for snb candidate page
 *
 * @author John Lukose <john.lukose@quikr.com>
 */



var defaultSnbLoadState = {
	'showSimilarJobsTupleOnSnB': false
};

var SnbReducer_SnbReducer = function SnbReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSnbLoadState;
	var actions = arguments[1];

	switch (actions.type) {
		case events["l" /* default */].UPDATE_JOB_LISTINGS:
			state.jobs = SnbReducer__extends({}, state.jobs, actions.payload);
			break;
		case events["l" /* default */].SNB_CONTAINER_EVENTS.RECEVED_SIMILAR_JOBS_AJAXDATA:
			state = SnbReducer__extends(state, { showSimilarJobsTupleOnSnB: actions.payload.showHide });
			return state;
			break;
		default:
			return state;
	}
};
/* harmony default export */ var reducers_SnbReducer = (SnbReducer_SnbReducer);
// CONCATENATED MODULE: ../q-jobs/src/reducers/JobSearchReducer/index.js
var JobSearchReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var JobSearchReducer_defaultContext = {
  page: 1,
  jobs: [],
  idList: [],
  dfpOptions: []
};

/**
 * Default context values for jobs. Can include city, role, packs
 */
var defaultContextNew = JobSearchReducer_defaultContext;

var JobSearchReducer_jobSearchReducer = function jobSearchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultContextNew;
  var actions = arguments[1];

  switch (actions.type) {
    case events["h" /* JOB_SEARCH_EVENTS */].UPDATE_JOB_SEARCH_LIST:
      if (actions.payload.replaceJobs) {} else {
        actions.payload.jobs = state.jobs.concat(actions.payload.jobs);
      }

      state = JobSearchReducer__extends({}, state, actions.payload);
      break;
    case events["h" /* JOB_SEARCH_EVENTS */].UPDATE_DFP_OPTIONS:
      state = JobSearchReducer__extends({}, state, actions.payload);
      break;
    case events["h" /* JOB_SEARCH_EVENTS */].EMPTY_JOB_SEARCH_LIST:
      actions.payload.jobs = [];
      state = JobSearchReducer__extends({}, JobSearchReducer_defaultContext, { dfpOptions: state.dfpOptions, flyingCarpetPosition: state.flyingCarpetPosition });
      break;
    case events["h" /* JOB_SEARCH_EVENTS */].TOGGLE_JOB_LIST_DISPLAY:
      state = JobSearchReducer__extends({}, state, actions.payload);
      break;
    case events["h" /* JOB_SEARCH_EVENTS */].UPDATE_JOB_SEARCH_REDUCER:
      if (!actions.payload.replaceJobs) {
        actions.payload.jobs = state.jobs.concat(actions.payload.jobs);
      }
      state = JobSearchReducer__extends({}, state, actions.payload);
      break;
  }

  return state;
};

/* harmony default export */ var JobSearchReducer = (JobSearchReducer_jobSearchReducer);
// EXTERNAL MODULE: ../q-jobs/src/actions/PostAdActions/index.js
var PostAdActions = __webpack_require__("GNhE");

// CONCATENATED MODULE: ../q-jobs/src/utils/JobsPostAd/featureHandler.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PostAdFeaturesConstants = {
  IncludeWebsiteUrl: 'IncludeWebsiteUrl',
  IncludeMobile: 'IncludeMobile'
  // WFHPack: 'WFHPack',
  // PPAPack: 'PPAPack',
  // SpotlightPack: 'SpotlightPack',
  // GoldAd: 'GoldAd',
  // UnlimtedFreeAds: 'UnlimtedFreeAds'
};

// PostAdFeatures - Need to stored as state in redux

var PostAdFeatures = function () {
  function PostAdFeatures() {
    _classCallCheck(this, PostAdFeatures);

    this.initializeFeatures();
  }

  PostAdFeatures.prototype.initializeFeatures = function initializeFeatures() {
    this[PostAdFeaturesConstants.IncludeWebsiteUrl] = true;
    this[PostAdFeaturesConstants.IncludeMobile] = true;
    // this[PostAdFeaturesConstants.WFHPack] = false;
    // this[PostAdFeaturesConstants.PPAPack] = false;
    // this[PostAdFeaturesConstants.SpotlightPack] = false;
    // this[PostAdFeaturesConstants.GoldAd] = false;
    // this[PostAdFeaturesConstants.UnlimtedFreeAds] = false;
  };

  PostAdFeatures.prototype.set = function set(feature, value) {
    if (this.hasOwnProperty(feature)) this[feature] = value;
  };

  PostAdFeatures.prototype.get = function get(feature) {
    if (this.hasOwnProperty(feature)) return this.feature;
  };

  PostAdFeatures.prototype.getAll = function getAll() {
    var values = {};

    for (var key in this) {
      if (this.hasOwnProperty(key) && PostAdFeaturesConstants.hasOwnProperty(key)) {
        values[key] = this[key];
      }
    }

    return values;
  };

  return PostAdFeatures;
}();

var featureHandler_PostAdFeatureHandler = function PostAdFeatureHandler() {
  var _this = this;

  _classCallCheck(this, PostAdFeatureHandler);

  this.features = function () {
    return _this.postAdFeatures;
  };

  this.getAll = function () {
    return _this.features().getAll();
  };

  this.setFeature = function (feature, value) {
    _this.features().set(feature, value);
    _this.setInRedux();
  };

  this.setInRedux = function () {
    return Object(PostAdActions["b" /* reduxActionFeatureChange */])(_this.getAll());
  };

  this.getUpdatedFeatureConfig = function (storeValues) {
    var allFeatures = _this.getAll();
    for (var feature in allFeatures) {
      if (allFeatures.hasOwnProperty(feature)) {
        var isFeatureEnabled = _this.hasOwnProperty('is' + feature + 'Enabled') && _this['is' + feature + 'Enabled'](storeValues);
        _this.setFeature(feature, isFeatureEnabled);
      }
    }

    return _this.getAll();
  };

  // if (instance)
  //   return instance;

  this.postAdFeatures = new PostAdFeatures();
  this.instance = this;
};

// PostAdFeatureHandler is meant to be a singleton class


var instance = new featureHandler_PostAdFeatureHandler();

/* harmony default export */ var featureHandler = (instance);
// CONCATENATED MODULE: ../q-jobs/src/reducers/JobsPostAdReducer/featureReducer.js
var featureReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Declaring the redux reducers and default state
 * for Jobs Post Ad Features
 *
 * @author John Lukose <john.lukose@quikr.com>
 */




var defaultFeatureState = featureHandler.getAll();

var featureReducer_FeatureReducer = function FeatureReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultFeatureState;
	var actions = arguments[1];

	switch (actions.type) {
		case events["c" /* CONFIG_EVENTS */].CONFIG_UPDATED:
			state = featureReducer__extends({}, state, featureHandler.getUpdatedFeatureConfig(actions.payload.store));
			break;
		default:
			return state;
	}

	return state;
};

/* harmony default export */ var featureReducer = (featureReducer_FeatureReducer);
// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/index.js
var JobsPostAd = __webpack_require__("/gj+");

// CONCATENATED MODULE: ../q-jobs/src/reducers/JobsPostAdReducer/jobsPostAdRequestReducer.js
var jobsPostAdRequestReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var jobsPostAdRequestReducer_JobsPostAdRequestReducer = function JobsPostAdRequestReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : JobsPostAd["f" /* defaultJobsPostAdRequestState */];
  var actions = arguments[1];

  switch (actions.type) {
    case events["f" /* JOBS_POST_AD_EVENTS */].AD_ATTRIBUTE_CHANGE:
      {
        var oldState = Object(utils["c" /* copyObject */])(state);
        state = jobsPostAdRequestReducer__extends({}, state, actions.payload);

        if (Object(utils["s" /* isDebugMode */])()) {
          console.log('New attributes added ', Object(utils["e" /* difference */])(state, oldState));
        }
        break;
      }
    case events["f" /* JOBS_POST_AD_EVENTS */].UPDATE_PACK_SELECTED:
      {
        state = jobsPostAdRequestReducer__extends({}, state);
        state.others.selectedPack = actions.payload.selectedPack;
        state.others.selectedSubPack = actions.payload.selectedSubPack;
        break;
      }
    default:
      return state;
  }

  return state;
};

/* harmony default export */ var jobsPostAdRequestReducer = (jobsPostAdRequestReducer_JobsPostAdRequestReducer);
// CONCATENATED MODULE: ../q-jobs/src/reducers/ConfigReducer/index.js
var ConfigReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * @author shreyas.hande on 6/11/18
 *
 */



var defaultState = {};

var ConfigReducer_ConfigReducer = function ConfigReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case events["c" /* CONFIG_EVENTS */].UPDATE_CONFIG:
            state = ConfigReducer__extends({}, state, action.payload.config);
    }
    return state;
};

/* harmony default export */ var reducers_ConfigReducer = (ConfigReducer_ConfigReducer);
// EXTERNAL MODULE: ../q-jobs/src/utils/Integrations/utils.js
var Integrations_utils = __webpack_require__("5/Mg");

// CONCATENATED MODULE: ../q-jobs/src/reducers/IntegrationsReducer/index.js
var IntegrationsReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// set default state
var defaultIntegrationFormState = Object(Integrations_utils["c" /* getDefaultState */])();

var IntegrationsReducer_IntegrationsFormReducer = function IntegrationsFormReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultIntegrationFormState;
  var actions = arguments[1];

  switch (actions.type) {
    case events["e" /* INTEGRATIONS_EVENTS */].FORM_CHANGE:
      {
        state = IntegrationsReducer__extends({}, state, actions.payload);
        break;
      }
    case events["e" /* INTEGRATIONS_EVENTS */].FORM_FIELD_CHANGE:
      {
        state.form = IntegrationsReducer__extends({}, state.form, actions.payload);
        break;
      }
    case events["e" /* INTEGRATIONS_EVENTS */].FORM_OPEN:
      {
        if (state.type && state.forms[state.type]) {
          state.forms[state.type].status = 1;
        }
        break;
      }
    case events["e" /* INTEGRATIONS_EVENTS */].FORM_CLOSE:
      {
        if (state.type && state.forms[state.type]) {
          state.forms[state.type].status = 0;
        }
        break;
      }
    case events["e" /* INTEGRATIONS_EVENTS */].FORM_SUBMITTED:
      {
        if (state.type && state.forms[state.type]) {
          state.forms[state.type].status = 2;
        }
        break;
      }
    case events["e" /* INTEGRATIONS_EVENTS */].INTEGRATION_SOURCE_CLEAR:
      {
        var source = actions.payload.source;
        if (state.sourcesSet && source) state.sourcesSet[source] = false;
        break;
      }
    case events["e" /* INTEGRATIONS_EVENTS */].SET_FORM_TYPE:
      {
        // let jobStore = JobStore.getState();
        var jobStore = actions.payload.globalState;

        if (actions.payload.type) {
          state.type = actions.payload.type;
        }

        if (actions.payload.source) {
          var _source = actions.payload.source;
          state.sourcesSet = IntegrationsReducer__extends({}, state.sourcesSet);
          state.sourcesSet[_source] = true;
        }

        if (jobStore.context.city) state.form.city.value = jobStore.context.city;

        if (jobStore.user.loggedIn) {
          if (jobStore.user.name) state.form.name.value = jobStore.user.name;

          if (jobStore.user.email) state.form.email.value = jobStore.user.email;

          if (jobStore.user.mobile) state.form.mobile.value = jobStore.user.mobile;
        }

        break;
      }
    case events["e" /* INTEGRATIONS_EVENTS */].CLEAR_FORM:
      {
        if (state.type && state.forms[state.type]) {
          state.forms[state.type].status = 3;
          Object(Integrations_utils["e" /* setFormSubmitted */])(state.type);
          state.type = '';
        }
        break;
      }
    case events["e" /* INTEGRATIONS_EVENTS */].UPDATE_FORM_STATE:
      {
        var context = actions.payload.context || {};
        Object.keys(context).filter(function (key) {
          if (context[key]['alwaysOn']) {
            state.forms[key] = {
              status: Object(Integrations_utils["d" /* isFormSubmitted */])(key) ? 3 : 0
            };
            Object(Integrations_utils["f" /* updateIntegrationFormFields */])(key, context[key]);
            return key;
          }
        });
        state.formDetails = IntegrationsReducer__extends({}, Integrations_utils["a" /* INTEGRATIONS_FORMS_DETAILS */]);
        break;
      }
    default:
      break;
  }

  state = IntegrationsReducer__extends({}, state);
  return state;
};

/* harmony default export */ var IntegrationsReducer = (IntegrationsReducer_IntegrationsFormReducer);
// CONCATENATED MODULE: ../q-jobs/src/reducers/ProfileReducer/index.js
var ProfileReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var ProfileReducer_defaultState = {
  profileRichnessForm: {
    questions: [],
    answers: {},
    currentQuestion: 1,
    questionsLoaded: false,
    popupOpen: false,
    ackOpen: false,
    ackType: '',
    formSubmitted: false,
    config: {},
    submittedAnswers: []
  }
};

var ProfileReducer_profileReducer = function profileReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ProfileReducer_defaultState;
  var actions = arguments[1];

  var newState = void 0;
  switch (actions.type) {
    case events["i" /* PROFILE_EVENTS */].TOGGLE_POPUP:
      newState = Object(utils["c" /* copyObject */])(state);
      newState.profileRichnessForm.popupOpen = actions.payload;
      state = newState;
      break;
    case events["i" /* PROFILE_EVENTS */].SET_QUESTION:
      newState = Object(utils["c" /* copyObject */])(state);
      newState.profileRichnessForm.currentQuestion = actions.payload;
      state = newState;
      break;
    case events["i" /* PROFILE_EVENTS */].INITIALIZE_CONTEXT:
    case events["i" /* PROFILE_EVENTS */].UPDATE_CONTEXT:
      newState = Object(utils["c" /* copyObject */])(state);
      newState.profileRichnessForm = ProfileReducer__extends({}, state.profileRichnessForm, actions.payload);
      state = newState;
      break;
    case events["i" /* PROFILE_EVENTS */].TOGGLE_ACK:
      newState = Object(utils["c" /* copyObject */])(state);
      newState.profileRichnessForm.ackOpen = actions.payload;
      state = newState;
      break;
    case events["i" /* PROFILE_EVENTS */].FORM_SUBMITTED:
      newState = Object(utils["c" /* copyObject */])(state);
      newState.profileRichnessForm.formSubmitted = true;
      state = newState;
      break;
  }
  return state;
};

/* harmony default export */ var ProfileReducer = (ProfileReducer_profileReducer);
// CONCATENATED MODULE: ../q-jobs/src/reducers/CompanyReducer/index.js
var CompanyReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  companies: [],
  page: 1,
  totalCount: 0
};

var CompanyReducer = function CompanyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'UPDATE_COMPANY':
      state = CompanyReducer__extends({}, state, action.payload);
  }
  return state;
};

/* harmony default export */ var reducers_CompanyReducer = (CompanyReducer);
// EXTERNAL MODULE: ../q-jobs/src/reducers/FlexiCandidateReducer/index.js
var FlexiCandidateReducer = __webpack_require__("pUo6");

// CONCATENATED MODULE: ../q-jobs/src/reducers/FlexiRecruiterReducer/index.js
var FlexiRecruiterReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var FlexiRecruiterReducer_defaultState = {
  rmtReportsFilters: {
    masterUserId: '',
    startDate: '',
    endDate: ''
  }
};

var flexiRecruiterReducer = function flexiRecruiterReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FlexiRecruiterReducer_defaultState;
  var actions = arguments[1];

  switch (actions.type) {
    case 'UPDATE_FLEXI_RECRUITER_STATE':
      {
        state = FlexiRecruiterReducer__extends({}, state, actions.payload);
        break;
      }
  }

  return state;
};

/* harmony default export */ var FlexiRecruiterReducer = (flexiRecruiterReducer);
// CONCATENATED MODULE: ../q-jobs/src/reducers/CandidateTestReducer/index.js
var CandidateTestReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CandidateTestReducer_defaultState = {
  isContextLoaded: false,
  currentSurveyQuestion: 1,
  currentSkillTestQuestion: 1,
  surveyQuestions: [],
  surveyAnswers: {},
  skillTestQuestions: [],
  skillTestAnswers: {},
  currentTab: 'survey',
  feedbackQuestions: [],
  feedbackAnswers: {},
  surveyQuestionsOverall: [],
  surveyConfidenceQuestionMap: {},
  isTestSubmitted: false,
  isTestStarted: false,
  testResponse: {},
  testResponseStep: 1,
  specialQuestionIds: {},
  url: '',
  redirectURL: '',
  finalFeedbackQuestion: {},
  finalFeedbackAnswer: {},
  message: ''
};

var CandidateTestReducer_CandidateTestReducer = function CandidateTestReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CandidateTestReducer_defaultState;
  var actions = arguments[1];

  var newState = state;
  var currentState = void 0;

  switch (actions.type) {
    case events["b" /* CANDIDATE_TEST_EVENTS */].SHOW_NEXT_SURVEY_QUESTION:
      currentState = Object(utils["c" /* copyObject */])(state);
      currentState.currentSurveyQuestion++;
      newState = currentState;
      break;
    case events["b" /* CANDIDATE_TEST_EVENTS */].SHOW_PREVIOUS_SURVEY_QUESTION:
      currentState = Object(utils["c" /* copyObject */])(state);
      currentState.currentSurveyQuestion--;
      newState = currentState;
      break;
    case events["b" /* CANDIDATE_TEST_EVENTS */].INITIALIZE_CONTEXT:
    case events["b" /* CANDIDATE_TEST_EVENTS */].UPDATE_CONTEXT:
    case events["b" /* CANDIDATE_TEST_EVENTS */].CHANGE_TAB:
    case events["b" /* CANDIDATE_TEST_EVENTS */].SHOW_RESPONSE:
    case events["b" /* CANDIDATE_TEST_EVENTS */].SET_FINAL_FEEDBACK_ANSWER:
    case events["b" /* CANDIDATE_TEST_EVENTS */].SET_REDIRECT_URL:
    case events["b" /* CANDIDATE_TEST_EVENTS */].SET_ERROR:
      newState = CandidateTestReducer__extends({}, Object(utils["c" /* copyObject */])(state), actions.payload);
      break;
    case events["b" /* CANDIDATE_TEST_EVENTS */].START_TEST:
      newState = CandidateTestReducer__extends({}, state, { isTestStarted: true });
      break;
    case events["b" /* CANDIDATE_TEST_EVENTS */].SHOW_NEXT_RESPONSE_SCREEN:
      currentState = Object(utils["c" /* copyObject */])(state);
      currentState.testResponseStep++;
      newState = currentState;
      break;
  }

  return newState;
};

/* harmony default export */ var reducers_CandidateTestReducer = (CandidateTestReducer_CandidateTestReducer);
// CONCATENATED MODULE: ../q-jobs/src/reducers/index.js



















var reducers = Object(redux["c" /* combineReducers */])({
  config: reducers_ConfigReducer,
  user: UserReducer,
  apply: ApplyReducer,
  job: JobReducer,
  window: WindowReducer,
  context: ContextReducer,
  snb: reducers_SnbReducer,
  filter: filter["a" /* default */],
  jobSearch: JobSearchReducer,
  jobsPostAdFeature: featureReducer,
  postAdRequest: jobsPostAdRequestReducer,
  integrationsForm: IntegrationsReducer,
  profile: ProfileReducer,
  company: reducers_CompanyReducer,
  flexiCandidate: FlexiCandidateReducer["a" /* default */],
  flexiRecruiter: FlexiRecruiterReducer,
  candidateTest: reducers_CandidateTestReducer
});
// CONCATENATED MODULE: ../q-jobs/src/store.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JobStore; });
var _class, _temp;

function store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var jobsReducers = Object(redux["c" /* combineReducers */])({
    jobs: reducers
});

var store = void 0;

// Grab the state from a global variable injected into the server-generated HTML
var preloadedState = void 0;

if (typeof window !== 'undefined') {
    preloadedState = window.__PRELOADED_STATE__;
    console.log('store', preloadedState);
    // Allow the passed state to be garbage-collected
    // to be removed at a later stage
    // delete window.__PRELOADED_STATE__;
}

if (lib_default.a.document && Object(utils["s" /* isDebugMode */])()) {
    store = Object(redux["d" /* createStore */])(jobsReducers, preloadedState, Object(redux["a" /* applyMiddleware */])(redux_logger_default.a));
} else {
    store = Object(redux["d" /* createStore */])(jobsReducers, preloadedState);
}

/* harmony default export */ var src_store = __webpack_exports__["b"] = (store);

var JobStore = (_temp = _class = function JobStore() {
    store__classCallCheck(this, JobStore);
}, _class.getState = function () {
    return Object(utils["c" /* copyObject */])(store.getState().jobs);
}, _class.dispatch = function (params) {
    return store.dispatch(params);
}, _class.storeHasKey = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var obj = JobStore.getState();

    for (var i = 0; i < args.length; i++) {
        if (!obj || !obj.hasOwnProperty(args[i])) {
            return false;
        }
        obj = obj[args[i]];
    }

    return true;
}, _temp);

/***/ }),

/***/ "RGwo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Apply; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("R8p8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index__ = __webpack_require__("upA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_JobSearchActions__ = __webpack_require__("4t40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_ApplyActions__ = __webpack_require__("y6h9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WebStorageWrapper__ = __webpack_require__("Lpc9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexedDbWrapper__ = __webpack_require__("lmsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ApplyCookieHelper__ = __webpack_require__("8Ery");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_window_or_global__);
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This holds current apply state along with required parameters
 *
 */











var Apply = (_temp = _class = function () {
  // used to initiate apply from amp
  function Apply() {
    var _this = this;

    _classCallCheck(this, Apply);

    this.step = 0;
    this.type = 'DEFAULT';
    this.job = { //Current Job for which the apply is called.Only required Fields added
      id: '',
      title: '',
      snbUrl: '/jobs',
      cityId: ''
    };
    this.disableInputs = false;
    this.directApplyAdId = null;
    this.refDirectApplyAdId = null;
    this.applySource = null;
    this.discount = 0;
    this.showCallUnlockBuyOptions = false;
    this.applyForm = {};
    this.hasNewStepTwoAnswers = false;
    this.isSkipApplyInitiated = false;
    this.isQuickApplyInitiated = false;

    this.setDirectApplyDetails = function () {
      if (__WEBPACK_IMPORTED_MODULE_7_window_or_global___default.a.location && __WEBPACK_IMPORTED_MODULE_7_window_or_global___default.a.location.pathname.search('zwqxj') >= 0) {
        var adId = Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["l" /* getParamFromUrl */])('adId');

        if (adId) {
          _this.directApplyAdId = adId;
          _this.refDirectApplyAdId = adId;
        }
      }
    };

    this.setApplySourceFromUrl = function () {
      if (__WEBPACK_IMPORTED_MODULE_7_window_or_global___default.a.location && __WEBPACK_IMPORTED_MODULE_7_window_or_global___default.a.location.pathname.search('zwqxj') >= 0) {
        var applySource = Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["l" /* getParamFromUrl */])('source');
        if (applySource) {
          _this.applySource = applySource;
        }
      }
    };

    this.setDirectApplyDetails();
    this.setApplySourceFromUrl();
  } // used to pass source in apply request


  Apply.getApplyStore = function getApplyStore(key) {
    return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].getState().apply[key];
  };

  Apply.getJobsAppliedInSessionCount = function getJobsAppliedInSessionCount() {
    var count = __WEBPACK_IMPORTED_MODULE_4__WebStorageWrapper__["a" /* default */].getSessionStorage().get('totalJobsAppliedInSession');
    count = count ? parseInt(count, 10) : 0;
    return count;
  };

  Apply.incrementJobsAppliedInSession = function incrementJobsAppliedInSession() {
    var jobsAppliedInSession = Apply.getJobsAppliedInSessionCount();
    var count = jobsAppliedInSession ? jobsAppliedInSession + 1 : 1;

    __WEBPACK_IMPORTED_MODULE_4__WebStorageWrapper__["a" /* default */].getSessionStorage().set('totalJobsAppliedInSession', count);
  };

  Apply.getJobFromStore = function getJobFromStore(adId) {
    var searchedJob = null,
        jobs = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].getState().jobSearch.jobs;

    if (jobs.length > 0) {
      jobs.forEach(function (item) {
        if (adId == item.id) searchedJob = item;
      });
    }

    return searchedJob;
  };

  // set apply source from url if present


  Apply.toggleJobListDisplay = function toggleJobListDisplay(show) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_JobSearchActions__["b" /* toggleJobListDisplay */])(show));
  };

  Apply.updateSavedAppliesFromIDB = function updateSavedAppliesFromIDB() {
    try {
      var applyCookieHelper = new __WEBPACK_IMPORTED_MODULE_6__ApplyCookieHelper__["a" /* default */]();
      var appliedJobs = applyCookieHelper.getAppliedJobs();

      // get failed jobs to be removed from cookies and indexeddb

      var _IndexedDbWrapper$get = __WEBPACK_IMPORTED_MODULE_5__IndexedDbWrapper__["a" /* default */].getAppliedJobsByStatus('failed'),
          applyTransaction = _IndexedDbWrapper$get.applyTransaction,
          applyObjects = _IndexedDbWrapper$get.applyObjects;

      if (!applyTransaction) {
        return;
      }
      applyTransaction.oncomplete = function () {
        // check for indexeddb failed apply objects and update cookie
        // so that the user can view the failed jobs again in snb
        if (applyObjects && applyObjects.length === 0) {
          return;
        }

        applyObjects.forEach(function (value) {
          var applyIndex = appliedJobs.indexOf(value.adid);
          if (applyIndex > -1) {
            appliedJobs.splice(applyIndex, 1);
          }
          // remove the apply object from indexeddb
          __WEBPACK_IMPORTED_MODULE_5__IndexedDbWrapper__["a" /* default */].removeApplyFromIdb(value);
        });
        // update the cookie with the new applied jobs array
        applyCookieHelper.setAppliedJobs(appliedJobs);

        appliedJobs = applyCookieHelper.getAppliedJobs();
        var updatedApply = { appliedJobs: appliedJobs };
        __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].dispatch({ type: 'UPDATE_APPLY', payload: updatedApply });
      };
    } catch (e) {
      if (typeof JobsSentry !== 'undefined') {
        JobsSentry.captureMessage("Exception occurred while removing applies from idb.\nMessage : " + e.message + ".\nStack : " + e.stack);
      }
    }
  };

  return Apply;
}(), _class.toggleCallUnlockCandidateBuyBannerVisibility = function (value) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* JobStore */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_ApplyActions__["f" /* toggleCallUnlockCandidateBuyOptions */])(value));
}, _class.isApplyWithoutEmailEnabled = function (role, city) {
  var isEnabled = false;
  var formattedRole = Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["A" /* sanitizeRole */])(role).toLowerCase();
  var formattedCity = Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["A" /* sanitizeRole */])(city).toLowerCase();
  formattedCity = formattedCity.replace('x:', '');
  var config = Apply.getApplyStore('emailNonMandatoryConfig');
  if (config) {
    var isRoleEnabled = config.areAllRolesEnabled || config.enabledRoles && config.enabledRoles.indexOf(formattedRole) > -1;

    var isCityEnabled = config.areAllCitiesEnabled || config.enabledCities && config.enabledCities.indexOf(formattedCity) > -1;

    isEnabled = isRoleEnabled && isCityEnabled;
  }

  return isEnabled;
}, _class.toggleSkipApplyInitiatedFlag = function (value) {
  __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_ApplyActions__["h" /* toggleSkipApplyInitiatedFlag */])(value));
}, _class.toggleQuickApplyInitiatedFlag = function (value) {
  __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_ApplyActions__["g" /* toggleQuickApplyInitiatedFlag */])(value));
}, _class.setUtmParameters = function (value) {
  __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_ApplyActions__["e" /* setUtmParameters */])(value));
}, _temp);


/***/ }),

/***/ "RTKd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.clearIDB = clearIDB, exports.readFromIDB = readFromIDB, exports.writeToIDB = writeToIDB;function clearIDB(a) {
  return new Promise(function (b, c) {
    if (a) try {
      var d = a.transaction(["webpush"], "readwrite").objectStore("webpush"),
          e = d.clear();e.onsuccess = function () {
        b();
      }, e.onerror = function () {
        c(new Error("Could not transact with IDB"));
      };
    } catch (a) {
      c(new Error("Could not transact with IDB"));
    } else c(new Error("IDB instance unavailable. Please initialize."));
  });
}function readFromIDB(a, b) {
  return new Promise(function (c, d) {
    if (a) try {
      var e = a.transaction(["webpush"], "readwrite").objectStore("webpush"),
          f = e.get(b);f.onsuccess = function (a) {
        c(a.currentTarget.result);
      }, f.onerror = function () {
        d(new Error("Could not transact with IDB"));
      };
    } catch (a) {
      d(new Error("Could not transact with IDB"));
    } else d(new Error("IDB instance unavailable. Please initialize."));
  });
}function writeToIDB(a, b, c) {
  return new Promise(function (d, e) {
    if (a) try {
      var f = a.transaction(["webpush"], "readwrite").objectStore("webpush"),
          g = f.put(_extends({ id: b }, c));g.onsuccess = function () {
        d();
      }, g.onerror = function () {
        e(new Error("Could not transact with IDB"));
      };
    } catch (a) {
      e(new Error("Could not transact with IDB"));
    } else e(new Error("IDB instance unavailable. Please initialize."));
  });
}

/***/ }),

/***/ "SN0Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T6SA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sortFilterItemClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return openSortFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeSortFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return openFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return filterMountedAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return resetFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return prepareFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyFilter; });
/* unused harmony export filterJobs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setClickedFilterItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return toggleDisplayofInternalLinksTupple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return toggleNorthEasthCityFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateNorthEastCityFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateFilterState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");
/**
    Actions are payloads of information that send data from your application to your store.
    They are the only source of information for the store.

    Action creators are exactly that—functions that create actions.
*/

/**
 * Redux action creators defined for snb container component
 *
 * @author John Lukose <john.lukose@quikr.com>
 */



var sortFilterItemClicked = function sortFilterItemClicked() {
	var selectedFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.SORT_FILTER_ITEM_CLICKED,
		payload: { selectedFilter: selectedFilter }
	};
};

var openSortFilter = function openSortFilter() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.SORT_FILTER_CLICKED,
		payload: {}
	};
};

var closeSortFilter = function closeSortFilter() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.SORT_FILTER_CLOSED,
		payload: {}
	};
};

var openFilter = function openFilter() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_OPEN,
		payload: {}
	};
};

var filterMountedAction = function filterMountedAction(response) {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_MOUNTED,
		payload: { response: response }
	};
};

var closeFilter = function closeFilter() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_CLOSE,
		payload: {}
	};
};

var resetFilter = function resetFilter() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_RESET,
		payload: {}
	};
};

var prepareFilter = function prepareFilter() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_PREPARE,
		payload: {}
	};
};

var applyFilter = function applyFilter() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_APPLY,
		payload: {}
	};
};

var filterJobs = function filterJobs() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_JOBS,
		payload: {}
	};
};

var setClickedFilterItem = function setClickedFilterItem(key, multiValued, value) {
	var innerKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	var isInnerMultiValued = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	var innerValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_ITEM_CLICKED,
		payload: { key: key, multiValued: multiValued, value: value, innerKey: innerKey, isInnerMultiValued: isInnerMultiValued, innerValue: innerValue }
	};
};

var toggleDisplayofInternalLinksTupple = function toggleDisplayofInternalLinksTupple(showHide) {
	var data = {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.RECEVED_SIMILAR_JOBS_AJAXDATA,
		payload: { showHide: showHide }
	};
	return data;
};

var toggleNorthEasthCityFilter = function toggleNorthEasthCityFilter(payload) {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.NORTHEAST_MY_CITY,
		payload: payload
	};
};

var updateNorthEastCityFilter = function updateNorthEastCityFilter(payload) {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.SHOW_NORTHEAST_CITY_FILTER,
		payload: payload
	};
};

var updateFilterState = function updateFilterState(payload) {
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.UPDATE_FILTER_STATE,
		payload: payload
	};
};

/***/ }),

/***/ "TWrg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),

/***/ "TZCA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnlimitedFreeAds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Config__ = __webpack_require__("1QGg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jobsPostAdRequest__ = __webpack_require__("YShu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("upA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_apiEndpoints__ = __webpack_require__("v9L/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FetchHelper__ = __webpack_require__("Hm4v");
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Utility to handle unlimited free ads
 *
 * @author John Lukose <john.lukose@quikr.com>
 */








var UnlimitedFreeAds = (_temp = _class = function UnlimitedFreeAds() {
	_classCallCheck(this, UnlimitedFreeAds);
}, _class.details = {
	price: 99,
	duration: 20,
	unlockCount: 200,
	maxFreeAdLimit: 100,
	paymentFailureMessage: 'Something went wrong!! Please try again',
	paymentSuccessMessage: 'Successfully purchased Unlimited Free Ads Pack'
}, _class.getPrice = function () {
	return UnlimitedFreeAds.details.price;
}, _class.setPrice = function (price) {
	UnlimitedFreeAds.details.price = price;
}, _class.getDuration = function () {
	return UnlimitedFreeAds.details.duration;
}, _class.setDuration = function (duration) {
	UnlimitedFreeAds.details.duration = duration;
}, _class.getUnlockCount = function () {
	return UnlimitedFreeAds.details.unlockCount;
}, _class.setUnlockCount = function (unlockCount) {
	UnlimitedFreeAds.details.unlockCount = unlockCount;
}, _class.getMaxFreeAdLimit = function () {
	return UnlimitedFreeAds.details.maxFreeAdLimit;
}, _class.setMaxFreeAdLimit = function (maxFreeAdLimit) {
	UnlimitedFreeAds.details.maxFreeAdLimit = maxFreeAdLimit;
}, _class.updateDetails = function (store) {
	var jobsUnlimitedFreeAdsStaticDetails = __WEBPACK_IMPORTED_MODULE_0__Config__["a" /* default */].get('jobsUnlimitedFreeAdsStaticDetails', store);
	UnlimitedFreeAds.setPrice(jobsUnlimitedFreeAdsStaticDetails.price);
	UnlimitedFreeAds.setDuration(jobsUnlimitedFreeAdsStaticDetails.duration);
	UnlimitedFreeAds.setUnlockCount(jobsUnlimitedFreeAdsStaticDetails.maxApplicationLimit);
	UnlimitedFreeAds.setMaxFreeAdLimit(jobsUnlimitedFreeAdsStaticDetails.maxFreeAdLimit);
}, _class.isEnabled = function (city, store) {
	var jobsUnlimitedFreeAdsEnabledCities = __WEBPACK_IMPORTED_MODULE_0__Config__["a" /* default */].get('jobsUnlimitedFreeAdsEnabledCities', store);
	return -1 !== jobsUnlimitedFreeAdsEnabledCities.indexOf('All') || -1 !== jobsUnlimitedFreeAdsEnabledCities.indexOf(city.toLowerCase());
}, _class.redirectToPayment = function (packId) {
	__WEBPACK_IMPORTED_MODULE_1__jobsPostAdRequest__["a" /* default */].showLoader();
	__WEBPACK_IMPORTED_MODULE_1__jobsPostAdRequest__["a" /* default */].savePostAdRequest(__WEBPACK_IMPORTED_MODULE_1__jobsPostAdRequest__["a" /* default */].getPostAdRequest());
	__WEBPACK_IMPORTED_MODULE_4_window_or_global___default.a.location = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["o" /* getProtocol */])() + __WEBPACK_IMPORTED_MODULE_3__constants_apiEndpoints__["b" /* API_BASE_URL */] + __WEBPACK_IMPORTED_MODULE_3__constants_apiEndpoints__["g" /* UNLIMITED_FREE_ADS_PAYMENT_API */] + ('?packId=' + packId);
}, _class.getPaymentSuccessMessage = function () {
	return UnlimitedFreeAds.details.paymentSuccessMessage;
}, _class.getPaymentFailureMessage = function () {
	return UnlimitedFreeAds.details.paymentFailureMessage;
}, _class.handlePaymentResponse = function () {
	if (!__WEBPACK_IMPORTED_MODULE_4_window_or_global___default.a.location) {
		return;
	}
	var params = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["m" /* getParams */])(__WEBPACK_IMPORTED_MODULE_4_window_or_global___default.a.location.search);
	var message = '';
	if (params.hasOwnProperty('txnId')) {
		message = UnlimitedFreeAds.getPaymentSuccessMessage();
	} else if (params.hasOwnProperty('failed')) {
		message = UnlimitedFreeAds.getPaymentFailureMessage();
	}

	__WEBPACK_IMPORTED_MODULE_1__jobsPostAdRequest__["a" /* default */].showSnackbar(message);
}, _temp);


/***/ }),

/***/ "TsWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" });

var GPS = function GPS(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ viewBox: "0 0 24 24", "class": props.class },
		_ref
	);
};
/* harmony default export */ __webpack_exports__["a"] = (GPS);

/***/ }),

/***/ "UFu6":
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__("OCA3");

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)',
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue;
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = prefix || defaultDelimiter;
    var pattern = capture || group;
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : restrictBacktrack(delimiter, prevText)
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens;
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?';
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?';
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile(str, options) {
  return tokensToFunction(parse(str, options), options);
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue;
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
        }

        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }

      path += token.prefix + segment;
    }

    return path;
  };
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, '\\$1');
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags(options) {
  return options && options.sensitive ? '' : 'i';
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp(path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys);
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys);
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys);
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */keys);
  }

  if (isarray(path)) {
    return arrayToRegexp( /** @type {!Array} */path, /** @type {!Array} */keys, options);
  }

  return stringToRegexp( /** @type {string} */path, /** @type {!Array} */keys, options);
}

/***/ }),

/***/ "UNCw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PACKS; });
/* unused harmony export PACKS_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PackHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("R8p8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__others_freeLocality__ = __webpack_require__("5P8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jobsPostAdRequest__ = __webpack_require__("YShu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_PostAdActions__ = __webpack_require__("GNhE");
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Utility class for pack handler
 *
 * @author John Lukose <john.lukose@quikr.com>
 */






var PACKS = {
  FREE: 'freeAd',
  GOLD: 'goldAd',
  GOLD_URGENT: 'goldUrgentAd',
  PPA: 'ppaAd',
  SPOTLIGHT: 'spotlightAd',
  WFH: 'wfhAd',
  GOLD_SUB_3: 'goldSub3',
  GOLD_SUB_5: 'goldSub5',
  GOLD_SUB_10: 'goldSub10'
};

var PACKS_TYPE = {
  FREE: '',
  GOLD: 'T',
  GOLD_URGENT: 'HT',
  PPA: 'BT',
  GOLD_SUB_3: 'F',
  GOLD_SUB_5: 'S',
  GOLD_SUB_10: 'TR'
};

var packDetails = [{
  pack: PACKS.FREE,
  show: 1,
  supportsCredits: 1,
  displayName: 'FREE AD',
  subTitle: 'Normal x applications',
  price: 0,
  credits: 0,
  validity: '5 days',
  rightText: '',
  benefits: ['Limited applications'],
  isAd: 1,
  adType: PACKS_TYPE.FREE
}, {
  pack: PACKS.GOLD,
  show: 1,
  supportsCredits: 1,
  displayName: 'GOLD AD',
  subTitle: '10 x applications',
  subTitle2: 'Most Popular',
  price: null,
  credits: 1,
  validity: '10 days',
  rightText: '',
  benefits: ['Validity 10 days', 'View all applications', 'Top of page promotion website app & emails', 'Highlighted as \'Gold\''],
  subPacks: [],
  isAd: 1,
  adType: PACKS_TYPE.GOLD
}, {
  pack: PACKS.GOLD_URGENT,
  show: 1,
  supportsCredits: 0,
  displayName: 'Gold + Urgent',
  subTitle: '20 x applications',
  price: null,
  creditPrice: 0,
  validity: '5 days',
  rightText: '',
  benefits: ['View all applications', 'Top of page promotion website app & emails', 'Highlighted as \'Gold + Urgent\''],
  isAd: 1,
  adType: PACKS_TYPE.GOLD_URGENT
}, {
  pack: PACKS.PPA,
  show: 0,
  supportsCredits: 0,
  displayName: 'Pay Per 50 Applicant',
  subTitle: '50 applicants or refund',
  price: null,
  creditPrice: 0,
  validity: '45 Days',
  rightText: 'Guarantee',
  benefits: ['Validity 10 days', 'View all applications', 'Top of page promotion website app & emails', 'Highlighted as \'Gold\''],
  isAd: 1,
  adType: PACKS_TYPE.PPA
}];

var PackHandler = (_temp = _class = function PackHandler() {
  _classCallCheck(this, PackHandler);
}, _class.getPackDetails = function (_) {
  PackHandler.setPackDetails();
  return packDetails;
}, _class.getPackDetailsByType = function (type) {
  var result = null;

  packDetails.forEach(function (pack) {
    if (pack.pack === type) {
      result = pack;
    }
  });

  return result;
}, _class.getGoldAdSubPackDetails = function (type) {
  var result = null;

  packDetails.forEach(function (pack) {
    if (pack.pack === PACKS.GOLD && pack.subPacks && pack.subPacks.length > 0) {
      pack.subPacks.forEach(function (subpack) {
        if (type === subpack.pack) result = subpack;
      });
    }
  });

  return result;
}, _class.setPackDetails = function (_) {
  var storeValues = __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].getState().jobs;
  var papPrices = storeValues.config.papPrices;
  var hasCredits = storeValues.user.hasCredits;


  if (!papPrices) return;

  packDetails.forEach(function (pack) {
    switch (pack.pack) {
      case PACKS.FREE:
        break;
      case PACKS.GOLD:
        {
          pack.price = papPrices.top;
          pack.validity = papPrices.topValidity;
          pack.benefits[0] = 'Validity ' + pack.validity;
          if (papPrices.AdPackPurchaseData.length > 0) {
            pack.subPacks[0] = {
              pack: PACKS.GOLD_SUB_3,
              discount: papPrices.AdPackPurchaseData[0].percentage,
              credits: papPrices.AdPackPurchaseData[0].credits,
              price: papPrices.AdPackPurchaseData[0].price,
              duration: papPrices.AdPackPurchaseData[0].duration,
              durationType: papPrices.AdPackPurchaseData[0].durationType,
              adType: PACKS_TYPE.GOLD_SUB_3
            };
            pack.subPacks[1] = {
              pack: PACKS.GOLD_SUB_5,
              discount: papPrices.AdPackPurchaseData[1].percentage,
              credits: papPrices.AdPackPurchaseData[1].credits,
              price: papPrices.AdPackPurchaseData[1].price,
              duration: papPrices.AdPackPurchaseData[1].duration,
              durationType: papPrices.AdPackPurchaseData[1].durationType,
              adType: PACKS_TYPE.GOLD_SUB_5
            };
            pack.subPacks[2] = {
              pack: PACKS.GOLD_SUB_10,
              discount: papPrices.AdPackPurchaseData[2].percentage,
              credits: papPrices.AdPackPurchaseData[2].credits,
              price: papPrices.AdPackPurchaseData[2].price,
              duration: papPrices.AdPackPurchaseData[2].duration,
              durationType: papPrices.AdPackPurchaseData[2].durationType,
              adType: PACKS_TYPE.GOLD_SUB_10
            };
          }

          break;
        }
      case PACKS.GOLD_URGENT:
        {
          pack.price = papPrices.tophigh;
          pack.validity = papPrices.tophighValidity;
          pack.benefits[0] = 'Validity ' + pack.validity;
          pack.show = hasCredits ? 0 : 1;
          break;
        }
      case PACKS.PPA:
        {
          if (papPrices.ppa) {
            pack.price = papPrices.ppa.minUnits * papPrices.ppa.pricePerUnit;
            pack.validity = papPrices.ppaValidity;
          }
          pack.benefits[0] = 'Validity ' + pack.validity;
          pack.show = papPrices.isPayPerApplicantEnabled && !hasCredits ? 1 : 0;
          break;
        }
    }
  });
}, _class.updateSelectedPack = function (selectedPack, selectedSubPack, type) {
  var storeValues = __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].getState().jobs;
  var storePack = storeValues.postAdRequest.others.selectedPack;
  var storeSubPack = storeValues.postAdRequest.others.selectedSubPack;

  // unselecting sub pack
  if (storeSubPack === selectedSubPack) {
    selectedSubPack = null;
  }

  // unselecting pack
  if (storePack === selectedPack && 'packClick' === type) {
    selectedPack = null;
    selectedSubPack = null;
  }

  var pack = {
    selectedPack: selectedPack,
    selectedSubPack: selectedSubPack
  };

  __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_PostAdActions__["c" /* reduxActionUpdateSelectedPack */])(pack));
  __WEBPACK_IMPORTED_MODULE_2__jobsPostAdRequest__["a" /* default */].reduxUpdateCompanyDetails();
}, _class.getSelectedPackPrice = function (type) {
  var storeValues = __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].getState().jobs;
  var storePack = storeValues.postAdRequest.others.selectedPack;
  var storeSubPack = storeValues.postAdRequest.others.selectedSubPack;
  var price = 0;

  packDetails.forEach(function (pack) {
    if (pack.pack === storePack && (type === storePack || type === storeSubPack)) {
      price = pack.price;
      if (storeSubPack && pack.subPacks.length > 0) {
        pack.subPacks.forEach(function (subPack) {
          if (subPack.pack === storeSubPack) {
            price = subPack.price;
          }
        });
      }
    }
  });

  return price;
}, _temp);


/***/ }),

/***/ "UXCT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");
var normalizeHeaderName = __webpack_require__("rCO2");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("aLwj");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("aLwj");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/***/ }),

/***/ "Ux8J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VisV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_menu__ = __webpack_require__("IHAU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_list_item___ = __webpack_require__("ir2Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_menu_mdc_menu_scss__ = __webpack_require__("aQ7X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_menu_mdc_menu_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_menu_mdc_menu_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_scss__ = __webpack_require__("OPyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var defaultProps = {
	open: false
};

var Menu = function (_Component) {
	_inherits(Menu, _Component);

	function Menu(props) {
		_classCallCheck(this, Menu);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._mdcProps = ["open", "open-from-top-left", "open-from-top-right", "open-from-bottom-left", "open-from-bottom-right"];
		_this._select = _this._select.bind(_this);
		_this._cancel = _this._cancel.bind(_this);
		return _this;
	}

	Menu.prototype.componentDidMount = function componentDidMount() {
		this.MDComponent = new __WEBPACK_IMPORTED_MODULE_2__material_menu__["a" /* MDCSimpleMenu */](this.control);
		this.MDComponent.listen("MDCSimpleMenu:selected", this._select);
		this.MDComponent.listen("MDCSimpleMenu:cancel", this._cancel);
		toggleMenu(defaultProps, this.props, this.MDComponent);
	};

	Menu.prototype.componentWillUnmount = function componentWillUnmount() {
		this.MDComponent.unlisten("MDCSimpleMenu:selected", this._select);
		this.MDComponent.unlisten("MDCSimpleMenu:cancel", this._cancel);
		this.MDComponent.destroy && this.MDComponent.destroy();
	};

	Menu.prototype._select = function _select() {
		if (this.props.onSelect) {
			this.props.onSelect();
		}
		this._menuClosed();
	};

	Menu.prototype._cancel = function _cancel() {
		if (this.props.onCancel) {
			this.props.onCancel();
		}
		this._menuClosed();
	};

	Menu.prototype._menuClosed = function _menuClosed() {
		if (this.props.onMenuClosed) {
			this.props.onMenuClosed();
		}
	};

	Menu.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
		toggleMenu(this.props, nextProps, this.MDComponent);
	};

	Menu.prototype.render = function render(_ref) {
		var _this2 = this;

		var className = _ref['class'],
		    props = _objectWithoutProperties(_ref, ['class']);

		var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-simple-menu', className);
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			_extends({ 'class': classes, tabindex: '-1' }, props, { ref: function ref(control) {
					return _this2.control = control;
				} }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'ul',
				{
					'class': 'mdc-simple-menu__items mdc-list',
					role: 'menu',
					'aria-hidden': 'true'
				},
				props.children
			)
		);
	};

	return Menu;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var MenuAnchor = function (_Component2) {
	_inherits(MenuAnchor, _Component2);

	function MenuAnchor(props) {
		_classCallCheck(this, MenuAnchor);

		return _possibleConstructorReturn(this, _Component2.call(this, props));
	}

	MenuAnchor.prototype.render = function render(_ref2) {
		var className = _ref2['class'],
		    children = _ref2.children,
		    props = _objectWithoutProperties(_ref2, ['class', 'children']);

		var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-menu-anchor', className);
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': classes },
			children
		);
	};

	return MenuAnchor;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

function toggleMenu(oldprops, newprops, menu) {
	if ("open" in oldprops && "open" in newprops && oldprops.open !== newprops.open) {
		menu.open = newprops.open;
	}
}

Menu.Anchor = MenuAnchor;
Menu.Item = __WEBPACK_IMPORTED_MODULE_3__material_list_item___["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),

/***/ "VsV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Filter__ = __webpack_require__("WXY+");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Declaring the redux reducers and default state
 * for snb candidate filters
 *
 * @author John Lukose <john.lukose@quikr.com>
 */




var defaultFilters = {
	url: '',
	popupOpened: 0,
	loaded: 0,
	selectedFilters: [],
	isMyNorthEastCityFilter: false,
	showNorthEastCityFilter: false,
	filters: {
		role: {
			name: 'role',
			type: 'search',
			displayName: 'Roles',
			displayInFilter: 0,
			multiValued: 0,
			selected: [],
			options: [],
			subOptionsKey: 'subrole',
			subrole: {
				name: 'subrole',
				type: 'search',
				displayName: 'Sub Roles',
				displayInFilter: 0,
				multiValued: 1,
				selected: []
			}
		},
		city: {
			name: 'city',
			type: 'search',
			displayName: 'City',
			displayInFilter: 0,
			multiValued: 0,
			selected: [],
			options: []
		},
		locality: {
			name: 'locality',
			type: 'search',
			displayName: 'Locality',
			displayInFilter: 0,
			multiValued: 1,
			selected: [],
			options: []
		},
		salary: {
			name: 'salary',
			type: 'checkbox',
			displayName: 'Salary',
			displayInFilter: 1,
			multiValued: 0,
			selected: [],
			options: [{ value: 5000, displayValue: '₹ 5,000 and above' }, { value: 6000, displayValue: '₹ 6,000 and above' }, { value: 7000, displayValue: '₹ 7,000 and above' }, { value: 8000, displayValue: '₹ 8,000 and above' }, { value: 9000, displayValue: '₹ 9,000 and above' }, { value: 10000, displayValue: '₹ 10,000 and above' }, { value: 15000, displayValue: '₹ 15,000 and above' }, { value: 20000, displayValue: '₹ 20,000 and above' }, { value: 25000, displayValue: '₹ 25,000 and above' }, { value: 30000, displayValue: '₹ 30,000 and above' }, { value: 35000, displayValue: '₹ 35,000 and above' }, { value: 40000, displayValue: '₹ 40,000 and above' }, { value: 45000, displayValue: '₹ 45,000 and above' }, { value: 50000, displayValue: '₹ 50,000 and above' }, { value: 60000, displayValue: '₹ 60,000 and above' }, { value: 70000, displayValue: '₹ 70,000 and above' }, { value: 80000, displayValue: '₹ 80,000 and above' }, { value: 90000, displayValue: '₹ 90,000 and above' }, { value: 100000, displayValue: '₹ 1 Lakh and above' }, { value: '', displayValue: '' }]
		},
		type: {
			name: 'type',
			type: 'checkbox',
			displayName: 'Job Type',
			multiValued: 1,
			displayInFilter: 1,
			selected: [],
			options: [{
				value: 'work-from-home',
				displayValue: 'Work From Home',
				display: 1
			}, {
				value: 'part-time',
				displayValue: 'Part Time Jobs',
				display: 1
			}, {
				value: 'full-time',
				displayValue: 'Full Time Jobs',
				display: 1
			}, {
				value: 'internship',
				displayValue: 'Internships',
				display: 1
			}, {
				value: 'abroad',
				displayValue: 'Work Abroad',
				display: 1
			}]
		},
		sort: {
			name: 'sort',
			displayName: 'Sort',
			displayInFilter: 0,
			multiValued: 0,
			sortPopupOpened: 0,
			selected: ['relevancy'],
			options: [{
				value: 'relevancy',
				displayValue: 'Popular'
			}, {
				value: 'dt:DESC',
				displayValue: 'Recent'
			}, {
				value: 'dt:ASC',
				displayValue: 'Oldest'
			}]
		},
		company: {
			name: 'company',
			displayName: 'Company',
			type: 'search',
			displayInFilter: 0,
			multiValued: 0,
			selected: [],
			options: []
		},
		keyword: {
			name: 'keyword',
			displayName: 'keyword',
			type: 'search',
			displayInFilter: 0,
			multiValued: 0,
			selected: [],
			options: []
		}
	}
};

var defaultFiltersObj = JSON.parse(JSON.stringify(defaultFilters));
var defaultFilterLoadState = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Filter__["f" /* setFiltersFromUrl */])(defaultFiltersObj);

var FilterReducer = function FilterReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultFilterLoadState;
	var actions = arguments[1];

	switch (actions.type) {
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.SORT_FILTER_CLICKED:
			{
				state = _extends({}, state);
				state.filters.sort.sortPopupOpened = 1;
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.SORT_FILTER_CLOSED:
			{
				state = _extends({}, state);
				state.filters.sort.sortPopupOpened = 0;
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.SORT_FILTER_ITEM_CLICKED:
			{
				state = _extends({}, state);
				state.filters.sort.selected = [actions.payload.selectedFilter];
				state.filters.sort.sortPopupOpened = 0;
				state.url = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Filter__["d" /* getUrlFromFilters */])(state);
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_OPEN:
			{
				state = _extends({}, state);
				state.popupOpened = 1;
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_MOUNTED:
			{
				state = _extends({}, state);
				state = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Filter__["e" /* setFilterData */])(state, actions.payload.response);
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_CLOSE:
			{
				state = _extends({}, state);
				state.popupOpened = 0;
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_PREPARE:
			{
				state = _extends({}, state);
				state.url = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Filter__["d" /* getUrlFromFilters */])(state);
				if (typeof dataLayer != 'undefined') {
					dataLayer.push({ "event": "filters_select",
						"platform": "pwa" });
				}
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_APPLY:
			{
				state = _extends({}, state);
				Object(__WEBPACK_IMPORTED_MODULE_1__utils_Filter__["a" /* fireEventForFilter */])(state);
				state.popupOpened = 0;
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_RESET:
			{
				Object.keys(state.filters).forEach(function (key) {
					if ('sort' !== key && 'city' !== key) state.filters[key].selected = [];

					if (state.filters[key].subOptionsKey) {
						state.filters[key][state.filters[key].subOptionsKey].selected = [];
					}
				});
				state = _extends({}, state);
				state.url = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Filter__["d" /* getUrlFromFilters */])(state);
				state.popupOpened = 0;
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.FILTER_ITEM_CLICKED:
			{
				if (actions.payload.innerKey) {
					var index = state.filters[actions.payload.key][actions.payload.innerKey].selected.indexOf(actions.payload.innerValue);
					if (index === -1) {
						if (actions.payload.isInnerMultiValued) state.filters[actions.payload.key][actions.payload.innerKey].selected.push(actions.payload.innerValue);else state.filters[actions.payload.key][actions.payload.innerKey].selected = [actions.payload.innerValue];
					} else {
						state.filters[actions.payload.key][actions.payload.innerKey].selected.splice(index, 1);
					}
					state = _extends({}, state);
					break;
				} else {
					var _index = state.filters[actions.payload.key].selected.indexOf(actions.payload.value);
					if (_index === -1) {
						if (actions.payload.multiValued) state.filters[actions.payload.key].selected.push(actions.payload.value);else {
							state.filters[actions.payload.key].selected = [actions.payload.value];
							var innerKey = state.filters[actions.payload.key].subOptionsKey;
							if (state.filters[actions.payload.key][innerKey]) {
								state.filters[actions.payload.key][innerKey].selected = [];
							}
						}
					} else {
						if (state.filters[actions.payload.key].subOptionsKey) {
							var _innerKey = state.filters[actions.payload.key].subOptionsKey;
							if (state.filters[actions.payload.key][_innerKey]) {
								state.filters[actions.payload.key][_innerKey].selected = [];
							}
						}
						state.filters[actions.payload.key].selected.splice(_index, 1);
					}

					state = _extends({}, state);
					break;
				}
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.UPDATE_FILTER_STATE:
			{
				state = _extends(state, actions.payload);
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.NORTHEAST_MY_CITY:
			{
				state.isMyNorthEastCityFilter = actions.payload.isMyNorthEastCityFilter;
				state.selectedFilters["isMyNorthEastCityFilter"] = state.isMyNorthEastCityFilter;
				state = _extends({}, state);
				break;
			}
		case __WEBPACK_IMPORTED_MODULE_0__constants_events__["l" /* default */].SNB_CONTAINER_EVENTS.SHOW_NORTHEAST_CITY_FILTER:
			{
				state.showNorthEastCityFilter = actions.payload.showNorthEastCityFilter;

				state = _extends({}, state);
				break;
			}
		default:
			break;
	}
	state = transformSelectedFilterValues(state);
	return state;
};

function transformSelectedFilterValues(state) {
	if (state && state.filters && state.filters.locality && state.filters.locality.selected) {
		state.filters.locality.selected = state.filters.locality.selected.map(function (each) {
			return Number.isInteger(each) ? each : each.toLowerCase().split(' ').join("-");
		});
	}

	if (state && state.filters && state.filters.type && state.filters.type.selected) {
		state.filters.type.selected = state.filters.type.selected.map(function (each) {
			return Number.isInteger(each) ? each : each.toLowerCase().split(' ').join("-");
		});
	}

	if (state && state.filters && state.filters.role && state.filters.role.subrole && state.filters.role.subrole.selected) {
		state.filters.role.subrole.selected = state.filters.role.subrole.selected.map(function (each) {
			return Number.isInteger(each) ? each : each.toLowerCase().split(' ').join("-");
		});
	}

	return state;
}

/* harmony default export */ __webpack_exports__["a"] = (FilterReducer);

/***/ }),

/***/ "WDOI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEventTrackGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pushAnalyticsEvent; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getEventTrackGA = function getEventTrackGA(obj) {

	if (typeof obj !== 'undefined' && typeof ga !== 'undefined') {

		// let category = obj.category;
		// let action = obj.action;
		// let label = obj.label;
		var _obj$category = obj.category,
		    category = _obj$category === undefined ? 'quikr_pwa' : _obj$category,
		    action = obj.action,
		    label = obj.label,
		    rest = _objectWithoutProperties(obj, ['category', 'action', 'label']);

		var windowNewOpen = obj.windowNewOpen;
		var windowOpen = obj.windowOpen;

		if (category !== '' && action !== '' && label !== '') {

			if (typeof ga !== 'undefined' && ga) {
				ga('quikrPWATracker.send', 'event', _extends({ eventCategory: category, eventAction: action, eventLabel: label }, rest));
			} else {
				console.log('Google Analytics not loaded');
			}

			if (typeof gen_comscore_tag === 'function') {
				gen_comscore_tag('www.quikr.com/' + category + action);
			}
		}

		if (windowNewOpen) {
			window.open(windowNewOpen, '_blank');
		}

		if (windowOpen) {
			window.location = windowOpen;
			return false;
		}
	}
};


var pushAnalyticsEvent = function pushAnalyticsEvent(eventName, data) {
	var isMsite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	var MAX_TRY = 10; // try 10 times
	var source = isMsite ? 'Msite' : 'Desktop';

	var pushEvent = function pushEvent(eventName, _data, source) {
		var tryCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MAX_TRY;

		try {
			if (typeof _paqv3 !== 'undefined' && _paqv3) {
				_paqv3.push(["_sendEventApiData", eventName, source, JSON.stringify(_data)]);
			} else if (tryCount) {
				setTimeout(function () {
					return pushEvent(eventName, _data, source, tryCount - 1);
				}, 1000);
			}
		} catch (err) {
			console.log(err);
		}
	};

	pushEvent(eventName, data, source, MAX_TRY);
};

/***/ }),

/***/ "WJAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../preact/dist/preact.js
var preact = __webpack_require__("xIV9");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// CONCATENATED MODULE: ../q-components/components/icons/headerIcons/account/index.js



var _ref = Object(preact["h"])("path", { d: "M35.6,2C45.8,2,54,10,54,20.2v0.2c0,10.2-8,18.2-18.1,18.4c-10.1,0-18.4-8-18.4-18.2C17.3,10.3,25.5,2,35.6,2 M67.7,69.3c0,0.5-0.2,0.7-0.7,0.7H5c-0.5,0-0.7-0.2-0.7-0.7c0-13.2,14.6-24.1,31.6-24.1C53.1,45,67.4,56.1,67.7,69.3" });

var account_account = function account(props) {
	return Object(preact["h"])(
		"svg",
		{ viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};
/* harmony default export */ var headerIcons_account = (account_account);
// EXTERNAL MODULE: ../q-components/components/icons/headerIcons/back/index.js
var back = __webpack_require__("yXTJ");

// CONCATENATED MODULE: ../q-components/components/icons/headerIcons/menu/index.js



var menu__ref = Object(preact["h"])("path", { xmlns: "http://www.w3.org/2000/svg", d: "M70,10.8v9.1H2v-9.1H70z M2,33.5v9.1h68v-9.1H2z M2,56.1v9.1h68v-9.1H2z" });

var menu_menu = function menu(props) {
	return Object(preact["h"])(
		"svg",
		{ viewBox: "0 0 72 72", "class": props.class },
		menu__ref
	);
};
/* harmony default export */ var headerIcons_menu = (menu_menu);
// CONCATENATED MODULE: ../q-components/components/icons/headerIcons/quikr/index.js



var quikr__ref = Object(preact["h"])("path", { d: "M60.8,18.3c0.7,8.4-2.6,22.5-8.9,28.6c-1.4,1.4-3,2.5-4.7,3.4L44,44.8c-1.2-2.1-2.5-3.4-3.8-4.3c2-1.3,3.5-3.2,4.6-5.8c1.3-3.1,3.1-10.2,2.7-13.6c-0.5-3.7-3-6.7-8.8-7c-2.6-0.2-5.2,0-7.7,0.7c-2.2,0.6-4.1,1.6-5.4,2.9c-3.2,3-5.2,10.5-5.5,14.8c-0.2,3,0.2,5.3,1.3,6.8c1.9,2.8,4.9,3.1,7.9,3l2.3,0c3.6,0,6.6,0.4,9.7,5.6l3.9,6.8c2.2,3.6,2.6,4.7,7.9,4.7H65L62.6,71H49c-3.8,0-8.9-0.6-12-5.8l-4.6-7.9c-1.8-2.9-1.7-3.4-5-3.6c-3.6-0.2-7.6-0.6-9.8-1.5c-5.5-2.1-9.9-6.3-10.6-13.7c-0.2-1.9-0.1-3.9,0.1-6C7.4,30.2,8,27.3,8.6,25c1.5-6.2,3.7-11.3,7.6-15c5-4.8,12-6.7,18.6-6.9c2.6-0.1,7.1,0,10.9,0.5C53.9,4.7,60.1,9.5,60.8,18.3" });

var quikr_quikr = function quikr(props) {
	return Object(preact["h"])(
		"svg",
		{ viewBox: "0 0 72 72", "class": props.class },
		quikr__ref
	);
};
/* harmony default export */ var headerIcons_quikr = (quikr_quikr);
// EXTERNAL MODULE: ../q-components/components/icons/headerIcons/gps/index.js
var gps = __webpack_require__("uFKd");

// CONCATENATED MODULE: ../q-components/components/icons/headerIcons/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return headerIcons_account; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return back["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return headerIcons_menu; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return headerIcons_quikr; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return gps["a" /* default */]; });








/***/ }),

/***/ "WXY+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = setFiltersFromUrl;
/* unused harmony export handleAMPActions */
/* harmony export (immutable) */ __webpack_exports__["b"] = getFilterData;
/* harmony export (immutable) */ __webpack_exports__["c"] = getRoleFromUrlValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = setFilterData;
/* harmony export (immutable) */ __webpack_exports__["d"] = getUrlFromFilters;
/* harmony export (immutable) */ __webpack_exports__["a"] = fireEventForFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FetchHelper__ = __webpack_require__("Hm4v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search_UrlBuilder__ = __webpack_require__("4Pem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("upA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GaHelper__ = __webpack_require__("8wV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BigBrotherAnalytics_constants__ = __webpack_require__("EcKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BigBrotherAnalytics__ = __webpack_require__("e86g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_window_or_global__);
/**
 * @author John Lukose <john.lukose@quikr.com>
 *
 * Utility functions for filter
 */








var urlBuilder = new __WEBPACK_IMPORTED_MODULE_1__Search_UrlBuilder__["a" /* default */]();
var fetchHelper = new __WEBPACK_IMPORTED_MODULE_0__FetchHelper__["a" /* default */]();

/**
 * @function Set the default filter values from the url
 */
function setFiltersFromUrl(defaultFilters) {
	var currentUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	var snbUrlWithParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';


	var urlparams = __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location && urlBuilder.parseSnbUrl(__WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location.pathname);

	// the logic below assumes all the parameter recevied are in there correct format
	// and its in lower
	if (!urlparams && currentUrl) {
		urlparams = urlBuilder.parseSnbUrl(currentUrl);
	}

	Object.keys(defaultFilters.filters).forEach(function (key) {
		if (urlparams && urlparams[key]) {
			switch (key) {
				case 'role':
					{
						defaultFilters.filters[key].selected = urlparams.role;
						defaultFilters.filters[key].subrole.selected = urlparams.subrole ? urlparams.subrole : [];break;
					}
				case 'city':
					{
						var city = urlparams.city.length > 0 ? urlparams.city[0] : '';
						defaultFilters.filters[key].selected = [];

						if ('all-candidate-profiles' !== city) defaultFilters.filters[key].selected = [city];

						break;
					}
				case 'locality':
					defaultFilters.filters[key].selected = urlparams.locality;break;
				case 'salary':
					{
						var salary = urlparams.salary.length > 0 ? urlparams.salary[0] : '';
						defaultFilters.filters[key].selected = [];
						salary = salary.replace('salary-', '');
						salary = salary.replace('rs', '');

						if (salary) defaultFilters.filters[key].selected[0] = parseInt(salary);

						break;
					}
				case 'type':
					defaultFilters.filters[key].selected = urlparams.type;break;
				case 'company':
					defaultFilters.filters[key].selected = urlparams.company;break;
				case 'keyword':
					defaultFilters.filters[key].selected = urlparams.keyword;break;
				case 'sort':
					defaultFilters.filters[key].selected = urlparams.sort;break;
				default:
					break;
			}
		}
	});

	defaultFilters.selectedFilters = {};
	//  console.log(' default url param received from url', defaultFilters.filters);
	Object.keys(defaultFilters.filters).forEach(function (key) {
		if (defaultFilters.filters[key].selected) {
			if (key === 'keyword' && defaultFilters.filters[key].selected && defaultFilters.filters[key].selected.length > 0) {
				defaultFilters.isSearch = true;
			}

			defaultFilters.selectedFilters[key] = defaultFilters.filters[key].selected;

			if ('undefined' !== typeof defaultFilters.filters.role.subrole.selected && defaultFilters.filters.role.subrole.selected.length > 0) {
				for (var i = 0; i < defaultFilters.filters.role.subrole.selected.length; i++) {
					defaultFilters.selectedFilters.role.subrole = defaultFilters.filters.role.subrole.selected;
					defaultFilters.selectedFilters.subrole = defaultFilters.filters.role.subrole.selected;
				}
			}
		}
	});

	defaultFilters.selectedFilters['isMyNorthEastCityFilter'] = false; //default
	defaultFilters.selectedFilters['northEastFilter'] = getNorthEastFilter(snbUrlWithParam);

	return defaultFilters;
}

function getNorthEastFilter(url) {

	var urlparams = __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location && __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location.href ? __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location.href : "";
	if (!urlparams && url) {
		urlparams = url;
	}

	var query = urlparams ? urlparams.split("?")[1] : "";
	var filter = query ? (/^[?#]/.test(query) ? query.slice(1) : query).split("&").reduce(function (params, param) {
		var _param$split = param.split("="),
		    key = _param$split[0],
		    value = _param$split[1];

		params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
		return params;
	}, {}) : {};

	return filter;
};

function handleAMPActions(defaultFilters) {
	var action = Object(__WEBPACK_IMPORTED_MODULE_2__index__["l" /* getParamFromUrl */])("ac");

	if ('filter' === action) {
		defaultFilters.popupOpened = 1;
	} else if ('sort' === action) {
		defaultFilters.filters['sort'].sortPopupOpened = 1;
	}

	return defaultFilters;
}

/**
 * @function Get the filter values from server data
 */
function getFilterData(city) {
	var params = {
		url: __WEBPACK_IMPORTED_MODULE_6_window_or_global___default.a.location.protocol + '//www.quikr.com/jobs/jobsAjax/filterData?getrole=1&getlocation=1&city=' + city
	};
	return fetchHelper.request('GET', params);
}

function getRoleFromUrlValue(state, urlRole) {
	var roleOptions = state.filters.role.options;

	for (var i = 0; i < roleOptions.length; i++) {
		var role = roleOptions[i];

		if (role.value === urlRole) return role;
	}
}

/**
 * @function Set the filter values from server data
 */
function setFilterData(state, response) {
	state.loaded = 1;

	// setting localities
	if (typeof response.data.json.location !== 'undefined' && response.data.json.location) {
		var locations = Object.keys(response.data.json.location).map(function (key) {
			return response.data.json.location[key];
		});
		var filterLocations = [];

		for (var i = 0; i < locations.length; i++) {
			var location = locations[i];
			filterLocations.push({
				id: location.id,
				value: location.value,
				displayValue: location.name
			});
		}
		state.filters.locality.options = filterLocations;
		state.filters.locality.displayInFilter = 1;
	}

	// setting roles
	if (typeof response.data.json.roles !== 'undefined' && response.data.json.roles) {
		var roles = Object.keys(response.data.json.roles).map(function (key) {
			return response.data.json.roles[key];
		});
		var filterRoles = [];

		for (var _i = 0; _i < roles.length; _i++) {
			var role = roles[_i];
			filterRoles.push({
				id: role.id,
				value: role.value,
				displayValue: role.name,
				subOptions: role.subRoles
			});
		}
		state.filters.role.options = filterRoles;
		state.filters.role.displayInFilter = 1;
	}

	//Setting Company
	if (typeof response.data.json.companies !== 'undefined' && response.data.json.companies) {
		var companies = Object.keys(response.data.json.companies).map(function (key) {
			return key;
		});

		var filterCompanies = [];

		for (var _i2 = 0; _i2 < companies.length; _i2++) {
			var company = companies[_i2];
			if (company === 'Individual') {
				continue;
			}
			filterCompanies.push({
				id: company,
				value: company,
				displayValue: company
			});
		}
		if (filterCompanies.length > 0 && !(state.filters.company && state.filters.company.selected.length > 0)) {
			state.filters.company.options = filterCompanies;
			state.filters.company.displayInFilter = 1;
		}
		state.loaded = 0;
	}

	return state;
}

/**
 * @function Get url from current filter state
 */
function getUrlFromFilters(state) {
	var filters = {};

	// preparing input object for urlbuilder function
	if (state.filters.role.selected.length > 0) filters.role = state.filters.role.selected;

	if (state.filters.role.subrole.selected.length > 0) {
		filters.subrole = [];
		for (var i = 0; i < state.filters.role.subrole.selected.length; i++) {
			filters.subrole.push(state.filters.role.subrole.selected[i]);
		}
	}

	if (state.filters.city.selected.length > 0) filters.city = state.filters.city.selected;

	if (state.filters.locality.selected.length > 0 && 1 == state.filters.locality.displayInFilter) {
		filters.locality = [];
		for (var _i3 = 0; _i3 < state.filters.locality.selected.length; _i3++) {
			filters.locality.push(state.filters.locality.selected[_i3].replace(/\s+/g, '-').toLowerCase());
		}
	}

	if (state.filters.salary.selected.length > 0 && 1 == state.filters.salary.displayInFilter) {
		var salary = state.filters.salary.selected[0];
		filters.salary = [];
		filters.salary[0] = 'salary-' + salary + 'rs';
	}

	if (state.filters.type.selected.length > 0 && 1 == state.filters.type.displayInFilter) filters.type = state.filters.type.selected;

	if (state.filters.company.selected.length > 0 && 1 == state.filters.company.displayInFilter) filters.company = state.filters.company.selected;

	if (state.filters.sort.selected.length > 0) filters.sort = state.filters.sort.selected;

	if (state.filters.keyword.selected.length > 0) filters.keyword = state.filters.keyword.selected;

	//Added For SEO.TODO: NORMALIZE TABLE
	Object.keys(state.filters).forEach(function (key) {
		if (state.filters[key].selected) {
			state.selectedFilters[key] = state.filters[key].selected;
			if (state.filters[key].subOptionsKey) {
				var subKey = state.filters[key].subOptionsKey;
				state.selectedFilters[subKey] = state.filters[key][subKey].selected;
			}
		}
	});
	var url = urlBuilder.getJobsSnbUrl(filters);
	return url;
}

/**
 * @function Fire GA events for candidate filters
 */
function fireEventForFilter(state) {
	var filters = state.filters;

	if (filters.role.selected.length > 0) {
		fireGAEvent('role');
		var data = {
			role: filters.role.selected
		};
		fireBigBrotherEvent(data);
	}
	if (filters.role.subrole.selected.length > 0) {
		fireGAEvent('subRole');
		var _data = {
			subRole: filters.role.subrole.selected
		};
		fireBigBrotherEvent(_data);
	}
	if (filters.salary.selected.length > 0) {
		fireGAEvent('salary');
		var _data2 = {
			salary: filters.salary.selected
		};
		fireBigBrotherEvent(_data2);
	}
	if (filters.company.selected.length > 0) {
		fireGAEvent('company');
		var _data3 = {
			company: filters.company.selected
		};
		fireBigBrotherEvent(_data3);
	}
	if (filters.locality.selected.length > 0) {
		fireGAEvent('locality');
		var _data4 = {
			locality: filters.locality.selected
		};
		fireBigBrotherEvent(_data4);
	}
	if (filters.type.selected.length > 0) {
		fireGAEvent('jobType');
		var _data5 = {
			jobType: filters.type.selected
		};
		fireBigBrotherEvent(_data5);
	}
}

function fireGAEvent(filter) {
	Object(__WEBPACK_IMPORTED_MODULE_3__GaHelper__["b" /* firePageLoadGa */])('applyFilter', { pwa_candidate: filter });
}

function fireBigBrotherEvent(filter) {
	var data = {
		"filterSelect": filter
	};
	__WEBPACK_IMPORTED_MODULE_5__BigBrotherAnalytics__["a" /* default */].mapObjectDataToJSONData(data, __WEBPACK_IMPORTED_MODULE_4__BigBrotherAnalytics_constants__["a" /* BIG_BROTHER_EVENTS */].jobsSnBFilterSelect);
}

/***/ }),

/***/ "Wnb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../preact/dist/preact.js
var preact = __webpack_require__("xIV9");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// EXTERNAL MODULE: ../rum-pagetypes/src/index.js
var src = __webpack_require__("eKXM");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// EXTERNAL MODULE: ../q-mdc/elements/material-button/index.js
var material_button = __webpack_require__("vkp0");

// EXTERNAL MODULE: ../q-components/components/myAccount/index.js
var myAccount = __webpack_require__("MYMf");

// EXTERNAL MODULE: ../q-components/components/icons/headerIcons/index.js + 3 modules
var headerIcons = __webpack_require__("WJAn");

// EXTERNAL MODULE: ../q-cars/src/utils/FetchHelper.js
var FetchHelper = __webpack_require__("kQy/");

// CONCATENATED MODULE: ../q-cars/src/components/common/postAdButton.js




var postAdButton_PostAdButton = function PostAdButton(props, state) {
  var router = state.router;

  var buttonText = '';
  var _router$route$match$p = router.route.match.params,
      _router$route$match$p2 = _router$route$match$p.type,
      type = _router$route$match$p2 === undefined ? null : _router$route$match$p2,
      _router$route$match$p3 = _router$route$match$p.subCat,
      subCat = _router$route$match$p3 === undefined ? null : _router$route$match$p3;


  if (type || subCat) {
    if (type == 'cars' || subCat == 'cars') {
      buttonText = 'Sell your Car';
    } else if (type == 'bikes-scooters' || subCat == 'bikes-scooters') {
      buttonText = 'Sell your Bike';
    } else {
      buttonText = 'Post Free Ad';
    }
  } else {
    buttonText = "Post Free Ad";
  }
  return Object(preact["h"])(
    material_button["a" /* default */],
    { onClick: function onClick(e) {
        props.onClick(router);
      }, key: '0', unelevated: true, compact: true, dense: true },
    buttonText
  );
};

/* harmony default export */ var postAdButton = (postAdButton_PostAdButton);
// CONCATENATED MODULE: ../q-cars/src/components/common/AutoSuggest.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoSuggest_AutoSuggest = function (_Component) {
  _inherits(AutoSuggest, _Component);

  function AutoSuggest(props) {
    _classCallCheck(this, AutoSuggest);

    // this.state={data:this.props.data};
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.title = _this.props.title;
    return _this;
  }

  AutoSuggest.prototype.doSearch = function doSearch(event) {
    var url = event.target.getAttribute('data-href');
    var keyword = event.target.innerHTML;
    if (typeof dataLayer !== 'undefined' && dataLayer) {
      dataLayer.push({ "event": "pwa_cnb_event_snb_textSearchCompleted" });
    }
    window.location.href = url;
  };

  AutoSuggest.prototype.returnSearchList = function returnSearchList(data) {
    var _this2 = this;

    var htmlElement = [];
    var searchList = data;
    searchList.map(function (item) {
      if (item.url) {
        htmlElement.push(Object(preact["h"])(
          'li',
          { 'class': 'mdc-list-item', 'data-href': item.url, onClick: _this2.doSearch },
          item.keyworddata
        ));
      }
    });
    return htmlElement;
  };

  AutoSuggest.prototype.render = function render(props, state) {
    return Object(preact["h"])(
      'div',
      null,
      Object(preact["h"])(
        'h5',
        null,
        this.title
      ),
      Object(preact["h"])(
        'ul',
        { 'class': 'mdc-list' },
        this.returnSearchList(this.props.data)
      )
    );
  };

  return AutoSuggest;
}(preact["Component"]);

/* harmony default export */ var common_AutoSuggest = (AutoSuggest_AutoSuggest);
// EXTERNAL MODULE: ../q-cars/src/constants/constants.js
var constants = __webpack_require__("xN03");
var constants_default = /*#__PURE__*/__webpack_require__.n(constants);

// EXTERNAL MODULE: ../universal-cookie/lib/index.js
var lib = __webpack_require__("5aIp");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ../q-cars/src/config.js
var src_config = __webpack_require__("aB7+");

// EXTERNAL MODULE: ../q-cars/src/utils/CommonHelper.js
var CommonHelper = __webpack_require__("6QU2");
var CommonHelper_default = /*#__PURE__*/__webpack_require__.n(CommonHelper);

// EXTERNAL MODULE: ../q-cars/src/utils/UrlHelper.js
var UrlHelper = __webpack_require__("QZ4R");

// CONCATENATED MODULE: ../q-cars/src/shellConfig.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shellConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return desktopShellConfig; });















var cookies = new lib_default.a();
var currentCityName = cookies.get('new_prefer_city') ? cookies.get('new_prefer_city').toLowerCase() === 'www' ? 'all-india' : cookies.get('new_prefer_city') : "all-india";

function getJKID() {
    var jkidCookie = cookies.get('_jk_id') && cookies.get('_jk_id').split('.');
    return jkidCookie && jkidCookie[0];
}

function getCitySpecificCategoryId(cityId, cityName, categoryId, gId) {
    var isAllIndia = cityId === 0 || cityId === 1;
    return new Promise(function (resolve, reject) {
        var params = {
            url: src_config["b" /* apiUrl */] + '/ajax/get-city-category-id?aj=1&cityId=' + cityId + '&cityName=' + cityName + '&catId=' + categoryId
        };
        var apiHelper = new FetchHelper["a" /* default */]();
        var citySearchData = apiHelper.request('get', params);
        citySearchData.then(function (res) {
            if (res.data.id) {
                resolve(res.data.id);
            } else {
                reject('Something went wrong');
            }
        }).catch(function (err) {
            reject('Something went wrong');
        });
    });
}

function searchCityCallbackForSnb(cityId, cityName, globalId, match) {
    cityId = cityId * 1;
    var pageUrl = match.url;
    var matches = pageUrl.match(/[w|x|y|z](\d+)([a-zA-Z]+)?/);
    var gId = '0,' + cityName;
    getCitySpecificCategoryId(cityId, cityName, matches[1], gId).then(function (categoryId) {
        window.location.href = Object(UrlHelper["a" /* buildNewCitySnbUrl */])(categoryId, cityName, match);
    }).catch(function (err) {});
}

function searchStateCallback(stateId, stateName, globalId, match) {
    window.location.href = Object(UrlHelper["a" /* buildNewCitySnbUrl */])(stateId, stateName, match);
}

function searchCityCallbackForHP(cityId, cityName, globalId, match) {
    cityId = cityId * 1;
    var isAllIndia = cityId === 0 || cityId === 1;
    var pageUrl = match.url;
    var urlParts = pageUrl.split("/");
    if (isAllIndia) {
        urlParts[urlParts.length - 1] = "all-india";
    } else {
        urlParts[urlParts.length - 1] = cityName.toLowerCase();
    }
    pageUrl = urlParts.join("/");
    window.location.href = pageUrl;
}
function searchCityCallbackForVap(cityId, cityName, globalId, match) {
    var adId = match.params.adId;

    var apiHelper = new FetchHelper["a" /* default */]();
    var params = {
        url: src_config["b" /* apiUrl */] + '/ajax/get-city-url?aj=1&page=VAP&adId=' + adId + '&cityId=' + cityId
    };
    apiHelper.request('get', params).then(function (response) {
        if (response.status === 200 && response.data && response.data.href) {
            window.location.href = response.data.href;
        } else {
            window.location.href = 'https://www.quikr.com/cars/used-cars/' + cityName;
        }
    });
}

function searchStateCallbackForVap(stateId, stateName, globalId, match) {
    var adId = match.params.adId;

    stateName = stateName.replace(/ /g, '-');
    var apiHelper = new FetchHelper["a" /* default */]();
    var params = {
        url: src_config["b" /* apiUrl */] + '/ajax/get-city-url?aj=1&page=VAP&adId=' + adId + '&stateId=' + stateId + '&stateName=' + stateName + '&isCarsStateLevelRequest=1'
    };
    apiHelper.request('get', params).then(function (response) {
        if (response.status === 200 && response.data && response.data.href) {
            window.location.href = response.data.href;
        } else {
            window.location.href = 'https://www.quikr.com/cars/used-cars/' + stateName;
        }
    });
}

function handleVapPostAdClick(router) {
    var adId = router.route.match.params.adId;

    var params = {
        url: src_config["b" /* apiUrl */] + '/ajax/get-postad-url?aj=1&adId=' + adId
    };
    var apiHelper = new FetchHelper["a" /* default */]();
    apiHelper.request('get', params).then(function (res) {
        if (res.data.success) {
            window.location.href = res.data.href;
        } else {
            window.location.href = constants_default.a.baseUrl + "/post-classifieds-ads/select-category";
        }
    });
}

function hanldeHomePagePostAdClick() {
    var categoryId = localStorage.getItem('carsCategoryId');
    var mGlobal = localStorage.getItem('carsMglobal');
    if (categoryId && mGlobal) {
        switch (mGlobal) {
            case "71":
                window.location.href = constants_default.a.baseUrl + "/cars/sell-your-used-cars/?postadcategoryid=" + categoryId;
                break;
            case "72":
                window.location.href = constants_default.a.baseUrl + "/bikes-scooters/sell-your-used-bikes-scooters/?postadcategoryid=" + categoryId;
                break;
            case "139":
                window.location.href = constants_default.a.baseUrl + "/commercial-vehicles/sell-used-commercial-vehicles/?postadcategoryid=" + categoryId;
                break;
            case "74":
                window.location.href = constants_default.a.baseUrl + "/spare-parts-accessories/sell-spare-parts-accessories/?postadcategoryid=" + categoryId;
                break;
            default:
                window.location.href = constants_default.a.baseUrl + "/post-classifieds-ads/select-category";
                break;
        }
    } else {
        window.location.href = constants_default.a.baseUrl + "/post-classifieds-ads/select-category";
    }
}

function handlePostAdClick(router) {
    var match = router.route.match;

    var type = match.params.type;
    var url = match.url;
    var matches = url.match(/[w|x|y|z](\d+)([a-zA-Z]+)?/);
    var catId = matches[1];
    if (type === 'cars') {
        window.location.href = constants_default.a.baseUrl + "/" + type + "/sell-your-used-cars/?postadcategoryid=" + catId;
    } else if (type === 'bikes-scooters') {
        window.location.href = constants_default.a.baseUrl + "/" + type + "/sell-your-used-bikes-scooters/?postadcategoryid=" + catId;
    } else if (url.indexOf('commercial-vehicles') !== -1) {
        window.location.href = constants_default.a.baseUrl + "/" + type + "/sell-used-commercial-vehicles/?postadcategoryid=" + catId;
    } else if (url.indexOf('spare-parts-accessories') !== -1) {
        window.location.href = constants_default.a.baseUrl + "/" + type + "/sell-spare-parts-accessories/?postadcategoryid=" + catId;
    } else {
        window.location.href = constants_default.a.baseUrl + "/post-classifieds-ads/select-category";
    }
}

var getCookie = function getCookie(name) {
    var getCookieValues = function getCookieValues(cookie) {
        var cookieArray = cookie.split('=');
        return cookieArray[1] === undefined ? null : cookieArray[1].trim();
    };

    var getCookieNames = function getCookieNames(cookie) {
        var cookieArray = cookie.split('=');
        return cookieArray[0] === undefined ? null : cookieArray[0].trim();
    };

    var cookies = document.cookie.split(';');
    var cookieValue = cookies.map(getCookieValues)[cookies.map(getCookieNames).indexOf(name)];

    return cookieValue === undefined ? null : cookieValue;
};

function onSearchCallback(event, updateSearchSuggestions) {
    var searchText = event.target.value;
    var city = getCookie('new_prefer_city') ? getCookie('new_prefer_city') : 'www';
    var cityId = getCookie('prefer_city_id') ? getCookie('prefer_city_id') : 1;

    if (searchText && searchText !== '') {
        var apiHelper = new FetchHelper["a" /* default */]();
        var ajaxHost = location.hostname === "localhost" ? constants_default.a.baseUrl : "";
        var params = {
            url: ajaxHost + '/common?aj=1&for=searchautosuggest&metacatglobalid=60&data=' + searchText + '&subdom=' + city + '&cityid=' + cityId + '&rand=' + new Date().getTime()
        };

        var suggestionsPromise = apiHelper.request('get', params);

        suggestionsPromise.then(function (response) {
            var title = 'Search Results';
            var data = response.data ? response.data : {};
            if (data) {
                updateSearchSuggestions(Object(preact["h"])(common_AutoSuggest, { data: data, title: title }));
            }
        });
    }
}

function citySearchCallBack(keyWord, updateCityList) {
    if (keyWord !== '') {
        var apiHelper = new FetchHelper["a" /* default */]();
        var data = new URLSearchParams();
        data.append('param', keyWord);
        var params = {
            url: "https://www.quikr.com/siteheaderfooter?aj=1&for=suggestCities",
            data: data
        };
        apiHelper.request('post', params).then(function (response) {
            if (response.status === 200) {
                var _response$data$suggCi = response.data.suggCities,
                    suggCities = _response$data$suggCi === undefined ? [] : _response$data$suggCi;

                updateCityList(suggCities);
            }
        });
    }
}

var _ref = Object(preact["h"])(headerIcons["e" /* Quikr */], { 'class': 'mdc-toolbar__icons' });

var _ref2 = Object(preact["h"])(
    'span',
    { 'class': 'link-text-hidden' },
    'Quikr'
);

var _ref3 = Object(preact["h"])(
    'span',
    { 'class': 'link-text-hidden' },
    'Quikr'
);

function logoCallBack(props, context) {
    if (Object(CommonHelper["isMobileRequest"])()) {
        return Object(preact["h"])(
            'a',
            { 'class': 'logo', href: 'https://www.quikr.com/cars/used-cars/' + currentCityName },
            _ref,
            _ref2
        );
    }
    var type = props.match.params.type;

    var logoUrl = void 0;
    var href = void 0;
    var alt = void 0;
    if (type == 'bikes-scooters') {
        logoUrl = 'https://teja8.kuikr.com/module_assets/images/quikr_bikes_logo.png';
        href = 'https://www.quikr.com/bikes-scooters/' + currentCityName;
        alt = 'QuikrBikes - Best place to buy Used Bikes in India';
    } else {
        logoUrl = 'https://teja8.kuikr.com/module_assets/images/quikr_cars_logo.png';
        href = 'https://www.quikr.com/cars/used-cars/' + currentCityName;
        alt = 'QuikrCars - Best place to buy New and Used Cars in India';
    }

    return Object(preact["h"])(
        'a',
        { href: href, title: alt, 'class': 'logo' },
        Object(preact["h"])('img', { alt: alt, src: logoUrl, 'class': 'cars-logo' }),
        _ref3
    );
}

function handleVapBackClick(e, history, match) {
    if (typeof document.referrer === "undefined" || document.referrer === "") {
        var adId = match.params.adId;

        var apiHelper = new FetchHelper["a" /* default */]();
        var params = {
            url: src_config["b" /* apiUrl */] + '/ajax/get-city-url?aj=1&page=SNB&adId=' + adId
        };
        apiHelper.request('get', params).then(function (response) {
            window.location.href = response.data.href;
        });
    } else {
        history.goBack();
    }
    return;
}

function getCurrentCityId() {
    var cityCookie = cookies.get('prefer_city_id') || '1';
    return cityCookie;
}

//Get userTab on header based on user loggedin Status
var LoggedOutMenu = [{ title: 'My Cart', href: '/QuikrX/Cart', gaEventName: 'cart' }, { title: 'Login/Register', href: '/SignIn', onClick: function onClick(e) {
        e.preventDefault();window.location.href = '/SignIn?redirect=' + window.location.href;
    } }];

var LoggedInMenu = [{ href: '/MyQuikr', title: 'My Account', gaEventName: 'account' }, { href: '/MyQuikr?action=activeads', title: 'My Ads', gaEventName: 'ads' }, { title: 'My Cart', href: '/QuikrX/Cart', gaEventName: 'cart' }, { title: 'My Doorstep Offers', href: '/Escrow/MyOffers/getBuyersOfferForm', gaEventName: 'doorstep_offers' }, { href: '/MyQuikr?action=mychats', title: 'My Chats', gaEventName: 'chats' }, { href: '/QuikrX/myorders', title: 'My Orders', gaEventName: 'orders' }, { title: 'Logout', href: '/bye', gaEventName: 'logout' }];

var shellConfig = [{
    route: { path: "/:type(cars|cars-bikes|bikes-scooters)/:title([0-9a-zA-Z+\\-\\.\\,]+)\\+:city([a-zA-Z0-9]+)\\+W0QQAdIdZ:adId([0-9]+)", exact: true },
    header: {
        show: true,
        hasTitle: false,
        hamburger: false,
        logoCallback: logoCallBack,
        toolbarItems: true,
        back: true,
        handleBackClick: handleVapBackClick
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAVap' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.type;
        }
        var ptype = 'CNB_VAP_MOBILE';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: { path: '/cars-bikes/ImageGallery/:id', exact: true },
    header: {
        show: false,
        hasTitle: false
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAGallery' }
}, {
    route: { path: '/cars-bikes/:b(\\used-.*-model-images-\\d+)', exact: true },
    header: {
        show: false,
        hasTitle: false
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAGallery' }
}, {
    route: { path: '/:type(cars|bikes-scooters)/(used-car-showroom|used-bike-showroom)-:name([a-zA-Z]+)-:city([a-zA-Z]+)-:id([0-9]+)', exact: true },
    header: {
        show: true,
        hasTitle: false,
        logoHref: 'https://www.quikr.com/cars/used-cars/' + currentCityName,
        toolbarItems: true
    },
    search: { show: false },
    footer: { show: true },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWACarYardBikePointLP' }
}, {
    route: { path: '/:type(cars|bikes-scooters)/:subType(car-yards|bike-points)-in-:slug([a-zA-Z0-9\-]+)', exact: true },
    header: {
        show: false
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWACarYardBikePoint' },
    qrum: function qrum(location, match) {
        var type = 'NA';
        if (typeof match !== 'undefined') {
            type = match && match.params && match.params.type;
        }
        var ptype = 'CNB_CARYARDS_BIKEPOINTS_MOBILE';
        var config = { PTYPE: src_default()(ptype), CAT: type, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: { path: '/:type(cars|cars-bikes|bikes-scooters)/:slug(.*[w|x|y|z][\\d].*)', exact: true },
    header: {
        show: true,
        hasTitle: true,
        back: false,
        logoHref: 'https://www.quikr.com/cars/used-cars/' + currentCityName,
        logoCallback: logoCallBack,
        searchCityCallback: searchCityCallbackForSnb,
        toolbarItems: true
    },
    search: { show: true, onSearchCallback: onSearchCallback },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWASnB' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.type;
        }
        var ptype = 'CNB_SNB_MOBILE';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: {
        path: '/:subCat(cars-bikes)/rto-services/:slug([a-zA-Z0-9]+)',
        exact: true
    },
    header: {
        show: false,
        hasTitle: false,
        hamburger: false,
        back: true,
        logoHref: 'https://www.quikr.com/cars/used-cars/' + currentCityName,
        searchCityCallback: searchCityCallbackForHP,
        toolbarItems: true
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWARTOPage' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.subCat;
        }
        var ptype = 'CNB_RTO_MOBILE';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: { path: '/:subCat(cars-bikes)/inspection/:id([a-zA-Z0-9]+)', exact: true },
    header: {
        show: false,
        hasTitle: false
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAInspectionPage' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.subCat;
        }

        var ptype = 'CNB_INSPECTION_MOBILE';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: { path: '/cars-bikes/partnerships/:slug([a-zA-Z0-9-]+)', exact: true },
    header: {
        show: false,
        hasTitle: false
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAPartnership' }
}, {
    route: { path: '/cars-bikes/warranty/payment-success', exact: true },
    header: {
        show: true,
        hasTitle: false,
        location: false,
        logoCallback: logoCallBack
    },
    search: { show: false },
    footer: { show: true },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAPaymentSuccess' }
}, {
    route: {
        // Cars HP
        path: '/:subCat(cars)/:type(used-cars|new-cars)/:slug([a-zA-Z0-9-]+)',
        exact: true
    },
    header: {
        show: true,
        hasTitle: true,
        hamburger: true,
        back: false,
        logoHref: 'https://www.quikr.com/cars/used-cars/' + currentCityName,
        searchCityCallback: searchCityCallbackForHP,
        toolbarItems: true,
        marketTalkButton: true
    },
    search: { show: false },
    footer: { show: true },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAHomePage' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.subCat;
        }
        var ptype = 'CNB_HP_MOBILE';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: {
        path: '/:subCat(bikes-scooters|commercial-vehicles)/:slug([a-zA-Z0-9-]+)',
        exact: true
    },
    header: {
        show: true,
        hasTitle: true,
        hamburger: true,
        back: false,
        logoHref: 'https://www.quikr.com/bikes-scooters/' + currentCityName,
        searchCityCallback: searchCityCallbackForHP,
        toolbarItems: true
    },
    search: { show: false },
    footer: { show: true },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAHomePage' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.subCat;
        }
        var ptype = 'CNB_HP_MOBILE';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}];

var desktopShellConfig = [{
    route: { path: '/:type(cars|bikes-scooters)/(used-car-showroom|used-bike-showroom)-:name([a-zA-Z]+)-:city([a-zA-Z]+)-:id([0-9]+)', exact: true },
    header: {
        show: true,
        hasTitle: false,
        location: false,
        logoCallback: logoCallBack,
        toolbarItems: true
    },
    search: { show: false },
    footer: { show: true },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWACarYardBikePointLPDesk' }
}, {
    route: { path: '/:type(cars|bikes-scooters)/:subType(car-yards|bike-points)-in-:slug([a-zA-Z0-9\-]+)', exact: true },
    header: {
        show: true,
        logoCallback: logoCallBack
    },
    search: { show: false },
    footer: { show: true },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWACarYardBikePoint' },
    qrum: function qrum(location, match) {
        var type = 'NA';
        if (typeof match !== 'undefined') {
            type = match && match.params && match.params.type;
        }
        var ptype = 'CNB_CARYARDS_BIKEPOINTS_DESKTOP';
        var config = { PTYPE: src_default()(ptype), CAT: type, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: { path: "/:type(cars|cars-bikes|bikes-scooters)/:title([0-9a-zA-Z+\\-\\.\\,]+)\\+:city([a-zA-Z0-9]+)\\+W0QQAdIdZ:adId([0-9]+)", exact: true },
    header: {
        show: true,
        hasTitle: true,
        hamburger: true,
        logoCallback: logoCallBack,
        searchCityCallback: searchCityCallbackForVap,
        cityList: src_config["l" /* topCityList */],
        stateList: src_config["k" /* stateList */],
        citySearchCallBack: citySearchCallBack,
        cityModal: true,
        searchStateCallback: searchStateCallbackForVap,
        toolbarItems: true
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAVap' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.type;
        }
        var ptype = 'CNB_VAP_DESKTOP';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: { path: '/:type(cars|cars-bikes|bikes-scooters)/:slug(.*[w|x|y|z][\\d].*)', exact: true },
    header: {
        show: true,
        hasTitle: true,
        back: false,
        logoHref: 'https://www.quikr.com/cars/used-cars/' + currentCityName,
        logoCallback: logoCallBack,
        searchCityCallback: searchCityCallbackForSnb,
        cityList: src_config["l" /* topCityList */],
        stateList: src_config["k" /* stateList */],
        citySearchCallBack: citySearchCallBack,
        cityModal: true,
        searchStateCallback: searchStateCallback,
        toolbarItems: true
    },
    search: { show: true, onSearchCallback: onSearchCallback },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWASnB' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.type;
        }
        var ptype = 'CNB_SNB_DESKTOP';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: { path: '/:subCat(cars-bikes)/inspection/:id([a-zA-Z0-9]+)', exact: true },
    header: {
        show: false,
        hasTitle: false
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAInspectionPage' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.subCat;
        }

        var ptype = 'CNB_INSPECTION_DESKTOP';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: { path: '/cars-bikes/partnerships/:slug([a-zA-Z0-9-]+)', exact: true },
    header: {
        show: false,
        hasTitle: false
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAPartnership' }
}, {
    route: { path: '/cars-bikes/warranty/payment-success', exact: true },
    header: {
        show: true,
        hasTitle: false,
        location: false,
        logoCallback: logoCallBack
    },
    search: { show: false },
    footer: { show: true },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAPaymentSuccess' }
}, {
    route: {
        // Cars HP
        path: '/:subCat(cars)/:type(used-cars|new-cars)/:slug([a-zA-Z0-9-]+)',
        exact: true
    },
    header: {
        show: true,
        hasTitle: true,
        hamburger: true,
        back: false,
        logoCallback: logoCallBack,
        searchCityCallback: searchCityCallbackForHP,
        cityList: src_config["l" /* topCityList */],
        stateList: src_config["k" /* stateList */],
        citySearchCallBack: citySearchCallBack,
        cityModal: true,
        searchStateCallback: searchStateCallbackForVap,
        toolbarItems: true
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAHomePage' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.subCat;
        }
        var ptype = 'CNB_HP_DESKTOP';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}, {
    route: {
        path: '/:type(bikes-scooters|commercial-vehicles)/:slug([a-zA-Z0-9-]+)',
        exact: true
    },
    header: {
        show: true,
        hasTitle: true,
        hamburger: true,
        back: false,
        logoCallback: logoCallBack,
        searchCityCallback: searchCityCallbackForHP,
        cityList: src_config["l" /* topCityList */],
        stateList: src_config["k" /* stateList */],
        citySearchCallBack: citySearchCallBack,
        cityModal: true,
        searchStateCallback: searchStateCallbackForVap,
        toolbarItems: true
    },
    search: { show: false },
    footer: { show: false },
    ga: { accountId: 'UA-5568615-7', trackerName: 'CarsPWAHomePage' },
    qrum: function qrum(location, match) {
        var category = 'NA';
        if (typeof match !== 'undefined') {
            category = match && match.params && match.params.type;
        }
        var ptype = 'CNB_HP_DESKTOP';
        var config = { PTYPE: src_default()(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
        return config;
    }
}];

/***/ }),

/***/ "X6l3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");


var updateUser = function updateUser() {
	var updatedUser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	return {
		type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["j" /* USER_EVENTS */].UPDATE_USER,
		payload: updatedUser
	};
};

/***/ }),

/***/ "X84d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(_extends({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),

/***/ "XXKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToolbarSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss__ = __webpack_require__("w/zb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */


/**
 * Create the component.
 */

var ToolbarSection = function (_Component) {
  _inherits(ToolbarSection, _Component);

  function ToolbarSection() {
    _classCallCheck(this, ToolbarSection);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ToolbarSection.prototype.render = function render(_ref, state, context) {
    var className = _ref['class'],
        start = _ref.start,
        end = _ref.end,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['class', 'start', 'end', 'children']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-toolbar__section', {
      'mdc-toolbar__section--align-start': start,
      'mdc-toolbar__section--align-end': end
    }, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'section',
      _extends({ 'class': classes }, props),
      children
    );
  };

  return ToolbarSection;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "Xf5F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../@material/base/component.js
var component = __webpack_require__("xJR0");

// EXTERNAL MODULE: ../@material/ripple/index.js + 4 modules
var ripple = __webpack_require__("vrDd");

// CONCATENATED MODULE: ../@material/tabs/tab/constants.js
/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var cssClasses = {
  ACTIVE: 'mdc-tab--active'
};

var strings = {
  SELECTED_EVENT: 'MDCTab:selected'
};
// EXTERNAL MODULE: ../@material/base/foundation.js
var foundation = __webpack_require__("/X9I");

// CONCATENATED MODULE: ../@material/tabs/tab/foundation.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var foundation_MDCTabFoundation = function (_MDCFoundation) {
  _inherits(MDCTabFoundation, _MDCFoundation);

  _createClass(MDCTabFoundation, null, [{
    key: 'cssClasses',
    get: function get() {
      return cssClasses;
    }
  }, {
    key: 'strings',
    get: function get() {
      return strings;
    }
  }, {
    key: 'defaultAdapter',
    get: function get() {
      return {
        addClass: function addClass() /* className: string */{},
        removeClass: function removeClass() /* className: string */{},
        registerInteractionHandler: function registerInteractionHandler() /* type: string, handler: EventListener */{},
        deregisterInteractionHandler: function deregisterInteractionHandler() /* type: string, handler: EventListener */{},
        getOffsetWidth: function getOffsetWidth() {
          return (/* number */0
          );
        },
        getOffsetLeft: function getOffsetLeft() {
          return (/* number */0
          );
        },
        notifySelected: function notifySelected() {}
      };
    }
  }]);

  function MDCTabFoundation() {
    var adapter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MDCTabFoundation);

    var _this = _possibleConstructorReturn(this, _MDCFoundation.call(this, _extends(MDCTabFoundation.defaultAdapter, adapter)));

    _this.computedWidth_ = 0;
    _this.computedLeft_ = 0;
    _this.isActive_ = false;
    _this.preventDefaultOnClick_ = false;

    _this.clickHandler_ = function (evt) {
      if (_this.preventDefaultOnClick_) {
        evt.preventDefault();
      }
      _this.adapter_.notifySelected();
    };

    _this.keydownHandler_ = function (evt) {
      if (evt.key && evt.key === 'Enter' || evt.keyCode === 13) {
        _this.adapter_.notifySelected();
      }
    };
    return _this;
  }

  MDCTabFoundation.prototype.init = function init() {
    this.adapter_.registerInteractionHandler('click', this.clickHandler_);
    this.adapter_.registerInteractionHandler('keydown', this.keydownHandler_);
  };

  MDCTabFoundation.prototype.destroy = function destroy() {
    this.adapter_.deregisterInteractionHandler('click', this.clickHandler_);
    this.adapter_.deregisterInteractionHandler('keydown', this.keydownHandler_);
  };

  MDCTabFoundation.prototype.getComputedWidth = function getComputedWidth() {
    return this.computedWidth_;
  };

  MDCTabFoundation.prototype.getComputedLeft = function getComputedLeft() {
    return this.computedLeft_;
  };

  MDCTabFoundation.prototype.isActive = function isActive() {
    return this.isActive_;
  };

  MDCTabFoundation.prototype.setActive = function setActive(isActive) {
    this.isActive_ = isActive;
    if (this.isActive_) {
      this.adapter_.addClass(cssClasses.ACTIVE);
    } else {
      this.adapter_.removeClass(cssClasses.ACTIVE);
    }
  };

  MDCTabFoundation.prototype.preventsDefaultOnClick = function preventsDefaultOnClick() {
    return this.preventDefaultOnClick_;
  };

  MDCTabFoundation.prototype.setPreventDefaultOnClick = function setPreventDefaultOnClick(preventDefaultOnClick) {
    this.preventDefaultOnClick_ = preventDefaultOnClick;
  };

  MDCTabFoundation.prototype.measureSelf = function measureSelf() {
    this.computedWidth_ = this.adapter_.getOffsetWidth();
    this.computedLeft_ = this.adapter_.getOffsetLeft();
  };

  return MDCTabFoundation;
}(foundation["a" /* default */]);


// CONCATENATED MODULE: ../@material/tabs/tab/index.js
var tab__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tab__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function tab__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function tab__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









var tab_MDCTab = function (_MDCComponent) {
  tab__inherits(MDCTab, _MDCComponent);

  MDCTab.attachTo = function attachTo(root) {
    return new MDCTab(root);
  };

  tab__createClass(MDCTab, [{
    key: 'computedWidth',
    get: function get() {
      return this.foundation_.getComputedWidth();
    }
  }, {
    key: 'computedLeft',
    get: function get() {
      return this.foundation_.getComputedLeft();
    }
  }, {
    key: 'isActive',
    get: function get() {
      return this.foundation_.isActive();
    },
    set: function set(isActive) {
      this.foundation_.setActive(isActive);
    }
  }, {
    key: 'preventDefaultOnClick',
    get: function get() {
      return this.foundation_.preventsDefaultOnClick();
    },
    set: function set(preventDefaultOnClick) {
      this.foundation_.setPreventDefaultOnClick(preventDefaultOnClick);
    }
  }]);

  function MDCTab() {
    tab__classCallCheck(this, MDCTab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = tab__possibleConstructorReturn(this, _MDCComponent.call.apply(_MDCComponent, [this].concat(args)));

    _this.ripple_ = ripple["a" /* MDCRipple */].attachTo(_this.root_);
    return _this;
  }

  MDCTab.prototype.destroy = function destroy() {
    this.ripple_.destroy();
    _MDCComponent.prototype.destroy.call(this);
  };

  MDCTab.prototype.getDefaultFoundation = function getDefaultFoundation() {
    var _this2 = this;

    return new foundation_MDCTabFoundation({
      addClass: function addClass(className) {
        return _this2.root_.classList.add(className);
      },
      removeClass: function removeClass(className) {
        return _this2.root_.classList.remove(className);
      },
      registerInteractionHandler: function registerInteractionHandler(type, handler) {
        return _this2.root_.addEventListener(type, handler);
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(type, handler) {
        return _this2.root_.removeEventListener(type, handler);
      },
      getOffsetWidth: function getOffsetWidth() {
        return _this2.root_.offsetWidth;
      },
      getOffsetLeft: function getOffsetLeft() {
        return _this2.root_.offsetLeft;
      },
      notifySelected: function notifySelected() {
        return _this2.emit(foundation_MDCTabFoundation.strings.SELECTED_EVENT, { tab: _this2 }, true);
      }
    });
  };

  MDCTab.prototype.initialSyncWithDOM = function initialSyncWithDOM() {
    this.isActive = this.root_.classList.contains(cssClasses.ACTIVE);
  };

  MDCTab.prototype.measureSelf = function measureSelf() {
    this.foundation_.measureSelf();
  };

  return MDCTab;
}(component["a" /* default */]);
// EXTERNAL MODULE: ../@material/animation/index.js
var animation = __webpack_require__("PG4g");

// CONCATENATED MODULE: ../@material/tabs/tab-bar/constants.js
/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var constants_cssClasses = {
  UPGRADED: 'mdc-tab-bar-upgraded'
};

var constants_strings = {
  TAB_SELECTOR: '.mdc-tab',
  INDICATOR_SELECTOR: '.mdc-tab-bar__indicator',
  CHANGE_EVENT: 'MDCTabBar:change'
};
// CONCATENATED MODULE: ../@material/tabs/tab-bar/foundation.js
var foundation__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var foundation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function foundation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function foundation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function foundation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var foundation_MDCTabBarFoundation = function (_MDCFoundation) {
  foundation__inherits(MDCTabBarFoundation, _MDCFoundation);

  foundation__createClass(MDCTabBarFoundation, null, [{
    key: 'cssClasses',
    get: function get() {
      return constants_cssClasses;
    }
  }, {
    key: 'strings',
    get: function get() {
      return constants_strings;
    }
  }, {
    key: 'defaultAdapter',
    get: function get() {
      return {
        addClass: function addClass() /* className: string */{},
        removeClass: function removeClass() /* className: string */{},
        bindOnMDCTabSelectedEvent: function bindOnMDCTabSelectedEvent() {},
        unbindOnMDCTabSelectedEvent: function unbindOnMDCTabSelectedEvent() {},
        registerResizeHandler: function registerResizeHandler() /* handler: EventListener */{},
        deregisterResizeHandler: function deregisterResizeHandler() /* handler: EventListener */{},
        getOffsetWidth: function getOffsetWidth() {
          return (/* number */0
          );
        },
        setStyleForIndicator: function setStyleForIndicator() /* propertyName: string, value: string */{},
        getOffsetWidthForIndicator: function getOffsetWidthForIndicator() {
          return (/* number */0
          );
        },
        notifyChange: function notifyChange() /* evtData: {activeTabIndex: number} */{},
        getNumberOfTabs: function getNumberOfTabs() {
          return (/* number */0
          );
        },
        isTabActiveAtIndex: function isTabActiveAtIndex() {
          return (/* index: number */ /* boolean */false
          );
        },
        setTabActiveAtIndex: function setTabActiveAtIndex() /* index: number, isActive: true */{},
        isDefaultPreventedOnClickForTabAtIndex: function isDefaultPreventedOnClickForTabAtIndex() {
          return (/* index: number */ /* boolean */false
          );
        },
        setPreventDefaultOnClickForTabAtIndex: function setPreventDefaultOnClickForTabAtIndex() /* index: number, preventDefaultOnClick: boolean */{},
        measureTabAtIndex: function measureTabAtIndex() /* index: number */{},
        getComputedWidthForTabAtIndex: function getComputedWidthForTabAtIndex() {
          return (/* index: number */ /* number */0
          );
        },
        getComputedLeftForTabAtIndex: function getComputedLeftForTabAtIndex() {
          return (/* index: number */ /* number */0
          );
        }
      };
    }
  }]);

  function MDCTabBarFoundation(adapter) {
    foundation__classCallCheck(this, MDCTabBarFoundation);

    var _this = foundation__possibleConstructorReturn(this, _MDCFoundation.call(this, foundation__extends(MDCTabBarFoundation.defaultAdapter, adapter)));

    _this.isIndicatorShown_ = false;
    _this.computedWidth_ = 0;
    _this.computedLeft_ = 0;
    _this.activeTabIndex_ = 0;
    _this.layoutFrame_ = 0;
    _this.resizeHandler_ = function () {
      return _this.layout();
    };
    return _this;
  }

  MDCTabBarFoundation.prototype.init = function init() {
    this.adapter_.addClass(constants_cssClasses.UPGRADED);
    this.adapter_.bindOnMDCTabSelectedEvent();
    this.adapter_.registerResizeHandler(this.resizeHandler_);
    var activeTabIndex = this.findActiveTabIndex_();
    if (activeTabIndex >= 0) {
      this.activeTabIndex_ = activeTabIndex;
    }
    this.layout();
  };

  MDCTabBarFoundation.prototype.destroy = function destroy() {
    this.adapter_.removeClass(constants_cssClasses.UPGRADED);
    this.adapter_.unbindOnMDCTabSelectedEvent();
    this.adapter_.deregisterResizeHandler(this.resizeHandler_);
  };

  MDCTabBarFoundation.prototype.layoutInternal_ = function layoutInternal_() {
    var _this2 = this;

    this.forEachTabIndex_(function (index) {
      return _this2.adapter_.measureTabAtIndex(index);
    });
    this.computedWidth_ = this.adapter_.getOffsetWidth();
    this.layoutIndicator_();
  };

  MDCTabBarFoundation.prototype.layoutIndicator_ = function layoutIndicator_() {
    var isIndicatorFirstRender = !this.isIndicatorShown_;

    // Ensure that indicator appears in the right position immediately for correct first render.
    if (isIndicatorFirstRender) {
      this.adapter_.setStyleForIndicator('transition', 'none');
    }

    var translateAmtForActiveTabLeft = this.adapter_.getComputedLeftForTabAtIndex(this.activeTabIndex_);
    var scaleAmtForActiveTabWidth = this.adapter_.getComputedWidthForTabAtIndex(this.activeTabIndex_) / this.adapter_.getOffsetWidth();

    var transformValue = 'translateX(' + translateAmtForActiveTabLeft + 'px) scale(' + scaleAmtForActiveTabWidth + ', 1)';
    this.adapter_.setStyleForIndicator(Object(animation["b" /* getCorrectPropertyName */])(window, 'transform'), transformValue);

    if (isIndicatorFirstRender) {
      // Force layout so that transform styles to take effect.
      this.adapter_.getOffsetWidthForIndicator();
      this.adapter_.setStyleForIndicator('transition', '');
      this.adapter_.setStyleForIndicator('visibility', 'visible');
      this.isIndicatorShown_ = true;
    }
  };

  MDCTabBarFoundation.prototype.findActiveTabIndex_ = function findActiveTabIndex_() {
    var _this3 = this;

    var activeTabIndex = -1;
    this.forEachTabIndex_(function (index) {
      if (_this3.adapter_.isTabActiveAtIndex(index)) {
        activeTabIndex = index;
        return true;
      }
    });
    return activeTabIndex;
  };

  MDCTabBarFoundation.prototype.forEachTabIndex_ = function forEachTabIndex_(iterator) {
    var numTabs = this.adapter_.getNumberOfTabs();
    for (var index = 0; index < numTabs; index++) {
      var shouldBreak = iterator(index);
      if (shouldBreak) {
        break;
      }
    }
  };

  MDCTabBarFoundation.prototype.layout = function layout() {
    var _this4 = this;

    if (this.layoutFrame_) {
      cancelAnimationFrame(this.layoutFrame_);
    }

    this.layoutFrame_ = requestAnimationFrame(function () {
      _this4.layoutInternal_();
      _this4.layoutFrame_ = 0;
    });
  };

  MDCTabBarFoundation.prototype.switchToTabAtIndex = function switchToTabAtIndex(index, shouldNotify) {
    var _this5 = this;

    if (index === this.activeTabIndex_) {
      return;
    }

    if (index < 0 || index >= this.adapter_.getNumberOfTabs()) {
      throw new Error('Out of bounds index specified for tab: ' + index);
    }

    var prevActiveTabIndex = this.activeTabIndex_;
    this.activeTabIndex_ = index;
    requestAnimationFrame(function () {
      if (prevActiveTabIndex >= 0) {
        _this5.adapter_.setTabActiveAtIndex(prevActiveTabIndex, false);
      }
      _this5.adapter_.setTabActiveAtIndex(_this5.activeTabIndex_, true);
      _this5.layoutIndicator_();
      if (shouldNotify) {
        _this5.adapter_.notifyChange({ activeTabIndex: _this5.activeTabIndex_ });
      }
    });
  };

  MDCTabBarFoundation.prototype.getActiveTabIndex = function getActiveTabIndex() {
    return this.findActiveTabIndex_();
  };

  return MDCTabBarFoundation;
}(foundation["a" /* default */]);


// CONCATENATED MODULE: ../@material/tabs/tab-bar/index.js
var tab_bar__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tab_bar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function tab_bar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function tab_bar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var tab_bar_MDCTabBar = function (_MDCComponent) {
  tab_bar__inherits(MDCTabBar, _MDCComponent);

  function MDCTabBar() {
    tab_bar__classCallCheck(this, MDCTabBar);

    return tab_bar__possibleConstructorReturn(this, _MDCComponent.apply(this, arguments));
  }

  MDCTabBar.attachTo = function attachTo(root) {
    return new MDCTabBar(root);
  };

  MDCTabBar.prototype.initialize = function initialize() {
    var _this2 = this;

    var tabFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (el) {
      return new tab_MDCTab(el);
    };

    this.indicator_ = this.root_.querySelector(foundation_MDCTabBarFoundation.strings.INDICATOR_SELECTOR);
    this.tabs_ = this.gatherTabs_(tabFactory);
    this.tabSelectedHandler_ = function (_ref) {
      var detail = _ref.detail;
      var tab = detail.tab;

      _this2.setActiveTab_(tab, true);
    };
  };

  MDCTabBar.prototype.getDefaultFoundation = function getDefaultFoundation() {
    var _this3 = this;

    return new foundation_MDCTabBarFoundation({
      addClass: function addClass(className) {
        return _this3.root_.classList.add(className);
      },
      removeClass: function removeClass(className) {
        return _this3.root_.classList.remove(className);
      },
      bindOnMDCTabSelectedEvent: function bindOnMDCTabSelectedEvent() {
        return _this3.listen(foundation_MDCTabFoundation.strings.SELECTED_EVENT, _this3.tabSelectedHandler_);
      },
      unbindOnMDCTabSelectedEvent: function unbindOnMDCTabSelectedEvent() {
        return _this3.unlisten(foundation_MDCTabFoundation.strings.SELECTED_EVENT, _this3.tabSelectedHandler_);
      },
      registerResizeHandler: function registerResizeHandler(handler) {
        return window.addEventListener('resize', handler);
      },
      deregisterResizeHandler: function deregisterResizeHandler(handler) {
        return window.removeEventListener('resize', handler);
      },
      getOffsetWidth: function getOffsetWidth() {
        return _this3.root_.offsetWidth;
      },
      setStyleForIndicator: function setStyleForIndicator(propertyName, value) {
        return _this3.indicator_.style.setProperty(propertyName, value);
      },
      getOffsetWidthForIndicator: function getOffsetWidthForIndicator() {
        return _this3.indicator_.offsetWidth;
      },
      notifyChange: function notifyChange(evtData) {
        return _this3.emit(foundation_MDCTabBarFoundation.strings.CHANGE_EVENT, evtData);
      },
      getNumberOfTabs: function getNumberOfTabs() {
        return _this3.tabs.length;
      },
      isTabActiveAtIndex: function isTabActiveAtIndex(index) {
        return _this3.tabs[index].isActive;
      },
      setTabActiveAtIndex: function setTabActiveAtIndex(index, isActive) {
        _this3.tabs[index].isActive = isActive;
      },
      isDefaultPreventedOnClickForTabAtIndex: function isDefaultPreventedOnClickForTabAtIndex(index) {
        return _this3.tabs[index].preventDefaultOnClick;
      },
      setPreventDefaultOnClickForTabAtIndex: function setPreventDefaultOnClickForTabAtIndex(index, preventDefaultOnClick) {
        _this3.tabs[index].preventDefaultOnClick = preventDefaultOnClick;
      },
      measureTabAtIndex: function measureTabAtIndex(index) {
        return _this3.tabs[index].measureSelf();
      },
      getComputedWidthForTabAtIndex: function getComputedWidthForTabAtIndex(index) {
        return _this3.tabs[index].computedWidth;
      },
      getComputedLeftForTabAtIndex: function getComputedLeftForTabAtIndex(index) {
        return _this3.tabs[index].computedLeft;
      }
    });
  };

  MDCTabBar.prototype.gatherTabs_ = function gatherTabs_(tabFactory) {
    var tabElements = [].slice.call(this.root_.querySelectorAll(foundation_MDCTabBarFoundation.strings.TAB_SELECTOR));
    return tabElements.map(function (el) {
      return tabFactory(el);
    });
  };

  MDCTabBar.prototype.setActiveTabIndex_ = function setActiveTabIndex_(activeTabIndex, notifyChange) {
    this.foundation_.switchToTabAtIndex(activeTabIndex, notifyChange);
  };

  MDCTabBar.prototype.layout = function layout() {
    this.foundation_.layout();
  };

  MDCTabBar.prototype.setActiveTab_ = function setActiveTab_(activeTab, notifyChange) {
    var indexOfTab = this.tabs.indexOf(activeTab);
    if (indexOfTab < 0) {
      throw new Error('Invalid tab component given as activeTab: Tab not found within this component\'s tab list');
    }
    this.setActiveTabIndex_(indexOfTab, notifyChange);
  };

  tab_bar__createClass(MDCTabBar, [{
    key: 'tabs',
    get: function get() {
      return this.tabs_;
    }
  }, {
    key: 'activeTab',
    get: function get() {
      var activeIndex = this.foundation_.getActiveTabIndex();
      return this.tabs[activeIndex];
    },
    set: function set(tab) {
      this.setActiveTab_(tab, false);
    }
  }, {
    key: 'activeTabIndex',
    get: function get() {
      return this.foundation_.getActiveTabIndex();
    },
    set: function set(index) {
      this.setActiveTabIndex_(index, false);
    }
  }]);

  return MDCTabBar;
}(component["a" /* default */]);
// CONCATENATED MODULE: ../@material/tabs/tab-bar-scroller/constants.js
/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var tab_bar_scroller_constants_cssClasses = {
  INDICATOR_FORWARD: 'mdc-tab-bar-scroller__indicator--forward',
  INDICATOR_BACK: 'mdc-tab-bar-scroller__indicator--back',
  INDICATOR_ENABLED: 'mdc-tab-bar-scroller__indicator--enabled',
  TAB: 'mdc-tab'
};

var tab_bar_scroller_constants_strings = {
  FRAME_SELECTOR: '.mdc-tab-bar-scroller__scroll-frame',
  TABS_SELECTOR: '.mdc-tab-bar-scroller__scroll-frame__tabs',
  TAB_SELECTOR: '.mdc-tab',
  INDICATOR_FORWARD_SELECTOR: '.mdc-tab-bar-scroller__indicator--forward',
  INDICATOR_BACK_SELECTOR: '.mdc-tab-bar-scroller__indicator--back'
};
// CONCATENATED MODULE: ../@material/tabs/tab-bar-scroller/foundation.js
var tab_bar_scroller_foundation__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var tab_bar_scroller_foundation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tab_bar_scroller_foundation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function tab_bar_scroller_foundation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function tab_bar_scroller_foundation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var foundation_MDCTabBarScrollerFoundation = function (_MDCFoundation) {
  tab_bar_scroller_foundation__inherits(MDCTabBarScrollerFoundation, _MDCFoundation);

  tab_bar_scroller_foundation__createClass(MDCTabBarScrollerFoundation, null, [{
    key: 'cssClasses',
    get: function get() {
      return tab_bar_scroller_constants_cssClasses;
    }
  }, {
    key: 'strings',
    get: function get() {
      return tab_bar_scroller_constants_strings;
    }
  }, {
    key: 'defaultAdapter',
    get: function get() {
      return {
        addClass: function addClass() /* className: string */{},
        removeClass: function removeClass() /* className: string */{},
        eventTargetHasClass: function eventTargetHasClass() {
          return (/* target: EventTarget, className: string */ /* boolean */false
          );
        },
        addClassToForwardIndicator: function addClassToForwardIndicator() /* className: string */{},
        removeClassFromForwardIndicator: function removeClassFromForwardIndicator() /* className: string */{},
        addClassToBackIndicator: function addClassToBackIndicator() /* className: string */{},
        removeClassFromBackIndicator: function removeClassFromBackIndicator() /* className: string */{},
        isRTL: function isRTL() {
          return (/* boolean */false
          );
        },
        registerBackIndicatorClickHandler: function registerBackIndicatorClickHandler() /* handler: EventListener */{},
        deregisterBackIndicatorClickHandler: function deregisterBackIndicatorClickHandler() /* handler: EventListener */{},
        registerForwardIndicatorClickHandler: function registerForwardIndicatorClickHandler() /* handler: EventListener */{},
        deregisterForwardIndicatorClickHandler: function deregisterForwardIndicatorClickHandler() /* handler: EventListener */{},
        registerCapturedInteractionHandler: function registerCapturedInteractionHandler() /* evt: string, handler: EventListener */{},
        deregisterCapturedInteractionHandler: function deregisterCapturedInteractionHandler() /* evt: string, handler: EventListener */{},
        registerWindowResizeHandler: function registerWindowResizeHandler() /* handler: EventListener */{},
        deregisterWindowResizeHandler: function deregisterWindowResizeHandler() /* handler: EventListener */{},
        getNumberOfTabs: function getNumberOfTabs() {
          return (/* number */0
          );
        },
        getComputedWidthForTabAtIndex: function getComputedWidthForTabAtIndex() {
          return (/* number */0
          );
        },
        getComputedLeftForTabAtIndex: function getComputedLeftForTabAtIndex() {
          return (/* number */0
          );
        },
        getOffsetWidthForScrollFrame: function getOffsetWidthForScrollFrame() {
          return (/* number */0
          );
        },
        getScrollLeftForScrollFrame: function getScrollLeftForScrollFrame() {
          return (/* number */0
          );
        },
        setScrollLeftForScrollFrame: function setScrollLeftForScrollFrame() /* scrollLeftAmount: number */{},
        getOffsetWidthForTabBar: function getOffsetWidthForTabBar() {
          return (/* number */0
          );
        },
        setTransformStyleForTabBar: function setTransformStyleForTabBar() /* value: string */{},
        getOffsetLeftForEventTarget: function getOffsetLeftForEventTarget() {
          return (/* target: EventTarget */ /* number */0
          );
        },
        getOffsetWidthForEventTarget: function getOffsetWidthForEventTarget() {
          return (/* target: EventTarget */ /* number */0
          );
        }
      };
    }
  }]);

  function MDCTabBarScrollerFoundation(adapter) {
    tab_bar_scroller_foundation__classCallCheck(this, MDCTabBarScrollerFoundation);

    var _this = tab_bar_scroller_foundation__possibleConstructorReturn(this, _MDCFoundation.call(this, tab_bar_scroller_foundation__extends(MDCTabBarScrollerFoundation.defaultAdapter, adapter)));

    _this.pointerDownRecognized_ = false;
    _this.currentTranslateOffset_ = 0;
    _this.focusedTarget_ = null;
    _this.layoutFrame_ = 0;
    _this.scrollFrameScrollLeft_ = 0;
    _this.forwardIndicatorClickHandler_ = function (evt) {
      return _this.scrollForward(evt);
    };
    _this.backIndicatorClickHandler_ = function (evt) {
      return _this.scrollBack(evt);
    };
    _this.resizeHandler_ = function () {
      return _this.layout();
    };
    _this.interactionHandler_ = function (evt) {
      if (evt.type == 'touchstart' || evt.type == 'mousedown') {
        _this.pointerDownRecognized_ = true;
      }
      _this.handlePossibleTabKeyboardFocus_(evt);

      if (evt.type == 'focus') {
        _this.pointerDownRecognized_ = false;
      }
    };
    return _this;
  }

  MDCTabBarScrollerFoundation.prototype.init = function init() {
    var _this2 = this;

    this.adapter_.registerBackIndicatorClickHandler(this.backIndicatorClickHandler_);
    this.adapter_.registerForwardIndicatorClickHandler(this.forwardIndicatorClickHandler_);
    this.adapter_.registerWindowResizeHandler(this.resizeHandler_);
    ['touchstart', 'mousedown', 'focus'].forEach(function (evtType) {
      _this2.adapter_.registerCapturedInteractionHandler(evtType, _this2.interactionHandler_);
    });
    this.layout();
  };

  MDCTabBarScrollerFoundation.prototype.destroy = function destroy() {
    var _this3 = this;

    this.adapter_.deregisterBackIndicatorClickHandler(this.backIndicatorClickHandler_);
    this.adapter_.deregisterForwardIndicatorClickHandler(this.forwardIndicatorClickHandler_);
    this.adapter_.deregisterWindowResizeHandler(this.resizeHandler_);
    ['touchstart', 'mousedown', 'focus'].forEach(function (evtType) {
      _this3.adapter_.deregisterCapturedInteractionHandler(evtType, _this3.interactionHandler_);
    });
  };

  MDCTabBarScrollerFoundation.prototype.scrollBack = function scrollBack() {
    var evt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (evt) {
      evt.preventDefault();
    }

    var tabWidthAccumulator = 0;
    var scrollTargetIndex = 0;

    for (var i = this.adapter_.getNumberOfTabs() - 1; i > 0; i--) {
      var tabOffsetLeft = this.adapter_.getComputedLeftForTabAtIndex(i);
      var tabBarWidthLessTabOffsetLeft = this.adapter_.getOffsetWidthForTabBar() - tabOffsetLeft;

      var tabIsNotOccluded = tabOffsetLeft > this.currentTranslateOffset_;
      if (this.isRTL_()) {
        tabIsNotOccluded = tabBarWidthLessTabOffsetLeft > this.currentTranslateOffset_;
      }

      if (tabIsNotOccluded) {
        continue;
      }

      tabWidthAccumulator += this.adapter_.getComputedWidthForTabAtIndex(i);

      var scrollTargetDetermined = tabWidthAccumulator > this.adapter_.getOffsetWidthForScrollFrame();
      if (scrollTargetDetermined) {
        scrollTargetIndex = this.isRTL_() ? i + 1 : i;
        break;
      }
    }

    this.scrollToTabAtIndex_(scrollTargetIndex);
  };

  MDCTabBarScrollerFoundation.prototype.scrollForward = function scrollForward() {
    var evt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (evt) {
      evt.preventDefault();
    }

    var scrollFrameOffsetWidth = this.adapter_.getOffsetWidthForScrollFrame() + this.currentTranslateOffset_;
    var scrollTargetIndex = 0;

    for (var i = 0; i < this.adapter_.getNumberOfTabs(); i++) {
      var tabOffsetLeftAndWidth = this.adapter_.getComputedLeftForTabAtIndex(i) + this.adapter_.getComputedWidthForTabAtIndex(i);
      var scrollTargetDetermined = tabOffsetLeftAndWidth > scrollFrameOffsetWidth;

      if (this.isRTL_()) {
        var frameOffsetAndTabWidth = scrollFrameOffsetWidth - this.adapter_.getComputedWidthForTabAtIndex(i);
        var _tabOffsetLeftAndWidth = this.adapter_.getComputedLeftForTabAtIndex(i) + this.adapter_.getComputedWidthForTabAtIndex(i);
        var tabRightOffset = this.adapter_.getOffsetWidthForTabBar() - _tabOffsetLeftAndWidth;

        scrollTargetDetermined = tabRightOffset > frameOffsetAndTabWidth;
      }

      if (scrollTargetDetermined) {
        scrollTargetIndex = i;
        break;
      }
    }

    this.scrollToTabAtIndex_(scrollTargetIndex);
  };

  MDCTabBarScrollerFoundation.prototype.layout = function layout() {
    var _this4 = this;

    cancelAnimationFrame(this.layoutFrame_);
    this.scrollFrameScrollLeft_ = this.adapter_.getScrollLeftForScrollFrame();
    this.layoutFrame_ = requestAnimationFrame(function () {
      return _this4.layout_();
    });
  };

  MDCTabBarScrollerFoundation.prototype.isRTL_ = function isRTL_() {
    return this.adapter_.isRTL();
  };

  MDCTabBarScrollerFoundation.prototype.handlePossibleTabKeyboardFocus_ = function handlePossibleTabKeyboardFocus_(evt) {
    if (!this.adapter_.eventTargetHasClass(evt.target, tab_bar_scroller_constants_cssClasses.TAB) || this.pointerDownRecognized_) {
      return;
    }

    var resetAmt = this.isRTL_() ? this.scrollFrameScrollLeft_ : 0;
    this.adapter_.setScrollLeftForScrollFrame(resetAmt);

    this.focusedTarget_ = evt.target;
    var scrollFrameWidth = this.adapter_.getOffsetWidthForScrollFrame();
    var tabBarWidth = this.adapter_.getOffsetWidthForTabBar();
    var leftEdge = this.adapter_.getOffsetLeftForEventTarget(this.focusedTarget_);
    var rightEdge = leftEdge + this.adapter_.getOffsetWidthForEventTarget(this.focusedTarget_);

    var shouldScrollBack = rightEdge <= this.currentTranslateOffset_;
    var shouldScrollForward = rightEdge > this.currentTranslateOffset_ + scrollFrameWidth;

    if (this.isRTL_()) {
      var normalizedLeftOffset = tabBarWidth - leftEdge;
      shouldScrollBack = leftEdge >= tabBarWidth - this.currentTranslateOffset_;
      shouldScrollForward = normalizedLeftOffset > scrollFrameWidth + this.currentTranslateOffset_;
    }

    if (shouldScrollForward) {
      this.scrollForward();
    } else if (shouldScrollBack) {
      this.scrollBack();
    }

    this.pointerDownRecognized_ = false;
  };

  MDCTabBarScrollerFoundation.prototype.layout_ = function layout_() {
    var frameWidth = this.adapter_.getOffsetWidthForScrollFrame();
    var isOverflowing = this.adapter_.getOffsetWidthForTabBar() > frameWidth;

    if (!isOverflowing) {
      this.currentTranslateOffset_ = 0;
    }

    this.shiftFrame_();
    this.updateIndicatorEnabledStates_();
  };

  MDCTabBarScrollerFoundation.prototype.scrollToTabAtIndex_ = function scrollToTabAtIndex_(index) {
    var _this5 = this;

    var scrollTargetOffsetLeft = this.adapter_.getComputedLeftForTabAtIndex(index);
    var scrollTargetOffsetWidth = this.adapter_.getComputedWidthForTabAtIndex(index);

    this.currentTranslateOffset_ = this.normalizeForRTL_(scrollTargetOffsetLeft, scrollTargetOffsetWidth);

    requestAnimationFrame(function () {
      return _this5.shiftFrame_();
    });
  };

  MDCTabBarScrollerFoundation.prototype.normalizeForRTL_ = function normalizeForRTL_(left, width) {
    return this.isRTL_() ? this.adapter_.getOffsetWidthForTabBar() - (left + width) : left;
  };

  MDCTabBarScrollerFoundation.prototype.shiftFrame_ = function shiftFrame_() {
    var shiftAmount = this.isRTL_() ? this.currentTranslateOffset_ : -this.currentTranslateOffset_;

    this.adapter_.setTransformStyleForTabBar('translateX(' + shiftAmount + 'px)');
    this.updateIndicatorEnabledStates_();
  };

  MDCTabBarScrollerFoundation.prototype.updateIndicatorEnabledStates_ = function updateIndicatorEnabledStates_() {
    var INDICATOR_ENABLED = tab_bar_scroller_constants_cssClasses.INDICATOR_ENABLED;

    if (this.currentTranslateOffset_ === 0) {
      this.adapter_.removeClassFromBackIndicator(INDICATOR_ENABLED);
    } else {
      this.adapter_.addClassToBackIndicator(INDICATOR_ENABLED);
    }

    var remainingTabBarWidth = this.adapter_.getOffsetWidthForTabBar() - this.currentTranslateOffset_;
    if (remainingTabBarWidth > this.adapter_.getOffsetWidthForScrollFrame()) {
      this.adapter_.addClassToForwardIndicator(INDICATOR_ENABLED);
    } else {
      this.adapter_.removeClassFromForwardIndicator(INDICATOR_ENABLED);
    }
  };

  return MDCTabBarScrollerFoundation;
}(foundation["a" /* default */]);


// CONCATENATED MODULE: ../@material/tabs/tab-bar-scroller/index.js
var tab_bar_scroller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tab_bar_scroller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function tab_bar_scroller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function tab_bar_scroller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









var tab_bar_scroller_MDCTabBarScroller = function (_MDCComponent) {
  tab_bar_scroller__inherits(MDCTabBarScroller, _MDCComponent);

  function MDCTabBarScroller() {
    tab_bar_scroller__classCallCheck(this, MDCTabBarScroller);

    return tab_bar_scroller__possibleConstructorReturn(this, _MDCComponent.apply(this, arguments));
  }

  MDCTabBarScroller.attachTo = function attachTo(root) {
    return new MDCTabBarScroller(root);
  };

  MDCTabBarScroller.prototype.initialize = function initialize() {
    var tabBarFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (root) {
      return new tab_bar_MDCTabBar(root);
    };

    this.scrollFrame_ = this.root_.querySelector(foundation_MDCTabBarScrollerFoundation.strings.FRAME_SELECTOR);
    this.tabBarEl_ = this.root_.querySelector(foundation_MDCTabBarScrollerFoundation.strings.TABS_SELECTOR);
    this.forwardIndicator_ = this.root_.querySelector(foundation_MDCTabBarScrollerFoundation.strings.INDICATOR_FORWARD_SELECTOR);
    this.backIndicator_ = this.root_.querySelector(foundation_MDCTabBarScrollerFoundation.strings.INDICATOR_BACK_SELECTOR);
    this.tabBar_ = tabBarFactory(this.tabBarEl_);
  };

  MDCTabBarScroller.prototype.getDefaultFoundation = function getDefaultFoundation() {
    var _this2 = this;

    return new foundation_MDCTabBarScrollerFoundation({
      addClass: function addClass(className) {
        return _this2.root_.classList.add(className);
      },
      removeClass: function removeClass(className) {
        return _this2.root_.classList.remove(className);
      },
      eventTargetHasClass: function eventTargetHasClass(target, className) {
        return target.classList.contains(className);
      },
      addClassToForwardIndicator: function addClassToForwardIndicator(className) {
        return _this2.forwardIndicator_.classList.add(className);
      },
      removeClassFromForwardIndicator: function removeClassFromForwardIndicator(className) {
        return _this2.forwardIndicator_.classList.remove(className);
      },
      addClassToBackIndicator: function addClassToBackIndicator(className) {
        return _this2.backIndicator_.classList.add(className);
      },
      removeClassFromBackIndicator: function removeClassFromBackIndicator(className) {
        return _this2.backIndicator_.classList.remove(className);
      },
      isRTL: function isRTL() {
        return getComputedStyle(_this2.root_).getPropertyValue('direction') === 'rtl';
      },
      registerBackIndicatorClickHandler: function registerBackIndicatorClickHandler(handler) {
        return _this2.backIndicator_.addEventListener('click', handler);
      },
      deregisterBackIndicatorClickHandler: function deregisterBackIndicatorClickHandler(handler) {
        return _this2.backIndicator_.removeEventListener('click', handler);
      },
      registerForwardIndicatorClickHandler: function registerForwardIndicatorClickHandler(handler) {
        return _this2.forwardIndicator_.addEventListener('click', handler);
      },
      deregisterForwardIndicatorClickHandler: function deregisterForwardIndicatorClickHandler(handler) {
        return _this2.forwardIndicator_.removeEventListener('click', handler);
      },
      registerCapturedInteractionHandler: function registerCapturedInteractionHandler(evt, handler) {
        return _this2.root_.addEventListener(evt, handler, true);
      },
      deregisterCapturedInteractionHandler: function deregisterCapturedInteractionHandler(evt, handler) {
        return _this2.root_.removeEventListener(evt, handler, true);
      },
      registerWindowResizeHandler: function registerWindowResizeHandler(handler) {
        return window.addEventListener('resize', handler);
      },
      deregisterWindowResizeHandler: function deregisterWindowResizeHandler(handler) {
        return window.removeEventListener('resize', handler);
      },
      getNumberOfTabs: function getNumberOfTabs() {
        return _this2.tabBar.tabs.length;
      },
      getComputedWidthForTabAtIndex: function getComputedWidthForTabAtIndex(index) {
        return _this2.tabBar.tabs[index].computedWidth;
      },
      getComputedLeftForTabAtIndex: function getComputedLeftForTabAtIndex(index) {
        return _this2.tabBar.tabs[index].computedLeft;
      },
      getOffsetWidthForScrollFrame: function getOffsetWidthForScrollFrame() {
        return _this2.scrollFrame_.offsetWidth;
      },
      getScrollLeftForScrollFrame: function getScrollLeftForScrollFrame() {
        return _this2.scrollFrame_.scrollLeft;
      },
      setScrollLeftForScrollFrame: function setScrollLeftForScrollFrame(scrollLeftAmount) {
        return _this2.scrollFrame_.scrollLeft = scrollLeftAmount;
      },
      getOffsetWidthForTabBar: function getOffsetWidthForTabBar() {
        return _this2.tabBarEl_.offsetWidth;
      },
      setTransformStyleForTabBar: function setTransformStyleForTabBar(value) {
        _this2.tabBarEl_.style.setProperty(Object(animation["b" /* getCorrectPropertyName */])(window, 'transform'), value);
      },
      getOffsetLeftForEventTarget: function getOffsetLeftForEventTarget(target) {
        return target.offsetLeft;
      },
      getOffsetWidthForEventTarget: function getOffsetWidthForEventTarget(target) {
        return target.offsetWidth;
      }
    });
  };

  MDCTabBarScroller.prototype.layout = function layout() {
    this.foundation_.layout();
  };

  tab_bar_scroller__createClass(MDCTabBarScroller, [{
    key: 'tabBar',
    get: function get() {
      return this.tabBar_;
    }
  }]);

  return MDCTabBarScroller;
}(component["a" /* default */]);
// CONCATENATED MODULE: ../@material/tabs/index.js
/* unused concated harmony import MDCTabFoundation */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return foundation_MDCTabFoundation; });
/* unused concated harmony import MDCTab */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return tab_MDCTab; });
/* unused concated harmony import MDCTabBarFoundation */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return foundation_MDCTabBarFoundation; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return tab_bar_MDCTabBar; });
/* unused concated harmony import MDCTabBarScrollerFoundation */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return foundation_MDCTabBarScrollerFoundation; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return tab_bar_scroller_MDCTabBarScroller; });
/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/***/ }),

/***/ "YAz8":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function (string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("HPUF")))

/***/ }),

/***/ "YS7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),

/***/ "YShu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../q-jobs/src/utils/Config/index.js + 1 modules
var Config = __webpack_require__("1QGg");

// EXTERNAL MODULE: ../q-jobs/src/store.js + 18 modules
var store = __webpack_require__("R8p8");

// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/packHandler.js
var packHandler = __webpack_require__("UNCw");

// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/genericValidator.js
var genericValidator = __webpack_require__("LZrM");

// EXTERNAL MODULE: ../q-jobs/src/utils/index.js + 1 modules
var utils = __webpack_require__("upA3");

// EXTERNAL MODULE: ../window-or-global/lib/index.js
var lib = __webpack_require__("IyPV");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ../q-jobs/src/utils/SessionStorage/index.js
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author shreyas.hande on 6/21/18
 *
 */


var SessionStorage = (_temp = _class = function SessionStorage() {
  _classCallCheck(this, SessionStorage);
}, _class.isSessionStorageEnabled = function () {
  return lib_default.a.hasOwnProperty('sessionStorage');
}, _class.getItem = function (key) {
  return SessionStorage.isSessionStorageEnabled() ? lib_default.a.sessionStorage.getItem(key) : null;
}, _class.setItem = function (key, value) {
  SessionStorage.isSessionStorageEnabled() && lib_default.a.sessionStorage.setItem(key, value);
}, _class.removeItem = function (key) {
  SessionStorage.isSessionStorageEnabled() && lib_default.a.sessionStorage.removeItem(key);
}, _class.clear = function () {
  SessionStorage.isSessionStorageEnabled() && lib_default.a.sessionStorage.clear();
}, _temp);

// EXTERNAL MODULE: ../q-jobs/src/utils/LocalStorageWrapper/index.js
var LocalStorageWrapper = __webpack_require__("gEYR");

// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/others/freeLocality.js
var freeLocality = __webpack_require__("5P8N");

// EXTERNAL MODULE: ../q-jobs/src/utils/Apply/ApplyCookieHelper.js
var ApplyCookieHelper = __webpack_require__("8Ery");

// EXTERNAL MODULE: ../q-jobs/src/actions/PostAdActions/index.js
var PostAdActions = __webpack_require__("GNhE");

// EXTERNAL MODULE: ../q-jobs/src/utils/JobsPostAd/index.js
var JobsPostAd = __webpack_require__("/gj+");

// CONCATENATED MODULE: ../q-jobs/src/utils/JobsPostAd/jobsPostAdRequest.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JobsPostAdRequest; });
var jobsPostAdRequest__class, jobsPostAdRequest__temp;

function jobsPostAdRequest__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }















var sessionStorageKey = 'jobsPostAdRequest';

var JobsPostAdRequest = (jobsPostAdRequest__temp = jobsPostAdRequest__class = function JobsPostAdRequest() {
  jobsPostAdRequest__classCallCheck(this, JobsPostAdRequest);
}, jobsPostAdRequest__class.updatePostAdRequestFromContext = function (response) {
  var storeValues = store["a" /* JobStore */].getState();
  var currentRequest = storeValues.postAdRequest;
  var user = storeValues.user;
  var cookieHelper = new ApplyCookieHelper["a" /* default */]();

  var newPayload = {};
  var jobTypeObject = currentRequest[JobsPostAd["d" /* POST_AD_FIELDS */].TYPE];
  var minExpObject = currentRequest[JobsPostAd["d" /* POST_AD_FIELDS */].MIN_EXPERIENCE];
  var maxExpObject = currentRequest[JobsPostAd["d" /* POST_AD_FIELDS */].MAX_EXPERIENCE];

  jobTypeObject.options = response.json.jobTypes;
  newPayload[JobsPostAd["d" /* POST_AD_FIELDS */].TYPE] = jobTypeObject;

  minExpObject.options = response.json.minExpOptions;
  minExpObject.defaultOptions = response.json.minExpOptions;
  newPayload[JobsPostAd["d" /* POST_AD_FIELDS */].MIN_EXPERIENCE] = minExpObject;

  maxExpObject.options = response.json.maxExpOptions;
  maxExpObject.defaultOptions = response.json.maxExpOptions;
  newPayload[JobsPostAd["d" /* POST_AD_FIELDS */].MAX_EXPERIENCE] = maxExpObject;

  // updatedRequest.hiringCompany.value = response.json.hireCompanyName;
  // updatedRequest.postedByCompany.value = response.json.postedByCompany;
  JobsPostAdRequest.reduxUpdateCompanyDetails();

  if (user.loggedIn) {
    var recruiterEmailObject = currentRequest[JobsPostAd["d" /* POST_AD_FIELDS */].RECRUITER_EMAIL];
    var recruiterMobileObject = currentRequest[JobsPostAd["d" /* POST_AD_FIELDS */].RECRUITER_PHONE];

    if (user.hasOwnProperty('email') && genericValidator["a" /* Validator */].isEmpty(recruiterEmailObject.value)) {
      recruiterEmailObject.value = user.email;
      recruiterEmailObject.options = user.emailList;
      newPayload[JobsPostAd["d" /* POST_AD_FIELDS */].RECRUITER_EMAIL] = recruiterEmailObject;
    }

    if (user.hasOwnProperty('mobile') && genericValidator["a" /* Validator */].isEmpty(recruiterMobileObject.value)) {
      recruiterMobileObject.value = JSON.stringify(user.mobile);
      recruiterMobileObject.options = user.mobileList;
      newPayload[JobsPostAd["d" /* POST_AD_FIELDS */].RECRUITER_PHONE] = recruiterMobileObject;
    }
  }

  // let cookieCity = cookieHelper.getPreferredCity();
  var preferredCity = Object(utils["b" /* capitalizeFirstLetter */])(cookieHelper.getPreferredCity());
  var preferredCityId = cookieHelper.getPreferredCityId();

  var cityObject = currentRequest[JobsPostAd["d" /* POST_AD_FIELDS */].CITY];
  var localityObject = currentRequest[JobsPostAd["d" /* POST_AD_FIELDS */].LOCALITY];
  var roleName = currentRequest && currentRequest.role && currentRequest.role.valueObject ? currentRequest.role.valueObject.value : "";
  if (cityObject.id && -1 !== cityObject.id && cityObject.value) {
    preferredCity = cityObject.value;
    preferredCityId = cityObject.id;
  }

  if ('undefined' !== typeof preferredCityId && !Object(utils["r" /* isCityEmpty */])(preferredCity) && !Object(utils["u" /* isInternationalCity */])(preferredCity)) {
    if (cityObject.id !== preferredCityId) {
      cityObject = Object(JobsPostAd["h" /* updateCityField */])(cityObject, preferredCity, preferredCityId);
      newPayload[JobsPostAd["d" /* POST_AD_FIELDS */].CITY] = cityObject;

      localityObject = Object(JobsPostAd["i" /* updateLocalityFieldWithCity */])(localityObject, preferredCity);
      newPayload[JobsPostAd["d" /* POST_AD_FIELDS */].LOCALITY] = localityObject;
    }
    Config["a" /* default */].updateConfigForCategory({
      cityId: preferredCityId,
      subCatId: currentRequest[JobsPostAd["d" /* POST_AD_FIELDS */].TYPE].selectedId,
      cityname: preferredCity,
      roleName: roleName
    });
  } else {
    Config["a" /* default */].updateConfigForCategory({
      subCatId: currentRequest[JobsPostAd["d" /* POST_AD_FIELDS */].TYPE].selectedId
    });
  }

  // update pack container version in request
  newPayload['packContainerVersion'] = JobsPostAdRequest.updatePackContainerVersion(currentRequest.packContainerVersion);

  JobsPostAdRequest.updatePostAdRequest(newPayload);
}, jobsPostAdRequest__class.updateRedux = function (_) {
  JobsPostAdRequest.reduxUpdatePackContainerVersion();
  JobsPostAdRequest.reduxUpdateCompanyDetails();
  JobsPostAdRequest.reduxUpdateSelectedPacks();
  freeLocality["a" /* default */].setFullCityDetails();
  freeLocality["a" /* default */].setLocalityMaxSelectionLimit();
}, jobsPostAdRequest__class.reduxUpdateSelectedPacks = function (_) {
  var _JobStore$getState = store["a" /* JobStore */].getState(),
      user = _JobStore$getState.user,
      postAdRequest = _JobStore$getState.postAdRequest;

  var existingOthersObject = postAdRequest.others;
  var othersObject = Object(utils["c" /* copyObject */])(postAdRequest.others);
  if (user.hasCredits) {
    othersObject.selectedSubPack = null;
    othersObject.selectedPack = packHandler["a" /* PACKS */].GOLD;
  }

  var diffObject = Object(utils["e" /* difference */])(othersObject, existingOthersObject);

  if (0 !== Object.keys(diffObject).length) {
    JobsPostAdRequest.updatePostAdRequest({
      others: othersObject
    });
  }
}, jobsPostAdRequest__class.reduxUpdateCompanyDetails = function (_) {
  var _JobStore$getState2 = store["a" /* JobStore */].getState(),
      user = _JobStore$getState2.user,
      postAdRequest = _JobStore$getState2.postAdRequest;

  var existingHiringCompanyObject = postAdRequest[JobsPostAd["d" /* POST_AD_FIELDS */].HIRING_COMPANY];
  var existingPostedCompanyObject = postAdRequest[JobsPostAd["d" /* POST_AD_FIELDS */].POSTED_BY_COMPANY];
  var hiringCompanyObject = Object(utils["c" /* copyObject */])(existingHiringCompanyObject);
  var postedCompanyObject = Object(utils["c" /* copyObject */])(existingPostedCompanyObject);

  if (user.hasCredits) {
    if ('' === hiringCompanyObject.value) hiringCompanyObject.value = user.companyDetails.kycCompany;

    if (true === user.companyDetails.isToDisplayIndividual) {
      postedCompanyObject.value = 'Individual';
      postedCompanyObject.show = true;
    } else if (user.companyDetails.companyName) {
      postedCompanyObject.value = user.companyDetails.companyName;
      postedCompanyObject.show = true;
    }
  } else if (postAdRequest.locality.value.length <= JobsPostAd["b" /* PAP_CONSTANTS */].MAX_FREE_LOCALITY) {
    postedCompanyObject.value = 'Individual';
    postedCompanyObject.show = true;
  }

  var hiringCompanyDifference = Object(utils["e" /* difference */])(hiringCompanyObject, existingHiringCompanyObject);
  var postedCompanyDifference = Object(utils["e" /* difference */])(postedCompanyObject, existingPostedCompanyObject);

  var newPayload = {};
  var isDispatchRequired = false;
  if (0 !== Object.keys(hiringCompanyDifference).length) {
    newPayload[JobsPostAd["d" /* POST_AD_FIELDS */].HIRING_COMPANY] = hiringCompanyObject;
    isDispatchRequired = true;
  }

  if (0 !== Object.keys(postedCompanyDifference).length) {
    newPayload[JobsPostAd["d" /* POST_AD_FIELDS */].POSTED_BY_COMPANY] = postedCompanyObject;
    isDispatchRequired = true;
  }

  if (isDispatchRequired) {
    JobsPostAdRequest.updatePostAdRequest(newPayload);
  }
}, jobsPostAdRequest__class.updatePackContainerVersion = function (currentVersion) {
  return ++currentVersion;
}, jobsPostAdRequest__class.reduxUpdatePackContainerVersion = function (_) {
  var _JobStore$getState3 = store["a" /* JobStore */].getState(),
      postAdRequest = _JobStore$getState3.postAdRequest;

  JobsPostAdRequest.updatePostAdRequest({
    packContainerVersion: ++postAdRequest.packContainerVersion
  });
}, jobsPostAdRequest__class.updatePostAdRequest = function (updatedRequest, message) {
  if (!genericValidator["a" /* Validator */].isEmpty(message)) console.log(message);

  store["a" /* JobStore */].dispatch(Object(PostAdActions["a" /* reduxActionAdAttributeChange */])(updatedRequest));
}, jobsPostAdRequest__class.getDefaultState = function () {
  // let defaultStateFromStorage = JobsPostAdRequest.getPostAdRequestFromStorage();
  var defaultState = void 0;
  // if (('undefined' === typeof defaultStateFromStorage) || (null === defaultStateFromStorage)) {
  defaultState = JobsPostAd["f" /* defaultJobsPostAdRequestState */];
  // } else {
  // defaultState = JSON.parse(defaultStateFromStorage);
  // }

  return defaultState;
}, jobsPostAdRequest__class.isDefaultStateSaved = function () {
  var defaultStateFromStorage = JobsPostAdRequest.getPostAdRequestFromStorage();
  return !!defaultStateFromStorage;
}, jobsPostAdRequest__class.removePostAdRequestFromStorage = function () {
  SessionStorage.removeItem(sessionStorageKey);
  LocalStorageWrapper["a" /* default */].removeItem(sessionStorageKey);
}, jobsPostAdRequest__class.getPostAdRequest = function () {
  return Object(utils["c" /* copyObject */])(store["a" /* JobStore */].getState().postAdRequest);
}, jobsPostAdRequest__class.savePostAdRequest = function (request, isPermanent) {
  // set currentStep to 0 on saving state
  request.currentStep = 0;
  // set snackbar message to empty while saving state
  request.others.message = '';

  var updatedRequest = Object(utils["c" /* copyObject */])(request);
  updatedRequest.showLoader = false;
  updatedRequest.showOTP = false;
  updatedRequest.showUnlimitedFreeAdsBanner = false;
  if (isPermanent) {
    LocalStorageWrapper["a" /* default */].setItem(sessionStorageKey, JSON.stringify(updatedRequest));
  } else {
    SessionStorage.setItem(sessionStorageKey, JSON.stringify(updatedRequest));
  }
}, jobsPostAdRequest__class._saveAd = function (isPermanent) {
  return JobsPostAdRequest.savePostAdRequest(store["a" /* JobStore */].getState().postAdRequest, isPermanent);
}, jobsPostAdRequest__class.showSnackbar = function (message) {
  if (!genericValidator["a" /* Validator */].isEmpty(message)) {
    var _copyObject = Object(utils["c" /* copyObject */])(store["a" /* JobStore */].getState()),
        postAdRequest = _copyObject.postAdRequest;

    var othersObject = postAdRequest.others;
    othersObject.message = message;
    var updatedRequest = {
      others: othersObject
    };
    JobsPostAdRequest.updatePostAdRequest(updatedRequest);
  }
}, jobsPostAdRequest__class.showLoader = function () {
  JobsPostAdRequest.updatePostAdRequest({
    showLoader: true
  });
}, jobsPostAdRequest__class.hideLoader = function () {
  JobsPostAdRequest.updatePostAdRequest({
    showLoader: false
  });
}, jobsPostAdRequest__class.showUnlimitedFreeAdsBanner = function (freePostAdActiveBannerMsg) {
  JobsPostAdRequest.updatePostAdRequest({
    showUnlimitedFreeAdsBanner: true,
    freePostAdActiveBannerMsg: freePostAdActiveBannerMsg
  });
}, jobsPostAdRequest__class.getPostAdRequestFromStorage = function () {
  var data = SessionStorage.getItem(sessionStorageKey) || LocalStorageWrapper["a" /* default */].getItem(sessionStorageKey);
  return data ? JSON.parse(data) : null;
}, jobsPostAdRequest__temp);



lib_default.a.saveAd = JobsPostAdRequest._saveAd;

/***/ }),

/***/ "ZDZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEventTrackGA; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getEventTrackGA = function getEventTrackGA(obj) {

	if (typeof obj !== 'undefined' && typeof ga !== 'undefined') {

		// let category = obj.category;
		// let action = obj.action;
		// let label = obj.label;
		var _obj$category = obj.category,
		    category = _obj$category === undefined ? 'quikr_pwa' : _obj$category,
		    action = obj.action,
		    label = obj.label,
		    rest = _objectWithoutProperties(obj, ['category', 'action', 'label']);

		var windowNewOpen = obj.windowNewOpen;
		var windowOpen = obj.windowOpen;

		if (category !== '' && action !== '' && label !== '') {

			if (typeof ga !== 'undefined' && ga) {
				ga('quikrPWATracker.send', 'event', _extends({ eventCategory: category, eventAction: action, eventLabel: label }, rest));
			} else {
				console.log('Google Analytics not loaded');
			}

			if (typeof gen_comscore_tag === 'function') {
				gen_comscore_tag('www.quikr.com/' + category + action);
			}
		}

		if (windowNewOpen) {
			window.open(windowNewOpen, '_blank');
		}

		if (windowOpen) {
			window.location = windowOpen;
			return false;
		}
	}
};


/***/ }),

/***/ "a957":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_dialog___ = __webpack_require__("xXYm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_button__ = __webpack_require__("vkp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_dialog_mdc_dialog_scss__ = __webpack_require__("2mi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_dialog_mdc_dialog_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_dialog_mdc_dialog_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_scss__ = __webpack_require__("bFXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */




/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */



/**
 * Create the component.
 */

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'mdc-dialog__backdrop' });

var Dialog = function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog() {
    _classCallCheck(this, Dialog);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.componentName = "dialog";
    _this._onAccept = _this._onAccept.bind(_this);
    _this._onCancel = _this._onCancel.bind(_this);

    return _this;
  }

  Dialog.prototype.componentDidMount = function componentDidMount() {
    this.MDComponent = new __WEBPACK_IMPORTED_MODULE_2__material_dialog___["a" /* MDCDialog */](this.control);
    this.MDComponent.listen("MDCDialog:accept", this._onAccept);
    this.MDComponent.listen("MDCDialog:cancel", this._onCancel);
  };

  Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
    this.MDComponent.unlisten("MDCDialog:accept", this._onAccept);
    this.MDComponent.unlisten("MDCDialog:cancel", this._onCancel);
    this.MDComponent.destroy && this.MDComponent.destroy();
  };

  Dialog.prototype._onAccept = function _onAccept(e) {
    if (this.props.onAccept) {
      this.props.onAccept(e);
    }
  };

  Dialog.prototype._onCancel = function _onCancel(e) {
    if (this.props.onCancel) {
      this.props.onCancel(e);
    }
  };

  Dialog.prototype.render = function render(_ref) {
    var _this2 = this;

    var className = _ref['class'],
        children = _ref.children,
        full = _ref.full,
        props = _objectWithoutProperties(_ref, ['class', 'children', 'full']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-dialog__surface', {
      'mdc-dialog__full': full
    }, className);
    var dialogClasses = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-dialog', {
      'mdc-dialog--open': props.open
    }, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'aside',
      _extends({ 'class': dialogClasses,
        role: 'alertdialog', ref: function ref(control) {
          _this2.control = control;
        }
      }, props),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': classes },
        children
      ),
      _ref2
    );
  };

  return Dialog;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



var DialogHeader = function (_Component2) {
  _inherits(DialogHeader, _Component2);

  function DialogHeader() {
    _classCallCheck(this, DialogHeader);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this));

    _this3.componentName = "dialog__header";
    return _this3;
  }

  DialogHeader.prototype.render = function render(_ref3) {
    var className = _ref3['class'],
        children = _ref3.children,
        props = _objectWithoutProperties(_ref3, ['class', 'children']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-dialog__header', {}, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'header',
      _extends({}, props, { 'class': classes }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'h2',
        { className: 'mdc-dialog__header__title' },
        children
      )
    );
  };

  return DialogHeader;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);
/**
 * @prop scrollable = false
 */


var DialogBody = function (_Component3) {
  _inherits(DialogBody, _Component3);

  function DialogBody() {
    _classCallCheck(this, DialogBody);

    var _this4 = _possibleConstructorReturn(this, _Component3.call(this));

    _this4.componentName = "dialog__body";
    _this4._mdcProps = ["scrollable"];
    return _this4;
  }

  DialogBody.prototype.render = function render(_ref4) {
    var className = _ref4['class'],
        children = _ref4.children,
        scrollable = _ref4.scrollable,
        props = _objectWithoutProperties(_ref4, ['class', 'children', 'scrollable']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-dialog__body', {
      'mdc-dialog__body--scrollable': scrollable
    }, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'section',
      _extends({}, props, { 'class': classes }),
      children
    );
  };

  return DialogBody;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var DialogFooter = function (_Component4) {
  _inherits(DialogFooter, _Component4);

  function DialogFooter() {
    _classCallCheck(this, DialogFooter);

    var _this5 = _possibleConstructorReturn(this, _Component4.call(this));

    _this5.componentName = "dialog__footer";
    return _this5;
  }

  DialogFooter.prototype.render = function render(_ref5) {
    var className = _ref5['class'],
        children = _ref5.children,
        sticky = _ref5.sticky,
        props = _objectWithoutProperties(_ref5, ['class', 'children', 'sticky']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-dialog__footer', {
      'mdc-dialog__footer__sticky': sticky

    }, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'footer',
      _extends({}, props, { 'class': classes }),
      children
    );
  };

  return DialogFooter;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/**
 * @prop cancel = false
 * @prop accept = false
 */


var DialogFooterButton = function (_Button) {
  _inherits(DialogFooterButton, _Button);

  function DialogFooterButton() {
    _classCallCheck(this, DialogFooterButton);

    var _this6 = _possibleConstructorReturn(this, _Button.call(this));

    _this6.componentName = "dialog__footer__button";
    _this6._mdcProps = ["cancel", "accept", "disable"];
    return _this6;
  }

  DialogFooterButton.prototype.render = function render(_ref6) {
    var _this7 = this;

    var className = _ref6['class'],
        compact = _ref6.compact,
        primary = _ref6.primary,
        accent = _ref6.accent,
        raised = _ref6.raised,
        dense = _ref6.dense,
        children = _ref6.children,
        cancel = _ref6.cancel,
        accept = _ref6.accept,
        disable = _ref6.disable,
        props = _objectWithoutProperties(_ref6, ['class', 'compact', 'primary', 'accent', 'raised', 'dense', 'children', 'cancel', 'accept', 'disable']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-dialog__footer__button mdc-button', { 'mdc-dialog__footer__button--cancel': cancel,
      'mdc-dialog__footer__button--accept': accept,
      'mdc-dialog__footer__button--disable': disable,
      'mdc-button--compact': compact,
      'mdc-button--primary': primary,
      'mdc-button--accent': accent,
      'mdc-button--raised': raised,
      'mdc-button--dense': dense
    }, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'button',
      _extends({}, props, { 'class': classes,
        ref: function ref(control) {
          _this7.control = control;
        }
      }),
      children
    );
  };

  return DialogFooterButton;
}(__WEBPACK_IMPORTED_MODULE_3__material_button__["a" /* default */]);

Dialog.Header = DialogHeader;
Dialog.Body = DialogBody;
Dialog.Footer = DialogFooter;
Dialog.FooterButton = DialogFooterButton;

/***/ }),

/***/ "aB7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GTM_ACCOUNT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sortByOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return upfrontFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return assuredTextPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return benefitsAmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return assuredShortTextPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return inspectedTextPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return topCityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return smartFilterOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return preferredVehicleOffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return assuredVehicleOffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return stateList; });
var apiUrl = 'https://www.quikr.com/core/quikrcars';
var GTM_ACCOUNT_ID = 'GTM-M32VP9';
var sortByOptions = {
    timeDesc: 'Recently Posted',
    priceAsc: 'Lowest Price',
    priceDesc: 'Highest Price',
    year: 'Latest Model',
    kms_Driven: 'Kms Driven'
};
var upfrontFilters = {
    "71": {
        "identifiers": [{
            "identifierText": "Brand_name",
            "displayText": "Brand"
        }, {
            "identifierText": "Model",
            "displayText": "Model"
        }, {
            "identifierText": "Fuel_Type",
            "displayText": "Fuel"
        }, {
            "identifierText": "bikePointId",
            "displayText": "Quikr Store"
        }, {
            "identifierText": "Year",
            "displayText": "Mfg Year"
        }, {
            "identifierText": "Color",
            "displayText": "Color"
        }]
    },
    "72": {
        "identifiers": [{
            "identifierText": "Brand_name",
            "displayText": "Brand"
        }, {
            "identifierText": "Model",
            "displayText": "Model"
        }, {
            "identifierText": "Year",
            "displayText": "Mfg Year"
        }, {
            "identifierText": "bikePointId",
            "displayText": "Quikr Store"
        }]
    },
    "74": {
        "identifiers": [{
            "identifierText": "Product_Type",
            "displayText": "Product Type"
        }]
    },
    "139": {
        "identifiers": [{
            "identifierText": "Vehicle_Type",
            "displayText": "Vehicle Type"
        }]
    }
};

var assuredTextPoints = {
    "71": ["7 Day Return Policy", "97 Checkpoints Inspected on All Cars", "Hassle-free Paper Transfer & RTO Services", "Great EMI Options Available"],
    "72": ["7 Day Return Policy", "85 Checkpoints Inspected on All Bikes", "Hassle-free Paper Transfer & RTO Services", "6 Months Warranty Available"]
};

var benefitsAmount = 700;

var assuredShortTextPoints = {
    "71": ["7 Day Return Policy", "97 Checkpoints Inspected", "Hassle-free Paper Transfer", "Great EMI Options Available"],
    "72": ["7 Day Return Policy", "85 Checkpoints Inspected", "Hassle-free Paper Transfer", "6 Months Warranty Available"]
};

var inspectedTextPoints = {
    "71": ["97 Checkpoints Inspected", "6 Months Warranty Available", "Buy with confidence from <p>Quikr Preferred Sellers <p>"],
    "72": ["85 Checkpoints Inspected", "6 Months Warranty Available", "Buy with confidence from <p>Quikr Preferred Sellers <p>"]
};

var topCityList = [{ 'name': 'Ahmedabad', id: '22', 'carsCategoryId': 161, 'bikesCategoryId': 162 }, { 'name': 'Bangalore', id: '23', 'carsCategoryId': 263, 'bikesCategoryId': 264 }, { 'name': 'Chandigarh', id: '24', 'carsCategoryId': 365, 'bikesCategoryId': 366 }, { 'name': 'Chennai', id: '25', 'carsCategoryId': 467, 'bikesCategoryId': 468 }, { 'name': 'Coimbatore', id: '26', 'carsCategoryId': 569, 'bikesCategoryId': 570 }, { 'name': 'Delhi', id: '27', 'carsCategoryId': 671, 'bikesCategoryId': 672 }, { 'name': 'Hyderabad', id: '28', 'carsCategoryId': 773, 'bikesCategoryId': 774 }, { 'name': 'Kochi', id: '29', 'carsCategoryId': 875, 'bikesCategoryId': 876 }, { 'name': 'Kolkata', id: '30', 'carsCategoryId': 977, 'bikesCategoryId': 978 }, { 'name': 'Mumbai', id: '31', 'carsCategoryId': 1079, 'bikesCategoryId': 1080 }, { 'name': 'Pune', id: '33', 'carsCategoryId': 1283, 'bikesCategoryId': 1284 }, { 'name': 'Gurgaon', id: '132222', 'carsCategoryId': 13222205001, 'bikesCategoryId': 13222205002 }, { 'name': 'Jaipur', id: '152222', 'carsCategoryId': 15222205001, 'bikesCategoryId': 15222205002 }, { 'name': 'Lucknow', id: '162222', 'carsCategoryId': 16222205001, 'bikesCategoryId': 16222205002 }, { 'name': 'Noida', id: '201301', 'carsCategoryId': 18222208931, 'bikesCategoryId': 18222208934 }, { 'name': 'NaviMumbai', id: '400701', 'carsCategoryId': 18222208661, 'bikesCategoryId': 18222208664 }];

var smartFilterOrder = [{
    title: 'Select Your City',
    filterName: 'City'
}, {
    title: 'Price/Budget',
    filterName: 'Price'
}, {
    title: 'Brand',
    filterName: 'Brand_name'
}, {
    title: 'Model',
    filterName: 'Model'
}, {
    title: 'Fuel Type',
    filterName: 'Fuel_Type'
}, {
    title: 'Nearby localities',
    filterName: 'Locality'
}];

var preferredVehicleOffers = {
    "71": [{
        "title": "Earn {value} QCash",
        "highlightText": "QCash",
        "subtext": "on purchase of {this/any} Quikr Inspected Car",
        "icon": "https://teja10.kuikr.com/images/car/icon-earn.png",
        "offerType": {
            "type": "PERCENTAGE",
            "percentage": "2.0",
            "maxAmount": "10000"
        }
    }, {
        "title": "Earn {value} on visit of Quikr Preferred Seller Store",
        "subtext": "in QCash",
        "icon": "https://teja10.kuikr.com/images/car/icon-offer.png",
        "offerType": {
            "type": "FLAT",
            "maxAmount": "500"
        },
        "code": "CAR500"
    }],
    "72": [{
        "title": "Earn {value} QCash",
        "highlightText": "QCash",
        "subtext": "on purchase of {this/any} Quikr Inspected Bike",
        "icon": "https://teja10.kuikr.com/images/car/icon-earn.png",
        "offerType": {
            "type": "PERCENTAGE",
            "percentage": "4.0",
            "maxAmount": "5000"
        }
    }, {
        "title": "Earn {value} on visit of Quikr Preferred Seller Store",
        "subtext": "in QCash",
        "icon": "https://teja10.kuikr.com/images/car/icon-offer.png",
        "offerType": {
            "type": "FLAT",
            "maxAmount": "500"
        },
        "code": "BIKE500"
    }]
};

var assuredVehicleOffers = {
    "71": [{
        "title": "Discount of {value} using QCash",
        "highlightText": "QCash",
        "subtext": "on purchase of {this/any} Quikr Assured Car",
        "icon": "https://teja10.kuikr.com/images/car/icon-burn.png",
        "offerType": {
            "type": "PERCENTAGE",
            "percentage": "1.0",
            "maxAmount": "10000"
        }
    }, {
        "title": "Earn {value} QCash",
        "highlightText": "QCash",
        "subtext": "on purchase of {this/any} Quikr Assured Car",
        "icon": "https://teja10.kuikr.com/images/car/icon-earn.png",
        "offerType": {
            "type": "PERCENTAGE",
            "percentage": "2.0",
            "maxAmount": "10000"
        }
    }, {
        "title": "Earn {value} on visit of Quikr Car Store",
        "subtext": "in QCash and PayTM cash",
        "icon": "https://teja10.kuikr.com/images/car/icon-offer.png",
        "offerType": {
            "type": "FLAT",
            "maxAmount": "700"
        },
        "code": "CAR700"
    }],
    "72": [{
        "title": "Discount of {value} using QCash",
        "highlightText": "QCash",
        "subtext": "on purchase of {this/any} Quikr Assured Bike",
        "icon": "https://teja10.kuikr.com/images/car/icon-burn.png",
        "offerType": {
            "type": "PERCENTAGE",
            "percentage": "2.0",
            "maxAmount": "5000"
        }
    }, {
        "title": "Earn {value} QCash",
        "highlightText": "QCash",
        "subtext": "on purchase of {this/any} Quikr Assured Bike",
        "icon": "https://teja10.kuikr.com/images/car/icon-earn.png",
        "offerType": {
            "type": "PERCENTAGE",
            "percentage": "4.0",
            "maxAmount": "5000"
        }
    }, {
        "title": "Earn {value} on visit of Quikr Bike Point",
        "subtext": "in QCash and PayTM cash",
        "icon": "https://teja10.kuikr.com/images/car/icon-offer.png",
        "offerType": {
            "type": "FLAT",
            "maxAmount": "700"
        },
        "code": "BIKE700"
    }]
};

var stateList = [{ 'name': "Andaman Nicobar Islands", 'id': "1146884" }, { 'name': "Andhra Pradesh", 'id': "1146885" }, { 'name': "Arunachal Pradesh", 'id': "1146886" }, { 'name': "Assam", 'id': "1146887" }, { 'name': "Bihar", 'id': "1146888" }, { 'name': "Chattisgarh", 'id': "1146889" }, { 'name': "Dadra Nagar Haveli", 'id': "1146890" }, { 'name': "Daman Diu", 'id': "1146891" }, { 'name': "Gujarat", 'id': "1146894" }, { 'name': "Haryana", 'id': "1146895" }, { 'name': "Himachal Pradesh", 'id': "1146896" }, { 'name': "Jammu Kashmir", 'id': "1146897" }, { 'name': "Jharkhand", 'id': "1146898" }, { 'name': "Karnataka", 'id': "1146899" }, { 'name': "Kerala", 'id': "1146900" }, { 'name': "Lakshadweep", 'id': "1146901" }, { 'name': "Madhya Pradesh", 'id': "1146902" }, { 'name': "Maharashtra", 'id': "1146903" }, { 'name': "Manipur", 'id': "1146904" }, { 'name': "Meghalaya", 'id': "1146905" }, { 'name': "Mizoram", 'id': "1146906" }, { 'name': "Nagaland", 'id': "1146907" }, { 'name': "Orissa", 'id': "1146908" }, { 'name': "Punjab", 'id': "1146910" }, { 'name': "Rajasthan", 'id': "1146911" }, { 'name': "Sikkim", 'id': "1146912" }, { 'name': "Tamil Nadu", 'id': "1146913" }, { 'name': "Telangana", 'id': "1146920" }, { 'name': "Tripura", 'id': "1146914" }, { 'name': "Uttarakhand", 'id': "1146916" }, { 'name': "Uttar Pradesh", 'id': "1146915" }, { 'name': "West Bengal", 'id': "1146917" }];

/***/ }),

/***/ "aLwj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");
var settle = __webpack_require__("OZRe");
var buildURL = __webpack_require__("Aslg");
var parseHeaders = __webpack_require__("I2hN");
var isURLSameOrigin = __webpack_require__("2L6H");
var createError = __webpack_require__("dp6N");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("9BVR");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),

/***/ "aQ5F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aQ7X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "alvd":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = debounce;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("HPUF")))

/***/ }),

/***/ "bEy/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("6X2+");
var isBuffer = __webpack_require__("5x+S");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),

/***/ "bFXu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bcDK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bhOV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return removeErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateWindowData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");


var removeErrorMessage = function removeErrorMessage() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["k" /* WINDOW_EVENTS */].REMOVE_ERROR_MESSAGE,
    payload: { applyErrorMessage: null }
  };
};

var updateWindowData = function updateWindowData(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["k" /* WINDOW_EVENTS */].UPDATE_DATA,
    payload: payload
  };
};

/***/ }),

/***/ "c2AY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../preact/dist/preact.js
var preact = __webpack_require__("xIV9");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// CONCATENATED MODULE: ../q-components/components/icons/searchIcons/recent/index.js



var _ref = Object(preact["h"])("path", { d: "M37.6,23v16.2l13.9,8.2l2.3-3.9l-11.3-6.7V23H37.6z M40.9,6.9c-16.1,0-29.1,13-29.1,29.1H2l12.6,12.6l0.2,0.5l13.1-13h-9.7c0-12.5,10.1-22.7,22.7-22.7S63.5,23.5,63.5,36S53.4,58.7,40.9,58.7c-6.2,0-11.9-2.6-16-6.7l-4.6,4.6c5.3,5.3,12.5,8.5,20.6,8.5C57,65.1,70,52.1,70,36C70,19.9,57,6.9,40.9,6.9z" });

var recent_recent = function recent(props) {
	return Object(preact["h"])(
		"svg",
		{ id: "recent", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};

/* harmony default export */ var searchIcons_recent = (recent_recent);
// EXTERNAL MODULE: ../q-components/components/icons/searchIcons/search/index.js
var search = __webpack_require__("m1Ly");

// CONCATENATED MODULE: ../q-components/components/icons/searchIcons/shortlist/index.js



var shortlist__ref = Object(preact["h"])("path", { d: "M49.8,5.4C61.1,5.4,70,14.3,70,25.6c0,4-1.1,7.9-3.2,11.8c-3.7,6.9-8.6,11.9-24.1,26.1L36,69.5l-2.3-2.1l-4.4-4c-15.5-14-20.4-19.1-24.1-26C3.1,33.5,2,29.6,2,25.6C2,14.3,10.9,5.4,22.2,5.4c5,0,9.9,1.8,13.8,5C39.8,7.2,44.7,5.4,49.8,5.4z M38.2,58.4C53,44.9,57.7,40.1,60.9,34.1c1.6-2.9,2.3-5.7,2.3-8.6c0-7.5-5.9-13.4-13.4-13.4c-4.2,0-8.4,2-11.2,5.2l-2.6,3l-2.6-3c-2.7-3.2-6.9-5.2-11.2-5.2c-7.5,0-13.4,5.9-13.4,13.4c0,2.9,0.8,5.6,2.4,8.6c3.2,5.9,7.9,10.8,22.7,24.2l2.2,2L38.2,58.4z" });

var shortlist_shortlist = function shortlist(props) {
	return Object(preact["h"])(
		"svg",
		{ id: "shortlist", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", viewBox: "0 0 72 72", "class": props.class },
		shortlist__ref
	);
};

/* harmony default export */ var searchIcons_shortlist = (shortlist_shortlist);
// EXTERNAL MODULE: ../q-components/components/icons/searchIcons/trending/index.js
var trending = __webpack_require__("uXYi");

// CONCATENATED MODULE: ../q-components/components/icons/searchIcons/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return searchIcons_recent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return search["a" /* default */]; });
/* unused concated harmony import Shortlist */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return searchIcons_shortlist; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return trending["a" /* default */]; });







/***/ }),

/***/ "c9Av":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RoleSubRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CityOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LocalStorageWrapper__ = __webpack_require__("gEYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_apiEndpoints__ = __webpack_require__("v9L/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FetchHelper__ = __webpack_require__("Hm4v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("QSFW");
var _class, _temp, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author John Lukose <john.lukose@quikr.com>
 *
 * Utility functions for remaining post ad features
 */







var RoleSubRole = (_temp = _class = function RoleSubRole() {
  _classCallCheck(this, RoleSubRole);
}, _class.options = [], _class.localStorageKey = 'roleSubRoleOptions', _class.getOptions = function () {
  return RoleSubRole.options;
}, _class.getIndexedOptions = function () {
  var options = {};
  RoleSubRole.options.forEach(function (item) {
    options[item.id] = item;
  });

  return options;
}, _class.setOptions = function (optionsList) {
  RoleSubRole.options = optionsList;
}, _class.isOptionsStored = function () {
  return __WEBPACK_IMPORTED_MODULE_0__LocalStorageWrapper__["a" /* default */].hasKey(RoleSubRole.localStorageKey);
}, _class.getOptionsFromStorage = function () {
  var options = [];
  if (RoleSubRole.isOptionsStored()) {
    options = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.localStorage.getItem(RoleSubRole.localStorageKey));
  }
  return options;
}, _class.setOptionsInStorage = function (options) {
  __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.localStorage.setItem(RoleSubRole.localStorageKey, JSON.stringify(options));
}, _class.updateOptionsFromContext = function (response) {
  var roleSubRoleOptions = [];
  if (RoleSubRole.isOptionsStored()) {
    roleSubRoleOptions = RoleSubRole.getOptionsFromStorage();
  } else {
    if (response && response.json && response.json.hasOwnProperty('roleSubRoleOptions')) {
      var newOptions = response.json.roleSubRoleOptions;
      RoleSubRole.setOptionsInStorage(newOptions);
      roleSubRoleOptions = newOptions;
    }
  }
  RoleSubRole.setOptions(roleSubRoleOptions);
}, _temp);

var CityOptions = (_temp2 = _class2 = function () {
  function CityOptions() {
    _classCallCheck(this, CityOptions);
  }

  CityOptions.getCityId = function getCityId(city) {
    var cityList = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__constants__["t" /* LOCALSTORAGE_KEYS */].ALL_CITIES));
    cityList.forEach(function (cityObj) {
      if (city === cityObj.value) {
        return cityObj.id;
      }
    });
  };

  return CityOptions;
}(), _class2.options = [], _class2.localStorageKey = 'getAllCities', _class2.getOptions = function () {
  return CityOptions.options;
}, _class2.getIndexedOptions = function () {
  var options = {};
  CityOptions.options.forEach(function (item) {
    options[item.id] = item;
  });

  return options;
}, _class2.setOptions = function (optionsList) {
  CityOptions.options = optionsList;
}, _class2.isOptionsStored = function () {
  return __WEBPACK_IMPORTED_MODULE_0__LocalStorageWrapper__["a" /* default */].hasKey(CityOptions.localStorageKey);
}, _class2.getOptionsFromStorage = function () {
  var options = [];
  if (CityOptions.isOptionsStored()) {
    options = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.localStorage.getItem(CityOptions.localStorageKey));
  }
  return options;
}, _class2.setOptionsInStorage = function (options) {
  __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.localStorage.setItem(CityOptions.localStorageKey, JSON.stringify(options));
}, _class2.updateOptionsFromContext = function (response) {
  var cityOptions = [];
  if (CityOptions.isOptionsStored()) {
    cityOptions = CityOptions.getOptionsFromStorage();
  } else {
    if (response && response.json && response.json.cityOptions) {
      var newOptions = response.json.cityOptions;
      CityOptions.setOptionsInStorage(newOptions);
      cityOptions = newOptions;
    }
  }
  CityOptions.setOptions(cityOptions);
}, _class2.getLocalities = function (city) {
  var url = __WEBPACK_IMPORTED_MODULE_2__constants_apiEndpoints__["d" /* LOCALITY_SEARCH_API */] + city;
  var searchListFromCache = CityOptions.getSearchListFromLocalStorage(url);
  if (searchListFromCache && searchListFromCache.length > 0) {
    return searchListFromCache;
  } else {
    var fetchHelper = new __WEBPACK_IMPORTED_MODULE_3__FetchHelper__["a" /* default */]();
    var params = {
      url: url
    };
    var localityResponse = fetchHelper.request('GET', params);
    localityResponse.then(function (response) {
      response = response.data ? response.data : {};
      if (response.json && response.success) {
        CityOptions.setSearchListToLocalStorage(response.json, url);
        return JSON.parse(response.json);
      }
    });
  }
}, _class2.getSearchListFromLocalStorage = function (url) {
  var key = CityOptions.getSearchCacheKey(url);
  var listString = __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.localStorage.getItem(key);
  return JSON.parse(listString);
}, _class2.getSearchCacheKey = function (url) {
  if (url) {
    var parts = url.split('/');
    return parts[parts.length - 1];
  }
}, _class2.setSearchListToLocalStorage = function (list, url) {
  if (!list || list.length === 0) {
    return;
  }
  var key = CityOptions.getSearchCacheKey(url);
  __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.localStorage.setItem(key, JSON.stringify(list));
}, _temp2);

/***/ }),

/***/ "d1er":
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "d3IN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateApplyAfterCityChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateApplyAfterLocalityChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toggleSearchPopupFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");


var updateContext = function updateContext() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["d" /* CONTEXT_EVENTS */].UPDATE_CONTEXT,
    payload: context
  };
};

var updateApplyAfterCityChange = function updateApplyAfterCityChange(city) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["d" /* CONTEXT_EVENTS */].UPDATE_CONTEXT,
    payload: { cityForLocality: city }
  };
};

var updateApplyAfterLocalityChange = function updateApplyAfterLocalityChange(locality) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["d" /* CONTEXT_EVENTS */].UPDATE_CONTEXT,
    payload: { localityForLocality: locality }
  };
};

var toggleSearchPopupFilter = function toggleSearchPopupFilter(value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["d" /* CONTEXT_EVENTS */].SEARCH_POPUP_TOGGLE,
    payload: { value: value }
  };
};

var toggleLoader = function toggleLoader(value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["d" /* CONTEXT_EVENTS */].TOGGLE_LOADER,
    payload: { showLoader: value }
  };
};

/***/ }),

/***/ "dA1j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

// Filename: formurlencoded.js
// Timestamp: 2017.07.04-19:19:11 (last modified)
// Author(s): Bumblehead (www.bumblehead.com), JBlashill (james@blashill.com), Jumper423 (jump.e.r@yandex.ru)

module.exports = function (data) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var sorted = Boolean(opts.sorted),
        skipIndex = Boolean(opts.skipIndex),
        ignorenull = Boolean(opts.ignorenull),
        encode = function encode(value) {
        return String(value).replace(/(?:[\0-\x1F"-&\+-\}\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, encodeURIComponent).replace(/ /g, '+').replace(/[!'()~\*]/g, function (ch) {
            return '%' + ch.charCodeAt().toString(16).slice(-2).toUpperCase();
        });
    },
        keys = function keys(obj) {
        var keyarr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(obj);
        return sorted ? keyarr.sort() : keyarr;
    },
        filterjoin = function filterjoin(arr) {
        return arr.filter(function (e) {
            return e;
        }).join('&');
    },
        objnest = function objnest(name, obj) {
        return filterjoin(keys(obj).map(function (key) {
            return nest(name + '[' + key + ']', obj[key]);
        }));
    },
        arrnest = function arrnest(name, arr) {
        return arr.length ? filterjoin(arr.map(function (elem, index) {
            return skipIndex ? nest(name + '[]', elem) : nest(name + '[' + index + ']', elem);
        })) : encode(name + '[]');
    },
        nest = function nest(name, value) {
        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : typeof value === 'undefined' ? 'undefined' : _typeof(value);
        var f = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        if (value === f) f = ignorenull ? f : encode(name) + '=' + f;else if (/string|number|boolean/.test(type)) f = encode(name) + '=' + encode(value);else if (Array.isArray(value)) f = arrnest(name, value);else if (type === 'object') f = objnest(name, value);

        return f;
    };

    return data && filterjoin(keys(data).map(function (key) {
        return nest(key, data[key]);
    }));
};

/***/ }),

/***/ "dI2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_layout_grid_mdc_layout_grid_scss__ = __webpack_require__("lS63");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_layout_grid_mdc_layout_grid_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_layout_grid_mdc_layout_grid_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss__ = __webpack_require__("gdjD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_scss__);


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import local dependencies.
 */




var LayoutGrid = function (_Component) {
	_inherits(LayoutGrid, _Component);

	function LayoutGrid(props) {
		_classCallCheck(this, LayoutGrid);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {};
		return _this;
	}

	LayoutGrid.prototype.render = function render(_ref) {
		var className = _ref['class'],
		    children = _ref.children,
		    white = _ref.white,
		    props = _objectWithoutProperties(_ref, ['class', 'children', 'white']);

		var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-layout-grid', {
			'mdc-layout-grid__white': white
		}, className);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': classes },
			children
		);
	}; // end of render function


	return LayoutGrid;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var LayoutGridInner = function (_Component2) {
	_inherits(LayoutGridInner, _Component2);

	function LayoutGridInner(props) {
		_classCallCheck(this, LayoutGridInner);

		var _this2 = _possibleConstructorReturn(this, _Component2.call(this, props));

		_this2.state = {};
		return _this2;
	}

	LayoutGridInner.prototype.render = function render(_ref2) {
		var className = _ref2['class'],
		    children = _ref2.children,
		    props = _objectWithoutProperties(_ref2, ['class', 'children']);

		var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-layout-grid__inner', {}, className);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': classes },
			children
		);
	};

	return LayoutGridInner;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var LayoutGridCell = function (_Component3) {
	_inherits(LayoutGridCell, _Component3);

	function LayoutGridCell(props) {
		_classCallCheck(this, LayoutGridCell);

		var _this3 = _possibleConstructorReturn(this, _Component3.call(this, props));

		_this3._propsDict = {
			cols: "cols",
			desktop: "desktopCols",
			tablet: "tabletCols",
			phone: "phoneCols",
			order: "order",
			align: "align"
		};
		return _this3;
	}

	LayoutGridCell.prototype.createClassName = function createClassName(props) {
		var baseClass = "mdc-layout-grid__cell mdc-layout-grid__cell--";
		var classes = [];

		if (props[this._propsDict.cols]) {
			classes.push(baseClass + "span-" + props[this._propsDict.cols]);
		}

		if (props[this._propsDict.desktop]) {
			classes.push(baseClass + "span-" + props[this._propsDict.desktop] + "-desktop");
		}

		if (props[this._propsDict.tablet]) {
			classes.push(baseClass + "span-" + props[this._propsDict.tablet] + "-tablet");
		}

		if (props[this._propsDict.phone]) {
			classes.push(baseClass + "span-" + props[this._propsDict.phone] + "-phone");
		}

		if (props[this._propsDict.order]) {
			classes.push(baseClass + "order-" + props[this._propsDict.order]);
		}

		if (props[this._propsDict.align]) {
			classes.push(baseClass + "align-" + props[this._propsDict.align]);
		}

		if (props.className) {
			classes.push(props.className);
		}

		return classes.join(" ");
	};

	LayoutGridCell.prototype.render = function render(props) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ className: this.createClassName(props) },
			props.children
		);
	};

	return LayoutGridCell;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

LayoutGrid.Inner = LayoutGridInner;
LayoutGrid.Cell = LayoutGridCell;

/* harmony default export */ __webpack_exports__["a"] = (LayoutGrid);

/***/ }),

/***/ "dp6N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("3T6j");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),

/***/ "e86g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("EcKE");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var BigBrotherAnalytics = function () {
  function BigBrotherAnalytics() {
    _classCallCheck(this, BigBrotherAnalytics);
  }

  BigBrotherAnalytics.prototype.mapObjectDataToJSONData = function mapObjectDataToJSONData(data, event) {
    var payload = {};
    if (data) {
      payload = {
        'ad_id': data.job ? data.job.id : '',
        'cat_id': '93',
        'cat_name': 'Jobs',
        'city_id': data.job ? data.job.cityId : data.cityId ? data.cityId : '1',
        'city_name': data.job ? data.job.cityName : data.city ? data.city : 'www',
        'event_name': event,
        'event_time_epoc_ms': new Date().getTime()
      };
    }
    if (data.papSuccess) {
      payload.subcat_name = data.subcatname ? data.subcatname : "";
      payload.role = data.role ? data.role : "";
    }
    if (event == __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BIG_BROTHER_EVENTS */].jobsVapLoad) {
      payload.subcat_name = data.job ? data.job.role : data.role ? data.role : "";
    }
    if (event == __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BIG_BROTHER_EVENTS */].jobsSnBFilterSelect) {
      payload.filter_select = data.filterSelect ? data.filterSelect : "";
    }
    if (event == 'Browse') {
      payload.subcat_name = data.jobtype && data.jobtype.length > 0 ? data.jobtype.join(',') : data.role ? data.role : "";
      payload.role = data.role ? data.role : "";
    }
    if (event == "Search") {
      payload.subcat_name = data.jobtype && data.jobtype.length > 0 ? data.jobtype.join(',') : "";
      payload.properties = {
        keyword: data.keyword ? data.keyword : ""
      };
    }

    this._pushDataToBigBrotherAnalytics(payload, event);
  };

  BigBrotherAnalytics.prototype._pushDataToBigBrotherAnalytics = function _pushDataToBigBrotherAnalytics(payload, event) {
    var MAX_TRY = 10; // try 10 times
    var pushEvent = function pushEvent(event, payload) {
      var tryCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_TRY;

      try {
        if (typeof _paqv3 !== 'undefined' && _paqv3) {
          _paqv3.push(['_sendEventApiData', event, 'PWA', JSON.stringify(payload)]);
        } else if (tryCount) {
          setTimeout(function () {
            return pushEvent(event, payload, tryCount - 1);
          }, 1000);
        }
      } catch (e) {
        console.log('bigBrother push error', e);
      }
    };
    pushEvent(event, payload, MAX_TRY);
  };

  return BigBrotherAnalytics;
}();

/* harmony default export */ __webpack_exports__["a"] = (new BigBrotherAnalytics());

/***/ }),

/***/ "eAXu":
/***/ (function(module, exports) {

module.exports = {"CORE_HP_DESKTOP":"010100","CORE_HP_MOBILE":"010200","CORE_SEARCH_DESKTOP":"010300","CORE_SEARCH_MOBILE":"010301","CORE_BROWSE_DESKTOP":"010400","CORE_BROWSE_MOBILE":"010401","CORE_CHP_DESKTOP":"010500","CORE_CHP_MOBILE":"010501","CORE_VAP_DESKTOP":"010600","CORE_VAP_MOBILE":"010601","CORE_SSR_VAP_MOBILE":"010701","CORE_SSR_SEARCH_MOBILE":"010702","CORE_SSR_BROWSE_MOBILE":"010703","CORE_SSR_HP_MOBILE":"010704","QHMR_SNB_MOBILE":"020100","QHMR_SNB_DESKTOP":"020101","QHMR_SNB_WEBVIEW":"020102","QHMR_VAP_MOBILE":"020200","QHMR_VAP_DESKTOP":"020201","QHMR_VAP_WEBVIEW":"020202","QHMR_PAYMENT_MOBILE":"020300","QHMR_PAYMENT_DESKTOP":"020301","QHMR_PAYMENT_WEBVIEW":"020302","CF_HOME_DESKTOP":"030100","CF_HOME_MOBILE":"030200","CF_SERP_DESKTOP":"030300","CF_SERP_MOBILE":"030400","CF_SERPSEO_DESKTOP":"030500","CF_SERPSEO_MOBILE":"030600","CF_POSTAD_DESKTOP":"030700","CF_POSTAD_MOBILE":"030800","CF_MARKETPRICETRENDSRVP_DESKTOP":"030900","CF_MARKETPRICETRENDSRVP_MOBILE":"031000","CF_CITYOVERVIEW_DESKTOP":"031100","CF_CITYOVERVIEW_MOBILE":"031200","CF_ZONEOVERVIEW_DESKTOP":"031300","CF_ZONEOVERVIEW_MOBILE":"031400","CF_ZONEBUY_DESKTOP":"031500","CF_ZONEBUY_MOBILE":"031600","CF_ZONERENT_DESKTOP":"031700","CF_ZONERENT_MOBILE":"031800","CF_ZONEPROJECT_DESKTOP":"031900","CF_ZONEPROJECT_MOBILE":"032000","CF_REGIONOVERVIEW_DESKTOP":"032100","CF_REGIONOVERVIEW_MOBILE":"032200","CF_REGIONBUY_DESKTOP":"032300","CF_REGIONBUY_MOBILE":"032400","CF_REGIONRENT_DESKTOP":"032500","CF_REGIONRENT_MOBILE":"032600","CF_REGIONPROJECT_DESKTOP":"032700","CF_REGIONPROJECT_MOBILE":"032800","CF_LOCALITYOVERVIEW_DESKTOP":"032900","CF_LOCALITYOVERVIEW_MOBILE":"033000","CF_LOCALITYBUY_DESKTOP":"033100","CF_LOCALITYBUY_MOBILE":"033200","CF_LOCALITYRENT_DESKTOP":"033300","CF_LOCALITYRENT_MOBILE":"033400","CF_LOCALITYPROJECT_DESKTOP":"033500","CF_LOCALITYPROJECT_MOBILE":"033600","CF_PROJECTOVERVIEW_DESKTOP":"033700","CF_PROJECTOVERVIEW_MOBILE":"033800","CF_PROJECTLOCATION_DESKTOP":"033900","CF_PROJECTLOCATION_MOBILE":"034000","CF_PROJECTBUY_DESKTOP":"034100","CF_PROJECTBUY_MOBILE":"034200","CF_PROJECTRENT_DESKTOP":"034300","CF_PROJECTRENT_MOBILE":"034400","CF_LISTINGOVERVIEW_DESKTOP":"034500","CF_LISTINGOVERVIEW_MOBILE":"034600","CF_LISTINGLOCATION_DESKTOP":"034700","CF_LISTINGLOCATION_MOBILE":"034800","GOODS_BAZAAR_PWA":"040101","GOODS_CATEGORY_PWA":"040201","GOODS_SNB_PWA":"040301","GOODS_VAP_PWA":"040401","GOODS_SNB_SSR_PWA":"040311","GOODS_VAP_SSR_PWA":"040411","GOODS_CERTIFIED_PWA":"040501","GOODS_WAREHOUSE_PWA":"040601","COMMON_ASSURED_PWA":"040701","GOODS_BAZAAR_DESKTOP":"040103","GOODS_CATEGORY_DESKTOP":"040203","GOODS_SNB_DESKTOP":"040302","GOODS_VAP_DESKTOP":"040403","GOODS_CERTIFIED_DESKTOP":"040503","GOODS_WAREHOUSE_DESKTOP":"040602","COMMON_ASSURED_DESKTOP":"040703","GOODS_ENTITY_LISTING_DESKTOP":"040803","GOODS_ENTITY_VAP_DESKTOP":"040903","GOODS_ASSURED_INFO_DESKTOP":"041002","GOODS_SELL_INSTANTLY_DESKTOP":"041102","GOODS_LEAD_DESKTOP":"041202","GOODS_SELLER_PROMOTION_DESKTOP":"041302","GOODS_SELLER_PROFILE_DESKTOP":"041402","CNB_HP_DESKTOP":"050100","CNB_HP_MOBILE":"050101","CNB_SNB_DESKTOP":"050200","CNB_SNB_MOBILE":"050201","CNB_VAP_DESKTOP":"050300","CNB_VAP_MOBILE":"050301","CNB_INSPECTION_DESKTOP":"050400","CNB_INSPECTION_MOBILE":"050401","CNB_CARYARDS_BIKEPOINTS_DESKTOP":"050500","CNB_CARYARDS_BIKEPOINTS_MOBILE":"050501","CNB_RTO_DESKTOP":"050600","CNB_RTO_MOBILE":"050601","QH_HOME_DESKTOP":"060100","QH_HOME_MOBILE":"060200","QH_SNB_DESKTOP":"060300","QH_SNB_MOBILE":"060400","QH_LISTING_VAP_DESKTOP":"060500","QH_LISTING_VAP_MOBILE":"060600","QH_PROJECT_DESKTOP":"060700","QH_PROJECT_MOBILE":"060800","QH_LOCALITY_DESKTOP":"060900","QH_LOCALITY_MOBILE":"061000","QH_BUILDER_DESKTOP":"061100","QH_BUILDER_MOBILE":"061200","QH_INDIVIDUAL_DESKTOP":"061300","QH_INDIVIDUAL_MOBILE":"061400","QH_POSTAD_NEW_DESKTOP":"061500","QH_POSTAD_NEW_MOBILE":"061600","QH_HOMELOAN_DESKTOP":"061700","QH_HOMELOAN_MOBILE":"061800","QH_DREAM_HOMELOAN_DESKTOP":"061900","QH_DREAM_HOMELOAN_MOBILE":"062000","JOBS_HOME_MOBILE":"070100","JOBS_SNB_MOBILE":"070200","JOBS_VAP_MOBILE":"070300","JOBS_GUARANTEEDJOBS_MOBILE":"070400","JOBS_POST_AD_S1_MOBILE":"070500","JOBS_RECRUITMENT_ASSIST_LINK_MOBILE":"070600","JOBS_HOME_DESKTOP":"070101","JOBS_SNB_DESKTOP":"070201","JOBS_VAP_DESKTOP":"070301","JOBS_POST_AD_S1_DESKTOP":"070501","JOBS_POST_AD_S2_DESKTOP":"070701","JOBS_SSR_HOME_MOBILE":"070102","JOBS_SSR_SNB_MOBILE":"070202","JOBS_SSR_VAP_MOBILE":"070302","SER_HP_DESKTOP":"080100","SER_HP_PWA":"080200","SER_GYB_DESKTOP":"080300","SER_GYB_MOBILE":"080400","SER_SNB_DESKTOP":"080500","SER_SNB_PWA":"080600","SER_BL_DESKTOP":"080700","SER_BL_MOBILE":"080800","SER_SMEL_DESKTOP":"080900","SER_SMEL_MOBILE":"081000","SER_NMP_DESKTOP":"081100","SER_NMP_MOBILE":"081200","SER_ERROR_DESKTOP":"081300","SER_ERROR_MOBILE":"081400","SER_ENC_DESKTOP":"081500","SER_ENC_MOBILE":"081600"}

/***/ }),

/***/ "eKXM":
/***/ (function(module, exports, __webpack_require__) {

var pageTypes = __webpack_require__("eAXu");

function getPageType(key) {
    return pageTypes[key];
}

module.exports = getPageType;

/***/ }),

/***/ "ejLf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fMvH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_universal_cookie__ = __webpack_require__("5aIp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_universal_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_q_push_notifications__ = __webpack_require__("8j0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_q_push_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_q_push_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_q_push_notifications_lib_prototypes_optional_showGenericPreRequestModal__ = __webpack_require__("HQQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_q_push_notifications_lib_prototypes_optional_showGenericPreRequestModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_q_push_notifications_lib_prototypes_optional_showGenericPreRequestModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_constants__ = __webpack_require__("Nukh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__("5j+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("Vr6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_scss__ = __webpack_require__("y/5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










__WEBPACK_IMPORTED_MODULE_2_q_push_notifications___default.a.prototype.showCustomPopup = __WEBPACK_IMPORTED_MODULE_3_q_push_notifications_lib_prototypes_optional_showGenericPreRequestModal___default.a;
var cookies = new __WEBPACK_IMPORTED_MODULE_1_universal_cookie___default.a();

var NotificationPopup = function (_Component) {
	_inherits(NotificationPopup, _Component);

	function NotificationPopup(props) {
		_classCallCheck(this, NotificationPopup);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.initiate = function () {
			var webPush = new __WEBPACK_IMPORTED_MODULE_2_q_push_notifications___default.a({
				context: _this.props.context,
				pwa: true,
				vertical: _this.props.vertical,
				withTimeout: _this.props.withTimeout
			});
			webPush.initialize().then(function (subscription) {
				var pushCookie = cookies.get('pushSub');
				var promise = void 0;
				if (subscription) {
					if (!pushCookie) {
						cookies.set('pushSub', 'true', { path: '/', domain: '.quikr.com', maxAge: 1 * 24 * 60 * 60 });
					}
				} else {
					if (_this.props.customPopup) {
						promise = webPush.showCustomPopup({
							classes: {
								description: 'notif-text'
							},
							description: _this.props.customText,
							qcash: _this.state.qcash
						});
					} else {
						promise = webPush.requestPermission();
					}
					promise.then(function () {
						var isLoggedIn = _this.props.userInfo && _this.props.userInfo.loggedIn;
						if (isLoggedIn) {
							var params = {
								user: _this.props.userInfo,
								context: 'ChromeNotifications'
							};
							__WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('https://www.quikr.com/ssr-api/core/common/updateqcash', params).then(function (response) {
								var result = response.data;
								if (!result.isSuccess) {
									//log this error in grey log from failed payment
								}
							}).catch(function (error) {
								//log this error in grey log from failed payment
							});
						}
						if (!pushCookie) {
							cookies.set('pushSub', 'false', { path: '/', domain: '.quikr.com', maxAge: 1 * 24 * 60 * 60 });
						}
					}).catch(function (err) {
						console.error(err.message);
					});
				}
			});
		};

		_this.probability = props.probability || 100;
		_this.state = {
			qcash: 100
		};
		return _this;
	}

	NotificationPopup.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		var abRand = cookies.get(__WEBPACK_IMPORTED_MODULE_4__helpers_constants__["a" /* ABRAND_COOKIE_KEY */]) || Math.random() * 100;
		var cityName = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getCurrentCity */])();
		var context = 'ChromeNotifications';
		__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://www.quikr.com/ssr-api/core/common/getQcash/' + context).then(function (response) {
			var result = response.data;
			if (result) {
				_this2.setState({
					qcash: result
				});
			}
		}).catch(function () {});
		if (this.probability === 100 || Number(abRand) <= this.probability) {
			var initiateNotificationPopup = function initiateNotificationPopup() {
				if (_this2.props.withTimeout) {
					setTimeout(_this2.initiate, _this2.props.withTimeout * 1000);
				} else {
					_this2.initiate();
				}
			};
			if (cityName === __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["b" /* ALL_INDIA */] && this.props.geolocationEnabled) {
				var counter = 0;
				var checkGeoLocationStatus = function checkGeoLocationStatus() {
					if (typeof navigator.permissions !== "undefined") {
						navigator.permissions.query({ name: 'geolocation' }).then(function (geoPermission) {
							if (geoPermission.state !== 'prompt') {
								initiateNotificationPopup();
							} else if (counter <= 10) {
								counter += 1;
								setTimeout(checkGeoLocationStatus, 2000);
							}
						});
					} else {
						initiateNotificationPopup();
					}
				};
				checkGeoLocationStatus();
			} else {
				initiateNotificationPopup();
			}
		}
	};

	NotificationPopup.prototype.render = function render() {
		return null;
	};

	return NotificationPopup;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

NotificationPopup.defaultProps = {
	geolocationEnabled: true
};

/* harmony default export */ __webpack_exports__["a"] = (NotificationPopup);

/***/ }),

/***/ "fRvz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss__ = __webpack_require__("hsyS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */


/**
 * Create the component.
 */

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Footer.prototype.render = function render(_ref, state, context) {
    var className = _ref['class'],
        children = _ref.children,
        fixed = _ref.fixed,
        props = _objectWithoutProperties(_ref, ['class', 'children', 'fixed']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-footer', {
      // 
    }, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'footer',
      _extends({ 'class': classes }, props),
      children
    );
  };

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "fXy/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.appendModalStyles = appendModalStyles, exports.createActionButton = createActionButton;function appendModalStyles(a) {
  var b = document.createElement("style");b.type = "text/css", b.innerHTML = a, document.head.appendChild(b);
}function createActionButton(a) {
  var b = !1,
      c = document.createElement("button");c.className = "wpn_modal_actionButton";var d = function d(a) {
    var d = document.createElement("span");d.className = "wpn_ripple_effect", c.appendChild(d);var e = c.getBoundingClientRect();if (e.x = e.x || e.left, e.y = e.y || e.top, b) {
      var f = a.touches[0];d.style.left = "".concat(f.clientX - e.x, "px"), d.style.top = "".concat(f.clientY - e.y, "px");
    } else d.style.left = "".concat(a.x - e.x, "px"), d.style.top = "".concat(a.y - e.y, "px");d.addEventListener("animationend", function () {
      this.parentElement.removeChild(this);
    });
  };"ontouchstart" in document.documentElement ? (b = !0, c.addEventListener("touchstart", d, { passive: !0 })) : c.addEventListener("mousedown", d);var e = document.createElement("span");return e.innerHTML = a, c.appendChild(e), c;
}

/***/ }),

/***/ "feQy":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function getTag(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("HPUF"), __webpack_require__("d1er")(module)))

/***/ }),

/***/ "g4be":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createSearchUrl */
/* unused harmony export getSearchResultsOld */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSearchResultsPromise; });
/* unused harmony export getSearchResults */
/* unused harmony export setPageToLoadFromUrl */
/* unused harmony export handleAMPActions */
/* unused harmony export getTrendingJobsFromApi */
/* harmony export (immutable) */ __webpack_exports__["b"] = getFooterLinksDataFromApi;
/* harmony export (immutable) */ __webpack_exports__["e"] = storeCandidateResponseViaAjax;
/* harmony export (immutable) */ __webpack_exports__["d"] = sendUserLocationtoDB;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchFaqs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UrlBuilder__ = __webpack_require__("4Pem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FetchHelper__ = __webpack_require__("Hm4v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_form_urlencoded__ = __webpack_require__("dA1j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_form_urlencoded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_form_urlencoded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__("upA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_url__ = __webpack_require__("hnk3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("R8p8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Context__ = __webpack_require__("7xfs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_JobSearchActions__ = __webpack_require__("4t40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_SnbContainerActions__ = __webpack_require__("T6SA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("QSFW");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














var createSearchUrl = function createSearchUrl(selectedFilters) {
  var urlBuilder = new __WEBPACK_IMPORTED_MODULE_1__UrlBuilder__["a" /* default */]();
  var url = urlBuilder.getJobsSnbUrl(selectedFilters);
  return url;
};

/**
 * Get Search Results from url and get parameters
 */
var getSearchResultsOld = function getSearchResultsOld(url, searchParams, params) {
  var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();

  var defaultParams = _extends({
    fromPwa: 1,
    aj: 1
  }, params);

  var paramString = __WEBPACK_IMPORTED_MODULE_3_form_urlencoded___default()(defaultParams);
  //Using older api for search

  if (searchParams && searchParams !== '') {
    paramString = searchParams + '&' + paramString;
  } else {
    paramString = '?' + paramString;
  }
  var apiParams = {
    url: __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.location.protocol + '//www.quikr.com' + url + paramString
  };

  return fetchHelper.request('get', apiParams);
};

var getSearchResultsPromise = function getSearchResultsPromise(searchParams) {
  var directApplyAdId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var ssr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dispatch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var cookies = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  var dispatchPromises = [];
  if (!dispatch) {
    dispatch = __WEBPACK_IMPORTED_MODULE_6__store__["b" /* default */].dispatch;
  }

  return getSearchResults(searchParams, directApplyAdId, ssr, dispatch, cookies).then(function (response) {
    var data = response.data ? response.data : {};
    var responseJson = data.json;
    var jobList = responseJson.searchResponse.jobList ? responseJson.searchResponse.jobList : [];
    var pageCount = responseJson.pwaOptions.pageCount;
    var searchCount = responseJson.searchResponse.searchCount;
    var searchComplete = pageCount * (searchParams.page - 1) + jobList.length >= searchCount;
    var showNorthEastCityFilter = responseJson.showNorthEastCityFilter;
    var isMyNorthEastCityFilter = responseJson.isMyNorthEastCityFilter;

    var companyList = responseJson.searchResponse.companyList;
    if (companyList) {
      var filters = {
        data: {
          json: {
            companies: companyList
          }
        }
      };
      dispatchPromises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_SnbContainerActions__["d" /* filterMountedAction */])(filters)));
    }

    var updatedJobs = __WEBPACK_IMPORTED_MODULE_7__utils_Context__["a" /* default */].filterJobs(jobList, false);

    var jobSearchState = {
      jobs: updatedJobs,
      page: searchParams.page + 1,
      pageCount: pageCount,
      searchCount: searchCount,
      searchComplete: searchComplete
    };

    if (responseJson.pwaOptions) {
      jobSearchState = _extends(jobSearchState, {
        dfpRepetitionIndex: responseJson.pwaOptions.dfpRepetitionIndex,
        dfpOptions: responseJson.pwaOptions.dfpOtions,
        flyingCarpetPosition: responseJson.pwaOptions.flyingCarpetPosition
      });
    }

    dispatchPromises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_SnbContainerActions__["n" /* updateNorthEastCityFilter */])({ showNorthEastCityFilter: showNorthEastCityFilter })));
    dispatchPromises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_SnbContainerActions__["l" /* toggleNorthEasthCityFilter */])({ isMyNorthEastCityFilter: isMyNorthEastCityFilter })));
    dispatchPromises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_JobSearchActions__["e" /* updateJobSearchReducer */])(jobSearchState)));
    return dispatchPromises;
  });
};

var getSearchResults = function getSearchResults(searchParams, directApplyAdId, ssr, dispatch, cookies) {
  var url = void 0;
  if (directApplyAdId) {
    searchParams.directApplyAdId = directApplyAdId;
  }
  var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();

  if (ssr) {
    url = __JOBS_BAAHUBALI_PREFIX__ + __WEBPACK_IMPORTED_MODULE_10__constants__["c" /* BASE_URL */] + __WEBPACK_IMPORTED_MODULE_10__constants__["M" /* SEARCH_API */];
  } else {
    url = __WEBPACK_IMPORTED_MODULE_10__constants__["c" /* BASE_URL */] + __WEBPACK_IMPORTED_MODULE_10__constants__["M" /* SEARCH_API */];
  }

  var apiParams = {
    url: url,
    data: __WEBPACK_IMPORTED_MODULE_3_form_urlencoded___default()(searchParams),
    includeCredentials: true
  };

  if (cookies) {
    apiParams.cookies = cookies;
  }

  return fetchHelper.request('POST', apiParams);
};

function setPageToLoadFromUrl(defaultContext) {
  defaultContext = handleAMPActions(defaultContext);

  return defaultContext;
}

function handleAMPActions(defaultContext) {
  var page = Object(__WEBPACK_IMPORTED_MODULE_4__index__["l" /* getParamFromUrl */])("page");
  if (null !== page) {
    defaultContext.page = parseInt(page);
  }

  var action = Object(__WEBPACK_IMPORTED_MODULE_4__index__["l" /* getParamFromUrl */])('ac');
  var adId = Object(__WEBPACK_IMPORTED_MODULE_4__index__["l" /* getParamFromUrl */])('adId');

  defaultContext.hideJobs = 'apply' === action && null !== adId;
  return defaultContext;
}

function getTrendingJobsFromApi(params) {
  var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();
  var apiParams = {
    params: params,
    url: '/jobs/trending'
  };
  return fetchHelper.request('GET', apiParams);
}
/**
 * @author Alabhya Vaibhav
 * Utility functions for getting the mapped subroles, keywords and present links data for similar jobs/internal links. 
 */
function getFooterLinksDataFromApi(params) {
  var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();

  if (null != params['jobType']) {
    params['jobType'] = params['jobType'].toLowerCase().split(' ').join('-');
  }

  var apiParams = {
    params: params,
    url: '/jobs/footerlink'
  };
  return fetchHelper.request('GET', apiParams);
}

/**
 * Utility function to store candidate response from emails
 */
function storeCandidateResponseViaAjax(profileId, recruiterId) {
  var data = 'profileId=' + profileId + '&recruiterId=' + recruiterId;
  var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();
  var apiParams = {
    data: data,
    url: __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.location.protocol + '//www.quikr.com/jobs' + __WEBPACK_IMPORTED_MODULE_5__constants_url__["z" /* STORE_RESPONSE_URL */]
  };
  return fetchHelper.request('POST', apiParams);
}

/**
 * @author Alabhya Vaibhav
 * Utility functions for sending  the user current location for recruiter tracking. 
 */
function sendUserLocationtoDB(params) {
  var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();
  var apiParams = {
    params: params,
    url: '/jobs/hire/userLocation'
  };
  return fetchHelper.request('POST', apiParams);
}

function fetchFaqs(cityName, roleId) {
  var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();
  var params = {
    url: '/jobs/roleFaqs',
    data: '&location=' + cityName + '&roleId=' + roleId
  };
  return fetchHelper.request('POST', params);
}

/***/ }),

/***/ "g7YX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__("J5Lc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__("O4pu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__("6C3Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__("+Sxn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__("h1zN");






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */

function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */

function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}



/***/ }),

/***/ "g9YX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),

/***/ "gEYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_window_or_global__);


var LocalStorageWrapper = {};

LocalStorageWrapper.getItem = function (key) {
  if (__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage) {
    var lsValue = __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage.getItem(key);

    if (lsValue && lsValue.type && lsValue.type === 'tempLocalStorage' && lsValue.expires) {
      if (!LocalStorageWrapper.checkExpireTime(lsValue.expires)) {
        return null;
      }
    }

    return lsValue;
  }
};

LocalStorageWrapper.setItem = function (key, value) {
  return __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage && __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage.setItem(key, value);
};

LocalStorageWrapper.removeItem = function (key) {
  return __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage && __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage.removeItem(key);
};

LocalStorageWrapper.hasKey = function (key) {
  return __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage && __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.localStorage.hasOwnProperty(key);
};

// unixTime takes a number in milliseconds as integer
LocalStorageWrapper.setExpireTime = function (key, value) {
  var unixTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!unixTime) {
    // default expire time is one hour from current time
    unixTime = new Date().getTime() + 1000 * 60 * 60;
  } else {
    unixTime = new Date().getTime() + unixTime;
  }

  value = {
    value: value,
    expires: unixTime,
    type: 'tempLocalStorage'
  };

  return LocalStorageWrapper.setItem(key, JSON.stringify(value));
};

LocalStorageWrapper.checkExpireTime = function (unixTimestamp) {
  // return false if item is expired
  return !!(unixTimestamp - new Date().getTime() > 0);
};

/* harmony default export */ __webpack_exports__["a"] = (LocalStorageWrapper);

/***/ }),

/***/ "gdjD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gwQ+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h1zN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}



/***/ }),

/***/ "hP+K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hnk3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HOME_PATH_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GUARANTEEDJOBS_PATH_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RECRUITMENT_ASSIST_LINK_PATH_REGEX; });
/* unused harmony export POSTADJOBS_REF_PATH_REGEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return VAP_PATH_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SNB_PATH_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return POST_AD_S1_PATH_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SIGN_IN_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return KOTAK_PROMO_DAILER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PREMIUM_APPLY_RENEWAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return STORE_RESPONSE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CANDIDATE_TEST_LINK_PATH_REGEX; });
/* unused harmony export GET_RECRUITER_CONTACT_DETAILS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALL_UNLOCK_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return JOBS_404; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FLEXI_CANDIDATE_REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FLEXI_CANDIDATE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FLEXI_CANDIDATE_RMT_DATA_CAPTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FLEXI_RECRUITER_RMT_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPGRADE_AD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return URL_IDENTIFIERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SNB_URL_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return URL_PATTERN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SANITIZE_URL_SEPERATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARRAY_SEPERATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PARAMETER_SEPERATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return KEYWORD_URL_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return URL_PARAMS_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return NO_INDEX_URL_IDENTIFIERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SEARCH_URL_IDENTIFIERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NOODP_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return NO_INDEX_STRING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pageLinks__ = __webpack_require__("KAG1");
var _URL_IDENTIFIERS;



/**
 * URL/Search Constants
 */

var HOME_PATH_REGEX = '/jobs';
var GUARANTEEDJOBS_PATH_REGEX = __WEBPACK_IMPORTED_MODULE_0__pageLinks__["b" /* GUARANTEEDJOBS_LINK */];
var RECRUITMENT_ASSIST_LINK_PATH_REGEX = __WEBPACK_IMPORTED_MODULE_0__pageLinks__["e" /* RECRUITMENT_ASSIST_LINK */];
var POSTADJOBS_REF_PATH_REGEX = '/jobs/post-ad-jobs-ref';
var VAP_PATH_REGEX = '/jobs/:title([a-zA-Z0-9.\\-]+)W0QQAdIdZ:id([a-zA-Z0-9]+)(.*)';
// export const VAP_PATH_REGEX = '/jobs/:title([a-zA-Z0-9.\\-]+)W0QQAdIdZ:id([a-zA-Z0-9]+):queryParams?';
var SNB_PATH_REGEX = '/jobs/:query+(zwqxj)+:identifier';
var POST_AD_S1_PATH_REGEX = __WEBPACK_IMPORTED_MODULE_0__pageLinks__["d" /* POSTAD_PAGE_LINK */];
var SIGN_IN_PAGE = '/SignIn?redirect={redirect}';
var KOTAK_PROMO_DAILER = '//www.quikr.com/jobs/pushToDailerForKotak';
var PREMIUM_APPLY_RENEWAL = '/vip-apply-renewal';
var STORE_RESPONSE_URL = '/storeCandidateResponse';
var CANDIDATE_TEST_LINK_PATH_REGEX = __WEBPACK_IMPORTED_MODULE_0__pageLinks__["a" /* CANDIATE_TEST_PAGE_LINK */];

var GET_RECRUITER_CONTACT_DETAILS = '/jobs/getRecruiterDetails';
var CALL_UNLOCK_PAYMENT = '/jobs/candidate-call-unlock-payment?packId={packId}&adId={adId}';
var JOBS_404 = '/jobs/404';
var FLEXI_CANDIDATE_REGISTER = '/jobs/flexi/register';
var FLEXI_CANDIDATE_PROFILE = '/jobs/flexi/candidate/profile/:mobile';
var FLEXI_CANDIDATE_RMT_DATA_CAPTURE = '/jobs/flexi/rmt-data-capture';
var FLEXI_RECRUITER_RMT_REPORT = '/jobs/flexi/rmt/report';
var UPGRADE_AD = '/jobs/upgrade-ad';

var URL_IDENTIFIERS = (_URL_IDENTIFIERS = {
	// 'keyword-city': '1226783897',
	//  keyword: '1519612219',
	// 'role-city': '284607247',
	// 'type-role': '57998541',
	'keyword': '1519612219',
	'keyword-city': '1226783897',

	'indexedKeyword': '2726005330',
	'indexedKeyword-city': '4157493934',

	'type-keyword': '1516423419',
	'type-keyword-city': '1953942709',
	'locality-city': '3126537171',
	'role': '1466534506',
	'role-city': '284607247',
	'role-locality-city': '3333399006',
	'role-subrole': '14665345061',
	'role-subrole-city': '2846072472',
	'role-subrole-locality-city': '33333990063',
	'type': '2363381545',
	'type-city': '2034660499',
	'type-locality-city': '3250055950',
	'type-role': '57998541',
	'type-role-city': '1452070842',
	'type-role-locality-city': '2914287049',
	'type-role-subrole': '579985411',
	'type-role-subrole-city': '14520708422',
	'type-role-subrole-locality-city': '29142870493',
	'city': '760939060',
	'salary-city': '447231107',
	'salary-locality-city': '3701154297',
	'role-salary': '1153604546',
	'role-salary-city': '3767432033',
	'role-salary-locality-city': '2654641726',
	'role-salary-subrole': '11536045461',
	'role-salary-subrole-city': '37674320332',
	'role-salary-subrole-locality-city': '26546417263',
	'type-salary-city': '2579561593',
	'type-salary-locality-city': '1451053195',
	'type-role-salary': '3349828408',
	'type-role-salary-city': '127511652',
	'type-role-salary-locality-city': '2728933051',
	'type-role-salary-subrole': '33498284081',
	'type-role-salary-subrole-city': '1275116522',
	'type-role-salary-subrole-locality-city': '27289330513',
	'experience-city': '3467090630',
	'experience-locality-city': '1453635856',
	'role-experience': '753549341',
	'role-experience-city': '1504841750',
	'role-experience-locality-city': '1559395222',
	'role-subrole-experience': '7535493411',
	'role-subrole-experience-city': '15048417502',
	'role-subrole-experience-locality-city': '15593952223',
	'type-experience-city': '1632999624',
	'type-experience-locality-city': '3353931060',
	'type-role-experience': '2199405075'
}, _URL_IDENTIFIERS['type-role-salary-subrole-locality-city'] = '3545522532', _URL_IDENTIFIERS['type-role-experience-locality-city'] = '1023845720', _URL_IDENTIFIERS['type-role-subrole-experience'] = '21994050751', _URL_IDENTIFIERS['type-role-subrole-experience-city'] = '35455225322', _URL_IDENTIFIERS['type-role-subrole-experience-locality-city'] = '10238457203', _URL_IDENTIFIERS['education-city'] = '2380404578', _URL_IDENTIFIERS['education-locality-city'] = '1558281504', _URL_IDENTIFIERS['role-education'] = '2017646763', _URL_IDENTIFIERS['role-education-city'] = '1253134185', _URL_IDENTIFIERS['role-education-locality-city'] = '177069230', _URL_IDENTIFIERS['type-education-city'] = '1979405771', _URL_IDENTIFIERS['type-education-locality-city'] = '1960431214', _URL_IDENTIFIERS['type-role-education'] = '2153486850', _URL_IDENTIFIERS['type-role-education-city'] = '3372863858', _URL_IDENTIFIERS['type-role-education-locality-city'] = '2511126896', _URL_IDENTIFIERS['salary-experience-city'] = '4253656706', _URL_IDENTIFIERS['salary-experience-locality-city'] = '2348176638', _URL_IDENTIFIERS['role-salary-experience'] = '1006492479', _URL_IDENTIFIERS['role-salary-experience-city'] = '1643533206', _URL_IDENTIFIERS['role-salary-experience-locality-city'] = '3841912454', _URL_IDENTIFIERS['type-salary-experience-city'] = '3347216058', _URL_IDENTIFIERS['type-salary-experience-locality-city'] = '3219402777', _URL_IDENTIFIERS['type-role-salary-experience'] = '32901895', _URL_IDENTIFIERS['type-role-salary-experience-city'] = '4279183568', _URL_IDENTIFIERS['type-role-salary-experience-locality-city'] = '1858474484', _URL_IDENTIFIERS['salary-education-city'] = '2697180687', _URL_IDENTIFIERS['salary-education-locality-city'] = '57694799', _URL_IDENTIFIERS['role-salary-education'] = '3630676277', _URL_IDENTIFIERS['role-salary-education-city'] = '3593472971', _URL_IDENTIFIERS['role-salary-education-locality-city'] = '3149775769', _URL_IDENTIFIERS['type-salary-education-city'] = '507658350', _URL_IDENTIFIERS['type-salary-education-locality-city'] = '2144157990', _URL_IDENTIFIERS['type-role-salary-education'] = '1726369620', _URL_IDENTIFIERS['type-role-salary-education-city'] = '1272901324', _URL_IDENTIFIERS['type-role-salary-education-locality-city'] = '3867893122', _URL_IDENTIFIERS['experience-education-city'] = '1922700911', _URL_IDENTIFIERS['experience-education-locality-city'] = '3376507071', _URL_IDENTIFIERS['role-experience-education'] = '1927661940', _URL_IDENTIFIERS['role-experience-education-city'] = '3234096138', _URL_IDENTIFIERS['role-experience-education-locality-city'] = '2203230008', _URL_IDENTIFIERS['type-salary-education-city'] = '1309196010', _URL_IDENTIFIERS['type-experience-education-locality-city'] = '2546233669', _URL_IDENTIFIERS['type-role-experience-education'] = '1316446705', _URL_IDENTIFIERS['type-role-experience-education-city'] = '3162079075', _URL_IDENTIFIERS['type-role-experience-education-locality-city'] = '1862362720', _URL_IDENTIFIERS['salary-experience-education-locality-city'] = '4127499775', _URL_IDENTIFIERS['role-salary-experience-education'] = '2777308168', _URL_IDENTIFIERS['role-salary-experience-education-city'] = '4152718827', _URL_IDENTIFIERS['role-salary-experience-education-locality-city'] = '1623919913', _URL_IDENTIFIERS['type-salary-experience-education-city'] = '1726163047', _URL_IDENTIFIERS['type-salary-experience-education-locality-city'] = '1074254920', _URL_IDENTIFIERS['type-role-salary-experience-education'] = '2614114743', _URL_IDENTIFIERS['type-role-salary-experience-education-city'] = '1225022724', _URL_IDENTIFIERS['type-role-salary-experience-education-locality-city'] = '2708908467', _URL_IDENTIFIERS['type-salary'] = '3425898827', _URL_IDENTIFIERS['type-education'] = '2641381991', _URL_IDENTIFIERS['type-experience-city'] = '3202219028', _URL_IDENTIFIERS['type-salary-experience'] = '3341090907', _URL_IDENTIFIERS['type-salary-education'] = '3107234158', _URL_IDENTIFIERS['type-experience-education'] = '3623873606', _URL_IDENTIFIERS['type-salary-experience-education'] = '2649889506', _URL_IDENTIFIERS['salary'] = '2484321137', _URL_IDENTIFIERS['salary-experience'] = '3081298699', _URL_IDENTIFIERS['salary-education'] = '1579384427', _URL_IDENTIFIERS['salary-experience-education'] = '51077540', _URL_IDENTIFIERS['experience'] = '93372675', _URL_IDENTIFIERS['experience-education'] = '1561959732', _URL_IDENTIFIERS['education'] = '3674889938', _URL_IDENTIFIERS['role-company'] = '487012953', _URL_IDENTIFIERS['role-company-city'] = '2748976742', _URL_IDENTIFIERS['salary-experience-education-city'] = '1488539096', _URL_IDENTIFIERS['companyJobs'] = '487012822', _URL_IDENTIFIERS);

var SNB_URL_STRING = 'zwqxj';

var URL_PATTERN = /[^A-Z0-9_]+/ig;
var SANITIZE_URL_SEPERATOR = '-';
var ARRAY_SEPERATOR = '_';
var PARAMETER_SEPERATOR = '+';

var GET_PARAMS = ['sort', 'company'];

var KEYWORD_URL_PARAMS = ['keyword', 'type', 'city'];

var URL_PARAMS_ORDER = ['type', 'role', 'keyword', 'indexedKeyword', 'salary', 'subrole', 'experience', 'education', 'locality', 'city', 'company'];

var NO_INDEX_URL_IDENTIFIERS = ['1519612219', '1226783897',
//'2726005330',
//'4157493934',
'1516423419', '1953942709'];

var SEARCH_URL_IDENTIFIERS = ['1519612219', '1226783897', '2726005330', '4157493934', '1516423419', '1953942709', '487012822'];

var NOODP_STRING = 'noodp';

var NO_INDEX_STRING = 'noindex';

/***/ }),

/***/ "hsyS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iXy7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ "ir2Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_list_mdc_list_scss__ = __webpack_require__("hP+K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_list_mdc_list_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_list_mdc_list_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */


/**
 * Create the component.
 */

var ListItem = function (_Component) {
  _inherits(ListItem, _Component);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ListItem.prototype.render = function render(_ref, state, context) {
    var className = _ref['class'],
        children = _ref.children,
        role = _ref.role,
        link = _ref.link,
        props = _objectWithoutProperties(_ref, ['class', 'children', 'role', 'link']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-list-item', className);
    return link ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      _extends({ 'class': classes }, props),
      children
    ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'li',
      _extends({ 'class': classes }, props, { role: role }),
      children
    );
  };

  return ListItem;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "jC5+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jvbI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__("nJPD"));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__("EW5h"));

var _TransitionGroup = _interopRequireDefault(__webpack_require__("9Szb"));

var _Transition = _interopRequireDefault(__webpack_require__("7Mlx"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),

/***/ "kNFv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kQy/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("Vr6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var FetchHelper = function () {
	function FetchHelper() {
		_classCallCheck(this, FetchHelper);
	}

	FetchHelper.prototype.request = function request(method, params) {

		var apiHeaders = {
			'Content-Type': params.isJson ? 'application/json' : 'application/x-www-form-urlencoded;charset=UTF-8'
		};
		if (typeof window.__PRELOADED_STATE__ != 'undefined' && typeof window.__PRELOADED_STATE__.webp != 'undefined' && window.__PRELOADED_STATE__.webp) {
			apiHeaders.Accept = 'application/json,text/plain.image/webp,*/*;';
		}
		var options = {
			method: method ? method : 'get',
			url: params.url,
			headers: apiHeaders,
			withCredentials: params.includeCredentials ? params.includeCredentials : false
		};

		if (params.data) {
			options.data = params.data;
		}

		return this.apiCall(options);
	};

	FetchHelper.prototype.apiCall = function apiCall(options) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default()(options);
	};

	return FetchHelper;
}();



/***/ }),

/***/ "kZEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IncludeWebsiteUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IncludeMobileNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Config__ = __webpack_require__("1QGg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Apply_ApplyCookieHelper__ = __webpack_require__("8Ery");
var _class, _temp, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * * Utility to handle include mobile number and url in post ad
 *
 * @author John Lukose <john.lukose@quikr.com>
 */




var IncludeWebsiteUrl = (_temp = _class = function IncludeWebsiteUrl() {
	_classCallCheck(this, IncludeWebsiteUrl);
}, _class.priceDetails = {
	amount: 99,
	credits: 3
}, _class.isEnabled = function (store) {
	var isEnabled = false;
	if (__WEBPACK_IMPORTED_MODULE_0__Config__["a" /* default */].hasKey('jobsPostAdMonetizationFeatureEnabledAbRandValues', store)) {
		var enabledValues = __WEBPACK_IMPORTED_MODULE_0__Config__["a" /* default */].get('jobsPostAdMonetizationFeatureEnabledAbRandValues', store);
		if ('undefined' !== typeof enabledValues && '' !== enabledValues) {
			var cookieHelper = new __WEBPACK_IMPORTED_MODULE_1__Apply_ApplyCookieHelper__["a" /* default */]();
			var abRandValue = cookieHelper.getABRandMobile();
			isEnabled = -1 !== enabledValues.indexOf(abRandValue);
		}
	}
	return isEnabled;
}, _class.getPrice = function (type) {
	return 'credit' === type ? IncludeWebsiteUrl.priceDetails.credits : IncludeWebsiteUrl.priceDetails.amount;
}, _class.setPrice = function (type, price) {
	var field = 'credit' === type ? 'credits' : 'amount';
	IncludeWebsiteUrl.priceDetails[field] = price;
}, _class.updatePrice = function (store) {
	var jobsPostAdMonetizationFeaturePrices = __WEBPACK_IMPORTED_MODULE_0__Config__["a" /* default */].get('jobsPostAdMonetizationFeaturePrices', store);
	if ('undefined' !== typeof jobsPostAdMonetizationFeaturePrices) {
		IncludeWebsiteUrl.setPrice('money', jobsPostAdMonetizationFeaturePrices.includeWebsiteUrl);
		IncludeWebsiteUrl.setPrice('credit', jobsPostAdMonetizationFeaturePrices.includeWebsiteUrlCredit);
	}
}, _temp);

var IncludeMobileNumber = (_temp2 = _class2 = function IncludeMobileNumber() {
	_classCallCheck(this, IncludeMobileNumber);
}, _class2.priceDetails = {
	amount: 99,
	credits: 3
}, _class2.isEnabled = function (store) {
	var isEnabled = false;
	if (__WEBPACK_IMPORTED_MODULE_0__Config__["a" /* default */].hasKey('jobsPostAdMonetizationFeatureEnabledAbRandValues', store)) {
		var enabledValues = __WEBPACK_IMPORTED_MODULE_0__Config__["a" /* default */].get('jobsPostAdMonetizationFeatureEnabledAbRandValues', store);
		if ('undefined' !== typeof enabledValues && '' !== enabledValues) {
			var cookieHelper = new __WEBPACK_IMPORTED_MODULE_1__Apply_ApplyCookieHelper__["a" /* default */]();
			var abRandValue = cookieHelper.getABRandMobile();
			isEnabled = -1 !== enabledValues.indexOf(abRandValue);
		}
	}
	return isEnabled;
}, _class2.getPrice = function (type) {
	return 'credit' === type ? IncludeMobileNumber.priceDetails.credits : IncludeMobileNumber.priceDetails.amount;
}, _class2.setPrice = function (type, price) {
	var field = 'credit' === type ? 'credits' : 'amount';
	IncludeMobileNumber.priceDetails[field] = price;
}, _class2.updatePrice = function (store) {
	var jobsPostAdMonetizationFeaturePrices = __WEBPACK_IMPORTED_MODULE_0__Config__["a" /* default */].get('jobsPostAdMonetizationFeaturePrices', store);
	if ('undefined' !== typeof jobsPostAdMonetizationFeaturePrices) {
		IncludeMobileNumber.setPrice('money', jobsPostAdMonetizationFeaturePrices.includeMobileNumber);
		IncludeMobileNumber.setPrice('credit', jobsPostAdMonetizationFeaturePrices.includeMobileNumberCredit);
	}
}, _temp2);

/***/ }),

/***/ "lCHb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M60.8,18.3c0.7,8.4-2.6,22.5-8.9,28.6c-1.4,1.4-3,2.5-4.7,3.4L44,44.8c-1.2-2.1-2.5-3.4-3.8-4.3c2-1.3,3.5-3.2,4.6-5.8c1.3-3.1,3.1-10.2,2.7-13.6c-0.5-3.7-3-6.7-8.8-7c-2.6-0.2-5.2,0-7.7,0.7c-2.2,0.6-4.1,1.6-5.4,2.9c-3.2,3-5.2,10.5-5.5,14.8c-0.2,3,0.2,5.3,1.3,6.8c1.9,2.8,4.9,3.1,7.9,3l2.3,0c3.6,0,6.6,0.4,9.7,5.6l3.9,6.8c2.2,3.6,2.6,4.7,7.9,4.7H65L62.6,71H49c-3.8,0-8.9-0.6-12-5.8l-4.6-7.9c-1.8-2.9-1.7-3.4-5-3.6c-3.6-0.2-7.6-0.6-9.8-1.5c-5.5-2.1-9.9-6.3-10.6-13.7c-0.2-1.9-0.1-3.9,0.1-6C7.4,30.2,8,27.3,8.6,25c1.5-6.2,3.7-11.3,7.6-15c5-4.8,12-6.7,18.6-6.9c2.6-0.1,7.1,0,10.9,0.5C53.9,4.7,60.1,9.5,60.8,18.3" });

var quikr = function quikr(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ id: "quikr", version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};
/* harmony default export */ __webpack_exports__["a"] = (quikr);

/***/ }),

/***/ "lL3/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../preact/dist/preact.js
var preact = __webpack_require__("xIV9");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// EXTERNAL MODULE: ../react-router-dom/es/index.js + 24 modules
var es = __webpack_require__("stbB");

// EXTERNAL MODULE: ../axios/index.js
var axios = __webpack_require__("Vr6w");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ../classnames/dedupe.js
var dedupe = __webpack_require__("I0+G");
var dedupe_default = /*#__PURE__*/__webpack_require__.n(dedupe);

// EXTERNAL MODULE: ../lodash.get/index.js
var lodash_get = __webpack_require__("YAz8");
var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);

// EXTERNAL MODULE: ../universal-cookie/lib/index.js
var lib = __webpack_require__("5aIp");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ../babel-plugin-forked-dual-import/importCss.js
var importCss = __webpack_require__("QHaY");
var importCss_default = /*#__PURE__*/__webpack_require__.n(importCss);

// CONCATENATED MODULE: ../q-components/components/analytics/index.js


var _class, _temp2, analytics__initialiseProps;



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var analytics__ref = Object(preact["h"])('span', { 'class': 'ga' });

var Ga = (_temp2 = _class = function (_Component) {
	_inherits(Ga, _Component);

	function Ga() {
		var _temp, _this, _ret;

		_classCallCheck(this, Ga);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), analytics__initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	}

	Ga.prototype.componentDidMount = function componentDidMount() {
		this.init(this.props.accountId, this.props.trackerName);
	};

	Ga.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.accountId !== this.props.accountId || nextProps.trackerName !== this.props.trackerName) {
			this.init(nextProps.accountId, this.props.trackerName);
		}
	};

	Ga.prototype.render = function render() {
		return analytics__ref;
	};

	return Ga;
}(preact["Component"]), analytics__initialiseProps = function _initialiseProps() {
	var _this2 = this;

	this.init = function (accountId) {
		var trackerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'quikrPWATracker';
		var _props = _this2.props,
		    qrum = _props.qrum,
		    location = _props.location,
		    match = _props.match;

		var config = typeof qrum === 'function' ? qrum(location, match) : qrum;
		// Initialize the command queue in case analytics.js hasn't loaded yet.
		window.ga = window.ga || function () {
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}

			return (ga.q = ga.q || []).push(args);
		};

		ga('create', 'UA-5568615-7', 'auto', 'quikrPWATracker');
		ga('quikrPWATracker.set', 'transport', 'beacon');

		if (accountId) {
			ga('create', accountId, 'auto', trackerName);
			ga(trackerName + '.set', 'transport', 'beacon');
		}
		Promise.all([__webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "qpa4")), importCss_default()('quikr-rum')]).then(function (proms) {
			return proms[0];
		}).then(function (loaded) {
			var quikrRUM = loaded.default;
			quikrRUM(config);
		});
		Promise.all([__webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "aBHE")), importCss_default()('q-ga')]).then(function (proms) {
			return proms[0];
		});
	};
}, _temp2);


/* harmony default export */ var analytics = (Ga);
// EXTERNAL MODULE: ../react-loadable/lib/index.js
var react_loadable_lib = __webpack_require__("EDt3");
var react_loadable_lib_default = /*#__PURE__*/__webpack_require__.n(react_loadable_lib);

// EXTERNAL MODULE: ../q-mdc/elements/material-toolbar/index.js
var material_toolbar = __webpack_require__("9kyV");

// EXTERNAL MODULE: ../q-mdc/elements/material-button/index.js
var material_button = __webpack_require__("vkp0");

// EXTERNAL MODULE: ../q-mdc/elements/material-layout-grid/index.js
var material_layout_grid = __webpack_require__("dI2S");

// EXTERNAL MODULE: ../q-mdc/elements/material-toolbar-row/index.js
var material_toolbar_row = __webpack_require__("mzEQ");

// EXTERNAL MODULE: ../q-mdc/elements/material-toolbar-section/index.js
var material_toolbar_section = __webpack_require__("XXKb");

// EXTERNAL MODULE: ../q-mdc/elements/material-toolbar-title/index.js
var material_toolbar_title = __webpack_require__("oj1I");

// EXTERNAL MODULE: ../q-mdc/elements/material-dialog/index.js
var material_dialog = __webpack_require__("a957");

// EXTERNAL MODULE: ../lodash.debounce/index.js
var lodash_debounce = __webpack_require__("alvd");
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

// EXTERNAL MODULE: ../q-components/components/icons/headerIcons/index.js + 3 modules
var headerIcons = __webpack_require__("WJAn");

// CONCATENATED MODULE: ../q-components/components/hoc/showOrHide.js


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function showOrHide__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function showOrHide__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function showOrHide__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var showOrHide_showOrHide = function showOrHide(WrappedComponent) {
	return function (_Component) {
		showOrHide__inherits(ToggleableComponent, _Component);

		function ToggleableComponent() {
			showOrHide__classCallCheck(this, ToggleableComponent);

			return showOrHide__possibleConstructorReturn(this, _Component.apply(this, arguments));
		}

		ToggleableComponent.prototype.render = function render(_ref) {
			var show = _ref.show,
			    restProps = _objectWithoutProperties(_ref, ['show']);

			return show ? Object(preact["h"])(WrappedComponent, restProps) : null;
		};

		return ToggleableComponent;
	}(preact["Component"]);
};

/* harmony default export */ var hoc_showOrHide = (showOrHide_showOrHide);
// EXTERNAL MODULE: ../q-components/components/myAccount/index.js
var myAccount = __webpack_require__("MYMf");

// CONCATENATED MODULE: ../q-components/components/icons/location/index.js



var location__ref = Object(preact["h"])(
	"g",
	null,
	Object(preact["h"])("path", { d: "M36,71c-1.45,0-2.81-0.64-3.73-1.75c-7-8.44-23.3-29.36-23.3-41.22C8.97,13.13,21.1,1,36,1s27.03,12.12,27.03,27.03 c0,11.86-16.29,32.78-23.3,41.22C38.81,70.36,37.45,71,36,71z M36,6c-12.15,0-22.03,9.88-22.03,22.03c0,8.33,11.36,25,22.03,37.89 c10.67-12.89,22.03-29.56,22.03-37.89C58.03,15.88,48.15,6,36,6z M36,36.49c-6.13,0-11.12-4.99-11.12-11.12 c0-6.13,4.99-11.12,11.12-11.12s11.12,4.99,11.12,11.12C47.12,31.51,42.13,36.49,36,36.49z M36,19.26c-3.37,0-6.12,2.74-6.12,6.12 c0,3.37,2.74,6.12,6.12,6.12s6.12-2.74,6.12-6.12C42.12,22,39.37,19.26,36,19.26z" })
);

var location_Location = function Location(props) {
	return Object(preact["h"])(
		"svg",
		{ viewBox: "0 0 72 72", "class": props.class },
		location__ref
	);
};
/* harmony default export */ var icons_location = (location_Location);
// EXTERNAL MODULE: ../q-mdc/elements/material-list/index.js
var material_list = __webpack_require__("sRYg");

// EXTERNAL MODULE: ../q-mdc/elements/material-list-item/index.js
var material_list_item = __webpack_require__("ir2Q");

// EXTERNAL MODULE: ../q-mdc/elements/material-tabs/index.js
var material_tabs = __webpack_require__("Cl+G");

// EXTERNAL MODULE: ../q-components/components/icons/searchIcons/search/index.js
var search = __webpack_require__("m1Ly");

// EXTERNAL MODULE: ../q-components/components/icons/close/index.js
var icons_close = __webpack_require__("GoGY");

// EXTERNAL MODULE: ../q-components/components/icons/headerIcons/gps/index.js
var gps = __webpack_require__("uFKd");

// EXTERNAL MODULE: ../q-components/helpers/location.js
var helpers_location = __webpack_require__("+jex");

// EXTERNAL MODULE: ../q-components/helpers/constants.js
var constants = __webpack_require__("Nukh");

// EXTERNAL MODULE: ../q-components/components/SnackBar/index.js
var SnackBar = __webpack_require__("7qZ/");

// EXTERNAL MODULE: ../q-components/components/desktop/city/index.scss
var desktop_city = __webpack_require__("2Y88");
var city_default = /*#__PURE__*/__webpack_require__.n(desktop_city);

// CONCATENATED MODULE: ../q-components/components/desktop/city/index.js


function city__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function city__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function city__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var topCityList = [{ 'name': 'Ahmedabad', id: '22' }, { 'name': 'Bangalore', id: '23' }, { 'name': 'Chandigarh', id: '24' }, { 'name': 'Chennai', id: '25' }, { 'name': 'Coimbatore', id: '26' }, { 'name': 'Delhi', id: '27' }, { 'name': 'Hyderabad', id: '28' }, { 'name': 'Kochi', id: '29' }, { 'name': 'Kolkata', id: '30' }, { 'name': 'Mumbai', id: '31' }, { 'name': 'Pune', id: '33' }, { 'name': 'Gurgaon', id: '132222' }, { 'name': 'Jaipur', id: '152222' }, { 'name': 'Lucknow', id: '162222' }, { 'name': 'Noida', id: '201301' }, { 'name': 'NaviMumbai', id: '400701' }];

var cookies = new lib_default.a();

var city__ref = Object(preact["h"])(icons_close["a" /* default */], null);

var _ref2 = Object(preact["h"])(
    'h2',
    null,
    'Select Location'
);

var _ref3 = Object(preact["h"])(gps["a" /* default */], null);

var _ref4 = Object(preact["h"])(search["a" /* default */], null);

var _ref5 = Object(preact["h"])(
    'h3',
    null,
    'Popular Cities'
);

var city_CitySelection = function (_Component) {
    city__inherits(CitySelection, _Component);

    function CitySelection(props) {
        city__classCallCheck(this, CitySelection);

        var _this = city__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleCitySearchClick = function (cityId, cityName) {
            var cityInCookie = cookies.get('new_prefer_city');
            var _this$props = _this.props,
                closePopup = _this$props.closePopup,
                searchCityCallback = _this$props.searchCityCallback,
                close = _this$props.close;
            // If the user selects same city more than once

            if (cityInCookie && cityInCookie.toLowerCase() === cityName.toLowerCase()) {
                close();
                return;
            }

            var _this$props2 = _this.props,
                g_id = _this$props2.g_id,
                match = _this$props2.match;

            g_id = g_id || 0;

            var cityCookieName = cityName === 'All India' ? 'www' : cityName.toLowerCase();

            cookies.set(constants["f" /* CITY_NAME_COOKIE_KEY */], cityCookieName, {
                path: '/',
                maxAge: constants["d" /* CITY_COOKIE_TTL */],
                domain: constants["g" /* COOKIE_DOMAIN */]
            });
            cookies.set(constants["e" /* CITY_ID_COOKIE_KEY */], cityId, {
                path: '/',
                maxAge: constants["d" /* CITY_COOKIE_TTL */],
                domain: constants["g" /* COOKIE_DOMAIN */]
            });

            if (searchCityCallback) {
                searchCityCallback(cityId, cityName, g_id, match);
            } else {
                Object(helpers_location["b" /* searchCityDefaultCallback */])(cityId, cityName, g_id, match);
            }
        };

        _this.handleDetectLocationClick = function () {
            navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
                var permissionStatus = result.state;
                if (permissionStatus === 'prompt' || permissionStatus === 'granted') {
                    Object(helpers_location["a" /* detectLocations */])(function (res) {
                        var cityId = res.cityId,
                            cityName = res.cityName;

                        _this.handleCitySearchClick(cityId, cityName);
                    }, function (err) {
                        if (err && err.code === 1) {
                            _this.snackBarMessage = 'You have blocked Quikr from using your location. To enable this, change your location settings.';
                        } else {
                            _this.snackBarMessage = 'Something went wrong. Please try again after some time.';
                        }
                        _this.setState({
                            showSnackBar: true
                        });
                    });
                } else {
                    _this.snackBarMessage = 'You have blocked Quikr from using your location. To enable this, change your location settings.';
                    _this.setState({
                        showSnackBar: true
                    });
                }
            });
        };

        _this.handleSnackBarClose = function () {
            _this.setState({
                showSnackBar: false
            });
        };

        _this.handleToggle = function (index) {
            _this.setState({
                isClicked: index
            });
        };

        _this.handleStateSelect = function (e, stateName, stateId) {
            e.preventDefault();
            cookies.set(constants["o" /* STATE_NAME_COOKIE_KEY */], stateName.toLowerCase(), {
                path: '/',
                maxAge: constants["d" /* CITY_COOKIE_TTL */],
                domain: constants["g" /* COOKIE_DOMAIN */]
            });
            cookies.set(constants["n" /* STATE_ID_COOKIE_KEY */], stateId, {
                path: '/',
                maxAge: constants["d" /* CITY_COOKIE_TTL */],
                domain: constants["g" /* COOKIE_DOMAIN */]
            });
            _this.props.searchStateCallback(stateId, stateName, _this.props.g_id, _this.props.match);
        };

        _this.renderItem = function (data, type) {
            var html = [];
            data.map(function (state) {
                if (type == 'state') {
                    html.push(Object(preact["h"])(
                        'a',
                        { href: '#', key: state.id, onClick: function onClick(e) {
                                _this.handleStateSelect(e, state.name, state.id);
                            } },
                        state.name
                    ));
                } else {
                    html.push(Object(preact["h"])(
                        'a',
                        { href: '#', key: state.id, onClick: function onClick(e) {
                                e.preventDefault();_this.handleCitySearchClick(state.id, state.name);
                            } },
                        state.name
                    ));
                }
            });
            return html;
        };

        _this.getPartialLists = function (list) {
            var columns = 4;
            var rows = list.length / columns;
            var partialList = [];
            for (var i = 0; i < columns; i++) {
                partialList[i] = list.slice(i * rows, rows * (i + 1));
            }
            return partialList;
        };

        _this.state = {
            isClicked: 0,
            showSnackBar: false
        };
        return _this;
    }

    CitySelection.prototype.render = function render(props) {
        var _this2 = this;

        var _props$stateList = props.stateList,
            stateList = _props$stateList === undefined ? null : _props$stateList,
            _props$cityList = props.cityList,
            cityList = _props$cityList === undefined ? topCityList : _props$cityList,
            _props$results = props.results,
            results = _props$results === undefined ? [] : _props$results,
            handleSearch = props.handleSearch,
            close = props.close;

        if (cityList.length > 0 || results.length > 0) {
            var partialStateLists = stateList ? this.getPartialLists(stateList) : null;
            var partialCityList = results.length > 0 ? results : this.getPartialLists(cityList);
            var allIndiaItem = void 0;
            return Object(preact["h"])(
                'div',
                null,
                Object(preact["h"])(
                    'header',
                    { 'class': 'mdc-dialog__header' },
                    Object(preact["h"])(
                        'span',
                        { 'class': 'close-dialog', onClick: close, title: 'Close' },
                        city__ref
                    ),
                    _ref2,
                    Object(preact["h"])(
                        'span',
                        { 'class': 'navigation', title: 'Detect', onClick: this.handleDetectLocationClick },
                        'DETECT ',
                        _ref3
                    )
                ),
                Object(preact["h"])(
                    material_tabs["a" /* default */],
                    null,
                    Object(preact["h"])(
                        material_tabs["a" /* default */].Tab,
                        { active: true, onClick: function onClick(e) {
                                return _this2.handleToggle(0);
                            } },
                        'City'
                    ),
                    stateList && Object(preact["h"])(
                        material_tabs["a" /* default */].Tab,
                        { onClick: function onClick(e) {
                                return _this2.handleToggle(1);
                            } },
                        'States'
                    )
                ),
                Object(preact["h"])(
                    material_dialog["a" /* default */].Body,
                    { scrollable: false },
                    Object(preact["h"])(
                        'div',
                        { 'class': 'tab-content ' + (this.state.isClicked === 0 ? 'active' : '') },
                        Object(preact["h"])(
                            'div',
                            { 'class': 'city-dialog__search' },
                            _ref4,
                            Object(preact["h"])('input', { type: 'text', 'class': 'city-dialog__search--field', onkeyup: handleSearch, placeholder: 'Search for your City' })
                        ),
                        results.length > 0 ? Object(preact["h"])(
                            material_list["a" /* default */],
                            null,
                            Object(preact["h"])(
                                material_list_item["a" /* default */],
                                null,
                                results.map(function (item) {
                                    if (item.cityId && item.cityName) {
                                        if (item.cityId == 0 || item.cityId == 1) {
                                            allIndiaItem = [Object(preact["h"])(
                                                'a',
                                                { href: '#', key: item.cityId, onClick: function onClick(e) {
                                                        e.preventDefault();_this2.handleCitySearchClick(item.cityId, item.cityName);
                                                    } },
                                                item.cityName
                                            )];
                                        } else {
                                            return Object(preact["h"])(
                                                'a',
                                                { href: '#', key: item.cityId, onClick: function onClick(e) {
                                                        e.preventDefault();_this2.handleCitySearchClick(item.cityId, item.cityName);
                                                    } },
                                                item.cityName
                                            );
                                        }
                                    } else if (item.id && item.name) {
                                        if (item.id == 0 || item.id == 1) {
                                            allIndiaItem = [Object(preact["h"])(
                                                'a',
                                                { href: '#', key: item.id, onClick: function onClick(e) {
                                                        e.preventDefault();_this2.handleCitySearchClick(item.id, item.name);
                                                    } },
                                                item.name
                                            )];
                                        } else {
                                            return Object(preact["h"])(
                                                'a',
                                                { href: '#', key: item.id, onClick: function onClick(e) {
                                                        e.preventDefault();_this2.handleCitySearchClick(item.id, item.name);
                                                    } },
                                                item.name
                                            );
                                        }
                                    }
                                }),
                                allIndiaItem
                            )
                        ) : Object(preact["h"])(
                            'div',
                            null,
                            _ref5,
                            Object(preact["h"])(
                                material_list["a" /* default */],
                                null,
                                partialCityList.map(function (cityList) {
                                    return Object(preact["h"])(
                                        material_list_item["a" /* default */],
                                        null,
                                        _this2.renderItem(cityList, 'city')
                                    );
                                })
                            )
                        )
                    ),
                    stateList && Object(preact["h"])(
                        'div',
                        { 'class': 'tab-content ' + (this.state.isClicked === 1 ? 'active' : '') },
                        Object(preact["h"])(
                            material_list["a" /* default */],
                            null,
                            partialStateLists.map(function (stateList, i) {
                                return Object(preact["h"])(
                                    material_list_item["a" /* default */],
                                    null,
                                    _this2.renderItem(stateList, 'state')
                                );
                            })
                        )
                    )
                ),
                this.state.showSnackBar && Object(preact["h"])(SnackBar["a" /* default */], {
                    text: this.snackBarMessage,
                    active: true,
                    timeout: 5000,
                    onClose: this.handleSnackBarClose,
                    children: Object(preact["h"])(
                        'a',
                        { onClick: this.handleSnackBarClose },
                        'CLOSE'
                    )
                })
            );
        }
    };

    return CitySelection;
}(preact["Component"]);

/* harmony default export */ var components_desktop_city = (city_CitySelection);
// EXTERNAL MODULE: ../q-components/helpers/ga.js
var helpers_ga = __webpack_require__("ZDZs");

// EXTERNAL MODULE: ../q-components/helpers/index.js
var helpers = __webpack_require__("5j+z");

// CONCATENATED MODULE: ../q-components/helpers/userAgent.js
var isAndroid = function isAndroid(userAgent) {
  return userAgent.match(/Android/i);
};

var isIphone = function isIphone(userAgent) {
  return userAgent.match(/iPhone/i);
};
// EXTERNAL MODULE: ../q-mdc/quikr/core/customDialog/index.js
var customDialog = __webpack_require__("rZFj");

// CONCATENATED MODULE: ../q-components/components/icons/headerIcons/addToHomeScreen/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var addToHomeScreen__ref = Object(preact["h"])("path", { d: "M0,13.1242676 L1,13.1242676 L1,14 C1,14.5522847 1.44771525,15 2,15 L10,15 C10.5522847,15 11,14.5522847 11,14 L11,2 C11,1.44771525 10.5522847,1 10,1 L2,1 C1.44771525,1 1,1.44771525 1,2 L1,3.05566406 L0,3.05566406 L0,2 C0,0.8954305 0.8954305,2.22044605e-16 2,0 L10,0 C11.1045695,-2.22044605e-16 12,0.8954305 12,2 L12,14 C12,15.1045695 11.1045695,16 10,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,13.1242676 Z M11,14 L11,2 L1,2 L1,3.05566406 L0,3.05566406 L0,2 C0,0.8954305 0.8954305,2.22044605e-16 2,0 L10,0 C11.1045695,-2.22044605e-16 12,0.8954305 12,2 L12,14 C12,15.1045695 11.1045695,16 10,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,13.1242676 L1,13.1242676 L1,14 L11,14 Z", id: "Rectangle-7", "fill-rule": "nonzero" });

var addToHomeScreen__ref2 = Object(preact["h"])("polygon", { id: "Path", points: "4.66666667 9.66666667 6 9.66666667 6 5 1.33333333 5 1.33333333 6.33333333 3.72666667 6.33333333 0 10.06 0.94 11 4.66666667 7.27333333" });

var addToHomeScreen_AddToHomeScreen = function AddToHomeScreen(props) {
	return Object(preact["h"])(
		"svg",
		_extends({ viewBox: "0 0 20 20" }, props),
		addToHomeScreen__ref,
		addToHomeScreen__ref2
	);
};
/* harmony default export */ var addToHomeScreen = (addToHomeScreen_AddToHomeScreen);
// CONCATENATED MODULE: ../q-components/components/icons/headerIcons/arrowATH/index.js



var arrowATH__ref = Object(preact["h"])("path", { d: "M7.1,200.9l-2.9-6.4c0.3-0.1,30.5-13.9,61.4-43.5c18.1-17.3,32.8-36.7,43.8-57.5c12.8-24.2,20.6-50.6,23.2-78.3l-26.1,17.1 l-3.8-5.9L138.6,3l22.4,36l-5.9,3.7l-15.6-25c-6.6,65.9-40.9,111.6-69.1,138.7C38.6,186.7,8.4,200.4,7.1,200.9z" });

/* harmony default export */ var arrowATH = (function (props) {
  return Object(preact["h"])(
    "svg",
    { viewBox: "0 0 170.2 209.2", "enable-background": "new 0 0 170.2 209.2", "class": props.class },
    arrowATH__ref
  );
});
// CONCATENATED MODULE: ../q-components/components/addToHomescreen/index.js


function addToHomescreen__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function addToHomescreen__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function addToHomescreen__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var addToHomescreen__ref = Object(preact["h"])(addToHomeScreen, { 'class': 'icon' });

var addToHomescreen__ref2 = Object(preact["h"])(arrowATH, { 'class': 'up-arrow' });

var addToHomescreen__ref3 = Object(preact["h"])(
	'h3',
	null,
	'Add Quikr Lite to Homescreen'
);

var addToHomescreen__ref4 = Object(preact["h"])(
	'p',
	null,
	'Select ',
	Object(preact["h"])(
		'span',
		null,
		'Add to homescreen'
	),
	' from browser more menu ',
	Object(preact["h"])(
		'em',
		null,
		'\u2026'
	),
	' to pin the Quikr lite web app'
);

var addToHomescreen__default = function (_Component) {
	addToHomescreen__inherits(_default, _Component);

	function _default() {
		var _temp, _this, _ret;

		addToHomescreen__classCallCheck(this, _default);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = addToHomescreen__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleAddToHomeScreen = function (e) {
			var gaEventObject = {
				category: 'quikr_pwa',
				action: 'quikr_pwa_addtohomescreen',
				label: 'quikr_pwa_addtohomescreen_click'
			};
			Object(helpers_ga["a" /* getEventTrackGA */])(gaEventObject);
			if (_this.prompt) {
				_this.prompt.prompt();
				_this.prompt.userChoice.then(function (choiceResult) {
					if (choiceResult.outcome === 'accepted') {
						Object(helpers_ga["a" /* getEventTrackGA */])({
							category: 'quikr_pwa',
							action: 'quikr_pwa_addtohomescreen',
							label: 'quikr_pwa_addtohomescreen_success'
						});
					} else {
						Object(helpers_ga["a" /* getEventTrackGA */])({
							category: 'quikr_pwa',
							action: 'quikr_pwa_addtohomescreen',
							label: 'quikr_pwa_addtohomescreen_failure'
						});
					}
				});
			} else {
				_this.setState({
					showDialog: true
				});
			}
		}, _this.handleDialogClose = function () {
			_this.setState({
				showDialog: false
			});
		}, _temp), addToHomescreen__possibleConstructorReturn(_this, _ret);
	}

	_default.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		window.addEventListener('beforeinstallprompt', function (e) {
			e.preventDefault();
			_this2.prompt = e;
		});

		setTimeout(function () {
			_this2.setState({
				addAnimation: true
			});
		}, 1500);
	};

	_default.prototype.render = function render() {
		var _state = this.state,
		    showDialog = _state.showDialog,
		    addAnimation = _state.addAnimation;


		return Object(preact["h"])(
			'div',
			null,
			Object(preact["h"])(
				'a',
				{ onClick: this.handleAddToHomeScreen, 'class': 'mdc-toolbar__icon add-to__icon ' + (addAnimation && 'icon-highlight') },
				addToHomescreen__ref
			),
			Object(preact["h"])(customDialog["a" /* default */], {
				className: 'trasparent-dialog',
				full: true,
				showDialog: showDialog,
				body: Object(preact["h"])(
					'div',
					{ 'class': 'dialog-content' },
					addToHomescreen__ref2,
					addToHomescreen__ref3,
					addToHomescreen__ref4,
					Object(preact["h"])(
						material_button["a" /* default */],
						{ compact: true, dense: true, onClick: this.handleDialogClose },
						'GOT IT'
					)
				)
			})
		);
	};

	return _default;
}(preact["Component"]);


// EXTERNAL MODULE: ../q-components/components/icons/searchIcons/index.js + 2 modules
var searchIcons = __webpack_require__("c2AY");

// EXTERNAL MODULE: ../q-components/hoc/mediaQuery/index.js
var mediaQuery = __webpack_require__("KvVG");

// EXTERNAL MODULE: ../q-components/components/icons/drawerIcons/wallet/index.js
var drawerIcons_wallet = __webpack_require__("q78h");

// EXTERNAL MODULE: ../q-components/components/search/index.scss
var components_search = __webpack_require__("/5uS");
var search_default = /*#__PURE__*/__webpack_require__.n(components_search);

// CONCATENATED MODULE: ../q-components/components/search/index.js



function search__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function search__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function search__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















// import Popup from '../pageLayer';


var axiosInstance = axios_default.a.create({
	baseURL: 'https://www.quikr.com/',
	timeout: 1000,
	headers: {
		accept: 'application/json, text/javascript, */*; q=0.01',
		'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
		'Content-Type': 'application/x-www-form-urlencoded',
		'X-Requested-With': 'XMLHttpRequest'
	}
});

var search__ref = Object(preact["h"])('div', null);

var LoadableSearchPopup = react_loadable_lib_default()({
	loader: function loader() {
		return Promise.all([__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "xOwW")), importCss_default()('searchPopup')]).then(function (proms) {
			return proms[0];
		});
	},
	loading: function loading() {
		return search__ref;
	},
	render: function render(loaded, props) {
		var SearchPopup = loaded.default;
		return Object(preact["h"])(SearchPopup, props);
	}
});

var search_cookies = new lib_default.a();

var search__ref2 = Object(preact["h"])(drawerIcons_wallet["a" /* default */], { 'class': 'action-box__icons' });

var search__ref3 = Object(preact["h"])(
	'i',
	{ 'class': 'badge' },
	Object(preact["h"])(drawerIcons_wallet["a" /* default */], { 'class': 'action-box__icons' })
);

var search__ref4 = Object(preact["h"])(
	'span',
	{ 'class': 'search-btn' },
	Object(preact["h"])(searchIcons["b" /* Search */], { 'class': 'toolbar-search__icon' })
);

var search_Search = function (_Component) {
	search__inherits(Search, _Component);

	function Search(props) {
		search__classCallCheck(this, Search);

		var _this = search__possibleConstructorReturn(this, _Component.call(this, props));

		_this.getWalletListener = function () {
			document.body.addEventListener("apiCall", function () {
				if (!_this.state.walletCall) {
					_this.getWalletBalance();
				}
			});
		};

		_this.getWalletBalance = function () {
			_this.setState({ 'walletCall': true });
			var _this$props$wallet = _this.props.wallet,
			    wallet = _this$props$wallet === undefined ? true : _this$props$wallet;

			if (wallet) {
				axiosInstance.get('https://www.quikr.com/core/quikrcom/pwa_api/get-wallet-balance').then(function (res) {
					if (res.status === 200) {
						var amount = res.data.walletBalance;
						_this.setState({
							walletBalance: amount
						});
						_this.props.updateWalletBalance(amount);
						if (res.data.walletBalance != -1) {
							_this.setState({
								showBalance: true
							});
						}
					}
				}).catch(function (e) {});
			}
		};

		_this.getPageTypeFromProps = function () {
			var getPageType = _this.props.getPageType;

			if (typeof getPageType === 'function' && typeof window !== 'undefined') {
				return getPageType();
			}
			return 'other';
		};

		_this.showPopup = function () {
			_this.setState({
				popup: true,
				backdrop: false
			});
			var pageType = _this.getPageTypeFromProps();
			var gaEventObject = { category: 'quikr_pwa', action: 'quikr_pwa_' + pageType + '_search', label: 'quikr_pwa_' + pageType + '_search_focus' };
			Object(helpers_ga["a" /* getEventTrackGA */])(gaEventObject);
		};

		_this.closePopup = function () {
			_this.setState({
				popup: false,
				backdrop: true
			});
		};

		_this.handleInput = function (event) {
			if (_this.searchPopupRef) {
				// console.log("searchpopupref ", this.searchPopupRef._component.setValueAndSearch);
				_this.searchPopupRef._component.setValueAndSearch(event);
			}
		};

		_this.getPlaceholder = function () {
			var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Search';
			return prefix + ' In ' + Object(helpers["b" /* getCurrentCity */])();
		};

		_this.getpPerformanceFromProps = function () {
			var pPerformance = _this.props.pPerformance;

			if (typeof pPerformance !== 'undefined') {
				return pPerformance;
			}
			return false;
		};

		_this.getsearchtermFromProps = function () {
			var searchterm = _this.props.searchterm;

			if (typeof searchterm === 'function') {
				return searchterm();
			}
			return "";
		};

		_this.redirectToWalletPage = function () {
			var abRand = search_cookies.get(constants["a" /* ABRAND_COOKIE_KEY */]) || Math.random() * 100;
			if (Number(abRand) <= constants["r" /* WALLET_REDIRECTION_CONSTANT */]) {
				window.location.href = 'https://www.quikr.com/wallet';
			} else {
				window.location.href = 'https://www.quikr.com/Escrow/MyOffers/cashbalance';
			}
		};

		_this.renderWallet = function () {
			var isLoggedIn = _this.props.userInfo && _this.props.userInfo.loggedIn;
			var state = _this.state;

			var className = void 0;
			if (_this.state.walletBalance != -1) {
				className = '₹' + state.walletBalance;
			}
			return isLoggedIn && state.showBalance ? Object(preact["h"])(
				'aside',
				{ onClick: function onClick(e) {
						return _this.redirectToWalletPage();
					} },
				Object(preact["h"])(
					'i',
					{ 'class': 'badge', 'data-badge': className },
					search__ref2
				)
			) : Object(preact["h"])(
				'aside',
				{ onClick: function onClick(e) {
						return _this.redirectToWalletPage();
					} },
				search__ref3
			);
		};

		_this.doWalletCall = function () {
			if (_this.getpPerformanceFromProps()) {
				_this.getWalletListener();
			} else {
				var self = _this;
				setTimeout(function () {
					self.getWalletBalance();
				}, 5000);
			}
		};

		_this.state = {
			popup: false,
			walletBalance: 0,
			showBalance: false,
			walletCall: false,
			backdrop: true
		};
		return _this;
	}

	Search.prototype.componentDidMount = function componentDidMount() {
		this.doWalletCall();
	};

	/**
 * This method is called whenever the props or state changes
 * @return {Object} Context of child components
 */
	Search.prototype.getChildContext = function getChildContext() {
		var context = {};
		context.pageType = this.getPageTypeFromProps();
		return context;
	};

	Search.prototype.render = function render(props, state, context) {
		var _this2 = this;

		var _props$placeholder = props.placeholder,
		    placeholder = _props$placeholder === undefined ? this.getPlaceholder() : _props$placeholder,
		    onSearchCallback = props.onSearchCallback,
		    searchSuggestions = props.searchSuggestions,
		    onSearchSubmit = props.onSearchSubmit,
		    onRecentSearchClick = props.onRecentSearchClick,
		    onTrendingSearchClick = props.onTrendingSearchClick,
		    showTrendingSearches = props.showTrendingSearches,
		    showRecentSearches = props.showRecentSearches,
		    showDefaultSuggestion = props.showDefaultSuggestion,
		    _props$wallet = props.wallet,
		    wallet = _props$wallet === undefined ? true : _props$wallet;

		var searchterm = this.getsearchtermFromProps();
		var popup = state.popup;


		return Object(preact["h"])(
			'div',
			null,
			Object(preact["h"])(
				'div',
				{ 'class': 'toolbar-search__wrapper' },
				Object(preact["h"])(
					'form',
					{ 'class': 'toolbar-search' },
					Object(preact["h"])(
						'div',
						{ 'class': 'toolbar-search__child' },
						search__ref4,
						Object(preact["h"])(
							mediaQuery["a" /* default */],
							{ minWidth: 840, className: 'toolbar-search__box-desk' },
							Object(preact["h"])('input', { 'aria-label': 'search-box', 'class': 'toolbar-search__field', type: 'text', placeholder: searchterm !== "" ? searchterm : placeholder, onClick: this.showPopup, onInput: this.handleInput })
						),
						Object(preact["h"])(
							mediaQuery["a" /* default */],
							{ maxWidth: 840, className: 'toolbar-search__box' },
							Object(preact["h"])('input', { 'aria-label': 'search-box', 'class': 'toolbar-search__field', type: 'text', placeholder: searchterm !== "" ? searchterm : placeholder, onClick: this.showPopup })
						),
						Object(preact["h"])(
							mediaQuery["a" /* default */],
							{ maxWidth: 840, className: 'action-box' },
							wallet && this.renderWallet()
						)
					)
				),
				popup && Object(preact["h"])(LoadableSearchPopup, {
					ref: function ref(_ref5) {
						_this2.searchPopupRef = _ref5;
					},
					show: true,
					closePopup: this.closePopup,
					placeholder: placeholder,
					onSearchCallback: onSearchCallback,
					searchSuggestions: searchSuggestions,
					onSearchSubmit: onSearchSubmit,
					onRecentSearchClick: onRecentSearchClick,
					onTrendingSearchClick: onTrendingSearchClick,
					showRecentSearches: showRecentSearches,
					showTrendingSearches: showTrendingSearches,
					showDefaultSuggestion: showDefaultSuggestion
				})
			),
			!this.state.backdrop && Object(preact["h"])('div', { 'class': 'suggester-overlay', onClick: this.closePopup })
		);
	};

	return Search;
}(preact["Component"]);

/* harmony default export */ var q_components_components_search = (hoc_showOrHide(search_Search));
// EXTERNAL MODULE: ../q-components/components/SwitchBanner/SwitchBanner.scss
var SwitchBanner_SwitchBanner = __webpack_require__("oqC1");
var SwitchBanner_default = /*#__PURE__*/__webpack_require__.n(SwitchBanner_SwitchBanner);

// CONCATENATED MODULE: ../q-components/components/SwitchBanner/SwitchBanner.js


function SwitchBanner__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SwitchBanner__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SwitchBanner__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import Close from "../icons/close";



var SwitchBanner_SwitchBanner_SwitchBanner = function (_Component) {
  SwitchBanner__inherits(SwitchBanner, _Component);

  function SwitchBanner(props) {
    SwitchBanner__classCallCheck(this, SwitchBanner);

    var _this = SwitchBanner__possibleConstructorReturn(this, _Component.call(this, props));

    _this.fireGa = function (action) {
      var gaEventObject = {
        category: _this.props.pageType + "_" + _this.props.category,
        label: "switch_banner_" + action,
        action: _this.props.subcategory + "_" + _this.props.city
      };

      Object(helpers_ga["a" /* getEventTrackGA */])(gaEventObject);
    };

    _this.handleLinkClick = function () {
      _this.fireGa("clicked");
      setTimeout(function () {
        window.location.href = "https://www.quikr.com/quikrplus/agent";
      }, 300);
    };

    _this.state = {
      hide: false
    };
    return _this;
  }

  // closeClick = (e) => {
  //   e.stopPropagation();
  //   this.setState({ hide: true });
  //   this.fireGa("closed");
  // };

  SwitchBanner.prototype.render = function render() {
    return Object(preact["h"])(
      "div",
      { className: "switchbanner-root " + (this.state.hide ? "hide" : "") },
      Object(preact["h"])(
        "button",
        { onClick: this.handleLinkClick, type: "button" },
        "Switch to Quikr AI"
      )
    );
  };

  return SwitchBanner;
}(preact["Component"]);

/* harmony default export */ var components_SwitchBanner_SwitchBanner = (SwitchBanner_SwitchBanner_SwitchBanner);
// EXTERNAL MODULE: ../@material/typography/mdc-typography.scss
var mdc_typography = __webpack_require__("Ux8J");
var mdc_typography_default = /*#__PURE__*/__webpack_require__.n(mdc_typography);

// EXTERNAL MODULE: ../q-components/components/header/index.scss
var header = __webpack_require__("gwQ+");
var header_default = /*#__PURE__*/__webpack_require__.n(header);

// CONCATENATED MODULE: ../q-components/components/header/index.js


var header__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















// import Hamburger from '../hamburger';




// import Close from '../icons/close';

















var header_cookies = new lib_default.a();

var header__ref = Object(preact["h"])('div', null);

var header_LoadableSearchPopup = react_loadable_lib_default()({
	loader: function loader() {
		return Promise.all([__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "u11Z")), importCss_default()('city')]).then(function (proms) {
			return proms[0];
		});
	},
	loading: function loading() {
		return header__ref;
	},
	render: function render(loaded, props) {
		var CitySearchPopup = loaded.default;
		return Object(preact["h"])(CitySearchPopup, props);
	}
});

var header__ref2 = Object(preact["h"])('div', null);

var LoadableNotificationPopup = react_loadable_lib_default()({
	loader: function loader() {
		return Promise.all([__webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "QjlT")), importCss_default()('notification')]).then(function (proms) {
			return proms[0];
		});
	},
	loading: function loading() {
		return header__ref2;
	},
	render: function render(loaded, props) {
		var NotificationPopup = loaded.default;
		return Object(preact["h"])(NotificationPopup, props);
	}
});

var header__ref3 = Object(preact["h"])('div', null);

var LoadableHamburger = react_loadable_lib_default()({
	loader: function loader() {
		return Promise.all([__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "bbdc")), importCss_default()('hamburger')]).then(function (proms) {
			return proms[0];
		});
	},
	loading: function loading() {
		return header__ref3;
	},
	render: function render(loaded, props) {
		var Hamburger = loaded.default;
		return Object(preact["h"])(Hamburger, props);
	}
});

var header__ref4 = Object(preact["h"])('div', null);

var LoadableMarketTalkButton = react_loadable_lib_default()({
	loader: function loader() {
		return Promise.all([__webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "TRJT")), importCss_default()('MarketTalkButton')]).then(function (proms) {
			return proms[0];
		});
	},
	loading: function loading() {
		return header__ref4;
	},
	render: function render(loaded, props) {
		var MarketTalkButton = loaded.default;
		return Object(preact["h"])(MarketTalkButton, props);
	}
});

var header__ref5 = Object(preact["h"])('div', null);

var LoadableViewinAppFAB = react_loadable_lib_default()({
	loader: function loader() {
		return Promise.all([__webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "sD/K")), importCss_default()('FloatingActionButton')]).then(function (proms) {
			return proms[0];
		});
	},
	loading: function loading() {
		return header__ref5;
	},
	render: function render(loaded, props) {
		var ViewinAppFAB = loaded.default;
		return Object(preact["h"])(ViewinAppFAB, props);
	}
});

var _ref6 = Object(preact["h"])('div', null);

var LoadableQkrAppWidget = react_loadable_lib_default()({
	loader: function loader() {
		return Promise.all([__webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "uyZJ")), importCss_default()('QkrAppWidget')]).then(function (proms) {
			return proms[0];
		});
	},
	loading: function loading() {
		return _ref6;
	},
	render: function render(loaded, props) {
		var QkrAppWidget = loaded.default;
		return Object(preact["h"])(QkrAppWidget, props);
	}
});

var _ref7 = Object(preact["h"])(LoadableMarketTalkButton, null);

var _ref8 = Object(preact["h"])(headerIcons["d" /* Menu */], { 'class': 'mdc-toolbar__icons' });

var _ref9 = Object(preact["h"])(headerIcons["b" /* Back */], { 'class': 'mdc-toolbar__icons' });

var _ref10 = Object(preact["h"])(headerIcons["e" /* Quikr */], { 'class': 'mdc-toolbar__icons' });

var _ref11 = Object(preact["h"])(
	'span',
	{ 'class': 'link-text-hidden' },
	'Quikr'
);

var _ref12 = Object(preact["h"])(
	'i',
	{ 'class': 'location' },
	Object(preact["h"])(icons_location, null)
);

var _ref13 = Object(preact["h"])('i', { 'class': 'mdc-toolbar__arrow' });

var header_Header = function (_Component) {
	header__inherits(Header, _Component);

	function Header(props) {
		header__classCallCheck(this, Header);

		var _this = header__possibleConstructorReturn(this, _Component.call(this, props));

		_this.checkLocationStatus = function () {
			if (!navigator.geolocation) {
				return false;
			}
			if (!navigator.permissions) {
				return false;
			}
			navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
				var _this$props = _this.props,
				    searchCityCallback = _this$props.searchCityCallback,
				    _this$props$g_id = _this$props.g_id,
				    g_id = _this$props$g_id === undefined ? 0 : _this$props$g_id,
				    match = _this$props.match;


				if (result.state === 'prompt') {
					Object(helpers_location["a" /* detectLocations */])(function (res) {
						Object(helpers_ga["a" /* getEventTrackGA */])({ category: 'quikr_pwa', action: 'location_permission', label: 'allowed' });
						var cityId = res.cityId,
						    cityName = res.cityName;


						header_cookies.set('new_prefer_city', cityName, {
							path: '/',
							maxAge: constants["d" /* CITY_COOKIE_TTL */],
							domain: constants["g" /* COOKIE_DOMAIN */]
						});
						header_cookies.set('prefer_city_id', cityId, {
							path: '/',
							maxAge: constants["d" /* CITY_COOKIE_TTL */],
							domain: constants["g" /* COOKIE_DOMAIN */]
						});

						if (typeof searchCityCallback === 'function') {
							searchCityCallback(cityId, cityName, g_id, match);
						} else {
							Object(helpers_location["b" /* searchCityDefaultCallback */])(cityId, cityName, g_id, match);
						}
					}, function (err) {
						if (err && err.code === 1) {
							// User denied the permission
							Object(helpers_ga["a" /* getEventTrackGA */])({ category: 'quikr_pwa', action: 'location_permission', label: 'denied' });
						}
					});
				}
			});
		};

		_this.getPageTypeFromProps = function () {
			var getPageType = _this.props.getPageType;

			if (typeof getPageType === 'function' && typeof window !== 'undefined') {
				return getPageType();
			}
			return 'other';
		};

		_this.redirectToPostAd = function (e) {
			var pageType = _this.getPageTypeFromProps();
			var gaEventObject = { category: 'quikr_pwa', action: 'quikr_pwa_' + pageType + '_postad', label: 'quikr_pwa_' + pageType + '_postad_click' };
			Object(helpers_ga["a" /* getEventTrackGA */])(gaEventObject);
			window.location = 'http://' + window.location.host + '/post-classifieds-ads';
		};

		_this.setCityAndSearch = function (event) {
			var value = event.target.value;

			_this.setState({
				topCitiesList: false,
				value: value
			});
			_this.debouncedHandleCitySearch(event);
		};

		_this.updateCityList = function (cityList) {
			_this.setState({
				results: cityList,
				err: null
			});
		};

		_this.handleCitySearch = function (event) {
			var value = event.target.value;


			if (value === '') {
				_this.setState({
					results: [],
					topCitiesList: true
				});
				return;
			}

			if (_this.props.citySearchCallBack) {
				_this.props.citySearchCallBack(value, _this.updateCityList);
				return;
			}

			var hostname = 'www.quikr.com';
			if (window && window.location && window.location.hostname) {
				hostname = window.location.hostname;
			}

			var _this$props$internati = _this.props.international,
			    international = _this$props$internati === undefined ? false : _this$props$internati;

			var params = new URLSearchParams();
			params.append('keyword', value);
			params.append('abroad', international);

			axios_default.a.post('https://feservices.quikr.com/v2/header/suggest_cities_json', params, {
				accept: 'application/json, text/javascript, */*; q=0.01',
				'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
				'Content-Type': 'application/x-www-form-urlencoded'
			}).then(function (res) {
				if (res.status === 200) {
					_this.setState({
						results: res.data,
						err: null
					});
				} else {
					_this.setState({
						results: [],
						err: 'Something went wrong'
					});
				}
			}).catch(function (err) {
				_this.setState({
					err: err,
					results: []
				});
			});
		};

		_this.showCityPopup = function () {
			if (_this.props.cityModal && window.innerWidth >= 780) {
				_this.cityDialog.MDComponent.show();
			} else {
				_this.setState({
					cityPopup: true,
					topCitiesList: true
				});
				var pageType = _this.getPageTypeFromProps();
				var gaEventObject = { category: 'quikr_pwa', action: 'quikr_pwa_' + pageType + '_cityselection', label: 'quikr_pwa_' + pageType + '_cityselection_click' };
				Object(helpers_ga["a" /* getEventTrackGA */])(gaEventObject);
			}
		};

		_this.closeCityPopup = function () {
			_this.setState({
				cityPopup: false,
				value: null,
				results: [],
				err: null
			});
		};

		_this.closeNotificationPopup = function () {
			_this.setState({
				notificationPopup: false
			});
		};

		_this.openNotificationPopup = function () {
			_this.setState({
				notificationPopup: true
			});
		};

		_this.callHeaderfunction = function (headerfunction) {
			_this[headerfunction]();
		};

		_this.openHamburger = function (e) {
			e.preventDefault();
			e.stopPropagation();
			e.nativeEvent.stopImmediatePropagation();
			_this.setState({
				drawerOpen: true
			});
			var pageType = _this.getPageTypeFromProps();
			var gaEventObject = { category: 'quikr_pwa', action: 'quikr_pwa_' + pageType + '_hamburger', label: 'quikr_pwa_' + pageType + '_hamburger_click' };
			Object(helpers_ga["a" /* getEventTrackGA */])(gaEventObject);
		};

		_this.closeHamburger = function () {
			_this.setState({
				drawerOpen: false
			});
		};

		_this.handleBackOnClick = function (e) {
			var _this$props2 = _this.props,
			    handleBackClick = _this$props2.handleBackClick,
			    match = _this$props2.match;
			var history = _this.context.router.history;

			if (handleBackClick) {
				handleBackClick(e, history, match);
			} else {
				history.goBack();
			}
		};

		_this.shouldDisplayAddToHomeScreen = function () {
			if (typeof navigator !== "undefined") {
				var userAgent = lodash_get_default()(navigator, 'userAgent', '');
				if (!isAndroid(userAgent)) {
					return false;
				}
			}

			var _this$state$showAddto = _this.state.showAddtoHomeScreen,
			    showAddtoHomeScreen = _this$state$showAddto === undefined ? false : _this$state$showAddto;

			return showAddtoHomeScreen;
		};

		_this.renderMarketTalkButton = function () {
			if (_this.props.marketTalkButton) {
				return _ref7;
			}
		};

		_this.renderViewinAppFAB = function () {
			if (typeof navigator !== "undefined") {
				var userAgent = lodash_get_default()(navigator, 'userAgent', '');
				if (isAndroid(userAgent) && _this.props.viewinAppFAB) {
					return Object(preact["h"])(LoadableViewinAppFAB, {
						city: _this.context.quikr.city || 'www',
						category: _this.props.category || 'NA',
						subcategory: _this.props.match.params.type || 'NA',
						pageType: _this.props.gaPageType || 'OTHERS'
					});
				}
			}
		};

		_this.renderQkrAppWidget = function () {
			if (typeof navigator !== "undefined") {
				var userAgent = lodash_get_default()(navigator, 'userAgent', '');
				if (isAndroid(userAgent) && _this.props.qkrAppWidget) {
					return Object(preact["h"])(LoadableQkrAppWidget, {
						city: _this.context.quikr.city || 'www',
						category: _this.props.category || 'NA',
						subcategory: _this.props.match.params.type || 'NA',
						pageType: _this.props.gaPageType || 'OTHERS'
					});
				}
			}
		};

		_this.renderSwitchBanner = function () {
			if (typeof window !== 'undefined') {
				return Object(preact["h"])(components_SwitchBanner_SwitchBanner, {
					city: _this.context.quikr.city || 'www',
					category: _this.props.category || 'NA',
					subcategory: _this.props.match.params.type || 'NA',
					pageType: _this.props.gaPageType || 'OTHERS'
				});
			}
		};

		_this.state = {
			results: [],
			error: null,
			value: null,
			cityPopup: false,
			notificationPopup: false,
			topCitiesList: false,
			drawerOpen: null,
			showAddtoHomeScreen: false,
			showBottomBar: false
		};
		_this.debouncedHandleCitySearch = lodash_debounce_default()(_this.handleCitySearch, 250, { maxWait: 500 }).bind(_this);
		return _this;
	}

	Header.prototype.componentDidMount = function componentDidMount() {
		var city = Object(helpers["b" /* getCurrentCity */])();
		if (city === constants["b" /* ALL_INDIA */]) {
			this.checkLocationStatus();
		}

		if (window && window.matchMedia && !window.matchMedia('(display-mode: standalone)').matches) {
			this.setState({
				showAddtoHomeScreen: true
			});
		}

		if (typeof window !== 'undefined') {
			var searchParams = new URLSearchParams(window.location.search);
			var utmParams = {};
			var _arr = ['utm_source', 'utm_medium', 'utm_campaign'];
			for (var _i = 0; _i < _arr.length; _i++) {
				var item = _arr[_i];
				if (searchParams.has(item)) {
					var val = searchParams.get(item);
					if (val) {
						utmParams[item] = encodeURIComponent(val);
					}
				}
			}
			Object.keys(utmParams).length && sessionStorage.setItem('utm_params', JSON.stringify(utmParams));
		}
	};

	/**
 * This method is called whenever the props or state changes
 * @return {Object} Context of child components
 */


	Header.prototype.getChildContext = function getChildContext() {
		var context = {};
		context.pageType = this.getPageTypeFromProps();
		return context;
	};

	Header.prototype.render = function render(props, state, context) {
		var _this2 = this;

		// can get the userInfo from context also this.context.user
		var _props$hasTitle = props.hasTitle,
		    hasTitle = _props$hasTitle === undefined ? true : _props$hasTitle,
		    _props$CustomTitle = props.CustomTitle,
		    CustomTitle = _props$CustomTitle === undefined ? false : _props$CustomTitle,
		    _props$toolbarItems = props.toolbarItems,
		    toolbarItems = _props$toolbarItems === undefined ? true : _props$toolbarItems,
		    _props$hamburger = props.hamburger,
		    hamburger = _props$hamburger === undefined ? true : _props$hamburger,
		    _props$back = props.back,
		    back = _props$back === undefined ? false : _props$back,
		    _props$logoHref = props.logoHref,
		    logoHref = _props$logoHref === undefined ? null : _props$logoHref,
		    _props$myAccountMenu = props.myAccountMenu,
		    myAccountMenu = _props$myAccountMenu === undefined ? {} : _props$myAccountMenu,
		    user = props.userInfo,
		    searchCityCallback = props.searchCityCallback,
		    _props$logoCallback = props.logoCallback,
		    logoCallback = _props$logoCallback === undefined ? false : _props$logoCallback,
		    _props$hasLogo = props.hasLogo,
		    hasLogo = _props$hasLogo === undefined ? true : _props$hasLogo,
		    g_id = props.g_id,
		    match = props.match,
		    _props$location = props.location,
		    location = _props$location === undefined ? true : _props$location;
		var isLoggedIn = user.loggedIn;
		var city = this.context.quikr.city;

		var classes = dedupe_default()('mdc-typography');

		var _props$placeholder = props.placeholder,
		    placeholder = _props$placeholder === undefined ? 'Type your city' : _props$placeholder;
		var results = state.results,
		    err = state.err,
		    cityPopup = state.cityPopup,
		    notificationPopup = state.notificationPopup,
		    value = state.value,
		    topCitiesList = state.topCitiesList;

		var gridArray = [];
		for (var i = 1; i <= 12; i++) {
			gridArray.push(Object(preact["h"])(
				material_layout_grid["a" /* default */].Cell,
				{ desktopCols: '1' },
				i
			));
		}

		var homepageHref = city === 'All India' ? 'https://www.quikr.com' : 'https://' + city + '.quikr.com';

		return Object(preact["h"])(
			'div',
			{ 'class': classes },
			this.renderSwitchBanner(),
			this.renderMarketTalkButton(),
			this.renderViewinAppFAB(),
			this.renderQkrAppWidget(),
			Object(preact["h"])(
				material_toolbar["a" /* default */],
				null,
				Object(preact["h"])(
					material_toolbar_row["a" /* default */],
					null,
					Object(preact["h"])(
						material_toolbar_section["a" /* default */],
						{ start: true },
						hamburger && Object(preact["h"])(
							'a',
							{ 'class': 'mdc-toolbar__icon--menu',
								onClick: this.openHamburger
							},
							_ref8
						),
						back && Object(preact["h"])(
							'a',
							{ 'class': 'mdc-toolbar__icon--menu', onClick: this.handleBackOnClick },
							_ref9
						),
						Object(preact["h"])(
							material_toolbar_title["a" /* default */],
							null,
							hasLogo && (logoCallback ? logoCallback(props, context) : Object(preact["h"])(
								'a',
								{ href: logoHref ? logoHref : homepageHref, 'class': 'logo' },
								_ref10,
								_ref11
							)),
							location && _ref12,
							CustomTitle !== false && Object(preact["h"])(CustomTitle, null),
							!CustomTitle && hasTitle && Object(preact["h"])(
								'span',
								{ onClick: this.showCityPopup },
								city,
								_ref13
							)
						),
						Object(preact["h"])(
							mediaQuery["a" /* default */],
							{ minWidth: 840 },
							Object(preact["h"])(q_components_components_search, this.props.searchProps)
						)
					),
					typeof toolbarItems === typeof true && toolbarItems && Object(preact["h"])(
						material_toolbar_section["a" /* default */],
						{ end: true },
						Object(preact["h"])(myAccount["a" /* default */], header__extends({ isLoggedIn: isLoggedIn, callHeaderfunction: this.callHeaderfunction }, myAccountMenu)),
						Object(preact["h"])(
							material_button["a" /* default */],
							{ unelevated: true, compact: true, dense: true, onClick: this.redirectToPostAd },
							' Post Free Ad '
						)
					),
					toolbarItems.length > 0 && Object(preact["h"])(
						material_toolbar_section["a" /* default */],
						{ end: true },
						toolbarItems
					)
				),
				state.drawerOpen !== null && Object(preact["h"])(LoadableHamburger, { drawerOpen: state.drawerOpen, onClose: this.closeHamburger, isLoggedIn: isLoggedIn, user: user, city: city, showCityPopup: this.showCityPopup })
			),
			cityPopup && Object(preact["h"])(header_LoadableSearchPopup, {
				key: 'city-popup',
				show: cityPopup,
				results: results,
				err: err,
				value: value,
				closePopup: this.closeCityPopup,
				placeholder: placeholder,
				handleSearch: this.setCityAndSearch,
				showTopCities: topCitiesList,
				searchCityCallback: searchCityCallback,
				g_id: g_id,
				match: match
			}),
			notificationPopup && Object(preact["h"])(LoadableNotificationPopup, { closePopup: this.closeNotificationPopup }),
			Object(preact["h"])(
				mediaQuery["a" /* default */],
				{ minWidth: 840 },
				Object(preact["h"])(
					material_dialog["a" /* default */],
					{ 'class': 'city-dialog', ref: function ref(cityDialog) {
							_this2.cityDialog = cityDialog;
						}, full: true },
					Object(preact["h"])(components_desktop_city, header__extends({ close: function close() {
							_this2.cityDialog.MDComponent.close();
						} }, props, { handleSearch: this.setCityAndSearch, results: results }))
				)
			)
		);
	};

	return Header;
}(preact["Component"]);



/* harmony default export */ var components_header = (hoc_showOrHide(header_Header));
// EXTERNAL MODULE: ../q-mdc/elements/material-fab/index.js
var material_fab = __webpack_require__("/X51");

// EXTERNAL MODULE: ../q-mdc/elements/material-footer/index.js
var material_footer = __webpack_require__("fRvz");

// EXTERNAL MODULE: ../q-components/components/icons/socialIcons/facebook/index.js
var facebook = __webpack_require__("L8bY");

// CONCATENATED MODULE: ../q-components/components/icons/socialIcons/linkedin/index.js



var linkedin__ref = Object(preact["h"])("path", { d: "M17.7,69.6V24.2H3.4v45.4H17.7z M10.5,18c5,0,8.1-3.5,8.1-7.8c-0.1-4.5-3.1-7.8-8-7.8s-8.1,3.4-8.1,7.8C2.5,14.6,5.6,18,10.5,18L10.5,18z M69.5,69.6v-26c0-13.9-7.1-20.4-16.5-20.4c-7.6,0-11,4.4-12.9,7.5v-6.4H25.7c0.2,4.3,0,45.4,0,45.4H40V44.3c0-1.4,0.1-2.7,0.5-3.7c1-2.7,3.4-5.5,7.4-5.5c5.2,0,7.3,4.2,7.3,10.3v24.3L69.5,69.6L69.5,69.6z" });

var linkedin_linkedinIcon = function linkedinIcon(props) {
	return Object(preact["h"])(
		"svg",
		{ id: "in", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", viewBox: "0 0 72 72", "class": props.class },
		linkedin__ref
	);
};

/* harmony default export */ var linkedin = (linkedin_linkedinIcon);
// EXTERNAL MODULE: ../q-components/components/icons/socialIcons/twitter/index.js
var twitter = __webpack_require__("HTqT");

// CONCATENATED MODULE: ../q-components/components/icons/socialIcons/youtube/index.js



var youtube__ref = Object(preact["h"])("path", { d: "M29.3,2l-4.5,14.7v10.4h-3.9v-9.9L16.3,2h3.9l2.5,10H23l2.4-10H29.3z M30.5,9.4c0.9-0.9,2.2-1.3,3.7-1.3c1.4,0,2.6,0.4,3.5,1.3c0.9,0.9,1.4,2,1.4,3.4v9.6c0,1.6-0.5,2.8-1.3,3.7c-0.9,0.9-2.1,1.3-3.7,1.3c-1.5,0-2.7-0.5-3.6-1.4c-0.9-0.9-1.3-2.2-1.3-3.7v-9.6C29.1,11.4,29.6,10.2,30.5,9.4 M33,23.9c0.2,0.3,0.6,0.4,1,0.4c0.5,0,0.9-0.1,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.2V12.7c0-0.4-0.1-0.7-0.4-1c-0.3-0.2-0.6-0.4-1.1-0.4c-0.4,0-0.8,0.1-1,0.4c-0.3,0.2-0.4,0.6-0.4,1v10.1C32.7,23.2,32.8,23.7,33,23.9 M48.4,8.6v14c-0.3,0.4-0.7,0.7-1.1,1c-0.4,0.3-0.7,0.4-1,0.4c-0.3,0-0.6-0.1-0.7-0.3c-0.1-0.2-0.2-0.5-0.2-1V8.6H42V24c0,1.1,0.2,1.9,0.6,2.5c0.4,0.5,1,0.8,1.8,0.8c0.6,0,1.3-0.2,2-0.6c0.7-0.4,1.3-1,2-1.7v2.1h3.4V8.6L48.4,8.6L48.4,8.6z M40.5,46c-0.2,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.5,0.3-0.7,0.6v11.5c0.3,0.3,0.5,0.5,0.8,0.7s0.5,0.2,0.8,0.2c0.4,0,0.7-0.1,0.9-0.4c0.2-0.2,0.3-0.7,0.3-1.3h0v-9.6c0-0.6-0.1-1.1-0.4-1.4C41.3,46.1,41,46,40.5,46z M53.2,46.1c-0.5,0-0.9,0.1-1.2,0.5c-0.2,0.3-0.4,0.9-0.4,1.7h0v1.9h3v-1.9c0-0.8-0.1-1.3-0.4-1.7C54.1,46.3,53.7,46.1,53.2,46.1z M64,40.3c0-4.5-3.7-8.1-8.2-8.1c-6.1-0.3-12.4-0.4-18.8-0.4h-1h-1c-6.4,0-12.6,0.1-18.8,0.4c-4.5,0-8.2,3.6-8.2,8.1c-0.3,3.5-0.4,7.1-0.4,10.6c0,3.5,0.1,7.1,0.4,10.6c0,4.5,3.7,8.1,8.2,8.1C22.7,69.9,29.3,70,36,70s13.3-0.1,19.8-0.4c4.5,0,8.2-3.6,8.2-8.1c0.3-3.5,0.4-7.1,0.4-10.6S64.3,43.8,64,40.3z M18.5,61.8h-3.9V40.4h-4v-3.6h11.9v3.6h-4V61.8z M32.3,61.8h-3.4v-2.1c-0.6,0.7-1.3,1.3-2,1.7c-0.7,0.4-1.4,0.6-2,0.6c-0.8,0-1.4-0.3-1.8-0.8s-0.6-1.4-0.6-2.5V43.3h3.4v14.2c0,0.4,0.1,0.8,0.2,1c0.1,0.2,0.4,0.3,0.7,0.3c0.2,0,0.6-0.1,1-0.4c0.4-0.3,0.8-0.6,1.1-1h0v-14h3.4V61.8z M45.5,58c0,1.3-0.3,2.3-0.8,3s-1.3,1.1-2.3,1.1c-0.7,0-1.3-0.1-1.8-0.4s-1-0.7-1.5-1.2v1.4h-3.5V36.7h3.5v8.1c0.5-0.6,1-1,1.5-1.3c0.5-0.3,1.1-0.4,1.6-0.4c1.1,0,1.9,0.4,2.5,1.2c0.6,0.8,0.9,1.9,0.9,3.4V58z M58.2,53L58.2,53l-6.6,0v3.5c0,1,0.1,1.7,0.3,2c0.2,0.4,0.6,0.6,1.1,0.6c0.6,0,1-0.2,1.2-0.5s0.3-1,0.3-2.1v-1.3h3.5v1.4c0,1.9-0.4,3.3-1.3,4.3s-2.2,1.4-3.9,1.4c-1.5,0-2.8-0.5-3.6-1.5s-1.3-2.4-1.3-4.2v-8.3c0-1.6,0.5-2.9,1.5-3.9s2.2-1.5,3.8-1.5c1.6,0,2.8,0.5,3.6,1.4c0.9,0.9,1.3,2.3,1.3,4V53z" });

var youtube_youtube = function youtube(props) {
	return Object(preact["h"])(
		"svg",
		{ id: "youtube", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", viewBox: "0 0 72 72", "class": props.class },
		youtube__ref
	);
};

/* harmony default export */ var socialIcons_youtube = (youtube_youtube);
// CONCATENATED MODULE: ../q-components/components/icons/socialIcons/index.js






// CONCATENATED MODULE: ../q-components/components/footer/index.js


function footer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function footer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function footer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// The below css is coming from q-mdc - Shahab
// import styles from './index.scss';

var footer__ref = Object(preact["h"])(
	'h4',
	{ 'class': 'mdc-footer__heading' },
	'Useful Links'
);

var footer__ref2 = Object(preact["h"])(
	'h4',
	{ 'class': 'mdc-footer__heading' },
	'Follow Us'
);

var footer__ref3 = Object(preact["h"])(facebook["a" /* default */], { 'class': 'mdc-footer__icons' });

var footer__ref4 = Object(preact["h"])(linkedin, { 'class': 'mdc-footer__icons' });

var footer__ref5 = Object(preact["h"])(twitter["a" /* default */], { 'class': 'mdc-footer__icons' });

var footer__ref6 = Object(preact["h"])(socialIcons_youtube, { 'class': 'mdc-footer__icons' });

var footer_FooterToolbar = function (_Component) {
	footer__inherits(FooterToolbar, _Component);

	function FooterToolbar() {
		var _temp, _this, _ret;

		footer__classCallCheck(this, FooterToolbar);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = footer__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { currentYear: new Date().getFullYear() }, _this.pushGa = function (gaEvent) {
			Object(helpers_ga["a" /* getEventTrackGA */])(gaEvent);
		}, _this.onUsefulLinkClick = function (linkName) {
			var gaEvent = { category: 'quikr_pwa', action: 'quikr_pwa_useful_links', label: 'quikr_pwa_useful_links_' + linkName };
			_this.pushGa(gaEvent);
		}, _this.onFollowUsClick = function (platformName) {
			var gaEvent = { category: 'quikr_pwa', action: 'quikr_pwa_follow_us', label: 'quikr_pwa_follow_us_' + platformName };
			_this.pushGa(gaEvent);
		}, _temp), footer__possibleConstructorReturn(_this, _ret);
	}

	FooterToolbar.prototype.componentDidMount = function componentDidMount() {};

	FooterToolbar.prototype.render = function render(props, state) {
		var _this2 = this;

		return Object(preact["h"])(
			material_footer["a" /* default */],
			null,
			footer__ref,
			Object(preact["h"])(
				material_list["a" /* default */],
				{ links: true, 'class': 'mdc-footer__primary-links' },
				Object(preact["h"])(
					material_list_item["a" /* default */],
					{ link: true, href: '/html/about.php', onClick: function onClick(e) {
							return _this2.onUsefulLinkClick('about_us');
						} },
					'About us'
				),
				Object(preact["h"])(
					material_list_item["a" /* default */],
					{ link: true, href: '/html/contact.php', onClick: function onClick(e) {
							return _this2.onUsefulLinkClick('contact_us');
						} },
					'Contact Us'
				),
				Object(preact["h"])(
					material_list_item["a" /* default */],
					{ link: true, href: '/html/jobs.php', onClick: function onClick(e) {
							return _this2.onUsefulLinkClick('careers');
						} },
					'Careers'
				),
				Object(preact["h"])(
					material_list_item["a" /* default */],
					{ link: true, href: '/video?id=vhS7M5IdOpI', onClick: function onClick(e) {
							return _this2.onUsefulLinkClick('quikr_videos');
						} },
					'Quikr Videos'
				),
				Object(preact["h"])(
					material_list_item["a" /* default */],
					{ link: true, href: '/adsales', onClick: function onClick(e) {
							return _this2.onUsefulLinkClick('advertise_with_us');
						} },
					'Advertise With Us'
				),
				Object(preact["h"])(
					material_list_item["a" /* default */],
					{ link: true, href: 'http://blog.quikr.com', onClick: function onClick(e) {
							return _this2.onUsefulLinkClick('blog');
						} },
					'Blog'
				),
				Object(preact["h"])(
					material_list_item["a" /* default */],
					{ link: true, href: '/help/', onClick: function onClick(e) {
							return _this2.onUsefulLinkClick('help');
						} },
					'Help'
				),
				Object(preact["h"])(
					material_list_item["a" /* default */],
					{ link: true, href: '/html/premium_ads.php', onClick: function onClick(e) {
							return _this2.onUsefulLinkClick('premium_ads');
						} },
					'Premium Ads'
				)
			),
			Object(preact["h"])(
				'div',
				{ 'class': 'mdc-footer__socials' },
				footer__ref2,
				Object(preact["h"])(
					'div',
					{ 'class': 'social-elements' },
					Object(preact["h"])(material_fab["a" /* default */], {
						mini: true, icon: Object(preact["h"])(
							'a',
							{ 'aria-label': 'Facebook', href: 'http://www.facebook.com/QuikrFans', target: '_blank', onClick: function onClick(e) {
									return _this2.onFollowUsClick('facebook');
								} },
							footer__ref3
						)
					}),
					Object(preact["h"])(material_fab["a" /* default */], {
						icon: Object(preact["h"])(
							'a',
							{ 'aria-label': 'Linkedin', href: 'https://www.linkedin.com/company/673276?trk=tyah&trkInfo=clickedVertical%3Acompany%2Cidx%3A2-1-4%2CtarId%3A1427871622516%2Ctas%3Aquikr', target: '_blank', onClick: function onClick(e) {
									return _this2.onFollowUsClick('linkedin');
								} },
							footer__ref4
						)
					}),
					Object(preact["h"])(material_fab["a" /* default */], {
						mini: true,
						icon: Object(preact["h"])(
							'a',
							{ 'aria-label': 'twitter', href: 'http://www.twitter.com/quikr', onClick: function onClick(e) {
									return _this2.onFollowUsClick('twitter');
								}, target: '_blank' },
							footer__ref5
						)
					}),
					Object(preact["h"])(material_fab["a" /* default */], {
						mini: true,
						icon: Object(preact["h"])(
							'a',
							{ 'aria-label': 'Youtube', href: 'https://www.youtube.com/channel/UCpLtpHTmLXwgNMA_OXvOQew', target: '_blank', onClick: function onClick(e) {
									return _this2.onFollowUsClick('youtube');
								} },
							footer__ref6
						)
					})
				)
			),
			Object(preact["h"])(
				'p',
				{ 'class': 'mdc-footer__copyright' },
				'Copyright \xA9 2008-',
				state.currentYear,
				' Quikr India Private Limited'
			)
		);
	};

	return FooterToolbar;
}(preact["Component"]);



/* harmony default export */ var footer = (hoc_showOrHide(footer_FooterToolbar));
// EXTERNAL MODULE: ../q-components/components/shell/index.scss
var shell = __webpack_require__("tcXu");
var shell_default = /*#__PURE__*/__webpack_require__.n(shell);

// EXTERNAL MODULE: ../q-components/components/notificationPopup/index.js
var components_notificationPopup = __webpack_require__("fMvH");

// CONCATENATED MODULE: ../q-components/components/notificationPopup/notificationSupportedRoutes.js
var notificationSupportedRoutes = [{
	route: {
		path: '/jobs/:title(.*W0QQAdIdZ)+:id',
		exact: true
	},
	notification: {
		context: 'vap',
		customPopup: true,
		customText: 'Would you like to receive notifications about latest jobs from Quikr? Subscribe and get',
		vertical: 'jobs',
		withTimeout: 5
	}
}, {
	route: {
		path: '/jobs/:query+(zwqxj)+:identifier',
		exact: true
	},
	notification: {
		context: 'snb',
		customPopup: true,
		customText: 'Would you like to receive notifications about latest jobs from Quikr? Subscribe and get',
		vertical: 'jobs',
		withTimeout: 5
	}
}, {
	route: {
		path: '/homes/pg/:slug(.*paying-guest+.*)',
		exact: true
	},
	notification: {
		context: 'homepage',
		customPopup: true,
		customText: 'Would you like to receive personalized notifications from Quikr? Subscribe and get',
		vertical: 'qhmr',
		withTimeout: 5
	}
}, {
	route: {
		path: '/:type(cars)/:slug(.*AdIdZ[\\d]+)',
		exact: true
	},
	notification: {
		context: 'vap',
		customPopup: true,
		customText: 'Would you like to receive notifications about matching cars from Quikr? Subscribe and get',
		vertical: 'cars',
		withTimeout: 5
	}
}, {
	route: {
		path: '/:type(cars-bikes|bikes-scooters)/:slug(.*AdIdZ[\\d]+)',
		exact: true
	},
	notification: {
		context: 'vap',
		customPopup: true,
		customText: 'Would you like to receive notifications about matching vehicles from Quikr? Subscribe and get',
		vertical: 'cars',
		withTimeout: 5
	}
}, {
	route: {
		path: '/:type(cars)/:slug(.*[w|x|y|z][\\d].*)',
		exact: true
	},
	notification: {
		context: 'snb',
		customPopup: true,
		customText: 'Would you like to receive notifications about matching cars from Quikr? Subscribe and get',
		vertical: 'cars',
		withTimeout: 5
	}
}, {
	route: {
		path: '/:type(cars-bikes)/:slug(.*[w|x|y|z][\\d].*)',
		exact: true
	},
	notification: {
		context: 'snb',
		customPopup: true,
		customText: 'Would you like to receive notifications about matching vehicles from Quikr? Subscribe and get',
		vertical: 'cars',
		withTimeout: 5
	}
}, {
	route: {
		path: '/:type(bikes-scooters)/:slug(.*[w|x|y|z][\\d].*)',
		exact: true
	},
	notification: {
		context: 'snb',
		customPopup: true,
		customText: 'Would you like to receive notifications about matching bikes/scooters from Quikr? Subscribe and get',
		vertical: 'cars',
		withTimeout: 5
	}
}, {
	route: {
		path: '/:type(home-lifestyle|electronics-appliances|mobiles-tablets)/:slug(.*W0QQAdIdZ[\\d]+)',
		exact: true
	},
	notification: {
		context: 'vap',
		customPopup: true,
		customText: 'Would you like to receive notifications about matching products from Quikr? Subscribe and get',
		vertical: 'bazaar',
		withTimeout: 5
	}
}, {
	route: { path: '/:type(home-lifestyle|electronics-appliances|mobiles-tablets)/:slug(.*[w|x|y|z][\\d]+f.*)', exact: true },
	notification: {
		context: 'snb',
		customPopup: false,
		customText: 'Would you like to receive notifications about matching products from Quikr? Subscribe and get',
		vertical: 'bazaar',
		withTimeout: 5
	}
}, {
	route: {
		path: '/:vertical(pets|matrimonial|community|entertainment|events)/:slug([0-9a-zA-z+-.]+-[a-zA-Z]+-W0QQAdIdZ[0-9]+)',
		exact: true
	},
	notification: {
		context: 'vap',
		customPopup: true,
		customText: 'Would you like to receive notifications and updates from Quikr? Subscribe and get',
		vertical: 'core',
		withTimeout: 5
	}
}, {
	route: {
		path: ':slug(.*qc[a-z]{2}0s.*)'
	},
	notification: {
		context: 'snb',
		customPopup: true,
		customText: 'Would you like to receive notifications and updates from Quikr? Subscribe and get',
		vertical: 'core',
		withTimeout: 5
	}
}];

/* harmony default export */ var notificationPopup_notificationSupportedRoutes = (notificationSupportedRoutes);
// CONCATENATED MODULE: ../q-components/components/shell/index.js
var shell__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function shell__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function shell__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function shell__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var shell_RouterWrapper = function RouterWrapper(_ref) {
	var children = _ref.children,
	    location = _ref.location;

	if (typeof window !== 'undefined') {
		return Object(preact["h"])(
			es["a" /* BrowserRouter */],
			null,
			children
		);
	}
	return Object(preact["h"])(
		es["e" /* StaticRouter */],
		{ location: location, context: {} },
		children
	);
};

var shell_cookies = new lib_default.a();

/**
* Shell - Wraps your app with Quikr's Header and Footer
* It accepts a config array - you can vary the behaviour of header and footer based on routes
* Example - View app.js
*
*/

var shell__ref2 = Object(preact["h"])(
	es["d" /* Route */],
	null,
	Object(preact["h"])(
		mediaQuery["a" /* default */],
		{ maxWidth: 840 },
		Object(preact["h"])(q_components_components_search, { show: true })
	)
);

var shell__ref3 = Object(preact["h"])(
	es["d" /* Route */],
	null,
	Object(preact["h"])(footer, { show: true })
);

var shell_Shell = function (_Component) {
	shell__inherits(Shell, _Component);

	function Shell(props) {
		shell__classCallCheck(this, Shell);

		var _this = shell__possibleConstructorReturn(this, _Component.call(this, props));

		_this.updateWalletBalance = function (amount) {
			_this.setState({
				walletBalance: amount
			});
		};

		_this.getUser = function () {
			var hostname = constants["h" /* DEFAULT_HOSTNAME */];
			if (window && window.location && window.location.hostname) {
				hostname = window.location.hostname;
			}
			axios_default.a.get('https://' + hostname + '/' + constants["i" /* GET_USER_API_PATH */]).then(function (res) {
				if (res.status === 200 && res.data) {
					_this.setState({
						userInfo: res.data
					});
				} else {
					_this.resetUser();
				}
			}).catch(function () {
				_this.resetUser();
			});
		};

		_this.resetUser = function () {
			_this.setState({
				userInfo: {
					loggedIn: false
				}
			});
		};

		_this.getPageType = function (pageTypeStringOrFunction, route) {

			if (typeof pageTypeStringOrFunction === 'function' && typeof window !== 'undefined') {
				// const { location } = this.props;
				var _window = window,
				    location = _window.location;

				var match = Object(es["g" /* matchPath */])(location.pathname, shell__extends({}, route));
				return pageTypeStringOrFunction(location, match);
			} else if (typeof pageTypeStringOrFunction === typeof 'a') {
				return pageTypeStringOrFunction;
			}
			return 'other';
		};

		_this.state = {
			userInfo: {
				loggedIn: false
			},
			headerHeight: 0,
			walletBalance: -1
		};
		return _this;
	}

	/**
 * This method is called whenever the props or state changes
 * @return {Object} Context of child components
 */


	Shell.prototype.getChildContext = function getChildContext() {
		var context = {};
		var _props$isDesktop = this.props.isDesktop,
		    isDesktop = _props$isDesktop === undefined ? false : _props$isDesktop;

		context.user = this.state.userInfo;
		context.quikr = {
			city: Object(helpers["b" /* getCurrentCity */])()
		};
		if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
			context.device = {
				userAgent: lodash_get_default()(navigator, 'userAgent', '')
			};
		}
		context.walletBalance = this.state.walletBalance;
		if (isDesktop) {
			context.screenWidth = 1920;
		} else {
			context.screenWidth = 384;
		}
		return context;
	};

	Shell.prototype.componentDidMount = function componentDidMount() {
		this.getUser();
	};

	Shell.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
		try {
			var height = document.getElementById('qhswrap').clientHeight;
			if (height !== prevState.headerHeight) {
				this.setState({
					headerHeight: height
				});
			}
		} catch (e) {}
	};

	Shell.prototype.render = function render(props, state) {
		var _this2 = this;

		var _props = this.props,
		    config = _props.config,
		    children = _props.children,
		    location = _props.location,
		    pPerformance = _props.pPerformance;
		var _state = this.state,
		    userInfo = _state.userInfo,
		    headerHeight = _state.headerHeight;

		var divClassName = 'actual-app';
		// console.log('Children here => ', children);

		if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
			divClassName = dedupe_default()('actual-app', { 'ios-clickable': isIphone(lodash_get_default()(navigator, 'userAgent', '')) });
		}

		return Object(preact["h"])(
			shell_RouterWrapper,
			{ location: location, pPerformance: pPerformance },
			Object(preact["h"])(
				'div',
				{ className: divClassName },
				Object(preact["h"])(
					es["f" /* Switch */],
					null,
					config.map(function (c) {
						return Object(preact["h"])(es["d" /* Route */], shell__extends({}, c.route, { render: function render(routeProps) {
								return Object(preact["h"])(analytics, shell__extends({}, routeProps, c.ga, { pPerformance: c.pPerformance, qrum: c.qrum }));
							} }));
					}),
					Object(preact["h"])(es["d" /* Route */], { render: function render(routeProps) {
							return Object(preact["h"])(analytics, routeProps);
						} })
				),
				Object(preact["h"])(
					es["f" /* Switch */],
					null,
					notificationPopup_notificationSupportedRoutes.map(function (c, i) {
						return Object(preact["h"])(es["d" /* Route */], shell__extends({ key: i }, c.route, { render: function render(routeProps) {
								return Object(preact["h"])(components_notificationPopup["a" /* default */], shell__extends({}, routeProps, { userInfo: userInfo }, c.notification));
							} }));
					})
				),
				Object(preact["h"])(
					es["f" /* Switch */],
					null,
					config.map(function (headerConfig) {
						return Object(preact["h"])(
							es["d" /* Route */],
							headerConfig.route,
							Object(preact["h"])(
								'div',
								{ 'class': dedupe_default()('q__hs_wrap', 'mdc-toolbar-shadow', { 'mdc-toolbar--fixed': headerConfig.sticky }, shell_default.a && shell_default.a['q__hs_wrap']), id: headerConfig.sticky ? 'qhswrap' : null },
								Object(preact["h"])(
									es["f" /* Switch */],
									null,
									config.map(function (c) {
										return Object(preact["h"])(es["d" /* Route */], shell__extends({}, c.route, { render: function render(propsForHeader) {
												return Object(preact["h"])(components_header, shell__extends({}, propsForHeader, c.header, { userInfo: userInfo, getPageType: function getPageType() {
														return _this2.getPageType(c.pageType, c.route);
													}, pPerformance: c.pPerformance, g_id: c.g_id, searchProps: c.search }));
											} }));
									}),
									Object(preact["h"])(
										es["d" /* Route */],
										null,
										Object(preact["h"])(components_header, { show: true, hasTitle: true, userInfo: userInfo, g_id: headerConfig.g_id, searchProps: headerConfig.search })
									)
								),
								Object(preact["h"])(
									es["f" /* Switch */],
									null,
									config.map(function (c) {
										return Object(preact["h"])(
											es["d" /* Route */],
											c.route,
											Object(preact["h"])(
												mediaQuery["a" /* default */],
												{ maxWidth: 840 },
												Object(preact["h"])(q_components_components_search, shell__extends({}, c.search, { userInfo: userInfo, pPerformance: c.pPerformance, getPageType: function getPageType() {
														return _this2.getPageType(c.pageType, c.route);
													}, updateWalletBalance: _this2.updateWalletBalance }))
											)
										);
									}),
									shell__ref2
								)
							)
						);
					}),
					Object(preact["h"])(
						es["d" /* Route */],
						null,
						Object(preact["h"])(
							'div',
							{ 'class': dedupe_default()('q__hs_wrap', 'mdc-toolbar-shadow') },
							Object(preact["h"])(
								es["f" /* Switch */],
								null,
								Object(preact["h"])(
									es["d" /* Route */],
									null,
									Object(preact["h"])(components_header, { show: true, hasTitle: true, userInfo: userInfo, searchProps: { show: true } })
								)
							),
							Object(preact["h"])(
								es["f" /* Switch */],
								null,
								Object(preact["h"])(
									es["d" /* Route */],
									null,
									Object(preact["h"])(
										mediaQuery["a" /* default */],
										{ maxWidth: 840 },
										Object(preact["h"])(q_components_components_search, { show: true, userInfo: userInfo })
									)
								)
							)
						)
					)
				),
				Object(preact["h"])(
					'div',
					{ className: 'body-content', style: { marginTop: headerHeight + 'px' } },
					children
				),
				Object(preact["h"])(
					es["f" /* Switch */],
					null,
					config.map(function (c) {
						return Object(preact["h"])(
							es["d" /* Route */],
							shell__extends({}, c.route, { pPerformance: c.pPerformance }),
							Object(preact["h"])(footer, shell__extends({}, c.footer, { pPerformance: c.pPerformance }))
						);
					}),
					shell__ref3
				)
			)
		);
	};

	return Shell;
}(preact["Component"]);

/* harmony default export */ var components_shell = __webpack_exports__["a"] = (shell_Shell);

/***/ }),

/***/ "lS63":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lhFt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _idb = __webpack_require__("RTKd");Object.defineProperty(exports, "__esModule", { value: !0 }), exports.default = requestPermission;function requestPermission() {
  var a = this;return new Promise(function (b, c) {
    a.idb && a.swRegistration && !a.pushSubscription && "undefined" != typeof window ? (a.pushToGA("native", "impression", !1), a.swRegistration.pushManager.subscribe(a.subscribeConfig).then(function (d) {
      a.pushToGA("native", "allow"), a.pushSubscription = d;var e;(0, _idb.readFromIDB)(a.idb, "subscription").then(function (b) {
        return e = b, (0, _idb.writeToIDB)(a.idb, "subscription", d.toJSON());
      }).then(function () {
        return e && e.endpoint !== d.endpoint ? a.updateSubscription(d) : a.saveSubscription(d);
      }).then(function () {
        return b(d);
      }).catch(c);
    }).catch(function (b) {
      a.pushToGA("native", "block"), c(b);
    })) : c(new Error("Service Worker registration unavailable. Please initialize."));
  });
}

/***/ }),

/***/ "lmsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_window_or_global__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var IndexedDbWrapper =

// keys to store indexeddb versions in local storage
function IndexedDbWrapper() {
  var _this = this;

  _classCallCheck(this, IndexedDbWrapper);

  this.idbObject = null;
  this.jobsDbName = 'quikr-pwa-jobs';
  this.jobsApplyTable = "jobs-applied-offline";
  this.jobsDbVersion = null;
  this.jobsIndexedDbLSKey = 'jobsIndexedDbVersionPWA';
  this.jobsIndexedDbGlobalLSKey = 'jobsGlobalIndexedDbVersionPWA';

  this.dropIndexedDb = function () {
    if (__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.indexedDB) {
      var request = __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.indexedDB.deleteDatabase(_this.jobsDbName);
      request.onsuccess = function (event) {
        // console.log("success: ", event);
      };

      request.onerror = function (event) {
        // console.log("error: ", event);
      };
    }
  };

  this.removeApplyFromIdb = function (applyObj, type) {
    // console.log('remove post idb', applyObj.id);
    if (_this.idbObject && _this.idbObject.objectStoreNames.contains(_this.jobsApplyTable)) {
      var db = _this.idbObject;
      var jobsApplyTable = _this.jobsApplyTable;

      var applyDBStore = db.transaction([jobsApplyTable], "readwrite").objectStore(jobsApplyTable);
      var requestDelete = applyDBStore.delete(Number(applyObj.id));
      requestDelete.onsuccess = function (e) {
        // console.log('Record deleted successfully...', e);
      };
      requestDelete.onerror = function (e) {
        // console.log('Record could not be deleted...', e);
      };
    }
  };

  this.getIdbCursorRequest = function () {
    if (_this.idbObject && _this.idbObject.objectStoreNames.contains(_this.jobsApplyTable)) {
      var db = _this.idbObject;
      var jobsApplyTable = _this.jobsApplyTable;

      var applyTransaction = db.transaction([jobsApplyTable], "readwrite");
      var applyDBStore = applyTransaction.objectStore(jobsApplyTable);

      var keyRange = IDBKeyRange.lowerBound(0);
      var cursorRequest = applyDBStore.openCursor(keyRange);
      return { applyTransaction: applyTransaction, cursorRequest: cursorRequest };
    } else {
      return {};
    }
  };

  this.getAppliedJobsByStatus = function (status) {
    var applyObjects = [];

    var _getIdbCursorRequest = _this.getIdbCursorRequest(),
        applyTransaction = _getIdbCursorRequest.applyTransaction,
        cursorRequest = _getIdbCursorRequest.cursorRequest;

    if (!cursorRequest) {
      return {};
    }
    cursorRequest.onsuccess = function (e) {
      var result = e.target.result;

      if (result) {
        // console.log('result', result.value);

        if (status) {
          if (result.value.applyStatus === status) {
            var applyObject = result.value;
            applyObjects.push(applyObject);
          }
        } else {
          var _applyObject = result.value;
          applyObjects.push(_applyObject);
        }

        result.continue();
      } else {
        // console.log("No more entries!");
      }
    };

    return { applyTransaction: applyTransaction, applyObjects: applyObjects };
  };

  this.sendSentryError = function (msg) {
    if (typeof JobsSentry !== 'undefined') {
      JobsSentry.captureMessage(msg);
    }
  };

  var self = this;

  var _initDb = function _initDb(dbVersion) {
    dbVersion = dbVersion ? dbVersion : 1;

    var request = __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.indexedDB.open(self.jobsDbName);
    request.onsuccess = function (event) {
      self.idbObject = event.target.result;
      afterIdbInit();
    };

    request.onupgradeneeded = function (event) {
      self.idbObject = event.target.result;

      if (!self.idbObject.objectStoreNames.contains(self.jobsApplyTable)) {
        var objectStore = self.idbObject.createObjectStore(self.jobsApplyTable, {
          keyPath: "id", autoIncrement: true
        });
      }
    };

    request.onerror = function (event) {
      console.log("indexeddb open error: ", event);
      self.sendSentryError("Error occurred while creating indexeddb.\nMessage : " + JSON.stringify(event));
      // since indexeddb.open failed for a specific version, we try to upgrade indexeddb version
      // _initDb(dbVersion + 1);
    };
  };

  var afterIdbInit = function afterIdbInit() {
    self.jobsDbVersion = self.idbObject.version;

    if (self.idbObject.objectStoreNames.contains(self.jobsApplyTable)) {
      var applyDbStore = self.idbObject.transaction([self.jobsApplyTable], "readwrite").objectStore(self.jobsApplyTable);
    } else {
      // since objectstore for apply table isnt there, we try to upgrade indexeddb version
      // _initDb(self.jobsDbVersion + 1);
    }
  };

  if (__WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.indexedDB) {
    _initDb();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new IndexedDbWrapper());

/***/ }),

/***/ "m0N8":
/***/ (function(module, exports) {

module.exports = function (el, options) {
  options = options || {};

  var elementDocument = el.ownerDocument || el;
  var basicTabbables = [];
  var orderedTabbables = [];

  // A node is "available" if
  // - it's computed style
  var isUnavailable = createIsUnavailable(elementDocument);

  var candidateSelectors = ['input', 'select', 'a[href]', 'textarea', 'button', '[tabindex]'];

  var candidates = el.querySelectorAll(candidateSelectors.join(','));

  if (options.includeContainer) {
    var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

    if (candidateSelectors.some(function (candidateSelector) {
      return matches.call(el, candidateSelector);
    })) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var candidate, candidateIndexAttr, candidateIndex;
  for (var i = 0, l = candidates.length; i < l; i++) {
    candidate = candidates[i];
    candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
    candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;

    if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) {
      continue;
    }

    if (candidateIndex === 0) {
      basicTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        index: i,
        tabIndex: candidateIndex,
        node: candidate
      });
    }
  }

  var tabbableNodes = orderedTabbables.sort(function (a, b) {
    return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
  }).map(function (a) {
    return a.node;
  });

  Array.prototype.push.apply(tabbableNodes, basicTabbables);

  return tabbableNodes;
};

function createIsUnavailable(elementDocument) {
  // Node cache must be refreshed on every check, in case
  // the content of the element has changed
  var isOffCache = [];

  // "off" means `display: none;`, as opposed to "hidden",
  // which means `visibility: hidden;`. getComputedStyle
  // accurately reflects visiblity in context but not
  // "off" state, so we need to recursively check parents.

  function isOff(node, nodeComputedStyle) {
    if (node === elementDocument.documentElement) return false;

    // Find the cached node (Array.prototype.find not available in IE9)
    for (var i = 0, length = isOffCache.length; i < length; i++) {
      if (isOffCache[i][0] === node) return isOffCache[i][1];
    }

    nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);

    var result = false;

    if (nodeComputedStyle.display === 'none') {
      result = true;
    } else if (node.parentNode) {
      result = isOff(node.parentNode);
    }

    isOffCache.push([node, result]);

    return result;
  }

  return function isUnavailable(node) {
    if (node === elementDocument.documentElement) return false;

    var computedStyle = elementDocument.defaultView.getComputedStyle(node);

    if (isOff(node, computedStyle)) return true;

    return computedStyle.visibility === 'hidden';
  };
}

/***/ }),

/***/ "m1Ly":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M27.3,44.8c-9.7,0-17.5-7.8-17.5-17.5c0-9.7,7.8-17.5,17.5-17.5s17.5,7.8,17.5,17.5C44.8,37,37,44.8,27.3,44.8z M50.6,44.8h-3.1l-1.1-1c3.8-4.4,6.1-10.2,6.1-16.4C52.5,13.3,41.2,2,27.3,2S2,13.3,2,27.3s11.3,25.3,25.3,25.3c6.3,0,12-2.3,16.4-6.1l1,1.1v3.1L64.2,70l5.8-5.8L50.6,44.8z" });

var search = function search(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ id: "search", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};

/* harmony default export */ __webpack_exports__["a"] = (search);

/***/ }),

/***/ "mBU9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Snackbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_snackbar_mdc_snackbar_scss__ = __webpack_require__("xxYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_snackbar_mdc_snackbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_snackbar_mdc_snackbar_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */


/**
 * Create the component.
 */

var Snackbar = function (_Component) {
  _inherits(Snackbar, _Component);

  function Snackbar() {
    _classCallCheck(this, Snackbar);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Snackbar.prototype.render = function render(_ref, state, context) {
    var className = _ref['class'],
        children = _ref.children,
        active = _ref.active,
        text = _ref.text,
        multiline = _ref.multiline,
        actionOnBottom = _ref.actionOnBottom,
        props = _objectWithoutProperties(_ref, ['class', 'children', 'active', 'text', 'multiline', 'actionOnBottom']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-snackbar', {
      'mdc-snackbar--active': active,
      'mdc-snackbar--multiline': multiline,
      'mdc-snackbar--action-on-bottom': actionOnBottom
    }, className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      _extends({ 'class': classes, 'aria-live': 'assertive', 'aria-atomic': 'true', 'aria-hidden': !active }, props),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': 'mdc-snackbar__text' },
        text
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': 'mdc-snackbar__action-wrapper' },
        children
      )
    );
  };

  return Snackbar;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "mKYW":
/***/ (function(module, exports) {

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;

/**
 * Default configs.
 */
var DEFAULT_DELIMITER = '/';
var DEFAULT_DELIMITERS = './';

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)',
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
// "(\\d+)"  => [undefined, undefined, "\d+", undefined]
'(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || DEFAULT_DELIMITER;
  var delimiters = options && options.delimiters || DEFAULT_DELIMITERS;
  var pathEscaped = false;
  var res;

  while ((res = PATH_REGEXP.exec(str)) !== null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      pathEscaped = true;
      continue;
    }

    var prev = '';
    var next = str[index];
    var name = res[2];
    var capture = res[3];
    var group = res[4];
    var modifier = res[5];

    if (!pathEscaped && path.length) {
      var k = path.length - 1;

      if (delimiters.indexOf(path[k]) > -1) {
        prev = path[k];
        path = path.slice(0, k);
      }
    }

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
      pathEscaped = false;
    }

    var partial = prev !== '' && next !== undefined && next !== prev;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = prev || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prev,
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      pattern: pattern ? escapeGroup(pattern) : '[^' + escapeString(delimiter) + ']+?'
    });
  }

  // Push any remaining characters.
  if (path || index < str.length) {
    tokens.push(path + str.substr(index));
  }

  return tokens;
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile(str, options) {
  return tokensToFunction(parse(str, options));
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (data, options) {
    var path = '';
    var encode = options && options.encode || encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;
        continue;
      }

      var value = data ? data[token.name] : undefined;
      var segment;

      if (Array.isArray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
        }

        if (value.length === 0) {
          if (token.optional) continue;

          throw new TypeError('Expected "' + token.name + '" to not be empty');
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j], token);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        segment = encode(String(value), token);

        if (!matches[i].test(segment)) {
          throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
        }

        path += token.prefix + segment;
        continue;
      }

      if (token.optional) {
        // Prepend partial segment prefixes.
        if (token.partial) path += token.prefix;

        continue;
      }

      throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'));
    }

    return path;
  };
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup(group) {
  return group.replace(/([=!:$/()])/g, '\\$1');
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags(options) {
  return options && options.sensitive ? '' : 'i';
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */
function regexpToRegexp(path, keys) {
  if (!keys) return path;

  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        pattern: null
      });
    }
  }

  return path;
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  return new RegExp('(?:' + parts.join('|') + ')', flags(options));
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function tokensToRegExp(tokens, keys, options) {
  options = options || {};

  var strict = options.strict;
  var start = options.start !== false;
  var end = options.end !== false;
  var delimiter = escapeString(options.delimiter || DEFAULT_DELIMITER);
  var delimiters = options.delimiters || DEFAULT_DELIMITERS;
  var endsWith = [].concat(options.endsWith || []).map(escapeString).concat('$').join('|');
  var route = start ? '^' : '';
  var isEndDelimited = tokens.length === 0;

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
      isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1;
    } else {
      var capture = token.repeat ? '(?:' + token.pattern + ')(?:' + escapeString(token.delimiter) + '(?:' + token.pattern + '))*' : token.pattern;

      if (keys) keys.push(token);

      if (token.optional) {
        if (token.partial) {
          route += escapeString(token.prefix) + '(' + capture + ')?';
        } else {
          route += '(?:' + escapeString(token.prefix) + '(' + capture + '))?';
        }
      } else {
        route += escapeString(token.prefix) + '(' + capture + ')';
      }
    }
  }

  if (end) {
    if (!strict) route += '(?:' + delimiter + ')?';

    route += endsWith === '$' ? '$' : '(?=' + endsWith + ')';
  } else {
    if (!strict) route += '(?:' + delimiter + '(?=' + endsWith + '))?';
    if (!isEndDelimited) route += '(?=' + delimiter + '|' + endsWith + ')';
  }

  return new RegExp(route, flags(options));
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp(path, keys, options) {
  if (path instanceof RegExp) {
    return regexpToRegexp(path, keys);
  }

  if (Array.isArray(path)) {
    return arrayToRegexp( /** @type {!Array} */path, keys, options);
  }

  return stringToRegexp( /** @type {string} */path, keys, options);
}

/***/ }),

/***/ "mZt8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__("YS7T");
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("HPUF"), __webpack_require__("HBda")(module)))

/***/ }),

/***/ "miKh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");
var transformData = __webpack_require__("g9YX");
var isCancel = __webpack_require__("DyZn");
var defaults = __webpack_require__("UXCT");
var isAbsoluteURL = __webpack_require__("TWrg");
var combineURLs = __webpack_require__("+oM5");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),

/***/ "mzEQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToolbarRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss__ = __webpack_require__("w/zb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */


/**
 * Create the component.
 */

var ToolbarRow = function (_Component) {
  _inherits(ToolbarRow, _Component);

  function ToolbarRow() {
    _classCallCheck(this, ToolbarRow);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ToolbarRow.prototype.render = function render(_ref, state, context) {
    var className = _ref['class'],
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['class', 'children']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-toolbar__row', className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      _extends({ 'class': classes }, props),
      children
    );
  };

  return ToolbarRow;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "nJPD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__("yy8s"));

var _addClass = _interopRequireDefault(__webpack_require__("thHe"));

var _removeClass = _interopRequireDefault(__webpack_require__("3tI1"));

var _react = _interopRequireDefault(__webpack_require__("CK2z"));

var _Transition = _interopRequireDefault(__webpack_require__("7Mlx"));

var _PropTypes = __webpack_require__("uN/K");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }newObj.default = obj;return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
}

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */

var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "njsv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", { points: "70,31.8 18.2,31.8 41.9,7.9 36,2 2,36 36,70 41.9,64.1 18.2,40.2 70,40.2 " });

var back = function back(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ id: "back", version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};
/* harmony default export */ __webpack_exports__["a"] = (back);

/***/ }),

/***/ "nzOW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserUtil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("QSFW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_form_urlencoded__ = __webpack_require__("dA1j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_form_urlencoded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_form_urlencoded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FetchHelper__ = __webpack_require__("Hm4v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JobsPostAd_others_otherFeatures__ = __webpack_require__("c9Av");
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var UserUtil = (_temp = _class = function UserUtil() {
    _classCallCheck(this, UserUtil);
}, _class.updateUserCompanyDetails = function (userDetails) {
    if (userDetails.vblDetails && userDetails.vblDetails.length > 0) {
        var details = userDetails.vblDetails[0];
        var companyDetails = {
            hiringCompany: '',
            kycCompany: '',
            companyName: '',
            isToDisplayIndividual: true,
            teamType: ''
        };

        if (details.company_name && 'NA' !== details.company_name) companyDetails.hiringCompany = details.company_name;

        if (details.team_type) companyDetails.teamType = details.team_type;

        companyDetails.kycCompany = companyDetails.hiringCompany;
        companyDetails.companyName = companyDetails.hiringCompany;

        if (1 === details.company_type && ('FOS' === details.team_type || 'Direct Sales' === details.team_type && (1 === details.vbl || details.amount >= 10000))) {
            companyDetails.isToDisplayIndividual = false;
        }

        userDetails.companyDetails = companyDetails;
    }

    return userDetails;
}, _class.getUserByMobile = function (params) {
    var url = __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* BASE_URL */] + '/jobsAjax/getUserByMobile';
    url += "?isRoleSubRoleOptionsRequired=" + !__WEBPACK_IMPORTED_MODULE_3__JobsPostAd_others_otherFeatures__["b" /* RoleSubRole */].isOptionsStored() + "\n      &isCityOptionsRequired=" + !__WEBPACK_IMPORTED_MODULE_3__JobsPostAd_others_otherFeatures__["a" /* CityOptions */].isOptionsStored() + "&";
    var paramString = __WEBPACK_IMPORTED_MODULE_1_form_urlencoded___default()(params);
    var options = {
        url: url + paramString
    };

    var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();
    var promise = fetchHelper.request('GET', options);
    return promise.then(function (response) {
        return response.data;
    });
}, _temp);


/***/ }),

/***/ "o4Mi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rum_pagetypes_src__ = __webpack_require__("eKXM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rum_pagetypes_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rum_pagetypes_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils_ga__ = __webpack_require__("LU+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_universal_cookie__ = __webpack_require__("5aIp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_universal_cookie__);




function getCurrentCity() {
	var cookies = new __WEBPACK_IMPORTED_MODULE_2_universal_cookie___default.a();
	var cityCookie = cookies.get('new_prefer_city') || 'www';
	return cityCookie;
}

function setCurrentCity(cityName) {
	var cookies = new __WEBPACK_IMPORTED_MODULE_2_universal_cookie___default.a();
	if (cityName) cookies.set('new_prefer_city', cityName);
}

function getCurrentCityId() {
	var cookies = new __WEBPACK_IMPORTED_MODULE_2_universal_cookie___default.a();
	var cityCookie = cookies.get('prefer_city_id') || '1';
	return cityCookie;
}

function getJKID() {
	var cookies = new __WEBPACK_IMPORTED_MODULE_2_universal_cookie___default.a();
	var jkidCookie = cookies.get('_jk_id') && cookies.get('_jk_id').split('.');
	return jkidCookie && jkidCookie[0];
}

var exampleConfig = [{
	route: {
		path: '/NearByAds',
		exact: true
	},
	header: {
		show: false
	},
	pageType: 'NearByAds',
	sticky: false,
	search: {
		show: false
	},
	footer: {
		show: false
	}
}, {
	route: { path: '/:category(pets|matrimonial|community|entertainment|events)/:slug([0-9a-zA-z+\-\.]+-[a-zA-Z]+-W0QQAdIdZ[0-9]+)', exact: true },
	pageType: 'vap',
	pPerformance: true,
	header: {
		show: true,
		back: true,
		hamburger: false,
		handleBackClick: function handleBackClick(event, history, match) {
			var category = match.params.category;

			var gaEventObject = { category: category + '_vap_pwa', action: category + '_vap_pwa_goback', label: category + '_vap_pwa_goback_click' };
			Object(__WEBPACK_IMPORTED_MODULE_1__helpers_utils_ga__["a" /* getEventTrackGA */])(gaEventObject);
			history.goBack();
		}
	},
	sticky: false,
	search: { show: true },
	footer: { show: false },
	qrum: function qrum(location, match) {
		var category = 'NA';
		if (typeof match !== 'undefined') {
			category = match && match.params && match.params.category;
		}
		var city = getCurrentCityId();
		var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_0_rum_pagetypes_src___default()('CORE_VAP_MOBILE'), CAT: category, CITY: city, JKID: getJKID() };
		return config;
	}
}, {
	route: {
		path: '/post-classifieds-ads:cityName?/:select(select-category\/?)?',
		exact: true
	}, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
	header: {
		show: false
	},
	pageType: 'PostAd',
	pPerformance: true,
	sticky: false,
	search: {
		show: false
	},
	footer: {
		show: false
	}
}, {
	route: { path: ':slug(.*qc[a-z]{2}0s.*)' },
	pageType: 'snb',
	pPerformance: true,
	header: {
		show: true,
		searchCityCallback: function searchCityCallback(cityId, cityName, g_id, match, prevcity) {

			var currentLocation = window.location.href;
			var currentCity = void 0;
			currentCity = prevcity ? prevcity : 'www';
			if (cityName === 'all-India' || cityName === 'All India') {
				if (currentCity !== 'www') {
					window.location = currentLocation.replace('+' + currentCity, '');
				} else {
					window.location = currentLocation;
				}
			} else if (currentCity !== 'www') {
				window.location = currentLocation.replace(currentCity, cityName.toLowerCase());
			} else {
				var replacement = '+' + cityName.toLowerCase() + '+';
				var pos = currentLocation.lastIndexOf('+qc');
				window.location = currentLocation.substring(0, pos) + replacement + currentLocation.substring(pos + 1);
			}
		}
	},
	sticky: false,
	search: { show: true,
		searchterm: function searchterm() {
			var currentLocation = window.location.href;
			var urlArray = currentLocation.split('+');
			var splitsearch = urlArray[0].split('/');
			var searchterm = splitsearch[splitsearch.length - 1];
			if (searchterm) {
				return searchterm;
			}

			return '';
		}
	},
	footer: { show: true },
	qrum: function qrum(location, match) {
		var city = getCurrentCityId();
		var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_0_rum_pagetypes_src___default()('CORE_SEARCH_MOBILE'), CITY: city, JKID: getJKID() };
		return config;
	}
}, {
	route: { path: ':slug(.*qc[a-z]{2}1b.*)' },
	pageType: 'snb',
	header: {
		show: true,
		searchCityCallback: function searchCityCallback(cityId, cityName, g_id, match, prevcity) {
			var currentLocation = window.location.href;
			var currentCity = void 0;
			currentCity = prevcity ? prevcity : 'www';
			if (cityName === 'all-India' || cityName === 'All India') {
				if (currentCity !== 'www') {
					window.location = currentLocation.replace('+' + currentCity, '');
				} else {
					window.location = currentLocation;
				}
			} else if (currentCity !== 'www') {
				window.location = currentLocation.replace(currentCity, cityName.toLowerCase());
			} else {
				var replacement = '+' + cityName.toLowerCase() + '+';
				var pos = currentLocation.lastIndexOf('+qc');
				window.location = currentLocation.substring(0, pos) + replacement + currentLocation.substring(pos + 1);
			}
		}
	},
	pPerformance: true,
	qrum: function qrum(location, match) {
		var city = getCurrentCityId();
		var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_0_rum_pagetypes_src___default()('CORE_SEARCH_MOBILE'), CITY: city, JKID: getJKID() };
		return config;
	},
	sticky: false,
	footer: { show: true },
	search: { show: true }
}, {
	route: { path: ':slug(.*qc[a-z]{2}1s.*)' },
	pageType: 'snb',
	header: {
		show: true,
		searchCityCallback: function searchCityCallback(cityId, cityName, g_id, match, prevcity) {

			var currentLocation = window.location.href;
			var currentCity = void 0;
			currentCity = prevcity ? prevcity : 'www';
			if (cityName === 'all-India' || cityName === 'All India') {
				if (currentCity !== 'www') {
					window.location = currentLocation.replace('+' + currentCity, '');
				} else {
					window.location = currentLocation;
				}
			} else if (currentCity !== 'www') {
				window.location = currentLocation.replace(currentCity, cityName.toLowerCase());
			} else {
				var replacement = '+' + cityName.toLowerCase() + '+';
				var pos = currentLocation.lastIndexOf('+qc');
				window.location = currentLocation.substring(0, pos) + replacement + currentLocation.substring(pos + 1);
			}
		}
	},
	sticky: false,
	footer: { show: true },
	qrum: function qrum(location, match) {
		var city = getCurrentCityId();
		var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_0_rum_pagetypes_src___default()('CORE_SEARCH_MOBILE'), CITY: city, JKID: getJKID() };
		return config;
	},
	search: { show: true,
		searchterm: function searchterm() {
			var currentLocation = window.location.href;
			var urlArray = currentLocation.split('+');
			var splitsearch = urlArray[0].split('/');
			var searchterm = splitsearch[splitsearch.length - 1];
			if (searchterm) {
				return searchterm;
			}

			return '';
		}
	}
}, {
	route: {
		path: '/PostAd/',
		exact: true
	},
	header: {
		show: false
	},
	pageType: 'PostAdSuccess',
	sticky: false,
	pPerformance: true,
	search: {
		show: false
	},
	footer: {
		show: false
	}
}, {
	route: { path: '/MyChats', exact: true },
	header: {
		show: false
	},
	pageType: 'MyChats',
	sticky: true,
	search: {
		show: false
	},
	footer: {
		show: false
	}

}, {
	route: {
		path: '/:catName(community|pets|matrimonial|events|entertainment|education-training)/post-classifieds-ads+:cityName?',
		exact: true
	},
	header: {
		show: false
	},
	pPerformance: true,
	pageType: 'PostAd Form',
	sticky: false,
	search: {
		show: false
	},
	footer: {
		show: false
	}
}, {
	route: { path: '/:catName(pets|community|events|matrimonial|entertainment)/:cityName?', exact: true },
	pageType: function pageType(location, match) {
		if (typeof match !== 'undefined') {
			var catName = match.params.catName;

			return catName + '_hp';
		}
		return '';
	},
	header: {
		show: true,
		searchCityCallback: function searchCityCallback(cityId, cityName, g_id, match) {
			if (cityName === 'all-India' || cityName === 'All India') {
				window.location = '/' + match.params.catName + '/all%2DIndia';
			} else {
				window.location = '/' + match.params.catName + '/' + cityName.toLowerCase();
			}
		}
	},
	sticky: false,
	search: { show: true },
	footer: { show: true },
	pPerformance: true,
	qrum: function qrum(location, match) {
		var catName = 'NA';
		if (typeof match !== 'undefined') {
			catName = match && match.params && match.params.catName;
		}
		var city = getCurrentCityId();
		var config = { CAT: catName, PTYPE: __WEBPACK_IMPORTED_MODULE_0_rum_pagetypes_src___default()('CORE_CHP_MOBILE'), CITY: city, JKID: getJKID() };
		return config;
	}
}, {
	route: { path: '/:cityName?', exact: true }, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
	header: {
		show: true
	},
	pageType: 'home',
	sticky: false,
	search: { show: true },
	footer: { show: true },
	pPerformance: true,
	qrum: function qrum(location, match) {
		var city = getCurrentCityId();
		var config = { PTYPE: __WEBPACK_IMPORTED_MODULE_0_rum_pagetypes_src___default()('CORE_HP_MOBILE'), CITY: city, JKID: getJKID() };
		return config;
	}
}];

/* harmony default export */ __webpack_exports__["a"] = (exampleConfig);

/***/ }),

/***/ "oj1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToolbarTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss__ = __webpack_require__("w/zb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_toolbar_mdc_toolbar_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */


/**
 * Create the component.
 */

var ToolbarTitle = function (_Component) {
  _inherits(ToolbarTitle, _Component);

  function ToolbarTitle() {
    _classCallCheck(this, ToolbarTitle);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ToolbarTitle.prototype.render = function render(_ref, state, context) {
    var className = _ref['class'],
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['class', 'children']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-toolbar__title', className);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      _extends({ 'class': classes }, props),
      children
    );
  };

  return ToolbarTitle;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "oqC1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p5EL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCityCookies; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_universal_cookie__ = __webpack_require__("/ErD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_q_mdc_elements_material_button__ = __webpack_require__("s7k+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__ = __webpack_require__("2BRZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_url__ = __webpack_require__("hnk3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_constants__ = __webpack_require__("QSFW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_ga__ = __webpack_require__("HP3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Search_UrlBuilder__ = __webpack_require__("4Pem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_GaHelper__ = __webpack_require__("8wV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_FetchHelper__ = __webpack_require__("Hm4v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__("upA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rum_pagetypes_src__ = __webpack_require__("eKXM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rum_pagetypes_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rum_pagetypes_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_Context__ = __webpack_require__("7xfs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_CustomEventService__ = __webpack_require__("OIb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_CandidateTest__ = __webpack_require__("EpF0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducers_SnbReducer_filter__ = __webpack_require__("VsV7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_Filter__ = __webpack_require__("WXY+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_Search__ = __webpack_require__("g4be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions_SnbContainerActions__ = __webpack_require__("T6SA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_windowActions__ = __webpack_require__("bhOV");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
























var suggestions = null;

function handlePostAdClick() {
  if (__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location) {
    __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.href = '/jobs/post-ad-jobs';
  }
}

function searchPlaceHolder() {
  var urlBuilder = new __WEBPACK_IMPORTED_MODULE_8__utils_Search_UrlBuilder__["a" /* default */]();
  var params = {};
  var snbParams = __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location && urlBuilder.parseSnbUrl(__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.pathname);
  if (snbParams && snbParams.role && snbParams.role.length > 0) {
    params.role = snbParams.role[0];
  }
  if (snbParams && snbParams.keyword && snbParams.keyword.length > 0) {
    params.keyword = snbParams.keyword[0];
  }

  var searchPlaceHolder = params.role ? params.role : params.keyword ? params.keyword : 'Search in Jobs';

  return searchPlaceHolder;
}

var setCityCookies = function setCityCookies(cityId, cityName) {
  var cookies = new __WEBPACK_IMPORTED_MODULE_2_universal_cookie__["a" /* default */]();
  if (!cityName || typeof cityName === 'undefined' || cityName === 'undefined' || !cityId || typeof cityId === 'undefined' || cityId === 'undefined') {
    if (getCurrentCity() === 'undefined' || getCurrentCityId() === 'undefined') {
      cookies.set('new_prefer_city', 'www', { path: '/', domain: '.quikr.com' });
      cookies.set('prefer_city_id', '1', { path: '/', domain: '.quikr.com' });
      cookies.set('new_prefer_city_id', '1', { path: '/', domain: '.quikr.com' });
    }
    return;
  }

  if (getCurrentCity() || getCurrentCityId()) {
    if (cityName.indexOf('x:') > -1) {
      // if abroad cities are selected, set the cookie with /jobs as path
      // so that quikr homepage does not redirect to {cityName}.quikr.com
      // and unset the cookies with / as path and domain other than .quikr.com
      cookies.set('new_prefer_city', cityName.replace('x:', ''), { path: '/jobs', domain: '.quikr.com' });
      cookies.set('new_prefer_city_id', cityId, { path: '/jobs', domain: '.quikr.com' });

      cookies.set('new_prefer_city', cityName.replace('x:', ''), { path: '/', domain: '.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city', cityName.replace('x:', ''), { path: '/', domain: 'www.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city', cityName.replace('x:', ''), { path: '/jobs', domain: 'www.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city_id', cityId, { path: '/', domain: '.quikr.com', expires: new Date(0) });
      cookies.set('prefer_city_id', cityId, { path: '/', domain: '.quikr.com', expires: new Date(0) });
    } else {
      // if indian cities are selected, set the cookie with / as path
      // and unset the cookies with /jobs as path and domain other than .quikr.com
      cookies.set('new_prefer_city', cityName.replace('x:', ''), { path: '/', domain: '.quikr.com' });
      cookies.set('new_prefer_city_id', cityId, { path: '/', domain: '.quikr.com' });
      cookies.set('prefer_city_id', cityId, { path: '/', domain: '.quikr.com' });

      cookies.set('new_prefer_city', cityName.replace('x:', ''), { path: '/jobs', domain: '.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city', cityName.replace('x:', ''), { path: '/', domain: 'www.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city', cityName.replace('x:', ''), { path: '/jobs', domain: 'www.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city_id', cityId, { path: '/jobs', domain: '.quikr.com', expires: new Date(0) });
    }
  }
};

function searchCityCallback(cityId, cityName, globalId, match) {
  setCityCookies(cityId, cityName);

  if (__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location && __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.pathname.replace(/\//g, '') === 'jobs') {
    __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.reload();
  } else {
    var urlBuilder = new __WEBPACK_IMPORTED_MODULE_8__utils_Search_UrlBuilder__["a" /* default */]();
    var params = { cityName: cityName };
    var snbParams = __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location && urlBuilder.parseSnbUrl(__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.pathname);
    if (snbParams && snbParams.role && snbParams.role.length > 0) {
      params.role = snbParams.role[0];
    }

    if (__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location) {
      __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.href = urlBuilder.getJobsSnbUrl(params);
    }
  }
}

function onSearchSubmit(keyword) {
  if (!keyword || keyword === '') {
    return;
  }

  var cityName = getCurrentCity();
  var urlBuilder = new __WEBPACK_IMPORTED_MODULE_8__utils_Search_UrlBuilder__["a" /* default */]();
  var params = { keyword: keyword, cityName: cityName };
  var url = urlBuilder.getJobsSnbUrl(params);

  __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.href = url;
  Object(__WEBPACK_IMPORTED_MODULE_9__utils_GaHelper__["b" /* firePageLoadGa */])('applyFilter', { pwa_candidate: 'freetextwosuggest' });
  if (typeof dataLayer != 'undefined') {
    dataLayer.push({ 'event': 'search', 'platform': 'pwa' });
  }
}

function onSearchCallback(event, updateSearchSuggestions, defaultSearchHandler) {
  var searchText = event.target.value;

  if (searchText && searchText !== '') {
    var fetchHelper = new __WEBPACK_IMPORTED_MODULE_10__utils_FetchHelper__["a" /* default */]();
    var params = {
      url: __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.protocol + '//www.quikr.com/jobs/jobsAjax/roleSearch?keyword=' + searchText
    };

    var suggestionsPromise = fetchHelper.request('get', params);

    suggestionsPromise.then(function (response) {
      var data = response.data ? response.data : {};
      if (data.success) {
        data = sortSearchResults(data.json, searchText);
        suggestions = getCustomSearchResults(data);
        updateSearchSuggestions(suggestions);
      }
    });
  } else {
    suggestions = null;
    updateSearchSuggestions(suggestions);
  }
}

function getCustomSearchResults(searchItems) {
  searchItems = searchItems ? searchItems : null;

  var title = 'Search Roles';
  if (!searchItems || searchItems.length === 0) {
    searchItems = [];
    __WEBPACK_IMPORTED_MODULE_6__src_constants__["P" /* TOP_ROLES */].forEach(function (value, i) {
      searchItems.push({ role: value.name });
    });
    title = 'Top Roles';
  }

  return getRoleItemElements(searchItems, title);
}

function getRoleItemElements(searchItems, title) {
  var searchList = [];
  searchItems.forEach(function (value, i) {
    searchList.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'li',
      { 'class': 'mdc-list-item', onClick: doRoleSearch },
      value.role
    ));

    if (value.suggestedSubrole) {
      value.suggestedSubrole.forEach(function (subrole, i) {
        searchList.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'li',
          { 'class': 'mdc-list-item', onClick: doRoleSearch,
            'data-href': subrole.url,
            style: 'padding-left: 20px;font-size: 0.85rem;' },
          subrole.subrole
        ));
      });
    }
  });

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'h5',
      null,
      title
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'ul',
      { 'class': 'mdc-list' },
      searchList
    )
  );
}

function doRoleSearch(event) {
  var url = event.target.getAttribute('data-href');
  var keyword = event.target.innerHTML;
  pushToRecentSearches(keyword);

  if (url) {
    __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.href = url;
  } else {
    var urlBuilder = new __WEBPACK_IMPORTED_MODULE_8__utils_Search_UrlBuilder__["a" /* default */]();

    var cityName = getCurrentCity();

    var params = { city: cityName, role: keyword };
    url = urlBuilder.getJobsSnbUrl(params);
    __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.href = url;
  }
  if (typeof dataLayer != 'undefined') {
    dataLayer.push({ 'event': 'search', 'platform': 'pwa' });
  }
  Object(__WEBPACK_IMPORTED_MODULE_9__utils_GaHelper__["b" /* firePageLoadGa */])('applyFilter', { pwa_candidate: 'freetextsuggest' });
}

function pushToRecentSearches(value) {
  // Add the search to recent searches
  if (__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.localStorage) {
    var recentSearches = localStorage.getItem('recentSearches');
    if (recentSearches) {
      recentSearches = recentSearches.split(',');
    } else {
      recentSearches = [];
    }
    // find the current value in recent searches,
    // if it exists delete it
    // or else if the length >= 3 then delete the last element
    var index = recentSearches.indexOf(value);
    if (index >= 0) {
      recentSearches.splice(index, 1);
    } else if (recentSearches.length >= 3) {
      recentSearches.pop();
    }
    // push the current value at the end
    recentSearches.unshift(value);
    localStorage.setItem('recentSearches', recentSearches);
  }
}

function sortSearchResults(data, searchText) {
  searchText = searchText.toLowerCase();

  data = data.sort(function (item1, item2) {
    var dataValue1 = item1['role'].toLowerCase();
    var indexOfDataValue1 = dataValue1.indexOf(searchText);
    indexOfDataValue1 = indexOfDataValue1 === -1 ? Number.MAX_SAFE_INTEGER : indexOfDataValue1;
    var dataValue2 = item2['role'].toLowerCase();
    var indexOfDataValue2 = dataValue2.indexOf(searchText);
    indexOfDataValue2 = indexOfDataValue2 === -1 ? Number.MAX_SAFE_INTEGER : indexOfDataValue2;

    if (indexOfDataValue1 < indexOfDataValue2) {
      return -1;
    } else if (indexOfDataValue1 > indexOfDataValue2) {
      return 1;
    } else {
      if (dataValue1 < dataValue2) {
        return -1;
      } else if (dataValue1 > dataValue2) {
        return 1;
      }
    }

    return 0;
  });

  return data;
}

function handleVapBackClick(event, history) {
  if (history.length > 1) {
    history.goBack();
  } else {
    if (history.location.pathname) {
      var cityName = getCurrentCity();

      var urlBuilder = new __WEBPACK_IMPORTED_MODULE_8__utils_Search_UrlBuilder__["a" /* default */]();
      var params = { city: cityName };

      if (typeof JobSnow !== 'undefined') {
        JobSnow.route = __WEBPACK_IMPORTED_MODULE_6__src_constants__["I" /* ROUTES */].SNB;
        JobSnow.isInterstialAdEnabled = __WEBPACK_IMPORTED_MODULE_13__utils_Context__["a" /* default */].isInterstitialAdEnabled('snbPWA', cityName);
        JobSnow.isFlyingCarpetAdEnabled = __WEBPACK_IMPORTED_MODULE_13__utils_Context__["a" /* default */].isFlyingCarpetAdEnabled('', cityName);
      }
      __WEBPACK_IMPORTED_MODULE_14__utils_CustomEventService__["a" /* default */].triggerEvent('loadGoogleAds', false);
      Object(__WEBPACK_IMPORTED_MODULE_11__utils__["F" /* updateInterstitialConfig */])('snbPWA');

      __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.href = urlBuilder.getJobsSnbUrl(params);
      // }
      JobSnow.route = __WEBPACK_IMPORTED_MODULE_6__src_constants__["I" /* ROUTES */].SNB;
      var isInterstialAdEnabledPrevious = JobSnow.isInterstialAdEnabled;
      JobSnow.isInterstialAdEnabled = __WEBPACK_IMPORTED_MODULE_13__utils_Context__["a" /* default */].isInterstitialAdEnabled('snbPWA', cityName);
      JobSnow.isFlyingCarpetAdEnabled = __WEBPACK_IMPORTED_MODULE_13__utils_Context__["a" /* default */].isFlyingCarpetAdEnabled('', cityName);
      // Event listening is required only when we move from a page (where interstitial ads were disabled) to a page (where interstitial ads are enabled).
      var isEventListeningRequired = JobSnow.isInterstialAdEnabled && !isInterstialAdEnabledPrevious;
      __WEBPACK_IMPORTED_MODULE_14__utils_CustomEventService__["a" /* default */].triggerEvent('loadGoogleAds', {
        isInitializeJobSnowRequired: false,
        isEventListeningRequired: isEventListeningRequired,
        isInterstitialAdEventDispatchRequired: false
      });
      Object(__WEBPACK_IMPORTED_MODULE_11__utils__["F" /* updateInterstitialConfig */])('snbPWA');
    }
  }
}

function handleCandidateTestBackClick() {

  __WEBPACK_IMPORTED_MODULE_15__utils_CandidateTest__["a" /* default */].fireGAOnClose();
  __WEBPACK_IMPORTED_MODULE_15__utils_CandidateTest__["a" /* default */].redirect();
}

function getCurrentCity() {
  var cookies = new __WEBPACK_IMPORTED_MODULE_2_universal_cookie__["a" /* default */]();
  return cookies.get('new_prefer_city') || 'www';
}

function getCurrentCityId() {
  var cookies = new __WEBPACK_IMPORTED_MODULE_2_universal_cookie__["a" /* default */]();
  return cookies.get('prefer_city_id') || '1';
}

function getJKID() {
  var cookies = new __WEBPACK_IMPORTED_MODULE_2_universal_cookie__["a" /* default */]();
  var jkidCookie = cookies.get('_jk_id') && cookies.get('_jk_id').split('.');
  return jkidCookie && jkidCookie[0];
}

function hideShellHeader() {
  var isAndroidRequest = __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location && new URLSearchParams(__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.search).get('isAndroidRequest');
  return !isAndroidRequest;
}

function getAppPromotionDetails() {
  if (typeof navigator !== 'undefined' && navigator.userAgent.match(/Android/i)) {
    var _window = window,
        _window$__PRELOADED_S = _window.__PRELOADED_STATE__;
    _window$__PRELOADED_S = _window$__PRELOADED_S === undefined ? {} : _window$__PRELOADED_S;
    var _window$__PRELOADED_S2 = _window$__PRELOADED_S.common;
    _window$__PRELOADED_S2 = _window$__PRELOADED_S2 === undefined ? {} : _window$__PRELOADED_S2;
    var _window$__PRELOADED_S3 = _window$__PRELOADED_S2.showBanner,
        showBanner = _window$__PRELOADED_S3 === undefined ? true : _window$__PRELOADED_S3;


    return showBanner;
  }
  return null;
}

var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_3_q_mdc_elements_material_button__["a" /* default */],
  { onClick: handlePostAdClick, key: '0', unelevated: true, compact: true,
    dense: true },
  'Post Free Ad'
);

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_3_q_mdc_elements_material_button__["a" /* default */],
  { onClick: handlePostAdClick, key: '0', unelevated: true, compact: true,
    dense: true },
  'Post Free Job'
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_3_q_mdc_elements_material_button__["a" /* default */],
  { onClick: handlePostAdClick, key: '0', unelevated: true, compact: true,
    dense: true },
  'Post Free Job'
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'mdc-toolbar__title gaurTitle' },
  'Guaranteed Job'
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'mdc-toolbar__title papTitle' },
  'Post Free Job In 30 Seconds'
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'mdc-toolbar__title shellTitle' },
  'Premium Services'
);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_3_q_mdc_elements_material_button__["a" /* default */],
  { onClick: handlePostAdClick, key: '0', unelevated: true, compact: true,
    dense: true },
  'Post Free Job'
);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'mdc-toolbar__title shellTitle' },
  'Survey'
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'mdc-toolbar__title shellTitle' },
  'Upgrade your free ad'
);

var jobsConfig = [{
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["j" /* HOME_PATH_REGEX */], exact: true },
  sticky: true,
  international: true,
  header: {
    international: true,
    hasTitle: true,
    show: true,
    toolbarItems: function toolbarItems(data) {
      return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], { key: 'snb', loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */], loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn }), _ref];
    },
    logoHref: '/jobs',
    hamburger: true,
    back: false,
    searchCityCallback: searchCityCallback
  },
  // ssr: true,
  actions: function actions(dispatch, routeInfo, cookies) {
    var params = {};

    var windowData = {
      locationPathname: routeInfo.url
    };
    var context = new __WEBPACK_IMPORTED_MODULE_13__utils_Context__["a" /* default */]();

    var actions = [
      // [dispatch(updateWindowData(windowData))],
      // context.initializeContextForHome(true, dispatch, cookies.cookies)
    ];
    return actions;
  },
  search: {
    show: true,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    showTrendingSearches: false,
    wallet: false
  },
  footer: { show: true },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] },
  qrum: function qrum(location, match) {
    var category = 'NA';
    if (typeof match !== 'undefined') {
      category = match && match.params && match.params.category;
    }
    var city = getCurrentCityId();
    var config = {
      PTYPE: __WEBPACK_IMPORTED_MODULE_12_rum_pagetypes_src___default()('JOBS_SSR_HOME_MOBILE'),
      CAT: category,
      CITY: city,
      JKID: getJKID()
    };

    return config;
  }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["x" /* SNB_PATH_REGEX */], exact: true },
  international: true,
  header: {
    international: true,
    hasTitle: true,
    show: true,
    toolbarItems: function toolbarItems(data) {
      return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], { key: 'snb', loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */], loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn }), _ref2];
    },
    logoHref: '/jobs',
    searchCityCallback: searchCityCallback,
    category: 'jobs',
    showBanner: getAppPromotionDetails(),
    gaPageType: 'SnB',
    viewinAppFAB: false
  },
  getCityNameFromRoute: function getCityNameFromRoute(res, cookies, routeInfo) {
    var urlBuilder = new __WEBPACK_IMPORTED_MODULE_8__utils_Search_UrlBuilder__["a" /* default */]();
    var snbUrl = routeInfo.url.split('?')[0];
    var snbParams = urlBuilder.parseSnbUrl(snbUrl);
    if (snbParams.city && snbParams.city.length > 0) {
      return snbParams.city[0];
    } else {
      return 'www';
    }
  },
  ssr: true,
  actions: function actions(dispatch, routeInfo, cookies) {
    var params = {};
    // const cityName = getCurrentCity();

    var windowData = {
      locationPathname: routeInfo.url
    };
    var urlBuilder = new __WEBPACK_IMPORTED_MODULE_8__utils_Search_UrlBuilder__["a" /* default */]();
    var context = new __WEBPACK_IMPORTED_MODULE_13__utils_Context__["a" /* default */]();
    var cityRoleFilter = {};

    var snbUrl = routeInfo.url.split('?')[0];
    var snbParams = urlBuilder.parseSnbUrl(snbUrl);
    if (snbParams.role && snbParams.role.length > 0) {
      params.role = snbParams.role[0];
      cityRoleFilter.role = snbParams.role;
    }
    if (snbParams.city && snbParams.city.length > 0) {
      params.city = snbParams.city[0];
      cityRoleFilter.city = snbParams.city;
    }
    params.source = 'SNB';

    var defaultFiltersObj = Object(__WEBPACK_IMPORTED_MODULE_11__utils__["c" /* copyObject */])(__WEBPACK_IMPORTED_MODULE_16__reducers_SnbReducer_filter__["b" /* defaultFilters */]);
    var searchParams = Object(__WEBPACK_IMPORTED_MODULE_17__utils_Filter__["f" /* setFiltersFromUrl */])(defaultFiltersObj, snbUrl, routeInfo.url);
    if (!searchParams.selectedFilters.city.length || !searchParams.selectedFilters.role.length) {
      cityRoleFilter.role = cityRoleFilter.role ? cityRoleFilter.role : [];
      cityRoleFilter.city = cityRoleFilter.city ? cityRoleFilter.city : [];
    }
    var defaultFilterLoadState = Object(__WEBPACK_IMPORTED_MODULE_11__utils__["c" /* copyObject */])(searchParams);
    _extends(searchParams.selectedFilters, { page: 1 }, cityRoleFilter);

    var actions = [[dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_windowActions__["b" /* updateWindowData */])(windowData))], [dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions_SnbContainerActions__["m" /* updateFilterState */])(defaultFilterLoadState))], context.initializeContext(params, true, dispatch, cookies.cookies), Object(__WEBPACK_IMPORTED_MODULE_18__utils_Search__["c" /* getSearchResultsPromise */])(searchParams.selectedFilters, null, true, dispatch, cookies.cookies)];
    return actions;
  },
  search: {
    show: true,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    showTrendingSearches: false,
    wallet: false
  },
  footer: { show: true },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] },
  qrum: function qrum(location, match) {
    var category = 'NA';
    if (typeof match !== 'undefined') {
      category = match && match.params && match.params.category;
    }
    var city = getCurrentCityId();
    var config = {
      PTYPE: __WEBPACK_IMPORTED_MODULE_12_rum_pagetypes_src___default()('JOBS_SSR_SNB_MOBILE'),
      CAT: category,
      CITY: city,
      JKID: getJKID()
    };

    return config;
  }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["E" /* VAP_PATH_REGEX */], exact: false },
  sticky: true,
  header: {
    international: true,
    hasTitle: true,
    show: true,
    toolbarItems: function toolbarItems(data) {
      return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], { key: 'vap', loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */], loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn }), _ref3];
    },
    logoHref: '/jobs',
    hamburger: false,
    back: true,
    handleBackClick: handleVapBackClick,
    searchCityCallback: searchCityCallback
  },
  ssr: true,
  actions: function actions(dispatch, routeInfo, cookies) {
    var data = {};
    var queryParams = void 0;
    if (routeInfo.params && routeInfo.params.queryParams) {
      queryParams = routeInfo.params.queryParams;
    }

    var windowData = {
      locationPathname: routeInfo.url
    };
    var urlBuilder = new __WEBPACK_IMPORTED_MODULE_8__utils_Search_UrlBuilder__["a" /* default */]();
    var context = new __WEBPACK_IMPORTED_MODULE_13__utils_Context__["a" /* default */]();

    var jobId = urlBuilder.getJobIdFromVapUrl(routeInfo.url);
    var actions = [[dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_windowActions__["b" /* updateWindowData */])(windowData))], context.initializeContext({ jobId: jobId }, true, dispatch, cookies.cookies, queryParams)];
    return actions;
  },
  search: {
    show: true,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    showTrendingSearches: false,
    wallet: false
  },
  footer: { show: true },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] },
  qrum: function qrum(location, match) {
    var category = 'NA';
    if (typeof match !== 'undefined') {
      category = match && match.params && match.params.category;
    }
    var city = getCurrentCityId();
    var config = {
      PTYPE: __WEBPACK_IMPORTED_MODULE_12_rum_pagetypes_src___default()('JOBS_SSR_VAP_MOBILE'),
      CAT: category,
      CITY: city,
      JKID: getJKID()
    };

    return config;
  }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["i" /* GUARANTEEDJOBS_PATH_REGEX */], exact: false },
  sticky: true,
  header: {
    international: true,
    hasTitle: false,
    show: true,
    hasLogo: false,
    toolbarItems: function toolbarItems(data) {
      return [_ref4];
    },
    logoHref: '/jobs',
    hamburger: false,
    back: true,
    searchCityCallback: searchCityCallback
  },
  search: {
    show: false,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    wallet: false
  },
  footer: { show: true },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] },
  qrum: function qrum(location, match) {
    var category = 'NA';
    if (typeof match !== 'undefined') {
      category = match && match.params && match.params.category;
    }
    var city = getCurrentCityId();
    var config = {
      PTYPE: __WEBPACK_IMPORTED_MODULE_12_rum_pagetypes_src___default()('JOBS_GUARANTEEDJOBS_MOBILE'),
      CAT: category,
      CITY: city,
      JKID: getJKID()
    };

    return config;
  }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["r" /* POST_AD_S1_PATH_REGEX */], exact: false },
  sticky: true,
  header: {
    international: true,
    hasTitle: false,
    show: hideShellHeader(),
    hasLogo: false,
    toolbarItems: function toolbarItems(data) {
      return [_ref5, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], { key: 'snb', loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */], loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn })];
    },
    logoHref: '/jobs',
    hamburger: false,
    back: true,
    searchCityCallback: searchCityCallback
  },
  search: {
    show: false,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    wallet: false
  },
  footer: { show: false },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] },
  qrum: function qrum(location, match) {
    var category = 'NA';
    if (typeof match !== 'undefined') {
      category = match && match.params && match.params.category;
    }
    var city = getCurrentCityId();
    var config = {
      PTYPE: __WEBPACK_IMPORTED_MODULE_12_rum_pagetypes_src___default()('JOBS_POST_AD_S1_MOBILE'),
      CAT: category,
      CITY: city,
      JKID: getJKID()
    };

    return config;
  }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["t" /* RECRUITMENT_ASSIST_LINK_PATH_REGEX */], exact: false },
  sticky: true,
  header: {
    international: true,
    hasTitle: false,
    show: true,
    hasLogo: false,
    toolbarItems: function toolbarItems(data) {
      return [_ref6, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], { key: 'snb', loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */], loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn })];
    },
    logoHref: '/jobs',
    hamburger: false,
    back: true,
    searchCityCallback: searchCityCallback
  },
  search: {
    show: false,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    wallet: false
  },
  footer: { show: true },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] },
  qrum: function qrum(location, match) {
    var category = 'NA';
    if (typeof match !== 'undefined') {
      category = match && match.params && match.params.category;
    }
    var city = getCurrentCityId();
    var config = {
      PTYPE: __WEBPACK_IMPORTED_MODULE_12_rum_pagetypes_src___default()('JOBS_RECRUITMENT_ASSIST_LINK_MOBILE'),
      CAT: category,
      CITY: city,
      JKID: getJKID()
    };

    return config;
  }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["k" /* JOBS_404 */], exact: false },
  sticky: true,
  header: {
    international: true,
    hasTitle: true,
    show: true,
    toolbarItems: function toolbarItems(data) {
      return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], { key: '404', loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */], loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn }), _ref7];
    },
    logoHref: '/jobs',
    hamburger: false,
    back: true,
    handleBackClick: handleVapBackClick,
    searchCityCallback: searchCityCallback
  },
  search: {
    show: true,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    showTrendingSearches: false,
    wallet: false
  },
  footer: { show: true },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] }
}, {
  route: {
    path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["c" /* CANDIDATE_TEST_LINK_PATH_REGEX */],
    exact: true
  },
  sticky: true,
  header: {
    international: false,
    hasTitle: false,
    show: true,
    hasLogo: false,
    toolbarItems: function toolbarItems(data) {
      return [_ref8, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], {
        key: 'candidateTest',
        loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */],
        loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn
      })];
    },
    logoHref: '/jobs',
    hamburger: false,
    back: true,
    searchCityCallback: searchCityCallback,
    handleBackClick: handleCandidateTestBackClick
  },
  search: {
    show: false,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults()
  },
  footer: {
    show: false
  },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["e" /* FLEXI_CANDIDATE_REGISTER */], exact: false },
  sticky: true,
  header: {
    international: false,
    hasTitle: false,
    show: true,
    toolbarItems: function toolbarItems(data) {
      return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], { key: 'vap', loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */], loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn })];
    },
    logoHref: '/jobs',
    hamburger: false,
    back: false,
    handleBackClick: handleVapBackClick,
    searchCityCallback: searchCityCallback
  },
  // ssr: true,
  actions: function actions(dispatch, routeInfo, cookies) {
    var actions = [];
    return actions;
  },
  search: {
    show: false,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    showTrendingSearches: false,
    wallet: false
  },
  footer: { show: false },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["d" /* FLEXI_CANDIDATE_PROFILE */], exact: false },
  sticky: true,
  header: {
    international: false,
    hasTitle: false,
    show: true,
    toolbarItems: function toolbarItems(data) {
      return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], { key: 'vap', loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */], loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn })];
    },
    logoHref: '/jobs',
    hamburger: false,
    back: false,
    handleBackClick: handleVapBackClick,
    searchCityCallback: searchCityCallback
  },
  // ssr: true,
  actions: function actions(dispatch, routeInfo, cookies) {
    var actions = [];
    return actions;
  },
  search: {
    show: false,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    showTrendingSearches: false,
    wallet: false
  },
  footer: { show: false },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["f" /* FLEXI_CANDIDATE_RMT_DATA_CAPTURE */], exact: false },
  sticky: true,
  header: {
    international: false,
    hasTitle: false,
    show: true,
    toolbarItems: function toolbarItems(data) {
      return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], { key: 'vap', loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */], loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn })];
    },
    logoHref: '/jobs',
    hamburger: false,
    back: false,
    handleBackClick: handleVapBackClick,
    searchCityCallback: searchCityCallback
  },
  // ssr: true,
  actions: function actions(dispatch, routeInfo, cookies) {
    var actions = [];
    return actions;
  },
  search: {
    show: false,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    showTrendingSearches: false,
    wallet: false
  },
  footer: { show: false },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["g" /* FLEXI_RECRUITER_RMT_REPORT */], exact: false },
  sticky: true,
  header: {
    international: true,
    hasTitle: true,
    show: true,
    toolbarItems: function toolbarItems(data) {
      return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_q_components_components_myAccount__["a" /* default */], { key: 'vap', loggedOutMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["v" /* LOGGEDOUT_MENU */], loggedInMenu: __WEBPACK_IMPORTED_MODULE_6__src_constants__["u" /* LOGGEDIN_MENU */],
        isLoggedIn: data.isLoggedIn })];
    },
    logoHref: '/jobs',
    hamburger: false,
    back: true,
    handleBackClick: handleVapBackClick,
    searchCityCallback: searchCityCallback
  },
  // ssr: true,
  actions: function actions(dispatch, routeInfo, cookies) {
    var actions = [];
    return actions;
  },
  search: {
    show: false,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    showTrendingSearches: false,
    wallet: false
  },
  footer: { show: false },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] }
}, {
  route: { path: __WEBPACK_IMPORTED_MODULE_5__constants_url__["A" /* UPGRADE_AD */], exact: false },
  sticky: true,
  header: {
    international: false,
    hasTitle: false,
    show: true,
    toolbarItems: function toolbarItems(data) {
      return [_ref9];
    },
    hasLogo: false,
    hamburger: false,
    back: true,
    handleBackClick: handleVapBackClick,
    searchCityCallback: searchCityCallback
  },
  // ssr: true,
  actions: function actions(dispatch, routeInfo, cookies) {
    var actions = [];
    return actions;
  },
  search: {
    show: false,
    placeholder: searchPlaceHolder(),
    onSearchSubmit: onSearchSubmit,
    onSearchCallback: onSearchCallback,
    searchSuggestions: getCustomSearchResults(),
    showTrendingSearches: false,
    wallet: false
  },
  footer: { show: false },
  ga: { accountId: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["b" /* GA_ACCOUNT_ID */], trackerName: __WEBPACK_IMPORTED_MODULE_7__constants_ga__["c" /* GA_TRACKER_NAME */] }
}];

/* harmony default export */ __webpack_exports__["a"] = (jobsConfig);

/***/ }),

/***/ "pTcH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.default = void 0;var _default = "<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"wpn_modal_icon\" viewBox=\"0 0 72 72\"><path fill=\"#AAD5E9\" d=\"M36.7,59l-10.5-3.7c-3.2-1.1-4.9-4.6-3.8-7.8c0.2-0.5,0.4-1,0.8-1.5H8.9c-1.1,0-2-0.9-2-2s0.9-2,2-2h21c2.3-1.4,4.1-3.6,5-6.2l0-0.1H8.9c-1.1,0-2-0.9-2-2s0.9-2,2-2h27.4l0.7-2c0.9-2.7,2.5-5,4.4-6.8h-33c-3.9,0-7.1,3.2-7.1,7.1v25c0,3.9,3.2,7.1,7.1,7.1h27.9L36.7,59z M11,57.8c-1.4-3.9-4.8-3-4.8-3c3.3-1,1.8-5.6,1.8-5.6c1.6,4.3,4.8,3.3,4.8,3.3C9.7,53.5,11,57.8,11,57.8z M40.4,38.1c0,0,2.9-15.7,14.1-15.2c0,0-9.1,4.5-10.3,16.5L40.4,38.1z\"/><path fill=\"#231F20\" d=\"M69.1,57.1c-1.8-2.9-2.1-6.5-1-9.7l2.2-6.2c2.5-7.1,0.1-14.7-5.2-19.3c0.8-1,1.3-2.4,1.3-3.8c0-3.4-2.7-6.1-6.1-6.1c-3.2,0-5.8,2.5-6.1,5.6c-2.9-0.1-5.8,0.5-8.4,1.8c-4.3,2.1-7.5,5.7-9,10.2l-2.1,6.1c-1.1,3.3-3.7,5.9-7,7.1L26,43.1c-1.9,0.7-3.4,2.2-4.1,4.1c-1.2,3.5,0.6,7.3,4.1,8.5l10.1,3.5c-0.2,0.7-0.3,1.4-0.3,2.2c0,4.7,3.8,8.5,8.4,8.5c3.5,0,6.5-2.1,7.8-5.1l9.9,3.4c0.7,0.3,1.5,0.4,2.2,0.4c2.8,0,5.4-1.7,6.3-4.5c0.6-1.9,0.4-4-0.6-5.7L69.1,57.1z M60.2,12.9c2.8,0,5.1,2.3,5.1,5.1c0,1.2-0.4,2.3-1.1,3.2c-1.5-1.1-3.1-2-4.9-2.7c-1.4-0.5-2.7-0.8-4.1-0.9C55.3,14.9,57.5,12.9,60.2,12.9z M44.3,68.9c-4.1,0-7.4-3.3-7.4-7.5c0-0.6,0.1-1.3,0.2-1.9l14,4.9C49.9,67.1,47.3,68.9,44.3,68.9z M36.5,58.3l-10.1-3.5c-2.9-1-4.5-4.3-3.5-7.2c0.6-1.6,1.8-2.9,3.5-3.5l1.5-0.5c3.6-1.3,6.3-4.1,7.6-7.7l2.1-6.1c1.5-4.2,4.5-7.7,8.5-9.6c2.3-1.1,4.8-1.7,7.3-1.7l1.7,0.1c1.3,0.1,2.5,0.4,3.8,0.8c1.7,0.6,3.2,1.4,4.6,2.5l0.8,0.7c5.1,4.4,7.3,11.6,5,18.3L67.1,47c-1.2,3.5-0.8,7.4,1.1,10.6l0.8,1.3c0.9,1.5,1.1,3.2,0.5,4.9c-1,3-4.3,4.5-7.2,3.5l-9.9-3.4\"/><path fill=\"#BDDFB8\" d=\"M22.5,2.6c0,0,2.7,8.2-3.1,10.1c0,0,6.1-1.6,8.6,5.3c0,0-2.3-7.7,3.2-9.6C31.1,8.4,25.3,10.3,22.5,2.6z M59.1,46.1c0,0-2.8,5.7-6.8,3.6c0,0,4,2.3,1.7,7.2c0,0,2.8-5.2,6.6-3.3C60.5,53.6,56.6,51.6,59.1,46.1z\"/></svg>";exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"wpn_modal_icon\" viewBox=\"0 0 72 72\"><path fill=\"#AAD5E9\" d=\"M36.7,59l-10.5-3.7c-3.2-1.1-4.9-4.6-3.8-7.8c0.2-0.5,0.4-1,0.8-1.5H8.9c-1.1,0-2-0.9-2-2s0.9-2,2-2h21c2.3-1.4,4.1-3.6,5-6.2l0-0.1H8.9c-1.1,0-2-0.9-2-2s0.9-2,2-2h27.4l0.7-2c0.9-2.7,2.5-5,4.4-6.8h-33c-3.9,0-7.1,3.2-7.1,7.1v25c0,3.9,3.2,7.1,7.1,7.1h27.9L36.7,59z M11,57.8c-1.4-3.9-4.8-3-4.8-3c3.3-1,1.8-5.6,1.8-5.6c1.6,4.3,4.8,3.3,4.8,3.3C9.7,53.5,11,57.8,11,57.8z M40.4,38.1c0,0,2.9-15.7,14.1-15.2c0,0-9.1,4.5-10.3,16.5L40.4,38.1z\"/><path fill=\"#231F20\" d=\"M69.1,57.1c-1.8-2.9-2.1-6.5-1-9.7l2.2-6.2c2.5-7.1,0.1-14.7-5.2-19.3c0.8-1,1.3-2.4,1.3-3.8c0-3.4-2.7-6.1-6.1-6.1c-3.2,0-5.8,2.5-6.1,5.6c-2.9-0.1-5.8,0.5-8.4,1.8c-4.3,2.1-7.5,5.7-9,10.2l-2.1,6.1c-1.1,3.3-3.7,5.9-7,7.1L26,43.1c-1.9,0.7-3.4,2.2-4.1,4.1c-1.2,3.5,0.6,7.3,4.1,8.5l10.1,3.5c-0.2,0.7-0.3,1.4-0.3,2.2c0,4.7,3.8,8.5,8.4,8.5c3.5,0,6.5-2.1,7.8-5.1l9.9,3.4c0.7,0.3,1.5,0.4,2.2,0.4c2.8,0,5.4-1.7,6.3-4.5c0.6-1.9,0.4-4-0.6-5.7L69.1,57.1z M60.2,12.9c2.8,0,5.1,2.3,5.1,5.1c0,1.2-0.4,2.3-1.1,3.2c-1.5-1.1-3.1-2-4.9-2.7c-1.4-0.5-2.7-0.8-4.1-0.9C55.3,14.9,57.5,12.9,60.2,12.9z M44.3,68.9c-4.1,0-7.4-3.3-7.4-7.5c0-0.6,0.1-1.3,0.2-1.9l14,4.9C49.9,67.1,47.3,68.9,44.3,68.9z M36.5,58.3l-10.1-3.5c-2.9-1-4.5-4.3-3.5-7.2c0.6-1.6,1.8-2.9,3.5-3.5l1.5-0.5c3.6-1.3,6.3-4.1,7.6-7.7l2.1-6.1c1.5-4.2,4.5-7.7,8.5-9.6c2.3-1.1,4.8-1.7,7.3-1.7l1.7,0.1c1.3,0.1,2.5,0.4,3.8,0.8c1.7,0.6,3.2,1.4,4.6,2.5l0.8,0.7c5.1,4.4,7.3,11.6,5,18.3L67.1,47c-1.2,3.5-0.8,7.4,1.1,10.6l0.8,1.3c0.9,1.5,1.1,3.2,0.5,4.9c-1,3-4.3,4.5-7.2,3.5l-9.9-3.4\"/><path fill=\"#BDDFB8\" d=\"M22.5,2.6c0,0,2.7,8.2-3.1,10.1c0,0,6.1-1.6,8.6,5.3c0,0-2.3-7.7,3.2-9.6C31.1,8.4,25.3,10.3,22.5,2.6z M59.1,46.1c0,0-2.8,5.7-6.8,3.6c0,0,4,2.3,1.7,7.2c0,0,2.8-5.2,6.6-3.3C60.5,53.6,56.6,51.6,59.1,46.1z\"/></svg>";

/***/ }),

/***/ "pUo6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__ = __webpack_require__("9mGc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_JobsPostAd__ = __webpack_require__("/gj+");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var defaultState = {
  step: 0,

  isFlexiUser: false,

  candidateMobile: {
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: 'candidateMobile' }).get(),
    options: [],
    label: 'Mobile Number*',
    disabled: false
  },
  candidateOtp: {
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: 'candidateOtp' }).get(),
    options: [],
    label: 'OTP'
  },
  name: {
    value: '',
    show: true,
    disabled: false,
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: 'name' }).get(),
    label: 'Name'
  },
  email: {
    value: '',
    show: true,
    disabled: false,
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: 'email' }).get(),
    label: 'Email'
  },
  city: {
    options: [],
    value: '',
    id: '',
    apiUrl: '/jobs/jobsAjax/getAllCities',
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: __WEBPACK_IMPORTED_MODULE_1__utils_JobsPostAd__["d" /* POST_AD_FIELDS */].CITY }).get()
  },
  locality: {
    apiUrl: '/jobs/jobsAjax/localitySearch?cityName=',
    value: [],
    disabled: true,
    show: true,
    maxLimit: 5,
    fullCity: {
      display: '',
      show: false
    },
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: __WEBPACK_IMPORTED_MODULE_1__utils_JobsPostAd__["d" /* POST_AD_FIELDS */].LOCALITY }).get()
  },
  role: {
    options: [],
    // id: '',
    valueObject: {},
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: __WEBPACK_IMPORTED_MODULE_1__utils_JobsPostAd__["d" /* POST_AD_FIELDS */].ROLE }).get(),
    others: '',
    disabled: false
  },
  subRole: {
    subList: [],
    show: true,
    value: [],
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: __WEBPACK_IMPORTED_MODULE_1__utils_JobsPostAd__["d" /* POST_AD_FIELDS */].SUB_ROLE }).get(),
    others: ''
  },
  moveToRmt: {
    checked: false
  },
  others: {
    formType: 'FLEXI_CANDIDATE_STEP_0',
    message: '',
    customErrorField: ''
  },

  otpObject: {
    verifyMobile: null,
    isMobileAvailable: 0,
    fromSource: 'FlexiCandidate'
  },

  context: {
    profileType: 'NEW',
    rmtOptions: {}
  },

  showSuccessPopup: false,

  candidateProfileId: null,
  candidateUser: null,
  candidateProfile: {},
  candidateProfileRsa: {},
  candidateProfiles: [],
  candidateQuestions: [],
  candidateProfileStep: 0,
  candidateProfileRequest: {
    'sortType': 3,
    'filters': {
      'profileIdList': [],
      'roleIdList': [],
      'userIdList': []
    },
    'count': 20,
    'offset': 0
  },
  candidateProfileQuestions: [],
  flexiContextUpdatedInStore: false,
  flexiUserDetailsUpdatedInStore: false,

  recruiterProfileStep: 0,
  recruiterFolder: {
    show: true,
    id: '',
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: 'recruiterFolder' }).get(),
    others: ''
  },
  recruiterStatus: {
    show: true,
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: 'recruiterStatus' }).get(),
    others: ''
  },
  recruiterType: {
    show: true,
    value: '',
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: 'recruiterType' }).get(),
    others: ''
  },
  recruiterComment: {
    value: '',
    show: true,
    disabled: false,
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: 'recruiterComment' }).get(),
    others: ''
  },
  recruiterDateOfAction: {
    value: '',
    show: true,
    disabled: false,
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: 'recruiterDateOfAction' }).get(),
    others: ''
  },
  recruiterTimeOfAction: {
    value: '',
    show: true,
    disabled: false,
    message: new __WEBPACK_IMPORTED_MODULE_0__utils_JobsPostAd_message__["a" /* Message */](1, 0, '', { field: 'recruiterTimeOfAction' }).get(),
    others: ''
  }
};

var flexiCandidateReducer = function flexiCandidateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var actions = arguments[1];

  switch (actions.type) {
    case 'UPDATE_FLEXI_CANDIDATE_STATE':
      {
        state = _extends({}, state, actions.payload);
        break;
      }
  }

  return state;
};

/* harmony default export */ __webpack_exports__["a"] = (flexiCandidateReducer);

/***/ }),

/***/ "q78h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M60.79,64.29H11.21c-2.96,0-5.36-2.41-5.36-5.36V18.48c0-0.02,0-0.04,0-0.07c0-0.05,0-0.1,0-0.15 c0-3.23,2.63-5.85,5.85-5.85h26.1l8.63-4.57c0.28-0.15,0.61-0.17,0.91-0.07c0.3,0.1,0.54,0.32,0.68,0.61l1.85,4.03h5.83 c2.96,0,5.36,2.41,5.36,5.36v4.05c2.83,0.14,5.09,2.49,5.09,5.36v31.74C66.15,61.88,63.74,64.29,60.79,64.29z M8.15,22.92v36.01 c0,1.69,1.37,3.06,3.06,3.06h49.57c1.69,0,3.06-1.37,3.06-3.06v-8.2h-7.46c-4.05,0-7.35-3.3-7.35-7.35s3.3-7.35,7.35-7.35h7.46 v-8.84c0-1.69-1.37-3.06-3.06-3.06h-7.32c-0.02,0-0.03,0-0.05,0H20.35c-0.01,0-0.03,0-0.05,0h-8.6 C10.37,24.12,9.14,23.67,8.15,22.92z M56.39,38.33c-2.78,0-5.05,2.26-5.05,5.05s2.27,5.05,5.05,5.05h7.46v-10.1H56.39z M54.18,21.82 h4.58v-4.04c0-1.69-1.37-3.06-3.06-3.06h-4.77L54.18,21.82z M24.95,21.82h26.69l-5.21-11.37l-7.61,4.03 c-0.1,0.08-0.22,0.14-0.34,0.18L24.95,21.82z M11.7,14.71c-1.96,0-3.55,1.59-3.55,3.55s1.59,3.55,3.55,3.55h8.34l13.42-7.1H11.7z M56.93,44.44h-0.26c-0.64,0-1.15-0.52-1.15-1.15s0.51-1.15,1.15-1.15h0.26c0.64,0,1.15,0.52,1.15,1.15S57.57,44.44,56.93,44.44z" });

var QuikrWallet = function QuikrWallet(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ id: "share", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};

/* harmony default export */ __webpack_exports__["a"] = (QuikrWallet);

/***/ }),

/***/ "r+dl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),

/***/ "rCO2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("bEy/");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),

/***/ "rZFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isempty__ = __webpack_require__("feQy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isempty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isempty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss__ = __webpack_require__("2Pi1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_scss__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// Import the component as we are using the same classes that are used by mdc dialog
// import Dialog from '../../../elements/material-dialog';



var CustomDialog = function (_Component) {
	_inherits(CustomDialog, _Component);

	function CustomDialog(props) {
		_classCallCheck(this, CustomDialog);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.handleClose = function (e) {
			var _this$props = _this.props,
			    showDialog = _this$props.showDialog,
			    onClose = _this$props.onClose;


			if (showDialog && typeof onClose === 'function') {
				onClose(e);
			}
		};

		_this.isFooter = function (footer) {
			if ((typeof footer === 'function' || !__WEBPACK_IMPORTED_MODULE_1_lodash_isempty___default()(footer)) && _this.props.full) {
				return true;
			}
			return false;
		};

		_this.addedScrollLockClass = false;
		_this.makeFooterPositionFixed = false;
		_this.id = new Date().getTime() + '';
		return _this;
	}

	CustomDialog.prototype.componentDidMount = function componentDidMount() {
		// window.addEventListener('click', this.handleClose);

		if (this.props.showDialog) {
			var body = document.getElementsByTagName('body')[0];
			if (!body.classList.contains('custom-dialog-scroll-lock')) {
				body.classList.add('custom-dialog-scroll-lock');
				this.addedScrollLockClass = true;
			}
		}
	};

	CustomDialog.prototype.componentDidUpdate = function componentDidUpdate() {
		if (this.props.showDialog) {
			var body = document.getElementsByTagName('body')[0];
			if (!body.classList.contains('custom-dialog-scroll-lock')) {
				body.classList.add('custom-dialog-scroll-lock');
				this.addedScrollLockClass = true;
			}
		} else if (this.addedScrollLockClass) {
			var _body = document.getElementsByTagName('body')[0];
			if (_body.classList.contains('custom-dialog-scroll-lock')) {
				_body.classList.remove('custom-dialog-scroll-lock');
				this.addedScrollLockClass = false;
			}
		}

		if (this.props.showDialog && this.props.sticky && this.footerRef) {
			var footerHeight = this.footerRef.getBoundingClientRect().height;
			var dialogBody = document.getElementById(this.id + '_body');
			if (dialogBody && dialogBody.style) {
				dialogBody.style.marginBottom = footerHeight + 'px';
			}
		}
	};

	CustomDialog.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this.addedScrollLockClass) {
			var body = document.getElementsByTagName('body')[0];
			if (body.classList.contains('custom-dialog-scroll-lock')) {
				body.classList.remove('custom-dialog-scroll-lock');
				this.addedScrollLockClass = false;
			}
		}
	};

	CustomDialog.prototype.render = function render() {
		var _this2 = this;

		var _props = this.props,
		    _props$showDialog = _props.showDialog,
		    showDialog = _props$showDialog === undefined ? false : _props$showDialog,
		    header = _props.header,
		    footer = _props.footer,
		    body = _props.body,
		    bodyClass = _props.bodyClass,
		    className = _props.className,
		    _props$full = _props.full,
		    full = _props$full === undefined ? false : _props$full,
		    footerClass = _props.footerClass,
		    sticky = _props.sticky;


		if (!showDialog) {
			return null;
		}

		// return (<div class={`mdc-dialog mdc-dialog--animating mdc-dialog--open ${className ? className : ''}`}>
		// 	<div class={`mdc-dialog__surface ${full && 'mdc-dialog__full'} ${!full && 'mdc-dialog__sm'}`}>
		// 		{header && <div ref={(ref) => { this.headerRef = ref; }} class="mdc-dialog__header">
		// 			{typeof header === 'function' ? header() : header}
		// 		</div>}
		// 		{body && <section ref={(ref) => { this.bodyRef = ref; }} class={`mdc-dialog__body mdc-dialog__body--scrollable ${bodyClass ? bodyClass : ''} ${this.isFooter(footer) ? 'footer--space' : ''}`}>
		// 			{typeof body === 'function' ? body() : body}
		// 		</section>}
		// 		{footer && <div ref={(ref) => { this.footerRef = ref; }} class={`mdc-dialog__footer ${footerClass ? footerClass : ''}`}>
		// 			{typeof footer === 'function' ? footer() : footer}
		// 		</div>}
		// 	</div>
		// 	<div class="mdc-dialog__overlay"></div>
		// </div>);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			BaseModal,
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'custom-dialog custom-dialog--animating custom-dialog--open ' + (className ? className : '') },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': 'custom-dialog__surface ' + (full && 'custom-dialog__full') },
					header && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ ref: function ref(_ref) {
								_this2.headerRef = _ref;
							}, 'class': 'custom-dialog__header' },
						typeof header === 'function' ? header() : header
					),
					body && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'section',
						{ ref: function ref(_ref3) {
								_this2.bodyRef = _ref3;
							}, 'class': 'custom-dialog__body ' + (full ? 'custom-dialog__body--scrollable' : '') + ' ' + (bodyClass ? bodyClass : '') },
						typeof body === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ id: this.id + '_body' },
							body()
						) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ id: this.id + '_body' },
							body
						),
						footer && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ ref: function ref(_ref2) {
									_this2.footerRef = _ref2;
								}, 'class': 'custom-dialog__footer ' + (footerClass ? footerClass : '') + (sticky ? 'sticky' : '') },
							typeof footer === 'function' ? footer() : footer
						)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'custom-dialog__overlay', onClick: this.handleClose })
			)
		);
	};

	return CustomDialog;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



var ContextProvider = function (_Component2) {
	_inherits(ContextProvider, _Component2);

	function ContextProvider() {
		_classCallCheck(this, ContextProvider);

		return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	ContextProvider.prototype.getChildContext = function getChildContext() {
		return this.props.context;
	};

	ContextProvider.prototype.render = function render() {
		return this.props.children && this.props.children[0];
	};

	return ContextProvider;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', null);

var BaseModal = function (_Component3) {
	_inherits(BaseModal, _Component3);

	BaseModal.prototype.renderChildren = function renderChildren() {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ id: this.id },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				ContextProvider,
				{ context: this.context },
				this.props.children
			)
		);
	};

	function BaseModal(props) {
		_classCallCheck(this, BaseModal);

		var _this4 = _possibleConstructorReturn(this, _Component3.call(this, props));

		_this4.id = new Date().getTime() + '';
		_this4.element = '';
		return _this4;
	}

	// Using WillMount isntead of DidMount to make ref's available in parent components


	BaseModal.prototype.componentWillMount = function componentWillMount() {
		this.target = document.getElementById('modal-div');
		if (!this.target) {
			var el = document.createElement('div');
			el.setAttribute('id', 'modal-div');
			document.body.appendChild(el);
			this.target = el;
		}
		this.element = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["render"])(this.renderChildren(), this.target);
	};

	BaseModal.prototype.componentDidUpdate = function componentDidUpdate() {
		this.element = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["render"])(this.renderChildren(), this.target, this.element);
	};

	BaseModal.prototype.componentWillUnmount = function componentWillUnmount() {
		var element = this.element;
		if (element && element.parentElement) {
			element.parentElement.removeChild(this.element);
		}
	};

	BaseModal.prototype.render = function render() {
		return _ref4;
	};

	return BaseModal;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),

/***/ "rqos":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QPost; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("Qq+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_supports_webp__ = __webpack_require__("KIDv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_supports_webp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_supports_webp__);
/**
 * Written by Manish Singh on 3/29/18.
 */




var options = {};
if (__WEBPACK_IMPORTED_MODULE_2_supports_webp___default.a) {
    options['headers'] = {
        'Accept': 'image/webp, */*'
    };
}

var QGet = function QGet(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, options).then(function (data) {
        return data.data;
    });
};
var QPost = function QPost(url, data) {
    var params = new URLSearchParams();
    for (var i in data) {
        if (data.hasOwnProperty(i)) {
            params.append(i, data[i]);
        }
    }
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, params, options).then(function (data) {
        return data.data;
    });
};

//fetch(href).then(response => response.json())



/***/ }),

/***/ "s+cM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.default = getPushSubscription;function getPushSubscription() {
  var a = this;return new Promise(function (b, c) {
    a.swRegistration ? a.swRegistration.pushManager.getSubscription().then(function (c) {
      a.pushSubscription = c, b(c);
    }) : c(new Error("Service Worker registration unavailable. Please initialize."));
  });
}

/***/ }),

/***/ "s7k+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ripple__ = __webpack_require__("Atye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_button_mdc_button_scss__ = __webpack_require__("SN0Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_button_mdc_button_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_button_mdc_button_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_scss__ = __webpack_require__("bcDK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */




/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */



/**
 * Create the component.
 */

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.componentDidMount = function () {
      setTimeout(function () {
        var rippleInstance = Object(__WEBPACK_IMPORTED_MODULE_2__material_ripple__["a" /* default */])(_this.root_);
        _this.setState({ style: rippleInstance.style });
      });
    };

    _this.handleFocus = function (e) {
      _this.setState({ focus: true });
      _this.props.onFocus && _this.props.onFocus(e);
    };

    _this.handleBlur = function (e) {
      _this.setState({ focus: false });
      _this.props.onBlur && _this.props.onBlur(e);
    };

    _this.handleClick = function (e) {
      var rippleInstance = Object(__WEBPACK_IMPORTED_MODULE_2__material_ripple__["a" /* default */])(_this.root_);
      _this.setState({ ripple: true, style: rippleInstance.style });
      setTimeout(function () {
        _this.setState({ ripple: false });
      }, rippleInstance.duration);
      _this.props.onClick && _this.props.onClick(e);
    };

    _this.state = {
      focus: false,
      ripple: false,
      style: ''
    };
    return _this;
  }

  Button.prototype.render = function render(_ref, _ref2, context) {
    var _this2 = this;

    var focus = _ref2.focus,
        ripple = _ref2.ripple,
        style = _ref2.style;

    var className = _ref['class'],
        children = _ref.children,
        compact = _ref.compact,
        primary = _ref.primary,
        accent = _ref.accent,
        raised = _ref.raised,
        dense = _ref.dense,
        unelevated = _ref.unelevated,
        stroked = _ref.stroked,
        noBorderRadius = _ref.noBorderRadius,
        full = _ref.full,
        half = _ref.half,
        onFocus = _ref.onFocus,
        onBlur = _ref.onBlur,
        onClick = _ref.onClick,
        props = _objectWithoutProperties(_ref, ['class', 'children', 'compact', 'primary', 'accent', 'raised', 'dense', 'unelevated', 'stroked', 'noBorderRadius', 'full', 'half', 'onFocus', 'onBlur', 'onClick']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-button mdc-ripple-upgraded mdc-ripple-upgraded--unbounded', {
      'mdc-button--compact': compact,
      'mdc-button--primary': primary,
      'mdc-button--accent': accent,
      'mdc-button--raised': raised,
      'mdc-button--dense': dense,
      'mdc-button--unelevated': unelevated,
      'mdc-button--stroked': stroked,
      'mdc-ripple-upgraded--background-active-fill': ripple,
      'mdc-ripple-upgraded--foreground-activation': ripple,
      'mdc-ripple-upgraded--foreground-deactivation': !ripple,
      'mdc-ripple-upgraded--background-focused': focus,
      'mdc-button__no-border-radius': noBorderRadius,
      'mdc-button__width-full': full,
      'mdc-button__width-half': half
    }, className);

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'button',
      _extends({ 'class': classes,
        style: style,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick
      }, props, {
        ref: function ref(e) {
          return _this2.root_ = e;
        } }),
      children
    );
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "sPP5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sRYg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_list_mdc_list_scss__ = __webpack_require__("hP+K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_list_mdc_list_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_list_mdc_list_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss__ = __webpack_require__("2oDr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import styles.
 */


/**
 * Import local dependencies.
 */

/**
 * Create the component.
 */

var List = function (_Component) {
  _inherits(List, _Component);

  function List() {
    _classCallCheck(this, List);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  List.prototype.render = function render(_ref, state, context) {
    var className = _ref['class'],
        children = _ref.children,
        links = _ref.links,
        dense = _ref.dense,
        twoLine = _ref.twoLine,
        avatar = _ref.avatar,
        props = _objectWithoutProperties(_ref, ['class', 'children', 'links', 'dense', 'twoLine', 'avatar']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-list', {
      'mdc-list--dense': dense,
      'mdc-list--two-line': twoLine,
      'mdc-list--avatar-list': avatar
    }, className);
    return links ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      _extends({ 'class': classes }, props),
      children
    ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'ul',
      _extends({ 'class': classes }, props),
      children
    );
  };

  return List;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "sTIH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



/***/ }),

/***/ "stbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../warning/warning.js
var warning = __webpack_require__("r+dl");
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);

// EXTERNAL MODULE: ../preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("CK2z");

// EXTERNAL MODULE: ../prop-types/index.js
var prop_types = __webpack_require__("yy8s");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ../history/esm/history.js
var esm_history = __webpack_require__("g7YX");

// EXTERNAL MODULE: ../invariant/browser.js
var browser = __webpack_require__("iXy7");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ../react-router/es/Router.js
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}






/**
 * The public API for putting history on context.
 */

var Router_Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;

    browser_default()(children == null || preact_compat_es["default"].Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    warning_default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? preact_compat_es["default"].Children.only(children) : null;
  };

  return Router;
}(preact_compat_es["default"].Component);

Router_Router.propTypes = {
  history: prop_types_default.a.object.isRequired,
  children: prop_types_default.a.node
};
Router_Router.contextTypes = {
  router: prop_types_default.a.object
};
Router_Router.childContextTypes = {
  router: prop_types_default.a.object.isRequired
};

/* harmony default export */ var es_Router = (Router_Router);
// CONCATENATED MODULE: ../react-router-dom/es/Router.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Router = (es_Router);
// CONCATENATED MODULE: ../react-router-dom/es/BrowserRouter.js
function BrowserRouter__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function BrowserRouter__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function BrowserRouter__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter_BrowserRouter = function (_React$Component) {
  BrowserRouter__inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    BrowserRouter__classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = BrowserRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(esm_history["a" /* createBrowserHistory */])(_this.props), _temp), BrowserRouter__possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return preact_compat_es["default"].createElement(react_router_dom_es_Router, { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(preact_compat_es["default"].Component);

/* harmony default export */ var es_BrowserRouter = (BrowserRouter_BrowserRouter);
// CONCATENATED MODULE: ../react-router-dom/es/HashRouter.js
function HashRouter__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function HashRouter__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function HashRouter__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter_HashRouter = function (_React$Component) {
  HashRouter__inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    HashRouter__classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HashRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(esm_history["b" /* createHashHistory */])(_this.props), _temp), HashRouter__possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return preact_compat_es["default"].createElement(react_router_dom_es_Router, { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(preact_compat_es["default"].Component);

/* harmony default export */ var es_HashRouter = (HashRouter_HashRouter);
// CONCATENATED MODULE: ../react-router-dom/es/Link.js
var Link__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function Link__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Link__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function Link__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link_Link = function (_React$Component) {
  Link__inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    Link__classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Link__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;

          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), Link__possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    browser_default()(this.context.router, "You should not use <Link> outside a <Router>");

    browser_default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(esm_history["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return preact_compat_es["default"].createElement("a", Link__extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(preact_compat_es["default"].Component);

Link_Link.defaultProps = {
  replace: false
};
Link_Link.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      push: prop_types_default.a.func.isRequired,
      replace: prop_types_default.a.func.isRequired,
      createHref: prop_types_default.a.func.isRequired
    }).isRequired
  }).isRequired
};

/* harmony default export */ var es_Link = (Link_Link);
// CONCATENATED MODULE: ../react-router/es/MemoryRouter.js
function MemoryRouter__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function MemoryRouter__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function MemoryRouter__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter_MemoryRouter = function (_React$Component) {
  MemoryRouter__inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    MemoryRouter__classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = MemoryRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(esm_history["d" /* createMemoryHistory */])(_this.props), _temp), MemoryRouter__possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return preact_compat_es["default"].createElement(es_Router, { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(preact_compat_es["default"].Component);

/* harmony default export */ var es_MemoryRouter = (MemoryRouter_MemoryRouter);
// CONCATENATED MODULE: ../react-router-dom/es/MemoryRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_MemoryRouter = (es_MemoryRouter);
// EXTERNAL MODULE: ../path-to-regexp/index.js
var path_to_regexp = __webpack_require__("UFu6");
var path_to_regexp_default = /*#__PURE__*/__webpack_require__.n(path_to_regexp);

// CONCATENATED MODULE: ../react-router/es/matchPath.js


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var matchPath_compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = path_to_regexp_default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  if (path == null) return parent;

  var _compilePath = matchPath_compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ var es_matchPath = (matchPath);
// CONCATENATED MODULE: ../react-router/es/Route.js
var Route__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Route__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Route__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function Route__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







var Route_isEmptyChildren = function isEmptyChildren(children) {
  return preact_compat_es["default"].Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route_Route = function (_React$Component) {
  Route__inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    Route__classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Route__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), Route__possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: Route__extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    browser_default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return es_matchPath(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    warning_default()(!(this.props.component && this.props.children && !Route_isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    warning_default()(!(this.props.render && this.props.children && !Route_isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    warning_default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    warning_default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? preact_compat_es["default"].createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !Route_isEmptyChildren(children)) return preact_compat_es["default"].Children.only(children);

    return null;
  };

  return Route;
}(preact_compat_es["default"].Component);

Route_Route.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.object.isRequired,
    route: prop_types_default.a.object.isRequired,
    staticContext: prop_types_default.a.object
  })
};
Route_Route.childContextTypes = {
  router: prop_types_default.a.object.isRequired
};

/* harmony default export */ var es_Route = (Route_Route);
// CONCATENATED MODULE: ../react-router-dom/es/Route.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Route = (es_Route);
// CONCATENATED MODULE: ../react-router-dom/es/NavLink.js
var NavLink__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function NavLink__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink_NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = NavLink__objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return preact_compat_es["default"].createElement(react_router_dom_es_Route, {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return preact_compat_es["default"].createElement(es_Link, NavLink__extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? NavLink__extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink_NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ var es_NavLink = (NavLink_NavLink);
// CONCATENATED MODULE: ../react-router/es/Prompt.js
function Prompt__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Prompt__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function Prompt__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt_Prompt = function (_React$Component) {
  Prompt__inherits(Prompt, _React$Component);

  function Prompt() {
    Prompt__classCallCheck(this, Prompt);

    return Prompt__possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    browser_default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(preact_compat_es["default"].Component);

Prompt_Prompt.propTypes = {
  when: prop_types_default.a.bool,
  message: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string]).isRequired
};
Prompt_Prompt.defaultProps = {
  when: true
};
Prompt_Prompt.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      block: prop_types_default.a.func.isRequired
    }).isRequired
  }).isRequired
};

/* harmony default export */ var es_Prompt = (Prompt_Prompt);
// CONCATENATED MODULE: ../react-router-dom/es/Prompt.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Prompt = (es_Prompt);
// CONCATENATED MODULE: ../react-router/es/generatePath.js


var generatePath_patternCache = {};
var generatePath_cacheLimit = 10000;
var generatePath_cacheCount = 0;

var generatePath_compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = generatePath_patternCache[cacheKey] || (generatePath_patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = path_to_regexp_default.a.compile(pattern);

  if (generatePath_cacheCount < generatePath_cacheLimit) {
    cache[pattern] = compiledGenerator;
    generatePath_cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = generatePath_compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ var es_generatePath = (generatePath);
// CONCATENATED MODULE: ../react-router/es/Redirect.js
var Redirect__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Redirect__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Redirect__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function Redirect__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect_Redirect = function (_React$Component) {
  Redirect__inherits(Redirect, _React$Component);

  function Redirect() {
    Redirect__classCallCheck(this, Redirect);

    return Redirect__possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    browser_default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(esm_history["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(esm_history["c" /* createLocation */])(this.props.to);

    if (Object(esm_history["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      warning_default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return es_generatePath(to, computedMatch.params);
      } else {
        return Redirect__extends({}, to, {
          pathname: es_generatePath(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(preact_compat_es["default"].Component);

Redirect_Redirect.propTypes = {
  computedMatch: prop_types_default.a.object, // private, from <Switch>
  push: prop_types_default.a.bool,
  from: prop_types_default.a.string,
  to: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]).isRequired
};
Redirect_Redirect.defaultProps = {
  push: false
};
Redirect_Redirect.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      push: prop_types_default.a.func.isRequired,
      replace: prop_types_default.a.func.isRequired
    }).isRequired,
    staticContext: prop_types_default.a.object
  }).isRequired
};

/* harmony default export */ var es_Redirect = (Redirect_Redirect);
// CONCATENATED MODULE: ../react-router-dom/es/Redirect.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Redirect = (es_Redirect);
// CONCATENATED MODULE: ../react-router/es/StaticRouter.js
var StaticRouter__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function StaticRouter__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function StaticRouter__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function StaticRouter__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function StaticRouter__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return StaticRouter__extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return StaticRouter__extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var StaticRouter_createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(esm_history["e" /* createPath */])(location);
};

var StaticRouter_staticHandler = function staticHandler(methodName) {
  return function () {
    browser_default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter_StaticRouter = function (_React$Component) {
  StaticRouter__inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    StaticRouter__classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = StaticRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + StaticRouter_createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(esm_history["c" /* createLocation */])(location));
      context.url = StaticRouter_createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(esm_history["c" /* createLocation */])(location));
      context.url = StaticRouter_createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), StaticRouter__possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = StaticRouter__objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(esm_history["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: StaticRouter_staticHandler("go"),
      goBack: StaticRouter_staticHandler("goBack"),
      goForward: StaticRouter_staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return preact_compat_es["default"].createElement(es_Router, StaticRouter__extends({}, props, { history: history }));
  };

  return StaticRouter;
}(preact_compat_es["default"].Component);

StaticRouter_StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter_StaticRouter.childContextTypes = {
  router: prop_types_default.a.object.isRequired
};

/* harmony default export */ var es_StaticRouter = (StaticRouter_StaticRouter);
// CONCATENATED MODULE: ../react-router-dom/es/StaticRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_StaticRouter = (es_StaticRouter);
// CONCATENATED MODULE: ../react-router/es/Switch.js
function Switch__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Switch__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function Switch__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch_Switch = function (_React$Component) {
  Switch__inherits(Switch, _React$Component);

  function Switch() {
    Switch__classCallCheck(this, Switch);

    return Switch__possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    browser_default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    warning_default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    warning_default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    preact_compat_es["default"].Children.forEach(children, function (element) {
      if (match == null && preact_compat_es["default"].isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = es_matchPath(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? preact_compat_es["default"].cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(preact_compat_es["default"].Component);

Switch_Switch.contextTypes = {
  router: prop_types_default.a.shape({
    route: prop_types_default.a.object.isRequired
  }).isRequired
};


/* harmony default export */ var es_Switch = (Switch_Switch);
// CONCATENATED MODULE: ../react-router-dom/es/Switch.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Switch = (es_Switch);
// CONCATENATED MODULE: ../react-router-dom/es/generatePath.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_generatePath = (es_generatePath);
// CONCATENATED MODULE: ../react-router-dom/es/matchPath.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_matchPath = (es_matchPath);
// EXTERNAL MODULE: ../react-router/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__("FQP4");
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// CONCATENATED MODULE: ../react-router/es/withRouter.js
var withRouter__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function withRouter__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}






/**
 * A public higher-order component to access the imperative API
 */
var withRouter_withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = withRouter__objectWithoutProperties(props, ["wrappedComponentRef"]);

    return preact_compat_es["default"].createElement(es_Route, {
      children: function children(routeComponentProps) {
        return preact_compat_es["default"].createElement(Component, withRouter__extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;


  return hoist_non_react_statics_cjs_default()(C, Component);
};

/* harmony default export */ var es_withRouter = (withRouter_withRouter);
// CONCATENATED MODULE: ../react-router-dom/es/withRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_withRouter = (es_withRouter);
// CONCATENATED MODULE: ../react-router-dom/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return es_BrowserRouter; });
/* unused concated harmony import HashRouter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_HashRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return es_Link; });
/* unused concated harmony import MemoryRouter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return react_router_dom_es_MemoryRouter; });
/* unused concated harmony import NavLink */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_NavLink; });
/* unused concated harmony import Prompt */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return react_router_dom_es_Prompt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return react_router_dom_es_Redirect; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return react_router_dom_es_Route; });
/* unused concated harmony import Router */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return react_router_dom_es_Router; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return react_router_dom_es_StaticRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return react_router_dom_es_Switch; });
/* unused concated harmony import generatePath */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return react_router_dom_es_generatePath; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return react_router_dom_es_matchPath; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return react_router_dom_es_withRouter; });





























/***/ }),

/***/ "tcXu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "thHe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("2ckI");

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__("PWyx"));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ "uFKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" });

var GPS = function GPS(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ viewBox: "0 0 24 24", "class": props.class },
		_ref
	);
};
/* harmony default export */ __webpack_exports__["a"] = (GPS);

/***/ }),

/***/ "uN/K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("yy8s"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),

/***/ "uXYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", { points: "49.6,15.6 57.4,23.4 40.8,40 27.2,26.4 2,51.6 6.8,56.4 27.2,36 40.8,49.6 62.2,28.2 70,36 70,15.6" });

var trending = function trending(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ id: "trending", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};

/* harmony default export */ __webpack_exports__["a"] = (trending);

/***/ }),

/***/ "uka7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "upA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../q-jobs/node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__("/ErD");

// EXTERNAL MODULE: ../window-or-global/lib/index.js
var lib = __webpack_require__("IyPV");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ../q-jobs/src/utils/LocalStorageWrapper/index.js
var LocalStorageWrapper = __webpack_require__("gEYR");

// EXTERNAL MODULE: ../q-jobs/src/utils/FetchHelper/index.js
var FetchHelper = __webpack_require__("Hm4v");

// EXTERNAL MODULE: ../q-jobs/src/constants/index.js
var constants = __webpack_require__("QSFW");

// CONCATENATED MODULE: ../q-jobs/src/assets/roleKeywords.js
var ROLE_KEYWORD_MAP_FOR_SEO = {
  'Accountant': {
    'title': 'Accountant, Finance, CS, CA',
    'description': 'Accountant, finance, CS, CA, tax and audit',
    'h1': 'Accountant Jobs'
  },
  'Architect': {
    'title': 'Architecture, Interior Designer',
    'description': 'Architect and interior designer',
    'h1': 'Architecture Jobs'
  },
  'Beautician': {
    'title': 'Beautician, Hairdresser, Salon',
    'description': 'Beautician jobs, hairdresser, hair stylist, jobs in beauty parlors and salons',
    'h1': 'Beautician Jobs'
  },
  'BPO/ Telecaller': {
    'title': 'Call Center, BPO, KPO, Customer Care',
    'description': 'Call center, BPO/KPO, customer care',
    'h1': 'BPO/Call-Center Jobs'
  },
  'Cashier': {
    'title': 'Cashier, Bank Cashier',
    'description': 'Cashier, Bank cashier',
    'h1': 'Cashier Jobs'
  },
  'Construction/Laborer': {
    'title': 'Construction Jobs, Worker, Daily Labour',
    'description': 'Construction jobs, construction workers, labour, farmer and cultivator',
    'h1': 'Construction Jobs'
  },
  'Content Writer': {
    'title': 'Content Writer, Web Content Writer, Journalist',
    'description': 'Content writer, journalist, columnist & news writer',
    'h1': 'Content Writer Jobs'
  },
  'Cook': {
    'title': 'Cooks & Chef, Private Chef',
    'description': 'Cook and chef, private chef , multi cuisine cook',
    'h1': 'Cook and Chef Jobs'
  },
  'Data Entry /Back Office': {
    'title': 'Data Entry, Back Office',
    'description': 'Data entry, back office, online data entry',
    'h1': 'Data Entry Jobs'
  },
  'Delivery/Collections': {
    'title': 'Delivery, Courier, Delivery Boy',
    'description': 'Delivery, Couriers, delivery boy/courier boy',
    'h1': 'Delivery and Courier Jobs'
  },
  'Driver': {
    'title': 'Drivers, Truck Drivers, Private Driver',
    'description': 'Drivers, Truck Drivers, Private Driver',
    'h1': 'Driver Jobs'
  },
  'DTP Operator/Print Consultant': {
    'title': 'DTP Operator Jobs, Print Consultant',
    'description': 'Find DTP operator & print consultant jobs. Searching job is no more difficult as Quikr offer you number of opportunities.',
    'h1': 'DTP Operator/Print Consultant Jobs'
  },
  'Engineer': {
    'title': 'Engineering',
    'description': 'Engineering',
    'h1': 'Engineering Jobs'
  },
  'Hospitality Executive': {
    'title': 'Hospitality, Supervisor, Steward',
    'description': 'Hospitality, supervisor and steward',
    'h1': 'Hospitality Jobs'
  },
  'HR/Admin': {
    'title': 'HR & Admin',
    'description': 'HR and Admin',
    'h1': 'HR and Admin Jobs'
  },
  'Maid': {
    'title': 'Maids, Housekeepers',
    'description': 'Maid and housekeeper',
    'h1': 'Maid and Housekeeper Jobs'
  },
  'Sales': {
    'title': 'Sales, Sales Executive, Sales Managers',
    'description': 'Sales agent, sales manager, sales executive',
    'h1': 'Sales Jobs'
  },
  'Security/Guard': {
    'title': 'Security Guard Jobs, Security Supervisor',
    'description': 'Security guard jobs, security supervisor',
    'h1': 'Security Jobs'
  },
  'Warehouse Executive': {
    'title': 'Warehouse Executives',
    'description': 'Warehouse executive',
    'h1': 'Warehouse Jobs'
  },
  'Teacher': {
    'title': 'Teacher, Tutor, Online Tutor',
    'description': 'Teaching and tutor job',
    'h1': 'Teacher Jobs'
  },
  'Tailor': {
    'title': 'Tailor, Fashion Designing, Boutique',
    'description': 'Tailoring, fashion designing, dress making',
    'h1': 'Tailor Jobs'
  },
  'Receptionist/Front Office': {
    'title': 'Receptionist',
    'description': 'Receptionist, front office manager',
    'h1': 'Receptionist Jobs'
  },
  'Office Assistant/Helper': {
    'title': 'Office Boy, Office Assistant, Office Helpers',
    'description': 'Office boy, office assistant and office helper',
    'h1': 'Office Assistant Jobs'
  },
  'Nurse': {
    'title': 'Nurse, MR, Healthcare',
    'description': 'Nursing, MR (medical representative}, health care',
    'h1': 'Healthcare Jobs'
  },
  'Mechanic': {
    'title': 'Mechanic Jobs, Auto Mechanic, Diesel Mechanic',
    'description': 'Mechanic Jobs, Auto Mechanic, Diesel Mechanic',
    'h1': 'Mechanic Jobs'
  },
  'Marketing': {
    'title': 'Marketing, Advertising & Media',
    'description': 'Marketing, advertising & media',
    'h1': 'Marketing Jobs'
  },
  'Legal': {
    'title': 'Lawyers, Legal Secretary',
    'description': 'Legal sector like lawyers, legal secretary',
    'h1': 'Legal Sector Jobs'
  },
  'IT Software - Developer': {
    'title': 'IT Software, Engineer',
    'description': 'IT - software developer',
    'h1': 'IT Software Developer Jobs'
  },
  'IT Hardware & Network Engineer': {
    'title': 'IT Hardware & Network Engineer',
    'description': 'Hardware and networking',
    'h1': 'IT Hardware-Network Jobs'
  },
  'IT Software - Web Designer': {
    'title': 'Web Designer, Graphic Designer',
    'description': 'Web designer, graphic designer',
    'h1': 'IT Software - Web Designer Jobs'
  },
  'IT Software - QA/Test Engineer': {
    'title': 'Software Testing, Software QA & QC',
    'description': 'Software testing, Software QA and QC',
    'h1': 'IT Software - Testing Jobs'
  },
  'Others': {
    'title': 'Full Time, Part Time',
    'description': 'Find full time, part time, work from home, online opportunities',
    'h1': 'Full Time, Part Time Jobs'
  },
  'Photographer': {
    'title': 'Photographer Jobs, Photography, Fashion Photographer',
    'description': 'Photographer Jobs, Photography, Fashion Photographer',
    'h1': 'Photographer Jobs'
  },
  'Gardener': {
    'title': 'Gardener Jobs, Gardening',
    'description': 'Gardener Jobs, Gardening',
    'h1': 'Gardener Jobs'
  },
  'Painter': {
    'title': 'Painter Jobs, Wall Painter, Portrait Painter',
    'description': 'Painter Jobs, Wall Painter, Portrait Painter',
    'h1': 'Painter Jobs'
  },
  'Trainer': {
    'title': 'Trainer Job, Gym Trainer, Dance Trainer',
    'description': 'Trainer Job, Gym Trainer, Dance Trainer',
    'h1': 'Trainer Job'
  },
  'Electrician': {
    'title': 'Electrician Jobs, ITI Electrician, Electrical',
    'description': 'Electrician Jobs, ITI Electrician, Electrical',
    'h1': 'Electrician Jobs'
  },
  'Plumber': {
    'title': 'Plumber Jobs, Plumbing',
    'description': 'Plumber Jobs, Plumbing',
    'h1': 'Plumber Jobs'
  },
  'Carpenter': {
    'title': 'Carpenter Jobs, Carpentry',
    'description': 'Carpenter Jobs, Carpentry',
    'h1': 'Carpenter Jobs'
  },
  'Doctor': {
    'title': 'Doctor Jobs, MBBS Doctor',
    'description': 'Doctor Jobs, MBBS Doctor',
    'h1': 'Doctor Jobs'
  },
  'Government Jobs': {
    'title': 'Sarkari Naukri, Govt Jobs in <city>, Govt Jobs 2016-17',
    'description': "Find all Govt jobs, Sarkari Naukri vacancies, latest govt listings in <city> at QuikrJobs. Get details of all central & state Govt jobs, apply for Sarkari Naukri.",
    'h1': 'Govt Jobs'
  },
  'Bartender': {
    'title': 'Bartender',
    'description': 'Bartender',
    'h1': 'Bartender Jobs'
  },
  'Bouncer': {
    'title': 'Bouncer',
    'description': 'Bouncer',
    'h1': 'Bouncer Jobs'
  },
  'Caretaker/Nanny': {
    'title': 'Caretaker, Nanny',
    'description': 'Caretaker, Nanny',
    'h1': 'Caretaker/Nanny Jobs'
  },
  'Counsellor': {
    'title': 'Counsellor',
    'description': 'Counsellor',
    'h1': 'Counsellor Jobs'
  },
  'Pharmacist': {
    'title': 'Pharmacist, Chemist, Pharma',
    'description': 'Pharmacist, Chemist, Pharma',
    'h1': 'Pharmacist Jobs'
  },
  'Animation': {
    'title': 'Animation Jobs, Graphic Designer',
    'description': 'Animation Jobs, Graphic Designer',
    'h1': 'Animation Jobs'
  },
  'Data Collection/Survey': {
    'title': 'Data Collection Jobs, Field Survey',
    'description': 'Data Collection Jobs, Field Survey',
    'h1': 'Data Collection/Survey Jobs'
  },
  'Porter': {
    'title': 'Porter Jobs, Hospital Porter, Maintenance Porter',
    'description': 'Porter Jobs, Hospital Porter, Maintenance Porter',
    'h1': 'Porter Jobs'
  },
  'Handyman': {
    'title': 'Handyman Jobs, Repair Work, Maintenance',
    'description': 'Handyman Jobs, Repair Work, Maintenance',
    'h1': 'Handyman Jobs'
  },
  'Sound Engineer': {
    'title': 'Sound Engineer Jobs, Audio Engineer, Studio Sound Engineer',
    'description': 'Sound Engineer Jobs, Audio Engineer, Studio Sound Engineer',
    'h1': 'Sound Engineer Jobs'
  },
  'Cameraman': {
    'title': 'Cameraman',
    'description': 'Cameraman',
    'h1': 'Cameraman Jobs'
  },
  'Lighting Man': {
    'title': 'Lighting Man Jobs, Lighting Technician, Lighting Supervisor',
    'description': 'Lighting Man Jobs, Lighting Technician, Lighting Supervisor',
    'h1': 'Lighting Man Jobs'
  },
  'Videographer': {
    'title': 'Videographer',
    'description': 'Videographer',
    'h1': 'Videographer Jobs'
  },
  'Dubbing Artist': {
    'title': 'Dubbing Artist Jobs, Voice Artist',
    'description': 'Dubbing Artist Jobs, Voice Artist',
    'h1': 'Dubbing Artist Jobs'
  },
  'Projectionist': {
    'title': 'Projectionist Jobs, Cinema/Film Projectionist',
    'description': 'Projectionist Jobs, Cinema/Film Projectionist',
    'h1': 'Projectionist Jobs'
  },
  'Medical Assistant': {
    'title': 'Medical Assistant Job, Lab Assistant',
    'description': 'Medical Assistant Job, Lab Assistant',
    'h1': 'Medical Assistant Jobs'
  },
  'Nutritionist/Dietician': {
    'title': 'Dietician Jobs, Nutritionist',
    'description': 'Dietician Jobs, Nutritionist',
    'h1': 'Nutritionist/Dietician Jobs'
  },
  'Financial  Advisor': {
    'title': 'Financial  Advisor',
    'description': 'Financial  Advisor',
    'h1': 'Financial  Advisor Jobs'
  },
  'Insurance Consultant': {
    'title': 'Insurance Consultant',
    'description': 'Insurance Consultant',
    'h1': 'Insurance Consultant Jobs'
  },
  'Language Translator': {
    'title': 'Translator Jobs, Language Translator',
    'description': 'Translator Jobs, Language Translator',
    'h1': 'Language Translator Jobs'
  },
  'Public Relations': {
    'title': 'PR Jobs',
    'description': 'PR Jobs',
    'h1': 'Public Relations Jobs'
  },
  'Editor': {
    'title': 'Editor Jobs, Proofreading, Copy Editor',
    'description': 'Editor Jobs, Proofreading, Copy Editor',
    'h1': 'Editor Jobs'
  },
  'Reporter': {
    'title': 'Reporter Jobs, News, TV Reporter, Journalism',
    'description': 'Reporter Jobs, News, TV Reporter, Journalism',
    'h1': 'Reporter Jobs'
  },
  'Fitter': {
    'title': 'Fitter Jobs, ITI Fitter',
    'description': 'Fitter Jobs, ITI Fitter',
    'h1': 'Fitter Jobs'
  },
  'Welder': {
    'title': 'Welder Jobs, Structural Welding, Pipe Welding',
    'description': 'Welder Jobs, Structural Welding, Pipe Welding',
    'h1': 'Welder Jobs'
  },
  'Foundryman': {
    'title': 'Foundryman Jobs, ITI Foundryman, Moulder',
    'description': 'Foundryman Jobs, ITI Foundryman, Moulder',
    'h1': 'Foundryman Jobs'
  },
  'Dye Maker': {
    'title': 'Dye Maker',
    'description': 'Dye Maker',
    'h1': 'Dye Maker Jobs'
  },
  'Draftsman': {
    'title': 'Draftsman',
    'description': 'Draftsman',
    'h1': 'Draftsman Jobs'
  },
  'Scientist-Research': {
    'title': 'Scientist Jobs, Research, Science',
    'description': 'Scientist Jobs, Research, Science',
    'h1': 'Scientist-Research Jobs'
  },
  'Event Planner': {
    'title': 'Event Management Jobs, Event Planner, Wedding Planner',
    'description': 'Event Management Jobs, Event Planner, Wedding Planner',
    'h1': 'Event Planner Jobs'
  },
  'Librarian': {
    'title': 'Librarian',
    'description': 'Librarian',
    'h1': 'Librarian Jobs'
  },
  'Designer': {
    'title': 'Jewellery Designer Jobs, Fashion Designer',
    'description': 'Jewellery Designer Jobs, Fashion Designer',
    'h1': 'Designer Jobs'
  },
  'Waiter/Steward': {
    'title': 'Waiter Jobs, Steward, Hotel Staff',
    'description': 'Waiter Jobs, Steward, Hotel Staff',
    'h1': 'Waiter/Steward Jobs'
  },
  'Cleaner/Washer': {
    'title': 'Cleaner',
    'description': 'Cleaner',
    'h1': 'Cleaner/Washer Jobs'
  },
  'Operator/Machinist': {
    'title': 'Machinist Jobs, CNC, Milling Machine',
    'description': 'Machinist Jobs, CNC, Milling Machine',
    'h1': 'Operator/Machinist Jobs'
  },
  'Host/Hostess': {
    'title': 'Air Hostess Jobs, Airport Ground Staff, Flight Attendant',
    'description': 'Air Hostess Jobs, Airport Ground Staff, Flight Attendant',
    'h1': 'Host/Hostess Jobs'
  },
  'Electroplater': {
    'title': 'Electroplating',
    'description': 'Electroplating',
    'h1': 'Electroplater Jobs'
  },
  'Quality and Inspection': {
    'title': 'Quality Testing Jobs, Inspection',
    'description': 'Quality Testing Jobs, Inspection',
    'h1': 'Quality and Inspection Jobs'
  },
  'Sheet Metal Worker': {
    'title': 'Sheet Metal',
    'description': 'Sheet Metal',
    'h1': 'Sheet Metal Worker Jobs'
  },
  'Wireman': {
    'title': 'Wireman Jobs, ITI Wireman',
    'description': 'Wireman Jobs, ITI Wireman',
    'h1': 'Wireman Jobs'
  },
  'Moulder': {
    'title': 'Moulder Jobs, Injection Moulding',
    'description': 'Moulder Jobs, Injection Moulding',
    'h1': 'Moulder Jobs'
  },
  'Microbiologist': {
    'title': 'Microbiology Jobs, Biotechnology',
    'description': 'Microbiology Jobs, Biotechnology',
    'h1': 'Microbiologist Jobs'
  },
  'Ticketing Executive': {
    'title': 'Ticket Counter Jobs, Air Ticketing, Railway Ticketing',
    'description': 'Ticket Counter Jobs, Air Ticketing, Railway Ticketing',
    'h1': 'Ticketing Executive Jobs'
  },
  'Floor Manager': {
    'title': 'Resturant Manager Jobs, Retail Store Manager',
    'description': 'Resturant Manager Jobs, Retail Store Manager',
    'h1': 'Floor Manager Jobs'
  },
  'Rigger': {
    'title': 'Rigger Jobs, Oil Rig',
    'description': 'Rigger Jobs, Oil Rig',
    'h1': 'Rigger Jobs'
  },
  'Lighting Technician': {
    'title': 'Lighting Technician',
    'description': 'Lighting Technician',
    'h1': 'Lighting Technician Jobs'
  },
  'Optometrist': {
    'title': 'Optometrist Jobs, Optician',
    'description': 'Optometrist Jobs, Optician',
    'h1': 'Optometrist Jobs'
  },
  'Lab Assistant': {
    'title': 'Lab Technician Jobs, Lab Assistant, Medical Lab',
    'description': 'Lab Technician Jobs, Lab Assistant, Medical Lab',
    'h1': 'Lab Assistant Jobs'
  },
  'Sports Trainer': {
    'title': 'Sports Trainer Jobs, Athletic Trainer',
    'description': 'Sports Trainer Jobs, Athletic Trainer',
    'h1': 'Sports Trainer Jobs'
  },
  'Soldering Operator': {
    'title': 'Soldering Operator Jobs, Fabrication',
    'description': 'Soldering Operator Jobs, Fabrication',
    'h1': 'Soldering Operator Jobs'
  },
  'Database/System/Linux Administrator': {
    'title': 'DBA Jobs, Database Administrator',
    'description': 'DBA Jobs, Database Administrator',
    'h1': 'Database/System/Linux Administrator Jobs'
  },
  'Program/Project Manager': {
    'title': 'Project Manager Jobs, Program Manager',
    'description': 'Project Manager Jobs, Program Manager',
    'h1': 'Program/Project Manager Jobs'
  },
  'Product Manager': {
    'title': 'Product Manager',
    'description': 'Product Manager',
    'h1': 'Product Manager Jobs'
  },
  'Data Scientist': {
    'title': 'Data Scientist Jobs, Hadoop',
    'description': 'Data Scientist Jobs, Hadoop',
    'h1': 'Data Scientist Jobs'
  },
  'Software Architect': {
    'title': 'Software Jobs, Software Architect',
    'description': 'Software Jobs, Software Architect',
    'h1': 'Software Architect Jobs'
  },
  'Market Research Analyst': {
    'title': 'Market Research Analyst Jobs, Data Analyst',
    'description': 'Market Research Analyst Jobs, Data Analyst',
    'h1': 'Market Research Analyst Jobs'
  },
  'Business Analyst': {
    'title': 'Business Analyst',
    'description': 'Business Analyst',
    'h1': 'Business Analyst Jobs'
  },
  'SAP Consultant': {
    'title': 'SAP Jobs, SAP Consultant',
    'description': 'SAP Jobs, SAP Consultant',
    'h1': 'SAP Consultant Jobs'
  },
  'Ward Boy': {
    'title': 'Ward Boy Jobs, Male Nurse',
    'description': 'Ward Boy Jobs, Male Nurse',
    'h1': 'Ward Boy Jobs'
  },
  'MIS Executive': {
    'title': 'MIS Jobs, Advanced Excel',
    'description': 'MIS Jobs, Advanced Excel',
    'h1': 'MIS Executive Jobs'
  },
  'Purchase Executive': {
    'title': 'Purchase Jobs, Procurement',
    'description': 'Purchase Jobs, Procurement',
    'h1': 'Purchase Executive Jobs'
  },
  'Packing Officer/Packing Executive/Packaging Technologist': {
    'title': 'Packaging Jobs, Packing',
    'description': 'Packaging Jobs, Packing',
    'h1': 'Packing Officer/Packing Executive/Packaging Technologist Jobs'
  },
  'Safety Officer': {
    'title': 'Safety Jobs, Safety Officer',
    'description': 'Safety Jobs, Safety Officer',
    'h1': 'Safety Officer Jobs'
  },
  'Pest Control Executive': {
    'title': 'Pest Control',
    'description': 'Pest Control',
    'h1': 'Pest Control Executive Jobs'
  },
  'Fire Fighter': {
    'title': 'Fire Fighter, Entry Level Fire Fighter',
    'description': 'Fire Fighter, Entry Level Fire Fighter',
    'h1': 'Fire Fighter Jobs'
  },
  'Swimming Pool Attendant/Life Guard': {
    'title': 'Life Guard Jobs, Pool Attendant',
    'description': 'Life Guard Jobs, Pool Attendant',
    'h1': 'Swimming Pool Attendant/Life Guard Jobs'
  },
  'Control Room Operator': {
    'title': 'Control Room Operator',
    'description': 'Control Room Operator',
    'h1': 'Control Room Operator Jobs'
  },
  'Medical Representative': {
    'title': 'Medical Representative',
    'description': 'Medical Representative job',
    'h1': 'Medical Representative Jobs'
  }
};
// CONCATENATED MODULE: ../q-jobs/src/utils/index.js
/* unused harmony export loadExternalJS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return utils_getParamFromUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return capitalizeFirstLetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getOptionListFromArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return sanitizeRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return sanitizeRoleWithHyphen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formatStringForDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ucwords; });
/* unused harmony export hyphenToSpace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return spaceToHyphen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return replaceUrlParameter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return utils_updateInterstitialConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return copyObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return difference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isCityEmpty; });
/* unused harmony export getInternationalCities */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isInternationalCity; });
/* unused harmony export getObjectLength */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return utils_getProtocol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return utils_getDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return utils_getPathname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return utils_isDebugMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getFormattedInterviewDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return utils_overflowHidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return utils_initJsVars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return debounce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return utils_isDummyEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return timeAgo; });
/* unused harmony export getTimezoneOffsetDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getApplySourceFromPageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return utils_updateJobSnow; });
/* unused harmony export getQdfpRoute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return utils_getUserIdFromCookies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isLoggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return parsePrimaryRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return parseSecondaryRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return utils_getKeywordsForRoleSEO; });
/* harmony export (immutable) */ __webpack_exports__["a"] = adConverionEvent;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var utils_loadExternalJS = function loadExternalJS(src, callback) {
  var s = lib_default.a.document && lib_default.a.document.createElement('script');
  s.src = src;
  s.async = true;
  s.onreadystatechange = s.onload = function () {
    var state = s.readyState;
    if (!callback.done && (!state || /loaded|complete/.test(state))) {
      callback.done = true;
      callback();
    }
  };
  lib_default.a.document && lib_default.a.document.getElementsByTagName('head')[0].appendChild(s);
};

var utils_getParamFromUrl = function getParamFromUrl(param) {
  var params = {};
  if (typeof lib_default.a !== 'undefined') {
    params = lib_default.a.location && getParams(lib_default.a.location.search) || {};
  }
  return params[param] ? params[param] : null;
};

var getParams = function getParams(query) {
  if (!query) {
    return {};
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        key = _param$split[0],
        value = _param$split[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {});
};

var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  try {
    return string[0].toUpperCase() + string.slice(1);
  } catch (error) {
    return string;
  }
};

var getOptionListFromArray = function getOptionListFromArray(list) {
  var optionList = [];
  for (var _iterator = list, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var optionValue = _ref;

    optionList.push({ id: optionValue, value: optionValue });
  }
  return optionList;
};

var sanitizeRole = function sanitizeRole(role) {
  try {
    return role.replace(/\//g, '').replace(/-/g, '').replace(/ /g, '').toLowerCase();
  } catch (e) {
    return '';
  }
};

var sanitizeRoleWithHyphen = function sanitizeRoleWithHyphen(role) {
  try {
    role.replace(/ \//g, '-').replace(/\/ /g, '-').replace(/\//g, '-').replace(/ /g, '-').toLowerCase();
  } catch (e) {
    return '';
  }
};

var formatStringForDisplay = function formatStringForDisplay(string) {
  string = hyphenToSpace(string);
  return ucwords(string, true);
};

var ucwords = function ucwords(string) {
  var join = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' ';

  var stringArray = string.split(' ');
  for (var index in stringArray) {
    if (stringArray.hasOwnProperty(index)) {
      var value = stringArray[index];
      stringArray[index] = capitalizeFirstLetter(value);
    }
  }

  if (join) {
    stringArray = stringArray.join(separator);
  }

  return stringArray;
};

var hyphenToSpace = function hyphenToSpace(role) {
  if (role) {
    return role.replace(/-/g, ' ');
  } else {
    return role;
  }
};

var spaceToHyphen = function spaceToHyphen(text) {
  if (text) {
    return text.replace(/ /g, '-');
  } else {
    return text;
  }
};

var replaceUrlParameter = function replaceUrlParameter(param, newval, search) {
  var regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?');
  var query = search.replace(regex, '$1').replace(/&$/, '');

  return (query.length > 2 ? query + '&' : '?') + (newval ? param + '=' + newval : '');
};

var utils_updateInterstitialConfig = function updateInterstitialConfig(page) {
  if (JobSnow.isInterstialAdEnabled) {
    lib_default.a.dispatchEvent(new CustomEvent('START_INTAD'));
  }
};

var copyObject = function copyObject(referencedObject) {
  return JSON.parse(JSON.stringify(referencedObject));
};

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 *
 * https://gist.github.com/Yimiprod/7ee176597fef230d1451
 */
var difference = function difference(object, base) {
  // function changes(object, base) {
  //   return _.transform(object, function(result, value, key) {
  //     if (!_.isEqual(value, base[key])) {
  //       result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
  //     }
  //   });
  // }

  // return changes(object, base);
  return {};
};

var isCityEmpty = function isCityEmpty(cityname) {
  return '' === cityname || 'undefined' === typeof cityname || 'www' === cityname;
};

var utils_getInternationalCities = function getInternationalCities() {
  var cities = {};
  var citiesFromLocalStorage = {};
  var key = 'getAllCities?type=international';
  if (LocalStorageWrapper["a" /* default */].hasKey(key)) {
    citiesFromLocalStorage = JSON.parse(LocalStorageWrapper["a" /* default */].getItem(key));
  }

  if (getObjectLength(citiesFromLocalStorage) > 0) {
    cities = citiesFromLocalStorage;
  } else if (lib_default.a.location) {
    var fetchHelper = new FetchHelper["a" /* default */]();
    var params = {
      url: lib_default.a.location.protocol + '//' + constants["b" /* API_URL */] + constants["n" /* GET_INTERNATIONAL_CITIES_API */]
    };
    var response = fetchHelper.request('GET', params);
    response.then(function (apiResponse) {
      var response = apiResponse.data ? apiResponse.data : {};
      if (response.success && response.json.length > 0) {
        cities = JSON.stringify(response.json);
        LocalStorageWrapper["a" /* default */].setItem(key, cities);
      }
    });
  }

  return cities;
};

var isInternationalCity = function isInternationalCity(cityName) {
  var cities = utils_getInternationalCities();
  var isAbroadCity = false;

  for (var i = 0; i < cities.length; i++) {
    if (sanitizeRole(cities[i].value).toLowerCase() === sanitizeRole(cityName).toLowerCase()) {
      isAbroadCity = true;
      break;
    }
  }
  return isAbroadCity;
};

var getObjectLength = function getObjectLength(object) {
  return Object.keys(object).length;
};

var utils_getProtocol = function getProtocol() {
  return lib_default.a.location && lib_default.a.location.protocol + '//';
};

var utils_getDomain = function getDomain() {
  return lib_default.a.location && lib_default.a.location.hostname;
};

var utils_getPathname = function getPathname() {
  return lib_default.a.location && lib_default.a.location.pathname;
};

var utils_isDebugMode = function isDebugMode() {
  var cookies = new es6["a" /* default */]();
  return cookies.get('isDebugMode');
};

var getFormattedInterviewDate = function getFormattedInterviewDate(date, separator) {
  var isInterview = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var forApi = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var isDateTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var finalDateTime = '';
  var today = date ? date : new Date();

  var dd = today.getDate();
  dd = isInterview ? dd + 1 : dd;

  var mm = today.getMonth() + 1; // January is 0
  var yyyy = today.getFullYear();
  var h = today.getHours();
  var m = today.getMinutes();
  var s = today.getSeconds();

  var checkTime = function checkTime(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  };

  dd = checkTime(dd);
  mm = checkTime(mm);
  h = checkTime(h);
  m = checkTime(m);
  s = checkTime(s);

  separator = separator ? separator : '/';
  finalDateTime = forApi ? '' + yyyy + separator + mm + separator + dd : '' + dd + separator + mm + separator + yyyy;

  if (isDateTime) {
    var time = h + ":" + m + ":" + s;
    finalDateTime = finalDateTime + ' ' + time;
  }

  return finalDateTime;
};

var utils_overflowHidden = function overflowHidden(add) {
  if (typeof lib_default.a.document === 'undefined') {
    return;
  }
  var body = lib_default.a.document && lib_default.a.document.body;
  if (add) {
    body.classList.add('overflowHidden');
  } else {
    body.classList.remove('overflowHidden');
  }
};

var utils_initJsVars = function initJsVars(preloadedState) {
  lib_default.a.QAP_VERSION = '4.0.1';

  lib_default.a.JobSnow = {
    zone: '',
    isMobile: true,
    requestType: '',
    legacyRequestType: '',
    jobType: '',
    gaTrackId: '',
    keywords: '',
    lang: "en",
    langName: "english",
    gaTrackingUrl: "",
    seoUrlCombinations: "",
    roles: "",
    localities: "",
    email: '',
    mobile: '',
    userId: '',
    utmcampaign: '',
    utmmedium: '',
    utmsource: '',
    isCommonHeader: '',
    rolesSubRoles: '',
    assetUrl: '',
    rolesDBUser: '',
    // isInterstialAdEnabled: false,
    // isFlyingCarpetAdEnabled: false,
    route: 'home'
  };

  if (preloadedState && preloadedState.globalContainer && preloadedState.globalContainer.QDFPVERSION) {
    lib_default.a.QDFPVERSION = preloadedState.globalContainer.QDFPVERSION;
  } else {}

  if (preloadedState && preloadedState.globalContainer && preloadedState.globalContainer.jobsContext) {
    var jobsContext = preloadedState.globalContainer.jobsContext;

    var updatedValue = {
      city: jobsContext.city,
      cityId: jobsContext.cityId,
      role: jobsContext.role,
      isloggedIn: jobsContext.isloggedIn,
      isInterstialAdEnabled: jobsContext.isInterstialAdEnabled,
      isFlyingCarpetAdEnabled: jobsContext.isFlyingCarpetAdEnabled,
      upgradeAdAbRand: jobsContext.upgradeAdAbRand

    };

    if (jobsContext.route) {
      updatedValue.route = jobsContext.route;
    }

    lib_default.a.JobSnow = _extends(lib_default.a.JobSnow, updatedValue);
  } else if (preloadedState && preloadedState.jobs) {
    var _updatedValue = {
      city: preloadedState.jobs.context.city,
      cityId: preloadedState.jobs.context.cityId,
      role: preloadedState.jobs.context.role,
      isloggedIn: preloadedState.jobs.user.loggedIn,
      isInterstialAdEnabled: preloadedState.jobs.context.isInterstialAdEnabled,
      isFlyingCarpetAdEnabled: preloadedState.jobs.context.isFlyingCarpetAdEnabled
    };

    if (preloadedState.jobs.window.locationPathname) {
      _updatedValue.route = utils_getQdfpRoute(preloadedState.jobs.window.locationPathname);
    }

    lib_default.a.JobSnow = _extends(lib_default.a.JobSnow, _updatedValue);
  }
};

var debounce = function debounce(fn, delay) {
  var timer = null;
  return function () {
    var context = this,
        args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};

var utils_isDummyEmail = function isDummyEmail(emailId) {
  var isDummyEmailId = false;
  if (emailId) {
    for (var index in constants["k" /* DUMMY_EMAIL_PATTERNS */]) {
      if (constants["k" /* DUMMY_EMAIL_PATTERNS */].hasOwnProperty(index)) {
        var pattern = constants["k" /* DUMMY_EMAIL_PATTERNS */][index];
        if (emailId.match(pattern)) {
          isDummyEmailId = true;
        }
      }
    }
  }

  return isDummyEmailId;
};

var timeAgo = function timeAgo(date) {
  date = new Date(date);
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;
  if (interval > 1) {
    if (Math.floor(interval) === 1) {
      return Math.floor(interval) + " year ago";
    }
    return Math.floor(interval) + " years ago";
  }

  interval = seconds / 2592000;
  if (interval > 1) {
    if (Math.floor(interval) === 1) {
      return Math.floor(interval) + " month ago";
    }
    return Math.floor(interval) + " months ago";
  }

  interval = seconds / 86400;
  if (interval > 1) {
    if (Math.floor(interval) === 1) {
      return Math.floor(interval) + " day ago";
    }
    return Math.floor(interval) + " days ago";
  }

  interval = seconds / 3600;
  if (interval >= 1) {
    if (Math.floor(interval) === 1) {
      return Math.floor(interval) + " hour ago";
    }
    return Math.floor(interval) + " hours ago";
  }

  interval = seconds / 60;
  if (interval >= 1) {
    if (Math.floor(interval) === 1) {
      return Math.floor(interval) + " minute ago";
    }
    return Math.floor(interval) + " minutes ago";
  }

  return Math.floor(seconds) + " seconds ago";
};

// function to get timezone offset of the current user from the browser
// and update the utc date according to current timezone
var getTimezoneOffsetDate = function getTimezoneOffsetDate(date) {
  return new Date(new Date(date).getTime() - new Date().getTimezoneOffset() * 60000);
};

var getApplySourceFromPageType = function getApplySourceFromPageType(pageType) {
  var source = null;

  switch (pageType) {
    case 'SNB':
      source = 'SNB';
      break;
    case 'VAP':
      source = 'VAP';
      break;
  }

  return source;
};

var utils_updateJobSnow = function updateJobSnow(values) {
  if (lib_default.a.JobSnow && typeof lib_default.a.JobSnow !== 'undefined') {
    lib_default.a.JobSnow = _extends(lib_default.a.JobSnow, values);
  }
};

var utils_getQdfpRoute = function getQdfpRoute(locationPathname) {
  if (locationPathname.indexOf('W0QQAdIdZ') > -1) {
    return constants["I" /* ROUTES */]['VAP'];
  } else if (locationPathname.indexOf('zwqxj') > -1) {
    return constants["I" /* ROUTES */]['SNB'];
  }
};

var utils_getUserIdFromCookies = function getUserIdFromCookies() {
  var cookies = new es6["a" /* default */]();
  return cookies.get('__u');
};

var isLoggedIn = function isLoggedIn() {
  return !!utils_getUserIdFromCookies();
};

var parsePrimaryRole = function parsePrimaryRole(role) {
  var primaryRole = '';

  if ('undefined' !== typeof role && null != role && role.indexOf('/') !== -1) {
    var roleParams = role.split('/');
    primaryRole = roleParams[0].trim();
  }
  return primaryRole;
};

var parseSecondaryRole = function parseSecondaryRole(role) {
  var secondaryRole = '';

  if ('undefined' !== typeof role && null != role && role.indexOf('/') !== -1) {
    var roleParams = role.split('/');
    secondaryRole = roleParams[1].trim();
  }

  return secondaryRole;
};

var utils_getKeywordsForRoleSEO = function getKeywordsForRoleSEO(role, seoType) {
  var keywords = '';

  if (ROLE_KEYWORD_MAP_FOR_SEO.hasOwnProperty(role) && ROLE_KEYWORD_MAP_FOR_SEO[role].hasOwnProperty(seoType)) {
    var keywordsArray = ROLE_KEYWORD_MAP_FOR_SEO[role][seoType].split(', ');

    if ('title' === seoType) {
      //removing keywords from array which exactly match the role
      var roleIndex = keywordsArray.indexOf(role);
      if (roleIndex !== -1) {
        keywordsArray.splice(roleIndex, 1);
      }
    }

    keywords = keywordsArray.join(', ');
  }

  return keywords;
};

function adConverionEvent() {
  if (typeof dataLayer != 'undefined') {
    dataLayer.push(arguments);
  }
}

/***/ }),

/***/ "v9L/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_CITIES_API; });
/* unused harmony export ALL_ROLES_API */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOCALITY_SEARCH_API; });
/* unused harmony export APPLY_SUBMIT_API */
/* unused harmony export SIMILAR_JOBS_API */
/* unused harmony export CONTEXT_API */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UNLIMITED_FREE_ADS_PAYMENT_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ROLE_FACET_COUNT_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RELATED_CATEGORIES_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_PROTOCOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WHATSAPP_TEXT_API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_window_or_global__);


var API_BASE_URL = 'www.quikr.com/jobs';

var ALL_CITIES_API = '/jobsAjax/getAllCities';

var ALL_ROLES_API = '/jobsAjax/roleSearch?all=1';

var LOCALITY_SEARCH_API = 'jobsAjax/localitySearch?cityName=';

var APPLY_SUBMIT_API = '';

var SIMILAR_JOBS_API = '';

var CONTEXT_API = '/jobsAjax/context';

var UNLIMITED_FREE_ADS_PAYMENT_API = '/unlimited-free-ads-payment';

var ROLE_FACET_COUNT_API = '/role-facet-count';

var RELATED_CATEGORIES_API = '/relatedCategories';

var API_PROTOCOL = __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.location && __WEBPACK_IMPORTED_MODULE_0_window_or_global___default.a.location.protocol + '//';

var WHATSAPP_TEXT_API = 'https://wa.me/918066095795?text=';

/***/ }),

/***/ "vkp0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ripple__ = __webpack_require__("MIZk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_button_mdc_button_scss__ = __webpack_require__("SN0Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_button_mdc_button_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_button_mdc_button_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_scss__ = __webpack_require__("JI39");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */




/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */



/**
 * Create the component.
 */

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.componentDidMount = function () {
      setTimeout(function () {
        var rippleInstance = Object(__WEBPACK_IMPORTED_MODULE_2__material_ripple__["a" /* default */])(_this.root_);
        _this.setState({ style: rippleInstance.style });
      });
    };

    _this.handleFocus = function (e) {
      _this.setState({ focus: true });
      _this.props.onFocus && _this.props.onFocus(e);
    };

    _this.handleBlur = function (e) {
      _this.setState({ focus: false });
      _this.props.onBlur && _this.props.onBlur(e);
    };

    _this.handleClick = function (e) {
      var rippleInstance = Object(__WEBPACK_IMPORTED_MODULE_2__material_ripple__["a" /* default */])(_this.root_);
      _this.setState({ ripple: true, style: rippleInstance.style });
      setTimeout(function () {
        _this.setState({ ripple: false });
      }, rippleInstance.duration);
      _this.props.onClick && _this.props.onClick(e);
    };

    _this.state = {
      focus: false,
      ripple: false,
      style: ''
    };
    return _this;
  }

  Button.prototype.render = function render(_ref, _ref2, context) {
    var _this2 = this;

    var focus = _ref2.focus,
        ripple = _ref2.ripple,
        style = _ref2.style;

    var className = _ref['class'],
        children = _ref.children,
        compact = _ref.compact,
        primary = _ref.primary,
        accent = _ref.accent,
        raised = _ref.raised,
        dense = _ref.dense,
        unelevated = _ref.unelevated,
        stroked = _ref.stroked,
        noBorderRadius = _ref.noBorderRadius,
        full = _ref.full,
        half = _ref.half,
        onFocus = _ref.onFocus,
        onBlur = _ref.onBlur,
        onClick = _ref.onClick,
        props = _objectWithoutProperties(_ref, ['class', 'children', 'compact', 'primary', 'accent', 'raised', 'dense', 'unelevated', 'stroked', 'noBorderRadius', 'full', 'half', 'onFocus', 'onBlur', 'onClick']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-button mdc-ripple-upgraded mdc-ripple-upgraded--unbounded', {
      'mdc-button--compact': compact,
      'mdc-button--primary': primary,
      'mdc-button--accent': accent,
      'mdc-button--raised': raised,
      'mdc-button--dense': dense,
      'mdc-button--unelevated': unelevated,
      'mdc-button--stroked': stroked,
      'mdc-ripple-upgraded--background-active-fill': ripple,
      'mdc-ripple-upgraded--foreground-activation': ripple,
      'mdc-ripple-upgraded--foreground-deactivation': !ripple,
      'mdc-ripple-upgraded--background-focused': focus,
      'mdc-button__no-border-radius': noBorderRadius,
      'mdc-button__width-full': full,
      'mdc-button__width-half': half
    }, className);

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'button',
      _extends({ 'class': classes,
        style: style,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick
      }, props, {
        ref: function ref(e) {
          return _this2.root_ = e;
        } }),
      children
    );
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "vrDd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util_namespaceObject = {};
__webpack_require__.d(util_namespaceObject, "supportsCssVariables", function() { return supportsCssVariables; });
__webpack_require__.d(util_namespaceObject, "applyPassive", function() { return applyPassive; });
__webpack_require__.d(util_namespaceObject, "getMatchesProperty", function() { return getMatchesProperty; });
__webpack_require__.d(util_namespaceObject, "getNormalizedEventCoords", function() { return getNormalizedEventCoords; });

// EXTERNAL MODULE: ../@material/base/component.js
var component = __webpack_require__("xJR0");

// CONCATENATED MODULE: ../@material/ripple/adapter.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @license
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* eslint no-unused-vars: [2, {"args": "none"}] */

/**
 * Adapter for MDC Ripple. Provides an interface for managing
 * - classes
 * - dom
 * - CSS variables
 * - position
 * - dimensions
 * - scroll position
 * - event handlers
 * - unbounded, active and disabled states
 *
 * Additionally, provides type information for the adapter to the Closure
 * compiler.
 *
 * Implement this adapter for your framework of choice to delegate updates to
 * the component in your framework of choice. See architecture documentation
 * for more details.
 * https://github.com/material-components/material-components-web/blob/master/docs/architecture.md
 *
 * @record
 */
var MDCRippleAdapter = function () {
  function MDCRippleAdapter() {
    _classCallCheck(this, MDCRippleAdapter);
  }

  /** @return {boolean} */
  MDCRippleAdapter.prototype.browserSupportsCssVars = function browserSupportsCssVars() {};

  /** @return {boolean} */


  MDCRippleAdapter.prototype.isUnbounded = function isUnbounded() {};

  /** @return {boolean} */


  MDCRippleAdapter.prototype.isSurfaceActive = function isSurfaceActive() {};

  /** @return {boolean} */


  MDCRippleAdapter.prototype.isSurfaceDisabled = function isSurfaceDisabled() {};

  /** @param {string} className */


  MDCRippleAdapter.prototype.addClass = function addClass(className) {};

  /** @param {string} className */


  MDCRippleAdapter.prototype.removeClass = function removeClass(className) {};

  /**
   * @param {string} evtType
   * @param {!Function} handler
   */


  MDCRippleAdapter.prototype.registerInteractionHandler = function registerInteractionHandler(evtType, handler) {};

  /**
   * @param {string} evtType
   * @param {!Function} handler
   */


  MDCRippleAdapter.prototype.deregisterInteractionHandler = function deregisterInteractionHandler(evtType, handler) {};

  /**
   * @param {!Function} handler
   */


  MDCRippleAdapter.prototype.registerResizeHandler = function registerResizeHandler(handler) {};

  /**
   * @param {!Function} handler
   */


  MDCRippleAdapter.prototype.deregisterResizeHandler = function deregisterResizeHandler(handler) {};

  /**
   * @param {string} varName
   * @param {?number|string} value
   */


  MDCRippleAdapter.prototype.updateCssVariable = function updateCssVariable(varName, value) {};

  /** @return {!ClientRect} */


  MDCRippleAdapter.prototype.computeBoundingRect = function computeBoundingRect() {};

  /** @return {{x: number, y: number}} */


  MDCRippleAdapter.prototype.getWindowPageOffset = function getWindowPageOffset() {};

  return MDCRippleAdapter;
}();

/* harmony default export */ var adapter = (MDCRippleAdapter);
// EXTERNAL MODULE: ../@material/base/foundation.js
var foundation = __webpack_require__("/X9I");

// CONCATENATED MODULE: ../@material/ripple/constants.js
/**
 * @license
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var cssClasses = {
  // Ripple is a special case where the "root" component is really a "mixin" of sorts,
  // given that it's an 'upgrade' to an existing component. That being said it is the root
  // CSS class that all other CSS classes derive from.
  ROOT: 'mdc-ripple-upgraded',
  UNBOUNDED: 'mdc-ripple-upgraded--unbounded',
  BG_FOCUSED: 'mdc-ripple-upgraded--background-focused',
  BG_ACTIVE_FILL: 'mdc-ripple-upgraded--background-active-fill',
  FG_ACTIVATION: 'mdc-ripple-upgraded--foreground-activation',
  FG_DEACTIVATION: 'mdc-ripple-upgraded--foreground-deactivation'
};

var strings = {
  VAR_SURFACE_WIDTH: '--mdc-ripple-surface-width',
  VAR_SURFACE_HEIGHT: '--mdc-ripple-surface-height',
  VAR_FG_SIZE: '--mdc-ripple-fg-size',
  VAR_LEFT: '--mdc-ripple-left',
  VAR_TOP: '--mdc-ripple-top',
  VAR_FG_SCALE: '--mdc-ripple-fg-scale',
  VAR_FG_TRANSLATE_START: '--mdc-ripple-fg-translate-start',
  VAR_FG_TRANSLATE_END: '--mdc-ripple-fg-translate-end'
};

var numbers = {
  PADDING: 10,
  INITIAL_ORIGIN_SCALE: 0.6,
  DEACTIVATION_TIMEOUT_MS: 300,
  FG_DEACTIVATION_MS: 83
};


// CONCATENATED MODULE: ../@material/ripple/util.js
/**
 * @license
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Stores result from supportsCssVariables to avoid redundant processing to detect CSS custom variable support.
 * @private {boolean|undefined}
 */
var supportsCssVariables_ = void 0;

/**
 * Stores result from applyPassive to avoid redundant processing to detect passive event listener support.
 * @private {boolean|undefined}
 */
var supportsPassive_ = void 0;

/**
 * @param {!Window} windowObj
 * @return {boolean}
 */
function detectEdgePseudoVarBug(windowObj) {
  // Detect versions of Edge with buggy var() support
  // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/11495448/
  var document = windowObj.document;
  var node = document.createElement('div');
  node.className = 'mdc-ripple-surface--test-edge-var-bug';
  document.body.appendChild(node);

  // The bug exists if ::before style ends up propagating to the parent element.
  // Additionally, getComputedStyle returns null in iframes with display: "none" in Firefox,
  // but Firefox is known to support CSS custom properties correctly.
  // See: https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  var computedStyle = windowObj.getComputedStyle(node);
  var hasPseudoVarBug = computedStyle !== null && computedStyle.borderTopStyle === 'solid';
  node.remove();
  return hasPseudoVarBug;
}

/**
 * @param {!Window} windowObj
 * @param {boolean=} forceRefresh
 * @return {boolean|undefined}
 */

function supportsCssVariables(windowObj) {
  var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (typeof supportsCssVariables_ === 'boolean' && !forceRefresh) {
    return supportsCssVariables_;
  }

  var supportsFunctionPresent = windowObj.CSS && typeof windowObj.CSS.supports === 'function';
  if (!supportsFunctionPresent) {
    return;
  }

  var explicitlySupportsCssVars = windowObj.CSS.supports('--css-vars', 'yes');
  // See: https://bugs.webkit.org/show_bug.cgi?id=154669
  // See: README section on Safari
  var weAreFeatureDetectingSafari10plus = windowObj.CSS.supports('(--css-vars: yes)') && windowObj.CSS.supports('color', '#00000000');

  if (explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus) {
    supportsCssVariables_ = !detectEdgePseudoVarBug(windowObj);
  } else {
    supportsCssVariables_ = false;
  }
  return supportsCssVariables_;
}

//
/**
 * Determine whether the current browser supports passive event listeners, and if so, use them.
 * @param {!Window=} globalObj
 * @param {boolean=} forceRefresh
 * @return {boolean|{passive: boolean}}
 */
function applyPassive() {
  var globalObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (supportsPassive_ === undefined || forceRefresh) {
    var isSupported = false;
    try {
      globalObj.document.addEventListener('test', null, { get passive() {
          isSupported = true;
        } });
    } catch (e) {}

    supportsPassive_ = isSupported;
  }

  return supportsPassive_ ? { passive: true } : false;
}

/**
 * @param {!Object} HTMLElementPrototype
 * @return {!Array<string>}
 */
function getMatchesProperty(HTMLElementPrototype) {
  return ['webkitMatchesSelector', 'msMatchesSelector', 'matches'].filter(function (p) {
    return p in HTMLElementPrototype;
  }).pop();
}

/**
 * @param {!Event} ev
 * @param {!{x: number, y: number}} pageOffset
 * @param {!ClientRect} clientRect
 * @return {!{x: number, y: number}}
 */
function getNormalizedEventCoords(ev, pageOffset, clientRect) {
  var x = pageOffset.x,
      y = pageOffset.y;

  var documentX = x + clientRect.left;
  var documentY = y + clientRect.top;

  var normalizedX = void 0;
  var normalizedY = void 0;
  // Determine touch point relative to the ripple container.
  if (ev.type === 'touchstart') {
    normalizedX = ev.changedTouches[0].pageX - documentX;
    normalizedY = ev.changedTouches[0].pageY - documentY;
  } else {
    normalizedX = ev.pageX - documentX;
    normalizedY = ev.pageY - documentY;
  }

  return { x: normalizedX, y: normalizedY };
}


// CONCATENATED MODULE: ../@material/ripple/foundation.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function foundation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @license
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/**
 * @typedef {!{
 *   isActivated: (boolean|undefined),
 *   hasDeactivationUXRun: (boolean|undefined),
 *   wasActivatedByPointer: (boolean|undefined),
 *   wasElementMadeActive: (boolean|undefined),
 *   activationStartTime: (number|undefined),
 *   activationEvent: Event,
 *   isProgrammatic: (boolean|undefined)
 * }}
 */
var ActivationStateType = void 0;

/**
 * @typedef {!{
 *   activate: (string|undefined),
 *   deactivate: (string|undefined),
 *   focus: (string|undefined),
 *   blur: (string|undefined)
 * }}
 */
var ListenerInfoType = void 0;

/**
 * @typedef {!{
 *   activate: function(!Event),
 *   deactivate: function(!Event),
 *   focus: function(),
 *   blur: function()
 * }}
 */
var ListenersType = void 0;

/**
 * @typedef {!{
 *   x: number,
 *   y: number
 * }}
 */
var PointType = void 0;

/**
 * @enum {string}
 */
var DEACTIVATION_ACTIVATION_PAIRS = {
  mouseup: 'mousedown',
  pointerup: 'pointerdown',
  touchend: 'touchstart',
  keyup: 'keydown',
  blur: 'focus'
};

/**
 * @extends {MDCFoundation<!MDCRippleAdapter>}
 */

var foundation_MDCRippleFoundation = function (_MDCFoundation) {
  _inherits(MDCRippleFoundation, _MDCFoundation);

  _createClass(MDCRippleFoundation, [{
    key: 'isSupported_',


    /**
     * We compute this property so that we are not querying information about the client
     * until the point in time where the foundation requests it. This prevents scenarios where
     * client-side feature-detection may happen too early, such as when components are rendered on the server
     * and then initialized at mount time on the client.
     * @return {boolean}
     */
    get: function get() {
      return this.adapter_.browserSupportsCssVars();
    }
  }], [{
    key: 'cssClasses',
    get: function get() {
      return cssClasses;
    }
  }, {
    key: 'strings',
    get: function get() {
      return strings;
    }
  }, {
    key: 'numbers',
    get: function get() {
      return numbers;
    }
  }, {
    key: 'defaultAdapter',
    get: function get() {
      return {
        browserSupportsCssVars: function browserSupportsCssVars() /* boolean - cached */{},
        isUnbounded: function isUnbounded() /* boolean */{},
        isSurfaceActive: function isSurfaceActive() /* boolean */{},
        isSurfaceDisabled: function isSurfaceDisabled() /* boolean */{},
        addClass: function addClass() /* className: string */{},
        removeClass: function removeClass() /* className: string */{},
        registerInteractionHandler: function registerInteractionHandler() /* evtType: string, handler: EventListener */{},
        deregisterInteractionHandler: function deregisterInteractionHandler() /* evtType: string, handler: EventListener */{},
        registerResizeHandler: function registerResizeHandler() /* handler: EventListener */{},
        deregisterResizeHandler: function deregisterResizeHandler() /* handler: EventListener */{},
        updateCssVariable: function updateCssVariable() /* varName: string, value: string */{},
        computeBoundingRect: function computeBoundingRect() /* ClientRect */{},
        getWindowPageOffset: function getWindowPageOffset() /* {x: number, y: number} */{}
      };
    }
  }]);

  function MDCRippleFoundation(adapter) {
    foundation__classCallCheck(this, MDCRippleFoundation);

    /** @private {number} */
    var _this = _possibleConstructorReturn(this, _MDCFoundation.call(this, _extends(MDCRippleFoundation.defaultAdapter, adapter)));

    _this.layoutFrame_ = 0;

    /** @private {!ClientRect} */
    _this.frame_ = /** @type {!ClientRect} */{ width: 0, height: 0 };

    /** @private {!ActivationStateType} */
    _this.activationState_ = _this.defaultActivationState_();

    /** @private {number} */
    _this.xfDuration_ = 0;

    /** @private {number} */
    _this.initialSize_ = 0;

    /** @private {number} */
    _this.maxRadius_ = 0;

    /** @private {!Array<{ListenerInfoType}>} */
    _this.listenerInfos_ = [{ activate: 'touchstart', deactivate: 'touchend' }, { activate: 'pointerdown', deactivate: 'pointerup' }, { activate: 'mousedown', deactivate: 'mouseup' }, { activate: 'keydown', deactivate: 'keyup' }, { focus: 'focus', blur: 'blur' }];

    /** @private {!ListenersType} */
    _this.listeners_ = {
      activate: function activate(e) {
        return _this.activate_(e);
      },
      deactivate: function deactivate(e) {
        return _this.deactivate_(e);
      },
      focus: function focus() {
        return requestAnimationFrame(function () {
          return _this.adapter_.addClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
        });
      },
      blur: function blur() {
        return requestAnimationFrame(function () {
          return _this.adapter_.removeClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
        });
      }
    };

    /** @private {!Function} */
    _this.resizeHandler_ = function () {
      return _this.layout();
    };

    /** @private {!{left: number, top:number}} */
    _this.unboundedCoords_ = {
      left: 0,
      top: 0
    };

    /** @private {number} */
    _this.fgScale_ = 0;

    /** @private {number} */
    _this.activationTimer_ = 0;

    /** @private {number} */
    _this.fgDeactivationRemovalTimer_ = 0;

    /** @private {boolean} */
    _this.activationAnimationHasEnded_ = false;

    /** @private {!Function} */
    _this.activationTimerCallback_ = function () {
      _this.activationAnimationHasEnded_ = true;
      _this.runDeactivationUXLogicIfReady_();
    };
    return _this;
  }

  /**
   * @return {!ActivationStateType}
   */


  MDCRippleFoundation.prototype.defaultActivationState_ = function defaultActivationState_() {
    return {
      isActivated: false,
      hasDeactivationUXRun: false,
      wasActivatedByPointer: false,
      wasElementMadeActive: false,
      activationStartTime: 0,
      activationEvent: null,
      isProgrammatic: false
    };
  };

  MDCRippleFoundation.prototype.init = function init() {
    var _this2 = this;

    if (!this.isSupported_) {
      return;
    }
    this.addEventListeners_();

    var _MDCRippleFoundation$ = MDCRippleFoundation.cssClasses,
        ROOT = _MDCRippleFoundation$.ROOT,
        UNBOUNDED = _MDCRippleFoundation$.UNBOUNDED;

    requestAnimationFrame(function () {
      _this2.adapter_.addClass(ROOT);
      if (_this2.adapter_.isUnbounded()) {
        _this2.adapter_.addClass(UNBOUNDED);
      }
      _this2.layoutInternal_();
    });
  };

  /** @private */


  MDCRippleFoundation.prototype.addEventListeners_ = function addEventListeners_() {
    var _this3 = this;

    this.listenerInfos_.forEach(function (info) {
      Object.keys(info).forEach(function (k) {
        _this3.adapter_.registerInteractionHandler(info[k], _this3.listeners_[k]);
      });
    });
    this.adapter_.registerResizeHandler(this.resizeHandler_);
  };

  /**
   * @param {Event} e
   * @private
   */


  MDCRippleFoundation.prototype.activate_ = function activate_(e) {
    var _this4 = this;

    if (this.adapter_.isSurfaceDisabled()) {
      return;
    }

    var activationState = this.activationState_;

    if (activationState.isActivated) {
      return;
    }

    activationState.isActivated = true;
    activationState.isProgrammatic = e === null;
    activationState.activationEvent = e;
    activationState.wasActivatedByPointer = activationState.isProgrammatic ? false : e.type === 'mousedown' || e.type === 'touchstart' || e.type === 'pointerdown';
    activationState.activationStartTime = Date.now();

    requestAnimationFrame(function () {
      // This needs to be wrapped in an rAF call b/c web browsers
      // report active states inconsistently when they're called within
      // event handling code:
      // - https://bugs.chromium.org/p/chromium/issues/detail?id=635971
      // - https://bugzilla.mozilla.org/show_bug.cgi?id=1293741
      activationState.wasElementMadeActive = e && e.type === 'keydown' ? _this4.adapter_.isSurfaceActive() : true;
      if (activationState.wasElementMadeActive) {
        _this4.animateActivation_();
      } else {
        // Reset activation state immediately if element was not made active.
        _this4.activationState_ = _this4.defaultActivationState_();
      }
    });
  };

  MDCRippleFoundation.prototype.activate = function activate() {
    this.activate_(null);
  };

  /** @private */


  MDCRippleFoundation.prototype.animateActivation_ = function animateActivation_() {
    var _this5 = this;

    var _MDCRippleFoundation$2 = MDCRippleFoundation.strings,
        VAR_FG_TRANSLATE_START = _MDCRippleFoundation$2.VAR_FG_TRANSLATE_START,
        VAR_FG_TRANSLATE_END = _MDCRippleFoundation$2.VAR_FG_TRANSLATE_END;
    var _MDCRippleFoundation$3 = MDCRippleFoundation.cssClasses,
        BG_ACTIVE_FILL = _MDCRippleFoundation$3.BG_ACTIVE_FILL,
        FG_DEACTIVATION = _MDCRippleFoundation$3.FG_DEACTIVATION,
        FG_ACTIVATION = _MDCRippleFoundation$3.FG_ACTIVATION;
    var DEACTIVATION_TIMEOUT_MS = MDCRippleFoundation.numbers.DEACTIVATION_TIMEOUT_MS;


    var translateStart = '';
    var translateEnd = '';

    if (!this.adapter_.isUnbounded()) {
      var _getFgTranslationCoor = this.getFgTranslationCoordinates_(),
          startPoint = _getFgTranslationCoor.startPoint,
          endPoint = _getFgTranslationCoor.endPoint;

      translateStart = startPoint.x + 'px, ' + startPoint.y + 'px';
      translateEnd = endPoint.x + 'px, ' + endPoint.y + 'px';
    }

    this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
    this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
    // Cancel any ongoing activation/deactivation animations
    clearTimeout(this.activationTimer_);
    clearTimeout(this.fgDeactivationRemovalTimer_);
    this.rmBoundedActivationClasses_();
    this.adapter_.removeClass(FG_DEACTIVATION);

    // Force layout in order to re-trigger the animation.
    this.adapter_.computeBoundingRect();
    this.adapter_.addClass(BG_ACTIVE_FILL);
    this.adapter_.addClass(FG_ACTIVATION);
    this.activationTimer_ = setTimeout(function () {
      return _this5.activationTimerCallback_();
    }, DEACTIVATION_TIMEOUT_MS);
  };

  /**
   * @private
   * @return {{startPoint: PointType, endPoint: PointType}}
   */


  MDCRippleFoundation.prototype.getFgTranslationCoordinates_ = function getFgTranslationCoordinates_() {
    var activationState = this.activationState_;
    var activationEvent = activationState.activationEvent,
        wasActivatedByPointer = activationState.wasActivatedByPointer;


    var startPoint = void 0;
    if (wasActivatedByPointer) {
      startPoint = getNormalizedEventCoords(
      /** @type {!Event} */activationEvent, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect());
    } else {
      startPoint = {
        x: this.frame_.width / 2,
        y: this.frame_.height / 2
      };
    }
    // Center the element around the start point.
    startPoint = {
      x: startPoint.x - this.initialSize_ / 2,
      y: startPoint.y - this.initialSize_ / 2
    };

    var endPoint = {
      x: this.frame_.width / 2 - this.initialSize_ / 2,
      y: this.frame_.height / 2 - this.initialSize_ / 2
    };

    return { startPoint: startPoint, endPoint: endPoint };
  };

  /** @private */


  MDCRippleFoundation.prototype.runDeactivationUXLogicIfReady_ = function runDeactivationUXLogicIfReady_() {
    var _this6 = this;

    var FG_DEACTIVATION = MDCRippleFoundation.cssClasses.FG_DEACTIVATION;
    var _activationState_ = this.activationState_,
        hasDeactivationUXRun = _activationState_.hasDeactivationUXRun,
        isActivated = _activationState_.isActivated;

    var activationHasEnded = hasDeactivationUXRun || !isActivated;
    if (activationHasEnded && this.activationAnimationHasEnded_) {
      this.rmBoundedActivationClasses_();
      this.adapter_.addClass(FG_DEACTIVATION);
      this.fgDeactivationRemovalTimer_ = setTimeout(function () {
        _this6.adapter_.removeClass(FG_DEACTIVATION);
      }, numbers.FG_DEACTIVATION_MS);
    }
  };

  /** @private */


  MDCRippleFoundation.prototype.rmBoundedActivationClasses_ = function rmBoundedActivationClasses_() {
    var _MDCRippleFoundation$4 = MDCRippleFoundation.cssClasses,
        BG_ACTIVE_FILL = _MDCRippleFoundation$4.BG_ACTIVE_FILL,
        FG_ACTIVATION = _MDCRippleFoundation$4.FG_ACTIVATION;

    this.adapter_.removeClass(BG_ACTIVE_FILL);
    this.adapter_.removeClass(FG_ACTIVATION);
    this.activationAnimationHasEnded_ = false;
    this.adapter_.computeBoundingRect();
  };

  /**
   * @param {Event} e
   * @private
   */


  MDCRippleFoundation.prototype.deactivate_ = function deactivate_(e) {
    var _this7 = this;

    var activationState = this.activationState_;
    // This can happen in scenarios such as when you have a keyup event that blurs the element.

    if (!activationState.isActivated) {
      return;
    }
    // Programmatic deactivation.
    if (activationState.isProgrammatic) {
      var evtObject = null;
      var _state = /** @type {!ActivationStateType} */_extends({}, activationState);
      requestAnimationFrame(function () {
        return _this7.animateDeactivation_(evtObject, _state);
      });
      this.activationState_ = this.defaultActivationState_();
      return;
    }

    var actualActivationType = DEACTIVATION_ACTIVATION_PAIRS[e.type];
    var expectedActivationType = activationState.activationEvent.type;
    // NOTE: Pointer events are tricky - https://patrickhlauke.github.io/touch/tests/results/
    // Essentially, what we need to do here is decouple the deactivation UX from the actual
    // deactivation state itself. This way, touch/pointer events in sequence do not trample one
    // another.
    var needsDeactivationUX = actualActivationType === expectedActivationType;
    var needsActualDeactivation = needsDeactivationUX;
    if (activationState.wasActivatedByPointer) {
      needsActualDeactivation = e.type === 'mouseup';
    }

    var state = /** @type {!ActivationStateType} */_extends({}, activationState);
    requestAnimationFrame(function () {
      if (needsDeactivationUX) {
        _this7.activationState_.hasDeactivationUXRun = true;
        _this7.animateDeactivation_(e, state);
      }

      if (needsActualDeactivation) {
        _this7.activationState_ = _this7.defaultActivationState_();
      }
    });
  };

  MDCRippleFoundation.prototype.deactivate = function deactivate() {
    this.deactivate_(null);
  };

  /**
   * @param {Event} e
   * @param {!ActivationStateType} options
   * @private
   */


  MDCRippleFoundation.prototype.animateDeactivation_ = function animateDeactivation_(e, _ref) {
    var wasActivatedByPointer = _ref.wasActivatedByPointer,
        wasElementMadeActive = _ref.wasElementMadeActive;
    var BG_FOCUSED = MDCRippleFoundation.cssClasses.BG_FOCUSED;

    if (wasActivatedByPointer || wasElementMadeActive) {
      // Remove class left over by element being focused
      this.adapter_.removeClass(BG_FOCUSED);
      this.runDeactivationUXLogicIfReady_();
    }
  };

  MDCRippleFoundation.prototype.destroy = function destroy() {
    var _this8 = this;

    if (!this.isSupported_) {
      return;
    }
    this.removeEventListeners_();

    var _MDCRippleFoundation$5 = MDCRippleFoundation.cssClasses,
        ROOT = _MDCRippleFoundation$5.ROOT,
        UNBOUNDED = _MDCRippleFoundation$5.UNBOUNDED;

    requestAnimationFrame(function () {
      _this8.adapter_.removeClass(ROOT);
      _this8.adapter_.removeClass(UNBOUNDED);
      _this8.removeCssVars_();
    });
  };

  /** @private */


  MDCRippleFoundation.prototype.removeEventListeners_ = function removeEventListeners_() {
    var _this9 = this;

    this.listenerInfos_.forEach(function (info) {
      Object.keys(info).forEach(function (k) {
        _this9.adapter_.deregisterInteractionHandler(info[k], _this9.listeners_[k]);
      });
    });
    this.adapter_.deregisterResizeHandler(this.resizeHandler_);
  };

  /** @private */


  MDCRippleFoundation.prototype.removeCssVars_ = function removeCssVars_() {
    var _this10 = this;

    var strings = MDCRippleFoundation.strings;

    Object.keys(strings).forEach(function (k) {
      if (k.indexOf('VAR_') === 0) {
        _this10.adapter_.updateCssVariable(strings[k], null);
      }
    });
  };

  MDCRippleFoundation.prototype.layout = function layout() {
    var _this11 = this;

    if (this.layoutFrame_) {
      cancelAnimationFrame(this.layoutFrame_);
    }
    this.layoutFrame_ = requestAnimationFrame(function () {
      _this11.layoutInternal_();
      _this11.layoutFrame_ = 0;
    });
  };

  /** @private */


  MDCRippleFoundation.prototype.layoutInternal_ = function layoutInternal_() {
    this.frame_ = this.adapter_.computeBoundingRect();

    var maxDim = Math.max(this.frame_.height, this.frame_.width);
    var surfaceDiameter = Math.sqrt(Math.pow(this.frame_.width, 2) + Math.pow(this.frame_.height, 2));

    // 60% of the largest dimension of the surface
    this.initialSize_ = maxDim * MDCRippleFoundation.numbers.INITIAL_ORIGIN_SCALE;

    // Diameter of the surface + 10px
    this.maxRadius_ = surfaceDiameter + MDCRippleFoundation.numbers.PADDING;
    this.fgScale_ = this.maxRadius_ / this.initialSize_;
    this.xfDuration_ = 1000 * Math.sqrt(this.maxRadius_ / 1024);
    this.updateLayoutCssVars_();
  };

  /** @private */


  MDCRippleFoundation.prototype.updateLayoutCssVars_ = function updateLayoutCssVars_() {
    var _MDCRippleFoundation$6 = MDCRippleFoundation.strings,
        VAR_SURFACE_WIDTH = _MDCRippleFoundation$6.VAR_SURFACE_WIDTH,
        VAR_SURFACE_HEIGHT = _MDCRippleFoundation$6.VAR_SURFACE_HEIGHT,
        VAR_FG_SIZE = _MDCRippleFoundation$6.VAR_FG_SIZE,
        VAR_LEFT = _MDCRippleFoundation$6.VAR_LEFT,
        VAR_TOP = _MDCRippleFoundation$6.VAR_TOP,
        VAR_FG_SCALE = _MDCRippleFoundation$6.VAR_FG_SCALE;


    this.adapter_.updateCssVariable(VAR_SURFACE_WIDTH, this.frame_.width + 'px');
    this.adapter_.updateCssVariable(VAR_SURFACE_HEIGHT, this.frame_.height + 'px');
    this.adapter_.updateCssVariable(VAR_FG_SIZE, this.initialSize_ + 'px');
    this.adapter_.updateCssVariable(VAR_FG_SCALE, this.fgScale_);

    if (this.adapter_.isUnbounded()) {
      this.unboundedCoords_ = {
        left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
        top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
      };

      this.adapter_.updateCssVariable(VAR_LEFT, this.unboundedCoords_.left + 'px');
      this.adapter_.updateCssVariable(VAR_TOP, this.unboundedCoords_.top + 'px');
    }
  };

  return MDCRippleFoundation;
}(foundation["a" /* default */]);

/* harmony default export */ var ripple_foundation = (foundation_MDCRippleFoundation);
// CONCATENATED MODULE: ../@material/ripple/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ripple_MDCRipple; });
/* unused concated harmony import MDCRippleFoundation */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ripple_foundation; });
/* unused concated harmony import util */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return util_namespaceObject; });
var ripple__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ripple__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ripple__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ripple__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @license
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/**
 * @extends MDCComponent<!MDCRippleFoundation>
 */

var ripple_MDCRipple = function (_MDCComponent) {
  ripple__inherits(MDCRipple, _MDCComponent);

  /** @param {...?} args */
  function MDCRipple() {
    ripple__classCallCheck(this, MDCRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    /** @type {boolean} */
    var _this = ripple__possibleConstructorReturn(this, _MDCComponent.call.apply(_MDCComponent, [this].concat(args)));

    _this.disabled = false;

    /** @private {boolean} */
    _this.unbounded_;
    return _this;
  }

  /**
   * @param {!Element} root
   * @param {{isUnbounded: (boolean|undefined)}=} options
   * @return {!MDCRipple}
   */


  MDCRipple.attachTo = function attachTo(root) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$isUnbounded = _ref.isUnbounded,
        isUnbounded = _ref$isUnbounded === undefined ? undefined : _ref$isUnbounded;

    var ripple = new MDCRipple(root);
    // Only override unbounded behavior if option is explicitly specified
    if (isUnbounded !== undefined) {
      ripple.unbounded = /** @type {boolean} */isUnbounded;
    }
    return ripple;
  };

  /**
   * @param {!RippleCapableSurface} instance
   * @return {!MDCRippleAdapter}
   */


  MDCRipple.createAdapter = function createAdapter(instance) {
    var MATCHES = getMatchesProperty(HTMLElement.prototype);

    return {
      browserSupportsCssVars: function browserSupportsCssVars() {
        return supportsCssVariables(window);
      },
      isUnbounded: function isUnbounded() {
        return instance.unbounded;
      },
      isSurfaceActive: function isSurfaceActive() {
        return instance.root_[MATCHES](':active');
      },
      isSurfaceDisabled: function isSurfaceDisabled() {
        return instance.disabled;
      },
      addClass: function addClass(className) {
        return instance.root_.classList.add(className);
      },
      removeClass: function removeClass(className) {
        return instance.root_.classList.remove(className);
      },
      registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
        return instance.root_.addEventListener(evtType, handler, applyPassive());
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
        return instance.root_.removeEventListener(evtType, handler, applyPassive());
      },
      registerResizeHandler: function registerResizeHandler(handler) {
        return window.addEventListener('resize', handler);
      },
      deregisterResizeHandler: function deregisterResizeHandler(handler) {
        return window.removeEventListener('resize', handler);
      },
      updateCssVariable: function updateCssVariable(varName, value) {
        return instance.root_.style.setProperty(varName, value);
      },
      computeBoundingRect: function computeBoundingRect() {
        return instance.root_.getBoundingClientRect();
      },
      getWindowPageOffset: function getWindowPageOffset() {
        return { x: window.pageXOffset, y: window.pageYOffset };
      }
    };
  };

  /** @return {boolean} */


  MDCRipple.prototype.activate = function activate() {
    this.foundation_.activate();
  };

  MDCRipple.prototype.deactivate = function deactivate() {
    this.foundation_.deactivate();
  };

  MDCRipple.prototype.layout = function layout() {
    this.foundation_.layout();
  };

  /** @return {!MDCRippleFoundation} */


  MDCRipple.prototype.getDefaultFoundation = function getDefaultFoundation() {
    return new ripple_foundation(MDCRipple.createAdapter(this));
  };

  MDCRipple.prototype.initialSyncWithDOM = function initialSyncWithDOM() {
    this.unbounded = 'mdcRippleIsUnbounded' in this.root_.dataset;
  };

  ripple__createClass(MDCRipple, [{
    key: 'unbounded',
    get: function get() {
      return this.unbounded_;
    }

    /** @param {boolean} unbounded */
    ,
    set: function set(unbounded) {
      var UNBOUNDED = ripple_foundation.cssClasses.UNBOUNDED;

      this.unbounded_ = Boolean(unbounded);
      if (this.unbounded_) {
        this.root_.classList.add(UNBOUNDED);
      } else {
        this.root_.classList.remove(UNBOUNDED);
      }
    }
  }]);

  return MDCRipple;
}(component["a" /* default */]);

/**
 * See Material Design spec for more details on when to use ripples.
 * https://material.io/guidelines/motion/choreography.html#choreography-creation
 * @record
 */


var RippleCapableSurface = function RippleCapableSurface() {
  ripple__classCallCheck(this, RippleCapableSurface);
};

/** @protected {!Element} */


RippleCapableSurface.prototype.root_;

/**
 * Whether or not the ripple bleeds out of the bounds of the element.
 * @type {boolean|undefined}
 */
RippleCapableSurface.prototype.unbounded;

/**
 * Whether or not the ripple is attached to a disabled component.
 * @type {boolean|undefined}
 */
RippleCapableSurface.prototype.disabled;



/***/ }),

/***/ "vyFQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplyService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return undoApplyService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_form_urlencoded__ = __webpack_require__("dA1j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_form_urlencoded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_form_urlencoded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global__ = __webpack_require__("IyPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_or_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_window_or_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FetchHelper__ = __webpack_require__("Hm4v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ApplyCookieHelper_js__ = __webpack_require__("8Ery");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__("RGwo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_ApplyActions__ = __webpack_require__("y6h9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("R8p8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_index__ = __webpack_require__("upA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_GaHelper_index__ = __webpack_require__("8wV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WebStorageWrapper__ = __webpack_require__("Lpc9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("QSFW");
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Utility Functions to submit apply form
 * No need to maintain any states or properties, just return the results
 */













var ApplyService = (_temp = _class = function () {
	function ApplyService() {
		var _this = this;

		_classCallCheck(this, ApplyService);

		this.updateCookieAfterApply = function (data) {
			for (var field in data) {
				if (data.hasOwnProperty(field)) {
					_this.applyCookieHelper.setPrefillItem(field, data[field]);
				}
			}
		};

		this.callRecruiterNumberAjax = function (payload) {
			var params = {
				url: Object(__WEBPACK_IMPORTED_MODULE_7__utils_index__["o" /* getProtocol */])() + __WEBPACK_IMPORTED_MODULE_10__constants__["b" /* API_URL */] + __WEBPACK_IMPORTED_MODULE_10__constants__["d" /* CALL_RECRUITER_NUMBER_API */],
				data: __WEBPACK_IMPORTED_MODULE_0_form_urlencoded___default()(payload)
			};

			var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();

			return fetchHelper.request('POST', params);
		};

		this.logExternalApplyDetails = function (payload) {
			var params = {
				url: Object(__WEBPACK_IMPORTED_MODULE_7__utils_index__["o" /* getProtocol */])() + __WEBPACK_IMPORTED_MODULE_10__constants__["b" /* API_URL */] + __WEBPACK_IMPORTED_MODULE_10__constants__["w" /* LOG_DATA_API_URL */],
				data: __WEBPACK_IMPORTED_MODULE_0_form_urlencoded___default()(payload)
			};

			var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();
			return fetchHelper.request('POST', params);
		};

		this.applyCookieHelper = new __WEBPACK_IMPORTED_MODULE_3__ApplyCookieHelper_js__["a" /* default */]();
		this.fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();
	}

	ApplyService.prototype.saveApplyFirstStep = function saveApplyFirstStep(inputFields, apply, user) {
		var formObject = '';
		try {
			formObject = this.getFirstStepRequest(inputFields, apply, user);
		} catch (error) {
			console.log(error);
		}

		var formData = __WEBPACK_IMPORTED_MODULE_0_form_urlencoded___default()(formObject);

		//console.log(formData);return;
		var updateduser = {
			mobile: formObject.var_mobile,
			email: formObject.var_email_Id,
			name: formObject.var_name,
			loggedIn: user.hasOwnProperty('loggedIn') && user.loggedIn || inputFields.hasOwnProperty('loggedIn') && inputFields.loggedIn
		};
		var params = {
			url: __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.protocol + '//www.quikr.com/jobs/apply/stepOne',
			includeCredentials: true,
			data: formData
		};
		var returnValues = {
			updatedUser: updateduser,
			applyPromise: this.fetchHelper.request('POST', params)
		};
		return returnValues;
	};

	ApplyService.prototype.getFirstStepRequest = function getFirstStepRequest(inputFields, apply, user) {
		// start: set apply source if available
		var directApplyAdId = __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('refDirectApplyAdId');
		var applySource = apply.source ? apply.source : 'VAP';

		if (directApplyAdId == apply.job.id) applySource = __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('applySource');
		// end : set apply source if available

		// Using Old Api For Now
		var request = {
			validateNewStep1: 1,
			adid: apply.job.id,
			var_current_role: apply.job.roleAnswerId ? apply.job.roleAnswerId : '',
			roleName: apply.job.role,
			source: applySource,
			jsStep1: 1,
			isNewApply: 1, //Handle this
			pwaApply: 1,
			isViewContact: apply.isCallButtonClicked ? 1 : 0,
			var_locality: apply.job.locality,
			utmSource: __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('utmSource'),
			utmMedium: __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('utmMedium'),
			utmCampaign: __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('utmCampaign')
		};

		if (inputFields.hasOwnProperty('addEmailToUser')) {
			request.addEmailToUser = inputFields.addEmailToUser;
			delete inputFields.addEmailToUser;
		}

		if (!inputFields.hasOwnProperty('city')) {
			request.var_city = apply.job.cityName;
		}

		if (user.vipEnabled) {
			request.isVipApplyAvailable = 1;
		}

		this.applyCookieHelper.setPrefillItem('city', apply.job.cityName);
		for (var _iterator = Object.keys(inputFields), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;

			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}

			var key = _ref;

			this.applyCookieHelper.setPrefillItem(key, inputFields[key]);

			var name = key;

			//TODO Handle Email
			if (key === 'email') {
				name = 'email_Id';
			}

			request['var_' + name] = inputFields[key];
		}

		request.isConflictCheckRequired = __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.localStorage.getItem('isConflictCheckRequired');

		try {
			if (!request['var_locality'] || request['var_locality'] === '') {
				request['var_locality'] = 'Entire ' + apply.job.cityName.replace('x:', '');
				request['var_city_show'] = request['var_city'];
			}
		} catch (error) {}

		/*
  if (request['var_city'] && request['var_city'].indexOf('x:') > -1 ){
  	let abroadCity = request['var_city'].replace('x:','');
  	request['var_city'] = request['var_locality'];
  	request['var_locality'] = 'Enitire '+abroadCity;
  }*/

		var localStorage = __WEBPACK_IMPORTED_MODULE_9__WebStorageWrapper__["a" /* default */].getLocalStorage();
		if (localStorage.hasKey('su')) {
			request['su'] = localStorage.getItem('su');
		}

		return request;
	};

	ApplyService.prototype.saveApplySecondStep = function saveApplySecondStep(inputFields, apply, user) {
		var formObject = this.getSecondStepRequest(inputFields, apply, user);

		var form_data = Object.keys(formObject).map(function (key) {
			if (formObject[key] instanceof Array) {
				return formObject[key].map(function (value, i) {
					return encodeURIComponent(key) + '=' + encodeURIComponent(value);
				}).join('&');
			}
			return encodeURIComponent(key) + '=' + encodeURIComponent(formObject[key]);
		}).join('&');

		var params = {
			url: __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.protocol + '//www.quikr.com/jobs/apply/stepTwo',
			includeCredentials: true,
			data: form_data
		};
		return this.fetchHelper.request('POST', params);
	};

	ApplyService.prototype.getSecondStepRequest = function getSecondStepRequest(inputFields, apply, user) {
		var request = {
			adid: apply.job.id,
			jsStep2: 1,
			validateNewStep2: 1,
			isPremium: 0,
			pwaApply: 1,
			role: apply.job.role,
			firstName: user.name,
			email: user.email,
			mobile: user.mobile
		};

		if (user.id) request.userId = user.id;

		for (var _iterator2 = Object.keys(inputFields), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
			var _ref2;

			if (_isArray2) {
				if (_i2 >= _iterator2.length) break;
				_ref2 = _iterator2[_i2++];
			} else {
				_i2 = _iterator2.next();
				if (_i2.done) break;
				_ref2 = _i2.value;
			}

			var key = _ref2;

			if (key === 'hasNewAnswers') {
				request.hasNewAnswers = inputFields[key];
			} else {
				if (inputFields[key]) {
					//&& inputFields[key].value > 0
					var arrayLabel = Array.isArray(inputFields[key]) ? '[]' : '';
					request['var_' + key.replace(/ /g, '_') + arrayLabel] = inputFields[key];
				}
			}
		}
		return request;
	};

	/**
   * Get Vip credist for user
   */


	ApplyService.prototype.getVipApplyDetailsFromApi = function getVipApplyDetailsFromApi(jobId) {
		var postData = 'pwaApply=1&adId=' + jobId;

		var params = {
			url: __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.protocol + '//www.quikr.com/jobs/getVipApplyCredits',
			includeCredentials: true,
			data: postData
		};
		return this.fetchHelper.request('POST', params);
	};

	/**
   * Save quick apply
   */


	ApplyService.prototype.saveQuickApply = function saveQuickApply(job) {
		// start : set apply source if available
		var directApplyAdId = __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('refDirectApplyAdId');
		var applySource = 'HEMS_VAP';

		if (directApplyAdId == job.id) applySource = 'HEMS_' + __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('applySource');
		// end : set apply source if available

		var formObject = {
			adId: job.id,
			role: job.role,
			applyCount: sessionStorage.applyCount ? sessionStorage.applyCount : 0,
			dontAskFlag: sessionStorage.dflag ? sessionStorage.dflag : false,
			showResumePromotionFlag: false,
			jobAppliedCounter: parseInt(localStorage.jobAppliedCounter, 10) + 1,
			source: applySource,
			utmSource: __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('utmSource'),
			utmMedium: __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('utmMedium'),
			utmCampaign: __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('utmCampaign')
		};

		var formData = __WEBPACK_IMPORTED_MODULE_0_form_urlencoded___default()(formObject);

		var params = {
			url: __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.protocol + '//www.quikr.com/jobs/quickApply',
			includeCredentials: true,
			data: formData
		};

		return this.fetchHelper.request('POST', params);
	};

	/**
  * Update Already Applied Details
  */


	ApplyService.prototype.submitUpdateApply = function submitUpdateApply(data, apply) {
		var _this2 = this;

		var changedQsObj = { locality: data.locality };
		var basicProfDataObj = {
			email: data.email,
			mobile: data.mobile,
			name: data.name,
			city: data.city
		};

		if (apply.firstStepProfile) {
			for (var key in basicProfDataObj) {
				if (basicProfDataObj[key] !== apply.firstStepProfile[key]) {
					changedQsObj[key] = basicProfDataObj[key];
				}
			}
		}

		var formObject = {
			adId: apply.job.id,
			city: apply.job.city,
			role: apply.job.role,
			vipApply: 0, //TODO,
			source: 'MOBILE',
			changedQs: changedQsObj,
			basicProfData: basicProfDataObj,
			utmSource: __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('utmSource'),
			utmMedium: __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('utmMedium'),
			utmCampaign: __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('utmCampaign')
		};

		var formData = __WEBPACK_IMPORTED_MODULE_0_form_urlencoded___default()(formObject);

		//let formData = Object.keys(formObject).map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(formObject[key])).join('&');
		var params = {
			url: __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.protocol + '//www.quikr.com/jobs/updateApplicationData',
			includeCredentials: true,
			data: formData
		};
		var response = this.fetchHelper.request('POST', params);
		response.then(function (apiResponse) {
			if (200 === apiResponse.status) {
				_this2.updateCookieAfterApply(data);
			}
		});
		return response;
	};

	ApplyService.prototype.getMobileVerifiedStatusPromise = function getMobileVerifiedStatusPromise(mobile) {
		if (!mobile) return false;

		var formObject = {
			mobile: mobile
		};
		var formData = __WEBPACK_IMPORTED_MODULE_0_form_urlencoded___default()(formObject);
		var params = {
			url: __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.protocol + '//www.quikr.com/jobs/jobsAjax/verificationStatus?' + formData
		};
		return this.fetchHelper.request('GET', params);
	};

	/**
  * Initialte apply for a job, incase the adId is present in url
  * feature introduced for amp
  */


	return ApplyService;
}(), _class.directApplyAd = function () {
	var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	var directApplyAdId = __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getApplyStore('directApplyAdId');
	var job = __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].getJobFromStore(directApplyAdId);

	if (directApplyAdId && 'SNB' === source && !job) {
		// firing amp ga, if it is an amp apply but ad is not available
		Object(__WEBPACK_IMPORTED_MODULE_8__utils_GaHelper_index__["b" /* firePageLoadGa */])('ampApplyError', { type: 'JobNotAvailable', adId: directApplyAdId });
	}

	var applyCookieHelper = new __WEBPACK_IMPORTED_MODULE_3__ApplyCookieHelper_js__["a" /* default */]();
	var isJobApplied = applyCookieHelper.isJobApplied(directApplyAdId);
	// storeHasKey check is present to check if the context response is available
	if (job && !isJobApplied && __WEBPACK_IMPORTED_MODULE_6__store__["a" /* JobStore */].storeHasKey('apply', 'isQuickApplyEnabled')) {
		var _source = Object(__WEBPACK_IMPORTED_MODULE_7__utils_index__["l" /* getParamFromUrl */])('source');
		__WEBPACK_IMPORTED_MODULE_6__store__["b" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_ApplyActions__["d" /* openApplyForm */])(job));

		Object(__WEBPACK_IMPORTED_MODULE_8__utils_GaHelper_index__["b" /* firePageLoadGa */])('applyinitiate', { type: 'inlineapply', source: _source });
		if (__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.history && __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location) {
			__WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.history.pushState(null, 'Apply for ' + job.title, __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.pathname + __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.search + '#apply');
		}
		// clear redux
		__WEBPACK_IMPORTED_MODULE_6__store__["b" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_ApplyActions__["c" /* clearDirectApplyAdId */])());
	} else if (isJobApplied) {
		__WEBPACK_IMPORTED_MODULE_6__store__["b" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_ApplyActions__["c" /* clearDirectApplyAdId */])());
		__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].toggleJobListDisplay(true);

		if (directApplyAdId && 'SNB' === source) {
			// firing amp ga, if it is an amp apply but the ad was already applied
			Object(__WEBPACK_IMPORTED_MODULE_8__utils_GaHelper_index__["b" /* firePageLoadGa */])('ampApplyError', { type: 'AlreadyApplied', adId: directApplyAdId });
		}
	}
}, _temp);



var undoApplyService = function undoApplyService(taskId, adId) {
	var city = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';

	var formObject = {
		taskId: taskId, adId: adId, city: city
	};

	var formData = __WEBPACK_IMPORTED_MODULE_0_form_urlencoded___default()(formObject);

	var params = {
		url: __WEBPACK_IMPORTED_MODULE_1_window_or_global___default.a.location.protocol + '//www.quikr.com/jobs/undoExpressApply',
		includeCredentials: true,
		data: formData
	};
	var fetchHelper = new __WEBPACK_IMPORTED_MODULE_2__FetchHelper__["a" /* default */]();

	return fetchHelper.request('POST', params);
};

/***/ }),

/***/ "w/zb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wZhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__foundation__ = __webpack_require__("/X9I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("xJR0");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__foundation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__component__["a"]; });
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/***/ }),

/***/ "xJR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__foundation__ = __webpack_require__("/X9I");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/**
 * @template F
 */

var MDCComponent = function () {
  /**
   * @param {!Element} root
   * @return {!MDCComponent}
   */
  MDCComponent.attachTo = function attachTo(root) {
    // Subclasses which extend MDCBase should provide an attachTo() method that takes a root element and
    // returns an instantiated component with its root set to that element. Also note that in the cases of
    // subclasses, an explicit foundation class will not have to be passed in; it will simply be initialized
    // from getDefaultFoundation().
    return new MDCComponent(root, new __WEBPACK_IMPORTED_MODULE_0__foundation__["a" /* default */]());
  };

  /**
   * @param {!Element} root
   * @param {F=} foundation
   * @param {...?} args
   */


  function MDCComponent(root) {
    var foundation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, MDCComponent);

    /** @protected {!Element} */
    this.root_ = root;

    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    this.initialize.apply(this, args);
    // Note that we initialize foundation here and not within the constructor's default param so that
    // this.root_ is defined and can be used within the foundation class.
    /** @protected {!F} */
    this.foundation_ = foundation === undefined ? this.getDefaultFoundation() : foundation;
    this.foundation_.init();
    this.initialSyncWithDOM();
  }

  MDCComponent.prototype.initialize = function initialize() /* ...args */{}
  // Subclasses can override this to do any additional setup work that would be considered part of a
  // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
  // initialized. Any additional arguments besides root and foundation will be passed in here.


  /**
   * @return {!F} foundation
   */
  ;

  MDCComponent.prototype.getDefaultFoundation = function getDefaultFoundation() {
    // Subclasses must override this method to return a properly configured foundation class for the
    // component.
    throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' + 'foundation class');
  };

  MDCComponent.prototype.initialSyncWithDOM = function initialSyncWithDOM() {
    // Subclasses should override this method if they need to perform work to synchronize with a host DOM
    // object. An example of this would be a form control wrapper that needs to synchronize its internal state
    // to some property or attribute of the host DOM. Please note: this is *not* the place to perform DOM
    // reads/writes that would cause layout / paint, as this is called synchronously from within the constructor.
  };

  MDCComponent.prototype.destroy = function destroy() {
    // Subclasses may implement this method to release any resources / deregister any listeners they have
    // attached. An example of this might be deregistering a resize event from the window object.
    this.foundation_.destroy();
  };

  /**
   * Wrapper method to add an event listener to the component's root element. This is most useful when
   * listening for custom events.
   * @param {string} evtType
   * @param {!Function} handler
   */


  MDCComponent.prototype.listen = function listen(evtType, handler) {
    this.root_.addEventListener(evtType, handler);
  };

  /**
   * Wrapper method to remove an event listener to the component's root element. This is most useful when
   * unlistening for custom events.
   * @param {string} evtType
   * @param {!Function} handler
   */


  MDCComponent.prototype.unlisten = function unlisten(evtType, handler) {
    this.root_.removeEventListener(evtType, handler);
  };

  /**
   * Fires a cross-browser-compatible custom event from the component root of the given type,
   * with the given data.
   * @param {string} evtType
   * @param {!Object} evtData
   * @param {boolean=} shouldBubble
   */


  MDCComponent.prototype.emit = function emit(evtType, evtData) {
    var shouldBubble = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var evt = void 0;
    if (typeof CustomEvent === 'function') {
      evt = new CustomEvent(evtType, {
        detail: evtData,
        bubbles: shouldBubble
      });
    } else {
      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(evtType, shouldBubble, false, evtData);
    }

    this.root_.dispatchEvent(evt);
  };

  return MDCComponent;
}();

/* harmony default export */ __webpack_exports__["a"] = (MDCComponent);

/***/ }),

/***/ "xN03":
/***/ (function(module, exports) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var carsHomePageUrl = '/cars/used-cars/';
var baseUrl = location.hostname === "localhost" ? "https://www.quikr.com" : location.origin;
var missedCallNumer = '07799740025';

module.exports = _extends({
    carsHomePageUrl: carsHomePageUrl,
    baseUrl: baseUrl,
    missedCallNumer: missedCallNumer
});

/***/ }),

/***/ "xXYm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util_namespaceObject = {};
__webpack_require__.d(util_namespaceObject, "createFocusTrapInstance", function() { return createFocusTrapInstance; });

// EXTERNAL MODULE: ../@material/base/index.js
var base = __webpack_require__("wZhe");

// EXTERNAL MODULE: ../@material/ripple/index.js + 4 modules
var ripple = __webpack_require__("vrDd");

// CONCATENATED MODULE: ../@material/dialog/constants.js
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var cssClasses = {
  ROOT: 'mdc-dialog',
  OPEN: 'mdc-dialog--open',
  ANIMATING: 'mdc-dialog--animating',
  BACKDROP: 'mdc-dialog__backdrop',
  SCROLL_LOCK: 'mdc-dialog-scroll-lock',
  ACCEPT_BTN: 'mdc-dialog__footer__button--accept',
  CANCEL_BTN: 'mdc-dialog__footer__button--cancel'
};

var strings = {
  OPEN_DIALOG_SELECTOR: '.mdc-dialog--open',
  DIALOG_SURFACE_SELECTOR: '.mdc-dialog__surface',
  ACCEPT_SELECTOR: '.mdc-dialog__footer__button--accept',
  ACCEPT_EVENT: 'MDCDialog:accept',
  CANCEL_EVENT: 'MDCDialog:cancel'
};
// CONCATENATED MODULE: ../@material/dialog/foundation.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var foundation_MDCDialogFoundation = function (_MDCFoundation) {
  _inherits(MDCDialogFoundation, _MDCFoundation);

  _createClass(MDCDialogFoundation, null, [{
    key: 'cssClasses',
    get: function get() {
      return cssClasses;
    }
  }, {
    key: 'strings',
    get: function get() {
      return strings;
    }
  }, {
    key: 'defaultAdapter',
    get: function get() {
      return {
        addClass: function addClass() /* className: string */{},
        removeClass: function removeClass() /* className: string */{},
        addBodyClass: function addBodyClass() /* className: string */{},
        removeBodyClass: function removeBodyClass() /* className: string */{},
        eventTargetHasClass: function eventTargetHasClass() {
          return (/* target: EventTarget, className: string */ /* boolean */false
          );
        },
        registerInteractionHandler: function registerInteractionHandler() /* evt: string, handler: EventListener */{},
        deregisterInteractionHandler: function deregisterInteractionHandler() /* evt: string, handler: EventListener */{},
        registerSurfaceInteractionHandler: function registerSurfaceInteractionHandler() /* evt: string, handler: EventListener */{},
        deregisterSurfaceInteractionHandler: function deregisterSurfaceInteractionHandler() /* evt: string, handler: EventListener */{},
        registerDocumentKeydownHandler: function registerDocumentKeydownHandler() /* handler: EventListener */{},
        deregisterDocumentKeydownHandler: function deregisterDocumentKeydownHandler() /* handler: EventListener */{},
        registerTransitionEndHandler: function registerTransitionEndHandler() /* handler: EventListener */{},
        deregisterTransitionEndHandler: function deregisterTransitionEndHandler() /* handler: EventListener */{},
        notifyAccept: function notifyAccept() {},
        notifyCancel: function notifyCancel() {},
        trapFocusOnSurface: function trapFocusOnSurface() {},
        untrapFocusOnSurface: function untrapFocusOnSurface() {},
        isDialog: function isDialog() {
          return (/* el: Element */ /* boolean */false
          );
        },
        layoutFooterRipples: function layoutFooterRipples() {}
      };
    }
  }]);

  function MDCDialogFoundation(adapter) {
    _classCallCheck(this, MDCDialogFoundation);

    var _this = _possibleConstructorReturn(this, _MDCFoundation.call(this, _extends(MDCDialogFoundation.defaultAdapter, adapter)));

    _this.isOpen_ = false;
    _this.componentClickHandler_ = function (evt) {
      if (_this.adapter_.eventTargetHasClass(evt.target, cssClasses.BACKDROP)) {
        _this.cancel(true);
      }
    };
    _this.dialogClickHandler_ = function (evt) {
      return _this.handleDialogClick_(evt);
    };
    _this.documentKeydownHandler_ = function (evt) {
      if (evt.key && evt.key === 'Escape' || evt.keyCode === 27) {
        _this.cancel(true);
      }
    };
    _this.transitionEndHandler_ = function (evt) {
      return _this.handleTransitionEnd_(evt);
    };
    return _this;
  }

  MDCDialogFoundation.prototype.destroy = function destroy() {
    // Ensure that dialog is cleaned up when destroyed
    if (this.isOpen_) {
      this.adapter_.deregisterSurfaceInteractionHandler('click', this.dialogClickHandler_);
      this.adapter_.deregisterDocumentKeydownHandler(this.documentKeydownHandler_);
      this.adapter_.deregisterInteractionHandler('click', this.componentClickHandler_);
      this.adapter_.untrapFocusOnSurface();
      this.adapter_.deregisterTransitionEndHandler(this.transitionEndHandler_);
      this.adapter_.removeClass(MDCDialogFoundation.cssClasses.ANIMATING);
      this.adapter_.removeClass(MDCDialogFoundation.cssClasses.OPEN);
      this.enableScroll_();
    }
  };

  MDCDialogFoundation.prototype.open = function open() {
    this.isOpen_ = true;
    this.disableScroll_();
    this.adapter_.registerDocumentKeydownHandler(this.documentKeydownHandler_);
    this.adapter_.registerSurfaceInteractionHandler('click', this.dialogClickHandler_);
    this.adapter_.registerInteractionHandler('click', this.componentClickHandler_);
    this.adapter_.registerTransitionEndHandler(this.transitionEndHandler_);
    this.adapter_.addClass(MDCDialogFoundation.cssClasses.ANIMATING);
    this.adapter_.addClass(MDCDialogFoundation.cssClasses.OPEN);
  };

  MDCDialogFoundation.prototype.close = function close() {
    this.isOpen_ = false;
    this.adapter_.deregisterSurfaceInteractionHandler('click', this.dialogClickHandler_);
    this.adapter_.deregisterDocumentKeydownHandler(this.documentKeydownHandler_);
    this.adapter_.deregisterInteractionHandler('click', this.componentClickHandler_);
    this.adapter_.untrapFocusOnSurface();
    this.adapter_.registerTransitionEndHandler(this.transitionEndHandler_);
    this.adapter_.addClass(MDCDialogFoundation.cssClasses.ANIMATING);
    this.adapter_.removeClass(MDCDialogFoundation.cssClasses.OPEN);
  };

  MDCDialogFoundation.prototype.isOpen = function isOpen() {
    return this.isOpen_;
  };

  MDCDialogFoundation.prototype.accept = function accept(shouldNotify) {
    if (shouldNotify) {
      this.adapter_.notifyAccept();
    }

    this.close();
  };

  MDCDialogFoundation.prototype.cancel = function cancel(shouldNotify) {
    if (shouldNotify) {
      this.adapter_.notifyCancel();
    }

    this.close();
  };

  MDCDialogFoundation.prototype.handleDialogClick_ = function handleDialogClick_(evt) {
    var target = evt.target;

    if (this.adapter_.eventTargetHasClass(target, cssClasses.ACCEPT_BTN)) {
      this.accept(true);
    } else if (this.adapter_.eventTargetHasClass(target, cssClasses.CANCEL_BTN)) {
      this.cancel(true);
    }
  };

  MDCDialogFoundation.prototype.handleTransitionEnd_ = function handleTransitionEnd_(evt) {
    if (this.adapter_.isDialog(evt.target)) {
      this.adapter_.deregisterTransitionEndHandler(this.transitionEndHandler_);
      this.adapter_.removeClass(MDCDialogFoundation.cssClasses.ANIMATING);
      if (this.isOpen_) {
        this.adapter_.trapFocusOnSurface();
        this.adapter_.layoutFooterRipples();
      } else {
        this.enableScroll_();
      };
    };
  };

  MDCDialogFoundation.prototype.disableScroll_ = function disableScroll_() {
    this.adapter_.addBodyClass(cssClasses.SCROLL_LOCK);
  };

  MDCDialogFoundation.prototype.enableScroll_ = function enableScroll_() {
    this.adapter_.removeBodyClass(cssClasses.SCROLL_LOCK);
  };

  return MDCDialogFoundation;
}(base["b" /* MDCFoundation */]);


// EXTERNAL MODULE: ../focus-trap/index.js
var focus_trap = __webpack_require__("33Wp");
var focus_trap_default = /*#__PURE__*/__webpack_require__.n(focus_trap);

// CONCATENATED MODULE: ../@material/dialog/util.js
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



function createFocusTrapInstance(surfaceEl, acceptButtonEl) {
  var focusTrapFactory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : focus_trap_default.a;

  return focusTrapFactory(surfaceEl, {
    initialFocus: acceptButtonEl,
    clickOutsideDeactivates: true
  });
}
// CONCATENATED MODULE: ../@material/dialog/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dialog_MDCDialog; });
/* unused concated harmony import MDCDialogFoundation */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return foundation_MDCDialogFoundation; });
/* unused concated harmony import util */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return util_namespaceObject; });
var dialog__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function dialog__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dialog__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function dialog__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










var dialog_MDCDialog = function (_MDCComponent) {
  dialog__inherits(MDCDialog, _MDCComponent);

  function MDCDialog() {
    dialog__classCallCheck(this, MDCDialog);

    return dialog__possibleConstructorReturn(this, _MDCComponent.apply(this, arguments));
  }

  MDCDialog.attachTo = function attachTo(root) {
    return new MDCDialog(root);
  };

  MDCDialog.prototype.initialize = function initialize() {
    this.focusTrap_ = createFocusTrapInstance(this.dialogSurface_, this.acceptButton_);
    this.footerBtnRipples_ = [];

    var footerBtns = this.root_.querySelectorAll('.mdc-dialog__footer__button');
    for (var i = 0, footerBtn; footerBtn = footerBtns[i]; i++) {
      this.footerBtnRipples_.push(new ripple["a" /* MDCRipple */](footerBtn));
    }
  };

  MDCDialog.prototype.destroy = function destroy() {
    this.footerBtnRipples_.forEach(function (ripple) {
      return ripple.destroy();
    });
    _MDCComponent.prototype.destroy.call(this);
  };

  MDCDialog.prototype.show = function show() {
    this.foundation_.open();
  };

  MDCDialog.prototype.close = function close() {
    this.foundation_.close();
  };

  MDCDialog.prototype.getDefaultFoundation = function getDefaultFoundation() {
    var _this2 = this;

    return new foundation_MDCDialogFoundation({
      addClass: function addClass(className) {
        return _this2.root_.classList.add(className);
      },
      removeClass: function removeClass(className) {
        return _this2.root_.classList.remove(className);
      },
      addBodyClass: function addBodyClass(className) {
        return document.body.classList.add(className);
      },
      removeBodyClass: function removeBodyClass(className) {
        return document.body.classList.remove(className);
      },
      eventTargetHasClass: function eventTargetHasClass(target, className) {
        return target.classList.contains(className);
      },
      registerInteractionHandler: function registerInteractionHandler(evt, handler) {
        return _this2.root_.addEventListener(evt, handler);
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(evt, handler) {
        return _this2.root_.removeEventListener(evt, handler);
      },
      registerSurfaceInteractionHandler: function registerSurfaceInteractionHandler(evt, handler) {
        return _this2.dialogSurface_.addEventListener(evt, handler);
      },
      deregisterSurfaceInteractionHandler: function deregisterSurfaceInteractionHandler(evt, handler) {
        return _this2.dialogSurface_.removeEventListener(evt, handler);
      },
      registerDocumentKeydownHandler: function registerDocumentKeydownHandler(handler) {
        return document.addEventListener('keydown', handler);
      },
      deregisterDocumentKeydownHandler: function deregisterDocumentKeydownHandler(handler) {
        return document.removeEventListener('keydown', handler);
      },
      registerTransitionEndHandler: function registerTransitionEndHandler(handler) {
        return _this2.dialogSurface_.addEventListener('transitionend', handler);
      },
      deregisterTransitionEndHandler: function deregisterTransitionEndHandler(handler) {
        return _this2.dialogSurface_.removeEventListener('transitionend', handler);
      },
      notifyAccept: function notifyAccept() {
        return _this2.emit(foundation_MDCDialogFoundation.strings.ACCEPT_EVENT);
      },
      notifyCancel: function notifyCancel() {
        return _this2.emit(foundation_MDCDialogFoundation.strings.CANCEL_EVENT);
      },
      trapFocusOnSurface: function trapFocusOnSurface() {
        return _this2.focusTrap_.activate();
      },
      untrapFocusOnSurface: function untrapFocusOnSurface() {
        return _this2.focusTrap_.deactivate();
      },
      isDialog: function isDialog(el) {
        return el === _this2.dialogSurface_;
      },
      layoutFooterRipples: function layoutFooterRipples() {
        return _this2.footerBtnRipples_.forEach(function (ripple) {
          return ripple.layout();
        });
      }
    });
  };

  dialog__createClass(MDCDialog, [{
    key: 'open',
    get: function get() {
      return this.foundation_.isOpen();
    }
  }, {
    key: 'acceptButton_',
    get: function get() {
      return this.root_.querySelector(foundation_MDCDialogFoundation.strings.ACCEPT_SELECTOR);
    }
  }, {
    key: 'dialogSurface_',
    get: function get() {
      return this.root_.querySelector(foundation_MDCDialogFoundation.strings.DIALOG_SURFACE_SELECTOR);
    }
  }]);

  return MDCDialog;
}(base["a" /* MDCComponent */]);

/***/ }),

/***/ "xxYg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y/5U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y6h9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openApplyForm; });
/* unused harmony export changeApplyStep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearDirectApplyAdId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleCallUnlockCandidateBuyOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyAttributeChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkWhatsappNotificationOtp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toggleSkipApplyInitiatedFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleQuickApplyInitiatedFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setUtmParameters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__("4xt+");


var updateApply = function updateApply() {
  var apply = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["a" /* APPLY_EVENTS */].UPDATE_APPLY,
    payload: apply
  };
};

var openApplyForm = function openApplyForm(job) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["a" /* APPLY_EVENTS */].UPDATE_APPLY,
    payload: { step: 1, job: job }
  };
};

var changeApplyStep = function changeApplyStep(step) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["a" /* APPLY_EVENTS */].UPDATE_APPLY,
    payload: { step: step }
  };
};

var clearDirectApplyAdId = function clearDirectApplyAdId() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["a" /* APPLY_EVENTS */].UPDATE_APPLY,
    payload: { directApplyAdId: null }
  };
};

var toggleCallUnlockCandidateBuyOptions = function toggleCallUnlockCandidateBuyOptions(show) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["a" /* APPLY_EVENTS */].TOGGLE_CALL_UNLOCK_CANDIDATE_BUY_OPTIONS,
    payload: { showCallUnlockBuyOptions: show }
  };
};

var applyAttributeChange = function applyAttributeChange(attributes) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["a" /* APPLY_EVENTS */].FORM_FIELD_CHANGE,
    payload: attributes
  };
};

var checkWhatsappNotificationOtp = function checkWhatsappNotificationOtp(optStatus) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["a" /* APPLY_EVENTS */].WHATSAPP_NOTIFICATION,
    payload: optStatus
  };
};

var toggleSkipApplyInitiatedFlag = function toggleSkipApplyInitiatedFlag(value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["a" /* APPLY_EVENTS */].TOGGLE_SKIP_APPLY_FLAG,
    payload: { isSkipApplyInitiated: value }
  };
};

var toggleQuickApplyInitiatedFlag = function toggleQuickApplyInitiatedFlag(value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["a" /* APPLY_EVENTS */].TOGGLE_QUICK_APPLY_FLAG,
    payload: { isQuickApplyInitiated: value }
  };
};

var setUtmParameters = function setUtmParameters(utmParameters) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_events__["a" /* APPLY_EVENTS */].SET_UTM_PARAMETERS,
    payload: utmParameters
  };
};

/***/ }),

/***/ "yMAY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: !0 }), exports.urlBase64ToUint8Array = urlBase64ToUint8Array, exports.getCurrentDateTime = getCurrentDateTime, exports.getBrowserDetails = getBrowserDetails, exports.getCookie = getCookie;function urlBase64ToUint8Array(a) {
  for (var b = "=".repeat((4 - a.length % 4) % 4), c = (a + b).replace(/\-/g, "+").replace(/_/g, "/"), d = window.atob(c), e = new Uint8Array(d.length), f = 0; f < d.length; f += 1) {
    e[f] = d.charCodeAt(f);
  }return e;
}function getCurrentDateTime() {
  var a = new Date();return "".concat(a.getFullYear() + "", "-").concat(a.getMonth() + 1, "-").concat(a.getDate(), " ").concat(a.toLocaleTimeString());
}function getBrowserDetails() {
  var a,
      b = navigator.userAgent,
      c = b.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];return (/trident/i.test(c[1]) ? (a = /\brv[ :]+(\d+)/g.exec(b) || [], "IE-".concat(a[1] || "")) : "Chrome" === c[1] && (a = b.match(/\b(OPR|Edge)\/(\d+)/), null !== a) ? a.slice(1).join(" ").replace("OPR", "Opera") : (c = c[2] ? [c[1], c[2]] : [navigator.appName, navigator.appVersion, "-?"], a = b.match(/version\/(\d+)/i), null !== a && c.splice(1, 1, a[1]), { name: c[0], version: c[1] })
  );
}function getCookie(a) {
  if ("undefined" != typeof document) {
    var b = document.cookie.match(new RegExp("(^| )".concat(a, "=([^;]+)")));if (b) return b[2];
  }return !1;
}

/***/ }),

/***/ "yXTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", { points: "70,31.8 18.2,31.8 41.9,7.9 36,2 2,36 36,70 41.9,64.1 18.2,40.2 70,40.2 " });

var back = function back(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ id: "back", viewBox: "0 0 72 72", "class": props.class },
		_ref
	);
};
/* harmony default export */ __webpack_exports__["a"] = (back);

/***/ }),

/***/ "ygIO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("G8y9");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ })

},["FnfM"]);


// WEBPACK FOOTER //
// bundler.1a72c.js